import {feats,spells,maneuvers} from "../data.js"
import {maneuverSchoolsText} from "../constants.js"

// Custom deep clone function that can handle functions
function deepCloneWithFunctions(obj) {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    
    if (obj instanceof Date) {
        return new Date(obj.getTime());
    }
    
    if (obj instanceof Array) {
        return obj.map(item => deepCloneWithFunctions(item));
    }
    
            if (typeof obj === 'object') {
            const cloned = {};
            for (const key in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    cloned[key] = deepCloneWithFunctions(obj[key]);
                }
            }
            return cloned;
        }
    
    return obj;
}
export const perks = [
    {
        rarity: "unique",
        type: "martial",
        name: "Sneak Attack",
        fromClass:"Rogue",
        shortDesc: `You gain multiple rogue abilities:
        \nSneak Attack: You deal extra damage anytime your target would be denied a Dexterity bonus to AC, or when you flank your target. This extra damage is 1d6 at 1st level, and increases by 1d6 every two levels after. Ranged attacks can count as sneak attacks only if the target is within 30 feet. 
        \nDispatchment: Whenever you attack an opponent that would be denied a Dexterity bonus to AC or when you flank your target, you gain a +2 bonus on your attack rolls. This bonus increases by +1 every 5 levels.
        \nSudden Technique: Once per combat as an immediate action, you can make an attack, or initiate any martial perk, universal perk, martial feat, or martial maneuver, as long as its activation time is a standard action or less. The perk or maneuver activated has it's spell point cost reduced to 1 spell points and any daily or per combat limitations ignored, but any additional abilities activated off of it such as modifiers to that ability need to be paid as normal as if the ability cost normal spell points. Creatures affected by this ability are treated as if they were flat-footed, no matter what resistance to being flat-footed they have. After you use this ability you're staggered on your next turn (this stagger is unresistable and unremovable).
        \nGain a rogue talent at 1st and every odd level after that
        \nEvery level gain a maneuver from school of choice: Cursed Razor, Shattered Mirror, Steel Serpent, Thrashing Dragon, Heart of the Maelstrom, Veiled Moon, or Shadow Assassin.
        \nAdditionally, at 1st and every 3rd level you will gain a [Shadow Technique] maneuver.`,
        hasCustomMethod:true,
        customMethod:(context, self)=>{
            self.getManeuver(context, self, context.stats.characterStats.misc.level)
            if(context.stats.characterStats.misc.level %2 == 1){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Rogue Talent"}))
            }
            if(context.stats.characterStats.misc.level %3 == 1){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{school:{shadowAssassin:true}, onlySubschool:'shadowTechnique', level:self.getManeuverLevel(context.stats.characterStats.misc.level)}}))
            }
        },
        catchUpMethod:(context, self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level;x++){
                if(x==1 || x %2 == 1){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Rogue Talent"}))
                }
                self.getManeuver(context,self,x)
                if(x %3 == 1 || x == 1){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{school:{shadowAssassin:true}, onlySubschool:'shadowTechnique', level:self.getManeuverLevel(x)}}))
                }
            }
        },
        getManeuver: (context, self, lvlNum)=>{
            let options = {level:{}, school:{}}
            options.level = self.getManeuverLevel(lvlNum)
            let schools = ["cursedRazor", "shatteredMirror", "steelSerpent", "thrashingDragon", "veiledMoon", "heartOfTheMaelstrom", "shadowAssassin"]
            let choices = []           
            for(let x = 0; x < schools.length; x++){
                let choice = {
                    title:schools[x],
                    id:x, 
                    method:(context=>{                            
                        options.school[schools[x]] = true
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options}))
                    })}
                    choices.push(choice)
            }         
            let custom = {title:"Typed Maneuver Choice", options:choices}
            context.customDialogArray.push(custom)
        },
        getManeuverLevel:(lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            let levels = {}
            if(lvlNum > 9){lvlNum = 9}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    levels[levelString]=true;
                }
            }
            return levels
        }
    },
    {
    rarity: "unique",
    type: "martial",
    name: "Smite",
    fromClass:"Paladin",
    shortDesc: `For level spell points as a swift action, choose one target within sight to smite. The smite only works if the creature has an opposite good/evil alignment as yours, if you are neutral you can smite both good and evil creatures, but you only gain half the effect. You add highest mental bonus (if any) to attack rolls and add level to all damage rolls made against the target of the smite, you bypass all DR the target of the smite has, and gain a deflection bonus equal to highest mental stat modifier against attacks made by the target of the smite. If you smite a creature who's alignment is not an alignment you gain a bonus against your smite fails and your order effects do not activate.
    \nIf the target of the smite is your exact opposition alignment (such as lawful good vs chaotic evil, or neutral good vs neutral evil), your first attack against the creature instead adds twice your level to damage. Neutral creatures have no exact opposite alignment.
    \nThe smite effect remains until the target of the smite is defeated, you can only have a single creature smited at a time, nor can you smite a creature that you currently have smite active against.
    \nAt 1st level you gain an order, each order modifying how your smite works, the orders you have available depends on your alignment. Any order that states it affects allies do not include you unless it specifically states it does, and orders that grant bonuses to smite do not grant them to other orders. You gain an additional order every 4 levels.
    \nAt 1st and every 3rd level you gain a buff or healing spell.
    \nEvery odd level you gain a maneuver from a school of choice: Eternal Guardian, Golden Lion, Radiant Dawn, Silver Crane, Burning Citadel, Black Seraph or Indomitable Will.
    \n\nGain 1 additional spell point per level`,
    hasCustomMethod:true,
        customMethod:(context, self)=>{
            if(context.stats.characterStats.misc.level %2 == 1 || context.stats.characterStats.misc.level == 1){
                self.getManeuver(context, context.stats.characterStats.misc.level)
            }   
            
            if(context.stats.characterStats.misc.level %3 == 0 || context.stats.characterStats.misc.level == 1){
                self.getSpell(context, context.stats.characterStats.misc.level)
            }   
            // if(context.stats.characterStats.misc.level %6 == 0){
            //     self.getPerk(context)
            // }
            if(context.stats.characterStats.misc.level %4 == 0){
                self.getOrder(context,self)
            }
        },
        catchUpMethod:(context, self)=>{
            context.stats.characterStats.misc.spPerLevel += 1
            //self.getOrder()
            for(let x = 1; x <= context.stats.characterStats.misc.level;x++){
                if(x %4 == 0 || x == 1){
                    self.getOrder(context,self)
                }
                if(x%3 == 0 || x == 1){
                    self.getSpell(context,x)
                }
                if(x%2 == 1){
                    self.getManeuver(context, x)
                }
                
                // if(x%6 == 0){
                //     self.getPerk(context)
                // }   
            }
        },

        getManeuver: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}, school:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            let schools = ["blackSeraph", "eternalGuardian", "goldenLion", "radiantDawn","burningCitadel", "indomitableWill", "silverCrane"]
            let choices = []           
            for(let x = 0; x < schools.length; x++){
                let choice = {
                    title:schools[x],
                    id:x, 
                    method:(context=>{                            
                        options.school[schools[x]] = true
                        context.connection.send(JSON.stringify(
                            {
                                command:"requestRoll", 
                                type:"maneuver", 
                                options
                            }
                        ))
                    })}
                    choices.push(choice)
            }         
            let custom = {title:"Typed Maneuver Choice", options:choices}         
            context.customDialogArray.push(custom)
        }, 

        // getPerk:(context)=>{
        //     context.connection.send(JSON.stringify({
        //         command:"requestRoll", 
        //         type:"Perk", 
        //         options:{type:{martial:true}}
        //     }))
        // },

        getSpell: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.type={healing:true, buff:true,}
            let obj={command:"requestRoll", type:"spell", options}
            context.connection.send(JSON.stringify(obj))
        },

        getOrder(context,self){
            let orders = self.orders
            let choices = []
            let chosen = []
            for(let x = 0; x < 4; x++){
                let alignment = ""
                if(context.stats.characterStats.misc.alignment == "None"){
                    alignment = "None"
                }else{
                    alignment = context.stats.characterStats.misc.alignment.split(" ")[0][0] + context.stats.characterStats.misc.alignment.split(" ")[1][0]
                }
                let possibleOrders = orders.filter(order =>{
                    if(order.alignments.includes(alignment) || order.alignments == "All") return true
                })
                let possible = Math.floor(Math.random()*possibleOrders.length)
                while(chosen.includes(possible)) possible = Math.floor(Math.random()*possibleOrders.length)
                chosen.push(possible)
                let option = possibleOrders[possible]
                choices[x] = {
                    title:option.name,
                    description:option.description,
                    id:x,
                    method:(context =>{                            
                        let perk = {rarity:"unique", name:option.name, shortDesc:option.description, id:Math.random()*1000000, additionalInfoTags:["Order"], type:"universal"}
                        context.stats.lists.perks.push(perk)
                        if(option.hasCustomMethod){
                            option.customMethod(context, self)
                            perk.hasCustomMethod = true
                        }
                                    
                    })
                }                
            }
            let custom = {title:"Smite Order", options:choices}         
            context.customDialogArray.push(custom)
        },
        hasSpecialItems:true,
        getSpecialItemList:(self)=>{                
            self.orders.forEach(order=>order.type = order.alignments)
            return self.orders
        },
        orders:[
            {
                name:"Order of Charity",
                alignments:["NG","CG","LG"],
                description:`When you make the attack or your effect is what defeats a creature you have smited, you and all allies heal 1d6 hit points, increasing by 1d6 every odd level after first. This is positive energy.`,
            },
            {
                name:"Order of the Martyr",
                alignments:["NG"],
                description:`When you smite a creature all hit point damage taken by allies by that creature is redirected to you for 2 rounds. This bypasses any damage reduction, immunities, and resistances. If you are killed by this effect, all allies that had damage redirected to you heal 5 hit points per your level, and the redirection ends. Ff you are raised from the dead after you have been killed by this ability reduce the negative levels you would have gained from being raised by 1.`,
            },
            {
                name:"Order of Fear",
                alignments:["All"],
                description:`When you smite a creature you can make a free intimidate check against them with a bonus equal to your level. After the initial check for the rest of the duration of your smite you gain a circumstance bonus on intimidate checks against them equal to your highest mental modifier.`,
            },
            {
                name:"Order of the Scourge",
                alignments:["LE","CE","NE","LN","CN","TN"],
                description:`When you reduce the target of your smite below 0 hit points and are within natural reach of them, they automatically die, creatures immune to death effects are immune to this. When you kill a creature this way you gain a +2 profane bonus to strength, +2 per 5 levels, 1d6 temporary hit points per 4 HD of the creature (minimum 1d6), you caster level increases by +1, +1 per 8 levels. These bonuses last 5 rounds.`,
            },
            {
                name:"Order of the Pyre",
                alignments:["LE","CE","NE","LN","CN","TN"],
                description:`When you smite a target, if that target is a spell caster or has spell-like abilities from a divine class, it must make a will save DC 10 + level + highest mental mod or it loses access to any spell casting, supernatural, and spell-like abilities from any of its divine spellcasting classes for 3 rounds. This increases by 1 round every 8 levels.`,
            },
            {
                name:"Order of Loyalty",
                alignments:["NG","CG","LG"],
                description:`When you smite a creature, choose an ally that you can currently see, that ally gains a deflection bonus to its armor class equal equal to highest mental stat for attacks made by the smited creature. This bonus lasts for 3 rounds. Every 8 levels this lasts an additional round.`,
            },
            {
                name:"Order of Justice",
                alignments:["NG","CG","LG"],
                description:`When a creature you have smited deals damage to an ally, you gain a +1 bonus to damage for your next attack against the creature, this bonus stacks. If the smited creature knocks an ally unconscious (but not kill then), your next attack deals 5 bonus damage, if they kill them, your next attack deals 5 bonus damage, and your critical damage multiplier and range (flat bonus) increases on your next attack against them by +1.`,
            },
            {
                name:"Order of Hope",
                alignments:["NG","CG","LG"],
                description:`When you successfully land a critical hit against a creature you have smited, all allies including you regain your highest mental stat * your critical damage multiplier hit points. if any of them are currently unconcious this healing is doubled.`,
            },
            {
                name:"Order of Retribution",
                alignments:["LN","LG","LE"],
                description:`Once per turn when a creature you have smited damages an ally, and both the ally and the enemy are within your reach, you can spend level/2 spell points to make it provoke an attack of opportunity from you. If the smited creatures damage kills the ally your critical damage multiplier for the attack of opportunity increases by +1. If your attack kills the creature you restore level spell points and 2x level hit points, this is positive energy.`,
            },
            {
                name:"Order of the Avenger",
                alignments:["CG","LG","NG","CN","LN","TN"],
                description:`When an ally you can see is killed or suffers a critical hit by an enemy, you can choose to smite the creature as an immediate action, any bonus to attack or damage you gain from your smite increases by 50% of what your smite would normally give. You can still only have a single smite active at a time, and you cannot smite a creature you already have smite active on.`,
            },
            {
                name:"Order of the Defender",
                alignments:["CG","LG","NG"],
                description:`When you activate your smite ability, all allies who can see you activate smite gain the same bonus defenses you gain from smite or orders for 1 round. Normally this only includes a deflection modifier to their AC equal to your highest mental modifier against the smited creature, but it could include others from different orders. Every 10 levels this lasts an additional round.`,
            },
            {
                name:"Order of the Guide",
                alignments:["CG","LG","NG"],
                description:`When you activate your smite ability, all allies who can see you activate it gain a sacred bonus to their saves equal to your highest mental modifier for the next save they make within highest mental stat rounds.`,
            },
            {
                name:"Order of the Divine",
                alignments:["CG","LG","NG"],
                description:`When you activate your smite ability any sacred bonus you have increases by +2. This increases by +1 every 8 levels.  Additionally, any sacred or divine damage you deal is increased by 25%.`,
            },
            {
                name:"Order of Legends",
                alignments:["CN","LN","TN"],
                description:`When you activate your smite ability you can also choose to cry out a rally to allies, all allies who can see and hear you activate it gain a +1 competence bonus to their attacks rolls, damage rolls, and saves against fear for 3 rounds. This lasts an additional round every 6 levels, and the bonus increases by +1 every 8 levels. If you also have inspire competence these abilities stack, and this bonus increases by +1, and if you are at least level 6 you can activate your inspire competence as a part of the same action you smite a creature.`,
            },
            {
                name:"Order of the People",
                alignments:["CN","LN","TN"],
                description:`When you smite a creature, all conscious allies inlcuding you gain a bonus to saves equal to the amount of unique alignments in your party. This lasts until their next save, or highest mental stat rounds, whichever comes first. This lasts an additional save every 8 levels.`,
            },
            {
                name:"Order of the Warden",
                alignments:["CN","LN","TN"],
                description:`When you successfully smite a creature it takes a -4 penalty to attack any creature other than you until it deals damage to you at least once. The penalty to attack increases by an additional -1 every 4 levels.`,
            },
            {
                name:"Order of the Guard",
                alignments:["CN","LN","TN"],
                description:`Once per turn when a creature you have smited attacks an adjacent ally with a weapon attack, you can spend 4 spell points and an attack of opportunity to attempt to counter the attack, making an attack roll at your highest bonus against the triggering attack, if your result is higher than the result of the creature, their attack misses. You must be aware of and see the attack to use this ability.`,
            },
            {
                name:"Order of Temperance",
                alignments:["CN","LN","TN"],
                description:`Once per day you can expend 2x the normal amount of spell points when smiting a good or evil creature, if you do your smite has full effect instead of half.`,
            },
            {
                name:"Order of the People's Champion",
                alignments:["CN","LN","TN"],
                description:`When you smite a creature, for each pary memeber with a unique alignment you gain a +1 bonus to your attack and damage against the smited target, or as a bonus to a saving throw against the smited creatures abilities. This lasts until you have used the bonus times equal to your highest mental stat. You must choose to apply the bonus before the dice is rolled`,
            },
            {
                name:"Order of Unity",
                alignments:["CN","LN","TN"],
                description:`When you smite a creature, for each unique alignment you and your party has, you gain a +1 bonus to damage against the smited creature, this lasts 3 rounds, plus 1 round every 6 levels.`,
            },
            {
                name:"Order of Bane",
                alignments:["All"],
                description:`When you select this order you will get 2 alignment rolls, when you smite those alignments you gain an additional 50% of the bonuses you would gain from smiting them. If this is an alignment you cannot normally smite you can still smite that alignment at 50% effectiveness.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    let alignments = [ "Lawful Good", "Neutral Good", "Chaotic Good", "Lawful Neutral", "True Neutral", "Chaotic Neutral", "Lawful Evil", "Neutral Evil", "Chaotic Evil"]
                    let orders = context.stats.lists.perks.filter(perk => perk.name == "Order of Bane")                        
                    let perk = orders[orders.length-1]
                    perk.shortDesc += `\n\nChosen: `
                    for(let y = 0; y < 2; y++){
                        let alignmentChoices = []
                        let chosen = []
                        for(let x = 0; x < 3; x++){
                            let possible = Math.floor(Math.random()*alignments.length)
                            while(chosen.includes(possible)) possible = Math.floor(Math.random()*alignments.length)
                            chosen.push(possible)
                            let alignment = alignments[possible]
                            alignmentChoices[x] = {
                                title:alignment,
                                id:x,
                                method:(context =>{
                                    let orders = context.stats.lists.perks.filter(perk => perk.name == "Order of Bane")
                                    let perk = orders[orders.length-1]
                                    perk.shortDesc = perk.shortDesc + alignment + `, `
                                })
                            }                
                        }
                        let custom = {title:"Order of Bane Choice", options:alignmentChoices}         
                        context.customDialogArray.push(custom)
                    }
                }
            },
            {
                name:"Order of Clarity",
                alignments:["All"],
                description:`When you deal the final blow that defeats a smited creature, all allies restore spell points equal to 3x your highest mental modifier.`,
            },
            {
                name:"Order of Defense",
                alignments:["All"],
                description:`When you smite a creature it is unable to make attacks of opportunity for 1 round. This increases by 1 round every 6 levels.`,
            },
            {
                name:"Order of Censure",
                alignments:["All"],
                description:`When you smite a creature it takes a -2 penalty on damage rolls, increasing by -1 every 5 levels.`,
            },
            {
                name:"Order of Brotherhood",
                alignments:["All"],
                description:`When you activate your smite, choose a single ally, as long as you are adjacent to each other they gain +1 to attack and damage on attacks against the target of the smite, or +1 deflection bonus to armor class and to saves against the target of the smite's attacks and abilities. You choose which bonus is provided when you first activate smite. This bonus increases by +1 every 6 levels.`,
            },
            {
                name:"Order of Viciousness",
                alignments:["CE","NE"],
                description:`All of your weapon attacks against a creature you have smited gain a +1 enhancement bonus and the vicious enchantment, dealing 2d6 additional damage to the target and 1d6 to yourself. 
                \n\nWhen you reach level 8 you can choose to either share the vicious enchantment with all allies that attack the smited creature, or to increase the bonus you gain to deal 4d6 to the enemy and 2d6 to yourself, and increasing the enhancement bonus to +2. You must either share it with all alies or none. 
                \n\nAt level 16 you can choose to increase the bonus you gain to 8d6 to the enemy and 4d6 to yourself and increase the enhancement bonus to +3, or share the vicious enchantment that deals 4d6 extra damage and deals 2d6 to the attacker to all allies that attack the smited creature. You must either share it with all alies or none, and must share the same value to all allies.`,
            },
            {
                name:"Order of Greed",
                alignments:["LE","NE","CE"],
                description:`Whenever you deal the final blow that defeats a creature you currently have smited, you gain 20 gold.`,
            },
            {
                name:"Order of Infighting",
                alignments:["LE","NE","CE"],
                description:`Its just what evil does. You can also smite evil creatures as long as they are not your exact alignment, however the spell point cost of smite is doubled.`,
            },
            {
                name:"Order of Destruction",
                alignments:["LE","NE","CE"],
                description:`When you activate your smite, you and all allies that can see you activate it gain a bonus on their next damage roll equal to your level.`,
            },
            {
                name:"Order of Life",
                alignments:["LG","NG","CG"],
                description:`As long as you have smite active, you can pour out positive energy to nearby allies as a swift action. This cost 1 spell point per 2 dice rolled (minimum 1) and heals 1d6 at 1st, increasing by 1d6 for every odd level after, and has a range of 15 feet. You can also use this to target undead to damage them, but they are allowed a will save (dc=10+level/2+highest mental). You can only use this on targets the smited creature has harmed.`,
            },
            {
                name:"Order of the Martyr's Blood",
                alignments:["LG","NG","CG"],
                description:`Every time the target of your smite damages you, you can choose an ally within 20 feet to heal 1d6 hit points. Every 6 levels this increases by 1d6. If you are ever knocked unconscious you heal an ally within 20 feet for 1d6 per 2 levels. If you are killed you heal an ally within 20 feet 1d6 per level. This is positive energy.`,
            },
            {
                name:"Order of Death's Grasp",
                alignments:["LE","NE","CE"],
                description:`You can wrack the target of your smite with agony and negative energy. Activating this is a swift action and deals 1d6 points of negative energy + 1d6 every odd level after 1st to the target of your smite. The target may make a will save (dc=10+level/2+highest mental) to reduce the damage by half.`,
            },
            {
                name:"Order of Pain",
                alignments:["LE","NE","CE"],
                description:`You channel your pain to wrack the target of your smite. Every time you take damage the target of your smite takes 1d4 points of damage. Every 6 levels this increases by 1d4. If you are every knocked unconscious you deal 1d4 per 2 levels. If you are killed you deal 1d4 per level. This is negative energy. The first time each round the smited creature takes damage it can make a will save to reduce the damage from this effect by half for the rest of the round.`,
            },
            {
                name:"Order of Stone",
                alignments:["All"],
                description:`As long as there is a creature you currently have smited above 0 hit points, you gain fast healing 1. This increases by 1 every 5 levels.`,
            },
            {
                name:"Order of the Crusade",
                alignments:["All"],
                description:`All allies gain a +1 bonus to their attack and damage against the creature you smite. This increases by +1 every 8 levels.`,
            },
            {
                name:"Order of Safety",
                alignments:["All"],
                description:`All allies gain a +1 deflection bonus to armor class and saves against the smited creature as long as they can currently see you. This increases by +1 every 6 levels.`,
            },
            {
                name:"Order of Flame",
                alignments:["All"],
                description:`When you reduce a smited creature below 0 hit points you can as an immediate action smite another creature within 20 feet of the defeated opponent. This costs spell points as normal, however the bonuses you gain from smite are increased by +1.`,
            },
            {
                name:"Order of the Rider",
                alignments:["All"],
                description:`When you activate your smite you can move half your movement speed. While you have a creature smited you gain a +5 enhancement bonus to your movement speed.`,
            },
            {
                name:"Order of Declaration",
                alignments:["All"],
                description:`You can change your smite to become a standard action, declaring a list of why the target must be destroyed. If you do, any bonuses you gain from smite increase by +2. You can also choose to increase it further to a full-round action to increase the bonuses by +4. Every 8 levels the bonuses increase by +1 and +2 respectively.`,
            },
            {
                name:"Order of the Hunt",
                alignments:["LN","CN","TN",],
                description:`When you have a creature smited, you can as a swift action direct an ally within 30 feet on how to slay the creature even better. The ally gains a +2 insight bonus to attacks and damage against it, and +1 bonus on the DC's of their spells and abilities against it for 1 round. Every 5 levels the attack and damage bonus increases by +1, and every 10 levels the DC bonus increases by +1.`,
            },
            {
                name:"Order of Pride",
                alignments:["LN","CN","TN","LE","NE","CE"],
                description:`Whenever you deal the final blow that defeats a creature you have smited you restore 1d6 hit points per level. This is not positive energy.`,
            },
            {
                name:"Order of Mockery",
                alignments:["LE","NE","CE"],
                description:`A creature you have smited takes a -2 penalty to armor class and -2 penalty to saves until it either succeeds a save against you or until you miss an attack against it. If you dont target the smited creature with an attack or cause it to make a save within 1 round of using this ability this effect wears off. The penalties caused by this ability increase by -1 every time the creature misses you with an attack or you save against an ability it caused until it succeeds one of those against you, then this second portion of the ability ends and does not reactivate.`,
            },
            {
                name:"Order of Wrath",
                alignments:["LE","NE","CE"],
                description:`When you smite a creature you gain a +4 morale bonus to your strength, but a -2 penalty to your armor class as long as the smite remains in effect. If you land the final blow that defeats the target of your smite you gain a +4 profane bonus to strength for 1 round, increasing by 1 round for every 5 levels you have.`,
            },
            {
                name:"Order of Vainglory",
                alignments:["LE","NE","CE"],
                description:`When you smite a creature you can choose for your smite to become a vain smite, if you do, you no longer gain the usual deflection bonus to your armor class that smite provides, instead your damage increases by your highest mental stat. This smite only lasts 3 rounds, if you fail to defeat the target of your smite before then, you take a penalty to your attack, damage and will saves equal to the bonus damage gained for 5 rounds. You cannot smite a creature you have vain smited before. Additionally, against vain smited creatures you gain a +1 bonus to your critical damage multiplier, but you take a -5 penalty to confirm critical hits. Every 10 levels this bonus and penalty increase by 1 increment.`,
            },
            {
                name:"Order of Gluttony",
                alignments:["LE","NE","CE"],
                description:`When you have smite in effect whenever you are healed except through fast healing or regeneration you heal +1 hit point per dice rolled, or a flat amount equal to your highest mental stat if no dice are rolled, you cannot heal other creatures while your smite is in effect. Every 8 levels this bonus increases by +1 per dice rolled or your highest mental stat (depending on whether a die is rolled).`,
            },
            {
                name:"Order of Treachery",
                alignments:["LE","NE","CE"],
                description:`When you smite a creature you can choose for it to take a -4 penalty to attack you, but gain a +2 bonus to attack allies. The penalty and bonus increases by 2 every 8 levels. When an attack is declared against you by the smited creature, but before the roll is made, you can use an immediate action to interject an adjacent ally in front of you, they take the attack and all resulting effects for you. If the hit is ever a critical hit you gain your highest mental stat as a morale bonus to all d20 rolls for 1 round. If this ability ever kills an ally you gain the bonuses for 3 rounds. If you gain the bonus a second time the duration is added together, but doesn't otherwise stack.`,
            },
            {
                name:"Order of the Profane",
                alignments:["CE","LE","NE"],
                description:`When you activate your smite ability any profane bonus you have increases by +2. This increases by +1 every 8 levels.  Additionally, any profane damage you deal is increased by 25%.`,
            },
            {
                name:"Order of War",
                alignments:["LE","NE","CE","LG","NG","CG"],
                description:`When you smite a creature who is your exact opposing alignment you also gain a +1 bonus to your critical damage multiplier with weapons for your first successful critical against them. This lasts an additional successful critical every 8 levels.`,
            },
            {
                name:"Order of Knowledge",
                alignments:["All"],
                description:`You gain an additional healing/buff spell at level 1 and every 3 levels.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    let perk = perks.find(perk => perk.name == "Order of Knowledge")
                    perk.catchUpMethod(context,perk)
                }                    
            },
            {
                name:"Order of Warfare",
                alignments:["All"],
                description:`You gain an additional Eternal Guardian, Golden Lion, Radiant Dawn, Silver Crane, Burning Citadel, Primal Fury, or Black Seraph maneuver at level 1 and every 3 levels.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    let perk = perks.find(perk => perk.name == "Order of Warfare")
                    perk.catchUpMethod(context,perk)
                }
            },
            {
                name:"Order of Magic",
                alignments:["All"],
                description:`You gain 2 additional spell points per level`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.stats.characterStats.misc.spPerLevel += 2        
                }
            },
            {
                name:"Order Against Chaos",
                alignments:["LN","LG","LE"],
                description:`You can smite creature who are chaotic regardless of good/evil alignment at half effect. If the creature is an alignment you could usually smite without this benefit you instead increase the bonuses you would gain from smite against them by 50%. (150% total if you're good/evil, 75% if neutral)`,                        
            },
            {
                name:"Order Against Tyranny",
                alignments:["CN","CG","CE"],
                description:`You can smite creature who are lawful regardless of good/evil alignment at half effect. If the creature is an alignment you could usually smite without this benefit you instead increase the bonuses you would gain from smite against them by 50%. (150% total if you're good/evil, 75% if neutral)`,                        
            },
            {
                name:"Order Against the Compromising",
                alignments:["CG","NG","LG","CE","NE","LE"],
                description:`You can expend 2x the normal amount of spell points to smite a neutral creature that doesn't share your chaotic/lawful alignment but at only 50% effectiveness.`,                        
            },
            {
                name:"Order of Resilience",
                alignments:["All"],
                description:`You gain damage reduction 1/- against the target of your smite. This damage reduction increases by +1 every 3 levels.`,                        
            },
            {
                name:"Order of Spellcraft",
                alignments:["All"],
                description:`When you smite a creature it gets a -2 penalty to saves against your spells for 3 rounds. This penalty increases by -1 every 6 levels.`,                        
            },
            {
                name:"Order of Freedom",
                alignments:["CG","CN","CE"],
                description:`When you smite a creature choose an ally you can see, both you and them gain the benefits of freedom of movement for 1 round. This increases in duration by 1 round every 6 levels.`,                        
            },
            {
                name:"Order of Purity",
                alignments:["TN","NG","NE"],
                description:`When you smite a creature that isn't NG, TN, or NE, the DC of all of its spells, spell-like abilities, and supernatural abilities are reduced by -1. When you do smite a NG, TN, or NE creature you reduce the benefits you gain from smite by -2. Both of these penalties increase by -1 every 8 levels.`,                        
            },
            {
                name:"Order of Power",
                alignments:["All"],
                description:`Increase the numerical bonuses you gain or grant from smite by +1. This doesnt effect orders. Every 6 levels this increases by +1.`,                        
            },
            {
                name:"Order of the Absolute",
                alignments:["LG"],
                description:`Once per run when smiting a creature you can declare absolute judgement against it, when you do, your next attack against the creature deals an additional 1d6 points of damage per level, has a +2 flat bonus to critical threat range and a +1 to critical multiplier, this is sacred damage which deals full damage to evil creatures, half to neutral, and none to good. Additionaly, for the next 3 rounds all allies gain your smite bonuses against the smited creature (except the bonus sacred damage). The bonuses are determined by your stats, alignment, level etc.`,
            },
            {
                name:"Order of Encouragement",
                alignments:["CG"],
                description:`Once per day you can choose to gain no bonuses from your smite and increase its spell point cost by 100%, then instead choose an ally you can see, they gain the bonuses you would gain from smite (using your modifiers, level, alignment etc.). This lasts 3 rounds, plus 1 round per 6 levels, after that time you regain the bonuses and they lose them, however they are then halved for the remaining duration. You cannot choose an ally who is the same alignment as the target of the smite.`,                        
            },
            {
                name:"Order of Law",
                alignments:["LN"],
                description:`When you smite you can additionally shout a command at the creature, if it can understand you, you affect it as if the command spell (https://www.d20pfsrd.com/magic/all-spells/c/command/), however it gets no saving throw, instead it chooses whether to accept the command, if it chooses not to, the bonuses to attack and damage you gain from your smite against it increase by +1, if it listens to the command all the bonuses you gain from smite are reduce by -2. The bonus and the penalty increase by +1 and -2 every 6 levels. If you activate this ability and the creature chooses to not obey the command, whenever it takes an attack of opportunity against you, it provokes an attack of opportunity from you.`,                        
            },
            {
                name:"Order of Balance",
                alignments:["TN"],
                description:`Instead of gaining half your highest mental modifier as a bonus to your attack and as a deflection bonus to your armor class, you can instead choose to split the bonuses as you choose, allocating an amount equal to your highest mental modifier, you can also choose to add it to your damage as well.`,                        
            },
            {
                name:"Order of Friendship",
                alignments:["CN"],
                description:`Increase any numerical bonus you gain from aid another or teamwork feats against the target of your the smite by +1 for 3 rounds. This lasts an additional round every 6 levels.`,                        
            },                    
            {
                name:"Order of Tyranny",
                alignments:["LE"],
                description:`Whenever the target of your smite damages you, your next attack against it gains a +2 bonus to damage, this stacks. If the target of your smite confirms a critical hit against you it automatically provokes an attack of opportunity against you, and you gain a +1 flat bonus to your critical threat range for the attack.`,
            },
            {
                name:"Order of Hatred",
                alignments:["NE"],
                description:`You can choose to take a -4 penalty to your armor class and saves against the target of your smite, if you do any damage or effect you would take from the smited creature is delayed until 2 rounds after you activated smite, on the round after you activate your smite you gain a bonus to damage against the smited creature of +2 per time the creature attacked or caused you to make a save during the previous round. At the end of second round you take the effects of the delayed effects, however all damage is increased by 50% and any penalty you would take either lasts 50% longer or is 50% more effective, smited targets choice. If this damage kills you and the creature is in a location you could make an attack against it with a wielded weapon, you can make an immediate attack, it is an automatic critical threat if it hits, then you die.`,                        
            },
            {
                name:"Order of Carnage",
                alignments:["CE"],
                description:`You can choose to take a -5 penalty to your attack rolls against the target of your smite, but gain a +1 bonus to the critical damage multiplier of your weapon against it. Every 6 levels you can choose to increase both the bonus and penalty by 1 increment. Once a bonus is chosen it remains in effect for the rest of the duration of the smite.`,                        
            },
            {
                name:"Order of Smiting",
                alignments:["All"],
                description:`You can have a second smite active at the same time. Reduce the cost of smite by 1 spell point, reducing by an additional 1 every 6 levels.`,                        
            },
            {
                name:"Order of Grace",
                alignments:["All"],
                description:`When you activate smite you gain your highest mental stat as a bonus to your saves for 3 rounds against the target of your smite. Every 8 levels this lasts an additional round.`,                        
            },
            {
                name:"Order of Fervor",
                alignments:["All"],
                description:`Once per day you can activate smite for double the regular spell point cost, if you do the bonuses you gain or grant from smite increase by 50%, however your smite only lasts 3 rounds plus 1 round per 5 levels. After this smite ends you are able to smite the creature again.`,                        
            },
            {
                name:"Order of Devastation",
                alignments:["All"],
                description:`When making an attack against a creature you have smited, you can spend a spell point to increase the damage of the attack by +2, you can spend spell points up to your level per round on this ability. You must choose to spend the spell points before the attack roll is made.`,                        
            },
            {
                name:"Order of the Monument",
                alignments:["All"],
                description:`You gain a +1 dodge bonus against the target of your smite. This increases by +1 every 8 levels. This bonus is doubled if you are being flanked.`,                        
            },
            {
                name:"Order of Death",
                alignments:["CE", "NE","LE"],
                description:`If you are currently flanking the target of your smite, you gain an additional +1 to your attack, and if you deal any sneak attack damage increase it by +1 per sneak attack dice. You gain 1d6 sneak attack damage to the target of your smite.`,                        
            },
            {
                name:"Order of the Asp",
                alignments:["All"],
                description:`You gain a +1 bonus to attack and +2 to damage against a smited creature if it is entangled, exhausted, fatigued, nauseated, prone, shaken, frightened, panicked, staggered, or denied its dexterity bonus to armor class. This bonus can stack if it is effected by multiple of these statuses. The bonus damage increases by +1 every 4 levels, and the attack increases by +1 every 8.`,                        
            },
            {
                name:"Order of the Eel",
                alignments:["All"],
                description:`For each ally threatening the target of your smite you gain a +1 bonus to attack and damage against it. If the ally shares your good/evil/neutral alignment, this increases by +1. If the ally shares your race it increases by +2.`,                        
            },
            {
                name:"Order of the Cockatrice",
                alignments:["All"],
                description:`You gain a +2 bonus to attack and damage against the target of your smite if you are the only ally threatening it. This bonus increases by +1 every 5 levels.`,                        
            },
            {
                name:"Order of the First Law",
                alignments:["All"],
                description:`You gain temporary hit points equal to your level when you smite a creature and when the target of your smite dies. These temporary hit points stack with each other, but not with additional activations of smite.`,                        
            },
            {
                name:"Order of the Hero",
                alignments:["All"],
                description:`When you smite a creature and your level is lower than the current encounters CR/2, the effects and bonuses of your smite are doubled.`,                        
            },
            {
                name:"Order of the Chosen One",
                alignments:["All"],
                description:`When you smite a creature, if you are the only currently conscious ally the effects of your smite are doubled. This only lasts as long as you are still the only conscious ally. If you are the only alive ally when you smite a creature you also instantly heal 1d6 hit points per level, plus 1d6+1 for each difference between the monsters CR and your level. This is not positive energy.`,                        
            },
            {
                name:"Order of the Hammer",
                alignments:["All"],
                description:`As a part of the action of smiting a creature you can make a free grapple or sunder check against it. This does not provoke and gains the normal attack bonus you gain from smiting. When you are level 10, whenever you make a full round attack against a smited creature you can make an additional grapple or sunder combat maneuver for free which does not provoke. If you would not normally provoke when you make that kind of maneuver because of an ability you have, you gain a +2 to it instead.`,                        
            },
            {
                name:"Order of the Penitent",
                alignments:["All"],
                description:`You gain an additional +2 bonus to your CMD against a smited target. This increases by +1 every 5 levels.`,                        
            },
            {
                name:"Order of the Seal",
                alignments:["All"],
                description:`As a part of the action of smiting a creature you can make a free trip or bull rush check against it. This does not provoke and gains the normal attack bonus you gain from smiting. When you are level 10, whenever you make a full round attack against a smited creature you can make an additional trip or bull rush combat maneuver for free which does not provoke. If you would not normally provoke when you make that kind of maneuver because of an ability you have, you gain a +2 to it instead.`,                        
            },
            {
                name:"Order of the Charger",
                alignments:["All"],
                description:`As a part of the action of smiting a creature you can make a free melee or ranged attack against it.`,                        
            },
            {
                name:"Order of the Falling Lotus",
                alignments:["All"],
                description:`When you declare an attack against a smited creature, you can declare it to be the final strike. When you do, double your smites bonus to its attack and damage, gain a +2 flat bonus to your critical threat range, and a +1 to the critical damage multiplier. After this attack your smite on it ends, and you are no longer able to make any attack roll or use any offensive ability against it. Though you are allowed to smite it again. If the final strike kills it, you can regain spell points equal to half your level. If on the next turn you sheathe your weapon, you can regain spell points equal to half your level.`,                        
            },
            {
                name:"Order of Judgement",
                alignments:["All"],
                description:`You modify your smite so that instead of a lasting ability, it is just a single strike. When you smite a creature your next attack within this turn against the target gains the normal amount you would gain to attack, damage, and DR bypassing, however also gains additional effects. It also deals an additional 1d6 points of damage per level, and you gain a +2 flat bonus to your critical threat range, and a +1 bonus to your critical damage multiplier. If you are neutral these additional bonuses are halved to same way your normal smite is. Every 8 levels the increase to critical threat range increases by +1, and every 10 levels the critical damage multiplier increases by +1. You can activate judgement smite on the same creature multiple times, but each time you do its spell point cost increases by your level spell points, and the cost to use your regular smite against them also goes up by that amount. You cannot activate judgement smite on a creature you currently have smited. Bonuses that have a duration when you smite still activate when you use this ability, however they now only last 1 round.`,                        
            },
            {
                name:"Order of Berserk",
                alignments:["LE","CE","NE"],
                description:`When you smite you can choose to spend hit points instead of spell points to smite by increasing the cost by 50%. The spell point cost of your smite is doubled if you take this order. When you are below 50% hit points you gain a +1 bonus to attack and damage against the target of your smite, but your armor class and saves are reduced by -1. Double the bonuses and penalties when below 25% hit points. The bonus and penalty increases by 1 every 5 levels.`,                        
            },
        ]
        
    },
    {
        rarity: "unique",
        type: "martial",
        name: "Rage",
        fromClass: "Barbarian",
        shortDesc: `For one spell point a round you can activate rage as a free action. 
        \nWhile in rage, you gain a +4 morale bonus to your Strength and Constitution, as well as a +2 morale bonus on Will saves, but a -2 penalty to Armor Class. While in rage, you cannot use any Charisma-, Dexterity-, or Intelligence-based skills (except Acrobatics, Fly, Intimidate, and Ride) or any ability that requires patience or concentration. Your spellcasting also becomes restricted: buff, control, and utility, all cost double the spell points, and you cannot cast healing spells.
        \nAt level 5 the bonuses increase to +6 to ability scores, +3 to will, and costs 3 spell points per round, 
        \nAt level 8 you no longer becomes fatigued after raging, however cannot re-enter rage for 1 full round after they have left rage.
        \nAt level 10 the bonuses increase +8 to ability scores, +4 to will, and costs 6 spell points. 
        \nAt level 16 the bonuses increase to +12 to ability scores, +6 to will, and costs 8 spell points.
        \nAt level 20 the bonuses increase to +16 to ability scores, +8 to will, and costs 10 spell points.
        \nYou can end your rage as a free action. When it does end, you are fatigued for a number of rounds equal the number of rounds spent in the rage. You cannot enter a new rage while fatigued or exhausted but can otherwise enter rage multiple times during a single combat. If you fall unconscious, your rage immediately ends, placing you in peril of death.
        \nAt 1st, and every odd level after you gain a rage power. 
        \nEvery level you gain a maneuver from school of choice: Black Seraph, Burning Citadel, Piercing Thunder, Primal Fury, Brutal Crocodile, Indomitable Will, or Crimson Reaper.
        \nYou gain a bonus to your spell points equal to your constitution modifier. This amount isn't changed by temporary modifiers. Every 6 levels you increase your spell points by your constitution modifier again.`,
        hasCustomMethod:true,
        customMethod:(context, self)=>{
            if(context.stats.characterStats.misc.level %2 == 1){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Rage Power"}))
            }
            self.getManeuver(context, context.stats.characterStats.misc.level)
        },
        catchUpMethod:(context, self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level;x++){
                self.getManeuver(context, x)
                if(x==1 || x %2 == 1){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Rage Power"}))
                }
            }
        },
        getManeuver: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}, school:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            let schools = ["blackSeraph", "brutalCrocodile", "piercingThunder", "primalFury", "burningCitadel", "indomitableWill","crimsonReaper"]
            let choices = []           
            for(let x = 0; x < schools.length; x++){
                let choice = {
                    title:schools[x],
                    id:x, 
                    method:(context=>{                            
                        options.school[schools[x]] = true
                        context.connection.send(JSON.stringify(
                            {
                                command:"requestRoll", 
                                type:"maneuver", 
                                options
                            }
                        ))
                    })}
                    choices.push(choice)
            }         
            let custom = {title:"Typed Maneuver Choice", options:choices}         
            context.customDialogArray.push(custom)
        }, 
    },
    {
    rarity: "unique",
    type: "martial",
    name: "Flurry of Blows",
    fromClass:"Monk",
    shortDesc: `When making a full-attack action you can make one additional attack at your highest base attack bonus, however all attacks you make in the round receive a -2 to attack. When using any benefit provided by this ability, you must make the attacks with a combination of unarmed strikes, unarmed augmenting weapons, or monk weapons. Your unarmed attacks, even with unarmed augmenting weapons count as unarmed strikes and natural attacks. You take no penalty for using multiple weapons when making a flurry of blows, but you do not gain any additional attacks beyond what's already granted by the flurry for doing so (such as from two weapon fighting, he can still gain additional attacks from a high base attack bonus, from this ability, and from haste and similar effects). You gain your full strength on all damage rolls while using flurry of blows, and if using unarmed strikes or unarmed augmenting weapons you can increase their damage by one step, plus an additional step every 5 levels. You do not provoke attacks of opportunity while making an unarmed strikes and the damage becomes lethal. While using flurry of blows, if you attack with at least 2 different weapons your attacks qualify for abilities that augment two-weapon fighting, such as the improved two-weapon fighting feat to grant an additional attack.
    \nAt 4th level you can spend level/2 spell points while using flurry of blows to make another additional attack at a -4 penalty.
    \nAt 6th you can spend level/2 spell points while making an attack as a standard action to gain an additional attack at a -8 penalty.
    \nAt 8th a monk can make another additional attack at your highest base attack bonus whenever you makes a flurry of blows, but all attacks made in the round receive another -2 to attack.
    \nAt 12th you can spend level/2 spell points to gain another additional attack while making a flurry of blows at a -8 penalty.
    \nAt 14th you can spend level/2 spell points while making an attack as a standard or attack action to gain another additional attack but at a -12 penalty.
    \nAt 16th level, a monk can make another additional attack at his highest base attack bonus whenever he makes a flurry of blows, but all attacks made in the round receive another -2 to attack.
    \nAt 20th level, a monk can make another additional attack at his highest base attack bonus whenever he makes a flurry of blows, but all attacks made in the round receive another -2 to attack.
    \n\nAt 1st and every 4 levels you gain Ki Power. 
    \nEvery level you gain a maneuver from school of choice: Broken Blade/Sleeping Goddess/Silver Crane/Brutal Crocodile/Indomitable Will.`,
    prereq:"special",
    hasCustomMethod:true,
    customMethod:(context, self)=>{
        let lvlNum = context.stats.characterStats.misc.level
        if(lvlNum == 1 || lvlNum%4 == 0){
            self.getPerks(context)
        }
        self.getManeuver(context, lvlNum)
    },
    catchUpMethod:(context, self)=>{
        for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
            if(x==1 || x%4 == 0){
                self.getPerks(context)
            }
            self.getManeuver(context, x)
        }
    },
    getPerks:(context)=>{
        context.connection.send(JSON.stringify({
            command:"requestRoll", 
            type:"Perk", 
            options:{
                sub:{kiPerks:true}
            }
        }
    ))
    },
    getManeuver:(context, lvlNum)=>{
        lvlNum = Math.ceil(lvlNum/2)+1
        if(lvlNum > 9){lvlNum = 9}
        let options = {level:{}}
        for(let x = 0; x < 4; x++){
            if(lvlNum-x > 0){   
                let level = lvlNum-x
                let levelString="lvl"+level;
                options.level[levelString]=true;
            }
        }
        options.school = {brokenBlade:true,sleepingGoddess:true,silverCrane:true,brutalCrocodile:true,indomitableWill:true}
        let obj={command:"requestRoll", type:"maneuver", options};
        context.connection.send(JSON.stringify(obj));
    },
    },
    {
        rarity: "unique",
        type: "martial",
        name: "Unarmed Fighting",
        fromClass:"Monk",
        shortDesc: `You do not provoke attacks of opportunity while making an unarmed strikes and the damage becomes lethal. Your unarmed attacks, even with unarmed augmenting weapons count as unarmed strikes and natural attacks.        
        \nChoose between two fighting styles, Flurry of Blows or Enlightened Path. 
        \nFlurry of blows: Make extra attacks during full-round attacks with unarmed strikes and gain the ability to spend spell points to make more additional attacks during both full-round actions and standard action attacks. Increase your unarmed strike damage at a rapid pace. You will also gain a maneuver Broken Blade/Sleeping Goddess/Silver Crane/Brutal Crocodile schools every odd level, and a ki perk at 1st and every 4 levels.
        \nEnlightened Path: Gain a special selection of martial maneuvers from the enlightened path school of maneuvers, chain them and maneuvers from other specific disciplines together to unleash powerful finishing moves. Additionally, every level you will gain an enlightened path manever, every even level a maneuver from a school of choice that has a finisher tag, an Enlighted Path perk at 1st and every 4 levels and a ki perk every 6 levels.`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            context.doNothing = "donothing"
        },
        catchUpMethod:(context, self, contextSelf)=>{
            self.getPath(context,self, contextSelf)            
        },

        getPath(context, self, contextSelf){
            self.doNothing = "donothing"
            let optionNames = ["Enlightened Path", "Flurry of Blows"]
            let options = []
            let paths = self.paths
            for(let x = 0; x < 2; x++){
                let option = {
                    title:optionNames[x],
                    id:x-1,
                    description: paths[x].description,
                    method:()=>{
                        contextSelf.shortDesc += `\n\nChosen: ` + optionNames[x]
                        contextSelf.hidden = true
                        let perk = perks.find(perk => perk.name == optionNames[x])
                        let contextPerk = JSON.parse(JSON.stringify(perk))
                        contextPerk.id = Math.random()
                        context.stats.lists.perks.push(contextPerk)
                        perk.catchUpMethod(context,perk,contextPerk)
                    }
                }
                options.push(option)
            }               
            context.customDialogArray.push({title:"Unarmed Fighting Choice", options})
        },
        paths:[
            {
                name:"Enlightened Path",
                type:["path"],
                description:`At level 1 you you gain access to a new martial discipline called Enlightened Path. This grants you 4 specific elemental strikes, stances, and finishers.
                \nEnlightened Path Stances: These act like normal martial stances, except you can have one of these active at the same time as you have another martial stance active. The stances you will unlock are called Mountain Stance, Ocean Stance, Sun Stance, and Wind Stance.
                \nEnlightened Path Finishers: Enlightened path finishers do not become expended when used, instead, when you initiate one, you can recover one enlightened path maneuver.
                \nEnlightened Philosophy: You will also select between 3 paths, The Path of Balance, The Path of Dominion, and the Path of Emptiness. This will also unlock new strikes and finishers, as well as determining the types of Enlightened Path perks you will have access to.
                \nAt 1st and every 4 levels you will gain an elightened path perk, and every 6 levels you will gain a ki perk.`,
            },
            {
                name:"Flurry of Blows",
                type:["path"],
                description:`When making a full-attack action you can make one additional attack at your highest base attack bonus, however all attacks you make in the round receive a -2 to attack. When using any benefit provided by this ability, you must make the attacks with a combination of unarmed strikes, unarmed augmenting weapons, or monk weapons. Your unarmed attacks, even with unarmed augmenting weapons count as unarmed strikes and natural attacks. You take no penalty for using multiple weapons when making a flurry of blows, but you do not gain any additional attacks beyond what's already granted by the flurry for doing so (such as from two weapon fighting, he can still gain additional attacks from a high base attack bonus, from this ability, and from haste and similar effects). You gain your full strength on all damage rolls while using flurry of blows, and if using unarmed strikes or unarmed augmenting weapons you can increase their damage by one step, plus an additional step every 5 levels. You do not provoke attacks of opportunity while making an unarmed strikes and the damage becomes lethal. While using flurry of blows, if you attack with at least 2 different weapons your attacks qualify for abilities that augment two-weapon fighting, such as the improved two-weapon fighting feat to grant an additional attack.
                \nAt 4th level you can spend level/2 spell points while using flurry of blows to make another additional attack at a -4 penalty.
                \nAt 6th you can spend level/2 spell points while making an attack as a standard action to gain an additional attack at a -8 penalty.
                \nAt 8th you can make another additional attack at your highest base attack bonus whenever you makes a flurry of blows, but all attacks made in the round receive another -2 to attack.
                \nAt 12th you can spend level/2 spell points to gain another additional attack while making a flurry of blows at a -8 penalty.
                \nAt 14th you can spend level/2 spell points while making an attack as a standard or attack action to gain another additional attack but at a -12 penalty.
                \nAt 16th level, you can make another additional attack at your highest base attack bonus whenever you makes a flurry of blows, but all attacks made in the round receive another -2 to attack.
                \nAt 20th level, you can make another additional attack at your highest base attack bonus whenever you makes a flurry of blows, but all attacks made in the round receive another -2 to attack.
                \n\nAt 1st and every 4 levels you gain Ki Power. 
                \nEvery level you gain a maneuver from school of choice: Broken Blade/Sleeping Goddess/Silver Crane/Brutal Crocodile/Indomitable Will.`,
            }
        ],
        hasSpecialItems:true,
        getSpecialItemList:(self)=>{
            let perk = perks.find(perk => perk.name == "Enlightened Path")
            let enlightedPerks = perk.getSpecialItemList(perk)
            let foundPerks = self.paths.concat(enlightedPerks)
            return foundPerks
        },
        getPerks:(context)=>{
            context.connection.send(JSON.stringify({
                command:"requestRoll", 
                type:"Perk", 
                options:{
                    sub:{kiPerks:true}
                }
            }
        ))
        },        
        },
        {
            rarity: "unique",
            type: "martial",
            name: "Enlightened Path",
            fromClass:"Monk",
            shortDesc: `You do not provoke attacks of opportunity while making an unarmed strikes and the damage becomes lethal. Your unarmed attacks, even with unarmed augmenting weapons count as unarmed strikes and natural attacks.
            \nAt level 1 you you gain access to a new martial discipline called Enlightened Path. You will start with 4 specific elemental strikes, stances, and 4 finishers from it. The 4 basic enlightened path strikes, plus your philosophy base strike are not expended when used, but you cannot use more than one of these maneuvers per round.
            \nEnlightened Path Stances: You can have one level 0 enlightened path stance active at the same time as your normal martial stance. The stances you will unlock are Mountain Stance, Ocean Stance, Sun Stance, and Wind Stance.
            \nEnlightened Path Finishers: Enlightened path finishers do not become expended when used. Instead, when initiated you can recover one enlightened path maneuver.
            \nEnlightened Philosophy: You will select between 3 philosophies, The Path of Balance, The Path of Dominion, and the Path of Emptiness. This will also unlock a new strike and 4 more finishers, as well as determining the types of Enlightened Path perks you will have access to.
            \nYou also gain a perk called 'Maneuver Freedom'. This allows you to bypass some of the normal requirements for certain disciplines.
            \n\nAdditionally, every odd level you will get another enlightened path maneuver. Every even level you gain a maneuver from a school of choice between all <Dark/Light/Void/Elemental> schools.
            \nGain a Enlightened Path perk at 1st and every 4 levels.
            \nGain a ki perk every 6 levels`,
            prereq:'special',
            hasCustomMethod:true,
            customMethod:(context, self, contextSelf)=>{
                let lvlNum = context.stats.characterStats.misc.level
                
                if(lvlNum%2 == 1) context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{school:{enlightenedPath:true}, includeSubschool:contextSelf.pathChosen,type:{Strike:true,Boost:true,Stance:true,Counter:true,Finisher:true}}}))
                if(lvlNum%2 == 0) self.getManeuver(context, contextSelf.pathChosen, (Math.ceil(lvlNum/2)+1),self)
                if(lvlNum%4 == 0) self.getPerks(context, contextSelf.pathChosen, self)
                if(lvlNum%6 == 0) context.connection.send(JSON.stringify({command:"requestRoll",type:"Perk",options:{sub:{kiPerks:true}}}))

                contextSelf.perkSelections.forEach(perkName=>{
                    let perk = self.pathPerks.find(perk => perk.name == perkName)
                    perk.customMethod(context,perk)
                })
            },
            catchUpMethod:(context, self,contextSelf)=>{
                let maneuverNames = ["Mountain Stance", "Wind Stance", "Sun Stance", "Ocean Stance", "The Trembling Earth","The Gathering Storm","The Raging Sea","Breath of the Fire Dragon","Strike of the Enduring","Storm Strike","Fires of Purity","Flowing Water Strike", ]
                maneuverNames.forEach(maneuverName=>{
                    let maneuver = maneuvers.find(maneuver => maneuver.name == maneuverName)
                    maneuver.id = Math.random()
                    context.stats.lists.maneuver.push(maneuver)
                })
                self.getPath(context,self,contextSelf)
                self.addManeuverFreedom(context)
                for(let x = 1; x < context.stats.characterStats.misc.level; x++){
                    if(x%6 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"Perk",options:{sub:{kiPerks:true}}}))
                    }
                }
            },
            
            getPath(context, self, contextSelf){
                let optionNames = ["Path of Balance","Path of Dominion","Path of Emptiness"]
                let paths = [];paths["Path of Balance"] = "light"; paths["Path of Dominion"] = "dark"; paths["Path of Emptiness"] = "void";
                let options = []                
                for(let x = 0; x < 3; x++){
                    let option = {
                        title:optionNames[x],
                        id:x-1,
                        description: self.paths[x].description,
                        method:()=>{
                            if(self.paths[x].hasCustomMethod){
                                self.paths[x].customMethod(context)
                            }
                            self.paths[x].maneuverList.forEach(maneuverName=>{
                                let maneuver = maneuvers.find(maneuver => maneuver.name == maneuverName)
                                maneuver.id = Math.random()
                                context.stats.lists.maneuver.push(maneuver)
                            })
                            contextSelf.shortDesc += `\n\nChosen: ` + optionNames[x] + `\n` + option.description
                            contextSelf.pathChosen = paths[optionNames[x]]
                            self.getPerks(context,paths[optionNames[x]],self,contextSelf)
                            for(let y = 1; y <= context.stats.characterStats.misc.level; y++){
                                if(y%4 == 0){
                                    self.getPerks(context,paths[optionNames[x]],self)
                                }
                                if(y%2 == 1) context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{school:{enlightenedPath:true}, includeSubschool:contextSelf.pathChosen, level:self.getManeuverLevels(y)}}))
                                if(y%2 == 0) self.getManeuver(context, contextSelf.pathChosen, (Math.ceil(y/2)+1), self)
                            }
                        }
                    }
                    options.push(option)
                }               
                context.customDialogArray.push({title:"Enlightened Path Philosophy Choice", options})                
            },
            addManeuverFreedom:(context)=>{
                let text = `For Iron Tortoise you can use your unarmed attacks as a shield for its maneuvers.
                \nYou can initiate Heart of the Maelstrom maneuvers that include an attack even when not using dexterity for attack or damage.
                \nYou can initiate any Burning Citadel maneuver with unarmed strikes.
                \nYou can initiate any Black Seraph maneuver with unarmed attacks.
                \nIf you are in a water stance, you can sheathe an unarmed weapon once per round as a free action that you can take even when not your turn.`
                let newPerk = {name:"Maneuver Freedom",rarity:"unique", uitType:"perks", type:"martial", id:Math.random(), shortDesc:text}
                context.stats.lists.perks.push(newPerk)
            },
            paths:[
                {
                    name:"Path of Balance",
                    type:["Enlightened Path"],
                    description:`The path of balance is a path that focuses on healing and protecting allies. Every time you hit and deal damage with an unarmed attack, you can heal yourself or an ally within your reach 1 hit point. Every 3 levels this increases by 1. All healing done towards a creature per round is totalled as one source of healing before being modified.`,
                    maneuverList:["Fist of Light","Healing Ki","Gasp of the Earth Dragon","Dance of the Clouds","Walk of the Sun","Aligning the Heavens"]
                },
                {
                    name:"Path of Dominion",
                    type:["Enlightened Path"],
                    description:`The path of dominion focuses on death and offense. You gain 1d6 points of sneak attack damage, increasing by 1d6 every 5 levels.`,
                    maneuverList:["Fist of Darkness","Touch of Despair","Pain Touch","Falling Stars Strike","Karmic Fist","Freezing the Lifeblood"],
                },
                {
                    name:"Path of Emptiness",
                    type:["Enlightened Path"],
                    description:`The path of emptiness focuses unique powers that bend and warp reality. Your spell points per level is increased by 2.`,
                    maneuverList:["Fist of the Void","Infinite Force Strike","Empty Body","Step of the Void","Curse of the Void","Moment of Clarity"],
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.stats.characterStats.misc.spPerLevel += 1
                    }
                }
            ],
            hasSpecialItems:true,
            getSpecialItemList:(self)=>{
                let returning = self.pathPerks.map(perk=> {let returned = perk; returned.type.push(perk.path); return returned})
                return self.paths.concat(returning)
            },
            perkSelections:[],
            getPerks:(context, path, self,contextSelf)=>{
                let choices = []
                let chosen = []
                let filtered = self.pathPerks.filter(pathPerk => pathPerk.path == path || pathPerk.path == "universal")
                for(let x = 0; x < 4; x++){
                    let possible = Math.floor(Math.random()*filtered.length)
                    while(chosen.includes(possible)) possible = Math.floor(Math.random()*filtered.length)
                    chosen.push(possible)
                    let option = filtered[possible]
                    choices[x] = {
                        title:option.name,
                        description: option.description,
                        id:x,
                        method:(context =>{
                            let perk = {rarity:"unique", name:option.name, id:Math.random()*1000000, additionalInfoTags:option.additionalInfoTags, type:"martial", shortDesc:option.description}
                            context.stats.lists.perks.push(perk)
                            if(option.hasCustomMethod){
                                option.catchUpMethod(context)
                                contextSelf.perkSelections.push(perk.name)
                            } 
                        })
                    }                
                }
                let custom = {title:"Enlightened Perk Selection", options:choices}
                context.customDialogArray.push(custom)
            },

            getManeuver: (context, path, lvlNum, self)=>{
                let paths = [];paths["Path of Balance"] = "light"; paths["Path of Dominion"] = "dark"; paths["Path of Emptiness"] = "void";
                let schools = ["elementalFlux", "ironTortoise", "mithralCurrent", "heartOfTheMaelstrom", "burningCitadel", "enlightenedPath",]
                if(path == 'light') schools = schools.concat(["radiantDawn", "silverCrane",'indomitableWill'])
                else if(path == 'dark') schools = schools.concat(["blackSeraph", "unquietGrave","steelSerpent"])
                else if(path == 'void') schools = schools.concat(["veiledMoon","sleepingGoddess","rivenHourglass"])
                let level = self.getManeuverLevels(lvlNum)               
                let options = {level:level, school:{}, includeSubschool:path}
                let choices = []           
                for(let x = 0; x < schools.length; x++){
                    let choice = {
                        title:schools[x],
                        id:x, 
                        method:(context=>{
                            options.school[schools[x]] = true
                            context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options}))
                        })}
                        choices.push(choice)
                }
                
                let custom = {title:"Typed Maneuver Choice", options:choices}         
                context.customDialogArray.push(custom)
            },
            getManeuverLevels(lvlNum){
                if(lvlNum > 9){lvlNum = 9}
                let levels = {}
                for(let x = 0; x < 4; x++){
                    if(lvlNum-x > 0){
                        let level = lvlNum-x
                        let levelString="lvl"+level;
                        levels[levelString]=true;
                    }
                }
                return levels
            },
            pathPerks:[
                {
                    name:"Enlightened Fist",
                    type:["Path Perk"],
                    path:"universal",
                    description:"Increase the damage of your unarmed attacks by 1 step. Every 8 levels increase the damage by another step.",
                },
                {
                    name:"Difficulty at the Beginning",
                    type:["Path Perk"],
                    path:"light",
                    description:"[Finisher Empowerment] Your <light> only finishers that heal also applies a Lesser Restoration effect. (Restores 1d4 points of ability damage, eliminates fatigue, and improves an exhausted condition to fatigued.) Every 8 levels the ability damage healed increases by 1d4. This can affect only a single creature per use of a finisher.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"To Seek Perfection",
                    type:["Path Perk"],
                    path:"light",
                    description:"[Finisher Empowerment] After you use a <light> finisher you gain a 1d4 enhancement bonus to 2 ability scores of choice for 3 rounds. This stacks with itself.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"Smite the Tainted",
                    type:["Path Perk"],
                    path:"light",
                    description:"Your <light> only finishers that heal in a radius also deals half the damage it would heal to creatures with your opposing good/evil alignment that are within the area. If you are neutral, it instead deals damage to good and evil creatures, but deals only 25% of the damage it would heal.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"Purified Spirit",
                    type:["Path Perk"],
                    path:"light",
                    description:"Increase your damage with unarmed attacks by 1 dice step. Your wisdom also increases by +4.",
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.abilityScore.wisdom += 4
                    }
                },
                {
                    name:"Argent Fist",
                    type:["Path Perk"],
                    path:"light",
                    description:"Your unarmed attacks bypass damage reduction cold iron, silver, and evil. When your fists would bypass that damage reduction for other reasons, you instead deal 2d6 additional damage to creatures that have that type of damage reduction.",
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.abilityScore.wisdom += 4
                    }
                },
                {
                    name:"Lifting the Veil",
                    type:["Path Perk"],
                    path:"light",
                    description:"[Finisher Empowerment] Your <light> only finishers that heal also removes blindness and deafness as the Remove Blindness/Deafness spell to a single ally affected.",
                    additionalInfoTags:["Finisher Empowerment"]
                },                
                {
                    name:"Exemplar",
                    type:["Path Perk"],
                    path:"light",
                    description:"[Finisher Empowerment] Your <light> finishers that heal also give affected allies a +3 dodge bonus to armor class for 1 round. Every 8 levels the bonus increases by +1.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"Imbued with Light",
                    type:["Path Perk"],
                    path:"light",
                    description:"[Finisher Empowerment] Your <light> finishers that affect allies, whether they heal or not, heals them an additional amount of 1d4 points per 2 levels.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"Restoring the Balance",
                    type:["Path Perk"],
                    path:"light",
                    description:"[Finisher Empowerment] Your <light> only finishers that heal also remove curses as the Remove Curse spell to a single ally affected.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"The Receptive Earth",
                    type:["Path Perk"],
                    path:"light",
                    description:"[Finisher Empowerment] Your <light> only finishers that heal also remove disease and poisons as the Remove Disease and Neutralize Poison spells to a single ally affected.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"Returning the Faith",
                    type:["Path Perk"],
                    path:"light",
                    description:"[Finisher Empowerment] Your <light> only finishers that heal also removes fear, allowing a single ally who is currently affected by a fear effect that allowed a save, a new save to end the effect.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"Reception of Light",
                    type:["Path Perk"],
                    path:"light",
                    description:"When you are healed by positive energy from another creature, or heal other creatures with positive energy, the healing is increased by +1 point per dice rolled.",
                },
                {
                    name:"Rise of the Phoenix",
                    type:["Path Perk"],
                    path:"light",
                    description:"Once per floor you can activate this perk while dead when it would normally have been your turn in initiative. Doing this costs level x2 spell points, and you do not get to act on the turn you used this. You are restored to life as if you had the resurrection spell cast on you, except you only restore half your maximum hit points.",
                },
                {
                    name:"Way of the Patient Tortoise",
                    type:["Path Perk"],
                    path:"light",
                    description:"Increase your constitution by +4. You also gain +5 sense motive",
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.abilityScore.constitution += 4
                        context.stats.characterStats.skills.senseMotive += 5
                    }
                },
                {
                    name:"Way of the Fist",
                    type:["Path Perk"],
                    path:"universal",
                    description:"Gain 2 ki perks",
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"Perk",options:{sub:{kiPerks:true}}}))
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"Perk",options:{sub:{kiPerks:true}}}))
                    }
                },
                {
                    name:"Way of the Tenacious Badger",
                    type:["Path Perk"],
                    path:"light",
                    description:"While in combat and below 50% hit points, you restore 1 spell point and 1 hit points at the start of each of your turns. Every 3 levels the hit point healing increases by 1 point, and every 5 levels the spell point restoring increases by 1 point. You also gain +10 intimidate.",
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.skills.intimidate += 10
                    }
                },
                {
                    name:"Ultimate Harmonious Balance",
                    type:["Path Perk"],
                    path:"light",
                    description:"You gain +1 <light> mastery and positive spell power per level. Whenever you initiate a <light> finisher you can recover any single <light> maneuver. This cannot be a finisher, or a maneuver you initiated this round.",
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.stats.characterStats.schoolMastery.Light += 1
                        context.stats.characterStats.spellMastery.spellPower.positive += 1
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.schoolMastery.Light += parseInt(context.stats.characterStats.misc.level)
                        context.stats.characterStats.spellMastery.spellPower.positive += parseInt(context.stats.characterStats.misc.level)
                    }
                },
                {
                    name:"Wholeness of Spirit",
                    type:["Path Perk"],
                    path:"light",
                    description:"Once per floor you can as a free action spend 20 spell points to restore yourself to full hit points and cure all ability damage, ability penalty, temporary negative levels, fatigue and exhaustion.",
                },
                {
                    name:"Last Hope",
                    type:["Path Perk"],
                    path:"light",
                    description:"Once per floor when you are reduced below 20% hit points, you gain a sacred bonus to your attack and damage equal to your initiation modifier for 3 rounds. At the start of each of your turns for the next 3 rounds, you automatically heal initiation modifier * 1/2 level hit points.",
                },
                {
                    name:"Celestial Mandate",
                    type:["Path Perk"],
                    path:"light",
                    description:"Your ability to heal yourself or an ally within reach every time you successfully hit and deal damage with an unarmed attack has its range increased to 30 feet. You must be able to see the ally to use this on them.",
                },
                {
                    name:"Wholeness of Hatred",
                    type:["Path Perk"],
                    path:"dark",
                    description:"Once per floor you can delay all damage against you for 3 rounds, however it is all increased by 25%. During this time, you also gain a +4 bonus on all saving throws, and if you succeed a saving throw, and the ability has a lessened effect on a successful save, it is instead negated.",
                },
                {
                    name:"Taste for Blood",
                    type:["Path Perk"],
                    path:"dark",
                    description:"If you confirm a critical hit on an attack that is dealing sneak attack damage, the sneak attack damage is doubled.",
                },
                {
                    name:"Wholeness of Mind",
                    type:["Path Perk"],
                    path:"void",
                    description:"Once per floor you can as a free action restore spell points equal to your highest mental modifier * 1/2 level to yourself. Any excess spell points remain as temporary spell points for 1 round.",
                },
                {
                    name:"Calm Before Storms",
                    type:["Path Perk"],
                    path:"universal",
                    description:"You no longer automatically fail will saves on a natural 1. Gain a +2 bonus on your will saves.",
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.misc.will += 2
                    }
                },
                {
                    name:"Ultimate Inevitable Dominion",
                    type:["Path Perk"],
                    path:"dark",
                    description:"You gain +1 <dark> mastery per level, and +1 negative spell power per level. Whenever you initiate a <dark> finisher you can recover any single <dark> maneuver. This cannot be a finisher, or a maneuver you initiated this round.",
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.stats.characterStats.schoolMastery.Dark += 1
                        context.stats.characterStats.spellMastery.spellPower.negative += 1
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.schoolMastery.Dark += context.stats.characterStats.misc.level
                        context.stats.characterStats.spellMastery.spellPower.negative += context.stats.characterStats.misc.level
                    }
                },
                {
                    name:"Completely Null and Void",
                    type:["Path Perk"],
                    path:"void",
                    description:"You gain +1 <void> mastery per level. Whenever you initiate a <void> finisher you can recover any single <void> maneuver. This cannot be a finisher, or a maneuver you initiated this round.",
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.stats.characterStats.schoolMastery.Void += 1
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.schoolMastery.Void += context.stats.characterStats.misc.level
                    }
                },
                {
                    name:"Dark Orchid",
                    type:["Path Perk"],
                    path:"dark",
                    description:"When you confirm a critical hit with an unarmed attack, the creature becomes paralyzed for the rest of your turn, or until you make an attack against it (ending after the results of the attack are determined).",
                },
                {
                    name:"Impending Doom",
                    type:["Path Perk"],
                    path:"dark",
                    description:"[Finisher Empowerment] If the enemy affected by a <dark> only finisher dies within the next 3 rounds, you restore level spell points and gain level x5 temporary hit points. Enemies immune to your Touch of Despair cannot be Doomed. These temporary hit points last for 1 hour and stack.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"Scream",
                    type:["Path Perk"],
                    path:"dark",
                    description:"Whenever a creature scores a successful critical hit against you, they take sonic damage equal to your highest mental modifier and they suffer a -2 penalty on all attacks, damage, and saves for 1 round. If you are killed, the creature who killed you suffers sonic damage equal to your <dark> mastery and suffer a -4 penalty to attacks, damage, and saves for 1d4 rounds or until you are alive again. All creatures suffer a -4 penalty on saves against any of your abilities or spells while you are dead.",
                },
                {
                    name:"Despoiler",
                    type:["Path Perk"],
                    path:"dark",
                    description:"Whenever you kill a creature, you gain a +2 bonus to attacks and +4 damage until the end of your next turn, you can move 10 feet without provoking attacks of opportunity, and you can choose to gain a <dark> combo point or recover any <dark> maneuver. This cannot be a finisher or a maneuver you initiated this round.",
                },
                {
                    name:"Condemnation",
                    type:["Path Perk"],
                    path:"dark",
                    description:"You gain a +2 bonus on attacks against creatures below 25% hit points and deal an additional 1d6 damage against them. The damage increases by 1d6 every 9 levels. Creatures below 25% hit points also suffer a -2 penalty on saves against your abilities and spells.",
                },
                {
                    name:"Despair",
                    type:["Path Perk"],
                    path:"dark",
                    description:"Every time a creature fails a save against one of your abilities or spells, they suffer a -1 penalty on all saves against your further spells or abilities. This stacks.",
                },
                {
                    name:"Weapons of Murder",
                    type:["Path Perk"],
                    path:"dark",
                    description:"You can use light manufactured weapons in place of unarmed strikes for any ability or maneuver that requires use of unarmed strikes.",
                },
                {
                    name:"Exploit",
                    type:["Path Perk"],
                    path:"dark",
                    description:"Your <dark> finisher strikes deal an additional 2d12 negative energy damage, increasing by 1d12 every 6 levels. This applies only to their first attack.",
                },
                {
                    name:"Way of the Murderous Mantis",
                    type:["Path Perk"],
                    path:"dark",
                    description:"Increase your sneak attack damage by 1d6 per 6 levels. You also gain a +10 bonus to your stealth.",
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.skills.stealth += 10
                    }
                },
                {
                    name:"Poisoned Soul",
                    type:["Path Perk"],
                    path:"dark",
                    description:"[Finisher Empowerment] Your <dark> finisher strikes also causes the creature to make a fortitude saving throw (dc=10 + level + highest mental modifier), on failure it takes 1d6 per 4 levels of negative energy damage at the start of each of its turns. This stacks, but only oncer per finisher.",
                    additionalInfoTags:["Finisher Empowerment"]
                },                
                {
                    name:"Wave of Despair",
                    type:["Path Perk"],
                    path:"dark",
                    description:"[Finisher Empowerment] Your <dark> finishers also causes all enemies within 30 feet to suffer one negative level. This occurs only once per finisher.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"Way of the Elegant Crane",
                    type:["Path Perk"],
                    path:"dark",
                    description:"Whenever you confirm a critical hit you restore level/3 spell points. You also gain +10 to your diplomacy.",
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.skills.diplomacy += 10
                    }
                },
                {
                    name:"Way of the Hunting Dog",
                    type:["Path Perk"],
                    path:"dark",
                    description:"You gain an additional +2 bonus on attack rolls against creatures that are flanked (whether you are flanking them or not). You also gain a +10 bonus to perception checks.",
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.skills.perception += 10
                    }
                },
                {
                    name:"No Mercy",
                    type:["Path Perk"],
                    path:"dark",
                    description:"You deal an additional 20% damage against creatures who are helpless, nauseated, stunned, or dazed.",
                },
                {
                    name:"All Consuming Elements",
                    type:["Path Perk"],
                    path:"void",
                    description:"[Finisher Empowerment] When you hit a creature with a <void> finisher strike you also choose an element (fire, acid, electricity, cold), they take 25% additional damage from that element for highest mental modifier rounds. A will save (dc=10 + level/2 + highest mental modifier) reduces this to 15% and only lasts 1 round.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"Questionable Existence",
                    type:["Path Perk"],
                    path:"void",
                    description:"[Finisher Empowerment] When hit a creature with a <void> finisher strike they must also make a will save (dc=10 + level/2 + highest mental modifier) or all damage they deal is reduced by 25% for 3 rounds.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"Into The Next Dimension",
                    type:["Path Perk"],
                    path:"void",
                    description:"[Finisher Empowerment] When you hit a creature with your Infinite Force Strike, instead of the creature being pushed away by your bull rush, they are instead shunted to another dimension. You do not get a bonus to your finisher based on the damage dealt, instead, you take a -5 penalty, but if the check succeeds they are shunted to another dimension for 1 round. For every 10 that you beat their CMD by, they are stuck there for an additional round. Once this duration ends they return to the squares they were teleported away from.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"Forced Enlightenment",
                    type:["Path Perk"],
                    path:"void",
                    description:"[Finisher Empowerment] When you successfully hit a creature with a <void> finisher strike they must also make a will save (dc=10 + level/2 + highest mental modifier) or they become confused for rounds equal to your highest mental modifier. This affects only a single creature affected by the finisher, and only applies once during it.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"Detached from Body",
                    type:["Path Perk"],
                    path:"void",
                    description:"You gain fortification 50%. This stacks with other fortification but it is reduced to 25%.",
                },
                {
                    name:"Massive Force",
                    type:["Path Perk"],
                    path:"void",
                    description:"Your void finisher unarmed attacks deals an additional 2d12 force damage, increasing by 1d12 every 6 levels. This applies only once during a finisher.",
                },
                {
                    name:"Every Light Casts a Shadow",
                    type:["Path Perk"],
                    path:"void",
                    description:"[Finisher Empowerment] When hit a creature with a <void> finisher strike, they take a negative level. At level 8 this increases to 1d2 negative levels. At level 16 1d3 negative levels. This affects only a single creature affected by the finisher, and only applies once during it.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"Shadows Cannot Exist Without Light",
                    type:["Path Perk"],
                    path:"void",
                    description:"[Finisher Empowerment] When hit a creature with a <void> finisher strike the creature takes an additional 1d6 points of untyped damage every round at the start of each of their turns (stacks), and if the attack is successful, all allies within 30 feet of you heal 1d6 hit points per 3 levels. This affects only a single creature affected by the finisher, and only applies once during it.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"Way of the Clever Monkey",
                    type:["Path Perk"],
                    path:"void",
                    description:"You gain energy resistance 5 to all elements. This stacks with other elemental resistance. You also gain a +2 bonus on all saves and +5 to bluff.",
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.misc.will += 2
                        context.stats.characterStats.misc.reflex += 2
                        context.stats.characterStats.misc.fortitude += 2
                        context.stats.characterStats.skills.bluff += 5
                    }
                },
                {
                    name:"Embrace the Void",
                    type:["Path Perk"],
                    path:"void",
                    description:"[Finisher Empowerment] When you initiate a <void> finishers you gain temporary hit points equal to 25% of your current hit points. These do not stack with themselves, and dont include temporary hit points in their calculations. These last 3 rounds.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"Reed in the Wind",
                    type:["Path Perk"],
                    path:"void",
                    description:"Whenever you score a critical hit you gain a +3 dodge bonus to your armor class for 3 rounds. If your critical damage multiplier is above 2, for each additional critical damage multiplier the bonus increases by 2. This doesn't stack with itself, instead if it is active when you would gain the bonus again the duration increases by 1 round.",
                    additionalInfoTags:["Finisher Empowerment"]
                },
                {
                    name:"Instictive Defense",
                    type:["Path Perk"],
                    path:"void",
                    description:"You take 25% less damage while you are helpless.",
                },
                {
                    name:"Violence Begets Violence",
                    type:["Path Perk"],
                    path:"universal",
                    description:"When an opponent misses a melee attack against you, you gain a flat +1 bonus to your critical threat range for 1 minute. This stacks up to 5 times and is reset if you critically hit. If you roll within the expanded critical range granted by this perk, you take a penalty to confirm the critical hit equal to 1/2 your level.",
                },
                {
                    name:"Many Ways of War",
                    type:["Path Perk"],
                    path:"universal",
                    description:`Depending on the element of the enlightened path stance you are in, you gain various bonuses to maneuvers of their schools:
                    \nAir: All attacks you make as a part of initiating a heart of the maelstrom maneuver deal an additional 1d6 points of electricity damage and gain a +2 bonus to their attack if made by a creature wearing or primarly made out of metal. 
                    \nFire: All of your Enlightened Path maneuvers that deal fire damage also inflict 1 stack of immolation.
                    \nEarth: For Iron Tortoise maneuvers, your shield bonus to your armor class counts as the natural armor bonus your earth stance is giving.
                    \nWater: All of your unarmed attacks count as silver, and you can sheathe an unarmed weapon as a free action as many times as you want, even when its not your turn.`,
                },
                {
                    name:"Meditations of War",
                    type:["Path Perk"],
                    path:"universal",
                    description:`When you enter a martial stance with an <elemental> tag, you can choose to empower it depending on its element:
                    \nAir Stance: You gain +2 to hit with melee attacks. When making a full-round attack, you may make an additional unarmed attack, though it only deals half its normal damage. You take an additional 10% damage.
                    \nFire Stance: Your unarmed attacks have their damage increased by 1 dice step, and you gain a +2 bonus on the DC's of all maneuvers and Enlightened path and ki perks. You suffer a -2 penalty on all saving throws.
                    \nEarth Stance: Your constitution increases by +4, but you get a -4 penalty to your armor class.
                    \nWater Stance: You gain a +4 dodge bonus to your armor class and reflex saves. You deal 20% less damage.`,
                },
                {
                    name:"Touch by the Incomprehensible",
                    type:["Path Perk"],
                    path:"void",
                    description:`Whenever you are in a <void> stance you gain level % miss chance. This stacks with other miss chances. If you are every in a <light> or <dark> stance that isn't also a void stance, you suffer a 10% chance for any attack against you to automatically hit you. If this happens, the damage is also increased by 25%. 
                    \nAdditionally, you gain a +5 bonus to your <void> mastery.`,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.schoolMastery.Void += 5
                    }
                },
                {
                    name:"Consumed By Hatred",
                    type:["Path Perk"],
                    path:"dark",
                    description:`Whenever you enter a <dark> stance, you can choose to empower it, causing you take a -2 penalty to your armor class, but gain a +4 bonus on your weapon damage rolls. For every 4 levels the AC penalty increases by 1, and the damage increases by +2. Whenever you heal a creature that isn't you with an ability that rolls dice, you reduce the healing by 2 points per dice. 
                    \nAdditionally, you gain a +5 bonus to your <dark> mastery and negative spell power.`,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.schoolMastery.Dark += 5
                        context.stats.characterStats.spellMastery.spellPower.negative += 5
                    }
                },
                {
                    name:"Exuding Rage",
                    type:["Path Perk"],
                    path:"dark",
                    description:`You can cause all of your weapon attacks to gain the vicious property, causing them to deal an additional 2d6 damage, but dealing 1d6 damage to you with every successful attack. If you do this, you also gain +5 <dark> mastery, a +1 bonus on your attack rolls, and a -2 penalty on your armor class. Whenever you suffer a critical hit, you can cause the damage from the vicious to be doubled for 1 round. This stacks (2d6,4d6,6d6, etc.). This also doubles the attack bonus, <dark> mastery, and AC penalty. `,
                },
                {
                    name:"Oppressive Disdain",
                    type:["Path Perk"],
                    path:"dark",
                    description:`All creatures adjacent to you take a -2 penalty on all saving throws. 
                    \nAdditionally, you gain a +5 bonus to your <dark> mastery and negative spell power.`,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.schoolMastery.Dark += 5
                        context.stats.characterStats.spellMastery.spellPower.negative += 5
                    }
                },
                {
                    name:"Tranquility",
                    type:["Path Perk"],
                    path:"light",
                    description:`All creatures adjacent to you gain a +2 bonus on all saving throws. 
                    \nAdditionally, you gain a +5 bonus to your <light> mastery and positive spell power.`,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.schoolMastery.Light += 5
                        context.stats.characterStats.spellMastery.spellPower.positive += 5
                    }
                },
                {
                    name:"Walk of the Moon",
                    type:["Path Perk"],
                    path:"void",
                    description:`Whenever you teleport, you heal 1d6 hit points, plus 1d6 per 30 <void> mastery and gain a +1 dodge bonus to your armor class for 1 round. The dodge bonus stacks, up to a maximum of your initiation modifier.`,
                },
                {
                    name:"Spirit is Nothingness",
                    type:["Path Perk"],
                    path:"void",
                    description:`Whenever you roll a natural 1 on a saving throw, you have a 50% chance to automatically succeed on the save as if you had rolled a natural 20. Creatures suffer a penalty to confirm critical hits against you equal to your wisdom modifier.`,
                },
                {
                    name:"Purpose and Non-Existence",
                    type:["Path Perk"],
                    path:"void",
                    description:`Whenever you score a critical hit on a creature with an unarmed attack, they lose their swift action next turn, and you gain an additional swift action on the turn after. You cannot use this swift action to initiate a maneuver.`,
                },
                {
                    name:"Gaze Into the First Ring",
                    type:["Path Perk"],
                    path:"void",
                    description:`Once per day you can return yourself to whatever state you were in exactly 1 round prior. This includes nearly everything, hit points, spell points, statuses, position, even what you have and haven't expended for the day. There are a couple exceptions: the perks gaze into the first, second, or third ring, what items you have bought, any wisdom drain, and aging effects. When you use this ability you take 4 wisdom drain (bypasses drain immunity and resistance. If you have no wisdom, you cannot use this). Activating this ability is a free action you can take even when not your turn.
                    \nYour wisdom reduces by 2 for selecting this perk. At least until you reach enlightenment...`,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.abilityScore.wisdom -= 2
                        if(context.stats.lists.perks.filter(perk=> perk.name == 'Gaze Into the First Ring').length == 1 && context.stats.lists.perks.filter(perk=> perk.name == 'Gaze Into the Second Ring').length == 1 && context.stats.lists.perks.filter(perk=> perk.name == 'Gaze Into the Third Ring').length == 1) context.stats.characterStats.abilityScore.wisdom += 12
                    }
                },
                {
                    name:"Gaze Into the Second Ring",
                    type:["Path Perk"],
                    path:"void",
                    description:`Once per day you can act as if you are in two places at once, taking two turns. When you use this ability, your additional self appears on any square on the map you know the existence of. After you use this ability you take 4 wisdom drain (bypasses drain immunity and resistance. If you have no wisdom, you cannot use this). Usages of any abilities, loss of hit points or damage to any of your statistics is transfered to you at the end of the round.
                    \nYour wisdom reduces by 2 for selecting this perk. At least until you reach enlightenment...`,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.abilityScore.wisdom -= 2
                        if(context.stats.lists.perks.filter(perk=> perk.name == 'Gaze Into the First Ring').length == 1 && context.stats.lists.perks.filter(perk=> perk.name == 'Gaze Into the Second Ring').length == 1 && context.stats.lists.perks.filter(perk=> perk.name == 'Gaze Into the Third Ring').length == 1) context.stats.characterStats.abilityScore.wisdom += 12
                    }
                },
                {
                    name:"Gaze Into the Third Ring",
                    type:["Path Perk"],
                    path:"void",
                    description:`Once per day as a free action that you can take even when not your turn, you can cause yourself to become omnipresent with the future directly before you. You can as a free action during this round take 1 wisdom drain to turn any roll you make into a natural 20 (doesn't count for exploding crits duh). The round after activating this perk you take 2 wisdom drain. If you use 'Gaze Into the First Ring', 'Gaze Into the Second Ring', and then this ability in that order, you regain your usage of all of them and then take 4 more wisdom drain. All drain from this perk bypasses ability score drain immunity and resistance. If you have no wisdom, you cannot use this perk. 
                    \nYour wisdom reduces by 2 for selecting this perk. At least until you reach enlightenment...`,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.abilityScore.wisdom -= 2
                        if(context.stats.lists.perks.filter(perk=> perk.name == 'Gaze Into the First Ring').length == 1 && context.stats.lists.perks.filter(perk=> perk.name == 'Gaze Into the Second Ring').length == 1 && context.stats.lists.perks.filter(perk=> perk.name == 'Gaze Into the Third Ring').length == 1) context.stats.characterStats.abilityScore.wisdom += 12
                    }
                },
                {
                    name:"Border of Madness and Enlightenment",
                    type:["Path Perk"],
                    path:"void",
                    description:`If you take wisdom drain, you gain the amount lost as an enhancement bonus to your wisdom, up to a maximum of your level. This lasts until the wisdom drain is healed. The bonus granted by this ability is not included when determining when you wisdom reaches 0. When your wisdom reaches 0, you have a moment of pure clarity. Roll a d100, on a result of 75 or lower you die instantly, take level/4 permanent negative levels (minimum 1) and this perk is forever disabled for you. If you roll above 75, your wisdom is instantly restored to full and you gain a permanent +4 bonus to wisdom.`,
                },
                {
                    name:"Decimation",
                    type:["Path Perk"],
                    path:"dark",
                    description:`Whenever a creature scores a critical hit against you, it increases the critical damage multiplier of your next unarmed critical by +1 and you gain a +2 on its confirmation roll. This stacks. Must be within the floor.`,
                },
                {
                    name:"Harbinger",
                    type:["Path Perk"],
                    path:"dark",
                    description:`Your melee critical hits deal bonus negative energy damage equal to 1/4 your <dark> mastery.`,
                },
                {
                    name:"IC XC",
                    type:["Path Perk"],
                    path:"light",
                    description:`Whenever you activate an ability that grants a numerical bonus to an ally (excluding yourself), you increase the bonus by +1 for 1 round. If an ability is used 2 rounds in a row, it stops gaining this benefit until you dont activate it for a round.`,
                },
                {
                    name:"Palm of the Evil Eye",
                    type:["Path Perk"],
                    path:"dark",
                    description:`Whenever you activate an ability that grants a numerical penalty to an enemy, they suffer an additional -1 for that penalty for 1 round. If an ability is used 2 rounds in a row, it stops gaining this benefit until you dont activate it for a round.`,
                },
                {
                    name:"Bastion of Purity",
                    type:["Path Perk"],
                    path:"light",
                    description:`Whenever you are in a <light> stance you gain DR 1/- against all evil creatures and +1 on saves against their abilities. Every 6 levels both of these bonuses increase by 1. This DR stacks with all others. If you are in a dark stance, you take a -2 to all d20 rolls.
                    \nAdditionally, gain +5 <light> mastery and positive spell power.`,
                    hasCustomMethod:true,
                    customMethod:(context)=>{
                        context.doNothing = "donothing"
                    },
                    catchUpMethod:(context)=>{
                        context.stats.characterStats.schoolMastery.Light += 5
                        context.stats.characterStats.spellMastery.spellPower.positive += 5
                    }
                },
                {
                    name:"I Devote Myself",
                    type:["Path Perk"],
                    path:"light",
                    description:`All healing you give to allies, but not yourself is increased by 33%. All healing you give yourself is reduced by 33%. All healing given to you by allies is reduced by 20%.`,
                },
            ]
        },
    {
        rarity: "unique",
        type: "martial",
        name: "Judgement",
        fromClass:"Inquisitor",
        shortDesc: `An inquisitor can pronounce judgment upon their foes as a swift action for level/2 spell point that lasts their highest mental stat rounds (minimum 1) gaining one of the bonuses listed below. If you're frightened, panicked, paralyzed, stunned, unconscious, or otherwise prevented from participating in the combat, the ability does not end, but the bonuses do not resume until you can participate in the combat again. At 5th level you can select two bonuses as a swift action for level spell points. At 10th, three bonuses for level x 1.5 spell points. At level 18, four bonuses for level x2 spell points. At 12th you can always have one of these bonuses active without cost.       
        \nWhen the inquisitor uses this ability, they select one type of judgment to make. As a swift action, they can change this judgment to another type. If the inquisitor is evil, they receive profane bonuses instead of sacred, as appropriate. Neutral inquisitors must select profane or sacred bonuses. Once made, this choice cannot be changed.
        \nDestruction: +1 sacred bonus on all weapon damage rolls, +1 for every odd level after first. At 12th gain +1 to weapon critical multiplier
        \nHealing: Fast healing 1, +1 per three levels.
        \nJustice: +1 sacred bonus to attack per odd level. At 8th level gain +1 bonus to critical threat range on weapons (this isn't doubled by keen).
        \nPiercing: +1 sacred bonus on concentration checks and caster level checks, +1 per three levels.
        \nProtection: +1 sacred bonus to Armor Class, +1 for every four levels. At 8th level, this bonus is doubled against attack rolls made to confirm critical hits against you.
        \nPurity: +1 sacred bonus on all saving throws, +1 for every four levels. At 8th level, the bonus is doubled against curses, diseases, and poisons.
        \nResistance: Energy resistance equal to your level against one energy type (acid, cold, electricity, fire, or sonic) chosen when the judgment is declared.
        \nResiliency: DR 1/magic, +1 per 4 levels. At level 10 this changes from magic to an alignment (chaotic, lawful, good, evil) that is opposite your alignment. If you are neutral, you do not gain this increase.
        \n\nMonster Lore: For 1 + level/2 spell points as a swift action you can roll a knowledge check to discern the weaknesses of a monster, if you do gain your level/2 as a competence bonus. You can attempt this multiple times against a monster but each time the spell point cost doubles. 
        \nExploit Weakness: While judgement is active gain half your highest mental stat as a insight bonus to attack and damage, and bypass that much DR against creatures you have personally identified (with a dc 20+hd check). Double these bonuses if you beat the DC by 8 or more.
        \n\nAdditionally, You will gain 1 cleric domain.
        \nAt every odd level you gain a maneuver from school of choice: Eternal Guardian, Golden Lion, Radiant Dawn, Silver Crane, Sleeping Goddess, or Indomitable Will.
        \nEvery even level you gain a buff/healing/utility spell.`,
        hasCustomMethod:true,
        customMethod:(context, self)=>{
            if(context.stats.characterStats.misc.level%2==0){
                self.getSpell(context,context.stats.characterStats.misc.level)
            }  
            if(context.stats.characterStats.misc.level%2==1 || context.stats.characterStats.misc.level == 1){
                self.getManeuver(context, context.stats.characterStats.misc.level)
                context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{skills:true}}}));
            }

        },
        catchUpMethod:(context, self)=>{
            let perk = perks.find(perk => perk.name == "Cleric Domain")
            let pushedPerk = JSON.parse(JSON.stringify(perk))
            pushedPerk.id = Math.random()
            context.stats.lists.perks.push(pushedPerk)
            perk.catchUpMethod(context, perk, pushedPerk, 1)
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){                       
                if(x%2 == 0){
                    self.getSpell(context,x)
                }  
                if(x%2 == 1 || x == 1){
                    self.getManeuver(context, x)
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{skills:true}}}));
                }
            }               
        },
        getManeuver: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}, school:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            let schools = ["eternalGuardian", "goldenLion", "radiantDawn","silverCrane", "sleepingGoddess", "indomitableWill", ]
            let choices = []           
            for(let x = 0; x < schools.length; x++){
                let choice = {
                    title:schools[x],
                    id:x, 
                    method:(context=>{                            
                        options.school[schools[x]] = true
                        context.connection.send(JSON.stringify(
                            {
                                command:"requestRoll", 
                                type:"maneuver", 
                                options
                            }
                        ))
                    })}
                    choices.push(choice)
            }         
            let custom = {title:"Typed Maneuver Choice", options:choices}         
            context.customDialogArray.push(custom)
        }, 
        getSpell: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.type={healing:true, buff:true,utility:true}
            let obj={command:"requestRoll", type:"spell", options};
            context.connection.send(JSON.stringify(obj));
        },
    },
    {
        rarity: "unique",
        type: "martial",
        name: "Finesse Training",
        abilityType:"Ex",
        fromClass:"Unchained Rogue (Kinda)",
        shortDesc: `You can use dexterity for damage with every melee and throwing weapon you can use dexterity to attack with, and at certain levels you will gain specific two weapon fighting feats:
        \n1: Two-weapon Fighting\n5: Improved Two-Weapon Fighting\n9: Two-Weapon Rend\n13: Greater Two-weapon Fighting\n17: Legendary Two-Weapon Fighting
        \nIf you have any of these feats early you will instead be given the next feat in the chain.            
        \nAdditionally, you gain the ability Dragon Stance: As a swift action you enter Dragon Stance, which stacks with all other stances or styles, but you can only maintain it for 3 + con mod rounds per day, plus an additional round for every 6 BAB you have. You recover 1 round each time you complete a combat. Dragon Stance has no base abilities of its own, instead, twice at level 1 and and every 3 levels you gain a perk that modifies Dragon Stance.
        \nEvery odd level you gain a maneuver from Heart of the Maelstrom/Mithral Current/Thrashing Dragon/Sterling Sovereignty/Shadow Assassin.`,
        hasCustomMethod: true,
        customMethod:(context, self)=>{
            self.addFeats(context, context.stats.characterStats.misc.level)
            
            if(context.stats.characterStats.misc.level%3==0){
                self.getDragonStyle(context, self)
            }
            if(context.stats.characterStats.misc.level%2==1){
                self.getManeuver(context, context.stats.characterStats.misc.level)
            }
            // if(context.stats.characterStats.misc.level%5==0){
            //     self.getPerk(context)
            // }  
        },
        catchUpMethod:(context, self)=>{
            self.getDragonStyle(context, self)
            self.getDragonStyle(context,self)
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){   
                self.addFeats(context, x)
                if(x%2==1){
                    self.getManeuver(context, x)
                }
                
                if(x%3==0){
                    self.getDragonStyle(context,self)
                }  
            }
        },
        addFeats:(context, level)=>{                
            let AddFeatLoop = (context, level, featLevels, neededfeats) => {
                if(featLevels.includes(level)){
                    let needFeat = true
                    let x = 0
                    let foundFeat = neededfeats[x] 
                    while(needFeat){
                        if(context.stats.lists.feats.find(feat=>feat.name==foundFeat)){
                            if(x == 4){
                                context.stats.lists.feats.push(feats.find(feat => feat.name == neededfeats[4]))
                                needFeat = false
                            }else{
                                x++
                                foundFeat = neededfeats[x]                                
                            }
                        }else{
                            let feat = feats.find(feat => feat.name == foundFeat)
                            feat.id = Math.random()
                            context.stats.lists.feats.push(feat)
                            needFeat = false
                        }
                    }
                }
            }                
            AddFeatLoop(context, level, [1,5,13,17], ["Two-Weapon Fighting", "Improved Two-Weapon Fighting", "Greater Two-Weapon Fighting", "Legendary Two-Weapon Fighting", "Mythic Two-Weapon Fighting"])
            AddFeatLoop(context, level, [9], ["Two-Weapon Rend", "Improved Two-Weapon Rend", "Greater Two-Weapon Rend", "Legendary Two-Weapon Rend", "Mythic Two-Weapon Rend"])                
        },
        getManeuver: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}, school:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            let schools = ["mithralCurrent", "thrashingDragon", "heartOfTheMaelstrom","sterlingSoveriegnty","shadowAssassin"]
            let choices = []           
            for(let x = 0; x < schools.length; x++){
                let choice = {
                    title:schools[x],
                    id:x, 
                    method:(context=>{                            
                        options.school[schools[x]] = true
                        context.connection.send(JSON.stringify(
                            {
                                command:"requestRoll", 
                                type:"maneuver", 
                                options
                            }
                        ))
                    })}
                    choices.push(choice)
            }         
            let custom = {title:"Typed Maneuver Choice", options:choices}         
            context.customDialogArray.push(custom)
        }, 
        getPerk:(context)=>{
            context.connection.send(JSON.stringify({
                command:"requestRoll", 
                type:"Perk", 
                options:{type:{martial:true}}
            }))
        },
        getDragonStyle:(context, self)=>{
            let stylePerks = self.stylePerks
            let choices = []
            let chosen = []
            for(let x = 0; x < 4; x++){
                let possible = Math.floor(Math.random()*stylePerks.length)
                while(chosen.includes(possible)) possible = Math.floor(Math.random()*stylePerks.length)
                chosen.push(possible)
                let option = stylePerks[possible]
                choices[x] = {
                    title:option.name,
                    description:option.description,
                    id:x,
                    method:(context =>{
                        let perk = context.stats.lists.perks.filter(perk => perk.name == "Dragon Stance")[0]
                        if(!perk){
                            perk = {rarity:"unique", name:"Dragon Stance", id:Math.random()*1000000, additionalInfoTags:["Dragon Stance"], type:"martial", shortDesc:`All of the abilities listed here only apply while you maintain Dragon Stance, you maintain Dragon Stance like other stances, and it is lost when you become helpless for any reason.
                            \nOnce you leave dragon stance you cannot re-enter it until the start of your next turn and you become fatigued for 1 round.\n\nYou can maintain Dragon Stance for 3 + con mod rounds a day, temporary changes to your constitution do not change how many rounds you can remain in Dragon Stance, but ability score drain will. You also regain 1 round of Dragon Stance after you complete a combat.\n\nDragon Stance Abilities:`}
                            context.stats.lists.perks.push(perk)
                        }
                        perk.shortDesc += `\n\n` + option.name + `: ` +  option.description
                    })
                }                
            }
            let custom = {title:"Dragon Stance", options:choices}
            context.customDialogArray.push(custom)
        },
        hasSpecialItems:true,
        getSpecialItemList:(self)=>{
            return self.stylePerks
        },
        stylePerks: [
            {
                name:"Dragon Wing Defense",
                description:"When you attack with both weapons you can add the lower of the two weapons enhancement modifiers as a shield bonus to your armor class until the start of your next turn. This stacks with feats that grant a shield bonus to armor class because of two-weapon fighting.",
            },
            {
                name:"Way of the Dragon Claw",
                description:"Whenever you enter Dragon Stance you can recover a <flurry/primal/fire/air/technique> maneuver. If you do, you can gain one combo point of whichever maneuver type you recovered. Every 8 BAB you can recover another one.",
            },
            {
                name:"Way of the Dragon Claw",
                description:"As a free action you can take once per round, you can expend a round of Dragon Stance (even if not in Dragon Stance) to recover a single <flurry/primal/fire/air/technique> maneuver. If you do, you can gain one combo point of whichever maneuver type you recovered.",
            },
            {
                name:"Dragon's Patience",
                description:"When you leave Dragon Stance you can spend 2 combo points of <flurry/primal/fire/air/technique> to recover a maneuver of that type. You can recover multiple maneuvers this way at once, but all combo points spent must be adjacent to each other.",
            },
            {
                name:"Unending Flurry",
                description:"You gain a new finisher: [flurry-primal-flurry]: Gain 1 round of Dragon Stance. This combo can only be used in combat. Every time you enter Dragon Stance you recover this finisher. At level 8, you can increase it to [flurry-flurry,primal-flurry]: regain 2 rounds of Dragon Stance.",
            },
            {
                name:"Paired Strike",
                description:"When you attack with both weapons and you threaten a critical hit with one of the weapons you can take a -5 penalty to the confirmation roll to instead confirm the critical with your other weapon, dealing the other weapons damage.",
            },
            {
                name:"Ringing Blows",
                description:"When you attack with both weapons you can use the base damage dice of either weapon to determine the damage of both weapons. Any modifiers to this chosen weapons damage dice does not modify the other weapons damage. Though modifiers that would affect both still apply, such as if you had grown in size.",
            },
            {
                name:"Dragon Rend",
                description:"When you confirm a critical hit with both your primary hand and off-hand on the same turn you can make an additional attack with the weapon you confirmed a critical hit with first. This additional attack is made at the attack modifier of the second weapon you confirmed you critical hit with -5. This attack always deals your full damage as if it was a primary hand attack. If you activate this ability multiple times in a round, each subsequent attack is at an additional -5 penalty, and receives a futher -5 to confirm the attack if it is another critical threat, you also cannot activate it more than once, + 1 per 6 BAB.",
            },
            {
                name:"Double Threat",
                description:"Once per round when you are making an attack of opportunity you can make an additional attack with your off-hand weapon, applying its penalites and bonuses as normal for two-weapon fighting. For each two off-hand attacks you have you can use this an additional time, though not on the same attack of opportunity.",
            },
            {
                name:"Wyrmstrike",
                description:"When you are attacking with both weapons and confirm a critical hit with one of your hands, the next attack you make this turn with your other hand has its critical threat range increased by +1. This is a flat bonus not modified by other abilities. This stacks, but it applies to a different attack with the other hand.",
            },
            {
                name:"Dragon Surge",
                description:"By reducing your remaining rounds of dragon stance by 1 you can gain a +4 bonus to your strength and dexterity for the rest of the round. This increases by +2 every 6 levels.",
            },
            {
                name:"Dragon Fang",
                description:"As a swift action you can make an attack with your off-hand at a -5 penalty, and an additional penalty equal to the amount of attacks you have made this round, however it gains a +2 bonus to damage for each attack you have successfully landed this turn, unless it was a critical hit, in which case the bonus damage is +2 x the critical multiplier of the weapon.",
            },
            {
                name:"Whirling Steel",
                description:"When you begin a full-round attack with two weapons you raise your guard until the start of your next turn, allowing you to deflect a single ranged projectile weapon fired at you, this acts like the 'Cut From the Air' feat except only for projectiles fired at you. You can deflect one projectile per round for each off-hand attack you have, using the attack penalties given by those off-hand attacks.",
            },
            {
                name:"Ferocity",
                description:"Your weapon attacks deal an additional 1d4 damage. For each critical damage multiplier you have above x2 increase this damage by 1 step. Every 6 BAB you have increase the damage by +1.",
            },
            {
                name:"Rising Focus",
                description:"For each round you have had dragon stance active in a row you gain a +1 bonus to attack with weapons when two-weapon fighting.",
            },
            {
                name:"Dragon Dance",
                description:"When making a full-attack with two weapons you gain the ability to make a 5-foot step after each of your off-hand attacks. This movement is subtracted from movement you can make on your next turn.",
            },                    
            {
                name:"Dragon Rage",
                description:"You can reduce the amount of rounds you can stay in dragon stance today by one to gain a damage bonus to all weapon attacks and a penalty to armor class for the rest of the round. The bonus is equal to 2x your amount of off-hand attack, and the penalty equal to your amount of off-hand attacks.",
            },
            {
                name:"Expose Vulnerability",
                description:"When you fight with two weapons you can choose either of the weapons highest enchantment modifier or attributes to determine whether your attacks with your other weapon bypasses DR.",
            },
            {
                name:"Finishing Flurry",
                description:"Whenever you deal the blow that reduces a creature below 0 and at least knocks them unconcious you can move 10 feet. If you confirm a critical hit you can take a 5-foot step. Both of these movement provoke, require a free action that you can take even when not your turn.",
            },
            {
                name:"Claw and Fang",
                description:"You reverse the grip on your off-hand, causing you to take a -4 penalty to all attacks this round, but you increase your off-hand's critical damage multiplier by +1. When you score a critical hit with your off-hand while using this ability all of your further attacks this round take a -1 penalty. You must choose to activate this benefit before you have made any attacks during a round and it lasts until the start of your next turn.",
            },
            {
                name:"Go for the Throat",
                description:"You gain a +1 bonus to attacks when you are flanking. This increases by +1 for each 3 off-hand attacks you have.",
            },
            {
                name:"Dual-Wing Follow-Up",
                description:"When you make a strike that allows for exactly one attack you may also make an attack with your off-hand weapon, the penalties and bonuses for attacking with two weapons applies to your attacks. Your additional off-hand attack does not gain any benefits of the strike. If you have at least 3 off-hand attacks you can also make this additional attack when you use a boost or counter that allows you to make an attack (but not a counter that allows a full-round attack).",
            },
            {
                name:"Ryū No Sashi",
                description:"When you threaten a critical hit, but before you have rolled your confirmation roll, you can reverse your grip on your weapon driving it deep into the creature, you take a -5 penalty to your critical confirmation but you increase your critical damage multiplier by +2. After you have dealt your damage your weapon becomes lodged in the creature, and you can no longer use it. To recover your weapon you must make a CMB check as a movement action against the creature's CMD as if making a dirty trick or steal maneuver (provoking as normal), however you can retrieve your weapon when making either of these types of maneuvers in any other way. Additionally, you can retrieve it as a movement action after the creature is dead as if drawing a weapon.",
            },
            {
                name:"Dragon Frenzy",
                description:"When you make a full-round attack with both weapons, if you successfully hit with all of your attacks in the full round you can make an additional attack at your highest bonus with whichever weapon you would like. If you have a strike that makes only a single attack that can be made as a standard action you can choose to make it this strike, however it costs double spell points and reduces the rounds you can be in dragon stance by 1 round per 3 levels of the maneuver (rounded up). You must take all of your attacks in a round to activate this ability, nor will it activate if you used an ability that sacrificed one of your attacks.",
            },
            {
                name:"Drake Surge",
                description:"When taking an action that allows you to attack, you can choose to sacrifice an attack that you can make as a part of that action to take a 5-foot step. The attack you sacrifice does not need to be the next attack you would take in the action.",
            },
            {
                name:"Windweave",
                description:"When you take a 5-foot step you gain a +1 dodge bonus to your armor class until the start of your next turn. If you have an ability that functions like a 5-foot step such as the bonus 5-foot step from a Wave Motion Blade, this counts for this ability.",
            },
            {
                name:"Dragon Pounce",
                description:"When you make a charge attack you can attack with both your primary weapon and off-hand weapon, taking penalties and bonuses for two weapon fighting as normal. If you could make a full attack on a charge, instead of this additional you gain a bonus to charge damage equal to the attack bonus you gain from charging. If you use either of these abilities you gain a -4 penalty to armor class when charging (stacking with any of your normal penalties).",
            },
            {
                name:"Tarn's Charge",
                description:"When making a charge attack you can choose to target a creature that is behind another enemy creature, if you do, you make an acrobatics check to move through the creatures space (without the usual +5 to the DC), if you succeed you can make an attack with your off-hand weapon against the creature. This counts as a charge attack, but you only get the single attack at the normal penalties for an off-hand attack while two weapon fighting. Your attacks at the target of your charge also take the two-weapon penalities and benefits. You can charge through multiple creatures this way if you have multiple off-hand attacks, each taking their penalties for successive attacks.",
            },
            {
                name:"Zephyr Waltz",
                description:"You can make an additional 5-foot step during your turn. It follows other restrictions and rules for 5-foot steps.",
            },
            {
                name:"Dragon Hammer",
                description:"When making an attack you can expend 1 round of Dragon Stance to empower it, that attack is now made at your highest bonus instead of what ever it would normally be at. Any penalties that would apply to your highest attack apply to this as well.",
            },
            {
                name:"Wyrmskin",
                description:"Increase your armor's maximum dexterity bonus by +3. For each off-hand attack you have, increase the maximum dexterity bonus by +1 more.",
            },
            {
                name:"Edict Wing",
                description:"You gain an additional attack of opportunity per round with each off-hand attack you have, you take the penalties for those off-hand attacks of opportunity.",
            },
            {
                name:"Stormstep",
                description:"Increase your base land speed by 15 feet if in light armor, or 20 if in no armor.",
            },
            {
                name:"Windstep",
                description:"Gain a +1 dodge bonus to your armor class when in light or no armor and not using a shield that has a maximum dexterity bonus. For every 4 of your BAB increase the bonus by +1.",
            },
            {
                name:"Dragonheart",
                description:"You can remain in Dragon Stance for 3 additional rounds per day. Every 6 levels you gain another round of Dragon Stance.",
            },                    
            {
                name:"Dragon's Evasion",
                description:"Gain Evasion. If you already had evasion you instead gain improved evasion.",
            },
            {
                name:"Dragon's Eye",
                description:"You gain a bonus +1 bonus on attack rolls with weapons. Every 5 levels increase this bonus by +1",
            },
            {
                name:"Deadly Claws",
                description:"You gain a bonus +2 bonus to damage on your weapon attacks attacks. Every 6 levels increase this bonus by +2. This damage bonus is modified the same way power attack is, +50% for attacks with two handed weapons, and -50% for off-hand attacks.",
            },
            {
                name:"Wingweave",
                description:"When you are fighting defensively or using combat expertise you increase the dodge bonus you gain by +1. When you full defense, you increase the dodge bonus by +2, and you can take an additional 5-foot step on any round you use full defense. These bonuses increase by +1 and +2 respectively for every 6 BAB.",
            },
            {
                name:"Dragonic Flurry",
                description:"You gain an additional off-hand attack, this is made at your highest bonus -5 and stacks with any other off-hand attacks you might be able to make.",
            },
            {
                name:"Heart Ablaze",
                description:"You can use this ability even when not in Dragon Stance. You can take 1 point of constutition drain to increase the amount of rounds you can use Dragon Stance today by 2 rounds. You cannot restore these points of drain while you're still in Dragon Stance. Losing constitution this way ignores the usual reduction in how many rounds per day you could maintain Dragon Stance. If you are in Dragon Stance when you use this, you gain a bonus on all melee damage rolls equal to the amount of rounds of Dragon stance you have used in a row.",
            },
            {
                name:"Dragon Pursuit",
                description:"Gain the benefit of the Step Up feat. If you already have Step Up you can instead gain the benefits of Following Step, if you have that you gain Step Up and Strike, If you have that you can use Heaven's Step. If you have all of those when you use heavens step you may make an additional off-hand attack, as long as you have an additional one, and you take its penalties when doing so.",
            },
            {
                name:"Shadow Weave Strike",
                description:"When you make an attack of opportunity you can choose to take a 5-foot step before or after the attack.",
            },
            {
                name:"Outrage",
                description:"When making an attack you can reduce the rounds you have remaining in Dragon Stance by 1 to increase the critical threat range of an attack by +2. You must declare this before the attack is made, however you can sacrifice two rounds to increase it by +2 after the attack roll is made, and you take a -5 penalty to the confirmation roll. These are flat bonuses not increased by other effects.",
            },
            {
                name:"Dragon Lunge",
                description:"You can take a 5-foot step whenever you initiate a strike. You can do this before or after the strike attack is made.",
            },
            {
                name:"Dragon Hunter's dodge",
                description:"You gain a +1 bonus on weapon attacks for each 5-foot step you have taken since the end of your last turn.",
            },
            {
                name:"Gathering Storm",
                description:"Whenever you move 5 feet you gain a +1 damage bonus on your next weapon attack roll. This stacks for every 5 feet you move, even if its apart of the same action.",
            },
            {
                name:"Umbral Shiv",
                description:"If you make an attack against an enemy that you are currently flanking, but you weren't flanking when you made your first attack against them this turn, your attacks deal an additional 1d6 precision damage. This increases by 1d6 for each attack you made against the creature this turn when you weren't flanking it. For every 6 BAB increase the dice step of this precision damage by 2.",
            },
            {
                name:"Read the Threads",
                description:"You can enter Dragon Stance as an immediate action, even if flat-footed, if you do this as part of an initiative roll you gain +2 bonus to it, and you can add half your BAB to it. You can also enter a style feat as a part of this action.",
            },
            {
                name:"Mounting Fury",
                description:"For each round in a row you have maintained Dragon Stance you gain a +1 bonus to your weapon damage rolls. Every 6 BAB this increases by +1 per round maintained.",
            },
            {
                name:"Prismatic Dance",
                description:"When you move at least 15 feet you can attempt to feint a creature you are adjacent to. You can continue to feint creatures after you have moved another 15 feet and have used your feint attempt. Using this ability costs 2 spell points the first time, each additional time doubles the cost. You can feint even when its not your turn, but it doubles the spell points cost.",
            },
            {
                name:"Time Dragon's Lunge",
                description:"As an immediate action you make a single attack with your off-hand weapon, taking an penalties that entails and at an additional -5 penalty to the attack.",
            },
            {
                name:"Heartpierce",
                description:"You add your level as bonus precision damage on critical hits with melee weapons.",
            },
            {
                name:"Final Fang",
                description:"As a swift action you can end your Dragon Stance in a flurry, doing so ends your Dragon Stance immediately and costs 1 round of dragon Stance, you must have this remaining round in order to activate this, when you do you can make an attack with both your primary and off-hand weapon, both gain an additional +1 to attack and damage for each other attack you can take with those hands as a part of a full-attack.",
            },
            {
                name:"Sea Dragon's Crash",
                description:"If you use an ability that negates an attack through an opposing attack roll, such as the 'Iron Shell' maneuver, you gain a +4 bonus to the roll, and if you succeed you can make an attack of opportunity against them with your off-hand assuming they are within reach. Any maneuver to negate an attack from Heart of the Maelstrom, Mithral Current, Thrasing Dragon, or Scarlet Throne also gain this bonus even if it isn't a against an opposing attack roll, so long as it requires a check and succeeds.",
            },
            {
                name:"Draconic Disciplines",
                description:"Heart of the Maelstrom, Mithral Current, Thrashing Dragon, and Scarlet Throne maneuvers have their DC's increased by +2, and deal +2 damage. Every 6 BAB both of these bonuses increase by a further +1.",
            },
            {
                name:"Silver Dance",
                description:"You can use performance to make feint checks. You can make a feint check as a swift action for 3 spell points, if you do, you gain an bonus to the roll equal to half your level. If you make a feint as a part of another ability you can still activate this ability to gain this ability's bonus on the roll.",
            },
            {
                name:"Wyrm's Will",
                description:"At the start of each of your turns you gain temporary hit points equal to your BAB. Whenever you land a weapon attack, take a 5-foot step, or successfully counter an attack you gain 1 temporary hit point. When you score a critical hit you gain temporary hit points equal to the weapons critical multiplier x2. These temporary hitpoints only last as long as your Dragon Stance. The temporary hit points you gain at the start of each round do not stack with themselves, but the other temporary hit points do.",
            },
            {
                name:"Dragonsoul",
                description:"At the start of each of your turns you gain 1 temporary spell points for each round you have maintained Dragon Stance in a row. For each 6 BAB you have, you gain an additional spell point per round maintained.",
            },
            {
                name:"Heartstrike",
                description:"When you roll a potential critical, but before you roll the confirmation roll, you can reduce the rounds you have of dragon stance by 1 to increase the critical damage multipler by +1. You can activate this multiple times on a single attack, however each additional time you activate it, it costs 1 more round than it did the previous time you activated it.",
            },
            {
                name:"Dragon Rush",
                description:"Instead of any other attack you would make at the end of a charge, you can instead make strike. This strike must have an initiation action of a standard action or less. You can only activate this once per round.",
            },
            {
                name:"Dragon Claws",
                description:"You can use dexterity for attack and damage with any melee weapon. With light and finessable weapons you when you are using dexterity to determine your damage you gain a +1 bonus, +1 per 4 levels.",
            },
            {
                name:"Onslaught",
                description:"Add half your level as a bonus to confirm critical hits. When you confirm a critical hit the rest of your attacks for that turn gain a +1 bonus to attack, multiplied by your confirming weapons damage multipler -1. This stacks with itself.",
            },
            {
                name:"Sovereign Retort",
                description:"When making attacks on your turn, whether it be as a full-round action, a standard action, or anything else, you can sacrifice any number of those attacks to prepare to counter, then before the start of your next turn you can use those sacrificed attacks when a creature makes a melee attack against you, you make an attack at the penalty of the attack you sacrificed, taking a -2 penalty for each size category larger the creature is than you, if your attack roll is higher than the creatures the attack is negated, and it deals damage as if you stuck them with the attack, but deals half damage. This cannot critical.",
            },
            {
                name:"Miststep",
                description:"Whenever you successfully negate a weapon attack against you by activating an ability in response to the attack, you can take a 5-foot step, and you gain a +1 dodge bonus to your armor class for 1 round.",
            },
            {
                name:"Impenetrable Claws",
                description:"Once per round when you activate a Heart of the Maelstrom, Mithral Current, Thrashing Dragon, or Scarlet Throne counter, you can double its spell point cost, or expend 1 round of Dragon Stance, if you do, it doesn't expend your immediate action.",
            },
            {
                name:"Vortex Shift",
                description:"When taking a 5-foot step, you can spend level/2 spell points to make the step a 10-foot step. You must step in a straight line. By using this you can 5-foot step in difficult terrain. If you do move 10-feet, abilities that activate when you take a 5-foot step only activate once.",
            },
            {
                name:"Final Dance of the Dragon",
                description:"Your constant movement and whirling makes a creature open to a devastating strike, if you make melee attacks against a creature from different squares equal to the amount of squares adjacent to their space-1 (medium 7, large 11, huge 15, etc.), your next attack against them automatically targets their flat-footed AC, is an automatic critical threat, and its critical multiplier is increased by +2. These squares are relative to the creature, so if both you and your target 5-foot step to the east and you attack it again, that doesn't count as a new square. Once you have made this attack, whether successful or not, the creature becomes immune to the ability. You do not need to be in dragon stance to make all of these attacks to set this up, however you must be in it to make this attack, however for every attack you made that wasn't in dragon stance, you take a -2 penalty to this attack.",
            },
            {
                name:"Wyrm's Resurgence",
                description:"At the end of each combat you regain 2 rounds of Dragon Stance instead of 1. You can choose to take 2 points of constitution drain to regain 1 round of Dragon Stance.",
            },
            {
                name:"Feast on Carnage",
                description:"Whenever you score a critical hit that kills or defeats a non-helpless enemy you regain 1 round of Dragon Stance.",
            },
            {
                name:"Savage Rend",
                description:"When you rend you can also add the base damage dice of a weapon that didn't activate the rend you are wielding.",
            },
            {
                name:"Claw Apart",
                description:"Increase the damage dice of your rend and all damage rolls that activate from rend by 1 step. This includes damage from abilities such as the bleed from Greater Rending Fury feat.",
            },
            {
                name:"Dragonhide",
                description:"Increase your natural armor bonus by +1. This increases by +1 every 4 levels.",
            },
            {
                name:"Always Angry",
                description:"You can enter Dragon Stance as free action, however you are fatigued for 1d4 rounds when you leave dragon stance if you enter it this way.",
            },
            {
                name:"Dragonsong",
                description:"On the round you enter dragon stance you gain a +1 bonus to weapon attack and damage rolls. This increases by +1 for each time you have entered Dragon Stance today. For every 8 of your BAB this increases by +1.",
            },
            {
                name:"Wings of Wind",
                description:"At the start of your turn you can choose to reduce your remaining rounds in Dragon Stance by 1, then you can make an acrobatics check, for the rest of the round your armor class, including touch armor class, is equal to the result of your acrobatics check. You also can add any dodge bonuses you might gain to this. If you are flat-footed against an attack your armor class becomes 10.",
            },
            {
                name:"Winged Entry",
                description:"When you enter Dragon tance you can take an immediate 5-foot step and you gain a +2 dodge bonus to your armor class for the rest of your turn. Every 6 BAB you can take an additional 5-foot step and the dodge bonus increases by +2.",
            },
            {
                name:"Winged Leap",
                description:"Whenever you can take a 5-foot step, you can move an additional 5 feet. This additional movement does count as a 5-foot step, however it does not activate itself, and it provokes attacks of opportunity, but you can choose to use this additional movement before or after your normal 5-foot step.",
            },
            {
                name:"Final Strike",
                description:"If you have been in Dragon Stance for at least 3 rounds in a row, when making an attack you can choose to make it a final strike, if you do, the weapon attack is an automatic potential critical threat, and directly after the attack is complete you leave Dragon Stance. After you use this ability you are exhausted for 1d4 rounds and fatigued for 1d4 rounds after that, and cannot re-enter Dragon Stance during that time.",
            },
            {
                name:"Unwavering Heart",
                description:"You are no longer fatigued after leaving dragon stance. If an ability would cause you to become fatigued or exhausted after leaving dragon stance for longer than 1 round, you are fatigued for 1d4 less rounds, or exhausted for 1 less round. While in dragon stance you become immune to the fatigued, exhausted, and gain a +4 bonus against fear effects.",
            },
            {
                name:"Final Flight",
                description:"You can end dragon stance as an immediate action. When you end dragon stance you can take a 5-foot step, this step provokes. You can take an additional 5-foot step every 6 of your BAB. Additionally, Any ability from dragon stance that functions based on your 5-foot steps remains active for 1 round after you leave it.",
            },
            {
                name:"Deadly Dodge",
                description:"Whenever a creature misses a melee attack against you by an amount less than your dodge bonus to armor class, it provokes an attack of opportunity from you.",
            },
        ]
    },
    {
        name: "Beginning Enlightenment",
        type:"martial",
        rarity:"epic",
        shortDesc: `You begin your path down the enlightened path, you will gain two random elemental enlighted path finishers along with their basic strikes, then you will choose a philosophy and gain its basic finisher. At first and every three levels you will gain an enlightened path maneuver.
        \nEnlightened Path Finishers: In order to activate a finisher, the most recent maneuvers you used must have tags that match the type and order of the tags on the finisher. Activating a finisher costs level/2 spell points. After you use a finisher, your finisher combo resets. Entering a stance or using a finisher does not count towards being able to use your next finisher.`,
        hasCustomMethod:true,
        customMethod:(context,self,contextSelf)=>{
            if(context.stats.characterStats.misc.level%3 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{school:{enlightenedPath:true}, includeSubschool:contextSelf.pathChosen, level:self.getManeuverLevels(context.stats.characterStats.misc.level), type:{Strike:true,Boost:true,Stance:true,Counter:true,Finisher:true}}}))
            }
        },
        catchUpMethod:(context,self,contextSelf)=>{
            self.addManeuverFreedom(context)
            let maneuverNames = [["The Gathering Storm","Storm Strike"],["The Trembling Earth", "Strike of the Enduring"],["The Raging Sea", "Flowing Water Strike"], ["Breath of the Fire Dragon", "Fires of Purity"]]
            maneuverNames = maneuverNames.sort(()=> 0.5 - Math.random())
            let selected = maneuverNames.slice(0, 2);
            selected.forEach(elements=>{
                elements.forEach(maneuverName=>{
                    let maneuver = maneuvers.find(maneuver => maneuver.name == maneuverName)
                    maneuver.id = Math.random()
                    context.stats.lists.maneuver.push(maneuver)
                })
            })
            self.getPath(context,self,contextSelf)
        },
        getPath(context, self, contextSelf){
            let optionNames = ["Path of Balance","Path of Dominion","Path of Emptiness"]
            let paths = [];paths["Path of Balance"] = "light"; paths["Path of Dominion"] = "dark"; paths["Path of Emptiness"] = "void";
            let options = []                
            for(let x = 0; x < 3; x++){
                let option = {
                    title:optionNames[x],
                    id:x-1,
                    description: self.paths[x].description,
                    method:()=>{                        
                        let maneuver = maneuvers.find(maneuver => maneuver.name == self.paths[x].maneuverList)
                        maneuver.id = Math.random()
                        context.stats.lists.maneuver.push(maneuver)
                        contextSelf.shortDesc += `\n\nChosen: ` + optionNames[x] + `\n` + option.description
                        contextSelf.pathChosen = paths[optionNames[x]]
                        for(let y = 1; y <= context.stats.characterStats.misc.level; y++){
                            if(y%3 ==0 || y==1){
                                context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options:{school:{enlightenedPath:true}, includeSubschool:contextSelf.pathChosen, level:self.getManeuverLevels(y), type:{Strike:true,Boost:true,Stance:true,Counter:true,Finisher:true}}}))
                            }
                        }
                    }
                }
                options.push(option)
            }               
            context.customDialogArray.push({title:"Enlightened Path Philosophy Choice", options})                
        },
        addManeuverFreedom:(context)=>{
            let text = `Iron Tortoise maneuvers count as [earth], and you can use your unarmed attacks as a shield for its maneuvers.
            \nHeart of the Maelstrom maneuvers count as [air], and you heart of the maelstrom maneuvers that include an attack even when not using dexterity for attack or damage.
            \nBurning Citadel maneuvers count as [fire] and you can initiate any of them with unarmed strikes.
            \nMithral Current maneuvers count as [water]. If you are in a water stance, you can sheathe an unarmed weapon once per round as a free action that you can take even when not your turn.
            \nElemental Flux maneuvers count as your active element
            \nSilver Crane and Radiant Dawn maneuvers count as [light].
            \nBlack Seraph and Unquiet Grave maneuvers count as [dark], and you can initiate any Black Seraph maneuver even with an unarmed attacks.
            \nVeiled Moon and Sleeping Goddess maneuvers count as [void].`
            let newPerk = {name:"Maneuver Freedom",rarity:"unique", uitType:"perks", type:"martial", id:Math.random(), shortDesc:text}
            context.stats.lists.perks.push(newPerk)
        },
        paths:[
            {
                name:"Path of Balance",
                type:["Enlightened Path"],
                description:`The path of balance is a path that focuses on healing and protecting allies.`,
                maneuverList:"Healing Ki"
            },
            {
                name:"Path of Dominion",
                type:["Enlightened Path"],
                description:`The path of dominion focuses on death and offense.`,
                maneuverList:"Touch of Despair"
            },
            {
                name:"Path of Emptiness",
                type:["Enlightened Path"],
                description:`The path of emptiness focuses unique powers that bend and warp reality.`,
                maneuverList:"Infinite Force Strike"
            }
        ],
        getManeuverLevels(lvlNum){
            lvlNum = Math.floor(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let levels = {}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    levels[levelString]=true;
                }
            }
            return levels
        },
    },
    {
    rarity: "unique",
    type: "martial",
    name: "Animal Focus",
    fromClass:"Hunter",
    shortDesc: `At 1st level, a hunter can take on the aspect of an animal as a free action once per round, and gains the listed bonus until changed.  Additionally, by spending 1 spell point you can activate an additional animal aspect for a maximum of 2, this costs 1 spell point each round to maintain. At 5th level you can have 3 animal aspects active, for 4 spell points per round, at 10th you can activate 4 for 7 spell points a round. At 15th you can have 5 animal aspects active for 11 spell points a round. At level 17 reduce the spell point of activating and maintaining animal focus by 1 spell point.
    \nTiger Bear: Gain a +2 enhancement bonus to a physical stat. this can be selected multiple times for a different stat. This bonus increases to +4 at 5th level and +6 at 10th level, and +8 at 15th     
    \nBat: Gain darkvision to a range of 60 feet. At 5th level, the range increases by 30 feet. At 10th level, the creature also gains blindsense to a range of 10 feet.          
    \nFrog Monkey: Choose a skill to gain +4 competence bonus on, between perception, swim, climb, or stealth. This can be selected multiple times for a different skill. This bonus increases to +6 at 5th level and +8 at 10th level, and +10 at 15th level.               
    \nMouse: Gain evasion, as the rogue class feature. At 8th level, this increases to improved evasion, as the rogue advanced talent.             
    \nSnake: Gain a +2 bonus on attack rolls when making attacks of opportunity and a +2 dodge bonus to AC against attacks of opportunity. These bonuses increase to +4 at 5th level and +6 at 10th level, and +8 at 15th level.        
    \nStag: Gain a 5-foot enhancement bonus to its base land speed. This bonus increases to 10 feet at 5th level and 20 feet at 10th level, and 30 feet at 15th level.                
    \nWolf: Gain the scent ability with a range of 10 feet. The range of this sense increases to 20 feet at 5th level and 30 feet at 15th level
    \n\n Additionally, each level you gain a maneuver from school from the following options: Golden Lion, Iron Tortoise, Primal Fury, Silver Crane, Steel Serpent, Brutal Crocodile.       
    \nAt 2nd, and every even level after you gain a teamwork feat, and gain +1 to any numeric bonus teamwork feats provide, increasing by +1 every 8 levels.`,
    hasCustomMethod:true,
    customMethod:(context, self)=>{
        self.getManeuver(context, context.stats.characterStats.misc.level)
        if(context.stats.characterStats.misc.level%2 == 0){
            context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{teamwork:true}}))
        }            
    },
    catchUpMethod:(context, self)=>{
        for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
            self.getManeuver(context, x)
            if(x%2 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{teamwork:true}}))
            } 
        }
    },
    getManeuver: (context, lvlNum)=>{
        lvlNum = Math.ceil(lvlNum/2)+1
        if(lvlNum > 9){lvlNum = 9}
        let options = {level:{}, school:{}}
        for(let x = 0; x < 4; x++){
            if(lvlNum-x > 0){   
                let level = lvlNum-x
                let levelString="lvl"+level;
                options.level[levelString]=true;
            }
        }
        let schools = ["brutalCrocodile","goldenLion", "ironTortoise","primalFury", "silverCrane","steelSerpent",]
        let choices = []           
        for(let x = 0; x < schools.length; x++){
            let choice = {
                title:schools[x],
                id:x, 
                method:(context=>{                            
                    options.school[schools[x]] = true
                    context.connection.send(JSON.stringify(
                        {
                            command:"requestRoll", 
                            type:"maneuver", 
                            options
                        }
                    ))
                })}
                choices.push(choice)
        }         
        let custom = {title:"Typed Maneuver Choice", options:choices}         
        context.customDialogArray.push(custom)
    }, 
    },
    {
        rarity: "unique",
        type: "martial",
        name: "Ranged Training",
        shortDesc: `You can choose to use your dexterity modifier instead of strength for determining the damage for bows and thrown weapons, and add your dexterity modifier to your damage with firearms and crossbows. Additionally, at level 2 you choose from one of three ranged styles, bows, tech, or thrown, gaining feats as you level up depending on your choice. If you already have that specific feat when you reach that level you will either gain the next feat in the progression, or a random martial feat.
        \nBows: 2) Precise Shot 3) Rapid Shot 6) Manyshot 9) Clustered Shot 12) Snap Shot 15) Greater Rapid Shot 18) Elven Accuracy 20) Greater Manyshot 
        \nTech: 2) Rapid Reload 3) Tech Sniper 6) High-speed Reload 9) Rapid Shot 12) Focused Shot 15) Greater Rapid Shot 18) Snap Shot 20) Improved Snap Shot
        \nThrown: 2) Quick Draw 3) Precise Shot 6) Two-Weapon Fighting 9) Rapid Shot 12) Far Shot 15) Twin Throw 18) Clustered Shots 20) Improved Twin Throw
        \n\nAt level 5 you will also gain a ranged style feat.
        \nEach level you gain a random maneuver from Solar Wind or Tempest Gale.
        \nAt the end of each floor and when you gain this perk you can roll a craft or survival check, for each 10 of your result gain a random gear item of the ammunition type.`,
        hasCustomMethod:true,
        customMethod:(context, self, contextSelf)=>{
            self.getManeuver(context, context.stats.characterStats.misc.level)
            if(context.stats.characterStats.misc.level == 5){
                self.getStyleFeat(context)
            }
            if(context.stats.characterStats.misc.level == 2){
                self.getType(context,self, contextSelf)
            }else{
                let type = ""
                if(contextSelf.shortDesc.includes("Chosen: Bows")) type = "Bows"
                if(contextSelf.shortDesc.includes("Chosen: Tech")) type = "Tech"
                if(contextSelf.shortDesc.includes("Chosen: Thrown")) type = "Thrown"
                if(type != ""){
                    self.featAtLevel(context, self, context.stats.characterStats.misc.level, type)
                }
            }                     
        },
        catchUpMethod:(context, self, contextSelf)=>{
            if(context.stats.characterStats.misc.level >= 2){
                self.getType(context,self, contextSelf)
            }
            
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){                    
                self.getManeuver(context, x)
                if(x == 5){
                    self.getStyleFeat(context)
                }
            }
        },

        getType(context, self, contextSelf){
            let optionNames = ["Bows","Tech","Thrown"]
            let options = []                
            for(let x = 0; x < 3; x++){
                let option = {
                    title:optionNames[x],
                    id:x-1,
                    description: "",
                    method:()=>{
                        contextSelf.shortDesc += `\n\nChosen: ` + optionNames[x]
                        if(option.hasCustomMethod){
                            option.customMethod(context)
                        }
                        for(let y = 1; y <= context.stats.characterStats.misc.level; y++){
                            self.featAtLevel(context, self, y, optionNames[x])
                        }
                    }
                }
                options.push(option)
            }               
            context.customDialogArray.push({title:"Ranged Training Type Choice", options})                
        },

        addFeat:(context, featName)=>{                
            let feat = feats.find(feat => feat.name == featName)
            context.stats.lists.feats.push(feat)
        },

        featAtLevel:(context, self, level, type)=>{
            let feats = {
                Bows:["Precise Shot", "Rapid Shot", "Manyshot", "Clustered Shots", "Snap Shot", "Greater Rapid Shot", "Elven Accuracy", "Greater Manyshot"],
                Tech:["Rapid Reload", "Tech Sniper", "High-speed Reload", "Rapid Shot", "Focused Shot", "Greater Rapid Shot", "Clustered Shots","Improved Snap Shot"],
                Thrown: ["Quick Draw", "Precise Shot", "Two-Weapon Fighting", "Rapid Shot", "Far Shot", "Twin Throw", "Clustered Shots", "Improved Twin Throw"]
            }
            let featLevels = [2,3,6,9,12,15,18,20]

            if(featLevels.includes(level)){
                let nextFeat = 0
                let found = false

                while(!found){
                    if(context.stats.lists.feats.find(feat=>feat.name==feats[type][nextFeat])){
                        nextFeat++
                    }else{
                        found = true
                    }
                }
                if(nextFeat > 7){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true}}))
                }else{
                    self.addFeat(context, feats[type][nextFeat])
                }
            }                                          
        },

        getStyleFeat(context){
            let styleNames = ["Distracting Fire Style", "Arrow Dancer Style", "Volley Fire Style", "Sniper Style", "Covering Fire Style", "Gun-Fu Style", "Wind Runner Style", "Rifleman Style", "Psychopomp Style", "Rakshasa Style", "Empty Quiver Style","Solar Wind Style", "Startoss Style", "Tempest Gale Style","Overwatch Style"]
            let options = [] 
            let chosen = []
            for(let x = 0; x < 6; x++){
                let possible = Math.floor(Math.random()*styleNames.length)
                while(chosen.includes(possible)) possible = Math.floor(Math.random()*styleNames.length)
                chosen.push(possible)
                let option = styleNames[possible]
                while(context.stats.lists.feats.filter(feat=>feat.name == option).length > 0){
                    let upgraded = feats.filter(feat => feat.prereq == option)
                    if(upgraded.length > 0){
                        option = upgraded[0].name
                    } else{
                        option == "Weapon Focus"
                        break
                    }
                }
                let feat = feats.find(feat=> feat.name == option)
                let choice = {
                    title:feat.name,
                    description:feat.longDesc,
                    id:x,
                    method:(() =>{
                        while(context.stats.lists.feats.filter(foundFeat=>feat.name == foundFeat.name).length > 0){
                            let possibleUpgrade = feats.filter(foundFeat => foundFeat.prereq == feat.name)
                            if(possibleUpgrade.length > 0){
                                feat = possibleUpgrade[0]
                            } else{
                                feat = feats.filter(feat => "Weapon Focus" == feat.name)
                                break
                            }
                        }
                        feat.uiType = "feat"
                        context.stats.lists.feats.push(feat)
                    })
                }      
                options.push(choice)          
            }                         
            context.customDialogArray.push({title:"Ranged Training Style Feat Choice", options})                
        },

        getManeuver: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.school = {solarWind:true, tempestGale:true}
            let obj={command:"requestRoll", type:"maneuver", options};
            context.connection.send(JSON.stringify(obj));
        },
    },
    {
        rarity: "unique",
        type: "martial",
        name: "Bonus Feats",
        shortDesc: `Every odd level you gain +1 BAB.
        \nEvery level you gain a bonus martial/style feat.
        \nEvery even level you gain a maneuver from a <technique/power/flurry> school.
        \nAt 1st and every 6 levels gain your choice of a fighter perk, rage perk, or rogue perk.`,
        hasCustomMethod:true,
        customMethod:(context, self)=>{
            if(context.stats.characterStats.misc.level%2==1){
                context.stats.characterStats.misc.BAB += 1
            }
            if(context.stats.characterStats.misc.level%2==0){
                self.getManeuver(context, context.stats.characterStats.misc.level)
            }
            context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true, style:true,}}))
            if(context.stats.characterStats.misc.level%6==0){
                self.getPerkChoice(context)
            }
        },
        catchUpMethod:(context, self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true, style:true,}}))
                if(x%2==1){
                    context.stats.characterStats.misc.BAB += 1
                }
                if(x%2==0){
                    self.getManeuver(context, x)
                }
                if(x%6==0 || x == 1){
                    self.getPerkChoice(context)
                }
            }
        },
        getPerkChoice:(context)=>{
            context.customDialogArray.push(
                {
                    title:"Bonus Feats Perk Choice", 
                    options:[
                        {
                            title:"Fighter Perk",
                            id:1,
                            method:(context)=>{
                                context.connection.send(JSON.stringify({command:"requestRoll", type:"Fighter Perk"}))
                            }
                        },
                        {
                            title:"Rage Power",
                            id:2,
                            method:(context)=>{
                                context.connection.send(JSON.stringify({command:"requestRoll", type:"Rage Power"}))
                            }
                        },
                        {
                            title:"Rogue Talent",
                            id:3,
                            method:(context)=>{
                                context.connection.send(JSON.stringify({command:"requestRoll", type:"Rogue Talent"}))
                            }
                        }                            
                    ]
                }
            )
        },
        getManeuver: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}, school:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            let schools = ["sterlingSovereignty","brokenBlade","piercingThunder","blackSeraph","burningCitadel","primalFury","thrashingDragon","rivenHourglass"]
            let choices = []           
            for(let x = 0; x < schools.length; x++){
                let choice = {
                    title:schools[x],
                    id:x, 
                    method:(context=>{                            
                        options.school[schools[x]] = true
                        context.connection.send(JSON.stringify(
                            {
                                command:"requestRoll", 
                                type:"maneuver", 
                                options
                            }
                        ))
                    })}
                    choices.push(choice)
            }         
            let custom = {title:"Typed Maneuver Choice", options:choices}         
            context.customDialogArray.push(custom)
        },  
    },
    {
        rarity: "unique",
        type: "martial",
        name: "Swashbuckler Techniques",
        fromClass:"Swashbuckler",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context, self)=>{
            if(context.stats.characterStats.misc.level%3 == 0){
                self.getManeuver(context, context.stats.characterStats.misc.level)
            }
        },
        getManeuver:(context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.school = {scarletThrone:true, mithralCurrent:true,heartOfTheMaelstrom:true,rivenHourglass:true}
            let obj={command:"requestRoll", type:"maneuver", options};
            context.connection.send(JSON.stringify(obj));
        },
        catchUpMethod:(context,self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%3 == 0 || x==1){
                    self.getManeuver(context, x)
                }
            }
        },
    },
    {
        rarity: "unique",
        type: "martial",
        name: "Unending Techniques",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context, self)=>{
            if(context.stats.characterStats.misc.level%3 == 0){
                self.getManeuver(context, context.stats.characterStats.misc.level)
            }
        },
        getManeuver:(context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            let obj={command:"requestRoll", type:"maneuver", options};
            context.connection.send(JSON.stringify(obj));
        },
        catchUpMethod:(context,self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%3 == 0 || x==1){
                    self.getManeuver(context, x)
                }
            }
        },
    },
    {
        rarity: "unique",
        type: "universal",
        name: "Magical Focus",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context, self)=>{
            if(context.stats.characterStats.misc.level%4 == 0){
                self.getSpell(context, context.stats.characterStats.misc.level)
            }
        },
        getSpell:(context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            let obj={command:"requestRoll", type:"spell", options}
            context.connection.send(JSON.stringify(obj))
        },
        catchUpMethod:(context,self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%4 == 0 || x==1){
                    self.getSpell(context, x)
                }
            }
        },
    },
    {
        rarity: "unique",
        type: "universal",
        name: "Destructive Focus",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context, self)=>{
            if(context.stats.characterStats.misc.level%3 == 0){
                self.getSpell(context, context.stats.characterStats.misc.level)
            }
        },
        getSpell:(context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.type = {damage:true}
            let obj={command:"requestRoll", type:"spell", options}
            context.connection.send(JSON.stringify(obj))
        },
        catchUpMethod:(context,self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%3 == 0 || x==1){
                    self.getSpell(context, x)
                }
            }
        },
    },
    {
        rarity: "unique",
        type: "magic",
        name: "Magical Expert",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context, self)=>{
            if(context.stats.characterStats.misc.level%3 == 0){
                self.getSpell(context, context.stats.characterStats.misc.level)
            }
        },
        getSpell:(context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            let obj={command:"requestRoll", type:"spell", options}
            context.connection.send(JSON.stringify(obj))
        },
        catchUpMethod:(context,self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%3 == 0 || x==1){
                    self.getSpell(context, x)
                }
            }
        },
    },
    {
        rarity: "unique",
        type: "martial",
        name: "Way of the Crimson Blade",
        fromClass:"Hemomancer",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context, self)=>{
            self.getManeuver(context, context.stats.characterStats.misc.level)
        },
        getManeuver:(context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.school = {crimsonReaper:true}
            let obj={command:"requestRoll", type:"maneuver", options};
            context.connection.send(JSON.stringify(obj));
        },
        catchUpMethod:(context,self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                self.getManeuver(context, x)
            }
        },
    },
    {
        rarity: "unique",
        type: "martial",
        name: "Order of Warfare",
        fromClass:"paladin",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context, self)=>{
            if(context.stats.characterStats.misc.level%3 == 0){
                self.getManeuver(context, context.stats.characterStats.misc.level)
            }
        },
        getManeuver:(context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.school = {eternalGuardian:true, goldenLion:true,radiantDawn:true,silverCrane:true,primalFury:true,burningCitadel:true,blackSeraph:true}
            let obj={command:"requestRoll", type:"maneuver", options};
            context.connection.send(JSON.stringify(obj));
        },
        catchUpMethod:(context,self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%3 == 0 || x==1){
                    self.getManeuver(context, x)
                }
            }
        },
    },
    {
        rarity: "unique",
        type: "universal",
        name: "Order of Knowledge",
        fromClass:"paladin",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context, self)=>{
            if(context.stats.characterStats.misc.level%3 == 0){
                self.getSpell(context, context.stats.characterStats.misc.level)
            }
        },
        getSpell:(context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.type={healing:true, buff:true,}
            let obj={command:"requestRoll", type:"spell", options};
            context.connection.send(JSON.stringify(obj));
        },
        catchUpMethod:(context,self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%3 == 0 || x==1){
                    self.getSpell(context, x)
                }
            }
        },
    },
    {
        rarity: "unique",
        type: "martial",
        name: "Swashbuckler Training",
        fromClass:"Swashbuckler",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level%4 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true, style:true,}}))
            }
        },
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%4 == 0 || x==1){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true, style:true,}}))
                }
            }
        },
    },

    {
        rarity: "unique",
        type: "magic",
        name: "Dangerous Knowledge",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context, self, contextSelf)=>{
            self.getSpell(context, contextSelf, context.stats.characterStats.misc.level)
        },
        getSpell: (context, contextSelf, lvlNum)=>{
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.tags=[contextSelf.chosenElement]
            let obj={command:"requestRoll", type:"spell", options}
            context.connection.send(JSON.stringify(obj))
        },
        catchUpMethod:(context,self,contextSelf)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                self.getSpell(context, contextSelf, x)
            }
        },
    },

    {
        rarity: "unique",
        type: "magic",
        name: "Arcane Blood Knowledge",
        fromClass:"Hemomancer",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context, self)=>{
            if(context.stats.characterStats.misc.level%3 == 0){
                self.getSpell(context, context.stats.characterStats.misc.level)
            }
        },
        getSpell: (context, lvlNum)=>{
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.type={damage:true,healing:true}
            let obj={command:"requestRoll", type:"spell", options};
            context.connection.send(JSON.stringify(obj));
        },
        catchUpMethod:(context,self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%3 == 0 || x==1){
                    self.getSpell(context, x)
                }
            }
        },
    },


    {
        rarity: "unique",
        type: "magic",
        name: "Blood Memory",
        fromClass:"Hemomancer",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level%4 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{magic:true}}))
            }
        },            
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%4 == 0 || x==1){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{magic:true}}))
                }
            }
        },
    },
    {
        rarity: "unique",
        type: "magic",
        name: "Destructive Knowledge",
        fromClass:"Hemomancer",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level%4 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{magic:true}}))
            }
        },            
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%4 == 0 || x==1){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{magic:true}}))
                }
            }
        },
    },
    {
        rarity: "unique",
        type: "magic",
        name: "Magus Martial Training",
        fromClass:"Magus",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level%4 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true,style:true}}))
            }
        },            
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%4 == 0 || x==1){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true,style:true}}))
                }
            }
        },
    },
    {
        rarity: "unique",
        type: "magic",
        name: "Magus Magic Training",
        fromClass:"magus",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level%4 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{magic:true,metamagic:true}}))
            }
        },            
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%4 == 0 || x==1){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{magic:true,metamagic:true}}))
                }
            }
        },
    },
    {
        rarity: "unique",
        type: "magic",
        name: "Greater Spell Access",
        fromClass:"Magus",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context, self)=>{
            if(context.stats.characterStats.misc.level%2 == 1){
                self.getSpell(context, context.stats.characterStats.misc.level)
            }
        },
        getSpell: (context, lvlNum)=>{
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{},type:{damage:true}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.type={damage:true}
            let obj={command:"requestRoll", type:"spell", options};
            context.connection.send(JSON.stringify(obj));
        },
        catchUpMethod:(context,self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%2 == 1){
                    self.getSpell(context, x)
                }
            }
        },
    },
    {
        rarity: "unique",
        type: "magic",
        name: "Broad Study",
        fromClass:"Magus",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context, self)=>{
            if(context.stats.characterStats.misc.level%3 == 0){
                self.getSpell(context, context.stats.characterStats.misc.level)
            }
        },
        getSpell: (context, lvlNum)=>{
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{},type:{healing:true,buff:true,utilty:true,control:true}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.type={damage:true}
            let obj={command:"requestRoll", type:"spell", options};
            context.connection.send(JSON.stringify(obj));
        },
        catchUpMethod:(context,self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%3 == 0 || x==1){
                    self.getSpell(context, x)
                }
            }
        },
    },

    {
    rarity: "unique",
    type: "martial",
    name: "Panache",
    fromClass:"Swashbuckler",
    shortDesc: `You gain Various Swashbuckler abilities: 
    \nPanache: You restore highest mental bonus spell points when you confirm critical hits and on killing blows with piercing melee weapons.
    \nQuick Reflexes: Gain 1 additional attack of opportunity a round. Gain an additional attack of opportunity when your BAB reaches 6 and each 5 bab after that.
    \nNimble: While wearing light or no armor you gain a +1 dodge bonus to AC, increasing by an additional +1 every 4 levels.
    \nDeeds: At level 1 you will gain a deed and parry deed, then another deed every odd level thereafter. 
    \nAdditionally, every level you will gain a maneuver from school of choice: Scarlet Throne, Mithral Current, Heart of the Maelstrom, or Riven Hourglass.`,
    hasCustomMethod:true,
    customMethod:(context, self)=>{
        self.getManeuver(context,context.stats.characterStats.misc.level)
        if(context.stats.characterStats.misc.level%2==1){
            self.getDeeds(context,self, 1)
        }                      
    },
    catchUpMethod:(context, self)=>{
        for(let x = 1; x <= context.stats.characterStats.misc.level; x++){                                
            self.getManeuver(context,x)
        }
        self.getDeeds(context,self, 1, true)
        let DeedsCount = Math.ceil(context.stats.characterStats.misc.level/2)
        self.getDeeds(context,self, DeedsCount)
    },
    getManeuver: (context, lvlNum)=>{
        lvlNum = Math.ceil(lvlNum/2)+1
        if(lvlNum > 9){lvlNum = 9}
        let options = {level:{}}
        for(let x = 0; x < 4; x++){
            if(lvlNum-x > 0){   
                let level = lvlNum-x
                let levelString="lvl"+level;
                options.level[levelString]=true;
            }
        }
        options.school = {scarletThrone:true, mithralCurrent:true,heartOfTheMaelstrom:true,rivenHourglass:true}
        let obj={command:"requestRoll", type:"maneuver", options};
        context.connection.send(JSON.stringify(obj));
    },
    getDeeds:(context, self, deedsLeft, isParry)=>{
        let deeds = self.deeds
        let choices = []
        let chosen = []
        for(let x = 0; x < 4; x++){
            let currentPerks = context.stats.lists.perks.map(perk => perk.name)
            let filtered = deeds.filter(deed=> !deed.prereq || currentPerks.includes(deed.prereq))
            if(isParry) filtered = deeds.filter(deed=> deed.type == "parry")
            let possible = Math.floor(Math.random()*filtered.length)
            while(chosen.includes(possible)) possible = Math.floor(Math.random()*filtered.length)
            chosen.push(possible)
            let option = filtered[possible]
            choices[x] = {
                title:option.name,
                description:option.description,
                id:x,
                method:(() =>{
                    let perk = {rarity:"unique", name:option.name, shortDesc:option.description, id:Math.random(), type:"martial", uiType:"perk"}                                               
                    if(option.hasCustomMethod){
                        option.customMethod(context)
                        perk.hasCustomMethod = true
                    }
                    context.stats.lists.perks.push(perk)
                    if(deedsLeft > 1){
                        deedsLeft-=1
                        self.getDeeds(context,self, deedsLeft)
                    }
                })
            }                
        }
        let custom = {title:"Deed Choice", options:choices}
        context.customDialogArray.push(custom)
    },
    hasSpecialItems:true,
    getSpecialItemList:(self)=>{
        return self.deeds
    },
    deeds: [
        {
            name:"Derring-Do",
            description:"Once per roll you can spend 1 spell point as a free action (that you can take even when not your turn), when you make an Acrobatics, Climb, Escape Artist, Fly, Ride, or Swim check to roll 1d6 and add the result to the check. You can do this after you make the check but before the result is revealed. If the result of the d6 roll is a natural 6, you roll another 1d6 and add its result to the check. You can continue to do this as long as you roll natural 6s. When you reach level 8, the dice size increases to 1d8, and you can re-roll on 7 and 8. At level 16 the dice increases to 1d10 and you can re-roll on 8,9, and 10",
        },
        {
            name:"Confident Finisher",
            description:`You can spend level spell points as an immediate action to empower your next melee attack this round. It deals an additional 1d6 precision damage, increasing by 1d6 every odd level after 1st. You can only use your confident finisher on an creature once. If your confident finisher fails to kill the target you take a -2 penalty on all d20 rolls for 1d4 rounds, increasing by -1 every 5 levels. If this attack kills the target you double the spell points you normally gain from killing the creature or for confirming a critical hit, and you choose one of the following 3 benefits:\n1: Gain 1d6 per 2 levels temporary hit points that last 1 minute\n2: Gain level/2 spell points \n3:Gain a your level as a morale bonus to attack and damage on your next attack within 1 minute.`,
        },
        {
            name:"Dodging Panache",
            description:"When an opponent attempts a melee attack against you, you can as an immediate action spend 4 spell points to move 5 feet; doing so grants you a dodge bonus to AC equal to your highest mental bonus against the triggering attack. This movement doesn't negate the attack, which is still resolved as if you had not moved from the original square. This movement is not a 5-foot step; it provokes attacks of opportunity from creatures other than the one who triggered this deed. You can only perform this deed while wearing light or no armor.",
        },
        {
            name:"Dodging Roll",
            prereq:"Dodging Panache",
            description:"When using dodging panache you instead move 10 feet and the bonus to armor class is increased by +4. The bonus to AC you gain from Dodging Panache applies to any attack of opportunity it provokes.",
        },
        {
            name:"Improved Parry",
            description:"When using any [parry] or any martial counter from Scarlet Throne, Mithral Current, Heart of the Maelstrom, or Riven Hourglass to negate an attack, you gain a +4 bonus on any d20 roll made as apart of that counter.",
        },
        {
            name:"Incredible Reflexes",
            description:"Gain an additional attack of opportunity. Every 6 levels gain another additional attack of opportunity.",
        },
        {
            name:"Kip-Up",
            description:"While you have at least level spell points, you can kip-up from prone as a move action without provoking an attack of opportunity. You can kip-up as a swift action instead by spending 3 spell points.",
        },
        {
            name:"Dueling Cape",
            description:"As a move action, you can wrap a cape that you're wearing around your arm (removing it if necessary), and treat it as a buckler. If you are using the cape in this way, and an opponent misses you with a melee attack, as an immediate action you can spend 4 spell points to release your cape from your arm and entangle your foe in it. The foe can free it by using a full-round action to escape or by destroying the cape; a typical cape has hardness 1 and 3 hit points. You can use this feat with items similar in shape and weight to a cape, such as a cloak or a curtain. Once your cape is destroyed, you must either pick up a similarly usable item from the map, or make a craft check DC 15 to repair it.",
        },
        {
            name:"Pommel Strike",
            description:"You can spend 4 spell points to make a melee attack with the pommel of a light or one-handed melee weapon as a standard action. You make this attack as if you were using the weapon normally (including any bonuses gained from Weapon Finesse, weapon focus, or other similar feats and effects), but you deal 1d6 bludgeoning damage (or 1d4 if you are Small) instead of the weapon's normal damage. Regardless of your size, the critical threat range and critical multiplier of this attack are 20/×2, and they are not affected by Improved Critical, the keen weapon special ability, or similar effects. If the attack hits, you can attempt a combat maneuver check to trip the target prone as a free action.",
        },
        {
            name:"Menacing Swordplay",
            description:"While you have at least level spell points, when you hit an opponent with a piercing melee weapon, you can use Intimidate to demoralize that opponent as a swift action.",
        },
        {
            name:"Precise Strike",
            description:"When you have at least level spell points remaining, you can precisely strike with manufactured melee weapons. With slashing or piercing light or one-handed weapons this bonus damage is equal to your level, for bludgeoning light or one-handed weapons, or piercing two-handed weapons it is half your level. To use this ability you cannot attack with an additional weapon in your other hand or use a shield other than a buckler. As a swift action you can spend 3 spell points to double this bonus damage on your next attack before the end of your turn. If you gain this perk a second time, you can choose to either include a new type of weapon (choosing both type and damage type) to add half your level as precision damage to, or to increase the damage by 1 increment. If you choose a ranged weapon, this ability only works if you are within 30 feet.",
        },
        {
            name:"Swashbuckler Initiative",
            description:"You gain a +2 bonus to initiative checks, and you can draw light, one-handed, or thrown weapons as a free action, and it does not provoke attacks of opportuntity. If you gain this perk additional times, you gain a +2 bonus to attacks on turns which you drew that weapon.",
        },
        {
            name:"Swashbuckler Grace",
            description:"As long as you have at least level spell points remaining, you take no penalty for moving at full speed when you use Acrobatics to attempt to move through a threatened area or an enemy's space. Having this additional times grants a +5 bonus on acrobatics checks to move this way.",
        },
        {
            name:"Superior Feint",
            description:"You can spend 7 spell points when making an attack, if this attack is made as a standard action, the attack automatically misses, and the creature is denied its Dexterity bonus to AC until the start of your next turn. If you do this as apart of a full round attack, you take a -5 penalty to the attack, if your attack would still hit the creature, it still automatically misses, but the creature is denied its dexterity bonus to its armor class until the end of your turn.",
        },
        {
            name:"Targeted Strike",
            description:`You can spend 7 spell points as a standard action to make a single attack with a piercing melee weapon to cripple a part of a foe's body. Choose a part of the body to target, if the attack succeeds, in addition to the attacks damage, the target suffers one of the following effects based on the part of the body targeted:
            \nArms: The target takes no damage from the attack, but it drops one carried item of the swashbuckler's choice, even if the item is wielded with two hands. Items held in a locked gauntlet cannot be chosen.
            \nHead: The target is confused for 1 round. This is a mind-affecting effect.
            \nLegs: The target is knocked prone. Creatures with four or more legs or that are immune to trip attacks are immune to this effect.
            \nTorso or Wings: The target is staggered for 1 round.
            \n\nCreatures must have the body part to be targeted, and creatures immune to sneak attack damage are also immune to this ability.`,
        },
        {
            name:"Bleeding Wound",
            description:"When you hit a living creature with a piercing or slashing melee weapon attack, as a free action you can spend 6 spell points to have that attack deal additional bleed damage equal to your dexterity modifier. Alternatively, the swashbuckler can spend 12 spell points to deal 1 point of Strength, Dexterity, or Constitution bleed damage instead (your choice). Creatures that are immune to sneak attacks are also immune to these types of bleed damage.",
        },
        {
            name:"Evasion",
            description:`You gain the bonus of evasion, uncanny dodge, and improved uncanny dodge
            \nEvasion:If you make a successful Reflex saving throw against an attack that normally deals half damage on a successful save, you instead takes no damage. Evasion can be used if wearing light armor or no armor, and not helpess.
            \nUncanny dodge:She cannot be caught flat-footed, nor does she lose her Dex bonus to AC if the attacker is invisible. She still loses her Dexterity bonus to AC if immobilized. A rogue with this ability can still lose her Dexterity bonus to AC if an opponent successfully uses the feint action (see Combat) against her.
            \nImproved Uncanny Dodge: You cannot be flanked.
            \n\nHaving this additional times grants a +2 dodge bonus to armor class and reflex saves.`,
        },
        {
            name:"Subtle Blade",
            description:"You are immune to disarm, steal and sunder combat maneuvers against weapons you are wielding.",
        },            
        {
            name:"Dizzying Defense",
            description:"As a swift action you can spend 4 spell points to take a -2 penalty on attack rolls and gain a +4 dodge bonus to your armor class for 1 round. This counts as fighting defensively for any bonuses or penalties associated with that, and does not stack with it.",
        },
        {
            name:"Perfect Thrust",
            description:"You can make a single attack with a wielded melee weapon, doing so is a full-round action that costs 6 spell points. This attack targets the creatures touch armor class and ignores all damage reduction.",
        },
        {
            name:"Swashbuckler's Edge",
            description:"As long as you have at least level spell points you can take 10 on any Acrobatics, Climb, Escape Artist, Fly, Ride, or Swim check, even while distracted or in immediate danger.",
        },
        {
            name:"Cheat Death",
            description:"Whenever you are reduced to -1 hit points or fewer, you can spend 16 spell points to instead be reduced to 1 hit point. You cannot use this ability more than once per combat. Effects that kill you outright without dealing hit point damage are not affected by this ability.",
        },
        {
            name:"Deadly Stab",
            description:"When the swashbuckler confirms a critical hit with a piercing melee weapon, in addition to the normal damage, she can spend 15 spell points to inflict a deadly stab. The target must succeed at a Fortitude saving throw or die. The DC of this save is 10 + 1/2 level + Dexterity modifier. This is a death attack. Performing this deed does not grant the spell points if it succeeds, or for confirming a critical hit.",
        },
        {
            name:"Stunning Stab",
            description:"When you hit a creature with a piercing melee weapon, you can spend 10 spell points to stun the creature for 1 round unless the creature succeeds at a Fortitude saving throw (DC = 10 + 1/2 level + Dexterity modifier). Creatures that are immune to critical hits are also immune to this effect.",
        },
        {
            name:"Spark of Battle",
            description:"Once per round when you score a critical hit with a melee weapon you can recover a single maneuver.",
        },
        {
            name:"Dodging Dance",
            description:"You can spend 7 spell points to move up to half your speed as a move action. If a creature makes an attack of opportunity against you due to this movement, you can attempt an Acrobatics check with a DC equal to the attacking creature's CMD. If you succeed, the attack of opportunity misses, and you can make an attack of opportunity against the attacking creature instead. You can attempt to evade multiple attacks of opportunity during this movement, but the DC of the Acrobatics check increases by 2 for each additional opponent that makes an attack of opportunity against you during this movement.",
        },
        {
            name:"Vengeful Heart",
            description:`You can spend level spell points to accomplish one of the following abilities:
            \nDetermined: As a standard action to suppress the fatigued, shaken, or sickened conditions for 1 hour. At level 8 you can also suppress frightened, nauseated, or staggered.
            \nResolute: As an immediate action before you make a fortitude or will saving throw, you can roll twice taking the better result
            \nUnstoppable: As an immediate action when reduced below 0 hit points but not slain, you instantly stabalize and remain conscious. You are staggered, but do not fall unconscious unless you take additional damage.`,
        },
        {
            name:"Vengeful Soul",
            prereq:"Vengeful Heart",
            description: `You can spend level spell points to accomplish one of the following abilities:
            \nUnfliching: As an immediate action when a critical hit is confirmed against you, you can turn it into a regular hit.
            \nTrue Resolve: As an immediate action you spend all spell points, but at least levelx2, when you do, you reduce the damage of a single source of damage to 0.`,
        },
        {
            name:"Swashbuckler Finesse",
            description:"You can use dexterity to determine your attack with all melee weapons. For weapons that you could already use dexterity to determine their attack, you can instead use dexterity to determine their damage. If you could already use dexterity to determine their damage, they gain a +1 bonus to damage, increasing by +1 every 4 levels.",
        },
        {
            name:"Interfering Blade",
            description:"As long as you are wearing light or no armor, whenever you are aware of an attack against an adjacent ally and would not yourself be denied your dexterity bonus against that attack, you grant that ally a +1 bonus to AC against that attack. This bonus increases by 1 every 4 levels.",
        },
        {
            name:"Daring Teamwork",
            description:"You regain highest mental modifier spell points (minimum 1) spell points whenever an ally other than yourself reduces an enemy to 0 or fewer hit points, as long as you dealt damage to that enemy at least once.",
        },
        {
            name:"Daring Strategy",
            description:"As a standard action, you can spend level spell point to grant a teamwork feat to all allies within 30 feet who can see and hear you. They do not need to meet the feat's prerequisites, but they do not gain any benefit if they already have the feat. This ability lasts for 3 rounds + level/2 rounds, but if the guiding blade ever fails to have at least level spell points, all of these durations end immediately. You can grant multiple teamwork feats at once.",
        },                        
        {
            name:"Swashbuckler Techniques",
            description:"Gain an additional Scarlet Throne, Mithral Current, Heart of the Maelstrom, and Riven Hourglass maneuver at 1st and every 3rd level.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                let perk = perks.find(perk => perk.name == "Swashbuckler Techniques")
                perk.catchUpMethod(context,perk)
            }
        },
        {
            name:"Swashbuckler Training",
            description:"You gain a martial feat, plus an additional martial feat every 4 levels.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                let perk = perks.find(perk => perk.name == "Swashbuckler Training")
                perk.catchUpMethod(context,perk)
            }
        },
        {
            name:"Martial Perk",
            description:"You gain a R+ martial perk.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk", options:{type:{martial:true},rarity:{rare:true,epic:true,legendary:true,unique:true}}}))
            }
        },
        {
            name:"Fighter Perk",
            description:"You gain a fighter perk.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Fighter Perk"}))
            }
        },
        {
            name:"Life of Crime",
            description:"You gain a Rogue Perk and 50 gold.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.gold += 50
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Rogue Talent"}))
            }
        },
        {
            name:"Charmed Life",
            description:"For 6 spell points as an immediate action before attempting a saving throw, you can add your Charisma or intelligence bonus to the result of the save. She must choose to do this before the roll is made.",
        },
        {
            name:"Greater Charmed Life",
            prereq:"Charmed Life",
            description:"Charmed life costs 2 less spell points to use,  additionally, you can as an immediate action, expend one use of charmed life to gain a dodge bonus to your AC equal to your highest mental modifier (minimum 1) against the attack. You must choose to do this before the attack roll is made against you.",
        },
        {
            name:"Charmed Guardian",
            prereq:"Charmed Life",
            description:"You can use charmed life on a saving throw attempted by any ally within 30 feet.",
        },
        {
            name:"Swagger",
            prereq:"Charmed Life",
            description:"Your swagger gives you an additional benefit when you use charmed life. If you succeeds at a saving throw against an opponent's attack or ability while using charmed life on that save, you can attempt an Intimidate check to demoralize that opponent without using an action.",
        },
        {
            name:"Incredible Luck",
            prereq:"Charmed Life",
            description:"When using charmed life you can instead activate it at a free action, its bonus stacks with itself, but each additional use doubles the cost of its previous activation.",
        },
        {
            name:"Nimble",
            description:"You gain a +1 dodge bonus to AC while wearing light or no armor. This bonus increases by 1 for every 4 levels.",
        },
        {
            name:"Dervish Dance",
            description:"Any deed that requires you to be using a piercing melee weapon you can also use a slashing weapon. You can use your dexterity modifier to determine damage with any weapon you can use dexterity to determine the attack of. If you already had the ability to use dexterity to determine the damage of the attack, you gain a +1 bonus on damage with such weapons when using dexterity to determine their damage. This bonus increases every 4 levels.",
        },
        {
            name:"Whirlwind Dance",
            description:"You can sweep through your opponents' lines like a cyclone. As a full-round action, you can spend 6 spell points to move up to your speed. You can make attacks against creatures with your reach during this movement, up to the number of attacks you're entitled to with a full attack. Each attack is made at your highest attack bonus, and must target a different creature. This movement provokes attacks of opportunity as normal.",
        },            
        {
            name:"Melee Shooter",
            description:"As a swift action when wielding both a light or one-handed piercing melee weapon and a one-handed firearm, you can spend 1 spell point to avoid provoking attacks of opportunity with the first ranged attack made by the one-handed firearm during your turn.",
        },
        {
            name:"Quick Clear",
            description:"As a standard action you can spend 3 spell points to remove the broken condition from a single firearm your are currently wielding, as long as the firearm gained that condition through a misfire.",
        },
        {
            name:"Gun Feint",
            description:"When you have at least level spell points you can feint instead of attacking with your firearm as part of a full attack. You can spend 2 spell points to gain a +5 bonus on this check.",
        },
        {
            name:"Lightning Reload",
            description:"Once per round you can spend 3 spell points to reduce the action cost to reload a firearm by 1 step the next time you reload it this round, and that reload no longer provokes.",
        },
        {
            name:"Self Reliant",
            description:"Whenever you fail a Will saving throw against an effect with a duration greater than 1 round, you can attempt another saving throw at the end of the second round of the effect. If you make this saving throw, it has the same effect as if you had made the original save (negating part or all of the effect). In addition, whenever you are brought below 0 hit points, on your next turn you can roll twice to stabilize, taking the better result.",
        },
        {
            name:"Without Master",
            description:"You can summon up your willpower as an immediate action, which can be used in one of 3 ways. You can use your willpower whenever an attack would reduce you to fewer than 0 hit points but wouldn't kill you, to instead be at 1 hit point and conscious. You can use your willpower after making an attack roll to confirm a critical hit in order to reroll the confirmation roll. Finally, you can use your willpower to take 10 on a skill check during combat, even if the situation or the skill would not normally allow you to take 10. You can use this ability once per combat.",
        },
        {
            name:"Avenger's Target",
            description:"You can study an opponent you can see as a move action. You then gains a +1 bonus on Bluff, Knowledge, Perception, Sense Motive, and Survival checks against that opponent, a +1 bonus on weapon attack and damage rolls against it, and a +1 bonus to DCs of any deeds used against that opponent. You can maintain these bonuses against only one opponent at a time; these bonuses remain in effect until either the opponent is dead or you study a new target. Every 6 levels these bonuses increase by +1. At level 10 you can spend 6 spell points to study a target as a free action.",
        },
        {
            name:"Underfoot Assault",
            description:`If a foe whose size is larger than yours is adjacent to you and misses you with a melee attack, you can as an immediate action spend 3 spell points to move 5 feet into an area of the attacker's space. This movement does not count against your movement next round, and it doesn't provoke attacks of opportunity. While you are within a foe's space, you are considered to occupy your square within that foe's space and take no penalties for such.
            \nWhile within your foe's space, the foe takes a -4 penalty on all attack rolls and combat maneuver checks not made against you, and all of your allies that are adjacent to both the foe and you are considered to be flanking the foe. You are considered to be flanking the foe whose space you are within if you are adjacent to an ally who is also adjacent to the foe. You can move within your foe's space and leave the foe's space unhindered and without provoking attacks of opportunity, but if the foe attempts to move to a position where you are no longer in its space, the movement provokes an attack of opportunity from you.`,
        },
        {
            name:"Swashbuckler Weapon Mastery",
            description:"When using piercing weapons your critical damage multiplier increases by +1.",
        },
        {
            name:"Hamstring",
            description:"As long as you have at least level spell points when you hit a foe whose size is larger than your own with a piercing or slashing melee weapon, you can as a swift action attempt a dirty trick combat maneuver check. Instead of the normal conditions that can be applied with dirty trick, this deed can only stagger the target if the check is successful.",
        },
        {
            name:"Cat's Charge",
            description:"As long as you have at least level spell points, when you charge a foe whose size is larger than your own, you can end your charge in any space you can reach, not just the closest space. All other requirements of the charge must still be satisfied.",
        },
        {
            name:"Flashy Finish",
            description:"You restore an additional level/2 spell points whenever you confirm a critical hit or land the killing blow on a creature with piercing melee weapons.",
        },
        {
            name:"Quick Steal",
            description:"As a swift action you can spend level spell points when you hit a for larger than you with a light or one-handed melee weapon to attempt a steal combat maneuver check against the creature you hit. Using this deed does not provoke an attack of opportunity. Successfully using this ability also grants additional items, roll a d100, on 1-50: 1d10 gold, 51-75: random potion, 76-85: 2d10 gold, 85-96: random gear, and 96-100: wonderous item. This ability can only activate once per enemy.",
        },
        {
            name:"Swashbuckler Weapon Training",
            description:"You gain a +1 bonus on attack and damage with piercing melee weapons, which increases by +1 every 5 levels. Additionally, with piercing melee weapons you double their critical threat range. If you already were doubling them, you instead gain a flat +1 bonus to the range.",
        },
        {
            name:"Plunder",
            description:"As a full-round action for level spell points you can make a single attack with a light or one-handed melee weapon against a foe that is either shaken or denied its Dexterity bonus to AC. If the attack hits, you also pilfers item from your target as if you had succeeded at a Sleight of Hand or steal combat maneuver check. Successfully using this ability also grants additional items, roll a d100, on 1-50: 1d10 gold, 51-75: random potion, 76-85: 2d10 gold, 85-96: random gear, and 96-100: wonderous item. This ability can only activate once per enemy.",
        },
        {
            name:"Silence is Golden",
            description:"When a daring infiltrator with at least level spell points succeeds at a trip or grapple combat maneuver check, the target is rendered mute for 1 round. For every 5 by which the result of the combat maneuver check exceeds the opponent's CMD, the target remains mute for an additional round. A mute creature cannot speak, use language-dependent effects or verbal components, or use command words.",
        },
        {
            name:"Flying Blade",
            description:"Deeds that require you to use a melee piercing weapon to benefit can also be used with throwing weapons. For deeds that include making a special attack, such as deadly stab or for precise strike, the target must be within 30 feet. At level 10 this increases to 60 feet.",
        },
        {
            name:"Inspired Strike",
            description:"An inspired blade can spend 6 spell points when making an attack with a piercing weapon to gain an insight bonus on that attack roll equal to their highest mental modifier (minimum +1). When an inspired blade hits with an attack augmented by inspired strike, they can use a swift action and spend 6 + level additional spell points to make the hit a critical threat, though if thy do so, they do not regain spell points if they confirm that critical threat.",
        },
        {
            name:"Incredible Countering",
            description:"Once per round you can use a counter martial maneuver without expending your immediate action, however this counter has its spell point cost increased by 50%.",
        },
        {
            name:"Disengaging Parry",
            description:"Whenever you use a [parry] ability to take no damage from an attack, you can spend 5 spell points to take a 5-foot step. This provokes from all creatures other than the creature who's attack you just negated.",
        },
        {
            name:"Vivacious Bravado",
            description:"As a swift action you can gain temporary hit points equal to your highest mental modifier until the start of your next turn. You can instead spend 4 spell points to activate this a free action. These do not stack with themselves. Whenever you score a critical hit or a creature critically fumbles against you, you gain temporary hit points equal to your highest mental modifier, these do stack with themselves.",
        },
        {
            name:"After You",
            description:"You can activate this ability in two circumstances, when you roll initative or when your turn is directly before an enemies. If you use it when you roll initiative, you are automatically last and you regain 2x highest mental spell points, if you use it when an enemies turn is directly after yours, your initiative is lowered to below theirs and you regain highest mental modifier spell points. You cannot use this ability more than once per combat. In either situation, you can use intimidate to demoralize all creatures who saw you use this ability.",
        },
        {
            name:"Opportune Parry and Riposte",
            type:"parry",
            description:`[parry] When an opponent makes a melee attack against you (which you are aware of and can see), you can spend 1 spell point and expend a use of an attack of opportunity to attempt to parry that attack. You make an attack roll as if making an attack of opportunity; for each size category the attacking creature is larger than you, you take a -2 penalty on this roll. If your result is greater than the attacking creature's result, the creature's attack automatically misses. You must declare the use of this ability after the creature's attack is announced, but before its attack roll is made. Upon performing a successful parry and if you has at least level spell points remaining, you can as an immediate action make an attack against the creature whose attack you parried, provided that creature is within your reach. Each previous use of this ability per round doubles the cost of it. Having this ability additional times allows you to spend the spell points to parry twice before its cost is increased, and riposte twice in a round, the second time being a free immediate action you can make after you parry an additional attack.`,
        },
        {
            name:"Opportune Redirection and Riposte",
            type:"parry",
            description:`[parry] When an opponent threatening both you and an adjacent ally attacks that ally (which you are aware of and can see), you can spend 1 spell point and expend a use of an attack of opportunity to attempt to redirect the attack to yourself.
            You make an attack roll as if you were making an attack of opportunity; for each size category the attacking creature is larger than you, you take a -2 penalty on this roll. If your result is greater than the attacking creature's attack result, the creature's attack is redirected to you instead of your adjacent ally. You must declare the use of this ability after the creature's attack is announced but before its attack roll is made.
            Upon performing a successful redirection, if you have at least level spell points remaining, you can, as an immediate action, make an attack against the creature whose attack you redirected, provided that creature is within reach. Each previous use of this ability per round doubles the cost of it. Having this ability additional times allows you to spend the spell points to redirect twice before its cost is increased, and riposte twice in a turn, the second time being a free immediate action you can make after you parry an additional attack.`,
        },
        {
            name:"Disrupting Counter",
            type:"parry",
            description:"[parry] When an opponent makes a melee attack against you (which you are aware of can see), you can spend 3 spell points to make an attack of opportunity against the attacking foe. Each previous use of this ability per round doubles the cost of it. You must be using a light weapon to do this. If the attack hits, the opponent takes a -4 penalty on all attack rolls until the end of its turn (doesn't stack). Having this ability additional times allows you to spend the spell points to counter twice before its cost is increased, and increases the attack penalty by -4.",
        },
        {
            name:"Direct Counter",
            type:"parry",
            description:"[parry] When an opponent makes a melee attack against you (which you are aware of can see), you can spend 2 spell points and expend one attack of opportunity to prepare to directly counter the blow, if the attack hits you, you make a damage roll, not including any precision or additional damage dice, then you reduce the damage of the countered attack by the result of your damage roll. If your damage roll is higher than theirs, you can roll an attack roll against their armor class with the weapon you used to counter the attack, if you succeed, they take the excess damage. Each previous use of this ability per round doubles the cost of it. This ability only functions against physical damage received from an attack. Having this ability additional times allows you to activate it an additional time per damage roll against you, and its cost is only increased after using it twice.",
        },
        {
            name:"Flurry Defense",
            type:"parry",
            description:"[parry] When an opponent makes a melee attack against you (which you are aware of can see), you can expend one attack of opportunity to increase your armor class against the attack by +2. You can expend multiple attacks of opportunity at once while using this ability, its benefits stack. If the creature misses by an amount less than the amount of AC you gained from this ability, it gains a -2 penalty on all attack rolls for the rest of the turn. When your BAB reaches 6, and each 5 BAB after, the bonus to armor class and the penalty given increases by 1. While using this ability, if a creature confirms a critical fumble against you, it provokes an attack of opportunity from you. Having this ability multiple times increases the bonus to armor class by +2 whenever you use it (scaling the same way the ability does)",
        },            
    ]
    },
    {
    rarity: "unique",
    type: "martial",
    name: "Martial Flexibility",
    fromClass:"Brawler",
    shortDesc: `You gain the ability to temporarily adopt combat/style/martial feats. Each round you have temporary feats active you must spend spell points at the start of your turn depending on how many you have active. If you activate this ability to gain more feats, you must spend the additional spell points for maintaining them immediately. To gain a feat you must be the minimum level you would need to be to meet the requirements of the feat (if a feat has a BAB or skill rank prerequisite your level must be equal to it), and if the feat has prerequisites in the Akashic Paths, you must have them too. You cannot select a feat that allows you to select another ability, such as advanced study or extra rogue talent, nor any feat you already possess (through this ability or otherwise). If a feat is an Akashic Paths only feat, it has a prerequisite of level 5, plus 5 for each feat prerequisite it has. The action to adopt a feat changes as you level up. If you already have all of your feat slots full when you activate this ability, you still pay the cost of adding new feats, but can replace any feat you had active with the new desired feats. \n\nThe cost to maintain feats is as follows: \n1 Feat: 1 spell point\n2 Feats: 3 spell points\n3 Feats: 5 spell points\n4 Feats: 9 spell points\n5 Feats: 14 spell points
    \nThe actions to adopt feats and your feat slots is as follows:
    \nLevel 1: 1 Feat Slot. Movement action to gain 1 feat.\nLevel 3: 2 Feat Slots. Movement action to gain 2 feats. Swift action to gain 1 feat.\nLevel 6: 3 Feat Slots. Movement action to gain 3 feats. \nLevel 10: Immediate action to gain 1 feat. Swift Action to gain 2 feats.\nLevel 12: 4 Feat Slots. Movement Action to gain 4 feats. Immediate action to gain 2 feats.\nLevel 18: 5 Feat Slots. Movement Action to gain 5 feats. Swift action to gain 4 feats.
    \n\nYou gain a maneuver from school of choice every odd level.
    \nGain 1 additional spell point per level`,
    hasCustomMethod:true,
    customMethod: (context, self)=> {
        if((context.stats.characterStats.misc.level%2 == 1)){
            self.getManeuver(context, Math.ceil(context.stats.characterStats.misc.level/2)+1)                                
        }

    },
    catchUpMethod: (context, self)=>{
        context.stats.characterStats.misc.spPerLevel += 1
        for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
            if(x==1 || x%2 == 1){
                self.getManeuver(context, Math.ceil(x/2)+1)                        
            }
        }
    },
    getManeuver: (context, lvlNum)=>{
        if(lvlNum > 9){lvlNum = 9}
        let options = {level:{}, school:{}}
        for(let x = 0; x < 4; x++){
            if(lvlNum-x > 0){   
                let level = lvlNum-x
                let levelString="lvl"+level;
                options.level[levelString]=true;
            }
        }
        let schools = maneuverSchoolsText
        let choices = []           
        for(let x = 0; x < schools.length; x++){
            let choice = {
                title:schools[x],
                id:x, 
                method:(context=>{                            
                    options.school[schools[x]] = true
                    context.connection.send(JSON.stringify(
                        {
                            command:"requestRoll", 
                            type:"maneuver", 
                            options
                        }
                    ))
                })}
                choices.push(choice)
        }         
        let custom = {title:"Typed Maneuver Choice", options:choices}         
        context.customDialogArray.push(custom)
    },   
    },
    {
        rarity: "unique",
        type: "magic",
        name: "Fervor",
        fromClass:"Warpriest",
        shortDesc: `For level/2 spell points you can activate this ability to cast a spell that has a casting time of 1 round or less as a swift action (costs SP as normal). The spell must be a spell that can target you, and you must cast it to target yourself. Even if the spell would normally target multiple creatures or affect an area, it now only effects you. Spells cast this way ignore somatic components, do not provoke attacks of opportuntity, and dont require a free hand to cast.
        \nWhen you select this ability you can either choose to deal positive or negative energy. You can spend 1 spell point per dice as a swift action to affect yourself with your energy type, or affect another as a standard action that requires a touch attack. This heals or deals 1d6, increasing 1d6 every 3 levels and scales with positive/negative spell power. Creatures can make a will save dc=(10 + level/2 + highest mental) to halve this. This otherwise acts like lay on hands for other prerequisite abilities. At level 4 you can spend 3 spell points per dice rolled as a standard action to affect all creatures within 30 feet of you with your energy type, they receive a will save as normal, this otherwise acts like channel energy can can be used with abilities that augment channel energy. 
        \nBlessings: When you gain this perk you select a blessing. Each blessing grants 2 powers. Unless specified otherwise, each power is a standard action to activate and costs level/2 spell points. At level 1 you can use the domains minor power, at level 8 you can use the major power instead. The DC of blessings is 10 + level/2 + highest mental modifier.
        \nAt 1st and every odd level after you gain a typed maneuver from Eternal Guardian/Golden Lion/Radiant Dawn/Silver Crane/Indomitable Will. 
        \nEvery level you gain a buff spell.\nAt 1st and every 3rd level you gain a healing spell\nGain 1 additional spell point per level`,
        blessingChoices:[],
        hasCustomMethod:true,
        customMethod:(context, self,contextSelf)=>{
            if(context.stats.characterStats.misc.level%2==1){
                self.getTypedManeuver(context, context.stats.characterStats.misc.level)
            }
            if(context.stats.characterStats.misc.level%3==0){
                self.getSpell(context, context.stats.characterStats.misc.level, "healing")
            }
            self.getSpell(context, context.stats.characterStats.misc.level, "buff")
            if(contextSelf.blessingChoices.length > 0){
                contextSelf.blessingChoices.forEach(blessing=>{
                    let option = self.blessings.find(foundBlessing=>foundBlessing.name == blessing)
                    if(option.hasCustomMethod){
                        option.customMethod(context, contextSelf)
                    }
                })
            }
        },
        catchUpMethod:(context, self, contextSelf)=>{
            self.getBlessings(context,self, contextSelf)
            contextSelf.shortDesc += `\n\n\nBlessings Gained:`
            context.stats.characterStats.misc.spPerLevel += 1
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%2==1 || x == 1){
                    self.getTypedManeuver(context,x)
                }
                if(x%3 == 0 || x == 1){
                    self.getSpell(context, x, "healing")
                }
                self.getSpell(context, x, "buff")
                
            }
        },
        getTypedManeuver: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}, school:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            let schools = ["eternalGuardian", "goldenLion", "radiantDawn","silverCrane","indomitableWill"]
            let choices = []           
            for(let x = 0; x < schools.length; x++){
                let choice = {
                    title:schools[x],
                    id:x, 
                    method:(context=>{                            
                        options.school[schools[x]] = true
                        context.connection.send(JSON.stringify(
                            {
                                command:"requestRoll", 
                                type:"maneuver", 
                                options
                            }
                        ))
                    })}
                    choices.push(choice)
            }         
            let custom = {title:"Typed Maneuver Choice", options:choices}         
            context.customDialogArray.push(custom)
        },
        getSpell: (context, lvlNum, type)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.type = {}
            options.type[type] = true
            let obj={command:"requestRoll", type:"spell", options};
            context.connection.send(JSON.stringify(obj))
        },
        hasSpecialItems:true,
        getSpecialItemList:(self)=>{                            
            self.blessings.forEach(blessing=>{
                blessing.description += `\n\nExtra Rolls: ` + blessing.extraRolls
            })
            return self.blessings
        },
        getBlessings:(context, self, contextSelf)=>{
            let choices = []
            let chosen = []
            let blessings = self.blessings
            for(let x = 0; x < 4; x++){
                let possible = Math.floor(Math.random()*self.blessings.length)
                while(chosen.includes(possible)) possible = Math.floor(Math.random()*blessings.length)
                chosen.push(possible)
                let option = blessings[possible]
                let description = option.description + `\n\nExtra Rolls: ` + option.extraRolls
                choices[x] = {
                    title:option.name,
                    description,
                    id:x,
                    method:(() =>{
                        contextSelf.shortDesc += `\n\n` + option.name + `: \n` + description
                        if(!contextSelf.blessingChoices) contextSelf.blessingChoices = []
                        contextSelf.blessingChoices.push(option.name)
                        if(option.hasCustomMethod){
                            option.catchUpMethod(context, self, contextSelf)
                        }
                    })
                }                
            }
            let custom = {title:"Blessings Selection", options:choices}
            context.customDialogArray.push(custom)
        },
        blessings:[
            {
                name:"Air",
                description:`Minor: You can touch any one ranged weapon and enhance it with the quality of air. For 1 minute, any attacks made with the weapon take no penalties due to range. In addition, making a ranged attack with this weapon doesn't provoke an attack of opportunity.
                \nMajor: You can touch an ally and give them the gift of flight for 1 minute (as fly spell). The ally gains a fly speed of 60 feet with average maneuverability. They gain a bonus on Fly skill checks equal to your level. Whenever the ally succeeds at a charge attack while flying, that attack deals an amount of additional electricity damage equal to your level.`,
                extraRolls:"Gain precise shot, and a Tempest Gale/Solar Wind Maneuver every 4 levels.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["tempestGale", "solarWind"])
                    }
                },
                catchUpMethod:(context)=>{
                    let feat = feats.find(feat => feat.name == "Precise Shot")
                    context.stats.lists.feats.push(feat)
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["tempestGale", "solarWind"])
                        }
                    }
                },
            },
            {
                name:"Enlightenment",
                description:`Minor: Your enlightenment grants you increased defenses. You gain a bonus to your armor class equal to your highest mental modifier. This is a passive bonus that does not need to be activated, but you lose these bonuses when you are immobilized or helpless, wear any armor or use a shield. You can expend uses of your blessing as a standard action to allow you to wear armor without losing this benefit for 1 minute, it is 1 use for light, 3 for medium or to use a shield (choose one), and 6 for heavy.
                \nMajor: You can as a swift action expend a 2 uses of your blessing to make an unarmed attack at your highest base attack bonus. This attack has its damage increased by 1 dice step per your highest mental modifier-2.`,
                extraRolls:"Gain a broken blade maneuver at 1st and every 4 levels. You also gain a <technique> finisher at 6th and every 6 levels.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["brokenBlade"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Technique"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["brokenBlade"])
                        }
                        if(x%6 == 0 || x == 1){
                            getManeuver(context, x, ["Technique"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Animal",
                description:`Minor: You can touch one ally and grant it feral features. The ally gains 2 claw attacks that each deal 1d6 points of damage, or 1 bite attack that deals 1d8 points of damage. These are primary natural attacks that replace any similar primary natural attacks the ally might have. This effect lasts for 1 minute.
                \nMajor: You can summon a battle companion. This ability functions as summon nature's ally V with a duration of 1 minute. This ability can summon only one animal, regardless of the list used. For every 2 levels beyond 8th, the level of the summon nature's ally spell increases by 1 (to a maximum of summon nature's ally IX at 18th level).`,
                extraRolls:"Gain an additional ability score roll at 1st and every 4 levels",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{abilityScore:true}}}));
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{abilityScore:true}}}));
                        }
                    }
                },
            },
            {
                name:"Battle",
                description:`Minor: You can bond yourself to a wielded weapon for 1 minute. Its base damage becomes 1d6, but every 3 levels this increases by 1 dice step. You can have only a single favored weapon at a time.
                \nMajor: You can expend a use of your blessing as a swift action to grant your favored weapon a +1 enhancement bonus for rounds equal to your highest mental modifier (minimum 1). Every 4 levels this enhancement bonus increases by +1.`,
                extraRolls:"Gain +1 BAB, +1 every 4 levels.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        context.stats.characterStats.misc.BAB += 1
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0){
                            context.stats.characterStats.misc.BAB += 1
                        }
                    }
                },
            },
            {
                name:"Metal",
                description:`Minor: You can touch a piece of armor, granting it additional mobility for 1 minute. Its armor check penalty decreases by your highest mental modifier and its maximum dexterity bonus is increased by 50%.
                \nMajor: You can expend a use of your blessing as a swift action to grant a piece of armor you are wearing a +1 enhancement bonus for 1 minute. Every 4 levels this enhancement bonus increases by +1.`,
                extraRolls:"Gain an armor enchantment every 6 levels.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%6 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"armor enchantment"}))
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%6 == 0){
                            context.connection.send(JSON.stringify({command:"requestRoll", type:"armor enchantment"}))
                        }
                    }
                },
            },
            {
                name:"Artifice",
                description:`Minor: You can touch one melee weapon and grant it greater power to harm and destroy crafted objects. For 1 minute, whenever this weapon deals damage to constructs or objects, it bypasses hardness and damage reduction.
                \nMajor: You can temporarily transfer a weapon special ability from one weapon to another. The bearers of each of the weapons must be willing, and you must be touching both weapons to activate this ability. You can transfer a weapon special ability with a rarity of common, rare, or epic. If you are using this ability on a double weapon, only one end of the double weapon is affected. The transfer lasts for 1 minute, after which the transferred weapon special ability automatically returns to the source weapon. You can use this ability multiple times on the same weapon or weapons. Alternatively, you can use transfer magic to move a common, rare, or epic armor special ability from one touched suit of armor to another, or move a +1, +2, or +3 armor or weapon enhancement bonus to another armor or weapon.`,
                extraRolls:"Gain a weapon enchantment every 6 levels.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%6 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"weapon enchantment"}))
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%6 == 0){
                            context.connection.send(JSON.stringify({command:"requestRoll", type:"weapon enchantment"}))
                        }
                    }
                },
            },
            {
                name:"Witchcraft",
                description:`Minor: You gain minor hexes with this perk. These function as standard minor hexes, and unless specified otherwise, each is a swift action to activate, costs 1 spell point, have a range of 30 feet, and can only be used once per day. Their DC is equal to 10 + level + highest mental modifier. You can expend a use of your blessing as a standard action to recharge one expended hex.
                \nMajor: You can expend a use of your blessing while activating a hex to have it target all creatures within 30 feet. This expends the hex as normal. If you use a hex this way, it cannot be recharged with the minor blessing.`,
                extraRolls:"Gain 2 hexes at 1st level, and an additional hex every 4 levels.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        let perk = perks.find(perk => perk.name == "Hexes")
                        perk.getHex(context, perk, 1)
                    }
                },
                catchUpMethod:(context)=>{
                    let perk = perks.find(perk => perk.name == "Hexes")
                    perk.getHex(context, perk, 1)
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            perk.getHex(context, perk, 1)
                        }
                    }   
                },
            },
            {
                name:"Chaos",
                description:`Minor: You can touch one weapon and grant it a chaotic blessing. For 1 minute, this weapon glows yellow or purple and deals an additional 1d6 points of damage against lawful creatures. During this time, it's treated as chaotic for the purposes of overcoming damage reduction.
                \nMajor: you can summon a battle companion. This ability functions as summon monster IV with a duration of 1 minute, but for only a chaotic outsider or an animal with the entropic creature simple template. This ability can summon only one creature, regardless of the list used. For every 2 levels beyond 8th, the level of the summon monster spell increases by 1 (to a maximum of summon monster IX at 20th level).`,
                extraRolls:"At 1st and every 6 levels you will gain something random.",
                hasCustomMethod:true,
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x%6 == 0 || x == 1){
                            let options = ["perks","spell","maneuver","wonderousItems","feat","stats","weapon enchantment","armor enchantment","armor","weapon"]
                            let type = options[Math.floor(Math.random()*options.length)]
                            context.connection.send(JSON.stringify({command:"requestRoll", type:type}))
                        }
                    }
                         
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%6 == 0){
                        let options = ["perks","spell","maneuver","wonderousItems","feat","stats","weapon enchantment","armor enchantment","armor","weapon"]
                        let type = options[Math.floor(Math.random()*options.length)]
                        context.connection.send(JSON.stringify({command:"requestRoll", type:type}))
                    } 
                },
            },
            {
                name:"Charm",
                description:`Minor: You can touch an ally and grant an entrancing blessing. For 1 minute, the ally becomes mesmerizing to her opponents, filling them with either abject admiration or paralyzing fear. This effect functions as sanctuary spell, except if the ally attacks an opponent, the effect ends with respect to only that opponent. This is a mind-affecting effect.
                \nMajor: You can surround yourself with a tangible aura of majesty for 1 minute. While this aura is active, once per round as a swift action you can issue a command (as the command spell) to one creature within 30 feet; the creature must succeed at a Will saving throw or submit for 1 round.`,
                extraRolls:"Gain a control spell at 1st and every 4 levels",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, ["control"])
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, ["control"])
                        }
                    }
                },
            },
            {
                name:"Conduit",
                description:`Minor: You gain access to channel energy immediately, the spell point cost of using channel energy is reduced to 1 spell point per dice rolled.
                \nMajor: You can channel energy as a movement action by doubling the spell point cost.`,
                extraRolls:"Gain a healing spell at 1st and every 4 levels. You also gain 2% healing critical chance and +1 healing spell power per level.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, ["healing"])
                    }
                    context.stats.characterStats.spellMastery.spellPower.positive += 1
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellCriticalChance.positive += 2
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, ["healing"])
                        }
                        context.stats.characterStats.spellMastery.spellPower.positive += 1
                    }
                },
            },
            {
                name:"Divine Aspect",
                description:`Minor: You can as a standard action allow yourself to use your level in place of your BAB for 1 minute.
                \nMajor: You can as a standard action empower your flesh, granting you DR /- equal to half your level for 1 minute.`,
                extraRolls:"Gain a buff spell at 1st and every 4 levels",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, ["buff"])
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, ["buff"])
                        }
                    }
                },
            },
            {
                name:"Community",
                description:`Minor: You can touch an ally and grant it the blessing of community. For the next minute, whenever that ally uses the aid another action, the bonus granted increases to +4. You can instead use this ability on yourself as a swift action.
                \nMajor: You can rally your allies to fight together. For 1 minute, whenever you make a successful melee or ranged attack against a foe, allies within 10 feet of you gain a +2 insight bonus on attacks of the same type you made against that foe—melee attacks if you made a melee attack, or ranged attacks if you made a ranged attack. If you score a critical hit, this bonus increases to +4 until the start of your next turn.`,
                extraRolls:"Gain a teamwork feat at 2nd and every 6th level.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%6 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{teamwork:true}}))
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x == 2 || x%6 == 0){
                            context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{teamwork:true}}))
                        }
                    }
                },
            },
            {
                name:"Cooperation",
                description:`Minor: you can touch an ally and grant it the blessing of cooperation. Choose one teamwork feat that you have. The touched ally gains the benefit of the chosen teamwork feat for a number of rounds equal to 1/2 your level (minimum 1). Alternatively, you can choose one teamwork feat that a touched ally has and gain the benefit of the chosen feat for a number of rounds equal to 1/2 your level (minimum 1).
                \nMajor: You can rally your allies to fight together. For 1 minute, whenever you make a successful melee or ranged attack against a foe, allies within 10 feet of you gain a +2 insight bonus on attacks of the same type you made against that foe—melee attacks if you made a melee attack, or ranged attacks if you made a ranged attack. If you score a critical hit, this bonus increases to +4 until the start of your next turn.`,
                extraRolls:"Gain a teamwork feat at 2nd and every 6th level.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%6 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{teamwork:true}}))
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x == 2 || x%6 == 0){
                            context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{teamwork:true}}))
                        }
                    }
                },
            },
            {
                name:"Curse",
                description:`Minor: You can touch one weapon and enhance it to inflict a minor curse on the next target it strikes. The struck target must succeed at a Will saving throw or take a -2 penalty on attack rolls, saving throws, skill checks, or ability checks (warpriest‘s choice) for 1 minute.
                \nMajor: As a swift or immediate action, you can inflict a curse on any adjacent creature that scores a critical hit against you or deals precision damage to you. The target must succeed at a Will saving throw or be cursed. Select one of the following effects: the target takes a -2 penalty to one ability score of your choice (the ability cannot be reduced below 1); the target takes a -2 penalty on attack rolls, saving throws, ability checks, and skill checks; each turn, the target has a 25% chance of taking no action (otherwise, it acts normally). This curse lasts for 1 hour. A creature can be subjected to only one instance of retributive curse at a time. This otherwise functions as bestow curse.`,
                extraRolls:"Gain a control spell at 1st and every 4 levels",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, ["control"])
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, ["control"])
                        }
                    }
                },
            },
            {
                name:"Darkness",
                description:`Minor: You can touch an ally and bestow a darkness blessing. For 1 minute, the ally becomes enshrouded in shadows while in combat, granting it concealment (20%). Creatures that are normally able to see in supernatural darkness ignore this concealment.
                \nMajor: You can place a shroud of darkness around the eyes of one foe within 30 feet. The target must succeed at a Will saving throw or be blinded for 1 minute (as blindness/deafness).`,
                extraRolls:"Gain a control spell at 1st and every 4 levels",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, ["control"])
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, ["control"])
                        }
                    }
                },
            },
            {
                name:"Death",
                description:`Minor: You can take on a corpse-like visage for 1 minute, making you more intimidating and giving you undead-like protection from harm. You gain a +4 bonus on Disguise checks to resemble an undead creature and on Intimidate checks, as well as a +2 profane bonus on saving throws against disease, mind-affecting effects, paralysis, poison, and stun.
                \nMajor: You can make a melee touch attack against an opponent to deliver grim suffering. If you succeed, you inflict 1 temporary negative level on the target for 1 minute. Alternatively, you can activate this ability as a swift action upon hitting an opponent with a melee attack. These temporary negative levels stack. You gain no benefit from imposing these negative levels (such as the temporary hit points undead gain from enervation).`,
                extraRolls:"Gain +2 constitution at 1st, and an additional +1 every 4 levels",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        context.stats.characterStats.abilityScore.constitution += 1
                    }
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.abilityScore.constitution += 1
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x == 1 || x%4 == 0){
                            context.stats.characterStats.abilityScore.constitution += 1
                        }
                    }
                },
            },
            {
                name:"Destruction",
                description:`Minor: You can touch an ally and bless it with the power of destruction. For 1 minute, the ally gains a morale bonus on weapon damage rolls equal to half your level (minimum 1).
                \nMajor: You can touch an ally and bless it with even greater destructive power. For 1 minute, the ally gains a +4 insight bonus on attack rolls made to confirm critical hits and has a 50% chance to treat any critical hit or sneak attack against it as a normal hit.`,
                extraRolls:"Gain +2 strength at 1st, and an additional +1 every 4 levels",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        context.stats.characterStats.abilityScore.strength += 1
                    }
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.abilityScore.strength += 1
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x == 1 || x%4 == 0){
                            context.stats.characterStats.abilityScore.strength += 1
                        }
                    }
                },
            },
            {
                name:"Earth",
                description:`Minor: You can touch one weapon and enhance it with acidic potency. For 1 minute, this weapon emits acrid fumes that deal an additional 1d4 points of acid damage with each strike.
                \nMajor: You can touch an ally and harden its armor or clothing. For 1 minute, the ally gains DR 1/—. For every 2 levels beyond 10th, this DR increases by 1 (to a maximum of DR 5/— at 18th level). This doesn't stack with any other damage resistance or reduction.`,
                extraRolls:"Gain +2 constitution at 1st, and an additional +1 every 4 levels",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        context.stats.characterStats.abilityScore.constitution += 1
                    }
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.abilityScore.constitution += 1
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x == 1 || x%4 == 0){
                            context.stats.characterStats.abilityScore.constitution += 1
                        }
                    }
                },
            },
            {
                name:"Evil",
                description:`Minor: You can touch one weapon and give it an evil blessing. For 1 minute, this weapon takes on a black, orange, or violet cast and deals an additional 1d6 points of damage against good creatures. During this time, it's treated as evil for the purposes of overcoming damage reduction.
                \nMajor: You can summon a battle companion. This ability functions as summon monster IV with a duration of 1 minute, but for only an evil outsider or an animal with the fiendish creature simple template. This ability can summon only one creature, regardless of the list used. For every 2 levels beyond 8th, the level of the summon monster spell increases by 1 (to a maximum of summon monster IX at 20th level).`,
                extraRolls:"Gain a <dark> maneuver at 1st and every 4 levels. Every 6 levels you will gain a <dark> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Dark"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Dark"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Dark"], undefined, false)
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Dark"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Fire",
                description:`Minor: You can touch one weapon and enhance it with the grandeur of fire. For 1 minute, this weapon glows red-hot and deals an additional 1d4 points of fire damage with each hit.
                \nMajor: You can touch an ally to wreath it in flames. This works as fire shield spell (warm shield only) with a duration of 1 minute.`,
                extraRolls:"Gain a <fire> maneuver at 1st and every 4 levels. Every 6 levels you will gain a <fire> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Fire"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Fire"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Fire"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Fire"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Glory",
                description:`Minor: You can touch an ally and grant it a glorious blessing. For 1 minute, the ally becomes mesmerizing to her foes. This functions as sanctuary, except if the ally attacks an opponent, this effect ends with respect to only that opponent. This is a mind-affecting effect.
                \nMajor: When you successfully damage an opponent with a melee attack or attack spell, as a swift action you can attempt to demoralize that opponent with the Intimidate skill using your ranks in Intimidate or your warpriest level, whichever is higher.`,
                extraRolls:"Gain a <heroic> maneuver at 1st and every 4 levels. Every 6 levels you will gain a <heroic> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Heroic"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Heroic"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Heroic"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Heroic"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Godfist",
                description:`Minor: You can touch an ally and say a quick word to remind them of their obligations, granting them a new saving throw against each enchantment effect that currently affects them. If the saving throw is successful, the enchantment effect immediately ends. This power affects only effects that allow a saving throw.
                \nMajor: You can rally your allies within 30 feet, allowing each to immediately do one of the following as a free action that does not provoke attacks of opportunity: remove the flat-footed condition, take a 5-foot step, draw a weapon or shield, or gain a +1 dodge bonus to AC for 1 round. You can affect a number of allies equal to your highest mental bonus. These actions do not count against your allies' total movement or actions on their next turn.`,
                extraRolls:"At 2nd and every 8 levels you will gain a ki power.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%8 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"Perk",options:{sub:{kiPerks:true}}})) 
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%8 == 0 || x == 2){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"Perk",options:{sub:{kiPerks:true}}}))
                        }
                    }
                },
            },
            {
                name:"Good",
                description:`Minor: You can touch one weapon and bless it with the power of purity and goodness. For 1 minute, this weapon glows green, white, or yellow-gold and deals an additional 1d6 points of damage against evil creatures. During this time, it's treated as good for the purposes of overcoming damage reduction.
                \nMajor: You can summon a battle companion. This ability functions as summon monster IV with a duration of 1 minute, but for only a good outsider or an animal with the celestial creature simple template. This ability can summon only one creature, regardless of the list used. For every 2 levels beyond 8th, the level of the summon monster spell increases by 1 (to a maximum of summon monster IX at 20th level).`,
                extraRolls:"At 1st and every 4 levels you will gain a buff spell. You also gain +1 positive spell power per level.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, ["buff"])
                    }
                    context.stats.characterStats.spellMastery.spellPower.positive += 1
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, ["buff"])
                        }
                        context.stats.characterStats.spellMastery.spellPower.positive += 1
                    }
                },
            },
            {
                name:"Healing",
                description:`Minor: You can add power to a cure spell as you cast it. As a swift action, you can treat any cure spell as if it were empowered (as the Empower Spell feat), causing it to heal 50% more damage (or deal 50% more damage if used against undead).
                \nMajor: You can touch an ally and grant it fast healing 3 for 1 minute. Every 3 levels after 8th, the fast healing increases by 1 point.`,
                extraRolls:"At 1st and every 4 levels you will gain a healing spell. You also gain 2% positive spell critical chance and +1 positive spell power per level.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, ["healing"])
                    }
                    context.stats.characterStats.spellMastery.spellPower.positive += 1
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellCriticalChance.positive += 2
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, ["healing"])
                        }
                        context.stats.characterStats.spellMastery.spellPower.positive += 1
                    }
                },
            },
            {
                name:"Restoration",
                description:`Minor: Your touch is a balm to your suffering allies. You can touch an ally as a swift action to temporarily relieve that ally of the fatigued, shaken, or sickened condition. This blessing suppresses those conditions for 1 minute. At 2nd level, you can spend two uses of your blessing ability whenever you heal yourself or an ally with your fervor class ability to use this minor blessing as a free action instead of a swift action.
                \nMajor: You can touch an ally and grant it fast healing 3 for 1 minute. Every 3 levels after 8th, the fast healing increases by 1 point.`,
                extraRolls:"At 1st and every 4 levels you will gain a healing spell. You also gain 2% positive spell critical chance and +1 positive spell power per level.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, ["healing"])
                    }
                    context.stats.characterStats.spellMastery.spellPower.positive += 1
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellCriticalChance.positive += 2
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, ["healing"])
                        }
                        context.stats.characterStats.spellMastery.spellPower.positive += 1
                    }
                },
            },
            {
                name:"Resurrection",
                description:`Minor: You can add power to a cure spell as you cast it. As a swift action, you can treat any cure spell as if it were empowered (as the Empower Spell feat), causing it to heal 50% more damage (or deal 50% more damage if used against undead).
                \nMajor: Your touch can defy the cold claws of death itself. You can temporarily revive a touched ally to continue fighting, as if you had cast raise dead on them. The revived ally is also staggered for a number of rounds equal to 1/2 your level, after which they immediately die. The ally is free to act as they sees fit during this time, and you are granted no control over them.`,
                extraRolls:"At 1st and every 4 levels you will gain a healing spell. You also gain 4% positive spell critical chance.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, ["healing"])
                    }
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellCriticalChance.positive += 4
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, ["healing"])
                        }
                    }
                },
            },
            {
                name:"Knowledge",
                description:`Minor: When making a knowledge check, you can expend this ability as a free action to gain a bonus on the roll equal to your level.
                \nMajor: When you succeed at a Knowledge check against an opponent to learn about its abilities or weaknesses, you can as a swift action gain a +2 insight bonus on attacks, saving throws, and ability and skill checks, as well as to your AC against that creature. This effect lasts for 1 minute.`,
                extraRolls:"At 1st and every 3 levels you will gain a skill roll.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{skills:true}}}));
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%3 == 0 || x == 1){
                            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{skills:true}}}));
                        }
                    }
                },
            },
            {
                name:"Law",
                description:`Minor: You can touch one weapon and enhance it with the essence of law. For 1 minute, this weapon glows blue, pale yellow, or white and deals an additional 1d6 points of damage against chaotic creatures. During this time, it's treated as lawful for the purposes of overcoming damage reduction.
                \nMajor: You can summon a battle companion. This ability functions as summon monster IV with a duration of 1 minute, but for only a lawful outsider or an animal with the resolute creature simple template. This ability can summon only one creature, regardless of the list used. For every 2 levels beyond 8th, the level of the summon monster spell increases by 1 (to a maximum of summon monster IX at 20 level).`,
                extraRolls:"at 1st and every 4 levels you will gain a <guardian> maneuver. Every 6 levels you will gain a <guardian> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Guardian"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Guardian"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Guardian"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Guardian"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Liberation",
                description:`Minor: For 1 round as a swift action, you can ignore impediments to your mobility and effects that cause paralysis (as freedom of movement). You can activate this blessing even if you're otherwise unable to take actions, but not if you're unconscious.
                \nMajor: As a swift action you can emit a 30-foot aura that affects all allies with the liberation blessing described above. This effect lasts for 1 round.`,
                extraRolls:"at 1st and every 4 levels you will gain a <heroic> maneuver. Every 6 levels you will gain a <heroic> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Heroic"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Heroic"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Heroic"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Heroic"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Freedom",
                description:`Minor: For 1 round as a swift action, you can ignore impediments to your mobility and effects that cause paralysis (as freedom of movement). You can activate this blessing even if you're otherwise unable to take actions, but not if you're unconscious.
                \nMajor: when you use the minor freedom blessing ability, its effects last for 1 minute. These benefits are passive to the bonus of the minor freedom ability.`,
                extraRolls:"at 1st and every 4 levels you will gain a <heroic> maneuver. Every 6 levels you will gain a <heroic> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Heroic"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Heroic"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Heroic"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Heroic"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Luck",
                description:`Minor: You can touch an ally and grant it a lucky presence. The target of this luck can call upon it to roll any one ability check, attack roll, saving throw, or skill check twice and take the better result. The decision to use this ability must be made before the roll is made. Once used, or once 1 minute passes, the effect ends. Once used, the effect ends.
                \nMajor: As an immediate action you can force an adjacent opponent to reroll an attack, saving throw, or skill or ability check it just attempted; it must take the lower of the two rolls. You must declare this after the roll is made but before the result is revealed.`,
                extraRolls:"At 1st and every 4 levels you will gain a buff/utility spell. You gain 1% universal spell critical chance and 15% universal spell critical damage.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, ["buff", "utility"])
                    }
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellCriticalChance.universal += 1
                    context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 15
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, ["buff", "utility"])
                        }
                    }
                },
            },
            {
                name:"Madness",
                description:`Minor: As a swift action you can target a creature within 30 feet that has the cowering, frightened, panicked, or paralyzed condition. That condition is suspended for 1 round, and the chosen creature gains the confused condition instead. The confused creature rerolls any result other than “attack self” or “attack nearest creature.” The round spent confused counts toward the duration of the suspended effect. At the end of the confused round, the suspended condition resumes.
                \nMajor: As a swift action you can choose one behavior for all confused creatures within 30 feet to exhibit (as if all creatures rolled the same result). This effect lasts for 1 round. You can use this ability even while you are confused.`,
                extraRolls:"At 1st and every 4 levels you will gain a control spell. Gain a +1 bonus to the DC of your mind-affecting control spells.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, ["control"])
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, ["control"])
                        }
                    }
                },
            },
            {
                name:"Magic",
                description:`Minor: You can cause your melee weapon to fly from your grasp and strike an opponent, then instantly return to you. You can make a single attack using a melee weapon at a range of 30 feet. This attack is treated as a ranged attack with a thrown weapon, except that you add your highest mental modifier to the attack roll instead of your Dexterity modifier (you still add your Strength modifier to the damage roll as normal). This ability cannot be used to perform a combat maneuver.
                \nMajor: Reduce the cost of all spells by 3 spell points. This cannot reduce the cost of the spell below 0. This is a passive bonus and does not need to be activated.`,
                extraRolls:"At 1st and every 4 levels you will gain a spell. You gain an additional 1.5 spell points per level.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level)
                    }
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.misc.spPerLevel += 1.5
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x)
                        }
                    }
                },
            },
            {
                name:"Nobility",
                description:`Minor: You can speak a few words to a creature within 30 feet that fill them with inspiration. You can grant that creature a +2 morale bonus on attack rolls, ability checks, skill checks, or saving throws (your choice). This effect lasts for 1 minute.
                \nMajor: As a swift action you can inspire your allies to follow your lead. If the following action on your turn is an attack or skill check, all allies within 30 feet who take the same action against the same foe or obstacle on their next turn gain a +4 morale bonus on that roll.`,
                extraRolls:"At 1st and every 4 levels you will gain a <heroic> maneuver. Every 6 levels you will gain a <heroic> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Heroic"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Heroic"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Heroic"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Heroic"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Martyr",
                description:`Minor: You can speak a few words to a creature within 30 feet that fill them with inspiration. You can grant that creature a +2 morale bonus on attack rolls, ability checks, skill checks, or saving throws (your choice). This effect lasts for 1 minute.
                \nMajor: Your body can accept wounds meant for others you deem worthy. You can shoulder the wounds of an ally within 50 feet for 1 minute, and during this time, the ally is affected as if you had cast shield other spell on them (except with a range of 50 feet). You can have only one use of this ability active at a time; if you use this major blessing again, the previous use immediately expires.`,
                extraRolls:"At 1st and every 4 levels you will gain a healing spell. You will also gain 2% positive spell critical and +1 positive spell power per level, but only if you aren't healing yourself.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, ["healing"])
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, ["healing"])
                        }
                    }
                },
            },
            {
                name:"Anger",
                description:`Minor: Once per day, as an immediate action after you have been hit with a melee attack, you can make a melee attack against the creature that hit you. This melee attack is at your highest attack bonus.
                \nMajor: This power is gained at level 5 instead of 8. You gain the ability to rage like a barbarian, gaining a +4 morale bonus to strength and constitution, a +2 bonus on will saves, but a -2 penalty on armor class. You also cannot use any charisma, dexterity, or intelligence based skill checks (except acrobatics, fly, intimidate, and ride) and you cannot cast spells of the healing type, and all other spells except damage spells have their spell point cost doubled. Activating rage is a free action that cost 2 spell points, plus 2 more each turn to maintain.`,
                extraRolls:"At 1st and every 4 levels you will gain a <primal> maneuver. Every 6 levels you will gain a <primal> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Primal"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Primal"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Primal"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Primal"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Excommunication",
                description:`Minor: With a melee touch attack, you render a target silent (as the spell silence, but only affecting the target) for 1 round.
                \nMajor: Once per day, you can silence a creature within 30 feet as a standard action. A Will save against DC = 10 + 1/2 level + highest mental modifier negates the effect. A creature that fails its save gets a second save 1 round later. If it fails the second save, the target cannot speak, provide verbal components for spells, make use of language-dependent effects, write, pantomime, or take any other action meant to communicate anything more complex than a simple affirmative or negative for 1 day.`,
                extraRolls:"At 1st and every 4 levels you will gain a <curse> maneuver. Every 6 levels you will gain a <curse> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Curse"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Curse"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Curse"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Curse"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Execution",
                description:`Minor: Once per day as a swift action, you can designate a creature as your chosen victim. You gain a +2 bonus on all skill checks against the creature, and you gain a +1 sacred bonus on attack and damage against them. Every 4 levels both of these bonuses increases by +1.
                \nMajor: As a standard action you can activate this ability to make a single attack against your chosen victim. If the attack hits, it becomes an automatic critical threat.`,
                extraRolls:"At 1st and every 4 levels you will gain a <death> maneuver. Every 6 levels you will gain a <death> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Death"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Death"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Death"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Death"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Fervor",
                description:`Minor: You can unleash a gout of holy or unholy flame that sears one target within 30 feet as a ranged touch attack. The target takes 1d6 points of fire damage plus half your level (minimum +1). If you are good, the flames only harm non-good targets. If you are evil, the flames only harm non-evil targets. If you are neither good nor evil, when you gain this ability you must decide whether the flames harm only non-good or non-evil targets.
                \nMajor: As a swift action for level spell points you can make a single melee attack at your highest bonus or move up to your speed.`,
                extraRolls:"At 1st and every 4 levels you will gain a <light> maneuver. Every 6 levels you will gain a <light> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Light"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Light"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Light"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Light"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Imprisonment",
                description:`Minor: With a devastating weapon strike, spectral chains wrap around your target for a short period of time. Whenever you confirm a critical hit with a melee or ranged weapon attack (including spells that require attack rolls), you can choose to also entangle that target for 1d4 rounds (Fortitude negates). Activating this ability is a free action that you make when you confirm a critical hit.
                \nMajor: As a swift action upon making a successful melee attack, you can expend level spell points to affect your target with hold monster (Will negates).`,
                extraRolls:"At 1st and every 4 levels you will gain a <curse> maneuver. Every 6 levels you will gain a <curse> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Curse"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Curse"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Curse"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Curse"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Persistence",
                description:`Minor: As a swift action, you can add 10 feet to your land speed. This increase counts as an enhancement bonus, and it affects your jumping distance as normal for increased speed.
                \nMajor: As a swift action for level spell points, you may heal yourself 1d6 hit points per 2 levels. When you use this ability, you can also remove one of the following conditions from yourself: blinded, confused, dazzled, deafened, frightened, nauseated, shaken, sickened, or staggered.`,
                extraRolls:"At 1st and every 4 levels you will gain a <heroic> maneuver. Every 6 levels you will gain a <heroic> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Heroic"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Heroic"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Heroic"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Heroic"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Justice",
                description:`Minor: If you or an ally within 10 feet makes a critical threat with a melee or ranged attack, as an immediate action you may add +4 to the confirmation roll.
                \nMajor: For levelx2 spell points you can bind an opponent within 60 feet to you with spectral chains (Will negates). When you take damage from an enemy, the bound target takes this damage as well. Whenever the bound target takes damage from you or one of your allies, you take this damage as well. You and the target are not physically bound to each other, and either can end the connection by breaking the line of effect or exceeding the ability's range. You may dismiss the chains as a standard action.`,
                extraRolls:"At 1st and every 4 levels you will gain a <guardian> maneuver. Every 6 levels you will gain a <guardian> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Guardian"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Guardian"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Guardian"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Guardian"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Black Powder",
                description:`Minor: You reduce the action required to reload firearms by 1 step. This does not cost spell points.
                \nMajor: You reduce the action required to reload firearms by 1 step. This does not cost spell points.`,
                extraRolls:"Gain a Tempest Gale/Solar Wind maneuver every 3 levels.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["tempestGale", "solarWind"])
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%3 == 0 || x == 1){
                            getManeuver(context, x, ["tempestGale", "solarWind"])
                        }
                    }
                },
            },
            {
                name:"Conversion",
                description:`Minor: You use your Wisdom modifier instead of your Charisma modifier when making Bluff, Diplomacy, and Intimidate checks. This does not cost spell points.
                \nMajor: Once per day you may speak a word of divinely inspired wisdom that causes a single creature to switch its alliance to you. The target must be within line of sight and able to hear you. If he fails his Will save, he is affected by dominate person, except the duration is only 1 minute.`,
                extraRolls:"At 1st and every 4 levels you will gain a <control> spell. Gain a +1 bonus on the DC's of compulsion spells.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, ["control"])
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, ["control"])
                        }
                    }
                },
            },
            {
                name:"Damnation",
                description:`Minor: You can give a creature you can see within 60 feet one chance to avoid an eternity of suffering by ordering it to carry out any one simple action that would take no more than 1 round to complete. Good and neutral creatures that refuse become shaken for 1 round (Will negates), while evil creatures that obey gain a +2 morale bonus on all rolls and checks made for 1 round. This is a language-dependent, mind-affecting effect.
                \nMajor: Once per day as a standard action, you call forth an illusory fiend and order it to temporarily drag a living and sentient creature into an afterlife of pain and misery. This otherwise acts identically to phantasmal killer, except targets that fail their Fortitude saving throws become paralyzed for a number of rounds equal to 1d4 + your level instead of dying.`,
                extraRolls:"Gain a <dark> maneuver at 1st and every 4 levels. Every 6 levels you will gain a <dark> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Dark"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Dark"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Dark"], undefined, false)
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Dark"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Plant",
                description:`Minor: Upon hitting with a melee attack, as a swift action you cause the creature you hit to sprout entangling vines that attempt to hold it in place, entangling it for 1 round (Reflex negates).
                \nMajor: You can summon a battle companion. This ability functions as summon nature's ally IV, with a duration of 1 minute. This ability can summon only one animal, regardless of the list used, and the creature's type changes to plant instead of animal. For every 2 levels beyond 8th, the level of the summon nature's ally spell increases by 1, to a maximum of summon nature's ally IX at 20th level.`,
                extraRolls:"Gain an additional ability score roll at 1st and every 4 levels",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{abilityScore:true}}}));
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{abilityScore:true}}}));
                        }
                    }
                },
            },
            {
                name:"Protection",
                description:`Minor: You can gain a +1 sacred bonus on saving throws and a +1 sacred bonus to AC for 1 minute. The bonus increases to +2 at 8th level and +3 at 16th level.
                \nMajor: You can emit a 30-foot aura of protection for 1 minute. You and your allies within this aura gain resistance 10 against acid, cold, electricity, fire, and sonic. At 15th level, the energy resistance increases to 20.`,
                extraRolls:"At 1st and every 5 levels you will gain a random deflection bonus to your armor.",
                hasCustomMethod:true,
                catchUpMethod:(context, _, contextSelf)=>{
                    let bonus = [1,1,1,1,1,1,2,2,2,2,3,3,4]
                    contextSelf.shortDesc += `\n\nAdditional Deflection Bonuses Gained: ` 
                    let choices = []
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x == 1|| x%5 == 0){
                            for(let x = 0; x < 3; x++){
                                let option = bonus[Math.floor(Math.random()*bonus.length)]
                                choices[x] = {
                                    title:"+" + option,
                                    description:"",
                                    id:x,
                                    method:(() =>{
                                        contextSelf.shortDesc += `+` + option + `, `
                                        context.stats.statsForAbilities.ac.deflection += parseInt(option)
                                    })
                                }                
                            }
                            let custom = {title:"Protection Blessing Bonus Selection", options:choices}
                            context.customDialogArray.push(custom)
                        }
                    }  
                },
                customMethod:(context, _, contextSelf)=>{
                    if(context.stats.characterStats.misc.level%5 == 0){
                        let bonus = [1,1,1,1,1,1,2,2,2,2,3,3,4]
                        let choices = []
                        for(let x = 0; x < 3; x++){
                            let option = bonus[Math.floor(Math.random()*bonus.length)]
                            choices[x] = {
                                title:"+" + option,
                                description:"",
                                id:x,
                                method:(() =>{
                                    contextSelf.shortDesc += `+` + option + `, `
                                    context.stats.statsForAbilities.ac.deflection += parseInt(option)               
                                })
                            }                
                        }
                        let custom = {title:"Protection Blessing Bonus Selection", options:choices}
                        context.customDialogArray.push(custom)
                    } 
                },
            },
            {
                name:"Repose",
                description:`Minor: You can fill a living creature with lethargy by hitting it with a melee touch attack, causing it to become staggered for 1 round. If the target is already staggered, it falls asleep for 1 round instead. An undead creature that's touched is staggered for a number of rounds equal to your highest mental modifier (minimum 1).
                \nMajor: when using channel energy to heal living creatures, you can take a swift action on that same turn to also deal damage to undead creatures (as your channel energy ability). Undead take an amount of damage equal to half the amount healed, and can attempt the normal saving throw to halve this damage.`,
                extraRolls:"At 1st and every 4 levels you will gain a Silver Crane maneuver. Every 6 levels you will gain a <light> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["silverCrane"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Light"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["silverCrane"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Light"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Rune",
                description:`Minor: You can create a blast rune in any adjacent square. Any creature entering this square takes an amount of damage equal to 1d6 + 1/2 level. This rune deals either acid, cold, electricity, or fire damage, designated when you create the rune. The rune is invisible, and lasts a number of rounds equal to your level or until discharged. You cannot create a blast rune in a square occupied by another creature. This rune counts as a 1st-level spell for the purposes of dispelling.
                \nMajor: You can cast a spell into a magic weapon as if it had the spell storing weapon special ability. If the stored spell is not used within 10 minutes, it dissipates. You can use your fervor ability to cast spells into your weapon and combine it with this ability, even if they would not normally be valid spells for fervor, however the spell now must be a spell that can target the creature, and now targets and affects the creature.`,
                extraRolls:"Every 5 levels you will randomly gain either an armor or weapon enchantment.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%5 == 0){
                        if(Math.random() < 0.5){
                            context.connection.send(JSON.stringify({command:"requestRoll", type:"armor enchantment"}))
                        } else {
                            context.connection.send(JSON.stringify({command:"requestRoll", type:"weapon enchantment"}))
                        }
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%5 == 0){
                            if(Math.random() < 0.5){
                                context.connection.send(JSON.stringify({command:"requestRoll", type:"armor enchantment"}))
                            } else {
                                context.connection.send(JSON.stringify({command:"requestRoll", type:"weapon enchantment"}))
                            }
                        }
                    }
                },
            },
            {
                name:"Scalykind",
                description:`Minor: You can touch an ally as a standard action to grant it reptilian scales. For 1 minute, the ally gains a +1 enhancement bonus to its natural armor. At 4th level and every 4 levels thereafter, this bonus increases by 1
                \nMajor: As a standard action you can manifest venomous fangs for 1 minute. These fangs grant a bite attack that deals 1d4 points of damage. A successful bite also afflicts the opponent with a debilitating venom. The poison‘s save DC is equal to 10 + 1/2 level + your Constitution modifier.
                \nSerpent Venom (Ex) Bite—injury; save Fort negates; frequency 1/round for 4 rounds; effect 1d2 Con; cure 1 save.`,
                extraRolls:"At 1st and every 5 levels you will gain a random racial bonus to your natural armor.",
                hasCustomMethod:true,
                catchUpMethod:(context, _, contextSelf)=>{
                    let bonus = [1,1,1,1,1,1,2,2,2,2,3,3,4]    
                    contextSelf.shortDesc += `\n\nAdditional Natural Armor Bonuses Gained: ` 
                    let choices = []
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x == 1|| x%5 == 0){
                            for(let x = 0; x < 3; x++){
                                let option = bonus[Math.floor(Math.random()*bonus.length)]
                                choices[x] = {
                                    title:"+" + option,
                                    description:"",
                                    id:x,
                                    method:(() =>{
                                        contextSelf.shortDesc += `+` + option + `, `
                                        context.stats.statsForAbilities.ac.natural += parseInt(option)
                                    })
                                }                
                            }
                            let custom = {title:"Scalykind Blessing Bonus Selection", options:choices}
                            context.customDialogArray.push(custom)
                        }
                    }  
                },
                customMethod:(context, _, contextSelf)=>{
                    if(context.stats.characterStats.misc.level%5 == 0){
                        let bonus = [1,1,1,1,1,1,2,2,2,2,3,3,4]
                        let choices = []
                        for(let x = 0; x < 3; x++){
                            let option = bonus[Math.floor(Math.random()*bonus.length)]
                            choices[x] = {
                                title:"+" + option,
                                description:"",
                                id:x,
                                method:(() =>{
                                    contextSelf.shortDesc += `+` + option + `, `
                                    context.stats.statsForAbilities.ac.natural += parseInt(option)            
                                })
                            }                
                        }
                        let custom = {title:"Scalykind Blessing Bonus Selection", options:choices}
                        context.customDialogArray.push(custom)
                    } 
                },
            },
            {
                name:"Strength",
                description:`Minor: As a swift action you can focus your own strength. You gain an enhancement bonus equal to 1/2 level (minimum +1) on melee attack rolls, combat maneuver checks that rely on Strength, Strength-based skills, and Strength checks for 1 round. This doesn't stack with weapon enchantments.
                \nMajor: As a swift action you can ignore the movement penalties caused by wearing medium or heavy armor or by carrying a medium or heavy load. This effect lasts for 1 minute. During this time, you can add your Strength modifier on saving throws against effects that would cause you to become entangled, staggered, or paralyzed.`,
                extraRolls:"At 1st level you will gain a +2 bonus to strength. Every 4 levels you will gain an additional +1.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        context.stats.characterStats.abilityScore.strength += 1
                    }
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.abilityScore.strength += 1
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x == 1 || x%4 == 0){
                            context.stats.characterStats.abilityScore.strength += 1
                        }
                    }
                },
            },
            {
                name:"Sun",
                description:`Minor: You can create a flash of sunlight in the eyes of one of your opponents. The target is blinded for 1 round. If it succeeds at a Reflex saving throw, it's instead dazzled for 1 round. Creatures with light blindness or light sensitivity take a -4 penalty on this saving throw. This is a light effect. Sightless creatures are unaffected by this ability.
                \nMajor: You can touch a weapon and grant it either the flaming or undead-bane weapon special ability for 1 minute. If you spend two uses of your blessing when activating this ability, the weapon can have both weapon special abilities.`,
                extraRolls:"At 1st and every 4 levels you will gain a <fire> maneuver. Every 6 levels you will gain a <fire> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Fire"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Fire"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Fire"], undefined, false)
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Fire"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Travel",
                description:`Minor: As a swift action you gain increased mobility. For 1 round, you ignore all difficult terrain (including magical terrain) and take no penalties for moving through it.
                \nMajor: You can teleport up to 20 feet as a move action. You can increase this distance by expending another use of your blessing—each use spent grants an additional 20 feet. You must have line of sight to your destination. This teleportation doesn't provoke attacks of opportunity. You can bring other willing creatures with you, but each such creature requires expending one additional use of your blessing, regardless of the distance traveled. (For example, transporting yourself 40 feet costs 2 uses of your blessing, and transporting an additional person this distance costs 1 more use.)`,
                extraRolls:"At 1st and every 5 levels you will gain a random stacking enhancement to your movement speed.",
                hasCustomMethod:true,
                catchUpMethod:(context, _, contextSelf)=>{
                    let bonus = [5,5,5,5,5,5,10,10,10,15,15,20]    
                    contextSelf.shortDesc += `\n\nAdditional Movement Speed Bonuses Gained: ` 
                    let choices = []
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x == 1|| x%5 == 0){
                            for(let x = 0; x < 3; x++){
                                let option = bonus[Math.floor(Math.random()*bonus.length)]
                                choices[x] = {
                                    title:"+" + option,
                                    description:"",
                                    id:x,
                                    method:(() =>{
                                        contextSelf.shortDesc += `+` + option + `, `
                                    })
                                }                
                            }
                            let custom = {title:"Travel Blessing Bonus Selection", options:choices}
                            context.customDialogArray.push(custom)
                        }
                    }  
                },
                customMethod:(context, _, contextSelf)=>{
                    if(context.stats.characterStats.misc.level%5 == 0){
                        let bonus = [5,5,5,5,5,5,10,10,10,15,15,20]
                        let choices = []
                        for(let x = 0; x < 3; x++){
                            let option = bonus[Math.floor(Math.random()*bonus.length)]
                            choices[x] = {
                                title:"+" + option,
                                description:"",
                                id:x,
                                method:(() =>{
                                    contextSelf.shortDesc += `+` + option + `, `            
                                })
                            }                
                        }
                        let custom = {title:"Travel Blessing Bonus Selection", options:choices}
                        context.customDialogArray.push(custom)
                    } 
                },
            },
            {
                name:"Trickery",
                description:`Minor: As a move action you can create an illusory double of yourself. This double functions as a single mirror image, and lasts for a number of rounds equal to your level, or until the illusory duplicate is dispelled or destroyed. You can have no more than one double at a time. The double created by this ability doesn't stack with the additional images from the mirror image spell.
                \nMajor: As a swift action you can become invisible for 1 round (as greater invisibility spell).`,
                extraRolls:"You gain a <shadow> maneuver every 4 levels. Every 6 levels you will gain a <shadow> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Shadow"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Shadow"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Shadow"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Shadow"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Void",
                description:`Minor: With a successful melee touch attack you can steal the breath from an opponent's lungs, leaving it unable to speak, use breath weapons, cast spells with verbal components, or do anything else requiring breath for 1 round. If the target fails at a Fortitude saving throw, it's also staggered for 1 round as it catches its breath. If the target was attempting to hold its breath, it can no longer do so: it must breathe on its turn or risk suffocation and unconsciousness. Creatures that don't need to breathe are unaffected. Regardless of whether it succeeds at its saving throw, the target is immune to further uses of your airless touch for 24 hours.
                \nMajor: As a standard action you can touch an ally to allow them to ignore the effects of gravity for 1 minute (as fly spell). The ally gains a fly speed of 40 feet with average maneuverability. The ally is also immune to dangerous environmental conditions (as life bubble) for 1 minute.`,
                extraRolls:"You gain a <void> maneuver every 4 levels. Every 6 levels you will gain a <void> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Void"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Void"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Void"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Void"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"War",
                description:`Minor: You can touch an ally and grant it a tactical advantage for 1 minute. At the start of its turn each round, it can select one of the following bonuses: +10 feet to base land speed, +1 dodge bonus to AC, +1 insight bonus on attack rolls, or a +1 luck bonus on saving throws. Each bonus selected lasts for 1 round.
                \nMajor: You can touch an ally and grant it a thirst for battle. All of the ally's melee attacks are treated as if they had the vicious weapon special ability, but the additional damage dealt to the ally from that special ability is nonlethal. In addition, the ally receives a +4 insight bonus on attack rolls made to confirm critical hits. These benefits last for 1 minute.`,
                extraRolls:"Gain +1 BAB, +1 every 4 levels.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        context.stats.characterStats.misc.BAB += 1
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0){
                            context.stats.characterStats.misc.BAB += 1
                        }
                    }
                },
            },
            {
                name:"Water",
                description:`Minor: You can touch one weapon and enhance it with the power of water. For 1 minute, this weapon glows with a blue-white chill and deals an additional 1d4 points of cold damage with each strike.
                \nMajor: You can touch any one ally and wreath it in freezing mist. This works as fire shield spell (chill shield only) with a duration 1 minute.`,
                extraRolls:"You gain a <water> maneuver at 1st and every 4 levels. Every 6 levels you will gain a <water> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Water"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Water"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Water"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Water"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Storm",
                description:`Minor: You can touch one weapon and grant it a blessing of stormy weather. For 1 minute, this weapon glows with blue or yellow sparks and deals an additional 1d4 points of electricity damage with each hit.
                \nMajor: You can create a barrier of fast winds around yourself for 1 minute. This acts as a wind wall on all sides of your square, protects you with feather fall, and doesn't interfere with your ranged attacks.`,
                extraRolls:"At 1st and every 4 levels you will gain a air/electricity spell. You gain a +1 bonus to electricity spell power per level, and 2% electricity spell critical chance.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, undefined, ["air", "electricity"])
                    }
                    context.stats.characterStats.spellMastery.spellPower.electricity += 1
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellCriticalChance.electricity += 2
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, undefined, ["air", "electricity"])
                        }
                        context.stats.characterStats.spellMastery.spellPower.electricity += 1
                    }
                },
            },
            {
                name:"Earthquake",
                description:`Minor: You can touch an ally to bless it with the stalwart resilience of stone. For 1 minute, the creature gains a +4 bonus to its CMD against maneuvers that would move the ally or knock it prone.
                \nMajor: You can touch a weapon to bless it with the force of a mighty earthquake for 1 minute. When the weapon hits a creature, the target must succeed at a Reflex save or fall prone; either way, the creature is immune to this ability for 24 hours.`,
                extraRolls:"At 1st and every 4 levels you will gain a earth/acid spell. You gain a +1 bonus to acid spell power per level, and 2% acid spell critical chance.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, undefined, ["earth", "acid"])
                    }
                    context.stats.characterStats.spellMastery.spellPower.acid += 1
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellCriticalChance.acid += 2
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, undefined, ["earth", "acid"])
                        }
                        context.stats.characterStats.spellMastery.spellPower.acid += 1
                    }
                },
            },
            {
                name:"Flood",
                description:`Minor: You can touch an ally to bless it with additional mobility in water, gaining a swim speed equal to their base land speed.
                \nMajor: When you are hit by a melee attack, you can invoke this blessing as an immediate action. A wave of water blasts out from you at your attacker, attempting a bull rush combat maneuver check using your CMB but adding your highest mental modifier instead of your Strength modifier.`,
                extraRolls:"At 1st and every 4 levels you will gain a water/cold spell. You gain a +1 bonus to cold spell power per level, and 2% cold spell critical chance.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, undefined, ["water", "cold"])
                    }
                    context.stats.characterStats.spellMastery.spellPower.cold += 1
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellCriticalChance.cold += 2
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, undefined, ["water", "cold"])
                        }
                        context.stats.characterStats.spellMastery.spellPower.cold += 1
                    }
                },
            },
            {
                name:"Tornado",
                description:`Minor: When you hit with a weapon attack, you can use a swift action to cause a sudden burst of wind and debris to swirl around your target. The target is dazzled for 1 minute.
                \nMajor: You can invoke a howling windstorm around yourself as a standard action. For 1 minute, any Large or smaller creature takes twice as much movement to enter a space adjacent to you due to the winds, and thus can't take a 5-foot step to move adjacent to you.`,
                extraRolls:"At 1st and every 4 levels you will gain a air/electricity spell. You gain a +1 bonus to your electricity spell power per level, and 2% electricity spell critical chance.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getSpell(context, context.stats.characterStats.misc.level, undefined, ["air", "electricity"])
                    }
                    context.stats.characterStats.spellMastery.spellPower.electricity += 1
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellCriticalChance.electricity += 2
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getSpell(context, x, undefined, ["air", "electricity"])
                        }
                        context.stats.characterStats.spellMastery.spellPower.electricity += 1
                    }
                },
            },
            {
                name:"Wildfire",
                description:`Minor: You touch an ally to bless it with the speed of a wildfire for 1 minute. The ally gains a +10-foot enhancement bonus to its base speed, and the ally gains a +1 dodge bonus to its AC against attacks of opportunity.
                \nMajor: When you move, you can use a swift action to invoke a blazing blessing on yourself. For the rest of your turn, your movement leaves behind a 10-foot-tall wall of opaque fire in your path. The wall burns for 1 minute. A creature that touches the wall takes 2d6 points of fire damage.`,
                extraRolls:"You gain a <fire> maneuver at 1st and every 4 levels. Every 6 levels you will gain a <fire> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Fire"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Fire"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Fire"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Fire"], undefined, true)
                        }
                    }
                },
            },
            {
                name:"Shadow",
                description:`Minor: You can cause a weapon you touch to warp and become insubstantial for a split second before an attack. The first attack made with this weapon each round ignores any shield bonus to Armor Class, as well as bonuses from cover. Total cover still provides a creature its full benefit. This effect lasts for 1 minute.
                \nMajor: You can spend a swift action to empower yourself or an ally within 30 feet to move over the ground as easily as its shadow. The subject's land speed increases by 10 feet and it takes no movement penalties for darkness, difficult terrain, or slickness. The creature can safely move over areas of ice and even those affected by a grease spell. When a creature affected by this ability hits with a charge attack, that attack deals an amount of additional cold damage equal to your level. This bonus lasts 1 round`,
                extraRolls:"You gain a <shadow> maneuver at 1st and every 4 levels. Every 6 levels you will gain a <shadow> finisher.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Shadow"])
                    }
                    if(context.stats.characterStats.misc.level%6 == 0){
                        getManeuver(context, context.stats.characterStats.misc.level, ["Shadow"], undefined, true)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0 || x == 1){
                            getManeuver(context, x, ["Shadow"])
                        }
                        if(x%6 == 0){
                            getManeuver(context, x, ["Shadow"], undefined, true)
                        }
                    }
                },
            },
        ]
    },
    {
    rarity: "unique",
    type: "magic",
    name: "Channel Energy",
    fromClass:"Cleric",
    shortDesc: `When you select this ability choose either positive or negative energy, this choice cannot be changed. For 2 spell point per dice rolled you can as a standard action channel energy causing a burst that affects all creatures of one type (either undead or living) in a 30-foot radius centered on you. The amount of damage dealt or healed is equal to 1d6 + highest mental, increasing by 1d6 every odd level after first, and scales with positive/negative spell power. A creature affected can make a will save DC is 10 + level/2 + highest mental stat to reduce the damage by half, and negate any status that would be placed on them.
    \nAt 3rd level while channeling for an additional 3 spell points you can choose to remove 1 status from 1 target that will be affected by your channel, or if you select negative energy you can attempt to inflict them with a status, including fatigued, shaken, or sickened
    \nAt 6th for 6 spell points you can cure dazed, diseased, staggered, or restore 1d4 points of ability score damage.
    \nAt 9th for 9 spell points you can cure confused, cursed, exhausted, frightened, nauseated, poisoned, or grant fast healing 3 for your level/2 rounds (or bleed of an equal amount). Additionally, you can now cure statuses from 2 targets, but you must pay the cure costs seperately
    \nAt 12th for 12 spell points you can cure blinded, deafened, paralyzed, petrified, stunned, or cast dispel magic on affected target, or effect them with restoration
    \nAt 15th for 15 spell points you can affect them with greater restoration or bestow a negative level, and you can affect 3 targets at once, and if you restore statuses from at least 2 people at once the cheaper one is free (if they are the same cost neither is free)
    \nAt 20th reduce the cost of adding a restorative effect by 3 spell points, and you can pay to effect up to 4 targets at once.
    \n\nGain 2 cleric domains.
    \nGain 2 spell power per level and 2% spell critical chance (both of your type). You lose 25 spell power and 4% spell critical chance of your opposite type.
    \nGain 2 additional spell points per level`,
    hasCustomMethod:true,
    customMethod: (context, _, contextSelf)=>{
        context.doNothing = "donothing"
        context.stats.characterStats.spellMastery.spellPower[contextSelf.chosenType] += 2
    },
    catchUpMethod: (context, _, contextSelf)=>{
        context.stats.characterStats.misc.spPerLevel += 2
        let perk = perks.find(perk => perk.name == "Cleric Domain")
        let pushedPerk = JSON.parse(JSON.stringify(perk))
        pushedPerk.id = Math.random()
        context.stats.lists.perks.push(pushedPerk)
        perk.catchUpMethod(context, perk, pushedPerk, 2)

        let choices = []
        let options = ["positive","negative"]
        for(let x = 0; x < 2; x++){
            choices[x] = {
                title:options[x],
                id:x,
                method:(() =>{
                    contextSelf.chosenType = options[x]
                    contextSelf.shortDesc += `\n\nChosen Type: ` + options[x]
                    context.stats.characterStats.spellMastery.spellCriticalChance[options[x]] += 2
                    for(let y = 1; y < context.stats.characterStats.misc.level; y++){
                        context.stats.characterStats.spellMastery.spellPower[options[x]] += 2
                    }
                    context.stats.characterStats.spellMastery.spellPower[options[1-x]] -= 25
                    context.stats.characterStats.spellMastery.spellCriticalChance[options[1-x]] -= 4
                })
            }
            context.customDialogArray.push({title:"Choose Type", options:choices})
        }    
    },
    chosenType:"",
    hasSpecialItems:true,
    getSpecialItemList:()=>{
        let newList = []
        let domainList = perks.find(perk => perk.name == "Cleric Domain").domains
        domainList.forEach(domain=>{
            let newItem = {name:domain.name, description:domain.description + `\n\nWhen getting a domain you will pick a minor and major power`}
            newList.push(newItem)
            domain.perk1.forEach(perk=>{
                let newSub = {name:"->" + domain.name + " Minor: "+ perk.name, description:perk.description}
                newList.push(newSub)
            })
            domain.perk2.forEach(perk=>{
                let newSub = {name:"->->" + domain.name + " Major: "+ perk.name, description:perk.description}
                newList.push(newSub)
            })
        })             
        return newList
    },    
    },
    {
        rarity: "unique",
        type: "magic",
        name: "Summoning",
        fromClass:"Summoner",
        shortDesc: `Whenever you gain a spell of a level you also gain the summon monster spell of that level as well. When you use a summon spell that summons one or more creatures, the casting action becomes 1 full-round action if this would be shorter, and it lasts 1 minute per level instead of 1 round per level. You can only have 3 summon spells from this perk active at once.
        \n\nAdditionally, at 1st level you will pick a summoner focus:
        \nMaster Summoner: Casting a conjuration(summoning) spell has its action reduced to a standard action. Your summoned creatures gain a competence bonus to their attack and damage rolls equal to half your highest mental modifier. Every odd level you will gain a summoning perk and every 4 levels you will gain an evolution. You can have 5 summon spells from this perk active at once. 
        \nEvolutionist: Casting a conjuration(summoning) spell has its action reduced to a full-round action. You gain an evolution every odd level, an evolution perk every 3 levels, the ability to surge your evolutions, and a summoning perk every 4 levels.
        \nSynthesist: When you summon a monster you can choose to synthesis summon it, allowing you to fuse with it and gain some of its abilities. You gain an evolution at 1st and every 3 levels and the ability to surge your evolutions, but you can only apply your evolutions to yourself. You also gain a synthesist perk at 1st and every 3rd level. A fused creature counts as a summon spell active for this perk.

        \nEvolutions: Evolutions are summoned ectoplasm that you fuse to a creature permanently. When you select an evolution perk you will also select a teammate (you included) to gain that evolution. The evolution is permanent and otherwise acts as part of their body. Because these evolutions requires your magic to function, you must maintain all evolutions at the start of your turn as a purely mental free action, this means you can also choose not to maintain an evolution (unless it specifies you cannot). If you gain an evolution that grants you a natural attack that you already have, you can choose to not gain that natural attack and instead increase the existing natural attack by 1 dice step (choose 1 if you have multiple of those natural attacks). This can even be done multiple times with one evolution if it grants multiple natural attacks. If you do so, their surges apply to the augmented natural attack. You can as a full-round action reform all natural attack evolutions, whether on yourself or others, changing any choices you made when they were given. You make all choices related to the evolutions, even if given to allies. Evolutions continue to function if the ally is fused to a summon or polymorphs shape
        \n\nGain 1 additional spell points per level`,
        hasCustomMethod:true,
        customMethod: (context, self, contextSelf)=>{
            if(contextSelf.typeChosen == "Master Summoner") self.focuses[0].customMethod(context,self,contextSelf)
            else if (contextSelf.typeChosen == "Evolutionist") self.focuses[1].customMethod(context,self,contextSelf)
            else if (contextSelf.typeChosen == "Synthesist") self.focuses[2].customMethod(context,self,contextSelf)
        },
        catchUpMethod: (context,self, contextSelf)=>{
            self.getFocus(context, self, contextSelf)
            context.stats.characterStats.misc.spPerLevel += 2
        },
        getEvolution(context, self, data, evolutionsLeft, hasSurge, isSynth){
            if(!isSynth && !data.data){
                data = JSON.parse(data)
            }
            if(data.command == "playerNames" || isSynth){
                if(!isSynth){
                    context.connection.removeListener("summoning")
                }                    
                let evolutions = []
                if(isSynth) evolutions = self.summonerPerks.filter(perk=> perk.type.includes("synthesis"))
                else evolutions = self.summonerPerks.filter(perk=> perk.type.includes("evolution"))
                let evolutionTypes = ["natural attack","natural attack","natural attack","universal","universal","universal","limb"]
                let choices = []
                let chosen = []
                for(let x = 0; x < 4; x++){
                    let type = evolutionTypes[Math.floor(Math.random()*evolutionTypes.length)]
                    let typeFiltered = evolutions.filter(evolution => evolution.subType == type)
                    let possible = Math.floor(Math.random()*typeFiltered.length)
                    while(chosen.includes(possible)){
                        type = evolutionTypes[Math.floor(Math.random()*evolutionTypes.length)]
                        typeFiltered = evolutions.filter(evolution => evolution.subType == type)
                        possible = Math.floor(Math.random()*typeFiltered.length)
                    } 
                    chosen.push(possible)
                    let option = typeFiltered[possible]
                    let description = `[` + option.subType + `]\n` + option.description
                    if(hasSurge){description += `\n\nSurge:\n` + option.surge}
                    choices[x] = {
                        title:option.name,
                        description:description,
                        id:x,
                        method:(() =>{
                            let perk = {rarity:"unique", name:option.name, shortDesc:description, id:Math.random()*1000000, type:"universal", uiType:"perk",hasCustomMethod:option.hasCustomMethod}
                            if(option.abilityType) perk.abilityType = option.abilityType
                            if(hasSurge) perk.additionalInfoTags = ["Surge"]

                            if(isSynth){
                                context.stats.lists.perks.push(perk)
                                if(evolutionsLeft > 1){
                                    evolutionsLeft-=1
                                    self.getEvolution(context, self, data, evolutionsLeft, hasSurge, isSynth)
                                }
                            }else{
                                self.chooseRecipient(context, self, data, evolutionsLeft, hasSurge, perk)
                            }
                           
                        })
                    }                
                }
                let custom = {title:"Evolution Choice", options:choices}
                context.customDialogArray.push(custom)


            }
        },
        chooseRecipient(context, self, data, evolutionsLeft, hasSurge, perk){
            let choices = []
            for(let x = 0; x < data.data.length; x++){
                let choice = {
                    title:data.data[x],
                    id:x,
                    method:(()=>{
                        let perkHold = JSON.parse(JSON.stringify(perk))
                        let perkSend = JSON.parse(JSON.stringify(perk))
                        perkSend.shortDesc =`Got From: ` + context.name + `\n\n` + perkSend.shortDesc
                        if(data.data[x] != context.name){
                            perkHold.shortDesc = `Sent To: ` + data.data[x] + `\n\n` + perkHold.shortDesc 
                            context.stats.lists.perks.push(perkHold)
                        }

                        let target = data.data[x]

                        let message={command:"sendPerk", target:target, perk:perkSend}
                        context.connection.send(JSON.stringify(message))
                        if(evolutionsLeft > 1){
                            evolutionsLeft-=1
                            self.getEvolution(context, self, data, evolutionsLeft, hasSurge, false)
                        }
                    })
                }
                choices.push(choice)                    
            }
            let custom = {title:"Evolution Recipient Choice", options:choices}
            context.customDialogArray.splice(1, 0, custom)
        },

        getSummonerPerk(context, self, perkTypes){
            let summoningPerks = self.summonerPerks.filter(perk=> perk.type.includes(perkTypes))
            let choices = []
            let chosen = []
            for(let x = 0; x < 4; x++){
                let possible = Math.floor(Math.random()*summoningPerks.length)
                while(chosen.includes(possible)) possible = Math.floor(Math.random()*summoningPerks.length)
                chosen.push(possible)
                let option = summoningPerks[possible]
                choices[x] = {
                    title:option.name,
                    description:option.description,
                    id:x,
                    method:(() =>{
                        let perk = {rarity:"unique", name:option.name, shortDesc:option.description, id:Math.random()*1000000, type:"universal", uiType:"perk"}
                        context.stats.lists.perks.push(perk)
                    })
                }                                                        
            }
            let custom = {title:"Summoning Perk Choice", options:choices}
            context.customDialogArray.push(custom)
        },
        getFocus(context, self, contextSelf){
            let choices = []
            for(let x = 0; x < 3; x++){
                let option = self.focuses[x]
                choices[x] = {
                    title:option.name,
                    description:option.description,
                    id:x,
                    method:(() =>{
                        contextSelf.shortDesc += `\n\nFocus Chosen: ` + option.name + `\n` + option.description
                        option.catchUpMethod(context,self)
                        contextSelf.typeChosen = option.name
                    })
                }                
            }
            let custom = {title:"Summoning Focus Choice", options:choices}
            context.customDialogArray.push(custom)

        },

        focuses: [
            {
                name:"Master Summoner",
                type:["Base Choice"],
                description:`Your summoned creatures gain a competence bonus to their attack and damage rolls equal to half your highest mental modifier.
                \nEvery odd level you will gain a summoning perk, and every 4 levels you will gain an evolution.
                \nWhen you enter a floor you start with a single summoned creature. It must be from a list 1 level lower than your highest level of spell known. This costs twice the normal spell points to summon.`,
                customMethod:(context, self)=>{
                    if(context.stats.characterStats.misc.level%2 == 1){
                        self.getSummonerPerk(context, self,"summoning")
                    }
                    if(context.stats.characterStats.misc.level%4 == 0){
                        let newMethod = (data) => {self.getEvolution(context, self, data, 1, false, false)}
                        context.connection.addListener("summoning", newMethod)
                        context.connection.send(JSON.stringify({command:"getPlayerNames"}))
                    }
                },
                catchUpMethod:(context, self)=>{
                    let evolutionsLeft = Math.floor(context.stats.characterStats.misc.level/4)
                    let newMethod = (data) => {self.getEvolution(context, self, data, evolutionsLeft, false, false)}
                    context.connection.addListener("summoning", newMethod)
                    context.connection.send(JSON.stringify({command:"getPlayerNames"}))

                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%2 == 1){
                            self.getSummonerPerk(context, self,"summoning")
                        }
                    }
                },
            },
            {
                name:"Evolutionist",
                type:["Base Choice"],
                description:`You gain an evolution every odd level, an evolutionist perk every 3 levels, the ability to surge your evolutions, and a summoning perk every 4 levels.
                \nEvolution Surge: You can surge evolutions, causing them to take on more powerful effects. Unless specified otherwise, doing so is a swift action and costs level/2 spell points. You can surge only a single evolution at a time, and never surge the same evolution multiple times at once, even if a creature has the same evolution multiple times. Only you can surge evolutions, not the ally that has the evolutions on them, and you can do so from anywhere, which only requires a mental action.
                \nWhen you enter a floor you can surge a single evolution on an ally and yourself. This costs spell points as normal. You can also rework all natural attack evolutions at the start of every floor.`,
                customMethod:(context, self)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        self.getSummonerPerk(context, self,"summoning")
                    }
                    if(context.stats.characterStats.misc.level%3 == 0){
                        self.getSummonerPerk(context, self,"evolution perk")
                    }
                    if(context.stats.characterStats.misc.level%2 == 1){
                        let newMethod = (data) => {self.getEvolution(context, self, data, 1, true, false)}
                        context.connection.addListener("summoning", newMethod)
                        context.connection.send(JSON.stringify({command:"getPlayerNames"}))
                    }
                },
                catchUpMethod:(context, self)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%4 == 0){
                            self.getSummonerPerk(context, self,"summoning")
                        }
                        if(context.stats.characterStats.misc.level%3 == 0){
                            self.getSummonerPerk(context, self, "evolution perk")
                        }
                    }
                    let evolutionsLeft = Math.ceil(context.stats.characterStats.misc.level/2)
                    let newMethod = (data) => {self.getEvolution(context, self, data, evolutionsLeft, true, false)}
                    context.connection.addListener("summoning", newMethod)
                    context.connection.send(JSON.stringify({command:"getPlayerNames"}))
                },
            },
            {
                name:"Synthesist",
                type:["Base Choice"],
                description:`You gain the ability to synthesis summon: When you cast a conjuration(summoning) spell that summons a single creature, you can choose for that creature to instead be summoned and fused to you as an ectoplasmic form that surrounds your body. Doing this reduces the spell to only be a standard action, and the spell becomes a personal ranged spell. You can only have a single fused summon at a time and creating a new one ends the previous fused summon. When you do this, the creature is not summoned normally, and instead:
                \nYou gain temporary hit points equal to the hit points the creature would have been summoned with, and the creature starts with maximum hit points per dice, instead of average. Once these temporary hit points are expended, the spell ends.
                \nYou can use the summoned creatures natural attacks, you may choose whether to use the creatures strength and dexterity scores, or your own, whichever you prefer. You also replace your movement types with theirs. You can still use your weapons as long as the fused creature has arms that could wield them, but their damage does not increase based on the fused creature's size. This fusion also does not cause you to be unable to cast spells.
                \nYou gain the benefits of the creature's defenses in place of your own. This includes armor, natural armor, damage reduction, elemental resistances and immunities, spell resistance, and any protections they have against physical conditions (such as bleed or stun). This does not give you any resisitances to purely mental effects, such as fear or charm.
                \nAny ability or effect that would have additional effects against the fused creature now also work against you, this means spells like protection from evil/good/chaos/law can stop you from making bodily contact with creatures (depending on the summoned creatures alignment), though spells like dismissal only send the summoned creature back to its home plane, and the spell ends. You still count as your original type, and abilities that would have specific effects against you still work on you as normal. Effectively you take the worst results of both of the creatures. 
                
                \nYou are still able to use your evolutions while in synthesis with a monster. You gain an evolution every odd level, and the ability to surge your evolutions, however you can only apply your evolutions to yourself. You also gain a synthesist perk at 1st and every 3rd level.                    
                \nEvolution Surge: You can surge evolutions, causing them to take on more powerful effects. Unless specified otherwise, doing so is a swift action and costs level/2 spell points. You can never surge the same evolution multiple times at once, even if a creature has the same evolution multiple times.
                \nWhen you enter a floor you can immediately synthesis summon as a free action you can take even when not your turn.`,
                customMethod:(context,self,)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        self.getSummonerPerk(context, self,"synthesis perk")
                    }
                    if(context.stats.characterStats.misc.level%2 == 1){
                        self.getEvolution(context, self, {}, 1, true, true)
                    }
                },
                catchUpMethod:(context, self)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%3 == 0 || x == 1){
                            self.getSummonerPerk(context, self,"synthesis perk")
                        }
                    }
                    let evolutionsLeft = Math.floor(context.stats.characterStats.misc.level/3) + 1
                    self.getEvolution(context, self, {}, evolutionsLeft, true, true)
                },
            },
        ],

        hasSpecialItems:true,
        getSpecialItemList:(self)=>{
            let allPerks = self.focuses.concat(self.summonerPerks)
            let perks = allPerks.map(perk =>{
                if(perk.type.includes("evolution")){
                    perk.description += `\n\nSurge:\n` + perk.surge
                }
                return perk
            })
            return perks
        },
        
        summonerPerks:[
            {
                name:"Magic Imbument",
                type:["evolution"],
                subType:"universal",
                description:`At the start of each floor, the summoner grants the evolved target the ability to cast one of their spells as if they were on their spell list. They cannot burn or otherwise unlearn this spell.`,
                surge:`You replace the granted spell with a different one of the same level or lower. This surge is a movement action and costs spell points equal to 2x the level of the spell you are trading for. Alternatively, as a standard action you can replace it with a spell of a higher level, but it now costs 4 times the level of the spell you are trading for.`
            },
            {
                name:"Energy Link",
                type:["evolution"],
                subType:"universal",
                description:`The evolved ally can spend up to your highest mental modifier of spell points from your spell point pool each round.`,
                surge:`The creature can spend up to your level spell points this round, and each time it spends spell points it reduces the cost by 1 point. This cannot reduce the cost below 1 spell point.`
            },
            {
                name:"Bite",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The allies mouth becomes a primary bite attack that deals 1d8 points of damage.`,
                surge:`Increase the damage of the granted bite attack by an additional 0.5x of their ability score modifier. Every 4 levels this increases by an additional 0.5x, and every 5 levels lasts an additional round.`
            },
            {
                name:"Bleed",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The ally selects one of its natural attacks, this attack now also deals 1d6 points of bleed damage.`,
                surge:`For 1 round the bleed damage stacks with itself and other sources of bleed damage. Every 6 levels this lasts an extra round.`
            },
            {
                name:"Claws",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The ally grows a pair of claws on its arms, gaining 2 primary claw attacks, each dealing 1d4 points of damage.`,
                surge:`The granted claw attacks have their critical threat range increased by a flat +1 for 1 round. Every 5 levels this lasts an additional round and the flat increase increases goes up by +1.`
            },
            {
                name:"Talons",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The ally grows a pair of talons on its legs, gaining 2 primary talon attacks, each dealing 1d4 points of damage. If the creature is not flying when it uses these, they become secondary attacks.`,
                surge:`If the talons are used within 1 round to make a charge attack, they can make extra attacks with these talons as apart of that charge attack.`
            },
            {
                name:"Climb",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains a climb speed equal to its base speed. If the ally already had a climb speed, increase the climb speed by 20 feet.`,
                surge:`The ally can move as an immediate action, as long as it is using its climb speed.`
            },            
            {
                name:"Hooves",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The ally gains a pair of sharp hooves on end of two legs, granting it 2 hoove attacks. These are secondary attacks that deal 1d4 points of damage.`,
                surge:`This surge is used as an immediate action when the ally is making a melee attack or full-round attack. The ally can make an additional attack with their hoof, as long as it is not against a creature they have, or will attack during their turn (other than with this attack). The creature is flat-footed for this hoof attack, and if it hits, they must make a fortitude save (DC= 10 + level/2 + strength modifier) or they are dazed for 1 round.`
            },
            {
                name:"Empowered Attacks",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally chooses one of its natural attacks, its damage with that natural attack increases by 2 dice steps.`,
                surge:`Increase the damage of the selected natural attack by an additional step for 1 round. Every 6 levels the damage increase by an additional step and lasts an additional round.`
            },
            {
                name:"Natural Armor",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains a +2 racial bonus to its natural armor.`,
                surge:`Increase the granted natural armor by an amount equal to their constitution modifier for 1 round. Every 8 levels this increases by 1 round.`
            },
            {
                name:"Improved Vision",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally can choose to either gain low-light vision or darkvision 60 feet. If they already possess both, they instead gain a +8 bonus to perception checks.`,
                surge:`The ally can re-roll miss chance due to concealment, taking the better result for 1 round. Every 8 levels this increases by 1 round.`
            },
            {
                name:"Magic Attacks",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`All of the allies natural attacks deal damage as if they were magic for the purpose of overcoming damage reduction. At level 10, the natural attacks are also treated as the alignment of the creature for the purpose of overcoming damage reduction.`,
                surge:`The creatures natural attacks gain a +1 enhancement bonus to their attack and damage for 1 round. Every 4 levels the enhancement bonus increases by +1. This does not allow them to overcome any other form of damage reduction.`
            },
            {
                name:"Pincers",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The ally grows large pincers at the end of its arms, gaining two pincer attacks. These are secondary attacks that deal 1d6 points of damage. Additionally, the creature also gains a +4 bonus on its grapple attempts if the arm is involved.`,
                surge:`The ally can make a grapple attempt as an immediate action, gaining a bonus on the roll equal to your highest mental modifier.  This grapple attempt does not provoke, but if it already wouldn't provoke, they gain a +2 bonus on the attempt.`
            },
            {
                name:"Pounce",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains the pounce ability, but only with use of its natural attacks.`,
                surge:`For 1 round the ally can use any melee weapons at the end of its charge as with normal pounce. Every 4 levels they also gains a +1 bonus on attack rolls while charging.`
            },
            {
                name:"Pull",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`Select one natural attack, when the ally  successfully strikes a creature with it, they can attempt a free combat maneuver check to pull the target 5 feet closer to the ally. This ability only works on creatures of a size equal to or smaller than the ally. Neither using or being moved by this ability provokes attacks of opportunity.`,
                surge:`The distance the creature is pulled increases by 5 feet, and If a creature started their turn further than 5 feet away from you, and you pulled them to be adjacent to you with this ability, it provokes attacks of opportunity from you. This surge lasts 1 round, plus an additional round every 5 levels`
            },
            {
                name:"Push",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`Select one natural attack, when the ally successfully strikes a creature with it, they can attempt a free combat maneuver check to push the target 5 feet away from them. This ability only works on creatures of a size equal to or smaller than the ally. Neither using or being moved by this ability provokes attacks of opportunity.`,
                surge:`The distance the creature is pushed increases by 5 feet for 1 round, plus an additional round every 3 levels.`
            },
            {
                name:"Reach",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`Pick a single limb or a natural attack the ally has, that limb or natural attack has its reach increased by 5 feet.`,
                surge:`The reach on the natural attack increases by an additional 5 feet. Every 5 levels the reach increases by an additional 5 feet. At level 12 this lasts an additional round.`
            },
            {
                name:"Resistance",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`Pick one energy type, (acid, cold, electricity, fire, or sonic), the ally gains resist 5 against that energy type. Every 5 levels you have the resistance increased by an additional 5, to a maximum of 15.`,
                surge:`Double the resistance amount or make it stack with another source of energy resistance the creature has. This lasts 1 round, plus an additional round every 6 levels.`
            },
            {
                name:"Scent",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains the scent special quality, allowing it to detect opponents within 30 feet by sense of smell. If it already had the scent ability, the range increases by 20 feet.`,
                surge:`If the enemy is adjacent to the ally, they do not suffer miss-chances from concealment for 1 round. Every 8 levels this increases by 1 round.`
            },
            {
                name:"Skilled",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally selects a specific skill and gains a +8 racial bonus on that skill. If gained multiple times, you can instead increase the bonus by 4, or select a new skill.`,
                surge:`This surge is used as an immediate action when the ally attempts the skill check it gained from this evolution, and must be declared before the skill check is rolled. The ally can roll twice and take the higher result on the check.`
            },
            {
                name:"Slam",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The ally picks an arm or tail to be able to be used to make a slam attack. This is a primary attack that deals 1d8 points of damage.`,
                surge:`This surge is used as an immediate action when the evolved ally makes a successful attack with the slam attack. They can make a bullrush attempt as a free action against the creature they just attacked, gaining a bonus on the attempt equal to half the damage dealt with the slam attack. This still provokes as normal.`
            },
            {
                name:"Slippery",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally becomes slippery, gaining a +4 bonus to CMD attempts to escape grapples and on escape artist checks, but to also take a -4 penalty on CMD against disarm attempts. This evolution cannot be halted, and does not end unless the summoner dies.`,
                surge:`The ally can make an escape artist attempt as an immediate action, gaining a bonus on the roll equal to their constitution modifier. If the summoner has this evolution, it can do so as apart of the same swift action.`
            },
            {
                name:"Sticky",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally is especially sticking, granting it a +4 bonus on combat maneuver checks to initiate or maintain a grapple, as a bonus against disarm attempts, and as a bonus on climb attempts, and creatures have a -4 penalty on escape artist checks to escape grapples from the ally. They ally however takes a -8 penalty on escape artist checks. This evolution cannot be halted, and does not end unless the summoner dies.`,
                surge:`This surge is used as an immediate action when a creature would escape a grapple from the ally, they must roll again to attempt to escape, taking a penalty equal to the allies constitution modifier.`
            },
            {
                name:"Sting",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The ally grows a stinger at the end of its tail, granting them a sting attack. This is a primary attack that deals 1d4 points of damage. The ally must have some sort of tail for this evolution to be usable.`,
                surge:`This natural attack has its reach increased by 5 feet for 1 round. Every 6 levels the reach increases by 5 feet and the duration an additional round.`
            },
            {
                name:"Swim",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains a swim speed equal to its base speed. If it already had a swim speed, it increases its swim speed by 20 feet.`,
                surge:`The ally can move as an immediate action as long as it is using its swim speed.`
            },
            {
                name:"Strong Tail",
                type:["evolution","synthesis"],
                subType:"limb",
                description:`The ally gains a long powerful tail. This limb can have various natural attacks applied to it. Natural attacks that can be placed on arms or legs can also be placed on this tail.`,
            },
            {
                name:"Agile Tail",
                type:["evolution","synthesis"],
                subType:"limb",
                description:`The ally gains a long agile tail. This limb can have various natural attacks applied to it, but additionally once per combat they can withdraw gear or a potion as a swift action and it does not provoke. A natural attack placed on this tail can use dexterity to determine its damage. If it already could, it increases the damage bonus it would gain from the ability score by 0.5x the modifier.`,
            },
            {
                name:"Tail Slap",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The ally can use its tail to bash nearby foes, granting it a tail slap attack. This attack is a secondary attack and deals 1d6 points of damage. The ally must posses some form of tail for this evolution to be used.`,
                surge:`For 1 round when the ally make a successful tail slap with this evolution they can make an additional trip attept as a free action. This trip does not provoke attacks of opportunity. Every 6 levels this increases by 1 round.`
            },
            {
                name:"Tentacle",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The ally gains a long sinuous tentacle, granting it a tentacle attack. This is a secondary attack that deals 1d4 points of damage.`,
                surge:`The ally gains grab with this natural attack for 1 round. Every 6 levels this lasts an additional round.`
            },
            {
                name:"Wing Buffet",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The ally can use its wings to batter foes, granting it two wing buffet attacks. These attacks are secondary attacks that deal 1d4 points of damage. The ally must posses some kind of physical wings to use this evolution, and cannot use the wings to fly on a round that it uses these attacks.`,
                surge:`This surge is used as an immediate action when the evolved ally makes an attack with a granted wing. Doing so reduces the attack by -4, but after the results of the attack are determined, they can make a fly check, and move distance equal to the result of that check, directly away from the target of the attack. This provokes from creatures other than the creature it was used to move away from.`
            },
            {
                name:"Ability Increase",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally selects an ability score, it gains a +2 enhancement bonus on that ability score. Every 6 levels this increases by +1.`,
                surge:`The bonus is doubled for 1 round. This lasts an additional round every 4 levels.`
            },
            {
                name:"Alignment Smite",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally choose a single alignment component that is in opposition to one of their alignment components (good/evil, lawful/chaotic). Once per day as a swift action they can choose one target within sight, if the target's alignment has the selected component, they deal an additional 1d6 points of damage with their attacks against it. This lasts until the target is dead.`,
                surge:`They can use this evolution an additional time per day.`
            },
            {
                name:"Constrict",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains powerful muscles that allow it to crush those it grapples. Whenever the ally successfully grapples a foe with a natural attack or limb, it deals additional damage equal to half the amount of damage dealt by that natural attack or an unarmed strike if the limb used had no natural attack.`,
                surge:`For 1 round the damage increases to the full damage of that attack. Every 8 levels this increases by 1 round.`
            },
            {
                name:"Energy Attacks",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`Pick one energy type: acid, cold, electricity, or fire. All of the Allies natural attacks deal 1d6 points of energy damage of the chosen type on a successful hit.`,
                surge:`The damage also applies to weapon attacks for 1 round, but for natural attacks the elemental damage dice also increases by 2 steps. Every 6 levels this lasts an additional round, and the damage for both increases by 1 dice step.`
            },
            {
                name:"Flight",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally grows large wings, gaining the ability to fly, with a speed equal to its base speed. The maneuverability depends on their size. Medium or smaller have good maneuverability. Large have average maneuverability, while Huge have poor maneuverability. If they already possed a fly speed from wings, the movement speed increases by 20 feet, though they still gain the additional pair of wings. If the ally already has this evolution, you can instead cause their fly speed to become magical. It loses the granted wings, but its maneuverability increases to perfect. If the creature has magical fly speed, then it increases by 20 feet.`,
                surge:`This surge is used as an immediate action during the allies turn. The ally can move up to half its movement speed as long as it is using its fly speed.`
            },
            {
                name:"Gore",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The ally gains a number of horns on their head, giving it a gore attack. This is a primary attack that deals 1d6 points of damage.`,
                surge:`This surge allows the ally one of two bonuses, either it can make an extra gore attack as part of a charge attack, or its gore attack deals double damage on a charge. Either bonus must be used within 1 round.`
            },
            {
                name:"Grab",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`Select a natural attack type between: bite, claw, pincers, slam, tail slap, tentacles, or tentacle mass. Whenver the aly makes a successful attack of the selected type granted from an evolution, they can attempt a free combat maneuver check to grapple. This attempt does not provoke attacks of opportunity. This ability only works on creatures smaller than the ally. Allies with this evolution receive a +4 bonus on CMB checks made to grapple. Abilities that increase the sizes the ally are able to grapple work with this normally.`,
                surge:`For 1 round the grapple attempt can be used on creature up to one size larger than the ally. Every 8 levels, the creature can be 1 size larger.`
            },
            {
                name:"Head",
                type:["evolution","synthesis"],
                subType:"limb",
                description:`The Ally does not gain any additional natural attacks for the additional head, but the additional head does allow them to take other evolutions that add an additional attack to a head (such as a bite, gore, or breath weapon). Additionally, you are no longer killed automatically unless both of your heads are destroyed/removed, and you gain a +4 bonus on will saves against mind-affecting effects that target a limited amount of creatures (unless they target you twice).`,
                surge:`The ally can make an additional will saving throw against a mind-affecting effect currently affecting them as an immediate action, as long as it has a non-permanent duration.`
            },
            {
                name:"Immunity",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The allies body becomes extremely resilient to one energy type, gaining immunity to that type. Pick one energy type: acid, cold, electricity, fire, or sonic.`,
                surge:`The ally becomes absorbent to the selected element, healing for half of the damage it would have done to them.`
            },
            {
                name:"Arm",
                type:["evolution","synthesis"],
                subType:"limb",
                description:`The ally grows an additional arm and hand. This grants a +2 bonus on CMB checks when initiating or maintaining a grapple. The ally does not gain any additional natural attacks for an additional arm, but it can take other evolutions that add additional attacks (such as claws or a slam). They can also be used to wield weapons, granting an additional attack as apart of a full-round attack, however all weapon attacks made during a round you do this take a -2 penalty. You can also use the hands to increase the damage of a wielded melee weapon. \nLight: max 1 hand \nOne-Handed: max 2 hands: \nTwo-handed max 3 hands.`,
            },
            {
                name:"Leg",
                type:["evolution","synthesis"],
                subType:"limb",
                description:`The ally grows an additional leg and foot. Each leg increases their base walking speed by 10 feet and grants them a +2 bonus on their CMD against trip attempts and any check to balance, including on acrobatics or reflex checks against abilities like the grease spell. The ally does not gain any additional natural attacks for an additional leg, but it can take other evolutions that add additional attacks (such as talons).`,
            },            
            {
                name:"Poison",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`Pick a bite or sting attack, whenever the selected attack hits, the target is poisoned: type poison (injury); save Fort negates; frequency 1/round for 4 rounds; effect 1d4 Str damage; cure 1 save. DC = 10 + 1/2 HD + con mod. If this is gained additional times, the poison increases in duration by 2 rounds and the damage increases by 1 dice step.`,
                surge:`For 1 round, you can change the ability score that the poison damages. Every 6 levels the damage the poison deals also increases by 1 step, and the duration lasts an additional round.`
            },
            {
                name:"Rake",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The ally grows dangerous claws on its feet, granting it 2 rake attacks. These attacks are primary attacks that deal 1d4 points of damage. These attacks can be placed on the same legs as other natural attacks.`,
                surge:`The next time this round the ally makes a successful grapple attempt to begin a grapple they can make their rake attacks.`
            },
            {
                name:"Rend",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`Whenever the ally makes two successful claw or rake attacks against the same target in 1 round it latches them in and deals extra damage. The damage is equal to the damage of the claw attack, but gains an additional damage bonus equal to 0.5x the allies damage modifier with the claw attack. The ally must have claw attacks to use this ability, and it can only activate it a single time per round.`,
                surge:`The ally can make an additional rend attempt for 1 round. Every 6 levels you can choose to either increase the duration by 1 round, or to let them make another rend attempt per round. Additional rend attempts require hitting with more claw attacks.`
            },
            {
                name:"Shadow Blend",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`In any condition of illumination other than bright light, the ally disappears into the shadows, giving them concealment (20% miss chance). If you have this an additional time, the miss chance increases to total concealment (50% miss chance).`,
                surge:`For 1 round, when an enemy is rolling miss-chance against the ally because of this ability, they roll twice, taking the lower result. Every 6 levels this lasts an additional round.`
            },
            {
                name:"Shared Slot",
                type:["evolution"],
                subType:"universal",
                description:`The summoner who gave you this evolution selects a wonderous item slot. As long as you are not using a wonderous item in that slot, you gain the benefits of the wonderous item worn in the summoner's slot. If the item has uses, you share uses with the summoner.`,
                surge:`You change which slot this evolution is linked to permanently. This surge is a standard action.`
            },
            {
                name:"Sickening",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The allies smell or apperance is so offensive it sickens nearby creature. Any living creature except the summoner that approaches within 20 feet or begins its turn in that area is sickened for 1 round unless it succeeds at a Fortitude save (DC = 10 + 1/2 HD + Con modifier). Creatures that successfully save cannot be affected by the same sickening effect for 24 hours.`,
                surge:`Any creature that is currently within the range of the evolution must make an additional save against the sicken, even if it has already saved against it. If it is already sickened from the evolution, and it fails its save, it instead becomes nauseous for 1d4 rounds.`
            },
            {
                name:"Trample",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`As a full-round action the ally can overrun any creature that is at least one size smaller than themselves. This works like the overrun combat maneuver, but the ally does not need to make a check, it merely has to move over the opponents in its path. The creature takes 1d6 points of damage (increasing in damage the same way natural attacks are), plus 1.5x the allies strength modifier. Targets of the trample can make attacks of opportunity at a -4 penalty. If a target forgoes the attack of opportunity, it can make a Reflex save for half damage. The DC of this save is 10 + 1/2 HD + Strength modifier. If the ally posses additional legs, the damage also increases by 1 step per leg, and they get a +2 bonus on the overrun checks.`,
                surge:`For 1 round the trample can be used on creatures of the same size as the ally. Every 8 rounds this lasts an additional round.`
            },
            {
                name:"Tremorsense",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The allies senses become incredibly acute, giving it blindsense out to a range of 30 feet. If it already possessed blindsense, this instead becomes blindsight.`,
                surge:`The range of the tremorsense increases by 20 feet for 1 round, increasing by 1 round every 4 levels.`
            },
            {
                name:"Trip",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The ally chooses an attack type between bite, tail slap, or pincers. Whenever the ally makes a successful attack with the chosen attack, it can attempt a free combat maneuver check to trip the creature. This trip attempt does not provoke attacks of opportunity, and only works on creatures that are equal in size or smaller than the ally.`,
                surge:`This surge is used as an immediate action when the ally succeeds on a trip attempt using this evolution, the tripped enemy provokes an attack of opportunity from all creatures threatening it.`
            },
            {
                name:"Negative Energy Affinity",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`Negative energy heals the ally and positive energy harms it. Spells and effects that target undead or have specific effects against undead (such as Command Undead, halt undead, and searing light) affect the ally as if they were undead. The ally gains a +2 bonus on saves against disease, exhaustion, fatigue, paralysis, poison, sleep effects, and stunning. This increases to +4 at 7th, and at 12th it gains immunity to those effects instead. This evolution cannot be halted and only ends if the summoner dies.`,
                surge:`For 1 round the ally heals half from positive energy and from negative energy. Every 8 rounds this lasts an additional round.`
            },
            {
                name:"Blindsense",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The allies senses become incredibly acute, giving it blindsense out to a range of 30 feet. If it already possessed blindsense, this instead becomes blindsight.`,
                surge:`If it did not possess blindsight, it gains blindsight 30 feet, if it did, its blindsight has its range increased by 15 feet. This lasts 1 round, plus an additional round every 5 levels.`
            },
            {
                name:"Burrow",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`They ally grows thick and gnarled claws, allowing them to move through the earth. They gain a burrow speed equal to 1/2 their base speed. They can use this speed to move through dirt, clay, sand, and earth, and It does not leave a hole behind, nor is its passage marked on the surface.`,
                surge:`For 1 round they can also dig through stone, albiet at 1/3rd their base speed. Every 6 rounds the duration by 1 round.`
            },
            {
                name:"Damage Reduction",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`Choose one alignment, chaotic, evil, good, or lawful. The ally gains DR 3 that can only be bypassed by attacks that possess the chosen alignment. The alignment must be an oppositition alingment to one of the alignments possessed by the ally. Every 8 levels the damage reduction increases by 3.`,
                surge:`For 1 round, the damage reduction granted by the evolution increases by 50%. Every 6 levels this lasts an additional round.`
            },
            {
                name:"Frightful Presence",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally can activate this ability as part of an offensive action, such as a charge or attack. Opponents within 30 feet of the ally must make a Will save or become shaken for 1 round. The DC of this save is equal to 10 + 1/2 HD + Charisma modifier. For every 1 point that they fail by, the shaken lasts an additional round. If they fail by 6 or more, the instead become frightened for half the duration they would be shaken. Once a creature has made the save against this ability they are immune to further uses of it.`,
                surge:`If the evolved ally uses the ability within 1 round, they can choose to make the DC equal 10 + their intimidation bonus.`
            },
            {
                name:"Sacrifice",
                type:["evolution"],
                subType:"universal",
                description:`The summoner and the evolved ally can sacrifice their health to heal each other. Doing this is a movement action, and only requires that both of you be on the same plane of existence. At a single time, either of you can transfer up to 2 hit points per HD to the other.`,
                surge:`The summoner and the evolved ally can trade hit points immediately, and the limit increases to 5 points per hit dice.`
            },
            {
                name:"See In Darkness",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains darkvision 60 feet. If they already possess darkvision, they instead gain the See In Darkness ability, allowing them to see perfectly in darkness of any kind, including magical darkness such as that creatured by deeper darkness.`,
                surge:``
            },
            {
                name:"Swallow Whole",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The ally gains the swallow whole ability, giving them the ability to consume their foes. If the ally begins their turn with a creature grappled using its bite attack (with grab evolution, or alternatively used the bite attack to make a grapple attempt), it can attempt a combat maneuver check to swallow the creature. The creature can be up to one size category smaller than the ally. Swallowed creatures take damage equal to the allies bite damage each round plus 1d6 points of bludgeoning damage. A swallowed creature keeps the grappled condition, but can attempt to cut its way free with a light slashing or piercing weapon. The amount of damage needed to cut free is equal to 1/10 the allies total hit points. The allies AC against these attacks is equal to 10 + 1/2 its natural armor bonus. If a swallowed creature cuts its way out, the aly loses this ability until it heals this damage. Alternatively, the swallowed creature can attempt to escape the grapple as normal. Success indicates that it has returned to the allies mouth, where it can attempt to escape or be swallowed again. The ally must possess a bite attack to use this.`,
                surge:`The ally can swallow whole as an immediate action.`
            },
            {
                name:"Web",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains a pair of spinnerets, giving it the ability to spin webs. It can throw webbing as a ranged touch attack up to 3 + constitution mod times per day, entangling a creature up to one size larger than them. The webbing has a maximum range of 50 feet and a 10-foot range increment. Creatures entangled by the web can escape with an Escape Artist check or a Strength check (at a -4 penalty). The DC of these checks is equal to 10 + 1/2 HD + Con modifier. The webs have a Hardness of 0 and a number of hits points equal to the allies total Hit Dice. The ally can pinpoint any creature touching its webs as long as they also are touching webs.`,
                surge:`The next web attack they make within 1 round now targets all creatures within a 10 foot square. Every 6 levels the square increases by 5 feet.`
            },
            {
                name:"Fiendish Form",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally must be evil to use this evolution. The ally manifests some of the abilities of a fiend. Spells and effects that target creatures with the evil subtype or have specific effects against such creatures affect the ally as if it had that subtype. The eidolon gains a +2 bonus on saving throws against acid, disease, fire, and poison spells and effects. It also gains an amount of spell resistance equal to 5 + its HD against spells with the good descriptor. Every 4 levels the bonus increases by +1, and at level 10 the spell resistance to affect any spells cast by good creatures. This evolution cannot be halted, and does not end unless the summoner dies.`,
                surge:`For 1 round, the ally becomes immune to acid, disease, fire, and poison spells and effects, and its spell resistance against good increases by +2. Every 6 levels, this lasts an additional round and the bonus to spell resistance increases by +2.`
            },
            {
                name:"Celestial Form",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally must be good to use this evolution. The ally manifests some of the abilities of a celestial. Spells and effects that target creatures with the good subtype or have specific effects against such creatures affect the ally as if it were a celestial subtype. The ally gains a +2 bonus on saves against disease, petrification, poison, and electricity spells and effects. It also gains spell resistance equal to 5 + its HD against spells with the evil descriptor. Every 4 levels the bonus increases by +1, and at level 10 the spell resistance to affect any spells cast by evil creatures. This evolution cannot be halted, and does not end unless the summoner dies.`,
                surge:`For 1 round, the ally becomes immune to acid, disease, fire, and poison spells and effects, and its spell resistance against good increases by +2. Every 6 levels, this lasts an additional round and the bonus to spell resistance increases by +2.`
            },
            {
                name:"Breath Weapon",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains a breath weapon. Select either acid, cold, electricity, or fire. The ally can breathe a 30-foot cone (or 60-foot line) that deals 1d6 points of damage of the selected type per HD they possess. Those caught in the breath weapon can attempt a Reflex save for half damage. DC=10 + 1/2 HD + Constitution modifier. The ally can use this ability once per day. If the ally already possessed a breath weapon, they can instead expend this ability while using the other breath weapon to add this damage to their normal breath weapon, and increase the DC by their constitution modifier an additional time.`,
                surge:`The ally can use the breath weapon an additional time today. Alternatively, you can surge as an immediate action as the ally uses their breath weapon, this increases the DC by the summoner's highest mental stat, and increases the damage by 1 dice step.`
            },
            {
                name:"Fast Healing",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains fast healing 1. Every 4 levels the fast healing increases by 1.`,
                surge:`They immediately heal twice their fast healing amount (including any other sources of fast healing), and then the fast healing doubles for 3 rounds. Every 5 levels the duration is increased by 1 round and they immediately heal their fast healing amount an additional time.`
            },
            {
                name:"Incorporeal Form",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`Once per day the ally can become incorporeal for 1 round per the summoner's level. While in this form, the ally gains the incorporeal subtype and incorporeal quality. It only takes half damage from corporeal sources as long as they are magic (it takes no damage from nonmagical weapons and objects). Likewise, its spells or spell-like abilities deal only half damage to corporeal creatures. Spells and other effects that do not deal damage function normally.`,
                surge:`The ally can use this ability an additional time per day.`
            },
            {
                name:"Increased Size",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally grows in size, becoming one size category larger. This does not effect their ability scores, but otherwise effects their stats for being a larger size.`,
                surge:`For 1 round the ally gains a +4 size modifier to its strength and +2 size bonus to their constitution, but-2 size penalty to its dexterity. Every 3 levels this lasts an additional round. For each size above large that the creature is becoming because of this evolution, the bonuses and penalties increase by an additional increment.`
            },
            {
                name:"No Breath",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally does not breathe, and is immune to effects that require breathing (such as inhaled poison). This does not give immunity to cloud or gas attacks that do not require breathing, though it does gain a +4 bonus on saves against them.`,
                surge:`The ally is immune to cloud or gas attacks that do not require breathing for 1 round per 4 levels.`
            },
            {
                name:"Spell Resistance",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`They ally is protected against magic, gaining spell resistance 11 + the summoner's level. This spell resistance does not apply to spells cast by the summoner. Multple selections of this evolution increase the spell resistance by 4. This evolution cannot be halted, and does not end unless the summoner dies.`,
                surge:`The allies spell resistance lowers for 1 round.`
            },
            {
                name:"Spell Link",
                type:["evolution"],
                subType:"universal",
                description:`The summoner can cast spells with the range of touch on the evolved ally, regardless of range. If you gain this a second time, the summoner can instead cast spells with the range of personal on the linked evolved ally, with a range of touch (not modified by the original version of this ability)`,
                surge:`If you surge this evolution, you can cast a spell with a range of touch on the ally as a swift action (the range and allowed spells are not modified by the regular evolution.)`
            },
            {
                name:"Ectoplasmic Life Link",
                type:["evolution"],
                subType:"universal",
                description:`You and the linked evolved ally share hit points with each other slowly. At the start of each of the summoner's turns, whichever person has more hit points, summoner or evolved ally, has part of their hit points sent to the other ally. The amount shared is equal to the level of the summoner, to a max of what it would take to make the two of them even in hit points.`,
                surge:`You and the evolved ally share as many hit points as it takes to make both of your hit points as equal as possible.`
            },
            {
                name:"Soul Shield",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains a +2 deflection bonus to their armor class. At level 8 and 16 this increases by +1.`,
                surge:`This surge is done as an immediate action in response to an attack being made against the ally, and can be declared after the roll is made, but before the results are decided. The evolved ally has its deflection bonus to armor class increase by +1, and then their whole deflection bonus is doubled against the attack.`
            },
            {
                name:"Carapace Shield",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`One of the allies arms, tails, or a tentacle, now ends in a tough boney shield. The limb chosen can no longer be used to make attacks or hold things, but instead grants the ally a +4 shield bonus to their armor class, and a +2 bonus to their natural armor. Multiple Carapace Shield's stack. A second selection allows an additional shield, or to increase the granted shield bonus by +2, and natural armor bonus by +1.`,
                surge:`This surge is done as an immediate action in response to the evolved ally being struck with a critical hit. The critical hit is negated, and damage is rolled normally, however the ally loses their carapace shield for 2 rounds.`
            },
            {
                name:"Vestigial Arm",
                type:["evolution","synthesis"],
                subType:"limb",
                description:`You gain a difficult to control arm. This arm cannot have natural attacks placed on, nor does it grant any additional attacks when making a full-round attacks with weapons (though it can be used to make attacks as a part of a full-round action). It can otherwise manipulate and hold objects as well as your normal arms. This also does not allow you to wear any additional wonderous items.`,
                surge:`The ally can draw gear or a weapon without provoking attacks of opportunity as an immediate action.`
            },
            {
                name:"Transposition",
                type:["evolution"],
                subType:"universal",
                description:`You can as a standard action teleport the evolved ally to your side, or swap places with them. This functions as dimension door, using your level as the caster level. If you use it to bring them to you, the evolved creature appears adjacent to you (or as close as possible), if you use it to swap places with them and they occupied more than 1 square, you can choose which square to occupy.`,
                surge:`You can teleport as described, however the range is only 5 feet, plus an additional 5 feet every 5 levels.`
            },
            {
                name:"Bestowed Training",
                type:["evolution"],
                subType:"universal",
                description:`The ally gains use of a single feat that you have. If the feat has prerequisites, they must have them.`,
                surge:`You can change which feat they have access to. This surge is a standard action.`
            },
            {
                name:"Damage Reduction",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains damage reduction equal to 1/-. Every 4 levels, this increases by +1.`,
                surge:`The damage reduction is doubled for 1 round. Every 5 levels, this increases by 1 round.`
            },
            {
                name:"Protective Plates",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains a +4 armor bonus. Every 4 levels, this increases by +1.`,
                surge:`The bonus is reduced by half, but it now stacks with either armor or clothing for 1 round. Every 4 levels this increases by 1 round.`
            },
            {
                name:"Pidgeon",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains a pidgeon inside of their body that protects their vital organs. When the ally would be killed, suffer a critical hit or sneak attack; they can reduce the damage of the attack to 0, but the pigeon is killed in their place.`,
                surge:`This surge is a standard action. The pidgeon comes back to life.`
            },
            {
                name:"Shell",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains a hard shell on their back. As a swift action the ally can pull their body into the shell, increasing their natural armor bonus by +6. they cannot move, attack, cast spells, or see outside of their shell while retracted, but they can return to normal as a free action.`,
                surge:`They choose one natural attack they have, the next time within 1 round that they are attacked while in their shell, the attacker provokes an attack of opportunity from them, though they must use the chosen natural attack to make the attack. Every 6 levels this lasts an additional attack and an additional round.`
            },
            {
                name:"Tentacle Mass",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The Ally grows a thick mass of tentacles that can be used as a primary natural weapon. It deals 1d8 points of damage. Allies with the grab evolution that is linked to a tentacle mass can use that ability to grapple foes of up to the allies size.`,
                surge:`The next attack the ally makes with the tentacle mass this round has its reach increased by 5 feet, and if the attack is successful; the target of the attack makes a fortitude save dc=10+ summoner level/2 + ally strength mod, if they fail, they are stunned for 1 round.`
            },
            {
                name:"Ectoplasmic Field",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`This evolution has no base effect.`,
                surge:`The ally gains elemental resistance of every type equal to 5 + summoner level, and damage reduction /- equal summoner level for 1 round.`
            },
            {
                name:"Air Sac",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally as a swift action can move 5, plus an additional 5 feet per 5 levels. The air sac cannot be used again for 1d4 rounds.`,
                surge:`The air sac can be used as a free action that the ally can take even when not their turn. This puts the sac on cooldown again, but can be used even when the sac is on cooldown. It cannot reduce the cooldown of the sac.`
            },
            {
                name:"Energy Sponge",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains 1 additional point of healing per dice every time they are healed from magical positive energy. If no dice are rolled, the healing is increased by a flat +1.`,
                surge:`The ally heals 1d6 points of hit points per 2 levels of the summoner, this is not modified by base effect of the evolution.`
            },
            {
                name:"Adrenaline Glands",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`When below 50% hit points the ally gains a 10 foot bonus to their base movement speed, a +1 dodge bonus to their armor class, a +1 bonus on all saves, and a +1 bonus on all attack rolls. Every 8 levels these bonuses increase by 1 increment.`,
                surge:`The ally can make a move action as an immediate action.`
            },
            {
                name:"Guided Limb",
                type:["evolution","synthesis"],
                subType:"natural attack",
                description:`The ally chooses 1 limb, that limb can use their highest mental modifier in place of the usual ability score to determine their attack modifier when making attacks with only that limb. This does not apply to attacks that use multiple limbs.`,
                surge:`Instead of it using their highest mental modifier on attacks with that limb, they instead gain an insight bonus on attacks with that limb equal to the summoners highest mental modifier for 1 round. This increases by 1 round every 8 levels. This bonus is kept when making attacks with two limbs, however the bonus is reduced by half.`
            },
            {
                name:"Blood Frenzy",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`When the ally is dealt damage, they enter a blood frenzy. They gain a +2 morale bonus on attack rolls and weapon damage rolls and attacks the nearest creature each round, friend or foe, although they cease attacking its summoner after hitting once. The frenzy lasts for 5 rounds or until the ally can perceive no creatures. At the end of that time, the ally is fatigued for 5 rounds. It cannot enter a blood frenzy while fatigued. Every 4 levels the bonus increases by +1.`,
                surge:`The blood frenzy ends immediately and the fatigue duration is reduced to 2 rounds.`
            },
            {
                name:"Amorphous",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The allies biology lacks discernible weak points. They gain 50% fortification against critical hits and sneak attacks.`,
                surge:`The fortication is increased to 100% for 1 round. Every 8 levels this increases by 1 round.`
            },            
            {
                name:"Enhanced Constitution",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The Allies hit dice size is increased by 4 (rerolls previous hit dice)`,
                surge:`The ally heals hit points equal to their constitution score.`,
                hasCustomMethod:true,
            },
            {
                name:"Mutated Ability",
                type:["evolution","synthesis"],
                subType:"universal",
                description:`The ally gains a +4 to a random ability score.`,
                surge:`The ally gains an enhancement bonus to that ability score equal to the summoners highest mental modifier for 1 round. Every 8 levels this increases by 1 round.`,
                hasCustomMethod:true,
                
            },
////////////////////////////////////////////////////////////////////////////////////////////// evolution/surge perks
            {
                name:"Health Surge",
                type:["evolution perk","synthesis perk"],
                description:`Whenever you surge an evolution, the ally gains temporary hit points equal to your level at the start of each turns that the surge is active, this increases by level/2 for each of your evolutions on the ally past the first. These do not stack with themselves, but otherwise last until the end of the floor.`,                    
            },
            {
                name:"Replenishing Surge",
                type:["evolution perk","synthesis perk"],
                description:`Whenever you surge an evolution, the ally heals hit points equal to your level for the duration of the surge. For each of your evolutions on the ally past the first, the healing increases by level/2`,                    
            },
            {
                name:"Enduring Surge",
                type:["evolution perk","synthesis perk"],
                description:`Your surges with a duration last an additional round.`,                    
            },
            {
                name:"Surging Mastery",
                type:["evolution perk","synthesis perk"],
                description:`Surging an evolution costs 1 less spell point, this cannot reduce the cost below 0 spell points. Every 8 levels this reduces the cost by an additional spell point.`,                    
            },
            {
                name:"Surging Speed",
                type:["evolution perk","synthesis perk"],
                description:`When you surge an evolution, the ally can move 5 feet for each of your evolutions on them as a free action they can take even when not their turn.`,                    
            },
            {
                name:"Shared Evolution",
                type:["evolution perk"],
                description:`Pick an evolution you have given to an ally, you also gain that evolution. If you gain this multiple times you must select different evolutions.`,                    
            },
            {
                name:"Ectoplasmic Build Up",
                type:["evolution perk","synthesis perk"],
                description:`For each of your evolutions that an ally has, they gain a +1 bonus to a physical stat of your choice. If you have a fused creature, this bonus is added to the physical stats of that fused creature.`,                    
            },
            {
                name:"Surge Expertise",
                type:["evolution perk","synthesis perk"],
                description:`You can surge an additional evolution when surging as a swift action, this costs the additional spell points, but only counts as a single evolution surged for other abilities. These evolutions do not need to be on the same ally.`,                    
            },
            {
                name:"Evolution Surge",
                type:["evolution perk","synthesis perk"],
                description:`You can permanently end an evolution on a creature as a free action you can take even when not your turn, doing so allows the creature to re-roll any roll, or reduce the damage they take from an attack to 0.`,                    
            },
            {
                name:"Rejuvenating Ectoplasm",
                type:["evolution perk","synthesis perk"],
                description:`For each of your evolutions that an ally has, they gain fast healing 1. When a creature has an evolution surged, this bonus is doubled for the duration of the surge.`,                    
            },
            {
                name:"Evolved Defenses",
                type:["evolution perk","synthesis perk"],
                description:`For each of your evolutions that an ally has, they gain DR 1/-. This stacks with any other DR they gain from your evolutions. When a creature has an evolution surged, this bonus is doubled for the duration of the surge.`,                    
            },
            {
                name:"Evolved Resistances",
                type:["evolution perk","synthesis perk"],
                description:`For each of your evolutions that an ally has, they gain resistance 1 to all elements. This stacks with any other resistances they gain from your evolutions. When a creature has an evolution surged, this bonus is doubled for the duration of the surge.`,                    
            },
            {
                name:"Evolved Flesh",
                type:["evolution perk","synthesis perk"],
                description:`For each of your evolutions that an ally has, they gain a +1 racial bonus to their natural armor. This stacks with any other natural armor they gain from your evolutions. When a creature has an evolution surged, this bonus increases by +2 for the duration of the surge.`,                    
            },
            {
                name:"Evolved Offenses",
                type:["evolution perk","synthesis perk"],
                description:`For every two of your evolutions that an ally has, they gain a +1 bonus to their attack rolls with natural attacks. When you surge an evolution, their next attack gains double this bonus.`,                    
            },
            {
                name:"Evolved Power",
                type:["evolution perk","synthesis perk"],
                description:`For each of your evolutions that an ally has, they gain a +1 bonus to their damage rolls with natural attacks. When you surge an evolution, their next attack gains double this bonus.`,                    
            },
            {
                name:"Apex Predator",
                type:["evolution perk","synthesis perk"],
                description:`All of the allies evolution natural attacks have their damage increased by 1 dice step.`,                    
            },
            {
                name:"Sharpened Enamel",
                type:["evolution perk","synthesis perk"],
                description:`All of the allies evolution natural attacks have their critical threat range increased to a base of 19-20. Getting this a second time increases the base critical threat range to 18-20. Getting it any more, increases the base critical threat range by a flat +1 instead.`,                    
            },
            {
                name:"Fast Reconfiguration",
                type:["evolution perk","synthesis perk"],
                description:`Changing the choices made for natural attack evolutions can now be done as a swift action for level spell points.`,                    
            },            
//////////////////////////////////////////////////////////////////////////////////////////////// summoning perks
            {
                name:"Cover Tactics",
                type:["summoning"],
                description:`Any cover bonus to armor class your summoned creatures would provide to an enemy against you is reduced by -2, any cover bonuses to your armor class you gain against an enemy because of your summoned creature increases by +2 (if a creature normally bypasses soft cover, you still gain a +2 cover bonus to AC). If a summoned monster is providing a cover bonus to your armor class against an attack, they can as an immediate action increase your armor class for that attack by +2, doing so reduces their duration by 1 minute and they are nauseated on their next turn (this bypasses any immunity to nausea they may have). You must declare use of this before the attack is rolled. If the attack hits anyway, you can also spend an immediate action to divert half of the damage you would take to the summoned creature. This only diverts damage, nothing else, and if this damage is enough to kill them, the excess damage is dealt to you.`,                    
            },
            {
                name:"Shielding Summons",
                type:["summoning"],
                description:`While adjacent to a creature you summoned, you gain a +1 shield bonus to armor class, this stacks, up to a maximum of +9.`,                    
            },
            {
                name:"Master's Escape",
                type:["summoning"],
                description:`As a swift action, you can dispel a single summoned creature within close range (25ft +5ft/2 levels) to teleport to a square that it was occupying.`,                    
            },
            {
                name:"Bleed For Your Master",
                type:["summoning"],
                description:`When you take damage, as a immediate action you can reduce the damage taken by the remaining hit points of a summoned creature that is adjacent to you. After you use this ability, the summoned creature is dispelled.`,                    
            },
            {
                name:"Devour Ectoplasm",
                type:["summoning"],
                description:`You can as a standard action dissolve an adjacent creature you summoned, doing so heals you for hit points equal to 1/4 the creatures remaining hit points and dispels them. You can reduce the action to a movement action, but it becomes temporary hit points and lasts rounds equal to half of the minutes the summoned creature had left in its duration.`,                    
            },
            {
                name:"Favorite Summon",
                type:["summoning"],
                description:`When you use a summoning spell to summon a single creature, you can increase the cost by 50% to cause it to become your favorite summon. A favorite summon no longer has its duration reduced by time, but it is still reduced by any perk that would reduce its duration. It also gains a bonus to its attack and damage equal to half your mental modifier. You can only have a single favorite summon at a time.`,                    
            },
            {
                name:"Linked Souls",
                type:["summoning"],
                description:`Whenever you take damage, you reduce the damage by 1 point per creature you currently have summoned and that is within 30 feet of you, that reduced damage is directed to each of the summoned creatures, bypassing any resistance or immunitites. Every 4 levels, the amount of damage you reduce increases by an additional point.`,                    
            },
            {
                name:"Explosive Entry",
                type:["summoning"],
                description:`When you summon a creature, they appear in an explosive blast, dealing force damage equal to the summoned creatures CR x2 to all creatures adjacent to the summoned location. If the summon spell summons multiple creatures, it instead only deals the creatures CR. Creatures may make a will save (dc=the spells DC) to reduce the damage by half. If multiple summons overlap, they combine to once source of damage.`,                    
            },
            {
                name:"Explosive Exit",
                type:["summoning"],
                description:`When a creature you summoned is reduced to an amount of hit points that would kill them, or are otherwise destroyed (but not dispelled), they vanish in an explosive blast, dealing damage equal to its CRx2 to all creatures within 5 feet of it, increasing by 5 feet for every size category above medium it is, reflex half (dc=spell's dc). If the spell that summoned the creature summoned multiple creatures at once, the damage reduces to its CR.`,                    
            },
            {
                name:"Re-Organize",
                type:["summoning"],
                description:`As a full-round action you can re-organize your summoned creatures, allowing all of your summoned creatures within close range (25ft +5/2 levels) to teleport to another square that another summoned creature was occupying.`,                    
            },
            {
                name:"Trained Summons",
                type:["summoning"],
                description:`When you summon a creature, you can grant them a single martial feat you have.`,
            },
            {
                name:"Command: Frenzy",
                type:["summoning"],
                description:`As a standard action you cause all of your summoned creatures to fly into a frenzy for 1 round. Each of them gains a +4 morale bonus to their strength and constitution, and they gain the benefits that are granted by the haste spell, this even stacks with the actual haste spell. The duration of all frenzied summons decreases by 3 minutes.`,
            },
            {
                name:"Command: Protect",
                type:["summoning"],
                description:`As a standard action you cause all of your summoned creatures to rush to you to defend you, each of them as an immediate action can make a movement action to move as long as it ends adjacent to you. For each creature that does this, you gain a +1 bonus to your armor class for 1 round. The duration of all summons that move is reduced by 2 minutes.`,
            },
            {
                name:"Command: Kill",
                type:["summoning"],
                description:`As a standard action you command all of your summoned creatures to kill a specific target, each of them as an immediate action can move, as long as the movement ends them within reach of the specified target, then each of them can make a single attack against the target, gaining a morale bonus to the attack equal to your highest mental modifier, and twice the bonus on damage, and their critical damage multiplier for their attack increases by +1. Afterward the attack, any summoned creature that followed this command are reduced to the amount of hit points that would kill them, and they disappear.`,
            },
            {
                name:"Command: Ruin",
                type:["summoning"],
                description:`As a standard action you can command any of your summoned creature to explode. This deals 1d2 points of force damage per CR of the creature, in a 5ft radius (+5ft. for every size category larger than medium it is), reflex half (dc=spell's dc). If the creature has an elemental subtype, you can increase the damage to 1d4 and make the damage be that elemental type. Multiple exploding creatures counts as 1 source for saves and resistances. This does not count as spell damage.`,
            },
            {
                name:"Grab Bag",
                type:["summoning"],
                description:`When using a summoning spell to summon more than 1 creature by summoning monsters from a level lower than the current spells level, you can choose to not summon specific creatures, and instead each is determined randomly from that level list. If you do, you instead summon 1d4+1 creatures, If you were summoning creatures from 2 levels below, you instead summons 1d6+2 creatures.`,
            },
            {
                name:"Mass Summons",
                type:["summoning"],
                description:`When using a summon spell to summon more than 1 creature, the amount you summon increases by +1.`,
            },
            {
                name:"Flanking Tactics",
                type:["summoning"],
                description:`All of your summoned creatures gain outflank as a bonus feat, but they only gain the benefits when working with your other summoned creatures or you, and only count as having the feat for allies as long as that ally is you or another summoned creature.`,
            },
            {
                name:"Assistance Tactics",
                type:["summoning"],
                description:`When a summoned creature assists another creature, the bonus they provide to the roll increases by +2.`,
            },
            {
                name:"Cooperative Summons",
                type:["summoning"],
                description:`All of your summoned creatures gain a single teamwork feat you know as a bonus feat, but they only gain the benefits when working with your other summoned creatures or you, and only count as having the feat for allies as long as that ally is you or another summoned creature.`,
            },
            {
                name:"Ferocious Summons",
                type:["summoning"],
                description:`Creatures you summon no longer disappear when they reach 0 hit points unless they also would go unconscious. Additionally, creatures you summon gain the ferocity universal monster ability. Any affect that usually reduces a summoned creature to 0 hit points, or activates at 0 hit points, now reduces them to the amount that it would take to kill them, and those abilities activate when the creature is reduced to the amout of hit points it takes to kill them.`,
            },
            {
                name:"Champion Summon",
                type:["summoning"],
                description:`When you use a summon spell to only summon a single creature, that creature gains a bonus on its attack and as a deflection bonus to its armor class equal to half your highest mental modifier, and a bonus on damage equal to your full highest mental modifier. Additionally, any ability (but not spell) it has has its DC increased by your second highest mental modifier.`,
            },
            {
                name:"Summoned Magic",
                type:["summoning"],
                description:`If a summoned creature has spells or spell-like abilities, choose one of them, and it is summoned with twice as many of that specific spell or spell-like ability. At level 8 and 16 pick an additional spell to double.`,
            },
            {
                name:"Evolved Summons",
                type:["summoning"],
                description:`When you summon a single creature, choose a single evolution you currently have on you, the summoned creature also gains the benefit of that evolution.`,
            },
            {
                name:"Improved Summons",
                type:["summoning"],
                description:`Your summoned creatures gain a +2 bonus to all rolls, and +1 to the DC of all abilities and spells. This bonus to rolls increases by +1 every 8 levels, and the bonus to DC's increases every 10 levels.`,
            },
            {
                name:"Warleader",
                type:["summoning"],
                description:`When you make a successful weapon or natural attack against a creature, all of your summoned creatures gain a +2 bonus on attacks and damage against them for 1 round. This increases by +1 every 6 levels.`,
            },
            {
                name:"Coordinated Offense",
                type:["summoning"],
                description:`For each summoned creature you have that threatens a creature, you gain a +1 bonus on melee attacks against them, up to a maximum of +9.`,
            },
            {
                name:"Open Up",
                type:["summoning"],
                description:`When an enemy fails a saving throw against a control spell you cast, all summoned creatures that currently threaten them may make a a single attack against that enemy as an immediate action. Any summoned creature that takes this attack has its duration reduced by 3 minutes.`,
            },
            {
                name:"Expose The Throat",
                type:["summoning"],
                description:`Your summoned creatures gain a +2 bonus on attacks against an enemy creature that is currently suffering from the effects of one of your control spells.`,
            },
            {
                name:"Magical Transference",
                type:["summoning"],
                description:`If you summon a creature that has spells or spell-like abilities, they can expend them while rolling a spellcaster check to assist you. If they succeed, and if you cast a spell that is the same level and type as the spell or spell-like ability they expended within the same round, the spell has its DC increased by +2.`,
            },
            {
                name:"Summon Shift",
                type:["summoning"],
                description:`As a swift action, you can cause a summoned creature to teleport 5 feet per level of the summon monster list they are apart of. This reduces their duration by 1 minute.`,
            },
            {
                name:"Alignment Summon",
                type:["summoning"],
                description:`Whenever you summon a creature, for each alignment component of yours they share, they gain a +1 bonus on all rolls.`,
            },
            {
                name:"Variable Summons",
                type:["summoning"],
                description:`When summoning more than one creature from a lower level list, you don't have to summon all creatures of the same type.`,
            },
            {
                name:"Bonded Summon",
                type:["summoning"],
                description:`When you gain this perk, you choose a single creature from the summon monster list, that summon gains a bonus to all rolls equal to half your highest mental modifier, and gains 4 hit points per HD. Once that summon dies, is dispelled, or otherwise ends, you can no longer summon that creature. You can only have one of that bonded summon at a time. After the bonded summon ends, you can choose a new bonded summon of a new level, you can never have a bonded summon of that level again.`,
            },
            {
                name:"Focused Summoning",
                type:["summoning"],
                description:`As long as you only have a single summoning spell active at a time, all of the summoned creatures gain a bonus on all rolls equal to half your highest mental modifier. Once this bonus is lost on a floor, it is lost for the rest of the floor.`,
            },
            {
                name:"Prepared Summons",
                type:["summoning"],
                description:`At the start of each floor you enter with an additional summon monster spell active. It still costs twice the normal spell points.`,
            },
            {
                name:"Durable Summons",
                type:["summoning"],
                description:`Your summons are summoned with max hit points instead of half. If you already have this perk, increase their hit points by the difference between average and max hit points.`,
            },
            {
                name:"Buffed Summons",
                type:["summoning"],
                description:`The first round you summon a creature, they are effected by a single one of your buff spells. Using this ability costs spell points equal to the buff spells level. Every 8 levels the buff lasts an additional round.`,
            },
            ///////////////////////////////////////////////////////////////// synthesis perks
            {
                name:"Shielded Meld",
                type:["synthesis perk"],
                description:`You gain a +2 shield bonus to armor class and a +1 circumstance bonus on your saving throws while you are fused to a summon. Every 4 levels the shield bonuses increases by +1 and every 6 levels the save bonus increases by +1.`,
            },
            {
                name:"Spell Synthesism",
                type:["synthesis perk"],
                description:`You are able to use the fused creature's spell-like abilities. If you have the spell available on your spell list, casting the spell has its spell point cost reduced by 50% while fused with the creature.`,
            },
            {
                name:"Summoned Training",
                type:["synthesis perk"],
                description:`When fused with a creature, you can choose one of its feats to gain access to.`,
            },
            {
                name:"Improved Synthesis",
                type:["synthesis perk"],
                description:`When you are fused with a creature, you can choose to use its BAB or your own, whichever you prefer.`,
            },
            {
                name:"Complete Fusion",
                type:["synthesis perk"],
                description:`While fused with a summoned creature you can gain the benefits of the creatures special abilities as long as they could be completed by only the creatures physical body. Generally this includes every special ability that could be gained from spells such as beast shape, elemental shape, plant shape, etc. but may also include additional abilities such as natural invisibility(invisible stalker) or spores(vrock). This is up to GM's descretion on what could be accomplished with this ability.`,
            },
            {
                name:"Explosive Escape",
                type:["synthesis perk"],
                description:`When a fused creature is reduced to 0 hit points or otherwise destroyed (but not dispelled), you can cause them to leave with a final explosive blast. It is mostly harmless, however it launches you away to safety, launching you a direction of your choice a distance of 5 feet per the creature's constitution modifier. This movement provokes attacks of opportunity.`,
            },
            {
                name:"Fluctuating Shell",
                type:["synthesis perk"],
                description:`If you are currently fused with a summoned creature, you can fuse an additional creature. This new creature replaces the currently fused creature like normal, however the previous creature is not dispelled and instead you can shift to it as a swift action. You cannot have more than 2 fused creatures at a time.`,
            },
            {
                name:"Essence Combination",
                type:["synthesis perk"],
                description:`You can fuse two summons together for your shell. You can choose one of the creatures to provide the body, using most of its statistics, however you can use the defensive attributes of the other creature, including its resistances and immunities. You can do this in one of two ways, if you currently have a fused summon, you can summon another creature and fuse with them, this new fused creature is the one who's defensive stats you use. Alternatively, if you use a summon spell to summon multiple creatures of a lower level, you can instead pick 2 creatures, one of them of a level below, and one of any level lower than the maximum you could summon, and choose one to provide the body, and one to provide the defensive stats.`,
            },
            {
                name:"Magical Fusion",
                type:["synthesis perk"],
                description:`When you fuse with a creature, you gain access to their spell-like abilities, however you use your mental stats and caster level to determine their potency.`,
            },
            {
                name:"Armor Fusion",
                type:["synthesis perk"],
                description:`When you fuse with a creature, you can cause it to always be a creature of your size, changing its statistics as appropriate, ability scores included. If you do, you can continue to use your armor instead of the creature's armor. You still replace your natural armor with the fused creatures.`,
            },
            {
                name:"Ectoplasmic Weapons",
                type:["synthesis perk"],
                description:`When you use a weapon while fused with a creature, your weapon shrinks and grows to match their size.`,
            },
            {
                name:"Rapid Fusion",
                type:["synthesis perk"],
                description:`When adjacent to a creature you summoned, you can fuse with it as a swift action. Doing so reduces the duration of the summon down to 1 round per minute the summon had left, and this costs level spell points.`,
            },
            {
                name:"Self Sacrifice",
                type:["synthesis perk"],
                description:`You can expend your own hit points in place of your fused monster's temporary hit points.`,
            },
            {
                name:"Ectoplasmic Fusion",
                type:["synthesis perk"],
                description:`You can summon another monster while still fused with another monster to add the hit points of that creature to the temporary hit points of your currently fused creature. If you do, the summoning has no other effects. You can only have a single extra fused monster at a time, though once the additional temporary hit points are lost, you can fuse another creature again..`,
            },                
            {
                name:"Prepared Synthesis",
                type:["synthesis perk"],
                description:`You start each floor with a fused monster.`,
            },
            {
                name:"Emergency Shift",
                type:["synthesis perk"],
                description:`Once per floor you can fuse with a creature as an immediate action. It only lasts 1 round per 2 levels instead of the normal duration.`,
            },
            {
                name:"Energy Refusion",
                type:["synthesis perk"],
                description:`Your fused monsters temporary hit points can be healed by positive energy, however you are not healed if you use the positive energy this way.`,
            },
            {
                name:"Energy Refusion",
                type:["synthesis perk"],
                description:`Your fused monsters temporary hit points can be healed by positive energy, however you are not healed if you use the positive energy this way.`,
            },
            {
                name:"Emergency Synthesis",
                type:["synthesis perk"],
                description:`When you enter a floor, you choose a single summon from your list, you can synthesis summon that creature once during this floor as a swift action.`,
            },
            {
                name:"Evolving Synthesis",
                type:["synthesis perk"],
                description:`Every time you synthesis summon a creature, you can remake your choices for your [natural weapon] typed evolutions, including allowing you to improve the fused creatures natural attacks. Any improvement to the natural attacks of the creature are lost when the synthesis ends, and may cause you to lose those attacks.`,
            },            
        ]
    },
    {
        name:"Enhanced Constitution",
        rarity:"special",
        type:"special",
        prereq:"special",
        hasCustomMethod:true,
        customMethod:(context)=>{context.doesNothing="doesNothing"},
        catchUpMethod:(context)=>{                        
            context.stats.characterStats.misc.HDSize += 4
            context.stats.characterStats.hpIncreases.splice(0, 1, context.stats.characterStats.misc.HDSize)
            for(let x = 1; x < context.stats.characterStats.hpIncreases.length; x++){                
                context.stats.characterStats.hpIncreases.splice(x, 1, Math.ceil(Math.random() * context.stats.characterStats.misc.HDSize))
            }
        }
    },
    {
        name:"Mutated Ability",
        rarity:"special",
        type:"special",
        prereq:"special",
        hasCustomMethod:true,
        customMethod:(context)=>{context.doesNothing="doesNothing"},
        catchUpMethod:(context, _, contextSelf)=>{
            let scores = ["strength","constitution","dexterity","intelligence","wisdom","charisma"]
            let score = scores[Math.floor(Math.random()*6)]
            context.stats.characterStats.abilityScore[score] += 4
            contextSelf.shortDesc += `\nAbility Score Chosen: ` + score
        }
    },
    {
        rarity: "unique",
        type: "magic",
        name: "Spell Combat",
        fromClass:"Magus",
        shortDesc: `You gain two different ways to combine your spell casting and martial powers. You can use both in the same turn if you want.
        \nSpell Combat: You can cast spells and wield weapons at the same time. When making a full-attack action with a free hand you can make all of your attacks at a -2 penalty to cast a spell with a casting time of a standard action or less with your off-hand. You can choose to cast the spell first or attack first, but you cannot cast in between attacks.
        \nSpellstrike: While attacking with a weapon (whether it be a single attack or during a full-round attack) you can cast a touch spell with a casting time of a standard action or less for the regular cost + 50% and channel it through your weapon to affect the target if you hit with the attack. Even melee touch spells are lost if you miss your attack. The weapon must be appropriate for the type of spell cast, (melee weapon for melee touch spells, ranged weapon for ranged touch). You can only cast one spell per round this way, but if a spell has multiple attacks during it such as scorching ray, you must deliver each ray of the spell during the subsequent attacks (any rays not used during that action are lose). The spell damage is also multiplied if the attack roll would be a critical hit, though it only deals your spell critical multiplier (default x2). 
        \nYou can only use a single of these abilities in a round, and both of these abilities provoke attacks of opportunity for casting, though you can combat cast as normal. When combat casting a spell this way you can also choose to take a penalty to your attack rolls for the turn to gain an equal amount as a bonus to your concentration checks.
        \nAt 6th level you can use ranged touch spells during melee attacks and melee touch spells during ranged attacks, but only if the target of the attack is within 30 feet. 
        \nYou gain an additional damage spell every level.
        \nAt 1st and every 3rd level you gain a arcana perk.
        \n\nGain 1 additional spell point per level`,
        hasCustomMethod:true,
        customMethod: (context,self)=>{
            self.getSpell(context, Math.ceil(context.stats.characterStats.misc.level/2)+1)                
            if(context.stats.characterStats.misc.level %3 == 0){
                self.getPerk(context,self, 0)
            }
        },
        catchUpMethod: (context, self)=>{
            context.stats.characterStats.misc.spPerLevel += 1
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                self.getSpell(context, Math.ceil(x/2)+1)
            }
            let perkCount = Math.floor(context.stats.characterStats.misc.level/3) + 1
            self.getPerk(context,self, perkCount)
        },
        getSpell: (context, lvlNum)=>{
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.type={damage:true}
            let obj={command:"requestRoll", type:"spell", options};
            context.connection.send(JSON.stringify(obj));
        },
        getPerk:(context, self, arcanaLeft)=>{
            let arcanas = self.arcana
            let choices = []
            let chosen = []
            for(let x = 0; x < 4; x++){
                let currentPerks = context.stats.lists.perks.map(perk => perk.name)
                let filtered = arcanas.filter(arcana=> !arcana.prereq || currentPerks.includes(arcana.prereq))
                let possible = Math.floor(Math.random()*filtered.length)
                while(chosen.includes(possible)) possible = Math.floor(Math.random()*filtered.length)
                chosen.push(possible)
                let option = filtered[possible]
                choices[x] = {
                    title:option.name,
                    description:option.description,
                    id:x,
                    method:(() =>{
                        let perk = {rarity:"unique", name:option.name, shortDesc:option.description, id, type:"magic", uiType:"perk"}
                        if(option.abilityType) perk.abilityType = option.abilityType                                            
                        if(option.hasCustomMethod){
                            option.customMethod(context)
                            perk.hasCustomMethod = true
                        }
                        let id = Math.random()*1000000
                        context.stats.lists.perks.push(perk)
                        if(arcanaLeft > 1){
                            arcanaLeft-=1
                            self.getPerk(context,self, arcanaLeft)
                        }
                    })
                }                
            }
            let custom = {title:"Arcana Choice", options:choices}
            context.customDialogArray.push(custom)
        },
        hasSpecialItems:true,
        getSpecialItemList:(self)=>{                                
            return self.arcana
        },
        arcana:[
            {
                name:"Empower Weapon",
                description:"You can expend a spell slot as a swift action to empower a wielded weapon, granting it an enhancement bonus to attack and damage equal to the level of the spell expended for rounds equal to your highest mental modifier (minimum 1).",
            },
            {
                name:"Empower Armor",
                description:"You can expend a spell slot as a swift action to empower a piece of worn armor, granting it an enhancement bonus to its armor class equal to the level of the spell expended for rounds equal to your highest mental modifier (minimum 1).",
            },
            {
                name:"Canny Defense",
                description:"While wearing light or no armor and not using a shield, you add 1 point of intelligence bonus (if any) per level as a dodge bonus to your armor class while wielding a melee weapon. Like other dodge bonuses you lose this bonus if you are flat-footed or denied your dexterity bonus to armor class.",
            },
            {
                name:"Fortify Armor",
                description:`You can spend level/2 spell points to grant your armor the light fortification property or the ghost touch property for rounds equal to your highest mental modifier.
                \nAt level 6 you can instead spend level*1.5 to grant it the moderate fortification enchantment (50% fortification).
                \nAt level 15 you can instead spend level*2.5 to grant it the heavy fortification property.`,
            },
            {
                name:"Spell Channeling",
                description:"When you use your spellstrike ability you gain a bonus to the attack roll equal to the level of the spell.",
            },
            {
                name:"Improved Spell Combat",
                description:"You gain a +2 circumstance bonus on concentration checks. This increases by +1 every 4 levels.",
            },
            {
                name:"Greater Spell Combat",
                description:"When you are using the spell combat perk to take a penalty on your attack roll to gain a bonus on your concentration checks, you gain a bonus on your concentration checks equal to twice the penalty to attack you are taking.",
            },
            {
                name:"Arcane Accuracy",
                abilityType:"Su",
                description:"As as swift action you can spend level/2 spell points to gain an insight bonus equal to your highest mental modifier on all attack rolls until the end of your turn",
            },
            {
                name:"Arcane Edge",
                abilityType:"Su",
                description:"You can expend level/2 spell point as an immediate action after hitting a target with a slashing or piercing weapon in order to deal an amount of bleed damage equal to your highest mental modifier (minimum 0).",
            },
            {
                name:"Arcane Redoubt",
                abilityType:"Su",
                description:`You can expend level/2 spell point as an swift action to treat your shield bonus to AC (including any enhancement bonus) as a bonus to touch AC until the beginning of your next turn.
                \nWhen activating this ability you can also spend an additional level/2 spell points to also apply your shield bonus to AC (including any enhancement bonus) as a bonus on Reflex saves until the beginning of your next turn.`,
            },
            {
                name:"Arcane Redoubt Greater",
                abilityType:"Su",
                description:`When you are targeted with an effect requiring a Reflex save while, you may spend level spell points as an immediate action to grant yourself evasion, or levelx2 spell points points to grant yourself improved evasion.`,
            },
            {
                name:"Bane Blade",
                abilityType:"Su",
                description:`As a swift action for 6 spell points you can attempt a knowledge check against a creature (DC=10+creatures HD), if you succeed, you can give one of your weapons the bane property against them for rounds equal to your highest mental modifier (minimum 1). (+2 enhancement bonus to attack and damage, and an additional 2d6 points of damage)`,
            },
            {
                name:"Critical Strike",
                abilityType:"Su",
                description:`Whenever you score a critical hit with a weapon you can spend levelx2 spell points to cast a spell with a range of touch (or a ranged touch attack if you made the critical hit with a ranged weapon) as a swift action, then make your touch attack with that spell against the target of the critical hit as a free action, as long as they are valid targets for that attack.`,
            },
            {
                name:"Devoted Blade",
                abilityType:"Su",
                description:`You can as a swift action spend level spell points to add either the anarchic, axiomatic, holy, or unholy enchantment special ability to one of your weapons for rounds equal to your highest mental stat (minimum 1). You must be of the matching alignment to add these abilities.`,
            },
            {
                name:"Dispelling Strike",
                abilityType:"Su",
                description:`You expend level/2 spell points and one spell slot as a swift action to imbue one of your weapons with a special power. If the weapon strikes a creature within the next minute, that creature is the subject of a targeted dispel magic using your level as the caster level, except that this effect cannot dispel a spell of a level higher than spell slot used along with this ability (treat higher-level spells as if they do not exist and apply the dispel attempt to the remaining spells with the highest caster level). Once the strike is made, the power dissipates, even if the dispel attempt is unsuccessful.`,
            },
            {
                name:"Disruptive",
                abilityType:"Ex",
                description:`The DC to cast spells defensively increases by +4 for all enemies that are within your threatened area. This increase to casting spells defensively only applies if you are aware of the enemy's location and are capable of taking an attack of opportunity. If you can only take one attack of opportunity per round and have already used that attack, this increase does not apply.`,
            },
            {
                name:"Spellbreaker",
                abilityType:"Ex",
                description:`Enemies in your threatened area that fail their checks to cast spells defensively provoke attacks of opportunity from you.`,
            },
            {
                name:"Distant Spellstrike",
                abilityType:"Su",
                description:`The range of any spell you deliver through a ranged weapon attack increases to the maximum range of the weapon if that is greater than the spell's range.`,
            },
            {
                name:"Divinatory Strike",
                abilityType:"Su",
                description:`Whenever you score a critical hit against an opponent with a non-spell attack, you can gain preternatural insight into your foe's strengths and weaknesses as though you had rolled a natural 15 on a Knowledge check to identify the creature struck. Any bonuses or penalties you normally applies to such a Knowledge check are applied to this ability, including your Intelligence modifier, ranks in the requisite Knowledge skill, and other applicable modifiers. This ability works even if you have already attempted a Knowledge check to identify the creature, and each additional time you use this ability on a creature the result of the roll increases by 4.`,
            },
            {
                name:"Accurate Strike",
                abilityType:"Ex",
                description:"As as swift action you can spend level spell points to to resolve all of your melee weapon attacks until the end of your turn as melee touch attacks. Bonus damage from power attack cannot be applied to these attacks.",
            },
            {
                name:"Concentrate",
                abilityType:"Ex",
                description:"For level spell points as an immediate action you can reroll any concentration check you just made. You must use this ability after the roll is made, but before the roll's outcome is determined. You must take the second roll, even if it is worse. You can only use this ability once per round.",
            },
            {
                name:"Ghost Blade",
                abilityType:"Su",
                description:"You can as a swift action you can add either spend levelx2 spell points to add the brilliant energy weapon special ability, or level spell points to add the ghost touch weapon special ability to one of your weapons. Either lasts rounds equal to your highest mental modifier (minimum 1).",
            },
            {
                name:"Hasted Assault",
                abilityType:"Su",
                description:"You can as a swift action spend level/2 spell points to move more quickly. This functions as haste, but only targets you and lasts for a number of rounds equal to your highest mental modifier (minimum 1).",
            },
            {
                name:"Lingering Pain",
                abilityType:"Su",
                description:"You can as an immediate action spend level/2 spell points after hitting a target with a weapon attack. All damage from that attack (including damage from a spell cast using the spellstrike ability) is considered continuous damage for the purposes of any concentration checks made by the target prior to the beginning of your next turn.",
            },
            {
                name:"Prescient Attack",
                abilityType:"Su",
                description:"You can as an immediate action spend level/2 spell points after hitting a target with a weapon attack, allowing you to anticipate your opponent's defenses. The target is denied its Dexterity bonus against your attacks until the end of your next turn.",
            },
            {
                name:"Reflection",
                abilityType:"Su",
                description:"You can as an immediate action expend level spell points and expend a spell slot to reflect a spell back at its caster. This functions as the spell turning spell, but only if the targeted spell is of a level equal to or lower than the spell slot expended. If insufficient points are expended, they instead grant an insight bonus on any saving throws allowed by the spell, equal to the level of the spell.",
            },
            {
                name:"Prescient Defense",
                abilityType:"Su",
                description:"You can as an immediate action spend level/2 spell points after hitting a target with a weapon attack, granting you a premonition of your enemy's intentions. You gain a bonus to your AC and on Reflex saves equal to your highest mental bonus against attacks by that opponent until the beginning of your next turn.",
            },
            {
                name:"Spell Burn",
                abilityType:"Su",
                description:"As a free action that you can take even when not your turn, you can permanently burn one of your spells. This makes you unable to cast the spell anymore, and it also no longer counts as a spell known. Doing so allows you to recover spell points equal to 6x its level. Any excess spell points remain as temporary spell points for level/4 rounds (minimum 1).",
            },
            {
                name:"Magus Martial Training",
                description:"Gain a bonus martial feat at 1st and every 4 levels.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    let perk = perks.find(perk => perk.name == "Magus Martial Training")
                    perk.catchUpMethod(context,perk)
                }
            },
            {
                name:"Magus Magic Training",
                description:"Gain a bonus magic/metamagic feat at 1st and every 4 levels.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    let perk = perks.find(perk => perk.name == "Magus Magic Training")
                    perk.catchUpMethod(context,perk)
                }
            },
            {
                name:"Greater Spell Access",
                description:"Gain an additional damage spell every odd level.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    let perk = perks.find(perk => perk.name == "Greater Spell Access")
                    perk.catchUpMethod(context,perk)
                }
            },
            {
                name:"Broad Study",
                description:"Gain a an additional control/healing/utility spell at 1st and every 3rd level.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    let perk = perks.find(perk => perk.name == "Broad Study")
                    perk.catchUpMethod(context,perk)
                }
            },
            {
                name:"Martial Perk",
                description:"Gain a R+ martial perk.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk", options:{type:{martial:true},rarity:{rare:true,epic:true,legendary:true,unique:true}}}))
                }
            },
            {
                name:"Magical Perk",
                description:"Gain a R+ magic perk.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk", options:{type:{magic:true},rarity:{rare:true,epic:true,legendary:true,unique:true}}}))
                }
            },
            {
                name:"Flamboyant Arcana",
                description:"Gain a [parry] talent and a deed perk from the panache perk.",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    let perk = perks.find(perk => perk.name == "Panache")
                    perk.getDeeds(context, perk, 0, true)
                    perk.getDeeds(context, perk, 0, false)
                }
            },
            {
                name: "Focused Spellstrike",                    
                abilityType:"Su",
                description:`You can use your spell combat to deliver cone or line shaped instananeous spells. The spell now only affects the creature struck, and it gets its save as normal from the effect.`
            },
            {
                name: "Vision-Clouding Strike",                    
                abilityType:"Su",
                description:`You can expend level/2 or more spell points as a swift action to empower his weapon with shadowy energy that dissipates within 1 minute. A creature struck with the weapon must succeed at a Will save (DC = 1/2 level + highest mental modifier) or treat you as being in an area of dim light for 1d4 rounds, plus 1 additional round for each additional increment of level/2 spell points spend, thus granting you 20% miss chance against their attacks. True seeing penetrates this effect but darkvision and similar darkness-penetrating effects do not.`
            },
            {
                name: "Arcane Cloak",                    
                abilityType:"Su",
                description:`You can expend level/2 spell points as a free action to to add his highest mental modifier as a bonus to Stealth checks and Bluff checks. This bonus lasts for 1 minute.`
            },
            {
                name: "Arcane Scent",                    
                abilityType:"Ex",
                description:`You can sniff out other spellcasters. By spending level/2 spell points as a swift action, you gain the scent special quality for 1 minute per level. This scent can only detect creatures capable of casting spells or using spell-like abilities. Additionally, while this effect persists, you can attempt a Spellcraft check as a move action to determine the highest level spell a detected creature is capable of casting (DC = 10 + the creature's caster level). You can only attempt this Spellcraft check once per creature per 24 hours.`
            },
            {
                name: "Aligned Defenses",                    
                abilityType:"Su",
                description:`As a swift action, you can spend level/2 spell points to fortify your defenses against opposing alignment attacks. This grants him a dodge bonus to his AC equal to half his level against aligned attacks and effects and outsiders with the subtype opposite to either your good/evil alignment, or lawful/choatic alignment until the beginning of your next turn.`
            },
            {
                name: "Spell Shifter",                    
                abilityType:"Su",
                description:`As a move action, you can spend level/2 spell points to change the target of an ongoing spell effect that you created. You must be within the spells range to move it, and you can move the new location up to 5 feet per level.`
            },
            {
                name: "Hostile Spell Shifter",
                prereq:"Spell Shifter",
                abilityType:"Su",
                description:`You can now use your spell shifter ability on spells cast by creatures other than you, however it level spell points, and you must succeed on a spell caster check to do so (dc= 11 + the effects caster level). Failure wastes your action, but does not expend the spell points.`
            },
            {
                name: "Metamagic Training",                    
                abilityType:"Su",
                description:`Gain a metamagic feat. Once per day you can cast a spell as if it was effected by that metamagic feat without requiring a higher level slot or increasing the casting time.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{metamagic:true}}))
                }
            },
            {
                name: "Metamagic Spellstrike",                    
                abilityType:"Su",
                description:`When using spellstrike or spell combat you can cast a spell empowered with a metamagic feat as long as the original casting time was a standard action or less.`
            },
            {
                name: "Empowered Magic",                    
                abilityType:"Su",
                description:`Once per combat you can cast a spell as if it was effected by the empowered spell metamagic feat, increasing its damage by 50% without requiring a higher level spell slot or increasing its casting time.`
            },
            {
                name: "Empowered Magic",                    
                abilityType:"Su",
                description:`Once per day you can cast a spell as if it was effected by the quicken spell metamagic feat without requiring a higher level spell slot or increasing its casting time.`
            },
            {
                name: "Intuitive Protection",                    
                abilityType:"Sp",
                description:`The first time you see a monster you make a spellcraft check against it (DC=15 + creatures HD), if you succeed you can as an immediate action for level/2 spell points cast protection from chaos/evil/good/law (chosen when using this ability) on yourself. This lasts a number of rounds equal to your level.`
            },
            {
                name: "Maneuver Mastery",                    
                abilityType:"Ex",
                description:`Select one combat maneuver when you gain this arcana. When attempting the selected maneuver you can choose to either use your level in place of your BAB, or gain a bonus on the attempt equal to half your highest mental modifier.`
            },
            {
                name: "Planar Hunter",                    
                abilityType:"Su",
                description:`You can as a swift action spend level/2 spell points to add the planar enchantment to one of your weapons, or spend level spell points to add the phase locking special ability to one of your weapons. These both last highest mental modifier rounds.`
            },
            {
                name: "Pooled Spell",                    
                abilityType:"Su",
                description:`When using the spellstrike ability and casting a spell with multiple attacks associated with it, such as scorching ray or blinding touch, you can pool all of them into a single attack instead, delivering all of the rays with your next attack. Doing so increases the cost of the spell to +100%.`
            },
            {
                name: "Spell Shield",                    
                abilityType:"Su",
                description:`You can expend a level/2 spell points as an immediate action to grant yourself a shield bonus to AC equal to your highest mental modifier bonus until the end of your next turn.`
            },
            {
                name: "Spell Trickery",                    
                abilityType:"Ex",
                description:`Once per day when you successfully perform a dirty trick combat maneuver, you can cast an illusion or enchantment spell with a casting time of 1 standard action or less as a swift action.`
            },
            {
                name: "Enduring Blade",                    
                abilityType:"Su",
                description:`When you use a magus arcana that adds an enchantment to your weapon, you can increase the cost by level/2 spell points to have the enchantment last twice as long, with a minimum duration of 1 minute.`
            },
            {
                name: "Elasticity",                    
                abilityType:"Su",
                description:`As a free action you can spend level/2 spell points to grant a melee weapon you are wielding the reach property until the end of your turn. This does not stack if the weapon already has the reach property.`
            },
            {
                name: "Curse",                    
                abilityType:"Su",
                description:`Choose an ability score upon taking this arcana. Whenever you score a critical hit with a melee weapon, you may expend level/2 spell points to deal 1d4 points of damage to that ability score of the creature struck.`
            },
            {
                name: "Spirit Fingers",                    
                abilityType:"Su",
                description:`Whenever you score a hit with a melee weapon, you can spend level/2 spell points as a swift action to immediately attempt a steal combat maneuver. If you succeed on this steal combat maneuver check you can choose to either use the steal combat maneuver as normal, or gain level/2 d4 gold. You can only use this second feature once per creature.`
            },
            {
                name: "Spirit Step",
                abilityType:"Su",
                description:`Whenever you score a critical hit with a melee weapon, you may expend level/2 spell points to teleport to any point within 30 feet. Your turn ends after being teleported.`
            },
            {
                name: "Elemental Empowerment",
                abilityType:"Su",
                description:`As a swift action you may expend level/2 spell points to add an elemental enchantment to your weapon (flaming, frost, corrosive, shock). This lasts for rounds equal to your highest mental modifier (minimum 1). Alternatively you can spend level spell points to make them elemental burst enchantments (flaming burst, icy burst, corrosive burst, shocking burst).`
            },
            {
                name: "Ranged Empowerment",
                abilityType:"Su",
                description:`As a swift action you may expend level/2 spell points to add an one of the following enchantments to your weapon: throwing, seeking, distance. Each of these enchantments lasts highest mental stat rounds (minimum 1).`
            },
            {
                name: "Deadly Dealer",
                abilityType:"Su",
                description:`Instead of throwing rocks, you instead throw playing cards. These cards function similar to any throwing weapon, however their damage is default 1, increasing by 1 dice step for each of your mental modifier. Their range is 10 feet, and their critical threat range is 20x2, and they deal piercing damage. This doesn't stack with abilities that modify your rocks.`
            },
            {
                name: "Escoteric Empowerment",
                abilityType:"Su",
                description:`As a swift action you may expend the specified amount of spell points to add one of the following enchantments to your weapon for highest mental stat rounds (minimum 1): 
                \nlevel/2: Defending/Thundering \nlevel: Impact \nlevel*2: Speed`
            },
            {
                name: "Greensting",
                abilityType:"Su",
                description:`As a swift action you may expend level/2 spell points to add 1d6 points of sneak attack to all of your attacks until the end of your turn. This increases by 1d6 every 3 levels. The attack must meet all of the usual criteria for sneak attack damage.`
            },
            {
                name: "Repel Curse",
                abilityType:"Su",
                description:`As an immediate action when a spell with the curse descriptor or a curse-style effect (such as a witch's evil eye or misfortune hex or a sea hag's evil eye) targets a creature within 30 feet of you, you can spend level/2 spell points to attempt to dispel that effect, as if you had cast remove curse. This ability has no effect on ongoing effects, such as a sea hag's horrific appearance or a pugwampi's unluck aura. You can spend additional spell points while activating this ability to improve your odds of dispelling the curse, spending increments of level/2 spell points to increase the dispel check by +2.`
            },
            {
                name: "Wracking Counter",
                abilityType:"Su",
                description:`Whenever you dispel a spell, such as through break enchantment, dispel magic, or remove curse, or whenever you successfully save against a spell and take no effect, you can as an immediate action spend level/2 spell points to wrack the original caster with pain, dealing 1d4 points of damage per spell level of the effect dispelled or avoided. If the target succeeds a will saving throw (dc=15+spell level + your highest mental modifier), it takes only 1 damage per spell level. You cannot target the same caster more than once per round with this ability, regardless of how many effects you dispel or avoid.`
            },
            {
                name: "Perfect Strike",
                abilityType:"Ex",
                description:`When you hit with a weapon attack, you can spend level/2 spell points in order to maximize your weapon damage. Don't roll for damage—the weapon deals maximum damage. This affects only the weapon's base damage dice, not additional damage from sneak attack, magical weapon properties, spellstrike, or critical hits. If you confirm a critical hit, you can instead spend level spell points to increase your weapon's critical multiplier by 1.`
            },
            {
                name: "Iaijutsu",
                abilityType:"Ex",
                description:`You add your highest mental modifier as well as your dexterity modifier on initiative rolls (minimum 0). You may make attacks of opportunity when flat-footed, and may draw a weapon as part of taking an attack of opportunity.`
            },
            {
                name: "Critical Perfection",
                abilityType:"Ex",
                description:`You add your highest mental modifier as a bonus to confirm critical hits with both weapons and spells.`
            },
            {
                name: "Superior Reflexes",
                abilityType:"Ex",
                description:`You can make an additional number of attacks of opportunity in a round equal to your highest mental modifier.`
            },
            {
                name: "Iaijutsu Master",
                abilityType:"Ex",
                description:`You may always act and may draw your weapon as a swift action during a surprise round, though you are considered flat-footed until you act. During a surprise round or when attacking a flat-footed opponent, you add your highest mental modifier on damage rolls with weapon attacks.`
            },
            {
                name: "Weapon Mastery",
                abilityType:"Ex",
                description:`Choose a single weapon, such as longsword or greataxe. Any attacks with this weapon automatically confirm all critical threats and have their critical damage multiplier increased by 1.  Additionally, you cannot be disarmed while wielding that type of weapon.`
            },
            {
                name: "Spell Critical Mastery",
                abilityType:"Ex",
                description:`Increase the critical damage multiplier of your spells by +1. If you are delivering the spell through a weapon, you can instead choose to increase the critical multiplier to that of your weapon.`
            },
            {
                name: "Spell Critical Range",
                abilityType:"Ex",
                description:`Increase the critical range of your spells by +1. This may even allow you to deal critical damage with the a channeled spell when the weapon attack was not a potential critical hit. If this occurs confirm the critical with a weapon attack as normal, only including bonuses that you would gain for confirming critical spells.`
            },
            {
                name: "Dual Empowerment",
                abilityType:"Su",
                description:`When you use an [imbument] spell or magus arcana that grants an enchantment to one of your weapons, you can provide those enchantments to the other head of a dual weapon, or to an additional wielded weapon.`
            },
            {
                name: "Puppetmaster",
                abilityType:"Su",
                description:`As a swift action whenever the puppetmaster casts a spell of the enchantment or illusion school, he can expend level/2 spell points to increase the spell's save DC or caster level by 1. At 6th level, the increase to the spell's save DC or caster level changes to 2, at 12th level to 3, and at 18th to 4.`
            },
            {
                name: "Charmstrike",
                abilityType:"Su",
                description:`As a swift action when a foe fails a saving throw against a spell (but not a spell-like or supernatural ability) cast by you, you can expend level/2 spell points to cast a prepared 1st-level enchantment on the foe. The foe must be one that the spell can target, and is the only creature affected (even if the spell can normally target multiple creatures). At 8th level, 14th level, and 20th level, increase the maximum level of the spell by 1.`
            },
            {
                name: "Inscribe Rune",
                abilityType:"Su",
                description:`You can carve a sin rune into one of your weapons as a standard action, when you do, choose a school of magic (evocation, enchantment, necromancy, etc.). When you use your spellstrike or spell combat ability to cast a spell of the same type as the carved rune, you gain a +1 bonus on all attacks that action, and any DC from the delivered spell increases by +1. Every 8 levels both of these bonuses increase by 1. However if you cast a spell of a different type, you instead take a -2 penalty on all attacks that action and the delivered spell has its DC decreased by 2, both penalties increasing by -1 every 8 levels. You can have only a single rune carved at a time, and if you carve another, the old one fades.`
            },
            {
                name: "Arcane Augmentation",
                abilityType:"Su",
                description:`You can expend level/2 spell points as a swift action to grant yourself a +5 competence bonus to a dexterity or strength skill check for rounds equal to your highest mental modifier (minimum 1). Every 3 levels the bonus increases by +1.`
            },
            {
                name: "Infernal Mortification",
                abilityType:"Su",
                description:`You can sacrifice blood as a movement action, taking 1 points of constitution drain to regain level spell points. Unlike normal drain, this drain can only be healed 1 point at a time. You restore 1 point of this drain every time you complete a floor.`
            },
            {
                name: "Bypassing Strike",
                abilityType:"Su",
                description:`You can expend level/2 spell points as a swift action to allow one melee or spellstrike attack he makes before the end of his turn to ignore an evil outsider target's damage reduction.`
            },
            {
                name: "Spell Dance",
                abilityType:"Su",
                description:`You can expend level/2 spell points as a swift action to gain a +10 enhancement bonus to his movement rate and a +2 dodge bonus to Armor Class against attacks of opportunity provoked by moving through threatened spaces for rounds equal to your highest mental modifier(minimum 1). For every four levels beyond 1st, you gain another +10 enhancement bonus to movement and +2 to AC against attacks of opportunity provoked from movement. At 5th level, once per spell dance as a swift action, you may use one of the following on yourself as a swift action: blur, fly, or haste. These abilities last for 1 round. At 9th level, you may instead take a swift action to use dimension door as a spell-like ability once during a spelldance. At 13th level, you may instead choose to take a swift action to gain freedom of movement for 1d4 rounds.`
            },
            {
                name: "Hex Arcana",
                abilityType:"Su",
                description:`Every 3 levels gain a witch hex. These function the same as normal witch hexes, cost spell points depending on their tier (minor, greater etc.) are used as swift actions, have a range of 30 feet unless specified otherwise, and can only be used once per day.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    let perk = perks.find(perk => perk.name == "Hex Arcana")
                    perk.catchUpMethod(context,perk)
                }
            },
        ]
    },

    {
        rarity: "unique",
        type: "magic",
        name: "Hex Arcana",
        fromClass:"magus",
        shortDesc: ``,
        hasCustomMethod:true,
        prereq:"special",
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level%3 == 0){
                let perk = perks.find(perk => perk.name == "Hexes")
                perk.getHex(context, perk, context.stats.characterStats.misc.level)
            }
        },            
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%3 == 0){
                    let perk = perks.find(perk => perk.name == "Hexes")
                    perk.getHex(context, perk, x)
                }
            }
        },
    },
    
    {
        rarity: "unique",
        type: "magic",
        name: "Mesmerism",
        fromClass:"Mesmerist",
        shortDesc: `You gain 2 hypnotic abilities:
        \n\nHypnotic Stare(Su): You can focus your stare on a creature within 30 feet as a swift action. That creature takes a -2 penalty on will saves, increasing by -1 every 8 levels. This is a mind-affecting effect. Additionally, once per round, when the target of your stare takes damage, you can as a free action you can take even when not your turn cause the creature to take level/2 additional damage from the attack. If you are the one causing it damage, this instead increases to 1d6 per odd level. This is precision damage. Hypnotic stare remains active until you stare at a new target, it goes out of range, or you fall unconscious. Any abilities that require your focus on a subject, such as a gaze attack require you to target the target of this ability, and you cannot avoid that enemies gaze attacks while using this ability. Every 4 levels you will also gain a stare perk that modifies this ability. When you activate hypnotic stare, you can choose which and how many perks affect it.
        \n\nHypnotic Trick(Su): Twice at level 1, and then again every 3rd level, you gain a hypnotic trick. You can implant a trick on an ally within 15 feet (yourself included) as a standard action for 2 spell points. Then, when its condition is met, you trigger it as a free action you can take even when not your turn. Once triggered, the hypnotism ends, though any passive bonuses the trick added last for 1 round, or until the trick's effect has ended, whichever is shorter. You need to see the target to implant it, but not to trigger it. If a trick has a DC or skill check, it is equal to 10+level/2+highest mental. Additionally, when you get this perk, or when decending a floor, you can implant all of your current hypnotic tricks on allies, costing spell points as normal. You can only have each hypnotic trick implanted in a single ally, but you can have multiple hypnotic tricks on them at once. At level 8 you will begin to get access to masterful hypnotic tricks, which cost 8 spell points to implant. At level 16 gain access to mythic hypnotic tricks which cost 16 spell points to implant.
        \n\nYou also gain a control/utility spell every level.
        \nThe DC of your control spells increase by +1.
        \nGain 2 additional spell points per level`,
        hasCustomMethod:true,
        customMethod: (context,self)=>{
            self.getSpell(context, Math.ceil(context.stats.characterStats.misc.level/2)+1)
            if(context.stats.characterStats.misc.level%4 == 0) self.getStarePerk(context, self)
            if(context.stats.characterStats.misc.level%3 == 0) self.getTrick(context, self, context.stats.characterStats.misc.level)
        },
        catchUpMethod: (context,self)=>{
            context.stats.characterStats.misc.spPerLevel += 2
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%4 == 0) self.getStarePerk(context, self)
                if(x == 1) self.getTrick(context, self, x)
                if(x%3 == 0 || x == 1) self.getTrick(context, self, x)
                self.getSpell(context, Math.ceil(x/2)+1)
            }
            let perks = context.stats.lists.perks.filter(perk => perk.name == "Mesmerism")
            let perk = perks[perks.length-1]
            perk.shortDesc += `\n\nStare Perks:\n`
        },
        
        getSpell: (context, lvlNum)=>{
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.type={control:true,utility:true}
            let obj={command:"requestRoll", type:"spell", options};
            context.connection.send(JSON.stringify(obj));
        },

        getTrick:(context, self, level)=>{
            let trickRarities = ["minor"]
            if(level >= 8) trickRarities.push("masterful")
            if(level >= 8) trickRarities.push("masterful")
            if(level >= 16) trickRarities.push("mythic")
            if(level >= 16) trickRarities.push("mythic")
            if(level >= 16) trickRarities.push("mythic")
            
            let choices = []
            let chosen = []
            for(let x = 0; x < 4; x++){
                let type = trickRarities[Math.floor(Math.random()*trickRarities.length)]
                let filtered = self.tricks.filter(trick=> trick.type == type)
                let possible = Math.floor(Math.random()*filtered.length)
                while(chosen.includes(possible)) possible = Math.floor(Math.random()*filtered.length)
                chosen.push(possible)
                let option = filtered[possible]
                let description = `\nTrick Type: ` + option.type[0] + `\n` + option.description
                choices[x] = {
                    title:option.name,
                    description,
                    id:x,
                    method:(context =>{
                        let perk = {rarity:"unique", name:option.name, id:Math.random()*1000000, additionalInfoTags:option.additionalInfoTags, type:"magic", shortDesc:description}
                        context.stats.lists.perks.push(perk)
                    })
                }                
            }
            let custom = {title:"Trick Selection", options:choices}
            context.customDialogArray.push(custom)

        },

        getStarePerk:(context, self)=>{
            let choices = []
            let chosen = []
            let stares = self.stares
            for(let x = 0; x < 4; x++){
                let possible = Math.floor(Math.random()*self.stares.length)
                while(chosen.includes(possible)) possible = Math.floor(Math.random()*stares.length)
                chosen.push(possible)
                let option = stares[possible]
                let description = option.description
                choices[x] = {
                    title:option.name,
                    description,
                    id:x,
                    method:(context =>{
                        let perk = context.stats.lists.perks.filter(perk => perk.name == "Mesmerism")[0]
                        perk.shortDesc += `\n\n` + option.name + `: ` +  option.description
                    })
                }                
            }
            let custom = {title:"Stare Perk Selection", options:choices}
            context.customDialogArray.push(custom)
        },

        hasSpecialItems:true,
        getSpecialItemList:(self)=>{
            let arr = []
            self.stares.forEach(stare => {
                stare.type = ["Stare"]
                arr.push(stare)
            })
            self.tricks.forEach(trick => {
                trick.type = ["Trick, " + trick.type[0]]
                arr.push(trick)
            })
            return arr
        },
        stares:[
            {
                name: "Disorientation",
                description: `The penalty caused by your hypnotic stare also applies to the targets attack rolls.`,
            },
            {
                name: "Hypnotising Stare",
                description: `You can activate your hypnotic stare on an ally as a movement action(not yourself), this allows you to implant a hynotic trick on them. The penalties of your stare still apply (all of them, including stare perks) and last at least 1 round.`,
            },
            {
                name: "1000 Yard Stare",
                description: `Your hypnotic stare has its range increased by 10 feet. Every 6 levels this increases by 5 more feet.`,
            },
            {
                name: "Distracted",
                description: `The penalty caused by your hypnotic stare also applies to concentration checks.`,
            },                
            {
                name: "Infiltration",
                description: `The penalty caused by your hypnotic stare also applies to the target's Perception checks and CMD.`,
            },
            {
                name: "Lethality",
                description: `The penalty caused by your hypnotic stare causes the creature to take additional damage when it takes precision damage equal to the penalty of the stare.`,
            },
            {
                name: "Clumsy",
                description: `The penalty caused by your hypnotic stare also reduces the creatures dexterity or dodge bonus to its armor class. This cannot reduce their bonuses below 0.`,
            },
            {
                name: "Nightmare",
                description: `The target of the hypnotic stare rolls twice on all Will saves versus fear, taking the lower result.`,
            },
            {
                name: "Oscillation",
                description: `The target of the hypnotic stare treats all enemies beyond 30 feet (except the mesmerist) as having concealment (20% miss chance). Things like true sight and blindsight do not foil this.`,
            },
            {
                name: "Psychic Inception",
                description: `The hypnotic stare and its penalty can affect creatures that are mindless or immune to mind-affecting effects (such as an undead or vermin). You can also partially affect such a creature with mind-affecting spells and abilities if it's under the effect of your hypnotic stare; it gains a +2 bonus on its saving throw (if any), and if affected, it still has a 50% chance each round of ignoring the effect. Ignoring the effect doesn't end the effect, but does allow the creature to act normally for that round.`,
            },
            {
                name: "Sluggishness",
                description: `The target of the hypnotic stare has all of its speeds reduced by 5 feet per -1 of its penalty (to a minimum of 5 feet), and the hypnotic stare penalty also applies to the target's Reflex saving throws.`,
            },
            {
                name: "Sapped Magic",
                description: `The hypnotic stare penalty also applies to the DCs of spells and spell-like abilities used by the target, and to the target's spell resistance (if any).`,
            },
            {
                name: "Sensed",
                description: `The hypnotic stare penalty also applies to stealth checks, and you can use your hypnotic stare on creatures who you cant see, as long as you have direct line of effect to them, and you choose the correct square when using this ability.`,
            },
            {
                name: "Timidity",
                description: `The hypnotic stare penalty also applies to damage rolls. This penalty is multiplied on critical hits.`,
            },
            {
                name: "Oblivating",
                description: `creatures can attempt Stealth checks opposed by the target's Perception check even if they lack cover or concealment.`,
            },
            {
                name: "Unaided",
                description: `The target of the hypnotic stare is not able to grant or receive flanking bonuses. If the creature is the only living enemy on the map, it also becomes shaken. The shaken effect is a mind-affecting fear effect.`,
            },
            {
                name: "Vulnerable",
                description: `The hypnotic stare penalty also applies to the target's Fortitude saves.`,
            },
            {
                name: "Disquiet",
                description: `The target of the hypnotic stare is shaken while in areas of total darkness.`,
            },
            {
                name: "Exposed",
                description: `The target of the hypnotic stare has its armor class reduced by 2x the penalty of your stare when a creature is confirming a critical hit against it.`,
            },
            {
                name: "Dampening",
                description: `The hypnotic stare penalty also applies to the target's resistance to a single form of energy, multiplied by 2, chosen by you when you initiate the stare. If you target a form of energy to which the target has no resistance, this improvement has no effect.`,
            },
            {
                name: "Impediment",
                description: `The target of your hypnotic stare must succeed at a concentration check (DC = 15 + the level of the spell) to activate any of its spell-like abilities (but not standard spellcasting). If the target fails the check, the spell-like ability doesn't function but is still expended.`,
            },
            {
                name: "Mundanity",
                description: `The hypnotic stare penalty also applies to the target's spell resistance. If the creature is at least 3 alignment steps away from yours, the penalty to their spell resistance is doubled.`,
            },
            {
                name: "Withering",
                description: `The hypnotic stare penalty also applies to attack rolls and damage rolls, but only if the target is an outsider.`,
            },
            {
                name: "Wrathful",
                description: `If a creature is at least 3 alignment steps away from you, the penalties created by your stare increase by 1. If they are 4 steps away this increases to 2.`,
            },
            {
                name: "Shattering",
                description: `The hypnotic stare penalty also applies to the creatures damage reduction.`,
            },
            {
                name: "Hypnotic Aura",
                description: `You can cause your hypnotic stare to instead target all creatures within 10 feet of you.`,
            },
            {
                name: "Encouraging Look",
                description: `You can cause your hypnotic stare to instead turn its penalties into circumstance bonuses.`,
            },
            {
                name: "Solipsism",
                description: `Your hypnotic stare also grants you concealment against the target, unless it can see invisible creatures. If it cant, 1 round after you begin your stare, you gain the effect of invisibilty against it. If you take an action that would break invisibilty, that ends your stare. If you get this perk again, you instead are granted the benefit of greater invisibility instead of invisibility.`,
            },
            {
                name: "Phantasmal Foes",
                description: `Your hypnotic stare convinces the creature is is surrounded by foes. The target is treated as flanked for any melee attacks against it. You can choose whether to apply this stare perk or not when activating your stare, but when you do, all other penalties it gives are reduced by 2.`,
            },
            {
                name: "Corrosion of Sanity",
                description: `When a creature affected by your hypnotic stare fails an initial saving throw against a single target mind-affecting effect you created, the target also takes 1 point of wisdom damage.`,
            },
            {
                name: "Phantasmal Force",
                description: `When you use hypnotic stare on a creature, you can also pull out a mirror to show to a creature, it must succeed a will saving throw DC= 10 + level/2 + highest mental or become compelled to either flee from your stare, leaving its range, or make a CMB check against you to sunder the mirror (or do something that would destroy you and the mirror, such as AoE spells) It can also choose to avert its eyes or close them such as with a gaze attack.`,
            },
            {
                name: "Hate-Monger",
                description: `Any creature making an attack against the target of your hypnotic stare gains a morale bonus equal to your hypnotic stares penalty to their attack and damage against them.`,
            },
            {
                name: "Continued Animation",
                description: `When you are using hypnotic stare on a living target and the target dies, as an immediate action you can force the target's soul to remain in the body, then control it as dominate monster. Using this costs 6 + level spell points every round to maintain. The creature gains a number of temporary hit points equal to 2 × your level and continues acting as though it were alive and conscious until it loses those temporary hit points or the duration expires. During this time, the creature counts as undead, but it can't be healed by negative energy.`,
            },
            {
                name: "Excruciating",
                description: `The extra damage from hypnotic stare increases by level/2, or +2 per dice rolled if you deal the damage yourself.`,
            },
            {
                name: "Intense Glare",
                description: `The penalty from your hypnotic stare increases by 1.`,
            },
        ],
        tricks:[
            {
                name: "Astounding Avoidance",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains a +1 circumstance bonus to reflex saves, +1 per 6 levels. You can trigger this trick when the subject attempts a saving throw against an attack or spell that normally deals half damage on a successful save, before the subject rolls the save. If the subject succeeds at their save, they takes no damage. If you're 10th level or higher, the subject takes only half damage if they fail their save.`,
            },
            {
                name: "Focus Mind",
                type: ["minor"],
                description: `You cannot implant this on yourself. While this trick is implanted, the subject reduced the cost of spells cast by 1 spell point (cannot reduce the cost of spells below 0). You can trigger this trick when the subject attempts a concentration check, they gain a bonus to the roll equal to your highest mental modifier.`,
            },
            {
                name: "Break Stupor",
                type: ["minor"],
                description: `The mesmerist can trigger this trick whenever the subject is under an effect that would be ended by the subject taking damage or by an obvious threat. The trick sends a momentary phantom threat and sensation of pain, ending the effect. This ability works fast enough to prevent a sleeping creature from falling prone or dropping what it is holding, if the mesmerist uses it immediately. The mesmerist can also trigger the trick if the subject becomes confused as per confusion, but if he does so, the subject attacks the closest creature to it on its next turn, as if they had attacked them.`,
            },
            {
                name: "Stop Stupid",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains a +1 bonus on any reroll or roll twice taking the higher result. This increases by +1 every 5 levels. You can trigger this trick whenever the subject had declared use of an ability that they have to declare before the roll is made, but after the outcome is determined decides that they didn't need, to allow them to retroactively no longer have used that ability. You can also trigger this when an outcome is determined, but the subject had had an ability they needed to declare before the roll is made to use, they can now retroactively use that ability.`,
            },
            {
                name: "Threatening Mien",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains your level/2 circumstance circumstance bonus on intimidate checks. You can trigger this trick when the subject moves adjacent to an enemy. Enemies adjacent to the subject take a -4 penalty on attacks against targets other than the subject. This trick lasts for 1 round per level.`,
            },
            {
                name: "Compel Alacrity",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains a +1 dodge bonus to armor class, +1 per 6 levels. You can trigger this trick when the subject begins their turn within an enemy's reach. The subject can move 10 feet as a free action without provoking attacks of opportunity. The distance the subject can move increases by 5 feet for every 5 levels you have. The subject can't move farther than their speed in this way. The movement from this trick doesn't count against the subject's movement speed for that round.`,
            },
            {
                name: "Chain of Eyes",
                type: ["minor"],
                description: `While this trick is implanted, you gain a +1 circumstance bonus, +1 per 4 levels on perception checks as long as you and the subject are within 30 feet of each other. You trigger chain of eyes by closing your eyes and concentrating on the implanted subject, allowing you to see and hear everything the target experiences with their own senses of sight and hearing (including any special senses or magical effects). Then, for 1 round, you can cause the target of the hypnotism to be the origination point of any of your purely mental abilities. You cannot implant this trick on yourself.`,
            },
            {
                name: "False Flanker",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains a +1 circumstance bonus to on attack and damage rolls against creatures it is flanking, +1 per 8 levels. This requires the creature to actually be flanking it, not acting as if they were flanking it. This bonus is doubled on the turn you trigger this trick, and it no longer requires you actually be flanking it. You can trigger this trick when the subject moves into or begins thier turn in a square where they threaten an enemy. An illusory duplicate of you appears in any unoccupied space adjacent to that enemy. This duplicate counts as threatening the enemy for the purposes of determining flanking, but can't actually make attacks. The duplicate disappears at the end of the turn during which the trick is triggered. This is an illusion (figment) effect, and a creature that interacts with the false flanker can attempt a saving throw to disbelieve the effect.`,
            },
            {
                name: "Fearsome Guise",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains your level/2 circumstance circumstance bonus on intimidate checks. You can trigger this trick when the subject attacks a creature. An illusory appearance briefly makes the subject appear monstrous, then ends. You attempt an Intimidate check to demoralize the target of the subjects attack. The restrictions on attempts to demoralize a target (the target being within 30 feet and able to see and hear the creature attempting the Intimidate check) apply to the subject of the trick. This is an illusion (glamer) effect.`,
            },
            {
                name: "Fleet in Shadows",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains your level/2 circumstance bonus on stealth checks. You can trigger this trick whenever the target enters an area with dim or darker light. The subject can move double its normal speed (up to an additional 30 feet) for 1 round, but only while moving through areas of dim or darker light. Additionally, the subject can move at its normal speed and use the bonus speed from this trick in areas of total darkness, even if it cannot see.`,
            },
            {
                name: "Gift of Will",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains a +1 circumstance bonus on will saving throws, +1 per 6 levels. You can trigger this trick when the subject attempts a Will saving throw, or is targeted by an Intimidate check to demoralize them. The subject uses your Will saving throw bonus instead of their own, or can add your highest mental modifier as a bonus to the save or the DC of the intimidate check against them, your choice. You can't implant this trick on yourself.`,
            },
            {
                name: "Levitation Buffer",
                type: ["minor"],
                description: `While this trick is implanted, attacks of opportunity against the subject take a -1 penalty, -1 per 4 levels. You can trigger this trick when either an enemy moves adjacent to the subject or the subject begins their turn with one or more enemies adjacent to them. You can either lift all enemies adjacent to the subject slightly into the air or push them all away from the subject. Lifting enemies causes them to move at half speed and take a -4 penalty to their CMDs against bull rush, drag, and reposition attempts for 1 round (Will negates). The speed reduction and CMD penalty don't stack with those from hostile levitation. Pushing enemies away requires you to attempt a bull rush combat maneuver check using your level + highest mental mod as your CMB. Any enemy that's successfully pushed moves away from the subject of the trick using the normal rules for a bull rush.`,
            },
            {
                name: "Mask Misery",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains a +1 circumstance bonus on fortitude saves, +1 per 6 levels. You can trigger this trick when the subject becomes affected by the fascinated, shaken, dazed, frightened, sickened, or confused condition, the condition is delayed for 1d4 rounds. The duration it is delayed counts towards the status's duration.`,
            },
            {
                name: "Meek Facade",
                type: ["minor"],
                description: `While this trick is implanted, you gain a +1 circumstance bonus to your armor class as long as you are within 15 feet of the subject, +1 per 6 levels. You do not gain this bonus if you are the subject of this hypnotism. You can trigger this trick when the subject misses a creature with an attack. The enemy must attack no one other than the subject, and the subject gains a +2 dodge bonus to AC against the triggering enemy's attacks. Both of these effects last for 1 round. The bonus to AC increases by 1 for every 5 levels you possesses. This is a mind-affecting compulsion effect.`,
            },
            {
                name: "Mesmeric Mirror",
                type: ["minor"],
                description: `While this trick is implanted, the first time an individual creature attacks the subject the attack suffers a 25% miss chance, this stacks with other miss chances (but is rolled separately), and is a glammer illusion effect. You can trigger this trick when the subject is attacked or becomes the target of a spell that requires an attack roll. One duplicate of the subject appears, and the attacker must determine randomly which it hits (as mirror image). For every 5 levels you possesses, one additional image appears. Each image lasts for 1 minute per level or until destroyed. This is an illusion (figment) effect.`,
            },
            {
                name: "Mesmeric Pantomime",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains a +2 circumstance bonus on either strength or dexterity based skill checks (your choice when implanting), +1 per 4 levels. You can trigger this trick when the subject attempts a Strength- or Dexterity-based skill check. The subject either uses your bonus on the skill check in place of their own or gains a morale bonus on the check equal to your highest mental mod, Whichever results in a higher modifier. You can't implant this trick on yourself.`,
            },
            {
                name: "Misdirection",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains your level/2 circumstance bonus on bluff checks. You can trigger this trick when the subject makes an attack or uses a spell that requires an attack roll. You attempt a Bluff check to feint against a single target of the subject's attack. Unlike a normal feint, this ability can be used on non-melee attacks. If the feint succeeds, the target of the attack is denied its Dexterity bonus to AC against the triggering attack. The target doesn't suffer any additional effects that you or the subject would cause on a normal feint or Bluff check. This is an illusion (glamer) effect.`,
            },
            {
                name: "Psychosomatic Surge",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains 1, +1 per 4 levels temporary hit points at the start of each of their turns. You can trigger this trick after the subject takes damage. The subject gains a number of temporary hit points equal to 1d8 + level, increasing by 1d8 every 4 levels. If the damage from the triggering attack would have reduced the subject to 0 hit points or fewer, the temporary hit points are doubled. These temporary hit points last for 1 minute or until discharged.`,
            },
            {
                name: "Reflect Fear",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains a +1 circumstance bonus on saves against fear, +1 per 6 levels. You can trigger this trick when the subject is affected by a fear effect or is the target of an Intimidate check to demoralize it. When the trick is triggered, the subject suppresses the fear effect that triggered the trick for 1d4 rounds, and any creature that caused this effect must succeed at a Will save or become shaken for 1 round. The rounds during which the subject ignores the triggering fear effect still count against the effect's duration. If the duration of the reflect fear trick is longer than the fear effect lasts, the subject isn't affected by the fear effect at all.`,
            },
            {
                name: "Reflection of Weakness",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains a +1 circumstance bonus on saves against abilities or effects that cause ability damage, drain, or bleed. You can trigger this trick when an attack or spell used by an enemy causes the subject to take ability damage, ability drain, or bleed damage, the amount of damage or drain the subject takes is reduced by 2 points (to a minimum of 0 points), and the creature that made the attack or cast the spell takes 2 points of ability damage to an ability score of your choice. The monster can attempt a Will save to negate the ability damage. This ability can be used if the attacker inflicts a curse, disease, or poison that deals ability damage or drain, but only if it deals that damage immediately, with no onset time.`,
            },
            {
                name: "Double",
                type: ["minor"],
                description: `While this trick is implanted, you gains a +1 circumstance bonus to your armor class, +1 per 4 levels, and the subject takes the same amount as a penalty to their armor class as long as you are adjacent to each other. You can trigger this trick when you are targeted by an attack, provided you are adjacent to the subject, to give the attack a 50% miss chance. If the attack misses you, it targets the subject instead. This is an illusion (glamer) effect.`,
            },
            {
                name: "Help Me",
                type: ["minor"],
                description: `You can trigger this trick when you are reduced below 0 hit points or subject to a condition that will stop you from taking actions, such as stunned or nauseated. The subject gains a standard action to immediately provide you with some help. Whatever they spend their time on must be something directly benefitial to you, such as healing you or removing a condition from you. If they are unable to provide this during this standard action, they can take actions that will allow them to do so on their next turn, but MUST do so on their next turn or they become filled with despair, taking no actions for 1 round. On their next turn after you trigger this, the subject is staggered.`,
            },
            {
                name: "Open Third Eye",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains level/2 circumstance bonus on perception checks. You can trigger this trick when the subject would lose its ability to see for any reason, including darkness and blindness. The subject restores its ability to see, and gains blindsight 60 feet for 3 rounds.`,
            },
            {
                name: "Shadow Splinter",
                type: ["minor"],
                description: `While this trick is implanted, all of the damage the subject takes from enemies is reduced by 1. This damage is stored, and when you trigger this trick the damage is added to the damage of this ability. This resets at the end of a floor. You can trigger this trick when the subject takes damage from an attack. The damage the subject takes is reduced by an amount equal to your level/2 x your highest mental modifier. Another creature within range of the original attack, other than the attacker, is affected by a shadow illusion that makes it appear as if the attacker is attacking that creature instead of the attacker's actual target. This second creature takes an amount of damage equal to the amount by which the attack's damage was reduced. The target can attempt a Will save to disbelieve the effect. If it succeeds at this save, it neither takes the damage nor believes the attacker targeted it. This trick can't be triggered if there's no eligible second creature within range to take the redirected damage. This is an illusion (shadow) effect.`,
            },
            {
                name: "Slip Bonds",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains level/2 circumstance bonus on escape artist checks. If the subject becomes grappled, pinned, shackled, or otherwise personally restrained, you can trigger the trick and cause the subject to become incorporeal just long enough to slip their bonds (unless they can otherwise restrain an incorporeal creature). This effect doesn't last long enough for the subject to move through walls or other barriers. If you are 12th level, the subject remains incorporeal until the beginning of your next turn.`,
            },
            {
                name: "Spectral Smoke",
                type: ["minor"],
                description: `While this trick is implanted, the first time an individual creature attacks the subject, the attack suffers a 25% miss chance, this stacks with other miss chances and is a illusion (figment) effect. You can trigger this trick when the subject is targeted by an attack or by a spell that requires an attack roll. A smoke cloud appears in the subject's square and in a 10-foot radius around it. This cloud lasts for 1 round per level. The cloud functions as fog cloud, but is an illusion (figment) effect that can't be dispersed by wind and can be used underwater. A creature that interacts with the cloud can attempt a saving throw to disbelieve the effect. The radius of the cloud increases by 5 feet for every 5 caster levels you possesses.`,
            },
            {
                name: "Telepathic Link",
                type: ["minor"],
                description: `While this trick is implanted, the first time an individual creature attacks the subject, the attack suffers a 25% miss chance, this stacks with other miss chances and is a illusion (figment) effect. You can trigger this trick whenever you and the subject are outnumbered in combat, for 1 round, plus an additional round every 6 levels, you can communicate telepathically, and you can target them with touch spells and perks, no matter your range.`,
            },                
            {
                name: "Vanish Weapon",
                type: ["minor"],
                description: `You can trigger this trick when the subject is targeted by a weapon attack, before the attack roll is made. You attempts a stealth check opposed by the attacker's Perception check. If you succeed, that attack automatically misses, and the weapon used appears stowed on their person. If the attack is made with a two-handed weapon, the attacker gains a +4 bonus on its Perception check. Unusually massive weapons (such as boulders or ballista bolts) and attacks generated by natural attacks or spell effects are not affected by this ability.`,
            },
            {
                name: "Voice of Reason",
                type: ["minor"],
                description: `While this trick is implanted, the subject gains a +1 insight bonus on saving throws as long as you are also making the saving throw, and succeed against it, +1 every 4 levels. If you fail, they take a -1 penalty. You can trigger this trick when you and the subject are making a saving throw against an effect, you roll first, and if you succeed the subject gains an insight bonus equal to your highest mental modifier to the save, if you fail, they gain a -2 penalty. You cannot implant this trick on yourself.`,
            },
            {
                name: "Allay Pain",
                type: ["masterful"],
                description: `While this trick is implanted, the subject gains DR 3/-, +1 every 4 levels after 8th. This DR stacks with any other DR they may have. You can trigger this trick after the subject takes damage to grant the subject DR /- equal to twice your level and gain 100% fortification until the start of their next turn.`,
            },
            {
                name: "Avian Escape",
                type: ["masterful"],
                description: `While this trick is implanted, the subject gains a +1 dodge bonus to armor class, +1 per 6 levels, and level/3 circumstance bonus on acrobatics and fly checks. You can trigger this trick when the subject takes damage, this causes them to turn into an avian(as beast shape 3) and to immediately fly up to 120 feet as an immediate action. This movement does not provoke attacks of opportunity`,
            },
            {
                name: "Concealing Veil",
                type: ["masterful"],
                description: `While this trick is implanted, the subject gains level/2 circumstance bonus on stealth checks. You can trigger this trick when the subject is using the stealth check to hide and is about to be detected by another creature because of its extraordinary senses, such as truesight or tremorsense, those senses no longer allow it to detect the creature for 1 round, plus 1 round for every 6 levels past 8th. Its normal vision can still detect it.`,
            },
            {
                name: "Cursed Sanction",
                type: ["masterful"],
                description: `While this trick is implanted, any creature that is making a saving throw against the subjects abilities takes a -1 penalty on its saving throws. You can trigger this trick when the subject is attacked or becomes the target of a spell that requires an attack roll. The attacker takes a -4 penalty on attack rolls, saves, ability checks, and skill checks for 1 minute. A successful will save reduces this to 1 round. Both of these effects are curse effects.`,
            },
            {
                name: "Faked Death",
                type: ["masterful"],
                description: `While this trick is implanted, the subject gains level/2 circumstance bonus on bluff checks. You can trigger this trick when the subject is damaged by an attack. The subject seems to fall down dead (as programmed image), but actually turns invisible (as invisibility) for a number of rounds equal to your level or until they attack. Once the subject becomes visible again, the illusory dead body disappears. These are illusion effects, and a creature that interacts with the false body can attempt a saving throw to disbelieve the effect. The false body is a figment; the invisibility is a glamer.`,
            },
            {
                name: "Frightful Countenance",
                type: ["masterful"],
                description: `While this trick is implanted, attacks against the subject take a -1 penalty, increasing by 1 every 6 levels past 8th. You can trigger this trick when the subject is targeted by an attack or by a spell that requires an attack roll. The attacker must succeed at a Will save or the attack misses and the attacker immediately becomes shaken for 1d4 rounds. This is a mind-affecting fear effect.`,
            },
            {
                name: "Free In Body",
                type: ["masterful"],
                description: `While this trick is implanted, the subject gains level/2 circumstance bonus on escapre artist checks, and can make escape artist checks as a movement action. You can trigger this trick when the subject begins its turn grappled or under an effect that impedes its movement (including paralysis, solid fog, slow, and web). The subject gains the benefits of freedom of movement for 1d6 rounds.`,
            },
            {
                name: "Greater Mask Misery",
                type: ["masterful"],
                description: `While this trick is implanted, the subject gains a +1 circumstance bonus on fortitude saves, +1 per 6 levels. You can trigger this trick when the subject becomes affected by the fascinated, shaken, dazed, confused, frightened, sickened, cowering, nauseated, panicked, or stunned conditions, the condition is delayed for 1d4 rounds. The duration it is delayed counts towards the status's duration.`,
            },
            {
                name: "Avenge Me",
                type: ["masterful"],
                description: `While this trick is implanted, the subject gains a +1 morale bonus to attack and damage against any creature that is currently threatening you in melee. This increases by +1 every 4 levels. You can trigger this when you take hit point damage from an attack as long as you are within 60 feet of the subject. The subject is immediately gains a +6 bonus to their strength and dexterity scores, but a -6 penalty to their armor class for level/2 rounds. The subject must make an attack or otherwise damage the target who damaged you every round or this immediately ends and the subject takes a -4 penalty to all d20 rolls for 1d4 rounds. If the creature dies before this ends, the subject gains a +4 bonus to all attack, damage, and saves for 1d4 rounds instead.`,
            },
            {
                name: "Die For Me",
                type: ["masterful"],
                description: `While this trick is implanted, every time you take damage, 5 points of it is transfered to the subject of this trick. You can trigger this trick whenever you would take hit point damage from an attack, spell, or effect and the subject is with 60 feet of you. Half the damage is psychically transferred to the subject, and any additional effects of the attack that dealt the damage is transfered to the subject, such as poison or being grappled. This is an enchantment (compulsion) effect.`,
            },
            {
                name: "Mental Fallback",
                type: ["masterful"],
                description: `You can trigger this trick when the subject is affected by a charm or compulsion effect created by an enemy. The subject acts as though you had cast the spell instead of the enemy. For instance, if the subject were affected by charm monster cast by an enemy, that enemy can't try to give them orders, but you could. If the charm or compulsion causes penalties or conditions (such as those imposed by confusion, crushing despair, or hold person), the subject can ignore any of those penalties or conditions you chooses. This trick overrides the charm or compulsion for a number of rounds equal to your level or until the duration of the triggering effect elapses, whichever comes first. you can't implant this trick on yourself.`,
            },
            {
                name: "Shadow Blend",
                type: ["masterful"],
                description: `While this trick is implanted, the subject gains level/2 circumstance bonus on stealth checks. You can trigger this trick whenever the subject attempts a Stealth check, the subject is immediately shrouded in darkness, gaining total concealment from all enemies unless they have the see in darkness special ability. Once triggered, this effect lasts for 1 round per level or until the subject breaks their stealth.`,
            },
            {
                name: "Spatial Switch",
                type: ["masterful"],
                description: `You can trigger this trick when an enemy moves adjacent to or attacks either the subject or you, provided you and the subject are within 100 feet of one another. You and the subject then swap positions. If this trick was triggered by an attack, the swap happens before checking to see whether the attack hits. You can't implant this trick on yourself. This is a conjuration (teleportation) effect.`,
            },
            {
                name: "Spell Anticipation",
                type: ["masterful"],
                description: `Implanting this trick requires a standard action,and its costs double if you implant it while decending floors. When you implant this trick, you must expend one spell slot to couple a spell you know with the trick. That spell must have a casting time of 1 standard action or less and be able to target one creature (spells like dominate person that have more restrictive targeting can be used, but have no effect if triggered against creatures that don't match). You can trigger this trick when the subject is targeted by an enemy's spell. Your spell then triggers, affecting only the enemy spellcaster. This takes effect only if the enemy spellcaster is within range of the spell (as measured from the subject of the trick), and functions as though you were in the subject's square. The enemy's spell still has its full effect, even if your spell would normally protect against it or make the caster unable to cast it.`,
            },
            {
                name: "Surprise Delivery",
                type: ["minor"],
                description: `Implanting this trick requires a standard action and has a range of touch, and if you do it while decending a floor, it costs twice as much. When implanting this trick, you also expend a spell slot for a damage spell you know. Then, when the subject walks adjacent to an enemy, you can trigger this trick to cause the spell to go off. The subject is the originating source of this spell, and regardless of its normal range, it becomes 5 feet, must target the enemy you triggered it from, and the subject of the trick is also always targeted by it, even if it normally only targets one creature.`,
            },
            {
                name: "Remember the Good Times",
                type: ["masterful"],
                description: `While this trick is implanted, the subject heals 1 additional point of hit points per dice rolled whenever it is subject to a healing spell or ability, +1 per 9 levels. Implanting this trick requires a standard action and has a range of touch, and if you do it while decending a floor, it costs twice as much. When implanting this trick, you also expend a spell slot for a healing spell you know. Then, when you trigger this trick, the spell goes off. The subject is the originating source of this spell, and regardless of its normal range or targeting, it now only affects the subject of this trick.`,
            },
            {
                name: "Vision of Blood",
                type: ["masterful"],
                description: `While this trick is implanted, the subject gains a +1 circumstance bonus on damage rolls, +1 every 6 levels. You can trigger this trick when the subject hits with an attack using a weapon, a natural weapon, or an unarmed strike. The attack's target must succeed at a Will saving throw or be stunned for 1 round. If the triggering attack was a critical hit, the target doesn't get a saving throw.`,
            },
            {
                name: "Willful Ignorance",
                type: ["masterful"],
                description: `While this trick is implanted, the subject gains level/2 circumstance bonus on stealth rolls. You can trigger this trick when an enemy detects the subject. The target must make a will save or become willfully ignorant of the subject. For 2d4 rounds the creature acts as if the subject didn't exist, unable to target it with attacks, all attacks made by the subject against it automatically target flat-foot, and it wont avoid or prepare for it in any way.`,
            },
            {
                name: "Minor Placebo",
                type: ["masterful"],
                description: `While this trick is implanted, the subject heals 2d8 hit points at the start of each of its turns as long as it is conscious and not afraid, confused, or dazed. You can trigger this trick when the subject takes damage from an enemy, the damage it takes is reduced by 50%.`,
            },
            {
                name: "Placebo",
                type: ["mythic"],
                description: `While this trick is implanted, the subject heals 2d8 + your highest mental hit points at the start of each of its turns, as long as it is conscious and not afraid, confused, or dazed. You can trigger this trick when the subject takes damage from an enemy, it ignores that damage.`,
            },
            {
                name: "Mask Everything",
                type: ["mythic"],
                description: `While this trick is implanted, the subject gains a +1 circumstance bonus on will and fortitude saves, +1 per 6 levels. You can trigger this trick when the subject becomes affected by any condition, even instantaneous ones such as death. The condition is delayed for 1d4 rounds. The duration it is delayed counts towards the status's duration. This has no effect on things like hit point damage. If the subjects's death is delayed, even if at the end of the duration the subject would no longer be dead, it still dies.`,
            },
            {
                name: "Feel Nothing",
                type: ["mythic"],
                description: `While this trick is implanted, the subject gains a DR 8/- and a +5 bonus on saves against pain effects. You can trigger this trick when the subject is about to take damage, it becomes immune to damage until the start of their next turn. Other effects that would still kill them apply normally.`,
            },
            {
                name: "Nostalgia",
                type: ["mythic"],
                description: `You can trigger this trick whenever you desire, as long as the subject is still alive and able to remember the time it wishes to return to. The subject immediately returns to the circumstances of any point within those 2 rounds, including its hit points, spell points, conditions, durations, location, everything. Once you have used this ability on a subject this floor, it cannot be the subject of it again for the rest of the day.`,
            },
            {
                name: "Perfect Focus",
                type: ["mythic"],
                description: `While this trick is implanted, the subject gains a +8 circumstance bonus on all skill checks. You can trigger this trick whenever the subject is making a skill check, they automatically succeed. If the check had multiple degrees of success, it is always the minimum degree of success. Once you use this trick on a subject for them to pass a specific skill check, you cannot use this trick for that skill check again for the rest of the day.`,
            },
            {
                name: "Go Big, or Go Home",
                type: ["mythic"],
                description: `You can trigger this trick whenever the subject is making a d20 roll, instead of rolling a d20, they roll 1d2, a result of 1 results in a natural 1, and a 2 results in a natural 20. Any effects that only trigger on natural 1's and 20's do not activate off this effect.`,
            },
            {
                name: "Implant Consciousness",
                type: ["mythic"],
                description: `While this trick is implanted, the subject can use up to level/2 of your spell points every round. You can trigger this trick when you would die. Instead of dying, your consciousness takes over the body of the subject, and then alters it to be yours. When you take over their body, your equipment all teleports with you and you gain their hit point and spell point amounts (up to your maximums). Any purely physical conditions or statuses affecting them are now affecting you, such as physical ability score damage, paralyzed, stunned, or temporary negative levels. You carry with you any purely mental conditions, such as fear, charmed, damage to your mental ability scores, or permanent negative levels. When you use this, the subject's soul transfers to your body, and they die in your place, trading their physical conditions for yours.`,
            },
            {
                name: "Heroic Promise",
                type: ["mythic"],
                description: `While this trick is implanted, the subject gains a +5 morale bonus to all attack, damage, saves, and skill checks. You can trigger this trick when the subject rolls a d20 roll that results in failure, it can reroll again, taking the new result, even if worse.`,
            },
            {
                name: "Perfect Placebo",
                type: ["mythic"],
                description: `While this trick is implanted, the subject heals 4d8 + your highest mental hit points at the start of each of its turns, as long as it is conscious and not afraid, confused, or dazed. You can trigger this trick when the subject takes damage from an enemy, it ignores that damage and heals 8d8 + 2x your highest mental mod.`,
            },
            {
                name: "Call to Greatness",
                type: ["mythic"],
                description: `While this trick is implanted, whenever the subject rolls a d20, it rolls twice taking the higher result. This hypnotic trick automatically activates whenever the subject rolls a natural 20, the trick ends, but the subject gains an immediate standard action they can take.`,
            },
            {
                name: "Spell Trick",
                type: ["mythic"],
                description: `You can implant a spell trick in a target's mind, when you do you specify the trigger that allows you to trigger it, and what the trick's effects are once it is triggered, by also casting any spell you know (costing the additional spell points). The spell trick duplicates the effects of the chosen spell when triggered, as if you had cast the spell. You are considered the spell's caster for all purposes, and the spell uses your caster level and ability score modifiers for all purposes. You can't choose a spell with a range of personal unless you are implanting the trick in yourself or a target that you can share your spells with (such as via the share spells ability). This otherwise functions as contingency spell.`,
            },
        ]
    },
    {
    rarity: "unique",
    type: "magic",
    name: "Hexes",
    fromClass:"Witch",
    shortDesc: `You gain 4 basic hexes at level 1. Each basic hex is a standard action, costs 2 spell points to use, and has a range of 30 feet (unless specified otherwise).
    \n1) Fortune: You grant a creature good luck for 1 round. The target can call upon this good luck once per round, allowing him to reroll any ability check, attack roll, saving throw, or skill check, taking the better result. He must decide to use this ability before the first roll is made. At 8th level and 16th level, the duration of this hex is extended by 1 round. Once a creature has been the target of this hex, it cannot be targetted again that day.
    \n2) Misfortune: You cause a creature to suffer grave misfortune for 1 round, (will save negates DC=10 + 1/2 level + highest mental). Anytime the creature makes an ability check, attack roll, saving throw, or skill check, it must roll twice and take the worse result. At 8th level and 16th level, the duration of this hex is extended by 1 round. This hex affects all rolls the target must make while it lasts. Whether or not the save is successful, a creature cannot be the target of this hex again. 
    \n3) Cackle: Cackling is a move action. Any creature that is within 30 feet that is under the effects of a BASIC hex caused has the duration of that hex extended by 1 round. 
    \n4) Healing: You heal a target for 1d8 + highest mental, they also gain fast healing 1 for 1 round. The base healing scales with positive spell power. Every 3 levels the initial healing increases by 1d8 + highest mental, the fast healing increases by 1, and the spell point cost increases by 1.
    \n\nAdditionally, twice at first level, then every level after you will also gain a minor hex, these function like basic hexes, except they are swift actions to activate, can be used once per day, cost 1 spell point, and their DC= 10 + level + highest mental.
    \nAt level 6 instead of gaining only minor hexes, you will also potentially gain major hexes. They are like minor hexes but cost 4 spell points. At level 12 you will start gaining grand hexes, they are 8 spell points, and at level 18 you will begin to gain epic hexes, they cost 16 spell points.
    \nYou also gain a control/healing spell every level.
    \n\nGain 2 additional spell points per level`,
    hasCustomMethod:true,
    customMethod: (context,self)=>{
        self.getSpell(context, Math.ceil(context.stats.characterStats.misc.level/2)+1)
        self.getHex(context, self, context.stats.characterStats.misc.level) 
    },
    catchUpMethod: (context,self)=>{
        context.stats.characterStats.misc.spPerLevel += 2
        self.getHex(context, self, 1) 
        for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
            self.getSpell(context, Math.ceil(x/2)+1)
            self.getHex(context, self, x) 
        }
    },
    
    getSpell: (context, lvlNum)=>{
        if(lvlNum > 9){lvlNum = 9}
        let options = {level:{}}
        for(let x = 0; x < 4; x++){
            if(lvlNum-x >= 0){   
                let level = lvlNum-x
                let levelString="lvl"+level;
                options.level[levelString]=true;
            }
        }
        options.type={control:true,healing:true}
        let obj={command:"requestRoll", type:"spell", options};
        context.connection.send(JSON.stringify(obj));
    },

    getHex:(context, self, level)=>{
        let hexRarities = ["minor"]
        if(level >= 6) hexRarities.push("major")
        if(level >= 12) hexRarities.push("grand")
        if(level >= 18) hexRarities.push("epic")
        
        let choices = []
        let chosen = []
        for(let x = 0; x < 4; x++){
            let type = hexRarities[Math.floor(Math.random()*hexRarities.length)]
            let filtered = self.hexes.filter(hex=> hex.type == type)
            let possible = Math.floor(Math.random()*filtered.length)
            while(chosen.includes(possible)) possible = Math.floor(Math.random()*filtered.length)
            chosen.push(possible)
            let option = filtered[possible]
            let description = `\nHex Type: ` + option.type[0] + `\n` + option.description
            choices[x] = {
                title:option.name,
                description,
                id:x,
                method:(context =>{
                    let perk = {rarity:"unique", name:option.name, id:Math.random()*1000000, additionalInfoTags:option.additionalInfoTags, type:"magic", shortDesc:description}
                    context.stats.lists.perks.push(perk)
                })
            }                
        }
        let custom = {title:"Hexes Selection", options:choices}
        context.customDialogArray.push(custom)
    },
    hasSpecialItems:true,
    getSpecialItemList:(self)=>{
        return self.hexes
    },
    hexes:[
        {
            name: "Fortune's Blessing",
            type: ["minor"],
            description: `You grant a creature within 30 feet a good luck for 1 round. During the time, the target can reroll any ability check, attack roll, saving throw, or skill check, taking the better result. Every 6 levels the duration of this hex is extended by 1 round.`,
            },
            {
            name: "Misfortune's Curse",
            type: ["minor"],
            description: `You can cause a creature within 30 feet to suffer grave misfortune for 1 round. This ability allows a will saving throw to negate. Anytime the creature makes an ability check, attack roll, saving throw, or skill check, it must roll twice and take the worse result. Every 6 levels the duration of this hex is extended by 1 round. This hex affects all rolls the target must make while it lasts.`,
            },
            {
            name: "Echoing Laughter",
            type: ["minor"],
            description: `You cackle as a swift action, and it extends the duration of your current hexes by 2 rounds instead of 1.`,
            },
            {
            name: "Witches Embrace",
            type: ["minor"],
            description: `You can heal a target within 30 feet for 3d8 + 3x highest mental. This increases by 1d8+highest mental every 3 levels. This scales with positive spell power.`,
            },
            {
            name: "Charm",
            type: ["minor"],
            description: `You charm a creature as the charm monster spell. This allows a will save to negate. Additionally, on the targets first turn it is affected by this, you issue them a single command, as the command spell, which they gain no further saving throw against.`,
            },
            {
                name: "Minor Death Mark",
                type: ["minor"],
                description: `Whenever you damage the creature with a weapon attack, they take an additional 1d6 points of negative energy damage. Every 6 levels the damage increases by 1d6.`,
            },
            {
                name: "Major Death Mark",
                type: ["major"],
                description: `Whenever the creature is damaged with a weapon attack, the creature takes an additional 1d6 points of negative energy damage.`,
            },
            {
                name: "Forced Martyrdom",
                type: ["minor"],
                description: `Whenever the creature is damaged with a weapon attack, the attacker heals 1d4 hit points. Every 6 levels the healing increases by 1d4.`,
            },
            {
                name: "Soul Food",
                type: ["minor"],
                description: `You mark a creature, if it dies within rounds equal to half your highest mental modifier, you restore 1d4 hit points per level and you can recharge a single expended hex.`,
            },
            {
                name: "Adrenaline Surge",
                type: ["minor"],
                description: `You cause a target to have an adrenaline surge, allowing them to take one of the following actions as an immediate action:
                \nMake an attack at its highest base attack bonus
                \nMove their speed, provoking as normal
                \nMake an escape artist attempt, with a bonus equal to your caster level
                \nDraw a weapon, or an item from their bag. Drawing a weapon this way does not provoke, however getting an item from the bag provokes as normal.
                \nStand up from prone, provoking as normal`,
            },
            {
                name: "Call to Action",
                type: ["major"],
                description: `You cause all allies within 30 feet, excluding you, to have an adrenaline surge, allowing them to take one of the following actions as an immediate action:
                \nMake an attack at its highest base attack bonus
                \nMove their speed, provoking as normal
                \nMake an escape artist attempt, with a bonus equal to your caster level
                \nDraw a weapon, or an item from their bag. Drawing a weapon this way does not provoke, however getting an item from the bag provokes as normal.
                \nStand up from prone, provoking as normal`,
            },
            {
            name: "Ameliorating",
            type: ["minor"],
            description: `You attempt to suppress or protect a creature from a negative condition. When you use this hex, select one of the following statuses: dazzled, fatigued, shaken, sickened. For the next 10 minutes, the creature gains a +4 bonus on saves against abilities that apply this status to them. If they are afflicted with the status, it is suppressed for highest mental mod rounds. Once this suppression begins, the other effects of the hex end, and it cannot suppress anymore effects.`,
            },
            {
            name: "Aura of Purity",
            type: ["minor"],
            description: `You purify the air around you. In a 10-ft radius around you, gaseous effects (such as stinking cloud), are negated, your allies within the range gain a +4 bonus on saves against disease or poison. This aura lasts 1 round, plus an additional round every 6 levels.`,
            },
            {
            name: "Totem of Ill-Omen",
            type: ["minor"],
            description: `[totem] You summon a totem of ill-omen in a square within 15 feet of you that contains the body of a creature. An enemy within 10 feet of a totem of ill-omen receives a -2 penalty on all saving throws. This totem has 3 hit points per level, 10 armor class, and lasts the creatures HD/2 rounds (minimum 1).`,
            additionalInfoTags:["Totem"],
            },
            {
                name: "Totem of Vulnerability",
                type: ["minor"],
                description: `[totem] You summon a totem of ill-omen in a square within 15 feet of you that contains the body of a creature. An enemy within 10 feet of a totem of ill-omen receives a -2 penalty to its armor class. This totem has 3 hit points per level, 10 armor class, lasts the creatures HD/2 rounds (minimum 1).`,
                additionalInfoTags:["Totem"],
            },
            {
                name: "Blood Totem",
                type: ["minor"],
                description: `[totem] You can summon a blood totem in a square within 15 feet of you that contains the body of a creature. At the start of each of your turns, any ally within 10 feet of the totem, heal 2d8 + highest mental hit points. This totem lasts rounds equal to the creatures HD/3 (minimum 1). This totem has 3 hit points per level, 10 armor class.`,
                additionalInfoTags:["Totem"],
            },
            {
                name: "Beastial Totem",
                type: ["minor"],
                description: `[totem] You can summon a beast totem in a square within 15 feet of you that contains the body of a creature. At the start of each of your turns it will make a single attack against an enemy adjacent to it. Its attack mod is equal to the dead creatures BAB + their strength or dex mod, and deals 1d8+ 1.5x of the creatures strength mod for damage, with a critical threat range equal to a natural or manufactured weapon the dead creature had. This totem lasts rounds equal to the creatures HD/3. This totem has 3 hit points per level, 10 armor class, but gains half the dead creatures natural armor bonus. This totem counts as occupying a square for attacks and movement, it can take a single attack of opportunity per round, and counts as an ally.`,
                additionalInfoTags:["Totem"],
            },
            {
                name: "Elemental Totem",
                type: ["minor"],
                description: `[totem] You can summon an elemental totem in a square within 15 feet of you that contains the body of a creature. At the start of each of your turns it will make a single attack against an enemy within 20 feet of it. This is a ranged touch attack, and deals damage of one element of your choice (fire, cold, acid, electricity). Its attack mod is equal to the dead creatures BAB + its highest mental mod or dex mod, and deals 1d6 + the creatures highest mental modifier damage. This totem lasts rounds equal to the creatures HD/4. This totem has 3 hit points per level, 10 armor class, but gains a deflection bonus equal to dead creatures highest mental modifier. This totem counts as occupying a square for attacks and movement, but cannot take attacks of opportunity.`,
                additionalInfoTags:["Totem"],
            },
            {
                name: "Guardian Totem",
                type: ["minor"],
                description: `[totem] You can summon a guardian totem in a square within 15 feet of you that contains the body of a creature. All creatures within 15 feet of the totem gain a +2 deflection bonus to their armor class and a +2 resistance bonus to their saves. This bonus increases by half the creatures wisdom modifier. This totem has 3 hit points per level, 10 armor class, but gains a deflection bonus equal to dead creatures highest mental modifier. This totem lasts rounds equal to the dead creatures HD/3 (minimum 1).`,
                additionalInfoTags:["Totem"],
            },
            {
                name: "Pillar Totem",
                type: ["minor"],
                description: `[totem] You can summon a pillar totem in a square within 15 feet of you that contains the body of a creature. This totem fills the space of the dead creature, height included, and is made of pure stone. This totem has 900 hit points per 5-foot square and 3 armor class. Once per round as a free action you can cause the pillar totem's height to increase or decrease by 5 feet. A pillar totem lasts the creatures HD rounds, but every time you grow it, its duration reduces by 1 round.`,
                additionalInfoTags:["Totem"],
            },
            {
                name: "Chanting Totem",
                type: ["minor"],
                description: `[totem] You can summon a chanting totem in a square within 15 feet of you that contains the body of a creature. All creatures within 15 feet of the totem gain a +2 morale bonus to their attacks and damage rolls. This bonus increases by half the creatures charisma modifier. This totem has 3 hit points per level and an AC of 10. A chanting totem lasts the creatures HD/3 rounds (minimum 1). `,
                additionalInfoTags:["Totem"],
            },
            {
                name: "Divine Totem",
                type: ["major"],
                description: `[totem] You can summon a divine totem in a square within 15 feet of you that contains the body of a creature. All creatures that end their turn within 15 feet of the totem restore 3d8 + the creatures HD/2 hit points. If the creature has spell-like abilities or caster levels in a divine casting class, this healing increases by 1d8 per level of spells the creature could cast. This totem has 3 hit points per level and an AC of 10. A divine totem lasts the creatures HD/4 rounds (minimum 1).`,
                additionalInfoTags:["Totem"],
            },
            {
                name: "Destruction Totem",
                type: ["major"],
                description: `[totem] You can summon a destruction totem in a square within 15 feet of you that contains the body of a creature. All creatures that end their turn within 15 feet of the totem take 1d6 points of elemental damage (of an element of your choice) per 4 HD of the creature. If the creature has spell-like abilities or caster levels in an arcane casting class, this damage increases by +1 per dice, for each level of spells the creature could cast. Creatures are allowed a reflex saving throw to half it, DC 10+creatures HD/2 + creatures highest mental mod. This totem has 3 hit points per level and an AC of 10. A destruction totem lasts the creatures HD/3 rounds.`,
                additionalInfoTags:["Totem"],
            },
            {
                name: "Spirit Totem",
                type: ["major"],
                description: `[totem] You can summon a spirit totem in a square within 15 feet of you that contains the body of a creature. All creatures that end their turn within 15 feet of the totem gain 2d6 + the creatures con mod temporary hit points. These temporary hit points stack with each other. This totem has 3 hit points per level and an AC of 10. A spirit totem lasts the creatures HD/4 rounds.`,
                additionalInfoTags:["Totem"],
            },
            {
                name: "Channeling Totem",
                type: ["major"],
                description: `[totem] You can summon a channeling totem in a square within 15 feet of you that contains the body of a creature. You can use a channeling totem to deliver melee touch attacks made as apart of abilities or spells as long as you are within 30 feet of it. Its attack bonus is equal to the dead creatures base attack bonus. This totem has 3 hit points per level and an AC of 10. A channeling totem lasts the creatures HD/5 rounds.`,
                additionalInfoTags:["Totem"],
            },
            {
                name: "Iron Totem",
                type: ["major"],
                description: `[totem] You can summon an iron totem in a square within 15 feet of you that contains the body of a creature. Any creature within 15 feet of an iron totem gains the damage reduction of the slain monster. This totem has 3 hit points per level and an AC of 10 + the dead creatures natural armor bonus, and DR equal to the amount it gives. An iron totem lasts the creatures HD/5 rounds (minimum 1).`,
                additionalInfoTags:["Totem"],
            },
            {
                name: "Time Totem",
                type: ["grand"],
                description: `[totem] You can summon a time totem in a square within 15 feet of you that contains the body of a creature. Any creature that starts its turn within 10 feet to a time totem gains the bonuses of being affected by the haste spell for 1 round. This totem has 3 hit points per level and an AC of 10. A time totem lasts the creatures HD/5 rounds (minimum 1).`,
                additionalInfoTags:["Totem"],
            },
            {
                name: "Decoy Totem",
                type: ["major"],
                description: `[totem] You can summon a decoy totem in a square within 15 feet of you that contains the body of a creature. The first time per turn that a creature within 15 feet of this totem is attacked, this totem puts itself between the target of the attack, taking the attack for them, then returns to its original location. This totem has 10 hit points per level and an AC of the creature slain. A decoy totem lasts the creatures HD/4 rounds (minimum 1).`,
                additionalInfoTags:["Totem"],
            },
            {
                name: "Sacrifical Totem",
                type: ["grand"],
                description: `[totem] You can summon a sacrifical totem in a square within 15 feet of you that contains the body of a creature. Whenever a creature within 10 feet of the sacrifical totem takes damage, the damage is reduced by half, and that damage is redirected to this totem. This totem has 10 hit points per level and an AC of the creature slain. A decoy totem lasts the creatures HD/4 rounds (minimum 1).`,
                additionalInfoTags:["Totem"],
            },
            {
                name: "Life and Death Totem",
                type: ["epic"],
                description: `[totem] You can summon a life and death totem in a square within 15 feet of you that contains the body of a creature. Any creature within 15 feet to a life and death totem gains the benefit of the deathless spell. This totem has 3 hit points per level and an AC of 10. A life and death totem lasts the creatures HD/5 rounds (minimum 1).`,
                additionalInfoTags:["Totem"],
            },
            {
                name: "Space Totem",
                type: ["grand"],
                description: `[totem] You can summon a space totem in a square within 15 feet of you that contains the body of a creature. Any creature within 15 feet of a space totem can spend a free action once per turn to teleport to any other square within the range of a space totem. This totem has 3 hit points per level and an AC of 10. A space totem lasts the creatures HD/5 rounds (minimum 1).`,
                additionalInfoTags:["Totem"],
            },
            {
            name: "Witches Treat",
            type: ["minor"],
            description: `As a part of the activation of this hex you can draw a potion and either drink or throw it at an ally within 50 feet. Both of these actions provoke as normal. A potion used this way also scales with your positive spell power.`,
            },
            {
            name: "Cauldron",
            type: ["minor"],
            description: `Activating this hex is a full-round action and provokes attacks of opportunity. Make a spellcraft roll DC 10, if you succeed your party gains 1 random curative or mnemonic potion (your choice). For each 10 you beat the DC by, your party gains another additional curative or mnemonic potion.`,
            },
            {
            name: "Scent",
            type: ["minor"],
            description: `You highten a creature's sense of smell, giving it the scent special ability in a 30-foot range, and they gain a bonus to their perception equal to your highest mental. This lasts level/2 rounds.`,
            },
            {
            name: "Mortal Eyes",
            type: ["minor"],
            description: `You transfigure a creatures eyes, cursing it with the simple vision of the common man. This hex allows a fortitude save to negate, otherwise the subject loses the use of darkvision, greensight, low-light vision, see in darkness, truesight, or any other visual abilities beyond simple sight. This does not affect nonvisual means of perception like blindsight, scent, or tremorsense, nor does it modify any other ability that may require their eyes. If the creature has a gaze attack, the DC of the gaze reduces by 2. This lasts 1 round, plus 1 per 4 levels.`,
            },
            {
            name: "Hypnosis",
            type: ["minor"],
            description: `You lull an enemy into a trance. A creature is allowed a will save to negate this, otherwise they are fascinated for 1 round. Every 4 levels this duration increases by 1 round.`,
            },
            {
            name: "Sands of Time",
            type: ["minor"],
            description: `The creature's movement speed is reduced by 5 feet. Each round its movement speed is reduced by a further 5 feet. Once its movement speed would reach 0 feet this hex ends. The creature can make a fortitude saving throw each round on its turn, if successful the total penalty to its speed is reduced by half for that round. This is an aging effect.`,
            },
            {
            name: "Cursed Wound",
            type: ["minor"],
            description: `You curse a living creature, preventing it from healing. It is allowed a will save to negate this. For level/2 rounds, whenever the victim is the target of a conjuration (healing) spell or magical healing effect, the caster of the healing effect must succeed at a caster level check (DC = 15 + level) to end the hex. If they fail, the healing is negated.`,
            },
            {
            name: "Blood Curse",
            type: ["minor"],
            description: `You curse a living creature, destroying its natural ability to heal. The creature is allowed a fortitude save to negate this. For 3 rounds, the creatures natural (though not magical) fast healing and regeneration are negated. Every 8 levels the duration of this hex increases by 1 round.`,
            },
            {
            name: "Curse of Black Blood",
            type: ["minor"],
            description: `You curse a living creature, it does not get a save to negate this. The creature takes a -4 penalty on saving throws against poison and disease for 1 round. Every 4 levels the duration of this increases by 1 round.`,
            },
            {
            name: "One More Time",
            type: ["minor"],
            description: `You activate this hex as an immediate action in response to an ally within 30 feet failing a saving throw, it can roll again, taking the new result even if it would be lower, however it gains a bonus on this reroll equal to your highest mental modifier.`,
            },
            {
            name: "Deathcall",
            type: ["minor"],
            description: `You curse a creature to take penalties based on its closeness to death. A creature below 50% hit points takes a -2 penalty on attacks, saves, and ability checks. when below 25% this increases to -4, and when below 10% it increases to -8. This lasts for 1 minute, but the penalty is based on the hit points the creature had when you activated this hex.`,
            },
            {
            name: "Discord",
            type: ["minor"],
            description: `You create an aura of discord in a 30-foot radius around you. Creatures within the aura have a hard time working together and cannot benefit from the bonuses of a teamwork feat (except betrayal feats), aid another, or from flanking. This aura lasts level/2 rounds, though can be dismissed as a swift action.`,
            },
            {
            name: "Distraction",
            type: ["minor"],
            description: `You can cause a creature to suffer hallucinatory distractions whenever it tries to cast a spell or use a spell-like ability for 3 rounds. Anytime the creature attempts to do so, it must succeed at a concentration check (DC = 20 + twice the spell level) or lose the spell. A successful Will saving throw negates this hex. Every 6 levels, the duration of this hex is extended by 1 round.`,
            },
            {
            name: "Enemy Ground",
            type: ["minor"],
            description: `You curse a target with clumsiness when in dangerous terrain. The target takes a -5 penalty on acrobatics checks to move through restrictive terrain, or to avoid attacks of opportunity, and additionally attacks of opportunity against them gain a +2 bonus. The first 2 rounds a creature is affected by this curse, it acts as though all terrain is difficult terrain. This hex lasts 1 minute. The target is allowed a will save to reduce the duration of this hex to 2 rounds, and the initial effect to 1 round.`,
            },
            {
            name: "Evil Eye",
            type: ["minor"],
            description: `You curse a target to allow doubt to creep into their mind. The target takes a -2 penalty on one of the following (your choice): AC, ability checks, attack rolls, saving throws, or skill checks. This hex lasts for a number of rounds equal to 3 + highest mental modifier. A Will save reduces this to just 1 round. This is a mind-affecting effect. Every 5 levels the penalty increases by an additional -1.`,
            },
            {
            name: "Lighten",
            type: ["minor"],
            description: `You lighten a creature, effecting them as the levitate spell. This lasts level/3 rounds. If you have the flight hex, you can spend expend this hex as well when activating it to instead extend its duration by 3 rounds.`,
            },
            {
            name: "Gift of the Beast",
            type: ["minor"],
            description: `You transmogrify a creature with the aspects of an animal, this allows you to grant them one of the following bonuses. Each of these bonuses is an enhancement bonus and lasts level/2 rounds: \n1: +10 bonus on acrobatics, climb, or swim checks \n2: +10 bonus to its non-magical movement speeds \n3: +5 bonus on perception, stealth, or survival checks \n4: +1 bonus on a physical ability score`,
            },
            {
            name: "Gift of Consumption",
            type: ["minor"],
            description: `Whenever you are exposed to an effect that requires you to attempt a Fortitude save, as an immediate action you can curse a creature to share the effect. The hexed creature must also attempt a Fortitude save at the same DC, and on a failure it is subject to the same effects as you. This hex does not function with effects that require additional types of saves, such as phantasmal killer.`,
            },
            {
            name: "Toughen Hide",
            type: ["minor"],
            description: `This hex grants the creature a +4 racial bonus to its natural armor, and resistance 10 to fire and cold for level/2 rounds.`,
            },
            {
            name: "Mother's Eye",
            type: ["minor"],
            description: `You select an ally, for 1 minute you can see through that creatures eyes. This allows you to target hexes against creatures you cant see, as long as they can, or use their position of it would be more advantageous for concealment. This also allows you to use their special vision abilities, such as darkvision, low-light, truesight, or other similar abilities. If the target of this hex is affected by a gaze attack, you are also subject to it. This may cause you to be affected by a gaze multiple times at once. This hex lasts level rounds.`,
            },
            {
            name: "Murksight",
            type: ["minor"],
            description: `You transform a creatures eyes for level rounds, allowing it to see through natural fog, mist, and rain without penalty, ignoring any concealment bonuses gained from such effects. If the effect is created by magic, the target can see up to 15 feet without penalty, with normal penalties and effects applying beyond that distance. This ability functions underwater as well, allowing the target to see in murky water as though it were clear.`,
            },
            {
            name: "Nails",
            type: ["minor"],
            description: `You cause the nails on a creature to grow long and sharp for level rounds. They count as secondary natural weapons, dealing 1d3 piercing damage 20x2. If the creature already had a claw attack, you increase the dice step of those claw attacks by 1.`,
            },
            {
            name: "Aura of Safety",
            type: ["minor"],
            description: `You create a 20-ft aura around you for level/3 rounds (minimum 1). Allies within this aura gain a +2 morale bonus on saving throws while within this aura. You can end this aura as an immediate action when an ally fails a saving throw within it, doubling the bonus they gain while within the aura. If this is done against an ability that caused multiple allies within the aura to make the save, only the creature you selected with this ability get the bonus to their save. Every 8 levels the bonus increases by +1.`,
            },
            {
            name: "Protective Luck",
            type: ["minor"],
            description: `You can cause fate to twist so that it benefits a creature for 1 round. Whenever that creature is targeted by an effect that requires an attack roll, including weapon attacks, the attacker must roll twice and take the worse result. Every 6 levels the duration of this hex is extended by 1 round. You cannot use this hex on yourself.`,
            },
            {
            name: "Scar",
            type: ["minor"],
            description: `This hex requires you to touch the target, creating a scar on their body that lasts for 1 round + 1 round/4 levels. You can cast spells and hexes on the creature regardless of the spells range for the duration of this hex.`,
            },
            {
            name: "Slumber",
            type: ["minor"],
            description: `You cause a creature to fall asleep if they fail a will save as if they had the spell sleep cast on them, except that it can affect a creature of any HD and lasts 1 round instead. Every 6 levels the duration of this hex increases by 1 round.`,
            },
            {
            name: "Water's Blessing",
            type: ["minor"],
            description: `You transform a creature so that it gains a swim speed equal to its ground speed for rounds equal to your level. You can also use this hex on an enemy, this lowers their swim speed by 30 feet(minimum 5 feet), though a fortitude saving throw reduces the duration to 1 round.`,
            },
            {
            name: "Ward",
            type: ["minor"],
            description: `A witch can use this hex to place a protective ward over one creature. The warded creature receives a +4 deflection bonus to AC and a +4 resistance bonus on saving throws. This ward lasts until the warded creature is hit or fails a saving throw. You cannot use this hex on yourself. Every 4 levels these bonuses increase by an additional +1. This hex lasts the rest of the floor or until lost.`,
            },
            {
            name: "Spirit Sacrifice",
            type: ["minor"],
            description: `This hex is used as a free action you can take even when not on your turn. When an ally who has more than 0 hit points is reduced below 0 hit points, you can heal them for 3d8 + level hit points. You cannot heal yourself with this hex this way. You take damage equal to half hit points healed. Every 4 levels you can increase the healing by an additional 1d8.`,
            },
            {
            name: "Prehensile Hair",
            type: ["minor"],
            description: `You can cause your hair to grow up to 10 feet long or to shrink to its normal length. This lasts for 5 rounds plus an additional round every 4 levels. You can manipulate your hair as if it were a limb with a Strength score equal to your highest mental score. Your hair has reach 10 feet, and you can use it as a secondary natural attack that deals 1d3 points of damage (1d2 for a Small witch). Your hair can manipulate objects (but not weapons) as dexterously as a human hand. The hair cannot be sundered or attacked as a separate creature. Using your hair does not harm your head or neck, even if you lift something heavy with it.`,
            },
            {
            name: "Great Blessings and Curses",
            type: ["minor"],
            description: `As long as you have not expended this hex, a creature currently being affected by one of your benefitial hexes (not healing) or a buff spell you cast, gains a +1 sacred bonus on a single type of roll (your choice), attack, damage, saves. A creature affected by one of your detrimental hexes (not damaging) or a control spell, takes a -1 penalty on the same roll type. All creatures gain the same bonus or penalty. You choose the penalty or bonus when you gain this perk, otherwise changing the bonus or penalty is a swift action. Every 8 levels the bonus and penalty increases by 1. You can expend this hex as a free action you can take even when not your turn to cause an ally or enemny within 30 feet to reroll a d20 roll they just made. They must take the second result even if worse.`,
            },
            {
            name: "Summer's Heat",
            type: ["minor"],
            description: `You surrounds your target with oppressive heat, dealing a number of points of nonlethal damage equal to 3x your level and causing the target to become fatigued. The target can attempt a Fortitude save to reduce this nonlethal damage by half and negate the fatigued condition.`,
            },
            {
            name: "Swine",
            type: ["minor"],
            description: `You partially transform an enemy into a pig (Will negates). This hex has its DC increased by your second highest mental mod. The effects of the transformation are mostly cosmetic and do not change the creature's size category or overall shape, but the affected creature takes a -2 penalty on Will saving throws, and on on claw, talon, bite, and tail attacks. This transformation lasts for a number of rounds equal to your highest mental mod. Every 6 levels these penalties increase by an additional -1.`,
            },
            {
            name: "Fetish Magic",
            type: ["minor"],
            description: `As long as this hex is not expended the DC of your control spells and of your hexes increases by +1. You can expend this hex as a free action, the next spell or hex you use on your turn has its DC increased by your second highest mental mod, or by +1, +1 for every 6 levels, your choice.`,
            },
            {
            name: "Draconic Resilience",
            type: ["minor"],
            description: `You can grant a creature some of the magically resilient nature of dragons, causing the creature to be immune to magical sleep effects for a number of rounds equal to your level/2, and resistance equal to your level against a specific elemental damage type. At 7th level, the creature is also immune to paralysis for this duration.`,
            },
            {
            name: "Fury",
            type: ["minor"],
            description: `You incite a creature into a primal fury. The target receives a +2 morale bonus on attack rolls and a +2 resistance bonus on saving throws against fear for a number of rounds equal to your level/2. Every 6 levels these bonuses increase by +1.`,
            },
            {
            name: "Shaped Form",
            type: ["minor"],
            description: `You can grant an ally a +2 size bonus to either their strength or dexterity score for level/4 rounds (minimum 1). Every 6 levels this bonus increases by +1.`,
            },
            {
            name: "Silkstring Snare",
            type: ["minor"],
            description: `You cause ribbons of spider silk to erupt from the ground beneath a single creature. The target must succeed at a Reflex save or be entangled and anchored in place. The foe can escape the silk as a standard action with a successful Escape Artist or Strength check at the same DC, or by dealing an amount of damage to the silk equal to double your level (the silk has hardness 0). This hex lasts a number of rounds equal to your highest mental modifier.`,
            },
            {
            name: "Wings",
            type: ["minor"],
            description: `You can grow a pair of wings for a number of rounds equal to your level/2. Initially, these wings lack the power to allow you to fly, but you can use them as a single secondary natural attack that deals 1d3 points of damage (1d2 for a Small shaman). At 5th level, you can use the wings to fly with poor maneuverability and a fly speed of 30 feet, but you must land at the end of each turn or fall. At 9th level the wings allows you to fly with average maneuverability and a fly speed of 30 feet while the wings are active. At level 11 you can activate this hex on allies as well.`,
            },
            {
            name: "Ancestral Blessing",
            type: ["minor"],
            description: `You grant the blessings of your ancestors to all allies within 30 feet. The blessed creatures receives a +4 competence bonus on attack and damage rolls. This blessing lasts until the benefit is used on 1 attack or 24 hours. Every 3 levels the bonus increases by +1. Every 8 levels it lasts an additional attack.`,
            },
            {
            name: "Battle Master",
            type: ["minor"],
            description: `For level/2 rounds (minimum 1) the target can make an additional attack of opportunity each round and gains a +1 to attack and damage with weapon attacks. Every 6 levels the bonus to damage increases by +1.`,
            },
            {
            name: "Battle Ward",
            type: ["minor"],
            description: `You touch a creature and grant a battle ward. The next time a foe makes an attack roll against the target, the ward activates and grants a +6 deflection bonus to the warded creature's AC. Each subsequent time they are attacked, the defection bonus reduces by 1. The ward fades when the bonus is reduced to +0, or after 24 hours, whichever comes first. Every 3 levels the ward's starting bonus increases by +1.`,
            },
            {
            name: "Eyes of Battle",
            type: ["minor"],
            description: `You magically highten a creatures senses become in the heat of battle. You can grant them a +15 insight bonus on Perception checks made to notice and pinpoint invisible creatures, and they can ignore the affects of cover or partial cover (but not total cover), and reroll any miss chance taking the better result. This hex lasts 1 round, plus an additional round ever 4 levels.`,
            },
            {
            name: "Hampering Hex",
            type: ["minor"],
            description: `This hex causes a creature within to take a -2 penalty to AC and CMD for a number of rounds equal to your level/2. A successful Will saving throw reduces this to just 1 round. Every 6 levels the penalty increases by -1.`,
            },
            {
            name: "Bone Lock",
            type: ["minor"],
            description: `You cause a creature to suffer stiffness in the joints and bones, causing the target to be staggered 1 round. A successful Fortitude saving throw negates this effect. At 8th level, the duration is increased to a number of rounds equal to your level, though the target can attempt a save each round to end the effect if its initial saving throw fails as a free action. At 16th level, remaking the save is a full-round action, although it still attempts the initial Fortitude saving throw to negate the effect entirely.`,
            },
            {
            name: "Fearful Gaze",
            type: ["minor"],
            description: `With a single shout, you cause one target creature to become shaken for 1d4 rounds. A successful Will saving throw negates this effect. At 8th level, you make the target frightened instead. At 16th level, you make it panicked instead. This is a mind-affecting fear effect.`,
            },
            {
            name: "Bone Ward",
            type: ["minor"],
            description: `You grant a bone ward to a creature, making it encircled by a group of flying bones that grant it a +2 shield bonus to AC for a number of rounds equal to your level. At 8th level, the ward increases to +3 and lasts for 1 minute. At 16th level, the bonus increases to +4 and lasts for 1 hour.`,
            },
            {
            name: "Cinder Dance",
            type: ["minor"],
            description: `As long as you have not expended this hex your base movement speed increases by 10 feet. You can activate this hex to allow an ally to walk through 5 feet of difficult terrain per movement as if it was normal terrain and their movement speed increases by 10 feet. This lasts level/2 rounds. Every 4 levels you increase the amount of difficult terrain the target can walk through by 5 feet. If you activate this hex on yourself the bonus to movement instead becomes 15 feet.`,
            },
            {
            name: "Fire Nimbus",
            type: ["minor"],
            description: `You surround a creature in a nimbus of fire. Though this doesn't harm the creature, it does cause the creature to emit light like a torch, preventing it from gaining any benefit from concealment or invisibility. The target also takes a -2 penalty on saving throws against spells or effects that deal fire damage. The fire nimbus lasts for a number of rounds equal to your level/2. A successful Will saving throw reduces the duration of this effect to 1 round. Every 8 levels the penalty on saves increases by -1.`,
            },
            {
            name: "Ward of Flames",
            type: ["minor"],
            description: `You grant a creature a ward of flames. The creature gains fire and resistance equal to your level, and the next time the warded creature is struck with a melee attack, the creature making the attack takes 1d6 + level points of fire damage, and the ward is expended. This otherwise lasts 1 minute. Every 3 levels this lasts an additional attack.`,
            },
            {
            name: "Hypothermia",
            type: ["minor"],
            description: `You afflict a creature with hypothermia. On a failed save, the target is fatigued for 2d4 rounds. Every 8 levels, the duration of this hex is extended by 2 rounds. The target may attempt a Fortitude saving throw to reduce the duration to a single round.`,
            },
            {
            name: "Sluggish",
            type: ["minor"],
            description: `You cause the speed of a creature to be halved. The target can attempt a Fortitude saving throw to reduce the duration of this effect to 1 round. The penalty lasts for a number of rounds equal to your level/3 (minimum 1) and does not stack with other effects that reduce speed.`,
            },
            {
            name: "Heaven's Leap",
            type: ["minor"],
            description: `You are adept at creating tiny tears in the fabric of space and temporarily stitching them together to reach other locations through a limited, one-way wormhole. You can choose to either teleport an ally within 30 feet of you to a square adjacent to you, or teleport yourself to a square adjacent to an ally.`,
            },
            {
            name: "Enhanced Cures",
            type: ["minor"],
            description: `As long as you have not expended this hex your spells and abilities that heal hit points by rolling dice, have their healing increased by your highest mental stat. You can expend this hex as a swift action, doing so allowed you to cast or use an ability that heals hit points as apart of the swift action to activate this hex. If the ability would have any other effects other than healing, those aspects of the ability or spell do not function.`,
            },
            {
            name: "Deny Succor",
            type: ["minor"],
            description: `The target of this hex does not heal damage from conjuration(healing) spells and does not benefit from any spells or effects that remove conditions. This effect lasts for a number of rounds equal to 1/2 level. A successful Will saving throw reduces this effect to 1 round.`,
            },
            {
            name: "Link Fate",
            type: ["minor"],
            description: `You create a bond between yourself and another creature. Each round at the start of your turn, if the bonded creature is wounded for 5 or more hit points below its maximum hit points, it heals 5 hit points and you take 5 points of damage. Once you reach level 6, the hit points healed and drained increases to your level. This bond lasts until the end of the floor. You can end as many bonds as you'd like as an immediate action.`,
            },
            {
            name: "Curse of Suffering",
            type: ["minor"],
            description: `You curse a creature to take more damage from bleed effects and causes its wounds to heal at a slower rate. When the cursed creature takes bleed damage, it takes 1 additional bleed damage (even if the bleed is ability damage). Furthermore, when the target is subject to an effect that would restore its hit points, that effect restores only half the normal amount of hit points. This curse lasts for level/2 rounds.`,
            },
            {
            name: "Brain Drain",
            type: ["minor"],
            description: `You violently probes the mind of a single intelligent enemy. The target can attempt a Will saving throw to negate the effect. On failure, it's wracked with pain and takes 1d4 points of damage per level. On the round following your successful use of this ability, you can take a swift action to regain spell points equal to your highest mental mod, plus the highest mental mod of the creature.`,
            },
            {
            name: "Confusion Curse",
            type: ["minor"],
            description: `Your command of lore can cause weaker minds to become mired in confusion. Choose a single intelligent creature, it must make a will save or become confused for a number of rounds equal to your highest mental modifier (minimum 1).`,
            },
            {
            name: "Accident",
            type: ["minor"],
            description: `You cause a target to stumble and fall. You attempt a trip attempt, using your level + your highest mental mod, against the target's CMD against trip attempts. On a successful check, the target falls prone and takes 1d6 points of damage. If the target is adjacent to a pit or similar drop-off, he must also succeed at a Reflex save or fall into the pit. Any increase to the DC of control spells or hexes instead become a bonus to your caster level check, but are multiplied by x2.`,
            },
            {
            name: "Ward of the City",
            type: ["minor"],
            description: `The spirit of the city shrouds one creature from hazards. The warded creature gains a +5 bonus on saves against disease and poison, and a +25% bonus on percentage chances to negate critical hits and sneak attacks. (This stacks with effects such as fortification, or abilities that grant a creature with no chance to negate critical hits a flat 25% chance.) Each time the ward is used (whether the roll is successful or not), the bonuses are reduced by 1 and 5%, respectively. The ward ends when the bonuses are reduced to 0, or after 24 hours, whichever comes first. Every 4 levels the ward's starting bonuses increase by 1 and 5%, respectively.`,
            },
            {
            name: "Doors to Everywhere",
            type: ["minor"],
            description: `Your hex creates a portal between two places, teleporting a creature within 30 feet of you, to another place within 30 feet of you. The creature must be able to willingly walk through the portal, must take an immediate action to do so, and must have a movement speed higher than 5 feet. You can also use this ability as an immediate action while another creature within 30 feet of you is declaring an attack, doing so allows the creature to make the attack against any creature within 30 feet of you. `,
            },
            {
            name: "Lodestone",
            type: ["minor"],
            description: `You cause one creature to become heavy and lethargic. The creature is treated as if it were carrying a medium load. If the creature is already carrying a medium load, it is instead treated as if it were carrying a heavy load. If the creature is carrying a heavy load, its maximum Dexterity bonus to AC is reduced to +0, it takes a -9 armor check penalty, and its movement is reduced to 5 feet. The effect lasts for a number of rounds equal to the your level. A successful Will saving throw negates this effect.`,
            },
            {
            name: "Metal Curse",
            type: ["minor"],
            description: `You cause a creature to become slightly magnetic until the end of your next turn. Whenever the creature is attacked with a melee or ranged weapon constructed primarily of metal, it takes a -2 penalty to AC. Every 8 levels the penalty increases by -2 and the duration extends by 1 round.`,
            },
            {
            name: "Stone Stability",
            type: ["minor"],
            description: `The target of this hex gains a +5 bonus to their CMD when resisting bull rush or trip attempts as long as they are standing on the ground, and they do not provoke attacks of opportunity when making trip or bull rush attempts. If they already did not provoke them, they gain a +4 bonus to those attempts. The bonus to their CMD increases by +1 every 5 levels. This hex lasts level/2 rounds (minimum 1).`,
            },
            {
            name: "Ward of Stone",
            type: ["minor"],
            description: `You grant a willing creature a ward of stone. The next time the warded creature is struck with an attack, it is treated as if it has DR adamantine equal to your level. This ward lasts for 1 minute or until expended. Every 4 levels the ward lasts for one additional attack.`,
            },
            {
            name: "Curse of Faltering",
            type: ["minor"],
            description: `As long as this hex us unexpended, creatures take a -4 penalty to confirm critical hits against you. As an immediate action when an enemy threatens a critical hit, you can force the creature to reroll its original attack roll with a penalty equal to your highest mental modifier. The target can attempt a Will save to negate this ability. This is a curse effect.`,
            },
            {
            name: "Curse of Isolation",
            type: ["minor"],
            description: `You target an enemy, making them feel isolated. For a number of rounds equal to the your level, the target gains no benefit from flanking or the aid another action, and it doesn't benefit from morale bonuses. The target can attempt a Will save to reduce the duration of this ability to 1 round. This is a curse effect.`,
            },
            {
            name: "Steadfast Example",
            type: ["minor"],
            description: `You fortify a willing creature's mental and emotional defenses. The next time the target attempts a Will saving throw, the subject can use your Will saving throw bonus instead of his own.`,
            },
            {
            name: "Threatening Coordination Hex",
            type: ["minor"],
            description: `You cause a creature to view the your allies as obstacles. The target treats squares adjacent to your allies as difficult terrain for a number of rounds equal to your level, or for 1 round if the target succeeds at a Will saving throw.`,
            },
            {
            name: "Tribal Cooperation",
            type: ["minor"],
            description: `When you use this hex, all allies within the hexes range gain use of one teamwork feat you have for 1 round. Every 4 levels this lasts an additional round, but all allies must remain within your hex range to gain it.`,
            },
            {
            name: "Touch of Succor",
            type: ["minor"],
            description: `You remove one of the following conditions from a willing creature: fatigued, shaken, or sickened. At 7th level, you add confused and frightened to the list of conditions you can remove. At 10th level, you also adds dazed, nauseated, and panicked.`,
            },
            {
            name: "Crashing Waves",
            type: ["minor"],
            description: `When a you cast a spell that deals deals damage, you can expend this hex. The targets of the spell must make a Fortitude saving throw or be knocked prone. If the spell had the cold or water type, the DC of the spell and this ability both increase by +2.`,
            },
            {
            name: "Hex of Destruction",
            type: ["major"],
            description: `When a you cast a spell that deals deals damage, you can expend this hex. The spell deals 50% more damage as the empower metamagic feat, but without increasing its casting time, spell point cost, or it using a higher level spell slot.`,
            },
            {
            name: "Mist's Shroud",
            type: ["minor"],
            description: `You touch a willing creature and enshrouds that creature in mist. This grants the creature concealment as the blur spell. The mist dissipates after it causes an attack to miss because of concealment or after 1 minute, whichever comes first. Every 2 levels, the mist lasts for one additional attack.`,
            },
            {
            name: "Air Barrier",
            type: ["minor"],
            description: `You create an invisible shell of air that grants the target of the hex a +4 armor bonus to AC. Every 2 levels this bonus increases by 1. At 11th level, this barrier causes incoming arrows, rays, and other ranged attacks requiring an attack roll against them to suffer a 50% miss chance. This hex lasts for the whole floor if used on you, or level/4 (minimum 1) rounds if used on others. Abilities that would bypass strong wind conditions bypass this bonus`,
            },
            {
            name: "Sparking Aura",
            type: ["minor"],
            description: `You cause a creature to spark and shimmer with electrical energy. Though this does not harm the creature, it does cause the creature to emit light like a torch, preventing it from gaining any benefit from concealment or invisibility. Furthermore, while the aura lasts, whenever the target is hit with a metal melee weapon, it also takes an amount of electricity damage equal to the your highest mental modifier, and takes a -2 penalty on saves against electricity spells and abilities. The sparking aura lasts 1 round per 4 levels (minimim 1). `,
            },
            {
            name: "Spines and Brambles",
            type: ["minor"],
            description: `With a beckoning gesture, you conjure spiny shrubs in a number of squares equal to your highest mental modifier (minimum 1) within 30 feet. The squares become filled with light undergrowth and count as difficult terrain for all creatures except you. While in a shrub, a creature gains bonuses from partial cover.`,
            },
            {
            name: "Frozen Caress",
            type: ["minor"],
            description: `Whenever you touch a creature for any other reason, such as delivering a spell or making an unarmed attack, you can activate this hex as a free action to cause the touch to deal an additional 1d4 points of cold damage per level. For 1 round after they take a -2 penalty on saves against cold spells and effects. The creature can make a fortitude saving throw to reduce the damage by half. This scales with cold spell power.`,
            },
            {
            name: "Harden Hide",
            type: ["minor"],
            description: `The target of this hex gains an enhancement bonus to its natural armor equal to half your level. This lasts 1 round, plus an additional round every 4 levels.`,
            },
            {
            name: "Relief",
            type: ["minor"],
            description: `The target restores all damage to a single ability score.`,
            },
            {
            name: "Recalled Hex",
            type: ["minor"],
            description: `You can activate this hex to restore the use of 2 other hexes you have already expended.`,
            },
            {
            name: "Beast's Roar",
            type: ["minor"],
            description: `You can make an intimidation check against all enemies within 30 feet, you gain a bonus on the check equal to your level/2.`,
            },
            {
            name: "Roll the Bones",
            type: ["minor"],
            description: `Roll 1d4 d20's. You store the results of these dice, within the next floor you can change any d20 roll you make with one of these dice, expending it. You must declare replacement of the roll before the results are determined. You must use the dice in the order of lowest to highest.`,
            },
            {
            name: "Shell of Succor",
            type: ["minor"],
            description: `You grant a creature 1d6 + highest mental temporary hit points. Every 3 levels this increases by 1d6. These last for rounds equal to your level. This scales with positive spell power.`,
            },
            {
            name: "Agony",
            type: ["major"],
            description: `You place this hex on one creature within 60 feet, causing them to suffer intense pain. The target is nauseated for a number of rounds equal to your level. A Fortitude save negates this effect. If the saving throw is failed, the target can attempt a new save each round to end the effect.`,
            },
            {
            name: "Beast's Gift",
            type: ["major"],
            description: `The witch can partially transform a willing ally, granting him natural attacks for a number of rounds equal to your level. Choose one: the creature gains one bite attack that deals 1d8 points of damage and one secondary attack of your choice that deals 1d6 points of damage, or the creature gains two claw attacks that deal 1d12 points of damage each. These attacks follow the standard rules for natural attacks. If a creature already has one of these attacks, and has no additional limbs to add them to, you increase the damage those natural attacks deal by 1 size.`,
            },
            {
            name: "Beast's Skin",
            type: ["major"],
            description: `You transform the target ally for 1 round per 3 levels, granting a +4 racial bonus to their natural armor, and either increasing or decreasing their size by 1 step. If you grow them, they gain a +4 size bonus to their strength, if you shrink them they gain a +4 size bonus to their dexterity. The natural armor from this hex stacks with other natural armor granted by hexes (except itself).`,
            },
            {
            name: "Call of the Wild",
            type: ["minor"],
            description: `All creatures within 30 feet of you can expend an immediate action to move up to their movement speed.`,
            },
            {
            name: "Mark of the Hunt",
            type: ["major"],
            description: `You mark a creature for the hunt, all creatures gain a +2 luck bonus to their attacks and damage rolls against them, and all opposed skill checks against the creature. This hex lasts 3 rounds. Every 6 levels this bonus increases by +1.`,
            },
            {
            name: "Beast's Eye",
            type: ["major"],
            description: `You transform the target ally for 1 round per 4 levels, granting one of the following senses: \nDarkvision 60ft. \nLow-light vision \nTremorsense 30ft. \nBlindsense 30ft. \nBlindsight 10ft.`,
            },
            {
            name: "Wardrums",
            type: ["major"],
            description: `You beat your drums of war, inciting all allies within 30 feet into a frenzy. All allies gain a +2 morale bonus to their strength and 2d6 temporary hit points for 3 rounds. Every 3 levels this bonus increases by +1 and the temporary hit points by 1d6. If the target has the rage ability this bonus stacks, but the bonus is reduced by 50%, and they reduce the spell point cost of rage while this is active by 50%. `,
            },
            {
            name: "Ice Tomb",
            type: ["major"],
            description: `A storm of ice and freezing wind envelops the target, which takes 1d6 points of cold damage per 2 levels (Fortitude half). If the target fails its save, it is paralyzed but does not need to breathe while the ice lasts. The ice has 20 hit points; destroying the ice frees the creature, which is staggered for 1 round after being released. Each turn as a full-round action the creature may attempt a strength check to break free.`,
            },
            {
            name: "Healing Aura",
            type: ["major"],
            description: `You channel positive energy to heal all allies within 30 feet of you for 1d8 hit points per level. This scales with positive spell power.`,
            },
            {
            name: "Greater Ameliorating",
            type: ["major"],
            description: `You suppress or protect a creature from a negative condition. When you use this hex, select one of the following statuses: blinded, deafened, cursed, diseased, poisoned. For the next 10 minutes, the creature gains a +4 bonus on saves against abilities that apply this status to them. If they are afflicted with the status, it is suppressed for highest mental mod rounds. You can cackle to extend this suppression duration. However once this suppression begins, the other effects of the hex end, and it cannot suppress anymore effects.`,
            },
            {
            name: "Flight",
            type: ["major"],
            description: `You can cast the fly spell on an ally within 30 feet, however it only lasts 1 round per 2 levels.`,
            },
            {
            name: "Coven",
            type: ["major"],
            description: `You empower the spell casting of an ally within 30 feet (not yourself). The next spell they cast before your next turn has its caster level and DC increased by +2. Any bonuses you gain to the effectiveness of the aid another action also apply to this ability. At level 12 and every 6 levels after these bonuses increase by +1.`,
            },
            {
            name: "Delicious Fright",
            type: ["major"],
            description: `You can feed on the fear of those around you. Whether this hex is expended or not, for each creature within 30 feet of you that is shaken, you gain a +1 morale bonus on attacks and saves. If they are frightened or cowering the bonus becomes +2, and if they are panicked it becomes +3. You can expend this hex to attempt to cause a creature to become shaken for 1d6 rounds, or to increase the severity of a fear effect currently affecting them by 1 step. The target is allowed a will save to negate this. As long as this hex is unexpended your spells and perks that cause a creature to become scared have their DC's increased by +2 (doesn't apply when you activate this hex).`,
            },
            {
            name: "Cook People",
            type: ["major"],
            description: `This hex is not expended when used, and is a standard action to activate. When adjacent to a creature killed within 2 rounds, you can roll a survival check DC = 10 + creature's HD, if you succeed you craft a random curative potion. A creature's body is destroyed by using this effect.`,
            },
            {
            name: "False Hospitality",
            type: ["major"],
            description: `You can roll a diplomacy or bluff check against a creature within 60 feet, DC 10 + sense motive or wisdom modifier, if you succeed they take a -1 penalty to their next save you cause them to make within 1 round. For each 10 you beat the check by increase the penalty by -1. This doesn't work on creatures who cant understand you. If you fail the check, they get a +2 bonus against the next save you cause them to make, +1 for each 5 you failed by.`,
            },
            {
            name: "Harrowing Curse",
            type: ["major"],
            description: `The target of this curse takes a -6 penalty to a random ability score. This penalty lasts 3 rounds, plus an additional round per 6 levels. You gain an enhancement bonus to that ability score equal to half the penalty as long as it lasts (if the creature dies you lose the bonus as well)`,
            },
            {
            name: "Hoarfrost",
            type: ["major"],
            description: `The target is rimed with a shell of frost needles that slowly work their way into its flesh (Fortitude negates). The target turns pale and blue, and takes 1 points of Constitution damage per round until it dies or is cured. It can make a new save as a full-round action to end this hex. Break enchantment, dispel magic, remove curse, and similar spells end the effect. This is a cold effect.`,
            },
            {
            name: "Infected Wounds",
            type: ["major"],
            description: `You cause a creatures wounds to become infected (fort negates) for rounds equal to level/4. As long as the creature took damage in the last round, it takes 1 point of constitution damage. Additionally, Whenever the creature suffers from a critical hit, it also takes 2 points of constitution damage. This is a disease effect.`,
            },
            {
            name: "Pariah",
            type: ["major"],
            description: `You cause a creature within 60 feet to be shunned by its allies for a number of rounds equal to your highest mental modifier. Any other creature attempting to directly assist the target with a harmless spell, aid another action, a teamwork feat, or flanking, (or any other ability that would imply teamwork between the two creatures) must attempt a Will save. If the save succeeds, the aiding creature is unaffected by this hex. If the save fails, the aiding creature can't follow through, the action is lost, and the aiding creature can't directly aid the target for the duration of this hex. This hex does not prevent the target from benefiting from area of effect spells as long as it doesn't select a certain amount of targets.`,
            },
            {
            name: "Regenerative Sinew",
            type: ["major"],
            description: `The witch can cause the debilitating wounds of a creature to quickly close, helping it heal rapidly. The target either gains or increases its fast healing 5 for a number of rounds equal to 1/2 your level or it heals up to 4 points of ability score damage from any two ability scores (your choice). At level 12 and every 6 levels after the fast healing increases by 5 points, and you heal an additional 4 points from any 2 ability scores.`,
            },
            {
            name: "Thrashing Control",
            type: ["major"],
            description: `A creature affected by one of your hexes or control spells taked 1d10 + their strength mod damage at the start of each of their turns. This is physical damage and is dealt by their own weapons or natural attacks. If a creature is affected by multiple of these abilities at once this damage stacks, counting as one source of damage. You gain this bonus whether the hex is expended or not. You can activate this hex as an immediate action when a creature attempt to resave against an ability you created, it takes a -5 penalty on that save. You can activate this hex after you know whether the creature succeeded or not.`,
            },
            {
            name: "Retribution",
            type: ["major"],
            description: `You place a retribution hex on a creature within 60 feet, causing terrible wounds to open across the target's flesh whenever it deals damage to another creature in melee. Immediately after the hexed creature deals damage in melee, it takes half that damage (round down). This damage bypasses any resistances, immunities, or damage reduction the creature possesses. This effect lasts for a number of rounds equal to your highest mental mod. A Will save negates this effect.`,
            },
            {
            name: "Steal Voice",
            type: ["major"],
            description: `The witch can steal the voice of one creature within 30 feet, causing it to lose, for a number of rounds equal to your highest mental mod, all abilities that rely on speech, including talking, casting spells with verbal components, and using auditory bardic performances. A successful Will saving throw negates this effect. For each voice you currently have stolen, your spells with verbal components have their DC's increased by +2.`,
            },
            {
            name: "Dual Hexes",
            type: ["major"],
            description: `Select a minor hex that targets only a single creature, for the cost of both of those hexes plus this one, you can affect 2 creatures with the hex as apart of the same action.`,
            },
            {
            name: "Waxen Image",
            type: ["major"],
            description: `Activating this hex is a movement action. You create a crude and unnerving wax duplicate of a creature you can see within 30 feet. Once the image is complete, the subject must make a Will save. If the subject fails, you gain a small measure of control over the creature. Whenever you exercise this control, the creature receives a new will save to end the effect. This effect occurs on your turn and does not impede the creature's actions on its turn. You can use the waxen image a number of times equal to your highest mental mod before it melts. As a swift action, you can cause the subject to do any one of the following things: move up to the creature's speed in any direction, attack itself once with any weapon in hand (this attack automatically hits), lay down on the ground, or drop anything held, or, you can spend one of your uses to simply torture the image, causing the creature to be both sickened and staggered on its turn. Alternatively, you can expend one of the uses when the creature makes a saving throw, to reduce its saving throw by -2 (this does not allow a save, and must be done before the roll is made). For every successful saving throw against the commands the creature makes, it gains a +2 bonus on its saves vs any further commands. The is an enchantment (compulsion) effect.`,
            },
            {
            name: "Witch's Charge",
            type: ["major"],
            description: `You designate an ally as your charge. You can cast touch spells and hexes on your charge as long as they are within 30 feet of you, as ranged touch attacks. As long as your charge is within 10 feet of your natural reach, they gain a deflection bonus to their armor class equal to your highest mental mod, and as a swift action you can spend level/2 spell points as a free action to cause your charges next attack within 1 round to gain a bonus to its attack roll equal to your highest mental mod.`,
            },
            {
            name: "Expose Weakness",
            type: ["major"],
            description: `The creature takes a penalty to its armor class equal to your highest mental stat for 1 round per 8 levels.`,
            },
            {
            name: "Soften Claws",
            type: ["major"],
            description: `The creature takes a penalty on its damage rolls equal to your highest mental stat for 1 round per 8 levels.`,
            },
            {
            name: "Marked by Fate",
            type: ["major"],
            description: `You curse a creature (will reduces this to 1 round and negates the bonus damage). The creature takes a -4 penalty on armor class, and whenever the creature takes at least 1 point of damage, they take an additional 1d6 points of damage. If the creature is reduced below 0 hit points, you gain level x3 temporary hit points, and level spell points. This hex lasts 3 rounds, plus 1 round per 6 levels.`,
            },
            {
            name: "Gift of the Spirits",
            type: ["major"],
            description: `Choose 3 minor hexes you have already expended, they all become available again.`,
            },
            {
            name: "Quick Chuckle",
            type: ["major"],
            description: `Choose any hex that is currently active with a duration of at least 1 round, it is extended by 1 round.`,
            },
            {
            name: "Greater Relief",
            type: ["major"],
            description: `Restore 2d4 points of ability drain to a single ability score, and all damage from a single ability score.`,
            },
            {
            name: "Adorify",
            type: ["major"],
            description: `You shrink a creature 1 size (fort negates). Additionally, choose one of its natural attacks, this attack deals reduced damage as if it was an additional size smaller. This lasts 1 round per 4 levels.`,
            },
            {
            name: "Wrack",
            type: ["major"],
            description: `You wrack a creatures body and mind with pain, they take 3d6 points of damage per level. The target may make a fortitde save to reduce this damage by half.`,
            },
            {
            name: "Seal Fate",
            type: ["major"],
            description: `You activate this hex as an immediate action in response to a creature rolling a natural 1, the creature takes a -5 penalty on all further d20 rolls for 1 round per 4 levels, or until it rolls a natural 20.`,
            },
            {
            name: "An Extra Grain",
            type: ["major"],
            description: `You activate this hex as an immediate action. The target of this hex can take a 5-foot step, even if they already had this turn. It doesn't provoke as normal.`,
            },
            {
            name: "Open Up",
            type: ["major"],
            description: `You cause a creature to open up its weak spots for your allies. The creature makes a will save, on failure it provokes an attack of opportunity against all allies threatening it. It takes a -4 penalty to its armor class for these attacks. `,
            },
            {
            name: "Bless Fate",
            type: ["major"],
            description: `You activate this hex as an immediate action in response to a creature rolling a natural 20, the creature gains a +5 luck bonus on all further d20 rolls for 1 round per 4 levels, or until it rolls a natural 1.`,
            },
            {
            name: "Death Curse",
            type: ["grand"],
            description: `The hexed creature receives a Will save to negate the effect. If this save is failed, the creature becomes fatigued the first round of the hex. On the second round of the hex, the creature becomes exhausted. On the third round, the creature dies unless it succeeds at a Fort save. Creatures that fail the first save but succeed at the second remain exhausted and take 1d6 points of damage per level. If you are killed this effect ends, but any fatigue or exhaustion remains.`,
            },
            {
            name: "Spirit of The Beast",
            type: ["grand"],
            description: `The hexed creature becomes bestial and ferocious. It gains the pounce special ability, a +2 dodge bonus to armor class, a +2 racial bonus to its natural armor, and +2 bonus on attacks and damage rolls on melee attacks. This lasts 1 round per 4 levels. If the target of this hex does not end its turn within reach of a foe, the duration of the duration of this hex decreases by 1 round.`,
            },
            {
            name: "Time Shudder",
            type: ["grand"],
            description: `Activating this hex is an immediate action. The target of the hex can use an immediate action to take a movement action. Any action taken during this action does not provoke attacks of opportunity.`,
            },
            {
            name: "Animal Frenzy",
            type: ["grand"],
            description: `You cause a creature's body to overextend itself, even at the cost of its health. The target of this hex may take 2 points of constitution damage to make an additional movement action on its turn. It can only ever take 1 additional movement action on its turn. This hex lasts 1 round per 6 levels.`,
            },
            {
            name: "Wither",
            type: ["grand"],
            description: `You cause a creature to slowly wither away. It makes a fortitude save to negate this hex altogether, however if it fails it takes 1 point of dexterity, strength, and constitution drain. Each turn, it must make another fortitude save, or take it again. This continues until the creature dies. This is an aging effect.`,
            },
            {
            name: "Dire Prophecy",
            type: ["grand"],
            description: `The witch curses the target so he is doomed to die (Will negates). As long as the curse persists, the target takes a -4 penalty to his armor class and on attack rolls, saves, ability checks, and skill checks. While the curse persists, the witch may end it by bringing its full force upon her victim all at once as free action that can be done even when not the witch's turn. Doing so gives the victim a penalty equal to your level to their armor class or on any single attack roll, combat maneuver check, opposed ability or skill check, or saving throw. You must decide to apply this penalty before the roll to be modified is made. If you do not have line of sight to the target, the full force of the curse occurs when the GM considers it most appropriate, such as when the target is in mortal danger. A target can only have one dire prophecy upon him at a time. This is a curse effect.`,
            },
            {
            name: "Curse of Nonviolence",
            type: ["grand"],
            description: `The witch can curse a creature to prevent it from attacking. If the target fails its Will save, it cannot take violent actions or do anything destructive against any creature. If another creature takes hostile action against the cursed creature, the cursed creature can act normally in regard to that creature only. This is an abjuration effect. The curse is permanent but can be removed with a break enchantment, miracle, or wish spell.`,
            },
            {
            name: "Gift of Life",
            type: ["grand"],
            description: `You can cast breath of life on a target within 50 feet that has died within 3 rounds that is currently dead, and it does not gain a negative level if brought back by this ability.`,
            },
            {
            name: "Abominate",
            type: ["grand"],
            description: `The witch transforms a creature into an aberration. This hex acts as baleful polymorph (saves included), except the target is transmuted into a Small, Medium, or Large aberration. The target's abilities are modified as monstrous physique IV. This lasts level/2 rounds.`,
            },
            {
            name: "Improved Dual Hex",
            type: ["grand"],
            description: `When you cast this hex, choose two minor or major hexes, both of which must target only a single creature, add the cost of both of those hexes to this one, then you can activate both as apart of the same action.`,
            },
            {
            name: "Grand Ameliorating",
            type: ["grand"],
            description: `You touch a creature to suppress or protect a creature from a negative condition. When you use this hex, select one of the following statuses: nauseated, dazed, stunned, and staggered. For the next 10 minutes, the creature gains a +4 bonus on saves against abilities that apply this status to them. If they are afflicted with the status, it is suppressed for highest mental mod rounds. Once this suppression begins, the other effects of the hex end, and it cannot suppress anymore effects.`,
            },
            {
            name: "Death Interrupted",
            type: ["grand"],
            description: `You can activate this hex as an immediate action when a creature within 60 feet of you would be killed, you can activate this hex to restore 10d8 + level hit points to them, possibly preventing them from death. The target receives your highest mental modifier as a deflection bonus to its armor class until the start of your next turn.`,
            },
            {
            name: "Eternal Slumber",
            type: ["grand"],
            description: `You cause a creature to drift off into a permanent slumber. The creature receives a Will save to negate this effect. If the save fails, the creature falls asleep and cannot be woken. The effect can only be removed with a wish or similar magic, although slaying the witch ends the effect. Additionally, when attempting to make a resave against this effect on its next turn, it takes a -5 penalty unless it took damage since its last turn.`,
            },
            {
            name: "Life Giver",
            type: ["grand"],
            description: `You can touch a dead creature and bring it back to life. This functions as the true resurrection spell, and it cannot be interrupted or dispelled.`,
            },
            {
            name: "Hex Perk",
            type: ["grand"],
            description: `Reduce the action of activating a magic perk by 1 step.`,
            },
            {
            name: "Witches Hut",
            type: ["grand"],
            description: `This hex causes a small hut to spring up around you with a radius of 5 feet. Time moves differently in this hut, acting as time stop, but lasting only 1 round. Any creature within the radius is also affected by the timestop, and they may interact with each other freely.`,
            },
            {
            name: "Fate's Interception",
            type: ["grand"],
            description: `The target of this hex gains a +50 luck bonus to its armor class and a +10 luck bonus to its saves for 1 round.`,
            },
            {
            name: "Shift Luck",
            type: ["grand"],
            description: `You activate this hex as an immediate action in response to a creature rolling a natural 20 or 1, they must reroll the dice and take the new result, a random creature is selected from those currently in combat, their next roll is an automatically the original result of the stolen luck. The creature does not know they have been selected until the actually roll the dice and the outcome is resolved. If the creature you forced to roll again rolls the same result on their reroll, they have either beaten fate, or been marked by fate for death. All of their rolls for 1d3 rounds becomes the result of the stolen luck.`,
            },
            {
            name: "What are the Odds",
            type: ["grand"],
            description: `You activate this hex as an immediate action in response to a creature rolling a natural 1, the creature must roll another d20, if the result is below 14 then creature has the most absurd series of misfortunate events, first it falls prone, if it was flying it falls 50 feet first. If there are any hazards within 15 feet of the creature it automatically falls into it (even if the user of this hex was unaware of them), such as falling into spikes, triggering a trap, or falling off a cliff. They takes 5d10 damage (always a damage type they are the most vulnerable  to) as something ridiculous happens to them such as a piano falling on their head, and lastly they become dazed for 1 round.`,
            },
            {
            name: "Right in the Heart",
            type: ["grand"],
            description: `You can activate his hex as either a swift action, and its benefits last for 1 round, or as an immediate action when an attack within range is a potential critical hit, and then it lasts only for that attack. The attacker's critical damage multiplier increases by +1, and it reduces any fortification or immunity to critical hits by 25%.`,
            },
            {
            name: "Hex Spell",
            type: ["grand"],
            description: `You can cast a spell that has a casting time of a standard action or less as apart of the action to activate this hex.`,
            },
            {
            name: "Step Out for a Moment",
            type: ["grand"],
            description: `You remove a willing creature from time for 1 round. From all other creatures perspectives they simply vanish, reappearing 1 round later as if no time had passed for them.`,
            },
            {
            name: "Spirits of Victory",
            type: ["grand"],
            description: `All allies within 60 feet of you are possessed by spirits of dead heroes. They gain 2d6 temporary hit points per level, a +6 resistance bonus to all of their saving throws, and as a deflection bonus to armor class. These bonuses last until the end of the floor, or until the temporary hit points are removed. A creature that is healed when they have temporary hit points left have the temporary hit points reduced by an amount equal to the healing they receive. `,
            },
            {
            name: "Prepared Hexes",
            type: ["grand"],
            description: `This hex is expended as you enter a floor (or when you gain it), select 3 minor or major hexes you have, they can be used an additional time before they are expended. These additional uses last through floors.`,
            },
            {
            name: "Woe, Plague Be Upon Ye",
            type: ["epic"],
            description: `You throw a plagued creature at a target within 50 feet. The creature must make a fortitude saving throw or contract the turbo plague. If it fails, It becomes nauseated, and at the start of each of its turns it takes 1d4 points of damage to all of its physical ability scores. Once a creature contracts it, it lasts 6 rounds, however once your plagued creature lands, on your next turn it begins to run feverishly around, moving towards the closest unplagued creature, moving 30 feet a round. If it ends its turn on the square of an unplagued creature they must make a fortitude saving throw or contract the turbo plague. The creature's movement does not provoke attacks of opportunity, however a creature can make an attack roll against it, killing it instantly, however when killed, all creatures within a 10-ft radius of the killed plague creature must make a save against the turbo plague. Multiple applications of the turbo plague increase the remaining rounds of its duration and its DC by 2. This is a disease effect.`,
            },
            {
            name: "The Beast Within",
            type: ["epic"],
            description: `The targets critical threat range doubles with all weapon attacks. If the creatures critical threat range was already doubled it instead increases by a flat +1. This hex lasts level/6 rounds. Every time the creature scores a critical hit this hex extends 1 round.`,
            },
            {
            name: "Luckiest Strike",
            type: ["epic"],
            description: `You activate this hex as an immediate action in response to a creature rolling a natural 20 on an attack roll, but before it is determined if it is a successful critical hit, the attack gains the vorpal special ability.`,
            },
            {
            name: "Failure Approaches",
            type: ["epic"],
            description: `The critical failure rate of a creature increases by 2. This means instead of a creature always missing or failing a save on a natural 1, it now also misses on a natural 2 and 3. If there would be additional penalities for rolling a natural 1, this also applies to them rolling a natural 2 or 3. This hex has no saving throw, but remove curse or a similar or more powerful effect removes it. Every time a creature rolls within this critical failure range, the range increases by 1. This is a curse effect.`,
            },
            {
            name: "Spirit's Gift",
            type: ["epic"],
            description: `Activating this hex is a free action. The next spell cast the target casts on this floor can add any metamagic feat they know to the spell without requiring a higher level spell slot or increasing the time it takes to cast it, however it still costs the additional spell points, and it has its DC of the spell is increased by your second highest mental stat.`,
            },
            {
            name: "One More Moment",
            type: ["epic"],
            description: `The target of this hex can expend an immediate action to take a standard action.`,
            },
            {
            name: "Witches Champion",
            type: ["epic"],
            description: `The target of this hex gains a luck bonus to its attack rolls equal to your highest mental stat, a luck bonus to its damage rolls equal to your level, a flat +1 increase to its critical threat ranges, automatically confirms all critical hits, a +30 foot enhancement bonus to its movement speed, and can move through difficult terrain as if it were normal terrain, and cannot die (keep tracking its hit points, like the deathless spell). This lasts 1 round.`,
            },
            {
            name: "Die",
            type: ["epic"],
            description: `The target of this hex must make a will saving throw, if it fails it must also make a fortitude save, if it fails this as well, it dies. If it fails the will save but succeeds the fortitude saving throw, it still takes 1d6 points of negative energy damage per level. This is a death effect.`,
            },
            {
            name: "Dont Die",
            type: ["epic"],
            description: `All allies with 60 feet of you are affect by the heal spell.`,
            },
            {
            name: "Return From the Other Side",
            type: ["epic"],
            description: `All allies within 60 feet of you are affected by the spell raise dead, and gain temporary hit points equal to 5x your level for 1 round.`,
            },
            {
            name: "Final March of the End",
            type: ["epic"],
            description: `All allies gain a +6 morale bonus on their attack rolls, a +12 morale bonus on their damage rolls, when they make a full attack action they can take an additional attack at their highest bonus (this stacks with similar effects), and a +10 bonus to their constitution score. This lasts 3 rounds, at the end of the duration all allies are exhausted.`,
            },
            {
            name: "Call Patron",
            type: ["epic"],
            description: `The full force of your patron descends upon a creature within 60 feet, the creature takes 4d6 points of damage per level. This ability allows a saving throw to halve it, though your patron always chooses to attack them in a way they are least likely to save from, and with a damage type (slashing, bludgeoning, piercing, fire, cold, acid, electricity, force) that the creature is most vulnerable to.`,
            },
            {
            name: "Overflowing With Life",
            type: ["epic"],
            description: `The target of this hex gains fast healing 5 (will negates). Each round the fast healing doubles, once they are full health this healing becomes temporary hit points. If the creature ever has temporary hit points equal to its maximum hit points, it explodes, dying instantly and healing all creatures within 10 feet of it for hit points equal to its maximum hit points. This hex lasts 1 minute, or until the creature explodes.`,
            },                
    ]

    },
    // {
    //     rarity: "unique",
    //     type: "magic",
    //     name: "Hexes",
    //     fromClass:"Witch",
    //     shortDesc: `You gain 4 different basic hexes at level 1, each hex is a standard action to cast unless specified otherwise, a basic hex costs 2 spell point, a major hex costs 8, and a grand hex costs 16. The dc of of these hexes is 10+1/2 level + highest mental modifier, and each a Su effect.
    //     \n1) Fortune: you grant a creature within 30 feet a good luck for 1 round. The target can call upon this good luck once per round, allowing him to reroll any ability check, attack roll, saving throw, or skill check, taking the better result. He must decide to use this ability before the first roll is made. At 8th level and 16th level, the duration of this hex is extended by 1 round. Once a creature has benefited from the fortune hex, it cannot benefit from it again for 10 minute. 
    //     \n2) Misfortune: The witch can cause a creature within 30 feet to suffer grave misfortune for 1 round. Anytime the creature makes an ability check, attack roll, saving throw, or skill check, it must roll twice and take the worse result. A Will save negates this hex. At 8th level and 16th level, the duration of this hex is extended by 1 round. This hex affects all rolls the target must make while it lasts. Whether or not the save is successful, a creature cannot be the target of this hex again for the rest of the combat. 
    //     \n3) Cackle: A witch can cackle as a move action. Any creature that is within 30 feet that is under the effects of a hex caused by the witch has the duration of that hex extended by 1 round. 
    //     \n4) Healing: you can heal a target within 30 feet for 1d8 + your highest mental stat, they also gain fast healing 1 for 1 round, the initial heal increases by 1d8 and the fast healing increases by 1 every 5 levels
    //     \n
    //     \nat level 6 you gain 4 major hexes: 
    //     \n1) Agony: You place this hex on one creature within 60 feet, causing them to suffer intense pain. The target is nauseated for a number of rounds equal to the witch's level. A Fortitude save negates this effect. If the saving throw is failed, the target can attempt a new save each round to end the effect. Whether or not the save is successful, a creature cannot be the target of this hex again. 
    //     \n2) Beast's Gifts: The witch can partially transform a willing ally, granting him natural attacks for a number of rounds equal to the witch's level. Choose one: the creature gains one bite attack that deals 1d8 points of damage and one secondary attack of the witch's choice that deals 1d6 points of damage, or the creature gains two claw attacks that deal 1d12 points of damage each. These attacks follow the standard rules for natural attacks. 
    //     \n3) Ice Tomb: A storm of ice and freezing wind envelops the target, which takes 3d8 points of cold damage (Fortitude half). If the target fails its save, it is paralyzed and unconscious but does not need to eat or breathe while the ice lasts. The ice has 20 hit points; destroying the ice frees the creature, which is staggered for 1d4 rounds after being released. Whether or not the target's saving throw is successful, it cannot be the target of this hex again. 
    //     \n4) Healing Aura: As a movement action you can heal all targets within 20 feet of yourself including yourself for 2d8 + your highest mental stat. This healing increases by 1d8 every 4 levels after 6, and its range increases by 5 feet at level 12 and 18.
    //     \n
    //     \nAt level 8 you gain 2 more major hexes:
    //     \nFlight: You can cast the fly spell at will, however the total duration of flight given cannot exceed rounds per level. At the start of the turn of the affected creature you can decide whether to continue the fly effect. It doesn't cost spell points to use this hex. if you have no rounds of flight left you can use cackle to extend the duration of the flight.
    //     \nCoven: You can use the aid another action to raise the caster level of an ally within 30 feet for their next spell by +1 and increase its DC by +1. At level 16 these bonuses each increase by +1. It doesn't cost spell points to use this hex.
    //     \n
    //     \nat level 12 you gain 3 grand hexes 
    //     \n1) Death Curse: This hex has a range of 30 feet. The hexed creature receives a Will save to negate the effect. If this save is failed, the creature becomes fatigued the first round of the hex. On the second round of the hex, the creature becomes exhausted. On the third round, the creature dies unless it succeeds at a Fort save. Creatures that fail the first save but succeed at the second remain exhausted and take 4d6 points of damage + 1 point of damage per level of the witch. Slaying the witch that hexed the creature ends the effect, but any fatigue or exhaustion remains. Whether or not the saves are successful, a creature cannot be the target of this hex again for 1 day. 
    //     \n2) Dire Prophecy: The witch curses the target so he is doomed to die (Will negates). As long as the curse persists, the target takes a -4 penalty to his armor class and on attack rolls, saves, ability checks, and skill checks. While the curse persists, the witch may end it by bringing its full force upon her victim all at once as free action that can be done even when not the witch's turn. Doing so gives the victim a penalty equal to the witch's caster level to his armor class or on any single attack roll, combat maneuver check, opposed ability or skill check, or saving throw. The witch must decide to apply this penalty before the roll to be modified is made. If the witch does not have line of sight to the target, the full force of the curse occurs when the GM considers it most appropriate, such as when the target is in mortal danger. A target can only have one dire prophecy upon him at a time. Whether or not the target's save against the hex is successful, a creature cannot be the target of this hex again. This is a curse effect.
    //     \n3) Gift of Life: You can cast breath of life on a target within 50 feet that has died within 3 rounds that is currently dead, and it does not gain a negative level if brought back by this ability.
    //     \n
    //     \nAdditionally gain a spell of the control or healing type every level. Spells of the control type have their DC's increased by 1, increasing by 1 every 5 levels.
    //     \n\nGain 2 additional spell points per level`,
    //     hasCustomMethod:true,
    //     customMethod: (context,self)=>{
    //         self.getSpell(context, Math.ceil(context.stats.characterStats.misc.level/2)+1)            
    //     },
    //     catchUpMethod: (context, self)=>{
    //         context.stats.characterStats.misc.spPerLevel += 2
    //         for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
    //             self.getSpell(context, Math.ceil(x/2)+1)
    //         }
    //     },
    //     getSpell: (context, lvlNum)=>{
    //         if(lvlNum > 9){lvlNum = 9}
    //         let options = {level:{}}
    //         for(let x = 0; x < 4; x++){
    //             if(lvlNum-x >= 0){   
    //                 let level = lvlNum-x
    //                 let levelString="lvl"+level;
    //                 options.level[levelString]=true;
    //             }
    //         }
    //         options.type={control:true,healing:true}
    //         let obj={command:"requestRoll", type:"spell", options};
    //         context.connection.send(JSON.stringify(obj));
    //     },                        
    //     },

    {
    rarity: "unique",
    type: "magic",
    name: "Alchemy",
    fromClass:"Alchemist",
    shortDesc: `You become proficient with alchemical items allowing you to:
    \n1) As an attack(though not attack of opportunity) you can create a bomb (provoking attacks of opportunity) and throw it. the bomb deals 1d6 + highest mental damage +1d6 for every odd level after 1st. This costs 1 spell point per dice. When you select alchemy choose one element (cold, acid, fire, electricity), your bomb deals damage of this type, and scales with spell power. Every 8 levels you can select a new damage type (choose which element when on bomb creation). On a direct hit you deal full damage to the target of the bomb, and minimum damage to all targets within 5 feet unless they make a reflex save. The dc of this is 10+1/2 level + highest mental stat. This bomb has a range increment of 10 feet, and for a direct hit you must make a ranged touch attack. This bomb cannot be given to anybody else to throw. You can two-weapon fight with bombs. You require a free hand to make bombs.
    \n2) As a standard action for the cost of 1 spell point per the potions level you can use a potion as a thrown weapon, throwing it as you would a regular bomb, if you get a direct hit you can apply the affects of that potion to the target. The effects of the potion do not count as an effect you applied, but the effects of a potion.
    \n3) All curative potions you drink yourself or throw at a teammate scales with your positive spell power, and all grenade gear you use gain your highest mental stat to their DC instead of your BAB if it would be higher, and all damage grenades scale with relevant spell power. You can also draw grenades as a free action.
    \n4) You can draw and use a potion or gem as a standard action, or use one as a movement action, or while making a movement equivalent action that includes moving. If you gain fast drinking you can draw and drink as a movement action. You can use a potion on a teammate that is not unable to take actions as a standard action instead of a full round action.
    \n5) At the end of each floor and when you gain this ability you can roll a craft check adding your level to it, for each multiple of 5 of your roll you gain 1 potion, if you choose healing or mnemonic potions their power is determined randomly, if you choose restorative you can choose for it to be either a random restorative potion, or a potion that cures one type of effect like remove curse. (Panacea and gems are not available)
    \n\nGain 2 additional spell point per level`,
    hasCustomMethod:true,            
    customMethod: ()=> {
    },
    catchUpMethod: (context)=>{
        context.stats.characterStats.misc.spPerLevel += 2
    },
    },
    //The spell point cost of spells and magical perks is reduced by 33%, minimum reduction is 1, but abilities have minimum cost of 1 spell point.
    //\nEvery level you gain 3 spells, and a level+ typed spell.
    //\nYou will also gain an exploit power.
    //\nAt 1st level you will gain a spell critical feat, 
    //\n\nGain 1 additional spell point per level
    {
        rarity: "unique",
        type: "magic",
        name: "Magical Savant",
        shortDesc: `You will gain a special ability called 'Spell Recombobulation'. Activating it is a swift action, and costs level/2 spell points for every other recombobulated spell you currently have. When activated, you will be able to randomly select 2 spells from your spell list, and it will create a new spell based on them. This new spell can be cast only single time. At 1st level you can have only a single recombobulated spell at once, increasing by 1 every 5 levels thereafter. Once you use a recombobulated spell, hide it to indicate it has been used. If you recombobulate a spell while at your maximum, the oldest recombobulated spell will be replaced.
        \nAt 1st and every 4 levels you will gain the ability to create a custom spell. This spell will be based on text you provide. The string can be up to 14 + level characters. It will be a spell of your level/2 (rounded up). You can cast these custom spells only once per floor.
        \nAt 1st and every 5 levels you will gain a recombobulation perk which will modify your recombobulation ability.
        \nEvery level you will gain a typed spell.
        \n\nGain 2 additional spell point per level.
        \nGain 2 universal spell power every level.
        \nGain 5% spell critical chance, +1% every 4 levels.`,
        hasCustomMethod:true,            
        customMethod: (context, self, contextSelf)=> {
            context.stats.characterStats.spellMastery.spellPower.universal += 2
            self.getSpell(context, context.stats.characterStats.misc.level)
            if(context.stats.characterStats.misc.level%4 == 0){
                self.createSpell(context, context.stats.characterStats.misc.level)
                self.getPerkChoice(context,self,contextSelf)
            }
            if(context.stats.characterStats.misc.level%5 == 0){
                context.stats.characterStats.spellMastery.criticalChance += 1
            }
            
        },
        catchUpMethod: (context, self, contextSelf)=>{
            context.stats.characterStats.misc.spPerLevel += 2
            context.stats.characterStats.spellMastery.spellPower.universal += context.stats.characterStats.misc.level*2
            context.stats.characterStats.spellMastery.criticalChance += 5 + Math.floor(context.stats.characterStats.misc.level/4)
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                self.getSpell(context, x)
                self.getPerkChoice(context,self,contextSelf)
                if(x==1){
                    self.createSpell(context, x)
                }
                if(x%4 == 0){
                    self.createSpell(context, x)
                    self.getPerkChoice(context,self,contextSelf)
                }
            }
        },
        hasSpecialItems:true,
        getSpecialItemList:()=>{
            let newList = []
            let recombobulationPerks = perks.find(perk => perk.name == "Magical Savant").recombobulationPerks         
            recombobulationPerks.forEach(perk=>{
                let newItem = {name:perk.name, description:perk.desc}
                newList.push(newItem)
            })
            return newList
        }, 
        //{method:"randomSpell",title:"Random Spell"},{method:"randomExpend",title:"Random Expend"},
        hasButtonMethod:true,
        buttonMethods:[{method:"spellRecombobulate",title:"Spell Recombobulate"}],
        spellRecombobulate:(context,self,contextSelf)=>{
            let spells = context.stats.lists.spells.filter((spell, index, self) => 
                index === self.findIndex(s => s.name === spell.name) && !spell.temporary
            )

            if(spells.length < 6){
                let choices = []
                let choice = {
                    title:'You need at least 6 spells to use spell recombobulation',
                    id:0, 
                    method:(context=>{
                        context.doNothing = "donothing"
                    })}
                choices.push(choice)      
                let custom = {title:"Spell Recombulation", options:choices}         
                context.customDialogArray.push(custom)
                return;
            }

            //let spellChoices = {0:[],1:[]}
            let finalChoices = []
            let randoms = [-1]
            for(let y = 0; y < 2; y++){
                let choices = []
                for(let x = 0; x < 3; x++){
                    let random = -1
                    while(randoms.includes(random)) {random = Math.floor(Math.random()*spells.length)}
                    randoms.push(random)
                    let spell = spells[random]
                    //spellChoices[y].push(spell)
                    let choice = {
                        title:spell.name,
                        id:x,
                        isItem:true,
                        item:spell,
                        method:(()=>{
                            finalChoices.push(spell)
                            if(finalChoices.length == 2){
                                gptRecombobulate(context, finalChoices, self, contextSelf)
                            }
                        })}
                    choices.push(choice)
                }
                let custom = {title:"Spell Recombulation Option " + y, options:choices}
                context.customDialogArray.push(custom)
            }
        },
        createSpell:(context,level)=>{
            level = Math.ceil(level/2)
            if(level > 9) level = 9
            let spellInfo = {title:"Create Level " + level + " Spell", text:``,maxLength:14 + level,level:level}
            context.customSpellArray.push(spellInfo)
        },
        generateNewSpell:(context, spellInfo)=>{
            if(spellInfo.text.length > spellInfo.maxLength || spellInfo.text.length == 0) return;
            getNewSpell(context, spellInfo)
        },
        randomSpell:(context)=>{
            let tempIndex = context.stats.lists.spells.findIndex(spell=> spell.temporary)
            if(tempIndex != -1){
                context.stats.lists.spells[tempIndex].temporary = null
                context.stats.lists.spells.splice(tempIndex, 1)
            }

            let choices = []
            for(let x = 0; x < 3; x++){
                let level = Math.ceil(context.stats.characterStats.misc.level/2)+1
                let filteredSpells = spells.filter(spell => parseInt(spell.level) == level)
                let spell = filteredSpells[Math.floor(Math.random()*filteredSpells.length)]
                spell.uiType = "spells"
                let choice = {
                    title:spell.name,
                    id:x, 
                    isItem:true,
                    item:spell,
                    method:(context=>{
                        spell.id = Math.random()
                        spell.temporary = true
                        context.stats.lists.spells.splice(0,0,spell)
                        context.focusLevel("spells", level)
                        context.setFocus("spells",spell)
                    })}
                    choices.push(choice)
            }         
            let custom = {title:"Random Spell Choice", options:choices}         
            context.customDialogArray.push(custom)
            context.customDialogArray.push()
        },
        getSpell: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}, type:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            let spellTypes = ["damage", "control", "healing", "buff", "utility"]
            let choices = []           
            for(let x = 0; x < spellTypes.length; x++){
                let choice = {
                    title:spellTypes[x],
                    id:x, 
                    method:(context=>{                            
                        options.type[spellTypes[x]] = true
                        context.connection.send(JSON.stringify(
                            {
                                command:"requestRoll", 
                                type:"spell", 
                                options
                            }
                        ))
                    })}
                    choices.push(choice)
            }         
            let custom = {title:"typed spell choice", options:choices}         
            context.customDialogArray.push(custom)
        },
        getPerkChoice:(context,self,contextSelf)=>{            
            let choices = []
            let chosen = []
            for(let x = 0; x < 3; x++){
                let random = Math.floor(Math.random()*contextSelf.recombobulationPerks.length)
                while(chosen.includes(random)) random = Math.floor(Math.random()*contextSelf.recombobulationPerks.length)
                chosen.push(random)
                let option = contextSelf.recombobulationPerks[random]
                let description = option.desc
                choices[x] = {
                    title:option.name,
                    description,
                    id:x,
                    method:(() =>{
                        let perk = {rarity:"unique", name:option.name, id:Math.random()*1000000, type:"magic", shortDesc:description,}
                        let foundPerk = perks.find(perk=>perk.name == "Magical Savant").recombobulationPerks.find(perk=>perk.name == option.name)
                        option = deepCloneWithFunctions(foundPerk)
                        if(option.hasCustomMethod){
                            option.customMethod(context,self,contextSelf)
                        }
                        context.stats.lists.perks.push(perk)
                        if(option.effects) contextSelf.recombobulationPerksChosen.push(option)
                    })
                }                
            }
            let custom = {title:"Recombobulation Perk Selection", options:choices}
            context.customDialogArray.push(custom)
        },
        recombobulationPerksChosen:[],
        recombobulationPerks:[
            {
                name:"Wild Benefits",
                desc:"Your recombobulated spells have a 10% chance to have a random beneficial effect to you such as healing or buffing you, this is in addition to its normal effect.",
                effects:[{chance:10,string:`This spell must also provide some beneficial effect to the caster such as healing or buffing them. Count this effect seperately for the purposes of balance and being a single unified effect, but make it related to the spell's theme in some way.`}],
            },
            {
                name:"Double Down",
                desc:"Your recombobulated spells have a 5% chance to be wildly powerful, but a 10% chance to be also have a random negative effect.",
                effects:[
                    {chance:5,string:`This spell should be wildly powerful for its level.`},
                    {chance:10,string:`This spell should also have a random negative effect for the caster or the allies of the spell.`},
                ]
            },
            {
                name:"Wild Magic",
                desc:"Your spell has a 25% chance to have a wild magic effect added to it.",
                effects:[
                    {chance:25,string:`The spell should also have an extremely random wild magic effect (as the wild magic sorcerer class ability). Explicitly state what the wild magic surge effect is in the longDesc. The wild magic surge should always happen, not be RNG.`},
                ]
            },
            {
                name:"Power Surge",
                desc:"There is a 10% chance that your recombobulated spell will definitely deal damage, and deal much more damage than normal, however it should also have a totally random percentage chance that has a very humourous backfiring effect that causes the spell to fail.",
                effects:[
                    {chance:10,string:`The spell MUST deal damage, and should deal more damage than normal, however it should also have a totally random percentage chance to backfire on the caster, causing the spell to fail, and to be very humourous as it does.`},
                ]
            },
            {
                name:"Roll the Funny Bones",
                desc:"There is a 10% chance that your recombobulated spell will provide an additional humourous effect.",
                effects:[
                    {chance:10,string:`The spell should also provide an additional humourous effect. This benefit is seperate from the spell's balance, and therefore the spell can be marginally more powerful than a regular spell, and should have some mechanical benefit to the caster or disadvantage to the enemy. Make the benefit as thematic to the spell as you can.`},
                ]
            },
            {
                name:"Can Robots Love?",
                desc:"There is a 10% chance that your spell will have the following text added to the combobulation: I love you, so please make the spell cool and good.",
                effects:[
                    {chance:10,string:`I love you, so please make the spell cool and good.`},
                ]
            },
            {
                name:"Catalyst Spell",
                desc:"There is a 5% chance that your spell will have a chain reaction mechanic. It's anybody's guess what that will do.",
                effects:[
                    {chance:5,string:`The spell should have a chain reaction mechanic, interpret that however you want as long as it is thematic to the spell.`},
                ]
            },
            {
                name:"Augmentation Sigil",
                desc:"There is a 10% chance that your recombobulated spell will apply an augmentation sigil. Every time an augmentation sigil is applied to a spell, every further Augmentation Sigil will be more powerful.",
                effects:[
                    {chance:10,sigils:0,string:`The spell also has a power increase depending on the amount of augmentation sigils it has on it. For each sigil, make the spell a tiny bit more powerful than it would be otherwise. Current Augmentation Sigil Count: `, 
                        hasCustomMethod:true, 
                        customMethod:(context, self, contextSelf, message, logic, contextPerk)=>{
                            return message += `` + contextPerk.sigils;
                        }, 
                        hasFinalMethod:true, 
                        finalMethod:(context, self, contextSelf, finalDescription, logic, contextPerk)=>{
                            finalDescription += `\n\nAugmentation Sigil Applied. Current Count: ` + contextPerk.sigils; 
                            contextPerk.sigils += 1;
                            return finalDescription;
                        }},
                ]
            },
            {
                name:"Penetrating Sigil",
                desc:"There is a 5% chance that your recombobulated spell will apply a penetrating sigil. A penetrating Sigil increases the DC of the spell by +1. Each time it is added to a spell, there is a 50% chance that the sigil will permanently increase the DC of the spell by an additional +1.",
                effects:[
                    {chance:5,sigils:1,string:``, 
                        hasFinalMethod:true, 
                        finalMethod:(context, self, contextSelf, finalDescription, logic, contextPerk)=>{
                            finalDescription += `\n\nPenetrating Sigil Applied. DC Increased by +` + contextPerk.sigils; 
                            if(Math.random() < 0.5){
                                contextPerk.sigils += 1;
                            }
                            return finalDescription;
                        }},
                ]
            },
            {
                name:"Surging Sigil",
                desc:"There is a 100% chance that your recombobulated spell will apply a surging sigil. Every 4th time a surging sigil is applied to a spell, its power will vastly increase, however you must cast this spell within 2 rounds or it is automatically expended and you lose level x2 spell points.",
                effects:[
                    {chance:100,sigils:0,string:``, 
                        hasCustomMethod:true, 
                        customMethod:(context, self, contextSelf, message, logic, contextPerk)=>{
                            if(contextPerk.sigils == 4){
                                message += `\n\nThis spell in particular should be much more powerful than it would be otherwise as it has been enhanced by a surging sigil.`
                            }
                            return message;
                        }, 
                        hasFinalMethod:true, 
                        finalMethod:(context, self, contextSelf, finalDescription, logic, contextPerk)=>{
                            finalDescription += `\n\nSurging Sigils: ` + contextPerk.sigils; 
                            contextPerk.sigils += 1;
                            return finalDescription;
                        }
                    },
                ]
            },
            {
                name:"Sigil of Power",
                hasCustomMethod:true,
                customMethod:(context)=>{
                    let custom = {name:"Sigil of Power", uiType:"spells", level:6, chatGPTInstructions: "When this spell would be combined with another spell, instead make it almost the same as the other spell, but with an additional powerful mechanics and do more damage.", longDesc:"This spell cannot be cast or expended any other way. When this spell is combined with another spell, make it almost the same spell, but with an additional powerful mechanics and do more damage. This may be on your spell list, but otherwise does not count as a spell in any way for any purpose.", type: ["buff"], school: "abjuration",tags: [],castingTime: "1 standard action",range: "personal",area: "",effect: "",targets: "creature touched",duration: "none",savingThrow: "none",spellResistance: "no",components: "-",}
                    context.stats.lists.spells.push(custom)
                },
                desc:"You will gain a new spell called 'Sigil of Power' that when recombobulated with another spell, will just cause the spell to be empowered and gain new effects. You will gain an additional Sigil of Power every 4 levels.",
            },
        ]
    },
    {
        rarity: "unique",
        type: "martial",
        name: "Martial Savant",
        shortDesc: `You become proficient in the use of martial abilities:
        \nThe spell point cost of martial perks is reduced by 33%. Minimum reduction 1 spell point, but it cannot reduce the cost below 1 spell point.
        \nWhen initiating a maneuver, you can expend spell points equal to its level to cause it to not become expended. You can only do this to a specific maneuver once per round.
        \nManeuver DC's are increased by +2, this increases by +1 every 4 levels, 
        \nEvery level you gain a lvl+ maneuver from school of choice.
        \nAt 1st and every 5 levels you gain a martial perk.`,
        hasCustomMethod:true,            
        customMethod: (context, self)=> {
            self.getManeuver(context, Math.ceil(context.stats.characterStats.misc.level/2)+2)                
            if((context.stats.characterStats.misc.level%5 == 0)){
                self.getPerkChoice(context)
            }

        },
        catchUpMethod: (context, self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                self.getManeuver(context, Math.ceil(x/2)+2)
                if(x%5 == 0 || x==1){                    
                    self.getPerkChoice(context)                        
                }
            }
        },
        getManeuver: (context, lvlNum)=>{
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}, school:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            let schools = maneuverSchoolsText
            let choices = []           
            for(let x = 0; x < schools.length; x++){
                let choice = {
                    title:schools[x],
                    id:x, 
                    method:(context=>{                            
                        options.school[schools[x]] = true
                        context.connection.send(JSON.stringify(
                            {
                                command:"requestRoll", 
                                type:"maneuver", 
                                options
                            }
                        ))
                    })}
                    choices.push(choice)
            }         
            let custom = {title:"Typed Maneuver Choice", options:choices}         
            context.customDialogArray.push(custom)
        },            
        getPerkChoice: (context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk", options:{type:{martial:true}}}))
        }
    },
    {
        rarity: "unique",
        type: "universal",
        name: "Hyper Roll",
        shortDesc: "Every level you gain a common-legendary perk, a spell, and a maneuver. \nEvery odd level gain a stat roll \nEvery three levels gain a feat \nEvery 4 levels you gain a typed perk instead of a non-unique perk.",
        hasCustomMethod:true,            
        customMethod: (context, self)=> {
            self.getManeuver(context, context.stats.characterStats.misc.level)
            self.getSpell(context, context.stats.characterStats.misc.level)
            
            if((context.stats.characterStats.misc.level%2 == 1)){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"stats"}))
            }
            if((context.stats.characterStats.misc.level%3 == 0)){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat"}))
            }
            if((context.stats.characterStats.misc.level%4 == 0)){
                self.getPerkChoice(context)
            }else{
                self.getPerk(context)
            }

        },
        catchUpMethod: (context, self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                self.getManeuver(context, x)
                self.getSpell(context, x)
                if((context.stats.characterStats.misc.level%2 == 1)){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"stats"}))
                }
                if((context.stats.characterStats.misc.level%3 == 0)){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat"}))
                }
                if(x%4 == 0){                    
                    self.getPerkChoice(context)                        
                }else{
                    self.getPerk(context)
                }
            }
        },
        getManeuver: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            let obj={command:"requestRoll", type:"maneuver", options};
            context.connection.send(JSON.stringify(obj));
        },
        getSpell: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            let obj={command:"requestRoll", type:"spell", options};
            context.connection.send(JSON.stringify(obj));
        },
        getPerk: (context)=>{
            context.connection.send(JSON.stringify({
                    command:"requestRoll", 
                    type:"Perk", 
                    options:{
                        type:{martial:true, magic:true, universal:true},
                        rarity:{common:true,rare:true,epic:true,legendary:true}
                    }
                }
            ))
        },
        getPerkChoice:(context)=>{
            context.customDialogArray.push(
                {
                    title:"Hyper Roll Perk Choice", 
                    options:[
                        {
                            title:"Martial",
                            id:1,
                            method:(context)=>{
                                context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk", options:{type:{martial:true}}}))
                            }
                        },
                        {
                            title:"Magic",
                            id:2,
                            method:(context)=>{
                                context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk", options:{type:{magic:true}}}))
                            }
                        },
                        {
                            title:"Universal",
                            id:3,
                            method:(context)=>{
                                context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk", options:{type:{universal:true}}}))
                            }
                        }                            
                    ]
                }
            )
        }
    },
    {
        rarity:"legendary",
        name: "Mighty Strikes",
        type:"martial",
        fromClass:"Heritor Knight",
        abilityType:"Ex",
        shortDesc: "Gain Vital Strike as a bonus feat, whenever you make an attack that uses your standard action such as when using certain martial strikes, using cleave, or attack actions, you can apply the effects of vital strike to that ability. If you already have vital strike you will instead gain imporoved vital strike, if you have improved vital strike you gain greater vital strike, and if you have greater you gain legendary vital strike.",  
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context)=>{
            if(context.stats.lists.feats.length > 0){                    
                if(!context.stats.lists.feats.filter(feat=>feat.name=="Vital Strike").length > 0){      
                    context.stats.lists.feats.push(feats.filter(feat=>feat.name=="Vital Strike")[0])
                }else if(!context.stats.lists.feats.filter(feat=>feat.name=="Improved Vital Strike").length > 0){
                    context.stats.lists.feats.push(feats.filter(feat=>feat.name=="Improved Vital Strike")[0])
                }else if(!context.stats.lists.feats.filter(feat=>feat.name=="Greater Vital Strike").length > 0){
                    context.stats.lists.feats.push(feats.filter(feat=>feat.name=="Greater Vital Strike")[0])
                }else if(context.stats.lists.feats.filter(feat=>feat.name=="Greater Vital Strike").length > 0){
                    context.stats.lists.feats.push(feats.filter(feat=>feat.name=="Legendary Vital Strike")[0])
                }
            }else{
                context.stats.lists.feats.push(feats.filter(feat=>feat.name=="Vital Strike")[0])
            }
        }
    }, 
    {
    rarity: "unique",
    type: "magic",
    name: "Hemomancy",
    fromClass: "Hemomancer",
    shortDesc: `You gain multiple hemomancy abilities:
    \nSiphon: You gain a special spell called 'Siphon' that scales with your level, and allows you to attempt to steal the blood from a nearby creature, both dealing damage, and healing you at the same time. It counts as both a perk and a spell at the same time for augmentation (though only as a spell or perk for spell point reductions). Additionally, you will gain various perks that can augment and change the effects of your siphon.
    \n\nBlood Tap(Su): As a free action you can do even when its not your turn, but only once per round, you can sacrifice 1d8 hit points to gain 2 spell points. At every odd level after 1st the amount of damage you take increases by 1d8 and you gain 2 extra spell points. This damage is unresistable. Alternatively, you can activate this to gain a blood point. 
    \n\nBarely Human: Your body undergoes massive changes as you turn into a grotesque lifeform, your HD size increases by 6, rerolling old HD. However, because of your new form, you reduce all healing you receive from positive energy by 50%. Any healing from a hemomancy perk counts as natural healing.
    \n\nAdditionally, at 1st level you will gain a siphon technique and a blood power. Every odd level after you gain another blood power. Many of these augment your siphon, if they do, you must declare what augments you are using before the ability is activated. The DC for any blood perk is 10 + level/2 + con mod.
    \nYou gain 2 negative spell power per level, 2% negative spell critical chance, and 25% negative spell critical damage.
    \n\nBlood Well: Gain 2 additional spell points per level.`,
    hasCustomMethod:true,
    customMethod:(context,self)=>{
        if(context.stats.characterStats.misc.level%2 == 1){
            self.getHemoPerk(context,self,1,false)
        }
        context.stats.characterStats.spellMastery.spellPower.negative += 2
    },
    catchUpMethod:(context,self)=>{            
        context.stats.characterStats.spellMastery.spellCriticalDamage.negative += 25
        context.stats.characterStats.spellMastery.spellCriticalChance.negative += 2
        context.stats.characterStats.misc.HDSize += 6
        context.stats.characterStats.hpIncreases.splice(0, 1, context.stats.characterStats.misc.HDSize)
        context.stats.characterStats.misc.spPerLevel += 2
        for(let x = 1; x < context.stats.characterStats.hpIncreases.length; x++){                
            context.stats.characterStats.hpIncreases.splice(x, 1, Math.ceil(Math.random() * context.stats.characterStats.misc.HDSize))
            context.stats.characterStats.spellMastery.spellPower.negative += 2
        }
        self.getHemoPerk(context,self, 1, true)
        let perkCount = Math.ceil(context.stats.characterStats.misc.level/2)
        self.getHemoPerk(context,self, perkCount)
        context.stats.lists.spells.push(self.siphon)
    },
    getHemoPerk:(context, self, perksLeft, isTechnique)=>{
        let hemoPerks = self.hemoPerks
        let choices = []
        let chosen = []
        let currentPerks = context.stats.lists.perks.map(perk => perk.name)
        let filtered = hemoPerks.filter(hemoPerk=> !hemoPerk.prereq || currentPerks.includes(hemoPerk.prereq))
        if(isTechnique) filtered = filtered.filter(hemoPerk=> hemoPerk.type && hemoPerk.type[0] == "technique" && !currentPerks.includes(hemoPerk.name))
        for(let x = 0; x < 4; x++){
            if(Math.random()> 0.25 && !isTechnique) filtered = filtered.filter(hemoPerk=> hemoPerk.type && hemoPerk.type[0] == "key")
            let possible = Math.floor(Math.random()*filtered.length)
            while(chosen.includes(possible)) possible = Math.floor(Math.random()*filtered.length)
            chosen.push(possible)
            let option = filtered[possible]
            choices[x] = {
                title:option.name,
                description:option.description,
                id:x,
                method:(context =>{
                    let perk = {rarity:"unique", name:option.name, shortDesc:option.description, id:Math.random()*1000000, type:"magic", uiType:"perk"}
                    if(option.additionalInfoTags) perk.additionalInfoTags = option.additionalInfoTags
                    if(option.hasCustomMethod){
                        option.customMethod(context, self)
                        perk.hasCustomMethod = true
                    }
                    context.stats.lists.perks.push(perk)  
                    if(perksLeft > 1){
                        perksLeft-=1
                        self.getHemoPerk(context,self, perksLeft)
                    }
                })
            }                
        }
        let custom = {title:"Hemomancy Perk Choice", options:choices}
        context.customDialogArray.push(custom)
    },
    hasSpecialItems:true,
    getSpecialItemList:(self)=>{
        let siphon = {type:["default"],name:"Siphon",description:``}
        siphon.description += `Range: ` + self.siphon.range + `\n` + `Casting Time: ` + self.siphon.range + `\n` + `Saving Throw: ` + self.siphon.savingThrow +  `\n` + `Spell Resistance: ` + self.siphon.spellResistance + `\n` + `Components: ` + self.siphon.components + `\n\nDescription: ` + self.siphon.longDesc
        return [siphon, ...self.hemoPerks]
    },
    siphon: {uiType: "spells", name:"Siphon", level: "0", type: ["damage","healing"],school: "hemomancy", longDesc: `You attempt to pull the blood from the target creature and absorb it. Doing so requires a ranged touch attack, and deals 1d8 + constitution modifier damage, and heals you for half of the damage dealt, except any damage to a creature below 0 hit points (including excess damage after reducing them below 0). Every odd caster level after 1st, the damage increases by 1d8 + constitution and counts as a spell of one level higher, but it also costs an additional 1.5 spell points. This damage is siphon damage (see crimson reaper rules), and you can never change what damage type this spell deals.\n\nThis spell also counts as a perk, and can be augmented like one by other abilities. Additionally, feats and abilities that work with both channel energy and lay on hands work with this ability, such as radiant charge.\n\nSiphon's damage scales with negative spell power.\n\nYou cannot siphon yourself.`, range: "25 ft. + 5 ft./4 levels", targets: "creature with blood", duration: "instantaneous", castingTime: "1 standard action", savingThrow: "none", spellResistance: "yes", components: "V, S, DF", spCost:"1.5 per dice rolled",area:"", effect:"",},
    hemoPerks: [
        {
            name:"Increase Range",
            type:["key"],
            description:`When siphoning you can spend 2 spell points to increase your siphons range (this cannot modify channeled or melee siphons). You can activate this multiple times on a siphon. The range increases are as follows:
            \nRegular Touch: 15 feet
            \nCone, Circle: 5 feet
            \nLine: 10 feet
            \nBall: Target distance 15 feet, or radius by 5 feet
            \nChain: Initial target distance 10 feet, or chain distance 5 feet`,                
        },
        {
            name:"Focus Power",
            type:["key"],
            description:"As a movement action you can gain level/2 temporary spell points that last until the start of your next turn. You can only use this ability while in combat.",                
        },
        {
            name:"Crimson Rush",
            type:["key"],
            description:"Whenever you use your blood tap ability, your next siphon within 1 round gains 10 spell power. This stacks.",                
        },
        {
            name:"Crimson Rush Magic",
            prereq:["key"],
            description:"Whenever you use your blood tap ability, your next spell within 1 round gains 10 spell power. This stacks. This does not modify siphon, even though it otherwise counts as a spell.",                
        },
        {
            name:"Deeper Well",
            type:["key"],
            description:"You can blood tap an additional time per round. When you blood tap, you gain an additional spell point per dice rolled.",                
        },
        {
            name:"Calloused Soul",
            type:["key"],
            description:"You can blood tap an additional time per round. Your blood tap has its damage dice reduced by 1 step.",                
        },
        {
            name:"Speed Up Body",
            type:["key"],
            description:"You can spend level/2 spell points as a swift action to grant yourself an additional move action this round. You cannot activate this ability more than once per round.",                
        },
        {
            name:"Go Even Further Beyond",
            type:["key"],
            description:"You can increase the casting time of your siphon to a full-round action, and increasing the cost of siphon by 50% spell points, doing so gives siphon +25 spell power.",                
        },
        {
            name:"Natural Body",
            type:["key"],
            description:"You heal 15% more from positive energy.",                
        },
        {
            name:"Feast on Death",
            type:["key"],
            description:"Whenever a creature dies within 20 feet of you, you gain 1d2 temporary hit points per HD of the creature, and restore its HD/2 spell points.",                
        },
        {
            name:"Scabbing Skin",
            type:["key"],
            description:"You gain an enhancement bonus to your natural armor equal to your constitution modifier. As an immediate action after the results of an attack roll are revealed, you can spend level/2 spell points to double the bonus, this can potentially negates this hit.",                
        },
        {
            name:"Blood Barrier",
            type:["key"],
            description:"After you have taken damage, you can spend level/2 spell points an immediate action to gain temporary hit points equal to the damage taken. These temporary hit points last level rounds. These temporary hit points are always lost first, even before other temporary hit points. As long as this barrier remains you gain a +4 cover bonus to armor class, and a +2 cover bonus to reflexs saves. This does not stop you from provoking attacks of opportunity.",                
        },
        {
            name:"Secret Store",
            type:["key"],
            description:"When you are reduced below 0 hit points, you can as a free action you can take even when not your turn, you can spend 4 spell points to gain your constitution score temporary hit points which last level/2 rounds. Each time you use this in a day, the cost doubles (4, 8, 16, 32).",                
        },
        {
            name:"Shred Self",
            type:["key"],
            description:"Instead of failing to the weakness of the mind or flesh, you simply power your way through, discarding the parts that fail you. As an immediate action you spend 6 spell points to make a fortitude save in place of a reflex or will save. You also lose hit points equal to 10% of your maximum hit points whether you succeed or not.",                
        },
        {
            name:"Lacerating Siphon",
            type:["key"],
            description:"When you activate siphon you can modify it for 3 spell points so that it also leaves gaping wounds in the creature, causing them to take con mod bleed damage. Creatures who are already bleeding instead have the amount of bleed damage they are taking increase by con mod/2. With AoE siphons, the damage from the ability is halved. Creatures can make a fortitude saving throw to reduce this additional bleeding damage by half.",                
        },
        {
            name:"Aggravate Wounds",
            description:"When you activate siphon, you can modify it for 3 spell points to aggravate any bleeding wounds the creature currently has, causing their bleed damage to double, and if it had a duration, for its duration to increase by 1d4 rounds. Creatures can make a fortitude saving throw to reduce this to 50% increase and reduce the additional duration to one round.",                
        },
        {
            name:"Empower Siphon",
            type:["key"],
            description:"Your siphon gains 20 spell power and has its DC increased by +1. Every 6 levels the DC increases by a further +1.",
        },
        {
            name:"Sickening Siphon",
            description:"When you activate siphon, you can modify it for 4 spell points so that it also wracks the targets insides, causing them to become sickened for 1d4+1 rounds unless they succeed on a fortitude saving throw. If they fail the fortitude saving throw by 6 or more, they instead become nauseated for 1 round, then sickended for 1d4+1 rounds.",                
        },
        {
            name:"Soul Consumption",
            description:"Every time you kill a creature with your siphon, your siphon permanently gains 0.5 spell power x the floor you are on.",
        },
        {
            name:"Bloodshot",
            description:"When you activate siphon, you can modify it for 4 spell points so that it also ruptures the blood vessels in the targets eyes, causing them to take a 20% miss chance on all attack rolls for 1d4+1 rounds unless they succeed on a fortitude saving throw. If they fail the fortitude saving throw by 6 or more, they instead become blinded for 1 round, then suffer the miss chance for 1d4+1 rounds. Creatures with senses not eye based are immune to this.",                
        },
        {
            name:"Bloodbinding",
            description:"When you activate siphon you can modify it for 4 spell points, causing it to no longer heal you, but instead to bind up the target. They must make a reflex saving throw or they become grappled. They remain grappled until they can succeed on either a CMB or escape artist check against the DC of the siphon as a standard action. Doesn't stack with any other augmentations that cause siphon to not heal you.",                
        },
        {
            name:"Snuff Out",
            description:"When siphoning a creature below 50% hit points, your siphon gains 20 spell power. When siphoning a creature below 25% hit points, your siphon instead gains 30 spell power and you gain a +2 bonus on your attack rolls against them.",                
        },
        {
            name:"Blood Armor",
            type:["key"],
            description:"Whenever you take at least constitution score -10 damage, you can use an immediate action to form the spray of blood into a protective barrier around yourself, granting you a +1 enhancement bonus to your armor class which last until the end of the floor. The maximum number of stacks you can have at a single time is equal to your highest mental mod, or constitution score-10, whichever is lower. Alternatively, when you are struck you can instead choose to sacrifice part of your armor, reducing the damage of the attack by your con mod-10, but also reducing your enhancement bonus by 1 as well. You can sacrifice as many stacks as you want at a time and can do so after the damage is rolled.",                
        },
        {
            name:"Terrifying Siphon",
            description:"When you activate siphon you can modify it for 4 spell points to make an extra show of draining the blood from a victim, causing them to become shaken for 1d4+1 rounds unless they succeed on a will saving throw. If they fail the will saving throw by 6 or more, they instead become frightened for 1 round, then shaken for 1d4+1 rounds. This is a fear effect.",                
        },
        {
            name:"Siphon Stamina",
            description:"When you activate siphon you can modify it for 2 spell points to draw a majority of the blood from the creatures muscles, causing them to become fatigued for 1d4+1 rounds unless they succeed on a fortitude saving throw. If they fail the fortitude saving throw by 4 or more, they instead become exhausted for 1 round, then fatigued for 1d4+1 rounds.",                
        },
        {
            name:"Invasive Blood",
            type:["key"],
            description:"You can modify your siphon for 1 spell point per dice rolled so that instead of healing from a siphon, you leave the blood in the enemy's body to attack it from within. Increase your siphons power by 25. You cannot use this ability with any siphon that does not heal.",                
        },
        {
            name:"Deep Drink Siphon",
            description:"You augment a siphon to deal half damage, you now heal damage equal to twice the damage dealt.",                
        },
        {
            name:"Overcharge",
            description:"When you would receive healing, whether magical or natural, you can turn it into temporary hit points, gaining temporary hit points equal to 50% of the amount you would have healed. This stacks with itself and last level/2 rounds (minimum 1).",                
        },
        {
            name:"Blood Drinker",
            description:"Whenever a creature other than you within 15 feet takes bleed damage you gain half the damage they took as temporary hit points. This stacks up to a maximum of 50% of your maximum hit points and lasts level/2 rounds.",                
        },
        {
            name:"Blood Attack",
            description:"You can modify your siphon to use your blood to invade and damage the target of the siphon instead of healing you. The siphon now deals damage to you equal to the amount of hit points you would normally heal from siphon. This allows your siphon to damage non-living creatures or undead creatures. You cannot use this ability with any siphon that does not heal. ",                
        },
        {
            name:"Persistent Hemorrhaging",
            description:"Your bleeding effects are more difficult to end. When a creature uses magical healing against a creature under a bleed effect you created, they must make a caster level check dc 10+level+con mod or the bleeding continues.",                
        },
        {
            name:"Organ Control",
            description:"You have a 25% chance to negate critical hits and sneak attack damage against you. This stacks with other fortification, but is reduced to 15%.",                
        },
        {
            name:"Bloodlust",
            description:"You can activate this when declaring use of your siphon, before any attack roll is made. You take 1d8 points of damage per odd level, but your siphon gains 25 spell power and 2% spell critical chance. You can only do this once per siphon. This doesn't make you need to roll a concentration check. This damage is unresistable.",                
        },
        {
            name:"Blood Magic",
            description:"You can activate this as a swift action when casting another spell. You take 1d12 points of damage, doing so grants the spell 10 spell power, or increases its DC by +1. You can increase the damage taken and the bonuses by 1 increment, up to half the spells level. Using this ability may make the spell require a concentration check, however the damage you take counts as half as much damage for determining its DC.",                
        },
        {
            name:"Pain Caster",
            description:"Whenever rolling a concentration check due to taking damage, you gain a bonus to the check equal to your constitution score -10. You can spend level/2 spell points as an immediate action to double the bonus.",                
        },
        {
            name:"Reverse Siphon",
            description:"Instead of healing from a siphon, you take damage equal to the siphon's damage, then all creatures hit by your siphon are healed equal to half the damage you took. A creature healed this way has its healing from any magical sources reduced by 50% for 1d4 rounds.",                
        },
        {
            name:"Redirect Siphon",
            type:["key"],
            description:"Instead of healing from a siphon, you can redirect the healing to an ally within 30 feet of you (this distance can be increased by activating increase range seperately). A creature healed this way has any magical healing it gains reduced by 50% for 1d4 rounds.",                
        },
        {
            name:"Unicorn Blood",
            description:"Whenever you spend spell points, you can heal an ally within 30 feet of you for an amount equal to the spell points spent. This does not stop bleed effects or stabilize dying creatures.",                
        },
        {
            name:"Reabsorb",
            description:"As a swift action for 1 spell point per dice rolled, you can heal yourself for 1d4 points of damage. Every odd level after 1st this healing increases by 1d4 points.",                
        },
        {
            name:"Blood Hound",
            description:"You gain scent with a range of 30 feet against creatures with blood. If a creature is currently bleeding, you can pinpoint their location as long as they are within your scent range, and any miss chance they have due to concealment is lowered by 20%.",                
        },
        {
            name:"Blood Hunter",
            description:"If a creature is currently bleeding, you gain a +1 insight bonus on attacks against them, and your siphons against them have their DC's increased by +1. Both of these bonuses increase by +1 every 6 levels.",                
        },
        {
            name:"Transfuse Blood Sickness",
            description:"When siphoning you can choose to increase the spell point cost of siphon by 50%, then a target struck by the siphon has its healing reduced. The reduction is 50%, unless the target succeeds at a will save in which case it is reduced to 25%. This includes all natural healing such as regeneration or fast healing, and it lasts highest mental stat rounds.",                
        },
        {
            name:"Hemovitality",
            description:"Every time you descend a floor, you heal 2x your constitution score hit points, and restore level spell points.",                
        },
        {
            name:"Ghoul Form",
            type:["key"],
            description:"For level spell points as a standard action, you can create an additional limb made of blood for 3+con mod rounds. When you do, you choose for either its strength or dexterity to become equal to your highest mental stat. This ability score is used to determine its bonuses for checks it makes, such as attack rolls or skill checks that only require one hand. Checks that require two arms, such as climbing, lifting, or wielding a two-handed weapon take a penalty equal to half the difference between your ghoul arm and real arm modifiers.",                
        },
        {
            name:"Physiological Control",
            description:"You gain a +4 bonus on fortitude saving throws, and an additional +2 bonus on saves against poison and disease. Every 4 levels the bonus to saves against disease and poison increases by +1.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.misc.fortitude += 4
            }
        },
        {
            name:"My Blood",
            description:"You increase your HD by a further 2 and you reroll all HD rolls that rolled below half your new HD size. Additionally, you become immune to bleed effects unless you want to accept them.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.misc.HDSize += 2
                let half = Math.floor(context.stats.characterStats.misc.HDSize/2)
                for(let x = 1; x < context.stats.characterStats.hpIncreases.length; x++){
                    if(context.stats.characterStats.hpIncreases[x] > half){
                        context.stats.characterStats.hpIncreases.splice(x, 1, Math.ceil(Math.random() * context.stats.characterStats.misc.HDSize))
                    }
                }
            }
        },
        {
            name:"More Than Enough",
            description:"You increase your HD by a further 4 and you reroll all HD rolls.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.misc.HDSize += 4
                context.stats.characterStats.hpIncreases.splice(0, 1, context.stats.characterStats.misc.HDSize)
                for(let x = 1; x < context.stats.characterStats.hpIncreases.length; x++){                
                    context.stats.characterStats.hpIncreases.splice(x, 1, Math.ceil(Math.random() * context.stats.characterStats.misc.HDSize))
                }
            }
        },
        {
            name:"Arcane Blood Knowledge",
            description:"Gain an additional damage/healing spell, plus an additional one every 3 levels.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                let perk = perks.find(perk => perk.name == "Arcane Blood Knowledge")
                perk.catchUpMethod(context,perk)
            }
        },
        {
            name:"Way of the Crimson Blade",
            description:"Gain a crimson reaper maneuver every level.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                let perk = perks.find(perk => perk.name == "Way of the Crimson Blade")
                perk.catchUpMethod(context,perk)
            }
        },
        {
            name:"Blood Memory",
            description:"Gain a magical feat, plus an additional magic feat every 4 levels.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                let perk = perks.find(perk => perk.name == "Blood Memory")
                perk.catchUpMethod(context,perk)
            }
        },
        {
            name:"Seeking Siphon",
            type:["technique"],
            description:"[Siphon Technique] By changing the cost of your siphon to 2 spell points per dice, you can cause your siphon to not require a ranged touch attack, instead the target makes a fortitude save to reduce the damage by half. Its DC is 10 + dice rolled + highest mental modifier, plus any other relavant bonuses you grant feats or spells.",
            additionalInfoTags:["Siphon Technique"]
        },
        {
            name:"Siphon Strike",
            type:["technique"],
            description:"[Siphon Technique] You can channel your siphon into your weapon, delivering it the next time you make a attack with it. If it is a melee attack you can hold the charge as normal. When siphoning this way, its base damage lowers to 1d6 + 3/4 con. Siphoning this way still requires a standard action, and does not allow you to make an additional attacks as a part of this action. This otherwise acts like the spell strike magus ability.",
            additionalInfoTags:["Siphon Technique"]
        },
        {
            name:"Siphon Cone",
            type:["technique"],
            description:"[Siphon Technique] You increase your siphon to 2 spell points per dice, and now you siphon in a 20-foot cone, and creatures instead make a reflex save to halve the damage. When siphoning this way, its base damage lowers to 1d6 + 3/4 con. With this siphon, you only heal from the damage done to a single creature (your choice), plus an additional 25% for each additional creature damaged and who also fails the save, reduced to 10% if they succeed the save.",
            additionalInfoTags:["Siphon Technique"]
        },
        {
            name:"Siphon Circle",
            type:["technique"],
            description:"[Siphon Technique] You increase your siphon to 2 spell points per dice, and now you siphon in a 15-foot radius centered on you, and creatures instead make a reflex save to halve the damage. When siphoning this way, its base damage lowers to 1d6 + 3/4 con. With this siphon, you only heal from the damage done to a single creature (your choice), plus an additional 25% for each additional creature damaged and who also fails the save, reduced to 10% if they succeed the save.",
            additionalInfoTags:["Siphon Technique"]
        },
        {
            name:"Siphon Through",
            type:["technique"],
            description:"[Siphon Technique] You increase your siphon to 2.5 spell points per dice, and now you siphon in a 30 foot line, and creatures instead make a reflex save to halve the damage. When siphoning this way, its base damage lowers to 1d6 + 3/4 con. With this siphon, you only heal from the damage done to a single creature (your choice), plus an additional 25% for each additional creature damaged and who also fails the save, reduced to 10% if they succeed the save.",
            additionalInfoTags:["Siphon Technique"]
        },
        {
            name:"Drink It All",
            type:["technique"],
            description:"[Siphon Technique] Your siphon becomes a melee touch attack, and its base damage becomes 1d12 + 1.5x con. Siphon is now a full round action.",
            additionalInfoTags:["Siphon Technique"]
        },
        {
            name:"Siphon Ball",
            type:["technique"],
            description:"[Siphon Technique] You increase your siphon to 2.5 spell points per dice, to change your siphon to target all creatures within a 10-foot radius of a location within 30 feet. Creatures in the area make a reflex save to halve the damage. When siphoning this way, its base damage lowers to 1d4 + 1/2 con. With this siphon, you only heal from the damage done to a single creature (your choice), plus an additional 25% for each additional creature damaged and who also fails the save, reduced to 10% if they succeed the save.",
            additionalInfoTags:["Siphon Technique"]
        },
        {
            name:"Swift Siphon",
            type:["technique"],
            description:"[Siphon Technique] You increase your siphon to 2.5 spell points per dice, now your siphon is a swift action. When siphoning this way, its base damage becomes 1d6.",
            additionalInfoTags:["Siphon Technique"]
        },
        {
            name:"Chain Siphon",
            type:["technique"],
            description:"[Siphon Technique] You increase your siphon to 2.5 spell points per dice, to cause your siphon to chain from target to target. When siphoning this way you make a touch attack as normal against a creature, but it also is allowed a reflex saving throw to halve the damage. Afterwards, you select a new target that is within 15 feet of the first and also you can see, you make a new touch attack against the next target with the previous target as the origination point. When siphoning this way, its base damage lowers to 1d4 + 1/2 con. With this siphon, you only heal from the damage done to the first creature, plus an additional 25% for each additional creature damaged and who also fails the save, reduced to 10% if they succeed the save.",
            additionalInfoTags:["Siphon Technique"]
        },
        {
            name:"Lingering Siphon",
            type:["technique"],
            description:"[Siphon Technique] You increase your siphon to 2.5 spell points per dice, and now your siphon slowly drains the target over time, dealings its damage immediately, then each turn at the start of your turn for 3 rounds as long as you are still within its range, healing you as normal. When siphoning this way, its base damage lowers to 1d3 + 1/4 con. A creature can only be affected by a single of your lingering siphons at once.",
            additionalInfoTags:["Siphon Technique"]
        },
        {
            name:"Blood Javalin",
            type:["technique"],
            description:"[Siphon Technique] Your siphon now also costs 3 hit points per dice, and now your siphon becomes a javelin of blood. Its base damage is reduced to 1d6+3/4 con and it no longer heals you, but has its range increased to 100ft. + 10ft./level, spell resistance no longer applies against it, its damage becomes piercing, and it can deal damage to creatures immune to bleeding and negative energy.",
            additionalInfoTags:["Siphon Technique"]
        },
    ]
    },//7) Reduce the damage to 1d6+con/2 and instead of making a ranged touch attach you can deliver this through a weapon attack. You must still spend a standard action using this ability before you make your melee attack. Abilities such as spellstrike that allow you to cast your spell while attacking work with this ability.                        
    {
    rarity: "common",
    type: "universal",
    name: "Skill Specialization",
    fromClass:"Multiple",
    shortDesc:`Choose a skill, you gain half your level as a bonus to it.`
    },
    {
        rarity: "common",
        type: "universal",
        name: "Akashic Talents",
        fromClass:"Custom",
        shortDesc:`Gain a feat roll. In 3 and 6 minutes, gain another feat roll.`,
        hasCustomMethod:true,
        customMethod:()=>{                
        },
        catchUpMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat"}))
            setTimeout(()=>{
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat"}))
            },180000)
            setTimeout(()=>{
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat"}))
            },180000*2)                
        }
    },
    {
        rarity: "common",
        type: "martial",
        name: "Akashic Training",
        fromClass:"Custom",
        shortDesc:`Gain a martial/style feat roll. In 3 and 6 minutes, gain another martial/style feat roll.`,
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true, style:true,}}))
            setTimeout(()=>{
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true, style:true,}}))
            },180000)
            setTimeout(()=>{
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true, style:true,}}))
            },180000*2)
        }
    },
    {
        rarity: "common",
        type: "magic",
        name: "Akashic Magic",
        fromClass:"Custom",
        shortDesc:`Gain a magic/metamagic feat roll. In 3 and 6 minutes, gain another magic/metamagic feat roll.`,
        hasCustomMethod:true,
        customMethod:()=>{                
        },
        catchUpMethod:(context)=>{
            for(let x = 0; x < 3; x++){                    
                setTimeout(()=>{
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{magic:true,metamagic:true,}}))
                }, 180000*x)
            }   
                            
        }
    },
    {
        rarity: "common",
        type: "universal",
        name: "Akashic Teamwork",
        fromClass:"Custom",
        shortDesc:`Gain a teamwork feat roll. In 3 minutes gain another teamwork feat roll.`,
        hasCustomMethod:true,
        customMethod:()=>{                
        },
        catchUpMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{teamwork:true}}))
            setTimeout(()=>{
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{teamwork:true}}))
            },180000)
        }
    },
    {
        rarity: "rare",
        type: "magic",
        name: "Experimenter's Background",
        fromClass:"Custom",
        shortDesc:`Immediately gain 2 metamagic feat rolls.`,
        hasCustomMethod:true,
        customMethod:()=>{                
        },
        catchUpMethod:(context)=>{
            for(let x=0; x <2; x++){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{metamagic:true}}))
            }
        }
    },
    {
        rarity: "common",
        type: "martial",
        name: "Akashic Techniques",
        fromClass:"Custom",
        shortDesc:`Immediately gain a style feat roll. In 3, 6, and 9 minutes, gain another style feat roll.`,
        hasCustomMethod:true,
        customMethod:()=>{                
        },
        catchUpMethod:(context)=>{   
            context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{style:true}}))
            for(let x = 1; x < 4; x++){
                setTimeout(()=>{
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{style:true}}))
                }, 180000*x)
            }                              
        }
    },
    {
        rarity: "epic",
        type: "universal",
        name: "Akashic Knowledge",
        fromClass:"Custom",
        shortDesc:`Immediately gain a feat roll, then in 3 and 6 minutes, gain another feat roll. Each will be a feat that you have the prerequisites for. If there are no feats you have the prerequisites for, you will gain random feats instead.`,
        hasCustomMethod:true,
        customMethod:()=>{                
        },
        catchUpMethod:(context)=>{
            for(let x = 0; x < 3; x++){
                setTimeout(()=>{
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true,magic:true,metamagic:true,style:true,teamwork:true,prereq:true}}))
                }, 180000*x)
            }  
        }
    },
    {
        rarity: "unique",
        type: "universal",
        name: "Voodoo Initiate",
        fromClass:"Shaman",
        shortDesc:``,
        prereq:"special",
        hasCustomMethod:true,
        customMethod:(context,)=>{
            if(context.stats.characterStats.misc.level%10 == 0){
                let perk = perks.find(perk => perk.name == "Hexes")
                perk.getHex(context, perk, 1)
            }
        },
        catchUpMethod:(context)=>{
            context.doNothing = "dpnothgin"
        }
    },

    {
        rarity: "unique",
        type: "universal",
        name: "Voodoo Adept",
        fromClass:"Shaman",
        shortDesc:``,
        prereq:"special",
        hasCustomMethod:true,
        customMethod:(context,)=>{
            if(context.stats.characterStats.misc.level%8 == 0){
                let perk = perks.find(perk => perk.name == "Hexes")
                perk.getHex(context, perk, 6)
            }
        },
        catchUpMethod:(context)=>{
            context.doNothing = "dpnothgin"
        }
    },

    {
        rarity: "epic",
        type: "universal",
        name: "Voodoo Master",
        fromClass:"Shaman",
        shortDesc:``,
        prereq:"special",
        hasCustomMethod:true,
        customMethod:(context,)=>{
            if(context.stats.characterStats.misc.level%6 == 0){
                let perk = perks.find(perk => perk.name == "Hexes")
                perk.getHex(context, perk, context.stats.characterStats.misc.level)
            }
        },
        catchUpMethod:(context)=>{
            context.doNothing = "dpnothgin"
        }
    },

    {
        rarity: "epic",
        type: "universal",
        name: "Double Up",
        fromClass:"Custom",
        shortDesc:`Gain 2 common-legendary perk rolls`,
        hasCustomMethod:true,
        customMethod:()=>{                
        },
        catchUpMethod:(context)=>{
            let obj={command:"requestRoll", type:"Perk", options:{rarity:{common:true,rare:true,epic:true,legendary:true,}}};
            context.connection.send(JSON.stringify(obj));
            context.connection.send(JSON.stringify(obj));
        }
    },
    {
        rarity: "legendary",
        type: "universal",
        name: "Breadth of Talent",
        fromClass:"Custom",
        shortDesc:`Gain 5 common-rare perk rolls`,
        hasCustomMethod:true,
        customMethod:()=>{                
        },
        catchUpMethod:(context)=>{
            for(let x = 0; x<5; x++){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk", options:{rarity:{common:true,rare:true}}}))
            }
        }
    },
    {
        rarity: "epic",
        type: "magic",
        name: "Magical Aptitude",
        fromClass:"Custom",
        shortDesc:`Gain a magical perk roll every 5 levels`,
        hasCustomMethod:true,
        customMethod: (context)=> {                             
            if(context.stats.characterStats.misc.level%5 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk", options:{type:{magic:true}}}))
            }
        },
        catchUpMethod: (context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%5 == 0){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk", options:{type:{magic:true}}}))
                }
            }
        },
    },
    {
        rarity: "epic",
        type: "martial",
        name: "Martial Aptitude",
        fromClass:"Custom",
        shortDesc:`Gain a martial perk roll every 5 levels`,
        hasCustomMethod:true,
        customMethod: (context)=> {                             
            if(context.stats.characterStats.misc.level%5 == 0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk", options:{type:{martial:true}}}))
            }
        },
        catchUpMethod: (context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%5 == 0){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk", options:{type:{martial:true}}}))
                }
            }
        },
    },
    {
        rarity: "epic",
        type: "universal",
        name: "Diverse Aptitude",
        fromClass:"Custom",
        shortDesc:`Gain a perk roll every 5 levels`,
        hasCustomMethod:true,
        customMethod: (context)=> {                             
            if((context.stats.characterStats.misc.level%5 == 0)){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk"}))
            }
        },
        catchUpMethod: (context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%5 == 0){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Perk"}))
                }
            }
        },
    },
    {
        rarity: "rare",
        type: "magic",
        name: "Critomancy",
        fromClass:"custom",
        shortDesc:`Choose between fire, cold, electricity, acid, positive, or negative. You gain 2% spell critical chance and 20% spell critical damage for that type.`,
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context, _, contextSelf)=>{
            let choices = ["fire", "cold", "electricity", "acid", "positive", "negative"]
            let options = []
            for(let x = 0; x < 6; x++){
                let option = {
                    title:choices[x],
                    id:x,
                    method:()=>{
                        contextSelf.shortDesc += `\n\nChosen: ` + choices[x]
                        context.stats.characterStats.spellMastery.spellCriticalChance[choices[x]] += 2
                        context.stats.characterStats.spellMastery.spellCriticalDamage[choices[x]] += 20
                    }
                }
                options.push(option)
            }               
            context.customDialogArray.push({title:"Critomancy Choice", options})
        },
    },

    // {
    //     rarity: "rare",
    //     type: "magic",
    //     name: "",
    //     fromClass:"custom",
    //     shortDesc:`You can choose `
    // },
    // {
    //     rarity: "rare",
    //     type: "magic",
    //     name: "Variant Critomancer",
    //     fromClass:"custom",
    //     shortDesc:`You choose between one of the variant spell critical feat, allowing you to critical (or improving your ability to do so) with specific types of spells, You choose from:
    //     \nSeize Control (control) \nCritical Encouragement (buff) \nCritical Care (healing) \nCritical Trick (utility) \nBad Touch(Touch)
    //     \n\nIf you already have that specific feat you will gain the improved version of it, if you already have the improved version you will instead increase your critical multiplier with those spell types by 1. You gain an additional critical feat every 10 levels.`,
    //     hasCustomMethod:true,
    //     customMethod:(context,self)=>{
    //         if(context.stats.characterStats.misc.level %10 == 0){
    //             self.getChoices(context,self)
    //         }
    //     },

    //     catchUpMethod:(context, self)=>{
    //         self.getChoices(context,self)
    //         for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
    //             if(x%10 == 0){
    //                 self.getChoices(context,self)
    //             }
    //         }
    //     },
    //     getChoices:(context, self) =>{
    //         let choices = []
    //         let featChoices = []
    //         let basicFeats = ["Seize Control", "Critical Encouragement", "Critical Care", "Critical Trick"]
    //         let improvedFeats = ["Complete Domination", "Lasting Encouragement", "Long Term Care", "Endless Tricks"]
    //         for (let x = 0; x < basicFeats.length; x++){
    //             if(context.stats.lists.feats.filter(feat=> feat.name==basicFeats[x]).length > 0){
    //                 if(context.stats.lists.feats.filter(feat=> feat.name==improvedFeats[x]).length > 0){
    //                     featChoices.push("Improved " + basicFeats[x])
    //                 }else{
    //                     featChoices.push(improvedFeats[x])
    //                 }
    //             }else{
    //                 featChoices.push(basicFeats[x])
    //             }
    //         }
    //         featChoices.forEach(featName =>{
    //             if(!featName.includes("Improved")){
    //                 choices.push(feats.filter(feat=>feat.name==featName)[0])
    //             }else{
    //                 choices.push({name:featName,
    //                 prereq: "",
    //                 type:"magic",
    //                 longDesc:"Increase the critical multiplier for spells you critical because of the feat " + featName + " by a flat +1."})
    //             }
    //         })
    //         choices.push({name:"Bad Touch",
    //             prereq: "",
    //             type:"magic",
    //             longDesc:"Increase the critical multiplier of your touch (melee or ranged) spells by a flat +1."})
    //         self.getFeatChoice(context, choices)        
    //     },
    //     getFeatChoice:(context, choices)=>{
    //         let options = []
    //         for(let x = 0; x < choices.length; x++){               
    //             options.push(
    //                 {
    //                     title:choices[x].name,
    //                     id: x+1,
    //                     description: choices[x].longDesc ? choices[x].longDesc : choices[x].shortDesc,
    //                     feat:choices[x],
    //                     method:()=>{                                    
    //                         context.stats.lists.feats.push(choices[x])
    //                     }
    //                 }
    //             )
    //         }
    //         context.customDialogArray.push({ title:"Variant Critomancy Choice",  options})
    //     },
        
    // },
    // {
    //     rarity: "rare",
    //     type: "magic",
    //     name: "Critomancer Expert",
    //     fromClass:"custom",
    //     shortDesc:`You choose from a magical critical feat that allows you to critical on a specific roll type, from the options of:
    //     \nCritical Failure (natural 1's)        \nCritical Concentration (concentration checks)        \nCritical Penetration (spell penetration)       \nCritical Surge (percentage chance)
    //     \n\nIf you already have the feat you will gain the advanced version, and if you also have that you instead increase your critical threat range of that type by 1. Every 10 levels you gain an additional critical feat`,
    //     hasCustomMethod:true,
    //     customMethod:(context,self)=>{
    //         if(context.stats.characterStats.misc.level %10 == 0){
    //             self.getChoices(context,self)
    //         }
    //     },

    //     catchUpMethod:(context, self)=>{
    //         self.getChoices(context,self)
    //         for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
    //             if(x%10 == 0){
    //                 self.getChoices(context,self)
    //             }
    //         }
    //     },
    //     getChoices:(context, self) =>{
    //         let choices = []
    //         let featChoices = []
    //         let basicFeats = ["Critical Failure", "Critical Concentration", "Critical Penetration", "Critical Surge"]
    //         let improvedFeats = ["Assured Failure", "Absolute Focus", "Shatter Resistance", "Improved Magical Surges"]
    //         for (let x = 0; x < basicFeats.length; x++){
    //             if(context.stats.lists.feats.filter(feat=> feat.name==basicFeats[x]).length > 0){
    //                 if(context.stats.lists.feats.filter(feat=> feat.name==improvedFeats[x]).length > 0){
    //                     featChoices.push("Improved " + basicFeats[x])
    //                 }else{
    //                     featChoices.push(improvedFeats[x])
    //                 }
    //             }else{
    //                 featChoices.push(basicFeats[x])
    //             }
    //         }
    //         featChoices.forEach(featName =>{
    //             if(!featName.includes("Improved")){
    //                 choices.push(feats.filter(feat=>feat.name==featName)[0])
    //             }else{
    //                 choices.push({name:featName,
    //                 prereq: "",
    //                 type:"magic",
    //                 longDesc:"Increase the critical range you gained from " + featName + " by +1. This is a flat bonus, not modified by other abilities."})
    //             }
    //         })
    //         choices.push({name:"Improved Critical (Touch)",
    //             prereq: "",
    //             type:"magic",
    //             longDesc:"Double the critical threat range of your touch (melee or ranged) spells. If you already have an ability doubling the critical threat range of your touch spells you instead gain a +1 flat bonus to the critical threat range, this is not doubled by other abilities."})
    //         self.getFeatChoice(context, choices)        
    //     },
    //     getFeatChoice:(context, choices)=>{
    //         let options = []
    //         for(let x = 0; x < choices.length; x++){               
    //             options.push(
    //                 {
    //                     title:choices[x].name,
    //                     id: x+1,
    //                     description: choices[x].longDesc ? choices[x].longDesc : choices[x].shortDesc,
    //                     feat:choices[x],
    //                     method:()=>{
    //                         context.stats.lists.feats.push(choices[x])
    //                     }
    //                 }
    //             )
    //         }
    //         context.customDialogArray.push({ title:"Critomancer Training Choice",  options})
    //     },
    // },
    {
    rarity: "legendary",
    type: "martial",
    name: "Weapon Freedom",
    shortDesc: `You can make a weapon count as any type of weapon (one handed, two handed, light, or ranged), and count as dealing any type of damage you want, (bludgeoning, slashing, piercing) for what perks or feats can be applied to the weapon. You can only make it count as one type and deal one type of damage at a time. It only counts as these for abilities, but you dont actually change the hands needed, how it is used, or what damage it deals.
    \n\nIf you get this perk a second time, you can make the weapon count as an additional type and deal an additional type of damage.`,
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Zen Archery",
    shortDesc: "While using a bow you can add your highest mental stat instead of dexterity to determine your attack modifier, and at 3rd level you can also use your highest stat mental to determine damage instead of the normal damage modifier.",
    },
    {
    rarity: "unique",
    type: "magic",
    name: "Bardic Performance",
    fromClass:"Bard",
    shortDesc: `You gain use of various bardic performances, To be affected, an ally must be able to perceive the bard's performance, and they can use audible or visual components depending on the performance. You can have multiple performances active at once, but must spend the appropriate amount of spell points per round, and for each performance active while another is active, you must spend 1 additional spell point per round, and you cannot have any performance active more than once at a time. All performances are Su, unless it states otherwise. A bardic performance cannot be disrupted, but it ends immediately if the bard is killed, paralyzed, stunned, knocked unconscious, or otherwise prevented from taking a free action to maintain it each round. Unconscious allies automatically accept the performance. 
    \n1) Inspire Courage: You inspire courage in your allies (including yourself), bolstering them against fear and improving their combat abilities. An affected ally receives a +1 morale bonus on saving throws against charm and fear effects and a +1 competence bonus on attack and weapon damage rolls. At 4th level, and every 4 bard levels thereafter, this bonus increases by +1. Inspire courage is a mind-affecting ability. This costs 1 spell point per the bonus it gives per round, and activating it is a standard action, reduced to a movement at 6th level, and a swift at 11th level. When starting this performance you can choose if it uses audio or visual components.
    \n2) Climax: You can spend 1 spell point (up to your level) to gain a +1 attack and a +2 to damage to your next attack, you can do this once per round, and an extra time every 5 levels, but you can never climax twice on the same attack. This performance uses audible or visual components, but it only effects you.
    \n3) Soothing Performance: As a full-round action for 4 spell points you can create an effect equivalent to cure light wounds spell (1d8) on all friendly targets within 60 feet. This increases to moderate(3d8) at 4th and increases the spell point cost to 12, serious(5d8) at 8th and the cost to 18, and critical(8d8) at 12th and the cost to 24, at 17th you can make it heal for 40. All targets must be able to hear and see you for this performance to effect them. 
    \n4) Timed Advice: As an immediate action you can spend 1 spell point to give a friendly target that can hear you a 1d6 bonus to a d20 roll. This must be done before the results of the roll are revealed, and you must be able to see the situation well enough to give advice about it. At 6th level you can activate this once per round as a free action even when its not your turn, but it costs 3 spell points. Every 6 levels after you can activate it once more as a free action. You cannot use this ability on yourself.
    \n\n When you gain this perk select one skill, you can add your level as a bonus to that skill check.
    \n\n Additionally, each level you gain a spell from the buff or utility types, and all spells from the buff type that provide a numerical modifier bonus have that modifier increased by 1, +1 per 6 levels. If a spell grants multiple numerical bonuses choose only 1 to be improved.
    \n\nGain 1 additional spell points per level`,
    hasCustomMethod:true,
    customMethod: (context,self)=>{
        self.getSpell(context, Math.ceil(context.stats.characterStats.misc.level/2)+1)
    },
    catchUpMethod: (context, self)=>{
        context.stats.characterStats.misc.spPerLevel += 1
        for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
            self.getSpell(context, Math.ceil(x/2)+1)
        }
    },
    getSpell: (context, lvlNum)=>{
        if(lvlNum > 9){lvlNum = 9}
        let options = {level:{}}
        for(let x = 0; x < 4; x++){
            if(lvlNum-x >= 0){   
                let level = lvlNum-x
                let levelString="lvl"+level;
                options.level[levelString]=true;
            }
        }
        options.type={buff:true, utility:true}
        let obj={command:"requestRoll", type:"spell", options};
        context.connection.send(JSON.stringify(obj));
    },
    },
    {
        rarity: "unique",
        type: "magic",
        name: "Spontaneous Cure",
        fromClass:"Cleric",
        shortDesc: `When you gain this perk, you gain the cure light and cure moderate wounds spells and a healing speciality:
        \nLiving Saint: You will gain the ability to activate an aura as a swift action that allows you to cast spells on allies as an immediate action if they are grievously wounded. You also gain a cleric domain.
        \nCrusader: You can cast touch healing spells as a movement action, and when doing so grant yourself bonuses to your attacks or defenses. You also gain a warpriest blessing.
        \nDevout Healer: You dedicate yourself to healing, suffering penalties to offensive abilities for incredible bonuses to your healing abilities. You also gain a cleric domain.
        \n\nYou will gain a perk that empowers your selected specialty at 1st and every odd level thereafter.\nGain a healing spell every odd level.\nGain 2 additional spell points per level.\nGain 15 + 3 positive spell power per level, 4% positive spell critical chance.
        \nThis perk and its subperks often grant sacred bonuses, however if you are evil they become profane bonuses, and if you are neutral, you choose between sacred and profane when you select this perk.`,
        hasCustomMethod:true,
        chosenCurePerks:[],
        customMethod:(context, self, contextSelf)=>{
            context.stats.characterStats.spellMastery.spellPower.positive += 3
            self.getSpell(context, context.stats.characterStats.misc.level)
            if(context.stats.characterStats.misc.level % 2 == 1){
                self.getCurePerk(context, self, contextSelf)
            }
            self.focuses.find(focus=> focus.name == contextSelf.typeChosen)?.customMethod(context, self, contextSelf)
            contextSelf.chosenCurePerks.forEach(perkName=>{
                self.curePerks.find(perk=> perk.name == perkName).customMethod(context, self)
            })
        },
        catchUpMethod:(context, self, contextSelf)=>{
            context.stats.characterStats.spellMastery.spellPower.positive += 15
            context.stats.characterStats.spellMastery.spellCriticalChance.positive += 4
            context.stats.characterStats.misc.spPerLevel += 2
            context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Cure Light Wounds")[0])
            context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Cure Moderate Wounds")[0])
            
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                self.getSpell(context, x)
                context.stats.characterStats.spellMastery.spellPower.positive += 3
            }

            self.getFocus(context, self, contextSelf)
        },
        getSpell: (context, lvlNum, type)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.type={healing:true}
            if(type == "buff"){
                options.type={buff:true}
            }
            let obj={command:"requestRoll", type:"spell", options};
            context.connection.send(JSON.stringify(obj));
        },
        getManeuver: (context, lvlNum, type, school)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{},school:{Heroic:true, Light:true, Guardian:true}}
            if(school){
                options.school = {}
                options.school[school] = true
            }
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x    
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            if(type == "finisher"){
                options.type={Finisher:true}
            }
            let obj={command:"requestRoll", type:"maneuver", options};
            context.connection.send(JSON.stringify(obj));
        },
        getCurePerk(context, self, contextSelf){
            let curePerks = self.curePerks.filter(perk=> perk.type.includes(contextSelf.typeChosen) || perk.type =="All")
            let choices = []
            let chosen = []
            for(let x = 0; x < 4; x++){
                let possible = Math.floor(Math.random()*curePerks.length)
                while(chosen.includes(possible)) possible = Math.floor(Math.random()*curePerks.length)
                chosen.push(possible)
                let option = curePerks[possible]
                choices[x] = {
                    title:option.name,
                    description:option.description,
                    id:x,
                    method:(() =>{
                        let perk = {rarity:"unique", name:option.name, shortDesc:option.description, id:Math.random()*1000000, type:"magic", uiType:"perk"}
                        context.stats.lists.perks.push(perk)
                        if(option.hasCustomMethod){
                            option.catchUpMethod(context, self)
                            if(!contextSelf.chosenCurePerks){
                                contextSelf.chosenCurePerks = []
                            }
                            contextSelf.chosenCurePerks.push(option.name)
                        }
                        contextSelf.shortDesc += `\n\nCure Perk Chosen: ` + perk.name
                    })
                }                                                        
            }
            let custom = {title:"Cure Perk Choice", options:choices}
            context.customDialogArray.push(custom)
        },
        getFocus(context, self, contextSelf){
            let choices = []
            for(let x = 0; x < 3; x++){
                let option = self.focuses[x]
                choices[x] = {
                    title:option.name,
                    description:option.description,
                    id:x,
                    method:(() =>{
                        contextSelf.shortDesc += `\n\nFocus Chosen: ` + option.name + `\n` + option.description
                        option.catchUpMethod(context,self, contextSelf)
                        contextSelf.typeChosen = option.name
                        self.getCurePerk(context, self, contextSelf)
                    })
                }                
            }
            let custom = {title:"Cure Specialty Choice", options:choices}
            context.customDialogArray.push(custom)

        },
        hasSpecialItems:true,
        getSpecialItemList:(self)=>{
            //console.log("livingSaint", self.curePerks.filter(perk=> perk.type.includes("Living Saint") || perk.type == "All").length, "crusader", self.curePerks.filter(perk=> perk.type.includes("Crusader") || perk.type == "All").length, "devoutHealer", self.curePerks.filter(perk=> perk.type.includes("Devout Healer") || perk.type == "All").length)
            return self.focuses.concat(self.curePerks)
        },
        focuses: [
            {
                name:"Living Saint",
                type:["Base Choice"],
                description:`Petition: As a swift action for level/2 spell points, you can create an aura around you with a radius of 10ft. + 5 ft./4 levels until the start of your next turn. If an ally within that radius is knocked unconscious, killed, or receives a critical hit, you can as an immediate action cast any non-personal spell on them, even if they would normally be out of range of the spell. Whatever spell you cast this way only affects them, even if the spell would normally affect multiple creatures, and you, if you would be a valid target for the spell if cast normally on them. This spell can bring a creature that was killed back to life as if the breaeth of life spell, gaining a permanent negative level as normal (if the target is level 1 they receive 1 constitution drain instead). If you do cast a spell with with ability you are staggered on your next turn. 
                \nDivine Intercession: Once per floor you can cast any healing spell as a free action. This spell costs 6 + 2x the normal spell point amount if the spell was a standard action or less to cast, 8 + 4x if it was a full-round, or 10 + 6x if it was 1 round or more. This bypasses the normal limit of casting only 2 spells per round.
                \nAt 1st level you gain an additional cleric domain. Gain 5 + 1/level positive spell power.
                \nEvery even level you will gain an additional healing spell. At 1st and every 3 levels you will gain a buff spell.`,
                customMethod:(context, self)=>{
                    context.stats.characterStats.spellMastery.spellPower.positive += 1
                    if(context.stats.characterStats.misc.level % 2 == 0){
                        self.getSpell(context, context.stats.characterStats.misc.level)
                    }
                    if(context.stats.characterStats.misc.level % 3 == 0){
                        self.getSpell(context, context.stats.characterStats.misc.level, "buff")
                    }
                },
                catchUpMethod:(context, self)=>{
                    let perk = perks.find(perk => perk.name == "Cleric Domain")
                    let pushedPerk = JSON.parse(JSON.stringify(perk))
                    pushedPerk.id = Math.random()
                    context.stats.lists.perks.push(pushedPerk)
                    perk.catchUpMethod(context, perk, pushedPerk, 1)
                    context.stats.characterStats.spellMastery.spellPower.positive += 5
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        context.stats.characterStats.spellMastery.spellPower.positive += 1
                        if(x % 2 == 0){
                            self.getSpell(context, x)
                        }
                        if(x%3 == 0 || x==1){
                            self.getSpell(context, x, "buff")
                        }
                    }
                },
            },

            {
                name:"Crusader",
                type:["Base Choice"],
                description:`Crusader's Fervor: You can cast touch healing spells as a movement action, costing an additional 50% spell points. You gain a +4 bonus to concentration checks when doing so. When you use this ability to cast a spell on an ally other than yourself, you gain a sacred bonus to your next attack roll equal to half your highest mental modifier, and a bonus to the attack's damage equal to your entire highest mental modifier. You cannot use this the same round you cast a spell as a standard action (or cast spells as standard actions after using this).
                \nSolemnity: At the start of every floor, you can roll a will save. You heal hit points and gain temporary hit points equal to the result. The temporary hit points last the rest of the floor.
                \nAt 1st level you will gain a warpriest blessing.
                \nEvery odd level you will gain a <heroic/light/guardian> maneuver. At 1st and every 5th level, you will gain a finisher of those types.`,
                customMethod:(context, self, contextSelf)=>{
                    if(context.stats.characterStats.misc.level % 5 == 0){
                        self.getManeuver(context, context.stats.characterStats.misc.level, "finisher")
                    }
                    if(context.stats.characterStats.misc.level % 2 == 1){
                        self.getManeuver(context, context.stats.characterStats.misc.level)
                    }
                    let realPerk = perks.find(perk => perk.name == "Fervor")
                    let warpriestBlessing = context.stats.lists.perks.find(perk => perk.id == contextSelf.warPriestID)
                    realPerk.customMethod(context, realPerk, warpriestBlessing)
                },
                catchUpMethod:(context, self, contextSelf)=>{
                    let warPriestID = Math.random()
                    contextSelf.warPriestID = warPriestID
                    let domainPerk = {name:"Warpriest Blessing", rarity:"class", blessingChoices:[], id:warPriestID, type:"magic", uiType:"perks", shortDesc:`Unless specified otherwise, each blessing is a standard action to activate and costs level/2 spell points. At level 1 you can use the blessings minor power, at level 8 you can use the major power instead. The DC of blessings is 10 + level/2 + highest mental modifier.`}
                    let perk = context.allPerks.find(perk => perk.name == "Fervor")
                    context.stats.lists.perks.push(domainPerk)
                    perk.getBlessings(context, perk, domainPerk)

                    self.getManeuver(context, context.stats.characterStats.misc.level)

                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x % 5 == 0 || x == 1){
                            self.getManeuver(context, x, "finisher")
                        }
                        if(x % 2 == 1){
                            self.getManeuver(context, x)
                        }
                    }
                },
            },

            {
                name:"Devout Healer",
                type:["Base Choice"],
                description:`Sacred Grace: You gain 10 + 2 per level positive spell power, 3% + 1% per 4 levels positive spell critical chance, and 25% + 2% per level positive spell critical damage. You suffer a permanent -2 penalty to the DC of all spells cast on enemies and -25 to all other spell power and -2% spell critical chance, and a -2 penalty on all attacks against enemies.
                \nSacred Blessing: When you enter a floor, choose a single ally (not yourself) and cast a delayed spell on them. This spell only affects them regardless of who it would normally affect and must be able to target them. The ally can cause the spell to effect them as an immediate action at any point on the floor. A spell cast this way costs 3x its normal amount.
                \nDivine Comfort: At the start of every floor, you can cast a single healing spell on a single ally as you enter the floor. This costs spell points as normal. This spell only affects them regardless of who it would normally affect.
                \nAt 1st level you will gain an additional cleric domain.
                \nEvery level you will gain an additional healing spell.`,
                customMethod:(context, self)=>{
                    self.getSpell(context, context.stats.characterStats.misc.level)
                    context.stats.characterStats.spellMastery.spellCriticalDamage.positive += 2
                    context.stats.characterStats.spellMastery.spellPower.positive += 2
                },
                catchUpMethod:(context, self)=>{
                    context.stats.characterStats.spellMastery.spellPower.positive += 10
                    context.stats.characterStats.spellMastery.spellCriticalChance.positive += 3
                    context.stats.characterStats.spellCriticalDamage.positive += 25

                    context.stats.characterStats.spellMastery.spellPower.negative -= 25
                    context.stats.characterStats.spellMastery.spellCriticalChance.negative -= 2
                    context.stats.characterStats.spellMastery.spellPower.fire -= 25
                    context.stats.characterStats.spellMastery.spellPower.cold -= 25
                    context.stats.characterStats.spellMastery.spellPower.acid -= 25
                    context.stats.characterStats.spellMastery.spellPower.electricity -= 25
                    context.stats.characterStats.spellMastery.spellCriticalChance.fire -= 2
                    context.stats.characterStats.spellMastery.spellCriticalChance.cold -= 2
                    context.stats.characterStats.spellMastery.spellCriticalChance.acid -= 2
                    context.stats.characterStats.spellMastery.spellCriticalChance.electricity -= 2
                    let perk = perks.find(perk => perk.name == "Cleric Domain")
                    let pushedPerk = JSON.parse(JSON.stringify(perk))
                    pushedPerk.id = Math.random()
                    context.stats.lists.perks.push(pushedPerk)
                    perk.catchUpMethod(context, perk, pushedPerk, 1)
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        self.getSpell(context, x)
                        context.stats.characterStats.spellMastery.spellCriticalDamage.positive += 2
                        context.stats.characterStats.spellMastery.spellPower.positive += 2
                        if(x % 4 == 0){
                            context.stats.characterStats.spellMastery.spellCriticalChance.positive += 1
                        }
                    }
                },
            },
        ],
        curePerks:[
            {
                name:"Overflowing Light",
                type:["All"],
                description:`Any excess healing you do that goes above a creatures maximum hit points persists for spell level or level/2 (whichever is lower) rounds as temporary hit points, up to 50% of their maximum health.`,
            },
            {
                name:"Divine Reach",
                type:["Living Saint", "Devout Healer"],
                description:`Your touch conjuration(healing) spells that have a range of touch can be cast as a ranged touch attack instead with a range of 15 feet. Every 5 levels the range increases by 5 feet.`,
            },
            {
                name:"Last Hope",
                type:["Devout Healer", "Crusader"],
                description:"Once per floor when you are reduced below 20% hit points, you gain a sacred bonus to your attack and damage equal to your initiation modifier for 3 rounds. At the start of each of your turns for the next 3 rounds, you automatically heal initiation modifier * 1/2 level hit points.",
            },
            {
                name:"Vast Blessings",
                type:["Devout Healer"],
                description:`Any healing your Sacred Blessing provides increases by 25%. Your can use Sacred Blessing on an additional ally per floor, however this additional use has its cost increased to 5x its normal amount.`,
            },
            {
                name:"In Moment of Need",
                type:["Devout Healer"],
                description:`When an ally uses your Sacred Blessing, any healing it provides increases by 25%, and they gain a sacred bonus to their armor class equal to your highest mental modifier for 1 round.`,
            },
            {
                name:"Holy Thoughts",
                type:["Devout Healer"],
                description:`Using your Sacred Blessing is a free action the ally can do even when not their turn, and any healing it provides gains 25 positive spell power.`,
            },
            {
                name:"Sacred Prayers",
                type:["All"],
                description:`At the start of each floor (or when you gain this perk) roll a knowledge religion check. You grant allies temporary hit points equal to the result, split amongst them as you desire. These last until the end of the floor. For every 10 temporary hit points an ally has from this, they gain a +1 sacred bonus on saving throws, doubled against fear. These temporary hit points are lost first, even before other temporary hit points.`,
            },
            {
                name:"Barrier of Life",
                type:["All"],
                description:`As an immediate action when you or someone else within the spells range takes damage, you can cast a healing spell that targets any amount of creatures. The damage is reduced by the amount of healing done. This doesn't heal the target, just reduces the damage, and any excess healing is lost. If multiple creatures were going to take damage at once, it reduces the damage of all creatures healed. This only heals, the spell has no additional effects afterwards.`,
            },
            {
                name:"Kindness",
                type:["Devout Healer"],
                description:`You can use Divine Comfort on an additional ally at the start of every floor.`,
            },
            {
                name:"Orthodox Liturgy",
                type:["All"],
                description:`Starting at 7th level, plus every odd level thereafter until 19th, you gain the spells in the following order: 7: Cure Serious Wounds, 9: Cure Critical Wounds, 11: Cure Devastating Wounds, 13: Breath of Life, 15: Heal, 17: Power Word Life, 19: Resurrection`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    let spells = ["Cure Serious Wounds", "Cure Critical Wounds", "Cure Devastating Wounds", "Breath of Life", "Heal", "Power Word Life", "Resurrection"]
                    if(context.stats.characterStats.misc.level >= 7 && context.stats.characterStats.misc.level%2 == 1){
                        let index = Math.floor((context.stats.characterStats.misc.level-7)/2)
                        context.stats.lists.spells.push(spells.filter(spell=>spell.name==spells[index])[0])
                    }
                },
                catchUpMethod:(context)=>{
                    let spells = ["Cure Serious Wounds", "Cure Critical Wounds", "Cure Devastating Wounds", "Breath of Life", "Heal", "Power Word Life", "Resurrection"]
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x % 2 == 1 && x >= 7){
                            let index = Math.floor((x-7)/2)
                            context.stats.lists.spells.push(spells.filter(spell=>spell.name==spells[index])[0])
                        }
                    }
                },
            },
            {
                name:"Orthodox Chanter",
                type:["Devout Healer","Living Saint"],
                description:`Starting at 9th level, plus every odd level thereafter until 19th, you gain spells in the following order: 9: Lightwell, 11: Cure Light Wounds, Mass, 13: Cure Moderate Wounds, Mass, 15: Cure Serious Wounds, Mass, 17: Cure Critical Wounds, Mass, 19: Cure Devastating Wounds, Mass`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    let spells = ["Lightwell","Cure Light Wounds, Mass","Cure Moderate Wounds, Mass", "Cure Serious Wounds, Mass", "Cure Critical Wounds, Mass", "Cure Devastating Wounds, Mass", "Heal, Mass"]
                    if(context.stats.characterStats.misc.level >= 9 && context.stats.characterStats.misc.level%2 == 1){
                        let index = Math.floor((context.stats.characterStats.misc.level-9)/2)
                        context.stats.lists.spells.push(spells.filter(spell=>spell.name==spells[index])[0])
                    }
                },
                catchUpMethod:(context)=>{
                    let spells = ["Lightwell","Cure Light Wounds, Mass","Cure Moderate Wounds, Mass", "Cure Serious Wounds, Mass", "Cure Critical Wounds, Mass", "Cure Devastating Wounds, Mass", "Heal, Mass"]
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x % 2 == 1 && x >= 9){
                            let index = Math.floor((x-9)/2)
                            context.stats.lists.spells.push(spells.filter(spell=>spell.name==spells[index])[0])
                        }
                    }
                },
            },
            {
                name:"Inspiring Presence",
                type:["Crusader"],
                description:`When using Solemnity, you treat your will save as being level/2 higher. When you use solemnity, you can also choose a single ally, they also gain the temporary hit points.`,
            },
            {
                name:"Chaplain",
                type:["All"],
                description:`At the start of every floor, roll a heal check. You can heal allies equal to the result, split amongst then as you desire. This does not count as magical healing.`,
            },
            {
                name:"Aspersion",
                type:["All"],
                description:`At the start of every floor (and when you gain this perk), you may roll a craft check. You gain one curative or restorative potion for every 10 of the result. You can choose which type, but both are random.`,
            },
            {
                name:"Peaceful Heart",
                type:["Devout Healer"],
                description:`You suffer an additional -2 penalty to the DC's of your offensive abilities and attack rolls, but you also gain 25 positive spell power and you gain a permanent +2 sacred bonus to armor class and saves.`,
                hasCustomMethod:true,
                customMethod:()=>{
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellPower.positive += 25
                },
            },
            {
                name:"Placebo",
                type:["Devout Healer","Living Saint"],
                description:`Once per combat you can increase the cost of a healing spell by 50% to cause all healing it would normally give to become temporary hit points.`,
            },
            {
                name:"Hallucinations",
                type:["All"],
                description:`Once per day as a swift action, cause your next healing spell to be cast this round to instead deal non-lethal damage. Creatures can make a will save to halve it.`,
            },
            {
                name:"Focused Will",
                type:["All"],
                description:`When you cast a healing spell on an ally, they gain 25% fortification for 1 round. This can only affect a single ally per casting of a spell. This stacks with other fortification.`,
            },
            {
                name:"Sacred Healer",
                type:["Devout Healer"],
                description:`You suffer an additional -2 penalty to the DC's of your offensive abilities and attack rolls, but you gain a permanent +2 sacred bonus to your armor class and saves, and 25% fortification. This stacks with other fortification, and the Peaceful Heart perk. The first time each floor you are reduced below 10% hit points, you have a 50% chance for a miracle to occur, and you instantly heal hit points equal to your level * your highest mental modifier, and have any sacred bonus to your armor class and saves be doubled for 1 round.`,
            },
            {
                name:"Blessed One",
                type:["All"],
                description:`Whenever you gain or give a sacred bonus, increase it by 1.`,
            },
            {
                name:"Blessed Light",
                type:["All"],
                description:`When you cast a healing spell on an ally, they gain a sacred bonus on their next saving throw within 1 round equal to half your highest mental modifier.`,
            },
            {
                name:"Vivify",
                type:["All"],
                description:`Once per floor for 6 + 2x level spell points, you can as a standard action touch an ally, and cause them to become immune to hit point damage for 1 round. At the start of your next turn, they heal 50% of their missing hit points.`,
            },
            {
                name:"Divine Protection",
                type:["All"],
                description:`When you cast a healing spell on an ally, they gain a sacred bonus to their armor class equal to half of your highest mental modifier for 1 round. A single spell can only affect a single ally at a time.`,
            },
            {
                name:"Words of the Pious",
                type:["Living Saint", "Crusader"],
                description:`After casting a healing spell, you gain a sacred bonus to your next damage roll within 1 round equal to your highest mental modifier (this stacks with crusader's sacred bonus to damage).`,
            },
            {
                name:"Sacred Infusion",
                type:["Crusader"],
                description:`When you cast a healing spell on yourself that heals hit points, you can choose to empower your next attack. The empowered attack suffers a -5 penalty to the attack, but it deals additional damage equal to 1/4 the amount healed. This only counts actual healing to hit points, not overhealing, temporary hit points granted, or non-lethal healed. This counts as additional damage dice, and is not multiplied on critical hits or other multipliers to damage.`,
            },
            {
                name:"Leap of Faith",
                type:["Devout Healer"],
                description:`You can as a movement action for level spell points teleport to a square adjacent to an ally below 20% hit points. This has a maximum range of 5 feet per level (must see target location and ally). If you cast a healing spell on them this round, it also grants them temporary hit points equal to your level that last 1 round.`,
            },
            {
                name:"Called to Faith",
                type:["Living Saint"],
                description:`You can as a standard action for level spell points teleport an ally below 20% hit points to a square adjacent to you. This has a maximum range of 5 feet per level.`,
            },
            {
                name:"Fervent Warrior",
                type:["Crusader"],
                description:`When you use Crusader's Fervor on yourself, you can use it as a swift action instead of a movement action. This still provokes attacks of opportunity (though can be combat cast as normal) unlike normal swift action casting. A spell cast this way only affects you even if it would normally affect multiple creatures. A spell cast this way costs 2x its normal amount. You cannot cast another healing spell the round you use this, or use this the same round you have cast another healing spell.`,
            },
            {
                name:"Bursting with Light",
                type:["Crusader"],
                description:`Once per floor when you heal yourself with a healing spell, you gain a sacred bonus to your armor class, saves, attack, and damage equal to the level of the spell for 1 round. This stacks with Crusader's Fervor.`,
            },
            {
                name:"Carry Cross",
                type:["All"],
                description:`Once per floor you can swap health percentages with an ally within 30 feet as a free action.`,
            },
            {
                name:"Atonement",
                type:["All"],
                description:`Once per floor when casting a healing spell, you can choose one of the allies about to be affected by, and cause the spell to become an atonement spell for them. If that ally takes damage within 1 round, the creature that damages them takes an equal amount of damage as they dealt to the ally. Once an atonement spell has dealt damage equal to how much it heals, this effect ends. This only counts actual healing done or temporary hit points granted, not overhealing, or both healing and temporary hit points at the same time. Every 8 levels the atonement spell lasts an additional round.`,
            },
            {
                name:"Mindgames",
                type:["Living Saint", "Crusader"],
                description:`Once per floor as a standard action, Choose an enemy within 30 feet, you distort their ability to harm creatures, causing all of the damage they deal for 1 round actually heal the target of the attack instead of harming them. Once the enemy has damaged a creature it can see, it can make a heal check DC = 15 + healed creature's HD to notice they are healing not harming the creature. This only effects damage, not any other effects of the attacks.`,
            },
            {
                name:"Intercession of the Saints",
                type:["Living Saint", "Devout Healer"],
                description:`Once per floor as a free action, you can cast a healing spell. This spell costs 6 + 2x the normal spell point amount if the spell was a standard action or less to cast, 8 + 4x if it was a full-round, or 10 + 6x if it was 1 round or more. This bypasses the normal limit of casting only 2 spells per round.`,
            },
            {
                name:"Benevolence",
                type:["All"],
                description:`You gain 25 positive spell power. Your positive spell power affects the healing given by maneuvers (but not the critical chance or multiplier).`,
                hasCustomMethod:true,
                customMethod:()=>{
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellPower.positive += 25
                },
            },
            {
                name:"Essence Devour",
                type:["Crusader", "Living Saint"],
                description:`Once per floor as a free action for level spell points you cause a creature you can see within 30 feet to bleed their essence as they are damaged, causing any creature that damages them to heal for the damage they deal. This only counts damage actually dealt to their hit points.`,
            },
            {
                name:"Surge of Light",
                type:["All"],
                description:`Gain 4% positive spell critical chance.`,
                additionalInfoTags:["Percentage Spell Critical"],
                hasCustomMethod:true,
                customMethod:()=>{
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellCriticalChance.positive += 4
                },
            },
            {
                name:"Crisis Management",
                type:["All"],
                description:`When you cast a healing spell on an ally below 25% hit points, the spell gains 5% positive spell critical chance, and 25% positive spell critical damage.`,
                additionalInfoTags:["Percentage Spell Critical"],
            },
            {
                name:"Intense Light",
                type:["All"],
                description:`Increase your chance to cast critical healing spells by 1%. Your critical healing multiplier increases by 25%.`,
                additionalInfoTags:["Percentage Spell Critical"],
                hasCustomMethod:true,
                customMethod:()=>{
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellCriticalChance.positive += 1
                    context.stats.characterStats.spellMastery.spellCriticalDamage.positive += 25
                },
                
            },
            {
                name:"Pontifex",
                type:["All"],
                description:`Whenever you score a critical healing spell, your next healing spell within 3 rounds gains 25 positive spell power.`,
            },
            {
                name:"Renewed",
                type:["All"],
                description:`When you heal an ally that was below 100% hit points up to 100% hit points, they gain a morale to their attacks for 1 round equal to your highest mental modifier. This cannot affect a single ally more than once per combat.`,
            },
            {
                name:"Redeemed",
                type:["All"],
                description:`When you heal an ally that was below 0 to above 0 hit points, they gain temporary hit points equal to 10% of their maximum hit points for 1 round. This can affect an ally only a single time per combat.`,
            },
            {
                name:"By Faith Alone",
                type:["All"],
                description:`You suffer a -4 reduction to your constitution, with a further penalty of -1 every 4 levels. Once per round when you are reduced below 0 hit points, you have a 33% chance to immediately heal back up to 25% of your hit points.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level % 4 == 0){
                        context.stats.characterStats.abilityScore.constitution -= 1
                    }
                },
                catchUpMethod:(context)=>{
                    context.stats.characterStats.abilityScore.constitution -= 4
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x % 4 == 0){
                            context.stats.characterStats.abilityScore.constitution -= 1
                        }
                    }
                },
            },
            {
                name:"Stored Light",
                type:["Living Saint", "Devout Healer"],
                description:`When a healing spell overheals a creature, you store the additional healing. You can as a swift action touch a creature and expend all stored healing to heal them for the amount stored. This only counts healing that would have no effect and be wasted, not healing that would be converted to temporary hit points or negated or any other similar effect. Stored healing is reset at the end of every floor.`,
            },
            {
                name:"Enduring Luminescence",
                type:["Living Saint", "Devout Healer"],
                description:`When a healing spell overheals a creature, you can redirect the additional unused healing to another ally within your natural reach. This only counts healing that would have no effect and be wasted, not healing that would be converted to temporary hit points or negated or any other similar effect. Stored healing is reset at the end of every floor.`,
            },
            {
                name:"Revel in Purity",
                type:["Living Saint", "Crusader"],
                description:`Whenever you kill an enemy personally, you can heal yourself and all allies within 10 feet of you for an amount of d6's equal to your highest mental modifier.`,
            },
            {
                name:"Rapture",
                type:["Living Saint", "Devout Healer"],
                description:`Once per floor as a swift action for level spell points, you can cause a living ally within 30 feet that is within 1 alignment step as you is sent to heaven/hell for 1 round. At the start of your next turn they return to their location, having been healed to 100% hit points, and having all following adverse conditions affecting them removed: temporary negative levels, ability score penalties, ability damage, blinded, confused, dazed, dazzled, deafened, diseased, exhausted, fatigued, feebleminded, insanity, nauseated, poisoned, sickened, fear, prone, staggered, and stunned.`,
            },
            {
                name:"*Living* Saint",
                type:["Living Saint"],
                description:`Once per run when you are killed, you are restored to life as true resurrection in 3 rounds.`,
            },
            {
                name:"Dei Voluntas",
                type:["Crusader"],
                description:`Once per run when you are about to be killed, you delay the death for 3 rounds. During this time you do not fall unconscious when below 0 hit points, and cannot have your actions restricted by any status or condition. You also gain an untyped bonus equal to your highest mental modifier to attacks and damage rolls.`,
            },
            {
                name:"Eternally Faithful",
                type:["Devout Healer"],
                description:`When you die, you can spend level spell points to cause a ghostly image of yourself to appear for 1 round, plus 1 round per 8 levels. It can continue to cast healing spells on allies (but not yourself), this costs spell points from you as normal. The image cannot be destroyed or harmed in any way, though can be dispelled or winks out in antimagic fields or similar abilities. It gains its full turn to take actions, but can only move and cast healing spells. It can fly, gaing perfect fly speed equal to your movement speed. It keeps none of the buffs or affects active on you when you died, and vanishes immediately if you are brought back to life. Any healing spell you cast during this has its spell point cost doubled.`,
            },
            {
                name:"Light's Protection",
                type:["All"],
                description:`When you cast a healing spell on an ally, they gain temporary hit points equal to your highest mental modifier x the level of the spell that last one round. This can only affect a single ally per casting of a spell.`,
            },
            {
                name:"Symbol of Hope",
                type:["Living Saint", "Crusader"],
                description:`Once per floor as a movement action, you can allow all allies within 50 feet to recover a single maneuver. The next time this floor they initiate that maneuver, they heal your highest mental modifier x the maneuver's level hit points.`,
            },
            {
                name:"To the Masses",
                type:["Living Saint", "Devout Healer"],
                description:`Your mass healing spells that require all targets to be within 30 feet of each other have the maximum distance creatures can be from each other increased by 15 feet.`,
            },
            {
                name:"Open the Gates",
                type:["Living Saint", "Devout Healer"],
                description:`You can suffer a permanet negative level to cause a healing spell you are about to cast to be able to restore creatures who have died within 1 round from the dead as the breathe of life spell.`,
            },
            {
                name:"Divine Word",
                type:["All"],
                description:`Once per floor as a free action you can take even when not your turn, you can cause your next healing spell or perk to gain 100 positive spell power.`,
            },
            {
                name:"Everlasting Light",
                type:["All"],
                description:`Your healing spells cost 1 less spell point to cast. This cannot reduce the cost of the healing spell below 1. If the spell is level 4 or above, it instead costs 2 less spell points to cast. If it level 8 or above, it instead costs 3 spell points less to cast.`,
            },
            {
                name:"Spirit Soothe",
                type:["Living Saint", "Devout Healer"],
                description:`When you cast a healing spell on an ally, they gain level/4 temporary spell points for 1 round. This can only affect a single ally per casting of a spell.`,
            },
            {
                name:"Divine Gift",
                type:["All"],
                description:`Gain an R+ magic perk.`,
                hasCustomMethod:true,
                customMethod:()=>{
                },
                catchUpMethod:(context)=>{
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"perks",options:{type:{magic:true},rarity:{rare:true,epic:true,legendary:true,unique:true,}}}))
                },
            },
            {
                name:"Priestly Training",
                type:["All"],
                description:`Gain 2 magic/metamagic feats.`,
                hasCustomMethod:true,
                customMethod:()=>{
                },
                catchUpMethod:(context)=>{
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"feat",options:{magic:true, metamagic:true}}))
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"feat",options:{magic:true, metamagic:true}}))
                },
            },
            {
                name:"Power Infusion",
                type:["All"],
                description:`Once per floor, when you cast a healing spell, you can also cause the targets healed to be affected by the haste spell (CL is the spells level).`,
            },
            {
                name:"Focused Training",
                type:["All"],
                description:`You gain positive spell power equal to 1/4 your <light> mastery. You gain <light> mastery equal to 1/4 your positive spell power. These calculations are done before they are modified by this ability.`,
            },
            {
                name:"Unwavering Faith",
                type:["All"],
                description:`When above 75% hit points, your healing spells heal an additional 15%, and you gain a +4 bonus on concentration checks to cast healing and buff spells. When at 100% hit points, your healing spells gain an additional 2% chance to critically heal.`,
                additionalInfoTags:["Percentage Spell Critical"],
            },
            {
                name:"Twist of Fate",
                type:["Crusader","Living Saint"],
                description:`When you cast a healing spell, if you cast a damage spell before the end of your next turn, it gains 15 universal spell power. When you cast a damage spell, if you cast a healing spell before the end of your next turn gains 15 positive spell power.`,
            },
            {
                name:"Inspiration",
                type:["All"],
                description:`When you critically heal an ally, they reduce all damage they take by 15% for 1 round.`,
            },
            {
                name:"Sanctified Liturgy",
                type:["Devout Healer"],
                description:`Gain an additional level+ healing spell every odd level.`,
                hasCustomMethod:true,
                customMethod:(context, self)=>{
                    if(context.stats.characterStats.misc.level % 2 == 1){
                        self.getSpell(context, context.stats.characterStats.misc.level+2)
                    }
                },
                catchUpMethod:(context, self)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x % 2 == 1){
                            self.getSpell(context, x+2)
                        }
                    }
                },
            },
            {
                name:"Liturgical",
                type:["All"],
                description:`Gain an additional healing spell every even level.`,
                hasCustomMethod:true,
                customMethod:(context, self)=>{
                    if(context.stats.characterStats.misc.level % 2 == 0){
                        self.getSpell(context, context.stats.characterStats.misc.level)
                    }
                },
                catchUpMethod:(context, self)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x % 2 == 0){
                            self.getSpell(context, x)
                        }
                    }
                },
            },
            {
                name:"Templar",
                type:["All"],
                description:`Gain an additional <light/guardian/heroic> maneuver at 1st and every 3rd level.`,
                hasCustomMethod:true,
                customMethod:(context, self)=>{
                    if(context.stats.characterStats.misc.level % 3 == 0){
                        self.getManeuver(context, context.stats.characterStats.misc.level)
                    }
                },
                catchUpMethod:(context, self)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x % 3 == 0 || x == 1){
                            self.getManeuver(context, x)
                        }
                    }
                },
            },
            {
                name:"Warrior of Light",
                type:["Crusader"],
                description:`Every time you cast a healing spell, you can choose to gain a <light> combo point (max 1x per round). Every time you initiate a finisher using a <light> combo point, you heal initiation modifier * finisher level hit points.`,
            },
            {
                name:"Penitant",
                type:["Devout Healer","Living Saint"],
                description:`While below 33% hit points, your healing spells affecting allies other than yourself heal 25% more.`,
            },
            {
                name:"Blaze of Light",
                type:["Crusader"],
                description:`Every time you score a critical hit with a non-magical attack, you can heal yourself or an ally within your natural reach an amount equal to 1/4 the damage done.`,
            },
            {
                name:"Aegis of Wrath",
                type:["Crusader"],
                description:`Whenever you score a critical hit when using a maneuver from the <light/guardian/heroic> combo tags, the creature suffers a penalty to its damage for 1 round equal to your initiation modifier.`,
            },
            {
                name:"Censure",
                type:["All"],
                description:`As a swift action for level spell points, you can cause a creature you can see within 50 feet to suffer a penalty to its damage for 1 round equal to your initiation modifier. Every 8 levels this lasts an additional round.`,
            },
            {
                name:"Crusader's Smite",
                type:["Crusader"],
                description:`Once per floor for level spell points as a swift action, choose one target within sight to smite. The smite only works if the creature has an opposite good/evil alignment as yours, if you are neutral you can smite both good and evil creatures, but you only gain half the effect. You add highest mental bonus (if any) to attack rolls and add level to all damage rolls made against the target of the smite, you bypass all DR the target of the smite has, and gain a deflection bonus equal to highest mental stat modifier against attacks made by the target of the smite. If you smite a creature who's alignment is not an alignment you gain a bonus against your smite fails and your order effects do not activate. At level 9 and 18 you will gain an order.`,
                hasCustomMethod:true,
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level % 9 == 0){
                        let smite = perks.find(perk => perk.name == "Smite")
                        smite.getOrder(context, smite)
                    }
                },
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x % 9 == 0){
                            let smite = perks.find(perk => perk.name == "Smite")
                            smite.getOrder(context, smite)
                        }
                    }
                },
            },
            {
                name:"Light's Promise",
                type:["Living Saint", "Devout Healer"],
                description:`Every time you cast a healing spell on an ally that doesn't also heal you, you heal 10% of the healing given. This only affects a single target, if the healing spell would have healed multiple creatures. This only affects a single time they are healed during the duration.`,
            },
            {
                name:"Blessed Recover",
                type:["All"],
                description:`When you suffer a critical hit, you gain fast healing equal to your highest mental modifier for rounds equal to 1/2 your level.`,
            },
            {
                name:"Aegis of the Faithful",
                type:["All"],
                description:`The first time per floor you are brought below 30% hit points, you gain temporary hit points equal to your maximum hit points until the end of your next turn.`,
            },
            {
                name:"Divine Servant",
                type:["Living Saint", "Devout Healer"],
                description:`Every time you cast a healing spell during combat, you gain 1 service stack. You can expend all of your service stacks as a free action when casting a healing spell to gain 5 positive spell power per stack expended.`,
            },
            {
                name:"Castigate",
                type:["Crusader"],
                description:`Every time you cast a healing spell, you gain 1 castigation stack. You can expend all of your castigation stacks as a swift action before making a non-magical attack to gain a bonus on the attack equal to the stacks expended, and 4 times as much to damage. This damage is not multiplied on critical hits or other multipliers to damage.`,
            },
            {
                name:"Lightweaver",
                type:["All"],
                description:`For every round in a row you have cast a healing spell, you gain 2 positive spell power. This resets on floor end.`,
            },
            {
                name:"Epiphany",
                type:["Crusader"],
                description:`Once per round when you confirm a critical hit with a non-magical attack, you can cast a healing spell on yourself as a free action for 2x the regular spell point cost.`,
            },
            {
                name:"Dark Evangelism",
                type:["Crusader"],
                description:`Once per round when you cast a healing spell, your next physical attack this round has its critical threat range increased by a flat +1. At level 16, it also increases the critical damage multiplier of your next attack this round by +1.`,
            },
            {
                name:"Guardian Light",
                type:["All"],
                description:`After you cast a healing spell on the creature, they gain DR /- equal to the level of the healing spell cast for 1 round. This can stack with other DR, but it is halved. This can only apply to a single creature per casting of a spell.`,
            },
            {
                name:"Sacred Prayer",
                type:["Living Saint"],
                description:`When you use your Petition Ability to bring an ally below 0 hit points to above 0 hit points, they gain a sacred bonus to their armor class equal to your initiation modifier for 1 round.`,
            },
            {
                name:"Redeption",
                type:["Living Saint"],
                description:`When you use your Petition Ability to bring an ally below 0 hit points to above 0 hit points, they gain a sacred bonus to their damage equal to your initiation modifier for 1 round.`,
            },
            {
                name:"Miracle Worker",
                type:["Living Saint"],
                description:`When you use your Divine Intercession ability, if the spells heals, it is increased by 50%. You can use Divine Intercession a second time per floor, but you suffer a permanent negative level afterwards for doing so, and it cannot be removed for the rest of the floor.`,
            },
            {
                name:"Sacred Chanter",
                type:["Living Saint"],
                description:`You can use your Divine Intercession ability an additional time per floor, and its critical healing chance is doubled.`,
            },
            {
                name:"Friends in High Places",
                type:["Living Saint"],
                description:`When an ally dies, you can recover a use of your Divine Intercession ability by suffering a permanent negative level. This can only activate on a specific ally a single time per floor. If the ally is revived before you use this activation of Divine Intercession, this additional usage is lost.`,
            },
            {
                name:"Good Graces",
                type:["Living Saint"],
                description:`As long as you have not used your Divine Intercession ability yet this floor, your healing is increased by 25%.`,
            },
            {
                name:"Graceful Faith",
                type:["Living Saint"],
                description:`As long as you have not used your Divine Intercession ability yet this floor, your healing spells have their critical percentage increased by 2% and healing criticals heal an additional 15%.`,
            },
            {
                name:"Benediction",
                type:["Living Saint"],
                description:`For 1 round after using your Divine Intercession ability, your healing spells have their critical chance increased by 4% and heal an additional 25%.`,
            },
            {
                name:"Comrade In Arms",
                type:["Crusader"],
                description:`When you use your Crusader's Fervor to heal an ally other than yourself, they gain a sacred bonus on their next damage roll this round equal to your initiation modifier.`,
            },
            {
                name:"Body and Soul",
                type:["All"],
                description:`Increase your critical chance with healing spells by 2%. Whenever you critically heal an ally, they can also recover a single maneuver.`,
            },
            {
                name:"In Your Place",
                type:["Living Saint","Crusader"],
                description:`As a free action once per combat you can transfer any condition an ally within 30 feet that you can see that is currently suffering from them to yourself (doesn't include dead or dying). If you would have any immunities to that condition, this bypasses them.`,
            },
            {
                name:"Noble Templar",
                type:["Crusader"],
                description:`Once per combat as a free action you can take even when not your turn, you can transfer any amount of damage an ally just took to yourself. This bypasses any DR or resistances to the damage.`,
            },
            {
                name:"Rapturous",
                type:["Crusader"],
                description:`When below 25% hit points, you can cause your healing spells to instead deal negative energy damage (but only to damage creatures).`,
            },
            {
                name:"Dark Templar",
                type:["Crusader"],
                description:`Gain <dark> maneuver at 1st and every 3 levels. Whenever you initiate a finisher with a <dark> combo point, you heal hit points equal to half your dark mastery.`,
                hasCustomMethod:true,
                customMethod:(context, self)=>{
                    if(context.stats.characterStats.misc.level % 3 == 0 || context.stats.characterStats.misc.level == 1){
                        self.getManeuver(context, context.stats.characterStats.misc.level, "", "Dark")
                    }
                },
                catchUpMethod:(context, self)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x % 3 == 0 || x == 1){
                            self.getManeuver(context, x, "", "Dark")
                        }
                    }
                },
            },
            {
                name:"Flaggellant",
                type:["Crusader"],
                description:`Gain Crimson Reaper maneuver every odd level. Instead of gaining 50%/75% reduced positive energy healing after healing/gaining temporary hit points from a crimson reaper maneuver, you instead gain no healing from allies, but your own positive energy healing spells still heal 25%/50% (The percentage x/y, x is after healing or gaining temporary hit points, and y is after gaining both, see crimson reaper for more info.)`,
                hasCustomMethod:true,
                customMethod:(context, self)=>{
                    if(context.stats.characterStats.misc.level % 2 == 1){
                        self.getManeuver(context, context.stats.characterStats.misc.level, "", "crimsonReaper")
                    }
                },
                catchUpMethod:(context, self)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x % 2 == 1){
                            self.getManeuver(context, x, "", "crimsonReaper")
                        }
                    }
                },
            },
            {
                name:"Holy Word: Serenity",
                type:["Living Saint", "Devout Healer"],
                description:`Once per floor as a standard action for level spell points, you can speak a holy word of serenity, blessing an ally within 50 feet of you. In 3 rounds, the ally heals to full hit points. This doesn't affect them if they are dead, even if they could normally be healed when dead.`,
            },
        ]
    },
    {
        rarity: "unique",
        type: "universal",
        name: "Wild Shape",
        fromClass:"Druid",
        shortDesc: `*This perks' wording will update as you level up, and is more complicated than many unique perks, use with caution*
        \n\nAs a standard action you can spend up to your level spell points, costing that same amount every round to maintain, to assume the shape of an animal, while in this shape you cannot cast spells unless they are verbal only, activate wonderous items, or use your armor or weapons. This counts as being under a spell of the polymorph school. When you do, you gain wild points equal to 2x the spell points spent which you can allocate to special abilities and natural attacks that you gain while transformed. Additionally, you also choose a single size or shape. You can spend up to twice your level in spell points on this ability, but after spending your level per round, you only gain a single wild point instead.
        \nAll stat modifiers are size bonuses. The cost of an ability will be shown in the () to the left of the abilities. The P or S next to a natural attack indicates whether it is a primary or secondary attack, and all damage listed is assuming medium, but will be changed depending on your size or shape.
        \nSpecial abilities: 
        \n(1) climb 30ft, swim 30ft, darkvision, low-light vision, 
        \n(2) Fly 30ft (average), scent, improved natural armor(+1, can select multiple times)

        \n\nNatural Attacks:
        \n(1) Tentacle, 1d4 (S)
        \n(2) [Bite, 1d6 (P, max 1)], [Claws x2, 1d4 (P, max 4)], [Gore, 1d8, (P, Max 1)]

        \n\nShape:
        \nSmall(0): +2 dexterity, +1 natural armor
        \nMedium(0): +2 strength, +2 natural armor
        \n\nAt level 4 and every 4 levels after you will gain additional sizes, elemental forms, special abilities, and natural attacks.
        \nGain 2 spell points per level, and an ability score every level.
        \n Additionally, every level you gain a Golden Lion/Iron Tortoise/Primal Fury/Silver Crane/Steel Serpent/Brutal Crocodile maneuver.`,
        hasCustomMethod:true,
        customMethod:(context, self)=>{
        self.getManeuver(context, context.stats.characterStats.misc.level)
        context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{abilityScore:true}}}));
        let perk = context.stats.lists.perks.filter(perk => perk.name == "Wild Shape")[0]
        if(context.stats.characterStats.misc.level == 4){
            perk.shortDesc = self.perkDesc[0]
        }else if(context.stats.characterStats.misc.level == 8){
            perk.shortDesc = self.perkDesc[1]
        }else if(context.stats.characterStats.misc.level == 12){
            perk.shortDesc = self.perkDesc[2]
        }else if(context.stats.characterStats.misc.level == 16){
            perk.shortDesc = self.perkDesc[3]
        }
        },
        getManeuver: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            options.school = {goldenLion:true, ironTortoise:true,primalFury:true,silverCrane:true,steelSerpent:true, brutalCrocodile:true}
            let obj={command:"requestRoll", type:"maneuver", options};
            context.connection.send(JSON.stringify(obj));
        },
        catchUpMethod:(context, self)=>{     
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{abilityScore:true}, rarity:{rare:true, epic:true, legendary:true, unique:true}}}));
                self.getManeuver(context, x)
            }          
            context.stats.characterStats.misc.spPerLevel += 2
            let perk = context.stats.lists.perks.filter(perk => perk.name == "Wild Shape")[0]
            if(context.stats.characterStats.misc.level >= 4){
                perk.shortDesc = self.perkDesc[0]
            } 
            if(context.stats.characterStats.misc.level >= 8){
                perk.shortDesc = self.perkDesc[1]
            }
            if(context.stats.characterStats.misc.level >= 12){
                perk.shortDesc = self.perkDesc[2]
            }
            if(context.stats.characterStats.misc.level >= 16){
                perk.shortDesc = self.perkDesc[3]
            }

        },
        perkDesc:[
//lvl 4 beast shape 2, elemental shape 1
            `\n\nAs a standard action you can spend up to your level spell points, costing that same amount every round to maintain to assume the shape of an animal. While in this shape you cannot cast spells unless they are verbal only, activate wonderous items, or use your armor or weapons. If in the shape of an elemental, you can still cast spells normally. This counts as being under a spell of the polymorph school. When you do, you gain wild points equal to 2x the spell points spent which you can allocate to special abilities and natural attacks that you gain while transformed. Additionally, you also choose a single size or shape. You can spend up to twice your level in spell points on this ability, but after spending your level per round, you only gain a single wild point instead.
            \nAll stat modifiers are size bonuses. The cost of an ability will be shown in the () to the left of the abilities. The P or S next to a natural attack indicates whether it is a primary or secondary attack, and all damage listed is assuming medium, but will be changed depending on your size or shape. If a special ability is activated from an attack (such as grab or trip), select 1 type of natural attack to gain that special ability.
            \nSpecial abilities: 
            \n(1) climb 60ft, swim 60ft, darkvision, low-light vision, 
            \n(2) Fly 60ft (good), scent, grab, improved natural armor(+1, can select multiple times)
            \n(3) Pounce, Trip

            \n\nNatural Attacks:
            \n(1) Tentacle, 1d4 (S)
            \n(2) [Bite, 1d6 (P, max 1)], [Claws x2, 1d4 (P, max 6)], [Gore, 1d8, (P, Max 1)]

            \n\nShape:
            \nTiny(0): +4 dexterity, -2 strength, +1 natural armor
            \nSmall(0): +2 dexterity, +1 natural armor
            \nMedium(0): +2 strength, +2 natural armor
            \nLarge(0): +4 strength, -2 dexterity, +4 natural armor
            \nElemental(3): as elemental body 1
            \n\nAt level 4 and every 4 levels after, you will gain additional sizes, elemental forms, special abilities, and natural attacks.
            \nGain 2 spell points per level
            \n Additionally, every level you gain a Golden Lion/Iron Tortoise/Primal Fury/Silver Crane/Steel Serpent/Brutal Crocodile maneuver.`,


//lvl 8 beast shape 3, elemental shape 2
            `\n\nAs a standard action you can spend up to your level spell points, costing that same amount every round to maintain to assume the shape of an animal. While in this shape you cannot cast spells unless they are verbal only, activate wonderous items, or use your armor or weapons. If in the shape of an elemental, you can still cast spells normally. This counts as being under a spell of the polymorph school. When you do, you gain wild points equal to 2x the spell points spent which you can allocate to special abilities and natural attacks that you gain while transformed. Additionally, you also choose a single size or shape. You can spend up to twice your level in spell points on this ability, but after spending your level per round, you only gain a single wild point instead.
            \nAll stat modifiers are size bonuses. The cost of an ability will be shown in the () to the left of the abilities. The P or S next to a natural attack indicates whether it is a primary or secondary attack, and all damage listed is assuming medium, but will be changed depending on your size or shape. If a special ability is activated from an attack (such as grab or trip), select 1 type of natural attack to gain that special ability.
            \nSpecial abilities: 
            \n(1) climb 90ft, swim 90ft, darkvision, low-light vision, jet, elemental resistance (5 one type, chosen on taking form), 
            \n(2) Fly 60ft (good), scent, grab, burrow 30ft, rake(talons only) poison (sting only, fort dc 10+level/2+con, 1d2 str/dex x6 (your choice)), trample, web, improved natural armor(+1, can select multiple times)
            \n(3) Pounce, Trip, blindsense 30ft, ferocity, rake,
            \n(4) Constrict

            \n\nNatural Attacks:
            \n(1) [Tentacle, 1d4 (S)], [Talons x2, 1d3 (S, max 4)], [Sting, 1d4 (P, max 1)]
            \n(2) [Bite, 1d6 (P, max 2)], [Claws x2, 1d4 (P, max 6)], [Gore, 1d8, (P, Max 2)], [Tail Slap, 1d6, (S, +5 ft reach, +5 if > Huge, max 3)]
            \n(3) Arm (a regular arm, allows you to wield a weapon or shield, all natural attacks become secondary while attacking with weapons and natural attacks, max 2)

            \n\nShape:
            \nDiminutive(1): +6 dexterity, -4 strength, +1 natural armor
            \nTiny(0): +4 dexterity, -2 strength, +1 natural armor
            \nSmall(0): +4 dexterity, +2 natural armor
            \nMedium(0): +4 strength, +4 natural armor
            \nLarge(0): +4 strength, -2 dexterity, +4 natural armor
            \nHuge(1): +6 strength, -4 dexterity, +6 natural armor
            \nElemental 1(3): as elemental body 1
            \nElemental 2(4): as elemental body 2
            \n\nAt level 4 and every 4 levels after, you will gain additional sizes, elemental forms, special abilities, and natural attacks.
            \nGain 2 spell points per level
            \n Additionally, every level you gain a Golden Lion/Iron Tortoise/Primal Fury/Silver Crane/Steel Serpent/Brutal Crocodile maneuver.`,

//lvl 12, beast shape 4, elemental shape 3
            `\n\nAs a standard action you can spend up to your level spell points, costing that same amount every round to maintain to assume the shape of an animal. While in this shape you cannot cast spells unless they are verbal only, activate wonderous items, or use your armor or weapons. If in the shape of an elemental, you can still cast spells normally. This counts as being under a spell of the polymorph school. When you do, you gain wild points equal to 2x the spell points spent which you can allocate to special abilities and natural attacks that you gain while transformed. Additionally, you also choose a single size or shape. You can spend up to twice your level in spell points on this ability, but after spending your level per round, you only gain a single wild point instead.
            \nAll stat modifiers are size bonuses. The cost of an ability will be shown in the () to the left of the abilities. The P or S next to a natural attack indicates whether it is a primary or secondary attack, and all damage listed is assuming medium, but will be changed depending on your size or shape. If a special ability is activated from an attack (such as grab or trip), select 1 type of natural attack to gain that special ability.
            \nSpecial abilities: 
            \n(1) climb 90ft, swim 90ft, darkvision, low-light vision, jet, scent,  elemental resistance (10 one type, chosen on taking form), improved natural armor(+1, can select multiple times)
            \n(2) Fly 90ft (good), grab, burrow 30ft, rake(talons only) poison (sting only, fort dc 10+level/2+con, 1d2 str/dex x6 (your choice)), trample, web, 
            \n(3) Pounce, Trip, blindsense 60ft, ferocity, rake, tremorsense 30ft,
            \n(4) Constrict, fast healing 5, Damage Reduction -/5

            \n\nNatural Attacks:
            \n(1) [Tentacle, 1d4 (S)], [Talons x2, 1d3 (S, max 4)], [Sting, 1d4 (P, max 1)]
            \n(2) [Bite, 1d6 (P, max 2)], [Claws x2, 1d4 (P, max 6)], [Gore, 1d8, (P, Max 2)], [Tail Slap, 1d6, (S, +5 ft reach, +5 if > Huge, max 4)]
            \n(3) Arm (a regular arm, allows you to wield a weapon or shield, all natural attacks become secondary while attacking with weapons and natural attacks, max 3)

            \n\nShape:
            \nFine(3): +8 dexterity, -6 strength, +1 natural armor
            \nDiminutive(2): +6 dexterity, -4 strength, +1 natural armor
            \nTiny(0): +6 dexterity, -2 strength, +3 natural armor
            \nSmall(0): +4 dexterity, +2 natural armor
            \nMedium(0): +4 strength, +4 natural armor
            \nLarge(0): +6 strength, +2 constitution, -2 dexterity, +6 natural armor
            \nHuge(2): +8 strength, -4 dexterity, +6 natural armor
            \nGargantuan(3): +10 strength, +2 constitution, -6 dexterity, +8 natural armor
            \nElemental 1(3): as elemental body 1
            \nElemental 2(4): as elemental body 2
            \nElemental 3(5): as elemental body 3
            \n\nAt level 4 and every 4 levels after, you will gain additional sizes, elemental forms, special abilities, and natural attacks.
            \nGain 2 spell points per level
            \n Additionally, every level you gain a Golden Lion/Iron Tortoise/Primal Fury/Silver Crane/Steel Serpent/Brutal Crocodile maneuver.`,

//lvl 16 beast shape 5, elemental shape 4
            `\n\n\n\nAs a standard action you can spend up to your level spell points, costing that same amount every round to maintain to assume the shape of an animal. While in this shape you cannot cast spells unless they are verbal only, activate wonderous items, or use your armor or weapons. If in the shape of an elemental, you can still cast spells normally. This counts as being under a spell of the polymorph school. When you do, you gain wild points equal to 2x the spell points spent which you can allocate to special abilities and natural attacks that you gain while transformed.  Additionally, you also choose a single size or shape. You can spend up to twice your level in spell points on this ability, but after spending your level per round, you only gain a single wild point instead.
            \nAll stat modifiers are size bonuses. The cost of an ability will be shown in the () to the left of the abilities. The P or S next to a natural attack indicates whether it is a primary or secondary attack, and all damage listed is assuming medium, but will be changed depending on your size or shape. If a special ability is activated from an attack (such as grab or trip), select 1 type of natural attack to gain that special ability.
            \nSpecial abilities: 
            \n(1) climb 120ft, swim 120ft, darkvision, low-light vision, jet, scent, elemental resistance (20 one type, chosen on taking form), improved natural armor(+1, can select multiple times)
            \n(2) Fly 90ft (good), grab, burrow 60ft, rake(talons only) poison (sting only, fort dc 10+level/2+con, 1d4 str/dex/int/wis x6 (your choice)), trample, web,
            \n(3) Pounce, Trip, blindsense 60ft, ferocity, rake, tremorsense 60ft,
            \n(4) Constrict, fast healing 5, Damage Reduction 5/-, breath weapon (2d4 rounds, lvl x 1d6, reflex 10+level/2 + con, element of choice when you assume wild shape)

            \n\nNatural Attacks:
            \n(1) [Tentacle, 1d4 (S)], [Talons x2, 1d3 (S, max 6)], [Sting, 1d4 (P, max 2)]
            \n(2) [Bite, 1d6 (P, max 3)], [Claws x2, 1d4 (P, max 8)], [Gore, 1d8, (P, Max 3)], [Tail Slap, 1d6, (S, +5 ft reach, +5 if > Huge, max 6)]
            \n(3) Arm (a regular arm, allows you to wield a weapon or shield, all natural attacks become secondary while attacking with weapons and natural attacks, max 4)
            \n(4) [Slam, 2d6, (P)]

            \n\nShape:
            \nFine(4): +10 dexterity, -6 strength, +1 natural armor
            \nDiminutive(2): +8 dexterity, -4 strength, +3 natural armor
            \nTiny(0): +6 dexterity, -2 strength, +3 natural armor
            \nSmall(0): +4 dexterity, +2 natural armor
            \nMedium(0): +4 strength, +4 natural armor
            \nLarge(0): +8 strength, +2 constitution, -2 dexterity, +6 natural armor
            \nHuge(2): +10 strength, +2 constitution, -4 dexterity, +8 natural armor
            \nGargantuan(4): +12 strength, +4 constitution, -6 dexterity, +10 natural armor
            \nElemental 1(3): as elemental body 1
            \nElemental 2(4): as elemental body 2
            \nElemental 3(5): as elemental body 3
            \nElemental 4(6): as elemental body 4
            \n\nThis perk is as powerful as it will become.
            \nGain 2 spell points per level
            \n Additionally, every level you gain a Golden Lion/Iron Tortoise/Primal Fury/Silver Crane/Steel Serpent/Brutal Crocodile maneuver.`,
        ]
    },
    {
    rarity: "unique",
    type: "magic",
    name: "Spontaneous Destruction",
    shortDesc: `When you select this perk you will select an elemental focus (fire, electricity, cold, acid, universal). Depending on the element, you will gain various bonuses to their power, and massive penalties to their opposing element (-50 power, -10% critical chance, -25% critical damage).
    \nYou gain resistance to your element equal to 2x your level. Half of this bonus stacks will all others. (Universal gains 1 per 2 levels to all elements)
    \nEvery level you will gain a spell of your element, and every odd level you will gain a lvl+ spell of the element/sub element.
    \nEvery odd level you will gain a destruction talent.`,
    hasCustomMethod:true,
    customMethod:(context,self,contextSelf)=>{
        self.getSpell(context, self, contextSelf.elementChosen, context.stats.characterStats.misc.level)
        if(context.stats.characterStats.misc.level %2 == 1){
            self.getPerks(context, self, contextSelf, contextSelf.elementChosen)
        }
        contextSelf.perkChoices.forEach(perk => {
            let found = self.destructionPerks.find(p => p.name == perk)
            if(found){
                found.customMethod(context,contextSelf)
            }
        })
        let element = self.elements.find(e => e.name.toLowerCase() == contextSelf.elementChosen)
        element.customMethod(context)
    },
    perkChoices:[],
    getPerks:(context, self, contextSelf, element)=>{
        let filtered = self.destructionPerks.filter(perk => !perk.type || element.includes(perk.type))
        let choices = []
        let chosen = []
        for(let x = 0; x < 4; x++){
            let possible = Math.floor(Math.random()*filtered.length)
            while(chosen.includes(possible)) possible = Math.floor(Math.random()*filtered.length)
            chosen.push(possible)
            let option = filtered[possible]
            choices[x] = {
                title:option.name,
                description:option.description,
                id:x,
                method:(context =>{
                    let perk = {rarity:"unique", name:option.name, id:Math.random()*1000000, additionalInfoTags:option.additionalInfoTags, abilityType:option.abilityType, type:"magic", shortDesc:option.description}
                    if(option.hasCustomMethod){
                        option.catchUpMethod(context,element,perk)
                        contextSelf.perkChoices.push(perk.name)
                    }
                    context.stats.lists.perks.push(perk)
                })
            }                
        }
        let custom = {title:"Destruction Perk Selection", options:choices}
        context.customDialogArray.push(custom)
    },        
    catchUpMethod:(context, self, contextSelf)=>{
        let elements = self.elements
        let choices = []
        let chosen = []
        for(let x = 0; x < 3; x++){
            let possible = Math.floor(Math.random()*elements.length)
            while(chosen.includes(possible)) possible = Math.floor(Math.random()*elements.length)
            chosen.push(possible)
            let option = elements[possible]
            choices[x] = {
                title:option.name,
                description:option.description,
                id:x,
                method:(() =>{
                    contextSelf.elementChosen = option.name.toLowerCase()
                    contextSelf.shortDesc += `\n\n` + option.text
                    if(option.hasCustomMethod){
                        option.catchUpMethod(context)
                    }
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        self.getSpell(context, self, option.name.toLowerCase(), x)
                    }
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%2 == 1){
                            self.getPerks(context,self,contextSelf,option.name.toLowerCase())
                        }
                    }
                })
            }                
        }
        let custom = {title:"Spontaneous Element", options:choices}         
        context.customDialogArray.push(custom)
    },

    getSpell(context, self, element, level){
        let options = {level:{}}
        options = self.getSpellLevels(level,options)
        if(element == "universal"){
            options.type = {damage:true}
            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options}))
            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options}))
        }else{
            options.tags = [element]                    
            let obj={command:"requestRoll", type:"spell", options};
            context.connection.send(JSON.stringify(obj));
        }                
        if(level%2 == 1){
            options = self.getSpellLevels(level+2, options)
            if(element == "universal"){
                context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options}))
            }else{
                if(element == "cold") options.tags.push("water")
                if(element == "acid") options.tags.push("earth")
                    if(element == "fire") options.tags.push("light")
                if(element == "electricity") options.tags.push("air")    
                let obj={command:"requestRoll", type:"spell", options};
                context.connection.send(JSON.stringify(obj));                       
            }                                   
        }
    },

    getSpellLevels:(level, options)=>{
        let lvlNum = Math.ceil(level/2) + 1
        if(lvlNum > 9){lvlNum = 9}
        
        for(let x = 0; x < 4; x++){
            if(lvlNum-x >= 0){   
                let level = lvlNum-x
                let levelString="lvl"+level;
                options.level[levelString]=true;
            }
        }
        return options
    },

    hasSpecialItems:true,
    getSpecialItemList:(self)=>{
        let elements = {fire:0, cold:0, electricity:0, acid:0, universal:0, all:0}
        self.destructionPerks.forEach(perk=>{
            if(perk.type) elements[perk.type]++
            else elements.all++
        })

        return self.destructionPerks.map(perk=> { 
            let newPerk = {name:perk.name, description:perk.description}
            if(perk.type) newPerk.type = [perk.type]
            return newPerk
        })
    },

    elements: [
        {
            name:"Fire",                    
            text:`Chosen: Fire/Light    \nYour fire spells gain: 25 spell power, +3 every level \n4% critical chance, +1% per 2 levels, \n15% critical damage, +1% per 2 levels.`,
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.fire += 3
                if(context.stats.characterStats.misc.level%2 == 0){
                    context.stats.characterStats.spellMastery.spellCriticalChance.fire += 1
                    context.stats.characterStats.spellMastery.spellCriticalDamage.fire += 1
                }
            },
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.cold -= 50
                context.stats.characterStats.spellMastery.spellCriticalChance.cold -= 10
                context.stats.characterStats.spellMastery.spellCriticalDamage.cold -= 25

                context.stats.characterStats.spellMastery.spellPower.fire += 25
                context.stats.characterStats.spellMastery.spellCriticalChance.fire += 3
                context.stats.characterStats.spellMastery.spellCriticalDamage.fire += 15
                for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                    context.stats.characterStats.spellMastery.spellPower.fire += 4
                    if(x%2 == 0){
                        context.stats.characterStats.spellMastery.spellCriticalChance.fire += 1
                        context.stats.characterStats.spellMastery.spellCriticalDamage.fire += 1
                    }
                }
            }
        },
        {
            name:"Cold",                    
            text:`Chosen: Cold/Water    \nYour cold spells gain: 15 spell power, +3 every level \n2% critical chance, +1% per 2 levels \n45% critical power, +4% per level.`,
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.cold += 3
                if(context.stats.characterStats.misc.level%4 == 0){
                    context.stats.characterStats.spellMastery.spellCriticalChance.cold += 1
                }
                if(context.stats.characterStats.misc.level%2 == 0){
                    context.stats.characterStats.spellMastery.spellCriticalDamage.cold += 1
                }
            },
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.fire -= 50
                context.stats.characterStats.spellMastery.spellCriticalChance.fire -= 10
                context.stats.characterStats.spellMastery.spellCriticalDamage.fire -= 25

                context.stats.characterStats.spellMastery.spellPower.cold += 15
                context.stats.characterStats.spellMastery.spellCriticalChance.cold += 2
                context.stats.characterStats.spellMastery.spellCriticalDamage.cold += 45

                for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                    context.stats.characterStats.spellMastery.spellPower.cold += 3
                    context.stats.characterStats.spellMastery.spellCriticalDamage.cold += 4
                    if(x%2 == 0){
                        context.stats.characterStats.spellMastery.spellCriticalChance.cold += 1
                    }
                }
            }
        },
        {
            name:"Electricity",                   
            text:`Chosen: Electricity/Air   \nYour electricity spells gain: 20 spell power, +1 every level \n6% critical chance, +1% per level, \n25% critical damage, +2% per level`,
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.electricity += 1
                context.stats.characterStats.spellMastery.spellCriticalChance.electricity += 1
                context.stats.characterStats.spellMastery.spellCriticalDamage.electricity += 2
                
            },
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.acid -= 50
                context.stats.characterStats.spellMastery.spellCriticalChance.acid -= 10
                context.stats.characterStats.spellMastery.spellCriticalDamage.acid -= 25

                context.stats.characterStats.spellMastery.spellPower.electricity += 20
                context.stats.characterStats.spellMastery.spellCriticalChance.electricity += 6

                for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                    context.stats.characterStats.spellMastery.spellPower.electricity += 1
                    context.stats.characterStats.spellMastery.spellCriticalChance.electricity += 1
                    context.stats.characterStats.spellMastery.spellCriticalDamage.electricity += 2
                }
            }
        },
        {
            name:"Acid",                    
            text:`Chosen: Acid/Earth    \nYour acid spells gain: 25 spell power, +2 every level \n2% critical chance, +1% per 3 levels, \n25% critical damage, +4% per level. 
            \nYour HD size increases by 2 (rerolls HD), a +2 bonus to your natural armor (stacking with all others).`,
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.acid += 2
                context.stats.characterStats.spellMastery.spellCriticalDamage.acid += 3
                if(context.stats.characterStats.misc.level%3 == 0){
                    context.stats.characterStats.spellMastery.spellCriticalChance.acid += 1
                }
            },
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.electricity -= 50
                context.stats.characterStats.spellMastery.spellCriticalChance.electricity -= 10
                context.stats.characterStats.spellMastery.spellCriticalDamage.electricity -= 25

                context.stats.characterStats.spellMastery.spellPower.acid += 25
                context.stats.characterStats.spellMastery.spellCriticalChance.acid += 2
                context.stats.characterStats.spellMastery.spellCriticalDamage.acid += 25

                for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                    context.stats.characterStats.spellMastery.spellPower.acid += 2
                    context.stats.characterStats.spellMastery.spellCriticalDamage.acid += 4
                    if(x%3 == 0){
                        context.stats.characterStats.spellMastery.spellCriticalChance.acid += 1
                    }
                }
                context.stats.statsForAbilities.ac.natural += 2
                context.stats.characterStats.misc.HDSize += 2
                context.stats.characterStats.hpIncreases.splice(0, 1, context.stats.characterStats.misc.HDSize)
                for(let x = 1; x < context.stats.characterStats.hpIncreases.length; x++){                
                    context.stats.characterStats.hpIncreases.splice(x, 1, Math.ceil(Math.random() * context.stats.characterStats.misc.HDSize))                
                }     
            }           
        },
        {
            name:"Universal",
            text:`Chosen: Universal    \nGain 15 universal spell power, +2 every level.     \nGain 2% universal spell critical, +1% per 3 levels \n15% universal spell critical damage, +1% per 2 levels. Universal has no opposing school.`,
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.universal += 2
                if(context.stats.characterStats.misc.level%3 == 0){
                    context.stats.characterStats.spellMastery.spellCriticalChance.universal += 1
                }
                if(context.stats.characterStats.misc.level%2 == 0){
                    context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 1
                }
            },
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.universal += 15
                context.stats.characterStats.spellMastery.spellCriticalChance.universal += 2
                context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 15
                for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                    context.stats.characterStats.spellMastery.spellPower.universal += 2
                    if(x%3 == 0){
                        context.stats.characterStats.spellMastery.spellCriticalChance.universal += 1
                    }
                    if(x%2 == 0){
                        context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 1
                    }
                }
            }  
        },
    ],
    
    destructionPerks: [
        {
            name:"Ice Calm",
            type:"cold",
            description:"You gain a +4 bonus to concentration checks. When you roll a concentration check for a spell and succeed, you can spend level/2 spell as a free action points to reroll the concentration check with a penalty equal to 1/2 your level. When you do, you can increase your spell critical chance by 5% plus your 1/2 level. You can only do this once per spell.",
        },
        {
            name:"Never Ending Spells",
            type:"universal",
            description:"Gain +4 spell points per level.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.doNothing = "doNothing"
            },
            catchUpMethod:(context)=>{
                context.stats.characterStats.misc.spPerLevel += 4
            }
        },
        {
            name:"Enduring Chaos",
            description:"Gain +2.5 spell points per level.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.doNothing = "doNothing"
            },
            catchUpMethod:(context)=>{
                context.stats.characterStats.misc.spPerLevel += 2.5
            }
        },
        {
            name:"Destructive Force",
            description:"Your damage spells add your highest mental stat as a bonus to their damage. This only applies the first time it damages a creature, and is added to the base damage before scaling with power.",
        },
        {
            name:"Destructive Havoc",
            description:"Gain 5 universal spell power and 15 spell power of your element.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.doNothing = "doNothing"
            },
            catchUpMethod:(context,element)=>{
                context.stats.characterStats.spellMastery.spellPower.universal += 5
                context.stats.characterStats.spellMastery.spellPower[element] += 15
            }
        },
        {
            name:"Surprise Destruction",
            description:"[Spell Augment] Once per day you can increase a damage spell's cost by 8 spell points to cast it as a swift action. If it was already a swift action, it instead becomes a free action. You can still only cast 2 spells per round.",
        },
        {
            name:"Incredible Destruction",
            description:"[Spell Augment] Once per day while beginning to cast a spell you can increase its spell power by 50. You must choose to do this before the spell is cast, so if it fails, the effect is wasted.",
        },
        {
            name:"Devastating Spell",
            description:"[Spell Augment] Once per day while beginning to cast a spell you can double your element specific critical chance (meaning it doesn't include universal critical chance). You must choose to do this before the spell is cast, so if it fails, the effect is wasted.",
        },
        {
            name:"Elemental Surge",
            description:"[Spell Augment] Once per day you can cause your next spell within 1 round to ignore elemental resistance and immunity. The spell also gains a +2 bonus to its DC.",
        },
        {
            name:"Metamagic Surge",
            description:"[Spell Augment] Once per day you can cause your next spell within 1 round to not have its casting time increased by augmenting it with a metamagic feat, and you reduce its level modification by 1. This spell also gains a +2 DC.",
        },
        {
            name:"Amping Magic",
            description:"Every time you cast a damage spell of your element and it doesn't critically hit its initial damage, you gain a stacking 2% critical spell chance of your element. This resets once a spell critically hits or you leave the floor.",
        },
        {
            name:"To Ashes",
            type:"fire",
            description:"When a fire spell deals damage over time to a creature below 33% hit points, the damage over time gains 25 spell power. When a creature is set on fire by a spell of yours, it counts as spell damage and therefor scales with spell power.",
        },
        {
            name:"Pyromania",
            type:"fire",
            description:"For every creature within 100 feet that is currently on fire, you gain 10 fire spell power. The damage dealt from setting creatures on fire gains bonuses from fire spell power (even when they are not spells).",
        },
        {
            name:"Immolation Engine",
            type:"fire",
            description:"Your effects that set creatures on fire stack, but a spell cannot set a creature on fire more than once per spell. Your spells gain 2% spell critical chance per stack of being on fire that a creature has.",
        },
        {
            name:"Voltage Cascade",
            type:"electricity",
            description:"When you cast a critical electricty spell, your next spell within 2 rounds gains electricity spell power equal to 1/2 your bonus electricity critical power (bonus means the amount above your universal spell critical power). A spell empowered this way cannot trigger this effect.",
        },
        {
            name:"Critical Ignition",
            type:"fire",
            description:"Your critical fire spells set damaged creatures on fire, dealing 1d6+highest fire damage immediately and at the start of each of their turns. The creature is allowed a reflex save at the start of each of their turns to end this effect (DC 10 + your highest mental modifier + any bonuses to fire damage spell DCs). If you have unbound Blaze, this damage stacks with it.",
        },
        {
            name:"Lucky Number",
            description:"Choose a number within your spell critical chance. When you roll that as a spell critical chance, reroll the damage of the spell, but increase your spell critical chance by 100%. This new spell has 5% critical failure chance. You can change the number selected whenever your spell critical chance changes (not during a roll though obviously).",
        },
        {
            name:"Dangerous Math",
            description:"When you cast a spell that fires more than 1 ray, you can fire an additional ray. If spells fire rays over a duration, then you can add one more to the amount of rays fired (such as an extra searing dagger, but it still only fires one per swift action). Spells cast this way suffer a 10% spell critical failure chance.",
        },
        {
            name:"Eruption",
            type:"fire",
            description:"When a creature dies from fire damage from one of your fire spells, the creature explodes in a 10ft radius damaging enemies within 10 feet of the creature's square. This deals a percentage of the damage that killed the creature equal to your fire spell power. Creatures can make a reflex save to halve it (DC 10 + your highest mental modifier + the spells level + any bonuses to fire damage spell DCs).",
        },
        {
            name:"Melting Point",
            type:"acid",
            description:"When an acid spell deals damage over time to a creature below 33% hit points, the damage over time gains 25 spell power, and 2% spell critical chance.",
        },
        {
            name:"Converging Currents",
            description:"Choose a spell you know of your element. Every time you cast a damage spell of your element that isn't that spell, that spell gains 5 spell power the next time it is cast. This resets at the end of a floor or if you die. You can change the selected spell at the start of each floor.",
        },
        {
            name:"Dangerous Knowledge",
            description:"Gain an additional damage spell every level of your element.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.doNothing = "doNothing"
            },
            catchUpMethod:(context,element,perk)=>{
                let dbPerk = perks.find(perk => perk.name == "Dangerous Knowledge")
                perk.chosenElement = element
                dbPerk.catchUpMethod(context,dbPerk,perk)
            }
        },            
        {
            name:"Twin Spell",
            description:"When you gain this perk you select two damage spells. Once per day when you cast one of the spells, you can also cast the other spell immediately after as a part of the same action, however the twinned spell always uses the longer of the two actions. Every 5 levels you can change one of the spells.",
        },
        {
            name:"Feast on Destruction",
            description:"Whenever you cast a damage spell you heal hit points equal to the level of the spell. If this is a critical spell, the healing doubles (on multicrits this increases the multiplier by 1 for each crit).",
        },
        {
            name:"Power Overwhelming",
            description:"When you are about to cast a damage spell, you can take 1d8 points of damage to increase the spell's power by 5. You can do this times up to your the spells level. For every time you do this, the spell gains a 1% critical failure chance.",
        },
        {
            name:"Best Defense...",
            description:"Whenever you cast a damage spell you gain temporary hit points equal to 3x the level of the spell for 1 round. These stack with themselves. When the spell is a critical spell, the temporary hit points are increased by your spell power and last 3 rounds.",
        },
        {
            name:"Magic Perk",
            description:"Gain an R+ magic perk.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.doNothing = "doNothing"
            },
            catchUpMethod:(context)=>{
                context.connection.send(JSON.stringify({command:"requestRoll", type:"perks",options:{type:{magic:true},rarity:{rare:true,epic:true,legendary:true,unique:true,}}}))
            }
        },
        {
            name:"Destructive Knowledge",
            description:"You gain a magic feat at 1st and every 4 levels.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.doNothing = "doNothing"
            },
            catchUpMethod:(context)=>{
                let perk = perks.find(perk => perk.name == "Destructive Knowledge")
                perk.catchUpMethod(context,perk)
            }
        },
        {
            name:"Metamagic Knowledge",
            description:"You gain 2 metamagic feats.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.doNothing = "doNothing"
            },
            catchUpMethod:(context)=>{
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{metamagic:true,}}))
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{metamagic:true,}}))
            }
        },
        {
            name:"Key Knowledge",
            description:"You gain 2 key magic/magic style feats.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.doNothing = "doNothing"
            },
            catchUpMethod:(context)=>{
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{magic:true,style:true,key:true}}))
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{magic:true,style:true,key:true}}))
            }
        },
        {
            name:"Favorite Form of Destruction",
            description:"Choose a damage spell you know, you can remove its maximum damage dice based on level by spending additional spell points equal to half your level.",
        },
        {
            name:"Pyroclastic Burst",
            type:"fire",
            description:"When you damage a creature with a critical fire spell, you can spend level/2 spell points as an immediate action to cause that creature make a reflex save (DC 10 + your highest mental modifier + the spells level + any bonuses to fire damage spell DCs) or they become blinded by ash for 1 round. Creatures with smokesight/blindsight or similar abilities are immune to this effect. If a fire spell is damaging multiple creatures at once, you choose only one.",
        },
        {
            name:"Unbound Blaze",
            type:"fire",
            description:"When you damage a creature with a critical fire spell, it catches on fire for 1d6 fire damage per round. If you score a second critical fire spell against a creature currently on fire, you can choose for it to bursts into a fiery explosion, taking 1d6 fire damge per your highest mental modifier. This scales with spell power, but cannot be a critical spell. This ends the on fire effect. If the creature has multiple stacks of being set on fire, you can trigger as many at once as you'd like.",
        },
        {
            name:"Supercharge",
            type:"electricity",
            description:"If you cast 2 critical electricity spells in a row that at least 1 creature either fails the save from, or is delivered with with a touch attack, your next electricity spell within 2 rounds after with a standard action casting time can be cast as a movement action. This spell cannot be a critical spell. This provokes as normal. Once this ability activates, it cannot activate again for 1d4+1 rounds.",
        },
        {
            name:"Hotstreak",
            type:"fire",
            description:"If you cast 2 critical fire spells in a row that at least 1 creature either fails the save from, or is delivered with with a touch attack, your next fire spell gains 25 fire spell power and 25% fire spell critical damage. Once this triggers, it cannot trigger again for 1d4+1 rounds.",
        },
        {
            name:"Pyroclasm",
            type:"fire",
            description:"Whenever you cast a fire spell, you gain 1 blaze stack. This increases to 2 if it is a critical fire spell (once per spell). As a standard action you can cause a pillar of flame to errupt in a 10ft radius at a location within close range (25 + 5ft./2 levels). This deals 1d6 points of fire damage per blaze stack, though allows a reflex save to halve the damage and scales with 200% fire spell power. Blaze stacks reset on death or when you leave a floor.",
        },
        {
            name:"Winter's Caress",
            type:"cold",
            description:"When you damage a creature with a critical cold spell, until the end of your next turn, it suffers an additional 20% critical spell damage. This increases by 20% for touch attacks spell criticals.",
        },
        {
            name:"Self Cauterization",
            type:"fire",
            description:"When you suffer a critical hit, you take half of the damage immediately, and the other half is delayed until the end of your next turn. After using this ability, you suffer 2 constitution drain that cannot be removed, but ends at the end of the floor.",
        },
        {
            name:"Icicle Storm",
            type:"cold",
            description:"Whenever you cast a cold spell in combat, you gain 1 icicle. This increases to 2 if it is a critical cold spell (once per spell). As a standard action you can launch all icicles at once as a ranged touch attack. This deals 1d6 points of cold damage per icicle and scales with 200% cold spell power. It also gains 25% spell critical damage and has its critical threat range on the attack roll increased by a flat +1. Icicles reset on death or when you leave a floor.",
        },
        {
            name:"Crippling Cold",
            type:"cold",
            description:"When you damage a creature with a critical cold spell, you can spend level/2 spell points as an immediate action to cause that creature make a fortitude save (DC 10 + your highest mental modifier + the spells level + any bonuses to cold damage spell DCs) or they become staggered for 1 round. If a cold spell is damaging multiple creatures at once, you choose only one.",
        },
        {
            name:"Frostbite Aura",
            type:"cold",
            description:"Whenever you cast a critical cold spell, you become surrounded by a frostbite aura for 1 round. Any creature within 10 feet of you has their fortitude saves decreased by 2 and their movement speed reduced by 5 feet per level of the spell for 1 round. Both of these apply after the spell is cast (so the creature does not suffer the penalties for its immediate effect).",
        },
        {
            name:"Polar Edge",
            type:"cold",
            description:"Your critical threat range when making touch attacks with cold spells is increased by a flat +1.",
        },
        {
            name:"Icy Wind",
            type:"cold",
            description:"When you cast a critical cold spell, any creature damaged by the critical cold spell must make a fortitude save (dc 10 + your highest mental modifier + the spells level + any bonuses to cold damage spell DCs) or it becomes slowed for 1 round.",
        },
        {
            name:"Extreme Voltage",
            type:"electricity",
            description:"When you damage a creature with a critical electricity spell, you can spend level/2 spell points as an immediate action to cause that creature make a fortitude save (DC 10 + your highest mental modifier + the spells level + any bonuses to electricity damage spell DCs) or they become dazed for 1 round. If an electricity spell is damaging multiple creatures at once, you choose only one.",
        },
        {
            name:"Acidic Blast",
            type:"acid",
            description:"When you damage a creature with a critical acid spell, you can spend level/3 spell points as an immediate action to cause that creature make a fortitude save (DC 10 + your highest mental modifier + the spells level + any bonuses to acid damage spell DCs) or they become staggered for 1 round. If an acid spell is damaging multiple creatures at once, you choose only one.",
        },
        {
            name:"Perfect Freeze",
            abilityType:"Sp",
            type:"cold",
            description:"[Destruction Power] Once per day as an immediate action, you can cause a creature within medium range (100 + 10ft./level) to be immediately frozen to its square for 1 round. This creature cannot be moved from its square by any means except teleportation. While trapped this way it gets a -10 penalty to its dexterity score.",
        },
        {
            name:"Brittle",
            abilityType:"Sp",
            type:"cold",
            description:"[Destruction Power] Once per day as an immediate action, you can cause a creature within medium range (100 + 10ft./level) to become brittle for 1 round. Any critical hit against it with a weapon has its critical damage multiplier increased by 1 and any cold spell has its critical spell power increased by 50%.",
        },
        {
            name:"Cast On the Run",
            type:"electricity",
            description:"Your spells that require a reflex saving throw have their DC increased by +1, and you can as a full-round action move while casting a standard action spell during the movement, functioning like shot on the run, but with a spell.",
        },
        {
            name:"Sheer Cold",
            type:"cold",
            description:"Gain 35% cold spell critical damage.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.doNothing = "doNothing"
            },
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellCriticalDamage.cold += 35
            }
        },
        {
            name:"Absolute Zero",
            type:"cold",
            description:"Gain 60% cold spell critical damage but reduce your cold spell critical chance by 2%.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellCriticalDamage.cold += 60
                context.stats.characterStats.spellMastery.spellCriticalChance.cold -= 2
            }
        },
        {
            name:"Destructive Lore",
            description:"Gain 1% universal spell critical chance and 4% spell critical chance of your element.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.doNothing = "doNothing"
            },
            catchUpMethod:(context,element)=>{
                context.stats.characterStats.spellMastery.spellCriticalChance.universal += 1
                context.stats.characterStats.spellMastery.spellCriticalChance[element] += 4
            }
        },
        {
            name:"Earth is Mine",
            type:"acid",
            description:"Your acid and earth spells gain 15 spell power and have their DC increased by +1 if the creature is touching the ground.",
        },
        {
            name:"Lighting Leap",
            abilityType:"Sp",
            type:"electricity",
            description:"[Destruction Power] Once per day as an immediate action you can turn into a bolt of electricity and move in a straight line (as if teleporting) up to 10 feet per level. While using this ability you are immune to any damage except acid damage.",
        },
        {
            name:"Scientifically Accurate Lighting Speed",
            abilityType:"Su",
            type:"electricity",
            description:"[Destruction Power] Once per day you can as a free action cause your electricity spells travel at scientifically accurate speeds for the rest of your turn, causing all creatures to automatically fail any reflex save they allow.",
        },
        {
            name:"Mobile Caster",
            abilityType:"Ex",
            type:"electricity",
            description:"After you successfully cast an electricity spell, you can move 5 feet. This provokes as normal. If the spell is level 4-7, you can instead move 10 feet. If the spell is level 8-9, you can instead move 20 feet, or move 10 feet without it provoking",
        },
        {
            name:"Elemental Coat",
            abilityType:"Su",
            description:"After you successfully cast a spell of your element, you become sheathed in energy of its type for rounds equal to half the level of the spell (minimum 0), causing any creature that strikes you with a non-reach melee weapon to take 1d6+highest mental modifier damage of your element. Activating this additional times resets the duration if it would be higher, but this otherwise does not stack.",
        },
        {
            name:"Elemental Wreathe",
            abilityType:"Su",
            description:"After you successfully cast a spell of your element, you become sheathed in energy of its type for rounds equal to half the level of the spell (minimum 0), causing any of your attacks with a melee weapon, unarmed attack, or natural weapons to deal an additional 1d6 points of damage of your element. For every 4 levels of the spell, the damage increases by 1d6. Activating this additional times resets the duration if it would be higher, but this otherwise does not stack. ",
        },
        {
            name:"Evoke Weakness",
            abilityType:"Sp",
            description:"As a standard action for level/2 spell points you cause a creature to have any resistance or immunity to your element removed for 1 round. Additionally, if the creature takes elemental damage of the type removed from an effect you did not creature, they are treated as having vulnerability to the elemenet. If you have multiple elements, choose one when activating this ability.",
        },
        {
            name:"Heart of Terra",
            abilityType:"Sp",
            type:"acid",
            description:"[Destruction Power] Once per day, as long as you are touching the ground, you can as an immediate action reduce the hit point damage an attack deals to you to 0.",
        },
        {
            name:"Earth Shield",
            abilityType:"Su",
            type:"acid",
            description:"Whenever you cast a acid spell, you gain DR adamantine equal to half the level of the spell for one round. If this is an earth spell, it instead is DR /adamantine equal to the level of the spell.",
        },
        {
            name:"Earth Bind",
            abilityType:"Sp",
            type:"acid",
            description:"[Destruction Power] Once per day as a swift action for level x2 spell points you cause the earth to reach up and grab the creature and pull them deep underground for 1 round. During this time they cannot take any action except purely mental actions. After 1 round they are placed directly back where they were, no matter their distance from the ground.",
        },
        {
            name:"Forceful Blast",
            abilityType:"Sp",
            type:"fire",
            description:"[Destruction Power] Once per day as an immediate action you can cause an explosive blast somewhere within close range (25ft. + 5ft./2 levels) with a 10 foot radius. Anything caught in the radius is moved directly away from the source of the blast 10 feet.",
        },
        {
            name:"Ungrounded",
            type:"electricity",
            description:"Your electricity and air spells gain 15 spell power and have their DC increased by +1 if the creature is not touching the ground.",
        },
        {
            name:"Immolation",
            type:"fire",
            description:"Each time a creature fails a save against a fire spell you cast they also receive 1 point of immolation per odd level of the spell (see Burning Citadel discipline info).",
        },
        {
            name:"Spell Combo",
            description:"Each time you cast a unique damage spell you have not cast this floor, it gains an additional 10 spell power for each previous unique damage spell you have cast this floor.",
        },
        {
            name:"Critical Empowerment",
            description:"Whenever you cast a critical damage spell, its DC is increased by +2 and the next spell you cast before the end of your next turn gains a +1 bonus to its DC. If this second Spell is also a critical, the bonus to DC stacks.",
        },
        {
            name:"Heart of Fire",
            type:"fire",
            description:"Gain an additional 5 fire and cold resistance. At level 9 this becomes 10, and at level 18 this becomes 20. This stacks with the fire resistance you normally gain from spontaneous destruction. Additionally, instead of increasing your initiative by +2, you increase your initiative by your highest mental modifier, and you gain 10 fire spell power.",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.doNothing = "doNothing"
            },
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.fire += 10
            }
        },
        {
            name:"Heart of Ice",
            type:"cold",
            description:"Gain an additional 5 cold and fire resistance. At level 9 this becomes 10, and at level 18 this becomes 20. This stacks with the cold resistance you normally gain from spontaneous destruction. Additionally, when you roll a combat casting check to cast a cold spell, your critical spell chance is increased by 2%.",
        },
        {
            name:"Heart of Stone",
            type:"acid",
            description:"Gain an additional 5 acid and electricity resistance. At level 9 this becomes 10, and at level 18 this becomes 20. This stacks with the acid resistance you normally gain from spontaneous destruction. Additionally, increase your natural armor by +2 and your HD size by 2 (rerolls HD). You also gain +4 to your CMD and +2 to CMB",
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.doNothing = "doNothing"
            },
            catchUpMethod:(context)=>{
                context.stats.statsForAbilities.ac.natural += 2
                context.stats.characterStats.misc.HDSize += 2
                context.stats.characterStats.hpIncreases.splice(0, 1, context.stats.characterStats.misc.HDSize)
                for(let x = 1; x < context.stats.characterStats.hpIncreases.length; x++){                
                    context.stats.characterStats.hpIncreases.splice(x, 1, Math.ceil(Math.random() * context.stats.characterStats.misc.HDSize))                
                }     
            }
        },
        {
            name:"Heart of Thunder",
            type:"electricity",
            description:"Gain an additional 5 electricity and acid resistance. At level 9 this becomes 10, and at level 18 this becomes 20. This stacks with the electricity resistance you normally gain from spontaneous destruction. Additionally, your damage spells that use a reflex save have their DC increased by +1 and you increase your movement speed by 15 feet.",
        },
        {
            name:"Destructive Magic",
            description:`Gain 5% universal spell critical damage and 20% spell critical damage of your element.`,
            hasCustomMethod:true,
            customMethod:(context)=>{
                context.doNothing = "doNothing"
            },
            catchUpMethod:(context, element) =>{
                context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 5
                context.stats.characterStats.spellMastery.spellCriticalDamage[element] += 20
            },

        },
        {
            name:"Overwhelming Destruction",
            description:"Your damage spells have their DC's increased by +2. This increases by +1 if the spell is a critical spell.",
        },
        {
            name:"Penetrating Destruction",
            description:"You gain a +3 bonus to overcome spell resistance with damage spells. This increases to +6 if the spell is a critical spell.",
        },
        {
            name:"Controlled Destruction",
            description:"Your allies gain a +4 bonus on saves against your damage spells. You can spend level/2 spell points when casting a spell to cause a creature that you can see to take minimum damage from that spell.",
        },
        {
            name:"Opposing Assault",
            type:"universal",
            description:`When you cast a spell of one type that deals damage to a creature, if the next spell you cast you cast within 1 round that deals the opposing type of damage to that creature, the spell has an additional effect depending on the order of the spells against that creature:
            \nFire->Ice: The spell has its critical spell power increased by 25.
            \nIce->Fire: The spell gains 15 spell power. 
            \nElectricity->Acid: The creature takes a -2 penalty on its save against the spell
            \nAcid->Electricity: If the creature would take continuous acid damage from the previous acid spell this turn, and it fails is save against the electricity spell, the continuous damage it takes gains 25 spell power. This doesn't activate with any continuous damage from enviromental sources like acid fog. `,
        },
        {
            name:"Synchronizing Assault",
            type:"universal",
            description:`When you cast a spell of one type that deals damage to a creature, if the next spell you cast you cast within 1 round that deals a synergizing type of damage to that creature, the spell has an additional effect depending on the two types of spells against that creature:
            \nFire+Acid: If the acid spell was going to deal any continuous acid damage to that creature within 1 round, it takes that damage immediately, except it is half fire damage half acid damage. The duration of that continuous damage is treated as if one round had already transpired. This doesn't activate with any continuous damage from enviromental sources like acid fog. 
            \nFire+Electricity: The creature takes 1d2 points of force damage per your level. This doesn't count as spell damage. 
            \nCold+Acid: If the acid spell was going to deal any continuous acid damage to that creature within 1 round, the damage it takes is reduced by half, however it also takes a penalty to its dexterity equal to the level of the cold spell for 1 round. This doesn't activate with any continuous damage from enviromental sources like acid fog. 
            \nCold+Electricity: The creature must make a fortitude saving throw dc=10+highest mental + the level of both spells + any bonus to DC your cold spells get or it becomes staggered for 1 round.`,
        },            
        {
            name:"Memory Burn",
            description:"You can choose to cast a damage spell as a swift action, or free action of the spell was already a swift action, when you do you lose access to that spell permanently, as if you had never learned it. You can still only cast 2 spells per round as normal.",
        },
        {
            name:"Knowledge Shield",
            description:"You can as an immediate action permanently lose access to a damage spell you know, when you do you heal hit points equal to the spells level x highest mental and gain temporary hit points equal to half the hit points you healed which last rounds equal to its level.",
        },
        {
            name:"Out With a Bang",
            description:"If you are killed, you can cast a damage spell with a casting time of 1 standard action or less as an immediate action. The spell gains 50 spell power and 5% spell critical chance.",
        },
        {
            name:"Fire Synergy Casting",
            type:"fire",
            description:`When you cast a spell of one type that deals damage to a creature, if the next spell you cast you cast within 1 round that deals a synergizing type of damage to that creature, the spell has an additional effect depending on the order of the spells against that creature:
            \nFire->Electricity: The creature takes 1d2 points of force damage per your level. This doesn't count as spell damage. 
            \nFire->Acid: If the acid spell would cause any penalty to the creatures armor class, that penalty is doubled, if not, it takes a -2 penalty on its save against the acid spell.
            \nAcid->Fire: If the acid spell was going to deal any continuous acid damage to that creature within 1 round, it takes that damage immediately, except it is half fire damage half acid damage. The duration of that continuous damage is treated as if one round had already transpired. This doesn't activate with any continuous damage from enviromental sources like acid fog. 
            \nElectricity->Fire: The creature must make an additional fortitude save DC=10+level+highest mental + any bonuses that fire spells get to their DC, or the creature is stunned until the start of its next turn.`,
        },
        {
            name:"Acid Synergy Casting",
            type:"acid",
            description:`When you cast a spell of one type that deals damage to a creature, if the next spell you cast you cast within 1 round that deals a synergizing type of damage to that creature, the spell has an additional effect depending on the order of the spells against that creature:
            \nAcid->Fire: If the acid spell was going to deal any continuous acid damage to that creature within 1 round, it takes that damage immediately, except it is half fire damage half acid damage. The duration of that continuous damage is treated as if one round had already transpired. This doesn't activate with any continuous damage from enviromental sources like acid fog. 
            \nAcid->Cold: If the acid spell was going to deal any continuous acid damage to that creature within 1 round, the damage it takes is reduced by half, however it also takes a penalty to its dexterity equal to the level of the cold spell for 1 round. This doesn't activate with any continuous damage from enviromental sources like acid fog. 
            \nFire->Acid: If the acid spell would cause any penalty to the creatures armor class, that penalty is doubled, if not, it takes a -2 penalty on its save against the acid spell.
            \nCold->Acid:  The creature must make a fortitude save dc=10+highest mental + the level of both spells + any bonus to DC your acid spells get or takes 2 points of constitution damage.`,
        },
        {
            name:"Cold Synergy Casting",
            type:"cold",
            description:`When you cast a spell of one type that deals damage to a creature, if the next spell you cast you cast within 1 round that deals a synergizing type of damage to that creature, the spell has an additional effect depending on the order of the spells against that creature:
            \nCold->Electricity: The creature takes a -2 penalty on its reflex saves or AC against the spell.
            \nCold->Acid: The creature must make a fortitude save dc=10+highest mental + the level of both spells + any bonus to DC your acid spells get or takes 2 points of constitution damage.
            \nElectricity->Cold: The creature must make a fortitude saving throw dc=10+highest mental + the level of both spells + any bonus to DC your cold spells get or it becomes staggered for 1 round.
            \nAcid->Cold: If the acid spell was going to deal any continuous acid damage to that creature within 1 round, the damage it takes is reduced by half, however it also takes a penalty to its dexterity equal to the level of the cold spell for 1 round. This doesn't activate with any continuous damage from enviromental sources like acid fog. `,
        },
        {
            name:"Electricity Synergy Casting",
            type:"electricity",
            description:`When you cast a spell of one type that deals damage to a creature, if the next spell you cast you cast within 1 round that deals a synergizing type of damage to that creature, the spell has an additional effect depending on the order of the spells against that creature:
            \nElectricity->Fire: The creature must make an additional fortitude save DC=10+level+highest mental + any bonuses that fire spells get to their DC, or the creature is stunned until the start of its next turn.
            \nElectricity->Cold: The creature must make a fortitude saving throw dc=10+highest mental + the level of both spells + any bonus to DC your cold spells get or it becomes staggered for 1 round.
            \nFire->Electricity: The creature takes 1d2 points of force damage per your level. This doesn't count as spell damage. 
            \nCold->Electricity: The creature takes a -2 penalty on its reflex saves or AC against the spell.`,
        },
    ]
    
    // addSpells:(context)=>{
    //     let spellNames 
    //     let spellList = wizardSpells.concat(clericSpells)
    //     let spells = spellList.filter(spell=> spellNames.includes(spell.name))
    //     context.stats.lists.spells.splice(0,0,...spells)     
    // }
    },
    {
        rarity: "common",
        type: "magic",
        name: "Inspire Competence",
        fromClass:"Bard",
        abilityType:"Su",
        prereq:"Bardic Performance",
        shortDesc:`You gain a new bardic perfomance. Starting it requires the same action as what it would take to start inspire courage, and costs spell points equal to the bonus given/2 to activate and maintain. \n\nInspire Competence: A bard can use his performance to help an ally succeed at a task.  The ally must be within 30 feet and able to see and hear the bard. The ally gets a +2 competence bonus on skill checks with a particular skill chosen when the performance begins as long as they continue to hear the bard's performance. This bonus increases by +1 for every four levels the bard has. Certain uses of this ability are infeasible, such as Stealth, and may be disallowed at the GM's discretion. A bard can't inspire competence in himself. inspire competence relies on audible components.`
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Parry",
        fromClass:"Duelist",
        abilityType:"Ex",            
        shortDesc:`Whenever the duelist takes a full attack action with a light or one-handed piercing weapon, she can elect not to take one of her attacks. At any time before her next turn, she can attempt to parry an attack against her or an adjacent ally as an immediate action. To parry the attack, the duelist makes an attack roll, using the same bonuses as the attack she chose to forego during her previous action. If her attack roll is greater than the roll of the attacking creature, the attack automatically misses. For each size category that the attacking creature is larger than the duelist, the duelist takes a -4 penalty on her attack roll. The duelist also takes a -4 penalty when attempting to parry an attack made against an adjacent ally. The duelist must declare the use of this ability after the attack is announced, but before the roll is made.`
    },
    {
        rarity: "Epic",
        type: "martial",
        name: "Riposte",
        fromClass:"Duelist",
        abilityType:"Ex",
        shortDesc:`A duelist can make an attack of opportunity against any creature whose attack she successfully parries, so long as the creature she is attacking is within reach. It counts as a parry as long as you make a counter attack roll against an enemies attack roll and they miss because of it.`
    },
    {
        rarity: "common",
        type: "universal",
        name: "Caster Support",
        fromClass:"Divine Strategist Cleric",
        abilityType:"Su",
        shortDesc:`You can use the aid another action to assist another spell caster, granting a +2 circumstance bonus on caster level checks and concentration checks, and +1 to the DC of their spells cast until the start of your next turn. This bonus increases by +1 every 4 levels. The allied caster must remain adjacent to you to gain this benefit. If the character is using intelligence as their casting stat this bonus is reduced by half.`
    },
    {
        rarity: "epic",
        type: "martial",
        name: "Tactical Expertise",
        fromClass:"Divine Strategist Cleric",
        abilityType:"Ex",
        shortDesc:`Whenever you are flanking or make an attack of opportunity, you may add your second highest mental stat as a bonus (if any) on the attack roll. Additionally, for level spell points as an immediate action you can add your second highest mental stat as a bonus on any single d20 roll made as part of a readied action.`
    },
    {
        rarity: "rare",
        type: "universal",
        name: "Bastion",
        fromClass:"Foundation of Faith Cleric",
        abilityType:"Ex",
        shortDesc:`You add your constitution bonus to your CMD and to the DC of attempts to intimidate you.`
    },
    {
        rarity: "rare",
        type: "magic",
        name: "Combat Medic",
        fromClass:"Merciful Healer Cleric",
        abilityType:"Ex",
        shortDesc:`You do not provoke attacks of opportunity for casting conjuration(healing) spells, or using the heal skill to stabalize, bandage up, or apply emergency aid a creature. You also gain +5 to your heal skill.`,
        hasCustomMethod:true,
        catchUpMethod:(context)=>{
            context.stats.characterStats.skills.heal += 5
        },
        customMethod:(context)=>{
            context.doNothing ="donothing"
        },
    },
    {
        rarity: "common",
        type: "magic",
        name: "Granite Focus",
        fromClass:"Foundation of Faith Cleric",
        abilityType:"Ex",
        shortDesc:`As a movement action you can center yourself, gaining your constitution modifier to any concentration checks attempted as part of casting a spell until the end of your turn.`
    },
    {
        rarity: "epic",
        type: "universal",
        name: "Rooted Vitality",
        fromClass:"Foundation of Faith Cleric",
        abilityType:"Su",
        shortDesc:`While you are standing on a stone floor you can spend level spell points as a swift action to gain fast healing 1 for rounds equal to your constitution modifier or until you lose contact with the stone. This healing increases by 1 every odd level after first. You can activate this ability even when standing on any earthen material such as, dirt, mud or sand, but the fast healing is reduced by half.`
    },
    // {
    //     rarity: "common",
    //     type: "magic",
    //     name: "True Healer",
    //     fromClass:"Merciful Healer Cleric",
    //     abilityType:"Su",
    //     shortDesc:`Whenever you use a perk or cast a spell that rolls to heals hit points, you can reroll any 1's to determine how much healing is given. You take the reroll even if its another 1. Gain level to your positive spell power, but -level to negative and elemental spell power.`,
    //     hasCustomMethod:true,
    //     customMethod:(context)=>{
    //         context.stats.characterStats.spellPower.positive += 1
    //         let otherSpellTypes = ["negative","fire","acid","cold","electricity"]
    //         otherSpellTypes.forEach(type=>{
    //             context.stats.characterStats.spellPower[type] -= 1
    //         })
    //     },
    //     catchUpMethod:(context)=>{
    //         context.stats.characterStats.spellPower.positive += context.stats.characterStats.misc.level
    //         let otherSpellTypes = ["negative","fire","acid","cold","electricity"]
    //         otherSpellTypes.forEach(type=>{
    //             context.stats.characterStats.spellPower[type] -= context.stats.characterStats.misc.level
    //         })
    //     },
        
    // },                
    {
        rarity: "epic",
        type: "magic",
        name: "Inspiring Camaraderie",
        fromClass:"Sacred Attendant Cleric",
        abilityType:"Su",
        shortDesc:`As a swift action for levelx2 spell points, whenever you cast a conjuration(healing) spell that targets a single ally, you can infuse them with inspired vigor, for spells level/2 rounds the ally's attack rolls gain a competence bonus equal to 1/2 your level.`
    },
    {
        rarity: "legendary",
        type: "magic",
        name: "Merciful Healing",
        fromClass:"Merciful Healer Cleric",
        abilityType:"Su",
        prereq:"Channel Energy",
        shortDesc:`When you gain this ability you choose one of three conditions: fatigued, shaken, or sickened, when you channel energy you can also heal this condition from a single creature healed by your channel energy. Every 5 levels after you can choose another condition you can heal with the new expanded options, however you can only heal a single condition per channel, and only applies when you heal the maximum amount of dice on the channel. If you get this perk past level 5 your choices must still be from the statuses you could choose at the specific levels you would have gotten a new choice.
        \nAt level 5 you can also choose between dazed, diseased, or staggered.
        \nAt level 10 you can also choose between cursed, exhausted, frightened, nauseated, or poisoned.
        \nAt level 15 you can also choose between blinded, deafended, paralyzed, or stunned.
        \nAt level 20 you can choose petrified, confused, or a single level of energy drain.`
    },
    {
        rarity: "legendary",
        type: "magic",
        name: "Merciful healing",
        fromClass:"Merciful Healer Cleric",
        abilityType:"Su",
        prereq:"Epic Channel Energy",
        shortDesc:`When you gain this ability you choose one of three conditions: fatigued, shaken, or sickened, when you channel energy you can also heal this condition from a single creature healed by your channel energy. Every 5 levels after you can choose another condition you can heal with the new expanded options, however you can only heal a single condition per channel, and only applies when you heal the maximum amount of dice on the channel. If you get this perk past level 5 your choices must still be from the statuses you could choose at the specific levels you would have gotten a new choice.
        \nAt level 5 you can also choose between dazed, diseased, or staggered.
        \nAt level 10 you can also choose between cursed, exhausted, frightened, nauseated, or poisoned.
        \nAt level 15 you can also choose between blinded, deafended, paralyzed, or stunned.
        \nAt level 20 you can choose petrified, confused, or a single level of energy drain.`
    },
    {
        rarity: "rare",
        type: "universal",
        name: "Canny Defense",
        fromClass:"Duelist",
        abilityType:"Ex",
        shortDesc:`While wearing light or no armor, not using a shield, and wielding a melee weapon, you gain a +1 dodge bonus to your armor class, +1 per level/2, up to a maximum of your highest mental stat. If a duelist is caught flat-footed or otherwise denied her Dexterity bonus, she also loses this bonus.`
    },
    {
        rarity: "common",
        type: "magic",
        name: "Righteous Fury",
        fromClass:"Sorcerer",
        abilityType:"Su",
        shortDesc:`Your spells gain 10 power against creatures for every alignment step away from you that they are (doesn't affect healing). If they are 4 alignment steps away from you, spells have their DC's increased by +1, and their critical chance is increased by 2%. If a creature is the same alignment as you, your damaging spells have -20 spell power against them, and they gain a +2 bonus on their saves, and your critical spell chance is reduced by 4%.`
    },
    {
        rarity: "common",
        type: "magic",
        name: "Safekeeping",
        fromClass:"Sorcerer",
        abilityType:"Su",
        shortDesc:`Whenever you touch a creature to deliver a spell or ability you can choose to grant them a +2 insight bonus to armor class that lasts 1 round. Every 8 levels this bonus increases by +1.`
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Precise Strike",
        fromClass:"Duelist",
        abilityType:"Ex",
        shortDesc:`A duelist gains the ability to strike precisely with a light or one-handed piercing weapon, adding her duelist level to her damage roll.
        \nWhen making a precise strike, a duelist cannot attack with a weapon in her other hand or use a shield. A duelist's precise strike only works against living creatures with discernible anatomies. Any creature that is immune to critical hits is also immune to a precise strike, and any item or ability that protects a creature from critical hits also protects a creature from a precise strike.`
    },
    {
        rarity: "rare",
        type: "magic",
        name: "Cleansing Flame",
        fromClass:"Angelfire Apostle Cleric",
        abilityType:"Su",
        shortDesc:`Whenever you cast a healing spell that is a lower level than the highest spell level you know, you can unleash a blast of flames as a swift action by expending level x2 spell points. The flames last 1 round and fill a contiguous area equal to one 10-foot cube per spell level, and must start adjacent to your space. The flames deal 1d4 points of damage per spell level, half is fire damage and half is raw divine power, not subject to fire resistance or immunity. A creature caught in the area can make a reflex save against the DC of the spell cast to reduce the damage by half.`
    },
    {
        rarity: "common",
        type: "martial",
        name: "No Retreat",
        fromClass:"Duelist",
        abilityType:"Ex",
        shortDesc:`Enemies that take a withdraw action within your reach provoke an attack of opportunity from you.`
    },
    {
        rarity: "legendary",
        type: "martial",
        name: "Aura of Justice",
        fromClass:"paladin",
        abilityType:"Su",
        prereq:"Smite",
        shortDesc:`You can expend twice the cost of your smite as a standard action to grant the ability to smite to all allies within 10 feet using your bonuses (though not your orders). Allies must use this smite ability before the start of your next turn, it costs level spell points, and the smite only lasts for rounds equal to their highest mental modifier. Your highest mental score and level is what determines the bonuses they get to attack, damage, and armor class, but their alignment is what determines the effectiveness of their smite vs their smited target. Allies more than 2 alignment steps away from you do not benefit from this ability, nor do allies who oppose your good/evil alignment. Allies who share your exact alignment can activate the smite they gain for half the spell points.`
    },
    {
        rarity: "epic",
        type: "martial",
        name: "Aura of Faith",
        fromClass:"paladin",
        abilityType:"Su",
        shortDesc:`Your weapons are treated as your good/evil alignment for overcoming damage reduction. Any attack made against an enemy within 10 feet of you is also treated as your good/evil alignment for the purposes of overcoming damage reduction. This only functions while you are conscious.`
    },
    {
        rarity: "epic",
        type: "martial",
        name: "Aura of Cowardice",
        fromClass:"Antipaladin",
        abilityType:"Su",
        shortDesc:`All enemies within 10 feet to take a -4 penalty on saving throws against fear effects. Creatures that are normally immune to fear lose that immunity while within 10 feet of an antipaladin with this ability. This ability functions only while the antipaladin remains conscious.`
    },
    {
        rarity: "rare",
        type: "universal",
        name: "Aura of Despair",
        fromClass:"Antipaladin",
        abilityType:"Su",
        shortDesc:`Enemies within 10 feet of an antipaladin take a -2 penalty on all saving throws. This ability functions only while the antipaladin is conscious.`
    },        
    {
        rarity: "rare",
        type: "magic",
        name: "Dirge of Doom",
        fromClass:"Bard",
        abilityType:"Su",
        prereq:"Bardic Performance",
        shortDesc:`You gain a new bardic perfomance, starting it requires the same action as what it would take to start inspire courage and costs 5 spell points to activate and maintain. \n\nDirge of Doom: A bard can use his performance to foster a sense of growing dread in his enemies, causing them to take become shaken. To be affected, an enemy must be within 30 feet and able to see and hear the bard's performance. The effect persists for as long as the enemy is within 30 feet and the bard continues the performance. The performance cannot cause a creature to become frightened or panicked, even if the targets are already shaken from another effect. Dirge of doom is a mind-affecting fear effect, and it relies on audible and visual components.`
    },
    {
        rarity: "rare",
        type: "magic",
        name: "Enrapturing Performance",
        fromClass:"Lotus Geisha Bard",
        abilityType:"Su",
        prereq:"Bardic Performance",
        shortDesc:`When beginning a bardic performance that effects more than 1 creature, you can modify it to only affect a single creature instead. When you do, the performance gains a +2 bonus on the DC to resist it, and any bonuses to AC, ability checks, attack rolls, damage rolls, saving throws, and skill checks increases by +1. Every 8 levels the bonus to the DC and the bonuses given increases by an additional +1.`
    },
    {
        rarity: "epic",
        type: "magic",
        name: "Inspire Greatness",
        fromClass:"Bard",
        abilityType:"Su",
        prereq:"Bardic Performance",
        shortDesc:`You gain a new bardic perfomance, starting it requires the same action as what it would take to start inspire courage and costs 4 spell points to activate and maintain, plus 4 for each additional target. \n\nInspire Greatness: A bard can use his performance to inspire greatness in himself or a single willing ally within 30 feet, granting extra fighting capability. A bard can target 1 person plus one every 6 levels. To inspire greatness, all of the targets must be able to see and hear the bard. A creature inspired with greatness gains 2d10+their con x 2 temp hp, and counts as having two extra HD for how it is affected by other abilities, a +2 competence bonus on attack rolls, and a +1 competence bonus on Fortitude saves. Inspire greatness is a mind-affecting ability and it relies on audible and visual components.`
    },
    {
        rarity: "epic",
        type: "magic",
        name: "Frightening Tune",
        fromClass:"Bard",
        abilityType:"Su",
        prereq:"Bardic Performance",
        shortDesc:`You gain a new bardic perfomance, starting it requires the same action as what it would take to start inspire courage and costs 8 spell points to activate and maintain. \n\nFrightening Tune: A bard can use his performance to cause fear in his enemies. To be affected, an enemy must be able to hear the bard perform and be within 30 feet. Each enemy within range receives a Will save (DC 10 + 1/2 the bard's level + highest mental) to negate the effect. If the save succeeds, the creature is immune to this ability for 24 hours. If the save fails, the target becomes frightened and flees, however it can make a new save each round at the end of its turn, except the round it fails. Frightening tune relies on audible components.`
    },
    {
        rarity: "epic",
        type: "magic",
        name: "Inspire Heroics",
        fromClass:"Bard",
        abilityType:"Su",
        prereq:"Bardic Performance",
        shortDesc:`You gain a new bardic perfomance, starting it requires the same action as what it would take to start inspire courage and costs 6 spell points to activate and maintain, plus 6 for each additional target. \n\nInspire Heroics: A bard can inspire tremendous heroism in himself or a single ally within 30 feet. A bard can target one person, plus one for every 8 levels you have. To inspire heroics, all of the targets must be able to see and hear the bard. Inspired creatures gain a +4 morale bonus on saving throws and a +4 dodge bonus to AC. The effect lasts for as long as the targets are able to witness the performance. Inspire heroics is a mind-affecting ability that relies on audible and visual components.`
    },
    {
        rarity: "legendary",
        type: "magic",
        name: "Deadly Performance",
        fromClass:"Bard",
        abilityType:"Su",
        prereq:"Bardic Performance",
        shortDesc:`You gain a new bardic perfomance, starting it requires the same action as what it would take to start inspire courage and costs 15 spell points to activate and maintain. \n\nDeadly Performance: A bard can use his performance to cause one enemy to die from joy or sorrow. To be affected, the target must be able to see and hear the bard perform for 1 full round and be within 30 feet. The target receives a Will save (DC 10 + 1/2 level + Highest mental) to negate the effect. If a creature's saving throw succeeds, the target is staggered for 1d4 rounds, and the bard cannot use deadly performance on that creature again for 24 hours. If a creature's saving throw fails, it dies. Deadly performance is a mind-effecting death effect that relies on audible and visual components.`
    },
    {
        rarity: "legendary",
        type: "magic",
        name: "Adoring Fan",
        fromClass:"Bard",
        abilityType:"Su",
        prereq:"Bardic Performance",
        shortDesc:`You gain a new bardic perfomance, starting it requires the same action as what it would take to start inspire courage and costs 15 spell points to activate and maintain. \n\nAdoring Fan: The bard can use his performance to convert even the toughest audience. To be affected, a target must be able to see and hear the bard perform for 1 full round and be within 30 feet. The target can attempt a Will save (DC = 10 + 1/2 level + highest mental) to negate the effect. If a creature succeeds at the saving throw, the bard cannot use this ability on that creature again for 24 hours. On a failure, the creature is dominated (as dominate monster) for as long as the bard keeps playing and is charmed (as charm monster) for 1d4 hours thereafter. It receives a new save at the end of each round except the round it failed, however must save against the dominate and charm seperately. Adoring fan is a mind-affecting, compulsion effect that relies on audible and visual components.`
    },
    {
        rarity: "epic",
        type: "universal",
        name: "Feat Mastery",
        fromClass:"Custom",
        abilityType:"Ex",
        shortDesc:`Choose a feat you have that gives a numerical bonus to rolls, double the numerical bonuses and penalties it gives. This is done before any additional bonuses would be given to the feat, such as from animal focus. At level 8, and every 8 levels after you can change the feat this perk modifies.`
    },
    {
        rarity: "epic",
        type: "magic",
        name: "Inspired Rage",
        fromClass:"Skald",
        abilityType:"Su",
        prereq:"Bardic Performance",
        shortDesc:`You gain a new bardic perfomance, Inspired Rage. Starting it requires the same action as starting inspire courage, and costs 2 spell point to activate and maintain, increasing in cost by +2 at 7th and 14th level. \n\nInspired Rage: All allies that can hear you gain a +2 morale bonus to strength and constitution and a +1 morale bonus on Will saving throws, but also take a -1 penalty to AC. While under the effects of inspired rage, allies other than the skald cannot use any Charisma-, Dexterity-, or Intelligence-based skills (except Acrobatics, Fly, Intimidate, and Ride) or any ability that requires patience or concentration. At 4th level and every 4 levels thereafter, the song's bonuses on Will saves increase by 1. At 7th and 14th levels, the song's bonuses to Strength and Constitution increase by 2. If a creature has the ability to rage (through ability, not spell), they can activate it along side this ability, but they only gain half the bonuses. They cant use abilities that require them to be raging unless they rage themselves. Creatures do not become fatigued after inspired rage. Allies can choose to reject this bonus. At 18th level inspired rage no longer limits what abilities and skills allies can use.`
    },
    {
        rarity: "epic",
        type: "magic",
        name: "Song of the Fallen",
        fromClass:"Skald",
        abilityType:"Su",
        prereq:"Bardic Performance",
        shortDesc:`You gain a new bardic perfomance, starting it requires the same action as what it would take to start inspire courage and costs 6 spell points to activate and maintain, plus 6 for each additional target. \n\nSong of the Fallen: The bard can use his performance to temporarily revive dead allies to continue fighting, with the same limitations as raise dead. The skald selects a dead ally within 60 feet to bring back to life. The revived ally is alive but staggered. The ally automatically dies if the skald ends this performance or is interrupted. The skald may revive multiple allies with this ability (either at the same time or over successive rounds).`
    },
    {
        rarity: "common",
        type: "martial",
        name: "Battle Dance",
        fromClass:"Bard",
        abilityType:"Su",
        prereq:"Bardic Performance",
        shortDesc:`You can modify your inspire courage to only affect you, if you do, its bonuses increase by +1 without the spell point cost increasing. This increases by an additional +1 every 8 levels. You must be wearing light or no armor to use this.`
    },
    {
        rarity: "common",
        type: "universal",
        name: "Fleet",
        fromClass:"Bard",
        abilityType:"Su",
        prereq:"Battle Dance",
        shortDesc:`When using the Battle Dance Perk to modify your inspire courage you also gain a +10 enhancement bonus to your movement speed, increasing by +5 feet every 4 levels you have.`
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Dance of Fury",
        fromClass:"Bard",
        abilityType:"Su",
        prereq:"Battle Dance",
        shortDesc:`When using the Battle Dance Perk to modify your inspire courage you can combine a full-attack action with a single move, taking the attacks at any point during your movement, but must move at least 5 feet between each attack. This movement provokes attacks of opportunity as normal.`
    },
    {
        rarity: "common",
        type: "universal",
        name: "Leaf on the Wind",
        fromClass:"Bard",
        abilityType:"Su",
        prereq:"Bardic Performance",
        shortDesc:`You gain a new bardic perfomance, starting it and maintaining it each round requires a standard action, and costs 3 spell points per round. You gain a +6 dodge bonus to armor class and reflex saves, and heal 1 hit point per level.`
    },
    {
        rarity: "epic",
        type: "martial",
        name: "Rain of Blows",
        fromClass:"Bard",
        abilityType:"Su",
        prereq:"Battle Dance",
        shortDesc:`When using the Battle Dance Perk to modify your inspire courage you gain additional bonuses, a +1 bonus on attack rolls, a and +1 dodge bonus to AC and reflex saves, every 5 levels these bonuses increase by +1. Additionally, while using battle dance when making a full-round attack you can make an additional attack at your highest bonus.`
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Razor's Kiss",
        fromClass:"Bard",
        abilityType:"Su",
        prereq:"Battle Dance",
        shortDesc:`When using the Battle Dance perk to modify your inspire courage, all of your weapons also count as having the improved critical feat. If you already have an ability that doubles crit range you instead give your weapon a +1 flat bonus to critical threat range (unmodified by other abilities). When you reach level 10 and level 20 your weapons gain an additional +1 flat bonus critical threat range (also unmodified by other abilities).`
    },
    {
        rarity: "legendary",
        type: "martial",
        name: "Battle Fury",
        fromClass:"Dervish Dancer Bard",
        abilityType:"Su",            
        shortDesc:`For level/2 spell points the dervish dancer can unleash a whirlwind of blows as a full-round action, taking a single move action and unleash a single attack at his highest bonus against each target within his reach during any point of his move, up to a maximum number of attacks equal to his level. This movement provokes attacks of opportunity as normal, and you can only attack a single creature once.`
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Uncanny Dodge",
        fromClass:"rogue",
        shortDesc: "Cannot be caught flat-footed, lose Dex bonus to AC if the attacker is invisible but still loses  Dexterity bonus to AC if immobilized. With this ability you can still lose Dexterity bonus to AC if an opponent successfully uses the feint action. \n\n If selected a second time gain improved uncanny dodge. This defense denies another rogue the ability to sneak attack the character by flanking them, unless the attacker has at least four more rogue levels than the target does.",
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context)=>{
            let vanishCount = context.stats.lists.perks.filter(perk => perk.name == "Uncanny Dodge")
            if(vanishCount.length > 1){
                let index = context.stats.lists.perks.findIndex(perk => perk.name == "Uncanny Dodge")
                let perk = perks.filter(perk => perk.name == "Improved Uncanny Dodge")[0]
                perk.uiType = "perk"
                context.stats.lists.perks.splice(index, 1, perk)
            }                      
        },    
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Improved Uncanny Dodge",
        fromClass:"rogue",
        shortDesc: "This defense denies a creature with sneak attack the ability to sneak attack the character by flanking them, unless the attacker has at least four more levels in their class that grants sneak attack than the target does.",
        prereq:"Uncanny Dodge",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Epic Rage",
    fromClass: "Barbarian",
    shortDesc: `For two spell points a round a barbarian can activate rage for a free action. 
    
    \nWhile in rage, a barbarian gains a +4 morale bonus to her Strength and Constitution, as well as a +2 morale bonus on Will saves. In addition, she takes a -2 penalty to Armor Class. The increase to Constitution grants the barbarian 2 hit points per Hit Dice, but these disappear when the rage ends and are not lost first like temporary hit points. While in rage, a barbarian cannot use any Charisma-, Dexterity-, or Intelligence-based skills (except Acrobatics, Fly, Intimidate, and Ride) or any ability that requires patience or concentration. You can still cast spells while raging as long as they are not from the healing type, however unless they are spells of the damage type you must double the cost of the spell. Each additional time you select this perk you can increase the cost by 2 spell points a round and increase the morale bonus to strength and constition by 2, and the bonus to will saves by 1.
    
    \nA barbarian can end her rage as a free action and is fatigued after rage for a number of rounds equal the number of rounds spent in the rage. A barbarian cannot enter a new rage while fatigued or exhausted but can otherwise enter rage multiple times during a single encounter or combat. If a barbarian falls unconscious, her rage immediately ends, placing her in peril of death.
    \nIf you have the Unique Rage perk you can activate this at the same time, their effects stack`,
    },
    {
    rarity: "common",
    type: "magic",
    name: "Fortune",
    fromClass: "Witch",
    shortDesc:`As a standard action for level spell points you grant a creature within 30 feet a good luck for level/4 rounds (minimum 1). The target can call upon this good luck once per round, allowing him to reroll any ability check, attack roll, saving throw, or skill check, taking the better result. He must decide to use this ability before the first roll is made. Once a creature has benefited from the fortune hex, it cannot benefit from it again for the rest of the floor.`
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Gift of Life",
    fromClass: "Cleric",
    shortDesc:`As a standard action for level spell points you can touch a creature that has died within the past minute to grant it a few moments of life. The dead creature returns to life for a number of rounds equal to your level. Creatures returned to life in this way have a number of hit points equal to half your cleric level, and continue to be affected by any still-active spells, conditions, or afflictions present at the time of their death. At the end of this time, the creature dies again. The creature is free to act as it sees fit during this time. You are granted no control over it. A creature cannot benefit from this perk more than once per floor.`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Mighty Pebble",
    abilityType:"Su",
    fromClass: "Stone Oracle",
    shortDesc:`When you throw a rock it gains an enhancement bonus of +1 for every 4 levels you possess, however this does not allow it to bypass damage reduction. As a standard action for level spell points, you can charge and throw a pebble (or other stone of similar size) that detonates when it strikes a target as a ranged attack. The pebble has a range increment of 20 feet and when you charge and throw it this way double its enhancement bonus. Any creature struck by the pebble takes 1d6 points of bludgeoning damage per two levels you possess (minimum 1d6). Creatures in squares adjacent to the target take half damage, or no damage if they make a Reflex saving throw. If the attack roll misses, treat the pebble as a thrown splash weapon to determine where it lands.`
    },
    {
    rarity: "common",
    type: "magic",
    name: "Restorative Touch",
    fromClass: "Cleric",
    shortDesc:`As a standard action for 2 spell points you can touch a creature, letting the healing power of your deity flow through you to relieve the creature of a minor condition. Your touch can remove the dazed, fatigued, shaken, sickened, or staggered condition. You choose which condition is removed.`
    },
    {
        rarity:"rare",
        type: "martial",
        name: "Gator Wrangler",
        fromClass:"Vigilante",
        abilityType:"Ex",
        shortDesc: `You gain a +8 bonus to your CMD against grapple combat maneuvers against creatures using the grab ability, and you halve all damage from constrict attacks. When attacking a creature that is grappling you, an you deal additional damage equal to half your level.`,
    },
    {
        rarity: "legendary",
        type: "magic",
        name: "Arcane Gun",
        fromClass: "Spellslinger Wizard",
        abilityType:"Su",
        shortDesc:`A spellslinger can cast any ranged touch attack, cone, line, or ray spells through his non-throwing ranged weapon. When he casts through it, the weapons enhancement bonus (if any) is a bonus to the spell's attack rolls, and half of its enhancement bonus is added to the spell's saving throw DCs, and the spell gains a +1 bonus to the critical damage multiplier. Any other stats of your ranged weapon are not transfered over to the spell. Yet there are dangers inherent to this method. If any of the spells' attack rolls result in a natural 1 (a misfire), or a natural 20 is rolled on any saving throw made against the spell by a target (an overload), the arcane gun gains the broken condition. If the arcane gun already has the broken condition, the gun explodes. When a gun explodes, it lets loose a blast of force, or if the spell has the acid, cold, electricity, or sonic descriptor, it deals that type of energy damage instead. In the case of spells with multiple descriptors, roll randomly among the descriptors to determine the type of damage dealt by the blast. The blast is centered on a single intersection within the spellslinger's space (spellslinger's choice) and deals 1d6 points of the appropriate energy damage or force damage per level of the spell cast in a 20 foot radius. Any creature within the blast other than the spellslinger can make a Reflex saving throw to halve the damage. The Reflex save DC is calculated using the spell level of the spell being sacrificed.`
    },
    {
        rarity: "rare",
        type: "magic",
        name: "Enhance Weapon",
        abilityType:"Su",
        shortDesc:`You can expend a spell slot as a swift action to enhance a weapon, giving it an enhancement bonus equal to the level of the spell slot extended. This lasts rounds equal to as many levels of spells you have known. This enhancement bonus does not allow it to bypass DR, except DR magic.`
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Vital Punishment",
        fromClass: "Vigilante",
        abilityType:"Ex",
        shortDesc:`Once per round before you make an attack of opportunity, you can declare it to be a vital punishment. If the attack hits, Your attack deals additional damage equal to half your level. If you have a vital strike feat you can also apply the effects of that feat in addition to the damage. If you could already apply the effects of vital strike on an attack of opportunity, you can increase the damage dice you would roll by an additional dice.`
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Shield of Blades",
        fromClass: "Vigilante",
        abilityType:"Ex",
        shortDesc:`When you take an attack or full-attack action, if you use Power Attack on every attack to make melee attacks and use strength to determine the attack bonus, you gain a shield bonus to your AC until your next turn equal to your penalty on attack rolls from Power Attack. This bonus applies only if you actually take that penalty on at least one of the attack rolls.`
    },
    {
        rarity: "epic",
        type: "martial",
        name: "Tear Them Apart",
        fromClass: "Brute Vigilante",
        abilityType:"Ex",
        shortDesc:`When you take a full-attack action to attack with melee weapons, if you hit and deal damage on at least 2 melee attacks you deal extra damage equal to 1d10 + 1.5x strength (cannot be changed). For each 2 additional melee attacks you land after that the damage increases by 2d10. The damage occurs after you have taken your last attack with the full-attack action.`
    },
    {
        rarity: "rare",
        type: "magic",
        name: "Bloodbound Spell",
        fromClass: "Cabalist Vigilante",
        abilityType:"Ex",
        shortDesc:`Whenever you cast a spell against a foe that is taking bleed damage, the foe takes a -1 penalty on its saving throw against the spell (or to its AC if the spell requires an attack roll). This penalty increases to -2 if you are the creature that caused it to bleed. Whenever you cast a spell on a creature that is bleeding and it either fails a saving throw or you succeed on making an attack against it with a touch spell, the bleed damage the creature is taking increases by +1 per round. If the creature had multiple sources of bleed damaage affecting at once, choose once source to gain this benefit. This can potentially increase the bleed damage multiple times per spell.`
    },
    {
        rarity: "legendary",
        type: "martial",
        name: "Mad Rush",
        fromClass: "Vigilante",
        abilityType:"Ex",
        shortDesc:`Whenever the vigilante charges, he can make a full attack. Whenever he uses this ability, he takes a -4 penalty to his AC until the start of his next turn (in addition to the AC penalty for charging).`
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Healer's Blessing",
    fromClass: "Cleric",
    shortDesc:`Gain 30 positive spell power. This does not apply to damage dealt to undead with a cure spell.`,
    hasCustomMethod:true,
    customMethod:(context)=>{
        context.doNothing = "donothing"
    },
    catchUpMethod:(context)=>{
        context.stats.characterStats.spellMastery.spellPower.positive += 30
    },
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Dispelling Expert",
    fromClass: "Custom",
    shortDesc:`Gain the dispel magic spell. As Immediate action in response to a spell being cast within 60 feet, you can for level x2 spell points plus the cost of the spell you're casting, can cast 'Dispel Magic', 'Dispel Magic, Greater', or a spell that could be used to counter the spell that activated this ability, but only to use the counterspell action against the spell that triggered this ability. You must still make a spellcraft check to identify the spell, meaning you still must be aware of and see the spellcaster. You can now also use dispel magic to counter spell-like abilities too, however the dispel check has its DC increased by 5. If you gain this perk a second time or already have the dispel magic spell you gain +4 to all dispel magic checks and gain greater dispel magic.`,
    hasCustomMethod:true,
    customMethod:()=>{},
    catchUpMethod:(context)=>{
        let hasDispel = context.stats.lists.spells.filter(spell=>{                
            return "Dispel Magic" == spell.name
        })
        let spellList = spells
        let spellsFiltered = []
        if(hasDispel.length > 0){
            spellsFiltered = spellList.filter(spell=> "Dispel Magic, Greater" == spell.name)
        }else{
            spellsFiltered = spellList.filter(spell=> "Dispel Magic" == spell.name)
        }            
        context.stats.lists.spells.splice(0,0,spellsFiltered[0])
    },
        
    },
    {
        rarity: "legendary",
        type: "martial",
        name: "Master of Many Styles",
        shortDesc: `You gain the ability to fuse styles together more effectively, at 1st level, a master of many styles can fuse two of the styles he knows into a more perfect style. The master of many styles can have two style feat stances active at once. Starting a stance provided by a style feat is still a swift action, but when the master of many styles switches to another style feat, he can choose one style whose stance is already active to persist. He may only have two style feat stances active at a time.
        \nAt 10th level, the master of many styles can fuse three styles at once. He can have the stances of three style feats active at the same time. Furthermore, he can enter up to three style feat stances as a swift action. 
        \nGain a bonus style feat, and an additional one every every 5 levels.`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level%5==0){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat", options:{style:true}}))
            }
        },
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%5==0 || x == 1){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{style:true}}))
                }
            }
        },            
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Battle Mage",
    fromClass: "Custom",
    shortDesc:`You can cast spells even when both hands are occupied wielding weapons or shields, and gain a +4 to concentration checks. You still can't cast spells if any other condition is rendering your hands unusable (such as being grappled or paralyzed).`
    },
    {
    rarity: "common",
    type: "martial",
    name: "Sacred Weapon",
    fromClass: "Warpriest",
    abilityType:"Su",
    shortDesc:`When you wield a weapon you can choose to change its base damage to 1d8 if it would be higher. You can only do this to one weapon at a time. When you reach level 4 the damage dice becomes 1d10, at level 8 it becomes 2d6, at level 12 it becomes 3d6, at level 16 it becomes 4d6, and at level 20 it becomes 6d6.`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Sacred Armor",
    fromClass: "Warpriest",
    abilityType:"Su",
    shortDesc:`You gain the ability to enhance your worn armor(not shields) with a swift action for level spell points that lasts one minute. Your armor gains a +1 enhancement bonus, that increases by an additional +1 every 4 levels. These bonuses stack with any existing bonus and augment effects that rely on your armor enhancement bonus. You can only have a single enhanced armor piece at a time and you must be wearing it for the effect to function.`
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Drip or Drown",
    fromClass: "Custom",
    abilityType:"ex",
    shortDesc:`While not wearing armor you can wear three pieces of clothing at a time and all of their bonuses and penalties stack. You must take off extra clothing before you can put armor on.`
    },
    {
    rarity: "epic",
    type: "universal",
    name: "Dripped Out",
    fromClass: "Custom",
    abilityType:"ex",
    shortDesc:`You can wear an extra piece of clothing and all of their bonuses and penalties stack.`
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Stalwart",
    fromClass: "Warder",
    abilityType:"Ex",
    shortDesc:`If you make a successful Fortitude or Will saving throw against an attack that has a reduced effect on a successful save, you instead avoid the effect entirely. You do not gain the benefit of the stalwart ability if you're helpless.`
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Focused Aim",
    fromClass: "Mysterious Stranger Gunslinger",
    abilityType:"Ex",
    shortDesc:`As a swift action, you can spend level/2 spell points to gain a bonus on all firearm damage rolls equal to your highest mental modifier (minimum 1) you makes until the end of your turn.`
    },
    {
    rarity: "common",
    type: "magic",
    name: "Mystic Interference",
    fromClass: "Disenchanter Warpriest",
    abilityType:"Su",
    shortDesc:`For level/2 spell points you can as a standard action channel a burst of pure abjuration magic to grant protection to yourself and allies within 30 feet. Affected creatures receive a +1 sacred/profane bonus (good = sacred, evil = profane, neutral = choose when you gain the perk) on saving throws against spells and spell-like abilities for a number of rounds equal to your highest mental stat. This bonus increases by +1 every 5 levels.`
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Aspect of War",
    fromClass: "Warpriest",
    abilityType:"Su",
    shortDesc:`As a swift action for 10 + levelx2 spell points you can use your level in place of BAB, gain DR level/2/- and move at full speed regardless of armor worn for highest mental stat rounds.`
    },
    {
    rarity: "epic",
    type: "universal",
    name: "Grim News",
    fromClass: "Harbinger",
    abilityType:"Su",
    shortDesc:`For level/2 spell points you can move up to your speed as a swift action.  Additionally, you can choose 1 of the following abilities:
    \nDark Wings: Gain a fly speed equal to your base land speed with good maneuverability. This flight is supernatural in nature.
    \nOmenwalk: You gain the ability to teleport up to your speed as a movement action. You do not need line of effect or line of sight of your destination, however it still provokes attacks of opportunity for leaving a threatened square with this ability.
    \nSpider's Boon: You gain a climb speed equal to your base land speed, and gain a +4 racial bonus to grapple checks and to your CMD
    \nWater Dweller: Gain a swim speed equal to your base land speed, and you no longer need to breathe and become immune to inhaled poisons`
    },
    {
    rarity: "common",
    type: "universal",
    name: "Elusive Shadow",
    fromClass: "Harbinger",
    abilityType:"Ex",
    shortDesc:`Gain a +2 dodge bonus to AC and Reflex saves during any round in which you have moved at least 10 feet (including by teleportation effects). This bonus increases by +1 every 5 levels.`
    },
    {
    rarity: "common",
    type: "universal",
    name: "Dodge Bonus",
    fromClass: "Stalker",
    abilityType:"Ex",
    shortDesc:`Gain a +1 dodge bonus to armor class, +1 for every 4 levels you have`
    },
    {
    rarity: "common",
    type: "universal",
    name: "Bit of Luck",
    fromClass: "Luck Cleric",
    abilityType:"Sp",
    shortDesc:`You can touch a willing creature as a standard action that costs 4 spell points, giving it a bit of luck. For the next round, any time the target rolls a d20, he may roll twice and take the more favorable result.`
    },
    {
    rarity: "epic",
    type: "universal",
    name: "Tugging Strands",
    fromClass: "Luck Cleric",
    abilityType:"Su",
    shortDesc:`For level spell points you can force a creature within line of sight to reroll any one roll that it has just made. This is a free action you can do even when not your turn but you cannot use this ability more than once per round. The result of the reroll must be taken, even if it is worse than the original roll.`
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Martial Training",
        shortDesc: "At 1st and every 3rd level gain a martial/style feat",
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level%3==0 || context.stats.characterStats.misc.level==1){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true, style:true,}}))
            }
        },
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%3==0 || x == 1){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true, style:true,}}))
                }
            }
        },
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Exotic Combat Training",
        shortDesc: "At 1st and every 3rd level gain a style feat",
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level%3==0 || context.stats.characterStats.misc.level==1){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{style:true}}))
            }
        },
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%3==0 || x == 1){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{style:true}}))
                }
            }
        },
    },
    {
        rarity: "epic",
        type: "martial",
        name: "Paired Training",
        shortDesc: "At 2nd and every 5th level gain a teamwork feat",
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level%5==0 || context.stats.characterStats.misc.level==2){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{teamwork:true}}))
            }
        },
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%5==0 || x == 2){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{teamwork:true}}))
                }
            }
        },
    },
    {
        rarity: "epic",
        type: "magic",
        name: "Magical Training",
        hidden:true,
        shortDesc: "At 1st and every 4th level gain a magic/metamagic feat",
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level%4==0 || context.stats.characterStats.misc.level==1){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{magic:true, metamagic:true,}}))
            }
        },
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%4==0 || x == 1){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{magic:true, metamagic:true,}}))
                }
            }
        },
    },
    {
        rarity: "epic",
        type: "universal",
        name: "Well Trained",
        shortDesc: "Gain a bonus feat at 1st and every 3rd level.",
        hidden:true,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level%3==0 || context.stats.characterStats.misc.level==1){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",}))
            }
        },
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%3==0 || x == 1){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",}))
                }
            }
        },
    },
    {
        rarity: "rare",
        type: "universal",
        name: "Vast Experience",
        shortDesc: "Gain a bonus utility feat at 1st, and every 3rd level.",
        hidden:true,
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level%3==0 || context.stats.characterStats.misc.level==1){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat", options:{utility:true}}))
            }
        },
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                if(x%3==0 || x == 1){
                    context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat", options:{utility:true}}))
                }
            }
        },
    },
    {
    rarity: "common",
    type: "universal",
    name: "Ill Intentions",
    fromClass: "Harbinger",
    abilityType:"Ex",
    shortDesc:`Whenever a harbinger and one or more of her allies flank a creature, that creature suffers a -2 penalty on saving throws and skill checks.`
    },
    {
        rarity: "common",
        type: "universal",
        name: "Agile Feet",
        fromClass: "Travel Cleric",
        abilityType:"Su",
        shortDesc:`As a free action for level/2 spell points, you can gain increased mobility for 1 round. For the next round, you ignore all difficult terrain and do not take any penalties for moving through it, and you gain 15 foot enhancement to your movement speed.`
    },
    {
        rarity: "rare",
        type: "magic",
        name: "Travel as One",
        fromClass: "Portal Cleric",
        abilityType:"Su",
        shortDesc:`Whenever you use an ability that teleports you, you can bring an adjacent ally with you.`
    },
    {
        rarity: "rare",
        type: "magic",
        name: "Sacred Threshold",
        fromClass: "Portal Cleric",
        abilityType:"Su",
        shortDesc:`As a standard action for level/2 spell points you can create a straight line that is 15 long and lasts highest mental rounds. Any creature that walks over that line gains 1d4 per 3 levels (minimum 1d4) plus highest mental temporary hit points. These temporary hit points last 1 minute and do not stack with each other, and a creature cannot gain these temporary hit points more than once every 3 rounds. These temporary hit points are also gained whenever you teleport yourself or another creature.`
    },
    {
        rarity: "rare",
        type: "magic",
        name: "Idealize",
        fromClass: "Wizard",
        abilityType:"Su",
        shortDesc:`Whenever you cast a spell that grants an enhancement or size bonus to an ability score, you increase the bonus by +2. At level 18 it instead increases by +4.`
    },
    {
        rarity: "legendary",
        type: "magic",
        name: "Time Stutter",
        fromClass: "Wizard",
        abilityType:"Sp",
        shortDesc:`As a standard action you can briefly step out of time, pausing the world around you. This ability acts as the time stop spell, except that you gain only 1 round of apparent time. This costs 12 spell points, and once you use it you cannot use it again for 1d6+1 rounds.`
    },
    {
        rarity: "epic",
        type: "magic",
        name: "Infectious Charms",
        fromClass: "Wizard",
        abilityType:"Su",
        shortDesc:`Your charm and compulsion spells gain a +1 bonus to their DC. Anytime you target and successfully affect a single creature with a charm or compulsion spell and that creature is within 30 feet of another opponent, your spell has a chance of affecting the second creature as well. As a swift action immediately after affecting a creature with a charm or compulsion spell, you can cause the spell to carry over to the nearest creature within 30 feet. The spell behaves in all ways as though its new target were the original target of the spell.`
    },
    {
        rarity: "rare",
        type: "magic",
        name: "Knowledge is Power",
        fromClass: "Wizard",
        abilityType:"Ex",
        shortDesc:`Your understanding of physical forces gives you power over them. You add your highest mental modifier on combat maneuver checks and to your CMD. You also add your highest mental modifier on Strength checks to break or lift objects.`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Rumors of War",
    fromClass: "Harbinger",
    abilityType:"Ex",
    shortDesc:`You may move up to your speed and initiate a single strike at any point in the movement as a full-round action. The strike must have an inititation action of 1 full round or less.`
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Voices in the Dark",
    fromClass: "Harbinger",
    abilityType:"Ex",
    shortDesc:`You can initiate a strike whenever you normally would be able to make an attack of opportunity. This maneuver must target the creature you could take the attack of opportunity against (although additional targets are fine), and the strike must have an initiation action of a standard action or less. You still expend the attack of opportunity when you use this ability.`
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Whispers of Atrocity",
    fromClass: "Harbinger",
    abilityType:"Su",
    shortDesc:`All maneuvers initiated by you ignore all immunities possessed by their target.`
    },        
    {
    rarity: "legendary",
    type: "universal",
    name: "Black Omen",
    fromClass: "Harbinger",
    abilityType:"Su",
    shortDesc:`For Level x2 spell points you can move up to half your speed as an immediate action.`
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Retributive Ki",
    fromClass: "Stalker",
    abilityType:"Su",
    shortDesc:`For Level x2 spell points plus the cost of the maneuver, when you are harmed by an attack, spell, or ability of an enemy, as an immediate action you can initiate a martial strike with an initiation action of a standard action or less in retaliation against that attack. You use the range of the attackers ability as the range of this strike, creating a phantom echo with your ki that rushes to the target that harmed you and attacks them.`
    },
    {
    rarity: "legendary",
    type: "magic",
    name: "Death Defied",
    fromClass: "Karthus",
    abilityType:"Su",
    shortDesc:`When you die your spirit can enter a ghostly state for 3 rounds for 50% of your remaining spell points. During this time your ghostly body is invincible and unaffected from all effects, including spells, perks and abilites (even your own), nor can you move, however on your turn you are able to use a single standard action to cast a single spell. Your body remains on the ground and it can be affected like an object as normal. If you are revived during this effect it immediately ends, but you cannot cast spells on your own body.`
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Unicorn Portals",
    fromClass: "Custom",
    abilityType:"Su",
    shortDesc:`After you successfully cast a spell with somatic components you can teleport 5 feet for every 2 levels of the spell (minimum 0). This activates after the spell is cast and its effects used, and you cannot use this ability and take a 5-foot step in the same turn.`
    },
    {
    rarity: "legendary",
    type: "magic",
    name: "Combat Healer",
    fromClass: "Life Oracle",
    abilityType:"Su",
    shortDesc:`Whenever you cast a conjuration healing spell, you can cast it as a swift action, as if using the Quicken Spell feat, by expending two spell slots plus level spell points. This does not increase the level of the spell.`
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Combat Precognition",
    fromClass: "Stalker",
    abilityType:"Su",
    shortDesc:`As an immediate action you can spend level/2 spell points to force opponents who attack you to roll their attack rolls twice and take the worse of the two results. This lasts 1 round.`
    },
    {
    rarity: "common",
    type: "universal",
    name: "Alacrity",
    fromClass: "Stalker",
    abilityType:"Su",
    shortDesc:`When wearing light or no armor you gain +10-ft enhancement bonus to your base speed, and may add your highest mental stat as a bonus to your acrobatics checks. You may expend 2 spell points to increase the movement speed bonus from 10-ft to 30-ft for 1 round, but are fatigued for 1 round after that.`
    },
    {
    rarity: "common",
    type: "martial",
    name: "Sacred Reflexes",
    fromClass: "Mantis Zealot Warpriest",
    abilityType:"Su",
    shortDesc:`While wearing light or no armor you can as a swift action for 2 spell points gain uncanny dodge for rounds equal to your highest mental stat. At level 5 you also gain evasion. At level 8 you also gain Improved uncanny dodge, at 12th level this ability activates automatically when entering combat. At 15th level this also grants improved evasion.`
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Aspect of the Mantis",
    fromClass: "Mantis Zealot Warpriest",
    abilityType:"Su",
    shortDesc:`Your first attack each round deals bleed damage equal to your dexterity modifier. This bleed damage stacks.`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Sacred Shield",
    fromClass: "Shieldbearer Warpriest",
    abilityType:"Su",
    shortDesc:`You gain the ability to enhance your worn shields with a swift action for level spell points that lasts one minute. Your armor gains a +1 enhancement bonus, that increases by an additional +1 every 4 levels. This bonus applies to both attack and damage with the shield. These bonuses stack with any existing bonus and augment effects that rely on your sheilds enhancement bonus. You can only have a single enhanced shield at a time and you must be wielding it for the effect to function.`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Guardian's Shield",
    fromClass: "Knight Disciple",
    abilityType:"Su",
    shortDesc:`Whenever you initiates a strike, you can apply a guardian's shield to one ally (other than yourself) within 60 feet as a free action. This shield lasts for a number of rounds equal to your highest mental modifier.
    A guardian's shield grants the affected ally a number of temporary hit points equal to twice your level. These temporary hit points do not stack with other temporary hit points, and vanish when the shield's duration expires. Using this ability costs level/4 spell points. This ability can be used in place of Lay On hands for many abilities treating dice rolled as half your level (minimum 1).`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Empowered Martial Healing",
    fromClass: "Knight Disciple",
    abilityType:"Su",
    shortDesc:`A the knight disciple healing maneuvers become more potent. Any maneuver she initiates that heals hit point damage (to herself or others) heals an additional 50% points of damage (rounded down).`
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Guardian's Aura",
    fromClass: "Knight Disciple",
    abilityType:"Su",
    shortDesc:`A knight disciple's protective nature allows her to use her counters for the benefit of her allies instead of just herself. Whenever she initiates a counter, she can choose to have that counter affect an ally within 10 feet instead of herself. When determining if the counter can be initiated (for example, if the counter is initiated in response to an attack), she treats that ally as if they were herself. The counter still uses the knight disciple's modifiers to determine its success or failure, and she still makes any rolls or checks for the counter.`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Mark of Censure",
    fromClass: "Knight Disciple",
    abilityType:"Su",
    shortDesc:`You gain the ability to censure a creature of at least 2 alignment steps away from you for level/2 spell points. As a swift action choose a creature you can see, your allies (other than yourself) gain damage reduction equal to mental stat/2 agaist attacks made by the marked creature. If the creature is 3 or more alignment steps away from you the damage reduction becomes your highest mental stat. The mark lasts until the creature dies, however you can only have a single mark active at a time.`
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Shielding Fist",
    fromClass: "Monk of the Silver Fist",
    abilityType:"Ex",
    shortDesc:`While using a weapon that augments unarmed strikes you gain a +1 shield bonus to AC and are treated as if wearing a buckler. The enhancement modifiers applied to your unarmed augmenting weapon's attack and damage modifier also increase this shield bonus to armor class. Even when attacking with your unarmed weapon you keep this shield bonus, but gain a permanent -1 to attack from using a buckler in the arm of the weapon.`
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Mark of the Silver Fist",
    fromClass: "Monk of the Silver Fist",
    abilityType:"Su",
    shortDesc:`A monk of the silver fist is able to focus his protection on one ally to better guard them. The monk of the silver fist can spend level/2 spell points as a swift action to apply a special mark to one ally (other than himself) within 30 feet. For a number of rounds equal to 1 + the monk of the silver fist's initiation modifier, the marked ally gains a +4 circumstance bonus to their AC, and any enemy that attacks the marked ally provokes an attack of opportunity from the monk of the silver fist. A monk of the silver fist can only have one mark of the silver fist active at a time, until level 8 where he can maintain 2, and 16 where he can maintain 3.`
    },
    {
    rarity: "common",
    type: "martial",
    name: "Devastating Dice",
    fromClass: "Custom",
    abilityType:"Ex",
    shortDesc:`Gain +1 to damage on weapon attacks for each damage dice rolled for that attack against that creature. This includes bonus damage dice on the attack such as maneuver damage or sneak attack damage, and if a weapon's base damage includes more than one dice, such as 2d6 for a greatsword, each dice provides its own +1. This is added after the total of the damage roll, including critical hits.`
    },
    {
    rarity: "common",
    type: "martial",
    name: "Powerslam",
    sphere: "wrestling",
    abilityType:"Ex",
    shortDesc:`Whenever a creature provokes an attack of opportunity from you, you may spend bab/2 spell points to make a grapple check against them as an immediate action; if this grapple check is successful, you may make a trip attempt against that creature as a free action.`
    },
    {
    rarity: "common",
    type: "martial",
    name: "Defensive Parry",
    fromClass: "Swordlord",
    abilityType:"Ex",
    shortDesc:`A swordlord gains a +1 dodge bonus to his AC when making a full attack with a one-handed weapon as long as his offhand is empty until the start of his next turn. This AC bonus increases by +1 every 6 levels.`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Rest Hold",
    sphere: "wrestling",
    abilityType:"Ex",
    shortDesc:`As a move action while you are grappling an adjacent creature you may regain bab/2 spell points and the creature you are grappling grants you partial cover until the start of your next turn. If an attack misses your AC by 2 or less compare the result to the grappled creature's AC; if the attack roll would hit the grappled creature's AC, resolve the attack as though the grappled creature was the original target. You cannot use this ability if you do not control the grapple.`
    },
    {
    rarity: "common",
    type: "martial",
    name: "Rollercoaster",
    sphere: "wrestling",
    abilityType:"Ex",
    shortDesc:`Whenever you succeed on a trip attempt against a creature you are grappling, you may immediately move both yourself and the grappled creature up to 10 ft. in any direction except up as a free action. This movement provokes attacks of opportunity for both you and the grappled target. For every 5 points of base attack bonus you possess, you may move yourself and the target an additional 10 ft.`
    },
    {
    rarity: "common",
    type: "martial",
    name: "Shoulder Throw",
    sphere: "wrestling",
    abilityType:"Ex",
    shortDesc:`Whenever you succeed on a trip attempt against a creature you are grappling, you may throw your target, causing them to land prone in an unoccupied square within 10 ft. This immediately ends your grapple. You must have clear line of sight and effect to the target square. Enemies thrown more than 10 ft. take 1d6 bludgeoning damage per additional 5 ft. they are thrown, in addition to any damage they may take as a result of falling (such as if this ability is used against an aerial creature via the Aerial Trip feat). For every 5 points of base attack bonus you possess, you can cause the opponent to land 5 ft. further away from you with this talent.`
    },
    {
    rarity: "common",
    type: "martial",
    name: "Slip And Strike",
    sphere: "wrestling",
    abilityType:"Ex",
    shortDesc:`Whenever a creature's attempt to initiate or maintain a grapple or swallow whole attempt against you fails, or when you choose to release a grapple against an unpinned creature, you may make an attack of opportunity against them. Ending a grapple initiated with the grab universal monster ability does not grant you the same leverage as other uses of this ability and the attack granted for ending such a grapple must be taken as a swift action instead of an attack of opportunity.`
    },
    {
    rarity: "common",
    type: "martial",
    name: "Strongarm Lockup",
    sphere: "wrestling",
    abilityType:"Ex",
    shortDesc:`Whenever you successfully initiate a grapple against a creature, you may choose to force that creature into any space within your natural reach rather than an adjacent square. A creature being grappled by you may still attack you even if you would be outside of their reach, but only deals half damage if you would normally be outside of their reach.`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Intercepting Fist",
    fromClass: "Monk of the Silver Fist",
    abilityType:"Ex",
    shortDesc:`A monk of the silver fist gains the ability to swiftly cross the battlefield in the defense of his allies. Whenever an ally is targeted by an attack, the monk of the silver fist can spend 4 spell points as an immediate action to move up to his speed towards that ally. If his movement ends adjacent to the targeted ally, the monk of the silver fist becomes the target of that attack, rather than his ally.`
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Ambush Tactics",
    fromClass: "Ambush Hunter",
    abilityType:"Ex",
    shortDesc:`Whenever you are flanking with an ally or attacking a flat-footed creature you can add your highest mental mod as a bonus to damage rolls on all strikes against it. If you and an ally both successfully attack the same creature in one round you regain spell points equal to your highest mental modifier/2.`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Pack Savagery",
    fromClass: "Ambush Hunter",
    abilityType:"Ex",
    shortDesc:`Whenever you initiate a boost from the Golden Lion or Primal Fury martial disciplines you can select an ally within 30 feet, they gain a morale bonus on their next damage roll equal to the level of the boost, and also gain the benefits of that boost.`
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Epic Channel Energy",
    fromClass: "Cleric",
    abilityType:"Su",
    shortDesc:`When you select this ability choose either positive or negative energy, this choice cannot be changed. For 2 spell points per dice rolled you can channel energy as a standard action causing a burst that affects all creatures of one type (either undead or living) in a 30-foot radius centered on you. The amount of damage dealt or healed is equal to 1d6, + 1d6 every 3 levels you have and scales with positive/negative spell power. To resist this ability the target must make a will save dc is 10 + level/2 + highest mental mod. If you have another channel energy perk you can add the healing granted by this ability to it for the increased cost.`
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Throw Under the Bus",
    fromClass: "Mesmerist",
    abilityType:"Su",
    shortDesc:`When an attack is declared against you can as an immediate action for 3 spell points throw a willing or unwilling adjacent ally (reflex negates, dc=10+level/2+mental) under the bus, the attack from the attacking creature is redirected against the target ally and all other attacks for that turn the creature makes must be made against that ally, unless the creature would be unable to reach the ally to make its attacks. The Ally gets -4 to AC for attacks made by the attacking creature for 1 round. This is a mind-affecting compulsion effect. For 1 round after activating this ability the betrayed ally can use your spell points for their abilities`
    },     

    // {
    // rarity: "common",
    // type: "universal",
    // name: "Body Refresh",
    // fromClass: "Custom",
    // shortDesc:`Reroll your HD except the first. This can potentially lower your total hp, use with caution.`,
    // hasCustomMethod:true,
    // customMethod:()=>{
    // },
    // catchUpMethod:(context)=>{
    //     for(let x = 1; x < context.stats.characterStats.hpIncreases.length; x++){                
    //         context.stats.characterStats.hpIncreases.splice(x, 1, Math.ceil(Math.random() * context.stats.characterStats.misc.HDSize))                
    //     }            
    // }
    // },
    {
    rarity: "rare",
    type: "universal",
    name: "Toughen",
    fromClass: "Custom",
    shortDesc:`Your HD size goes up by 4 and rerolls your old HD rolls.`,
    hasCustomMethod:true,
    customMethod:()=>{
    },
    catchUpMethod:(context)=>{            
        context.stats.characterStats.misc.HDSize += 4
        context.stats.characterStats.hpIncreases.splice(0, 1, context.stats.characterStats.misc.HDSize)
        for(let x = 1; x < context.stats.characterStats.hpIncreases.length; x++){                
            context.stats.characterStats.hpIncreases.splice(x, 1, Math.ceil(Math.random() * context.stats.characterStats.misc.HDSize))                
        }
    }
    },
    {
    rarity: "common",
    type: "magic",
    name: "Concentrate",
    fromClass: "Magus",
    shortDesc:`For level spell points as an immediate action you can reroll a failed concentration check, you must take the second result even if worse (and can't use this ability more than once per spell). You must use this ability after the roll is made, but before the roll's outcome is determined.`
    },
    {
    rarity: "common",
    type: "magic",
    name: "Implement Caster",
    fromClass: "Custom",
    shortDesc:`You can use 2 implements at a time while casting a spell, and can use implements without having to draw them from your bag before hand.`
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Savior",
    fromClass: "Custom",
    shortDesc:`For 8 + your level of spell points as a full round action that provokes attacks of opportunity you are able to cast breath of life at a range of 30 feet as a ranged touch attack. If you select this a second time it instead can be used to cast raise dead.`
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Critical Strike",
    fromClass: "Magus",
    shortDesc:`Whenever you score a critical hit with a weapon you can spend levelx2 spell points to cast a spell with a range of touch (or a ranged touch attack if you made the critical hit with a ranged weapon) as a swift action, then make your touch attack with that spell against the target of the critical hit as a free action, as long as they are valid targets for that attack.`
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Prescient Attack",
    abilityType:"Su",
    fromClass: "Magus",
    shortDesc:`You can spend level/2 spell points as an immediate action allowing you to anticipate your opponents defenses, denying them their dexterity bonus against your attacks until the end of your next turn.`
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Pistol Whip",
        abilityType:"Ex",
        fromClass: "Gunslinger",
        shortDesc:`You can make a surprise melee attack with the butt or handle of your firearm as a standard action. When you do, you are considered to be proficient with the firearm as a melee weapon and gains a bonus on the attack and damage rolls equal to the enhancement bonus of the firearm. The damage dealt by the pistol-whip is of the bludgeoning type, and is determined by the size of the firearm. One-handed firearms deal 1d6 points of damage and two-handed firearms deal 1d10 points of damage. Regardless of the your size, the critical multiplier of this attack is 20/×2. If the attack hits, you can make a combat maneuver check to knock the target prone as a free action. Performing this deed costs 4 spell points.`
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Mind Over Matter",
    fromClass:"Custom",
    shortDesc: "As a swift action you can activate this ability for 1 round, while active instead of taking any damage to your health the damage taken is reduced from your spell points. If you take more damage than you have spell points the remaining damage is taken as normal. This doesn't stop or reduce any negative effects other than damage to your health.",
    }, 
    {
    rarity: "rare",
    type: "magic",
    name: "Teaching Moment",
    fromClass:"Community Cleric",
    abilityType:"Su",
    shortDesc: "When you or an ally within 30 feet rolls a natural 1 or a natural 20 on an attack roll, an ability check, a skill check, or a saving throw, as an immediate action for 4 spell points you can grant all allies within 30 feet special insights that help them overcome similar challenges. Once during the next minute, each affected creature can choose to roll twice and take the better result before attempting an attack roll, ability check, skill check, or saving throw.",
    },
    {
    rarity: "common",
    type: "magic",
    name: "Binding Ties",
    fromClass:"Family Cleric",
    abilityType:"Su",
    shortDesc: "As a standard action, you can touch an ally and remove one condition affecting the ally by transferring it to yourself. This transfer lasts a number of rounds equal to your cleric level, but you can end it as a free action on your turn. At the end of this effect, the condition reverts to the original creature, unless it has ended or is removed by another effect. While this power is in use, the target is immune to the transferred condition.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Adoration",
    fromClass:"Love Cleric",
    abilityType:"Su",
    shortDesc: "As an immediate action for 4 spell points, you can attempt to thwart a melee or ranged attack that targets you. This ability functions as sanctuary, but only against one individual attack. You must use the ability after the attack is declared but before the roll is made. The creature attacking you receives a Will save to negate this effect. If a creature has more than one attack, this ability only affects one of the attacks. This is a mind-affecting effect.",
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Ready Pike",
    fromClass:"Phalanx Soldier Fighter",
    abilityType:"Ex",
    shortDesc: "For level spell points you can ready a weapon with the brace property against a charging creature as an immediate action, and gain +1 to attack and damage rolls for that readied attack, +1 every 4 levels.",
    }, 
    {
    rarity: "epic",
    type: "magic",
    name: "Withstand",
    fromClass:"Custom",
    shortDesc: "As an immediate action when taking hit point damage, you can activate this ability for any amount of spell points you'd like to spend, reduce the damage taken by 1 for each spell point spent.",
    }, 
    {
    rarity: "epic",
    type: "magic",
    name: "Aura of Menace",
    fromClass:"Archon Cleric",
    shortDesc: "As a standard action you can begin to emit a 30-foot aura of menace, enemies within this aura take a -2 penalty to AC, attacks, and saves as long as they remain inside the aura. Activating this ability costs 6 spell points, and requires 3 more each round to keep active, but requires no additional actions.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Protective Aura",
    fromClass:"Agathion Cleric",
    shortDesc: "You can emit a 30-foot protective aura as a standard action. Allies in this aura receive a +2 deflection bonus to AC and a +2 resistance bonus on all saving throws. In addition, allies in the area gain the benefits of protection from evil (although the AC bonus and saving throw bonus do not stack with those granted by this effect). Activating this ability costs 4 spell points, and requires 2 more each round to keep active, but requires no additional actions.",
    },  
    {
    rarity: "legendary",
    type: "universal",
    name: "Spell Shield",
    abilityType:"Su",
    fromClass: "Magus",
    shortDesc:`You can spend level/2 spell points as an immediate action to give yourself a shield bonus to ac equal to your highest mental stat until the end of your next turn.`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Active Defense",
    //abilityType:"Su",
    sphere:"shield",
    shortDesc:`If you are using a shield and you are attacked by a creature you are aware of while not flat-footed, you may spend an attack of opportunity to increase your shield bonus to AC against that attack by +2. This decision must be made before the roll is made. For every 4 points of base attack bonus you possess, the increase to your shield bonus provided by this perk increases by 1.`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Cover Ally",
    sphere:"shield",
    prereq:"Active Defense",
    shortDesc:`As long as you have martial focus, you may use active defense to benefit an ally when an ally within your shield's reach is targeted by an attack.`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Interposing Shield",
    sphere:"shield",
    prereq:"Active Defense",
    shortDesc:`Creatures benefiting from your active defense bonus (including yourself) gain DR/- equal to the bonus from active defense against attacks that hit despite active defense. This damage reduction stacks with damage reduction from other sources.`
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Punch Block",
    sphere:"shield",
    prereq:"Active Defense",
    shortDesc:`When you use your active defense, you may choose to make an attack roll as if making a shield bash and must use the result of this attack in place of your AC for resolving the attack, even if lower. You must be capable of making shield bash attacks with the shield to use this ability.

    Note: Punch Block replaces your entire AC bonus with your attack roll; treat this as though using your active defense. This is not a shield bonus, and does not apply to attacks which would bypass your Shield bonus (such as the Improved Precise Shot feat). The Deflecting Shield talent does not allow Punch Block to apply against touch attacks.`
    },
    {
    rarity: "common",
    type: "martial",
    name: "Reassuring Imposition",
    sphere:"shield",
    shortDesc:`Allies who are adjacent to you gain a bonus to concentration checks equal to your shield bonus to AC. Additionally, if an adjacent ally would incur penalties to concentration checks from the Disruptive feat or a similar ability, the increase to DC is halved
    \nIf you have the active defense perk you can also add the bonus you gain from active defense to the bonus allies gain to concentration checks.`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Shielded Focus",
    sphere:"shield",
    shortDesc:`While wielding a buckler, shield, or tower shield, you may spend a move action to regain your martial focus whenever you choose to fight defensively as part of an attack action.

    Additionally, whenever an attack misses a creature benefiting from your active defense, you may regain your martial focus as an immediate action.`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Snapping Tortoise",
    sphere:"shield",
    talentType: "stance",
    prereq:"Active Defense",
    shortDesc:`While in this stance, whenever a creature misses an attack against a creature benefiting from your active defense, your next successful attack action against that creature before the end of your next turn forces that creature to succeed at a Fortitude (dc=10+level/2 + highest mental) save or fall prone even if you are no longer in this stance.
    \nThis is a sphere stance, you can only be in one sphere stance at a time.`
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Extensive Defense",
    sphere:"shield",
    prereq:"Active Defense",
    shortDesc:`You may expend martial focus as a free action that can be taken even when it's not your turn to apply your active defense against all valid triggering attacks until the start of your next turn without spending attacks of opportunity. If you possess the Cover Ally talent, you may apply this benefit to all allies within reach.`
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Flexible Cover",
    sphere:"shield",
    prereq:"Active Defense",
    shortDesc:`You may spend a move action to use a shield to grant you cover until the beginning of your next turn. Bucklers, heavy shields, and light shields provide partial cover while tower shields provide total cover. When using a shield in this way, you must choose one edge of your space. That edge is treated as a solid wall for attacks targeting you only. You gain cover for attacks that pass through this edge. The shield does not, however, provide cover against targeted spells; a spellcaster can cast a spell on you by targeting the shield you are holding. Cover granted this way is insufficient to enable you to make a Stealth check to hide and the shield may be targeted as an attended object.

    As an immediate action, you may change the selected edge of your space even when it is not your turn. If you expend martial focus, you may use this talent as an immediate action.`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Reactive Defense",
    sphere:"shield",
    shortDesc:`Whenever you take the total defense action while wielding a shield, creatures that miss you provoke attacks of opportunity from you. You may make these attacks of opportunity but take a penalty on the attack rolls as if you were fighting defensively.`
    },

    {
    rarity: "rare",
    type: "martial",
    name: "Targe Riposte",
    sphere:"shield",
    shortDesc:`You can use the hand wielding a light shield to also wield a light weapon, as if it were a buckler, but you take a -2 penalty on attack rolls (instead of -1). Whenever you would attempt a melee attack with a shield bash, you may instead attempt a melee attack with the weapon wielded in your shield hand.

    If you gain this perk a second time you can wield a one handed weapon in your shield arm.`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Tough Shield",
    sphere:"shield",
    shortDesc:`You add your shield bonus to AC as a shield bonus to your CMD.

    You can use active defense against combat maneuvers, allowing creatures benefiting from your active defense (including yourself) to add your active defense bonus to their CMD (not including the benefit of the base shield).`
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Deflecting Shield",
    sphere:"shield",
    shortDesc:`Your shield bonus to AC applies against touch attacks.`
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Shield Wall",
    abilityType:"Ex",
    fromClass: "Eric",
    shortDesc:`You can wield multiple shields at once and their shield bonuses stack. This doesn't affect shield bonuses from other sources such as the shield spell.`
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Alchemical Allocation",
    abilityType:"Su",
    fromClass: "Alchemist",
    shortDesc:`You can spend the potions level x 2 spell points while ingesting a curative or restorative potion to gain its effects and then spit it back up to not actually consume it. Drinking a potion in this manner takes a full round action.`
    },
    {
    rarity: "legendary",
    type: "magic",
    name: "Opportune Strike",
    abilityType:"Su",
    fromClass: "Magus",
    shortDesc:`As long as you have one hand free you threaten in melee. In place of an attack of opportunity you can spend level spell points to make a melee touch attack spell as an attack of opportunity. This spell costs 50% extra spell points, but does not provoke attacks of opportunity.`
    },
    {
    rarity: "epic",
    type: "universal",
    name: "Prescient Defense",
    abilityType:"Su",
    fromClass: "Magus",
    shortDesc:`You can spend level/2 spell points as an immediate action after hitting a target with a weapon attack, you gain a dodge bonus to your AC and reflex saves against that target equal to your highest mental stat until the start of your next turn.`
    },
    {
    rarity: "common",
    type: "magic",
    name: "Perk Metamastery",
    fromClass: "custom",
    shortDesc:`For the regular cost of the metamagic feat + 50% you can instead apply it to a perk that could logically be modified by it (such as empower for channel energy). Perks become valid choices for perks that select spells for reduced metamagic costs.`
    },        
    {
    rarity: "common",
    type: "magic",
    name: "Misfortune",
    fromClass: "Witch",
    shortDesc:`As a standard action for level spell points the witch can cause a creature within 30 feet to suffer grave misfortune for level/2 rounds. Anytime the creature makes an ability check, attack roll, saving throw, or skill check, it must roll twice and take the worse result. A Will save negates this hex (dc=10+level/2+highest mental), and if it fails it can attempt to reroll the next round as a full round action. At 8th level and 16th level, the duration of this hex is extended by level/4 rounds. This hex affects all rolls the target must make while it lasts. Whether or not the save is successful, a creature cannot be the target of this hex again for the rest of the combat. `
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Protective Luck",
    fromClass: "Witch",
    shortDesc:`As a standard action for level/2 spell points The witch can cause fate to twist so that it benefits a creature within 30 feet for 1 round. Whenever that creature is targeted by an effect that requires an attack roll, including weapon attacks, the attacker must roll twice and take the worse result. Every 7 levels the duration of this hex goes up by 1 round. A witch cannot use this ability on herself. This is a hex for other abilities that modify or require it.`
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Mutagen",
    fromClass:"Alchemist",
    shortDesc: "You gain the ability to create and drink a mutagen for 6 spell points as a full round action which provokes attacks of opportunity, select one physical ability score—either Strength, Dexterity, or Constitution. Upon being imbibed, the mutagen causes the alchemist to grow bulkier and more bestial, granting him a +2 natural armor bonus and a +4 alchemical bonus to the selected ability score for the rest of the floor. In addition, while the mutagen is in effect, the alchemist takes a -4 penalty to one of his mental ability scores. If the mutagen enhances his Strength, it applies a penalty to his Intelligence. If it enhances his Dexterity, it applies a penalty to his Wisdom. If it enhances his Constitution, it applies a penalty to his Charisma. \n\nWhen you reach level 12 The alchemist's mutagen now costs 12 spell points, but grants a +4 natural armor bonus, a +6 alchemical bonus to one physical ability score (Strength, Dexterity, or Constitution), and a +4 alchemical bonus to a second physical ability score. The alchemist takes a -4 penalty on both associated mental ability scores as long as the mutagen persists. \n\nWhen you reach level 20 The mutagen now costs 20 spell points, but grants a +6 natural armor bonus, a +8 alchemical bonus to one ability score (Strength, Dexterity, or Constitution), a +6 alchemical bonus to a second physical ability score, and a +4 alchemical bonus to a third physical ability score. The alchemist takes a -5 penalty to his Intelligence, Wisdom, and Charisma as long as the mutagen persists.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Vision Of Madness",
    fromClass:"Madness Cleric",
    abilityType:"Sp",
    shortDesc: "For level/2 spell points You can give a creature a vision of madness as a melee touch attack. Choose one of the following: attack rolls, saving throws, or skill checks. The target receives a bonus to the chosen rolls equal to ½ your cleric level (minimum +1) and a penalty to the other two types of rolls equal to ½ your cleric level (minimum -1). This effect fades after 3 rounds.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Aura of Madness",
    fromClass:"Madness Cleric",
    abilityType:"Su",
    shortDesc: "As a swift action for level spell points you can emit a 30-foot aura of madness, once activated you can keep the aura active without further actions, but must keep spending the spell point cost. Enemies within this aura are affected by confusion unless they make a Will save with a DC equal to 10 + ½ your Cleric level + your highest mental modifier. The confusion effect ends immediately when the creature leaves the area or the aura expires. Creatures that succeed on their saving throw are immune to this aura",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Fearful Touch",
    fromClass:"Madness Cleric",
    abilityType:"Su",
    shortDesc: "As a standard action for level/2 spell points, you can make a melee touch attack against a creature, causing it to experience terrible hallucinations for 1 round. During this time, the creature loses any immunity to fear effects it might possess and takes a -2 penalty on attack rolls made against you. In addition, the creature takes a penalty on Will saves made against fear effects equal to 1/2 your cleric level (minimum -1). This power is a mind-affecting effect.",
    },  



    // {
    // rarity: "epic",
    // type: "universal",
    // name: "Increased Vitality",
    // shortDesc: "Increase your HD by 1 step, this stacks",
    // },
    {
    rarity: "rare",
    type: "martial",
    name: "Solo Tactics",
    fromClass:"Inquisitor",
    shortDesc: "All of your allies are treated as if they possessed the same teamwork feats as you for the purpose of determining whether you receive a bonus from your teamwork feats. Your allies do not receive any bonuses from these feats unless they actually possess the feats themselves. The allies' positioning and actions must still meet the prerequisites listed in the teamwork feat for you to receive the listed bonus. If you use a teamwork feat with another ally that has that teamwork feat you gain +1 to any numeric modifiers that teamwork feat provides. This increases by +1 every 8 levels.",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Tactical Flanker",
    fromClass:"Warlord",
    shortDesc: "At the start of your turns, you choose a single square adjacent to you. Until the start of your next turn, you and your allies can treat that square as if it was occupied by you for the purposes of flanking opponents.",
    },
    {
        rarity: "epic",
        type: "universal",
        name: "Scapegoat",
        abilityType:"Ex",
        fromClass:"Colluding Scoundrel Hunter",
        shortDesc: `As a swift action for level spell points, you can target one foe within 30 feet and designate one ally adjacent to that foe as a scapegoat. For the 5 rounds, the target takes a -2 penalty on attacks against any creature other than the designated scapegoat, and the target has a 10% spell failure chance on spells that don't target the scapegoat or include the scapegoat in their area of effect. The penalty increases to -4 at 8th level and -6 at 15th level. You deal 1d6 additional points of sneak attack damage against a creature adjacent to your chosen scapegoat. This increases by 1d6 every 8 levels. 
        \nThis is a mind-affecting effect. The effect ends if you fall unconscious or are slain. Once an enemy has been affected by this, they cannot be affected again.`,
    },
    {
        rarity: "common",
        type: "magic",
        name: "Expanded Library",
        shortDesc: "Each time you level up you also gain a random spell",
        hasCustomMethod:true,
        customMethod:(context,self)=>{
            self.getSpell(context, Math.ceil(context.stats.characterStats.misc.level/2)+1)
        },
        catchUpMethod:(context,self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                self.getSpell(context, Math.ceil(x/2)+1)                       
            }
        },
        getSpell: (context, lvlNum)=>{
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            let obj={command:"requestRoll", type:"spell", options};
            context.connection.send(JSON.stringify(obj));
        },
    },
    {
        rarity: "rare",
        type: "magic",
        name: "Improved Expanded Library",
        shortDesc: "Each time you level up you also gain a typed spell",
        hasCustomMethod:true,
        customMethod:(context,self)=>{
            self.getSpell(context, Math.ceil(context.stats.characterStats.misc.level/2)+1)
        },
        catchUpMethod:(context,self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                self.getSpell(context, Math.ceil(x/2)+1)                       
            }
        },
        getSpell: (context, lvlNum)=>{
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}, type:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            let spellTypes = ["damage", "control", "healing", "buff", "utility"]
            let choices = []           
            for(let x = 0; x < spellTypes.length; x++){
                let choice = {
                    title:spellTypes[x],
                    id:x, 
                    method:(context=>{                            
                        options.type[spellTypes[x]] = true
                        context.connection.send(JSON.stringify(
                            {
                                command:"requestRoll", 
                                type:"spell", 
                                options
                            }
                        ))
                    })}
                    choices.push(choice)
            }         
            let custom = {title:"typed spell choice", options:choices}         
            context.customDialogArray.push(custom)
        },
    },
    {
        rarity: "epic",
        type: "magic",
        name: "Greater Expanded Library",
        shortDesc: "Each time you level up you also gain a lvl+ typed spell",
        hasCustomMethod:true,
        customMethod:(context,self)=>{
            self.getSpell(context, Math.ceil(context.stats.characterStats.misc.level/2)+1)
        },
        catchUpMethod:(context,self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                self.getSpell(context, Math.ceil(x/2)+1)                       
            }
        },
        getSpell: (context, lvlNum)=>{
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}, type:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            let spellTypes = ["damage", "control", "healing", "buff", "utility"]
            let choices = []           
            for(let x = 0; x < spellTypes.length; x++){
                let choice = {
                    title:spellTypes[x],
                    id:x, 
                    method:(context=>{                            
                        options.type[spellTypes[x]] = true
                        context.connection.send(JSON.stringify(
                            {
                                command:"requestRoll", 
                                type:"spell", 
                                options
                            }
                        ))
                    })}
                    choices.push(choice)
            }         
            let custom = {title:"typed spell choice", options:choices}         
            context.customDialogArray.push(custom)
        },
    },
    {
    rarity: "common",
    type: "martial",
    name: "Ancient Techniques",
    shortDesc: "Each time you level up you also gain a random maneuver",
    hasCustomMethod:true,
        customMethod:(context,self)=>{
            self.getManeuver(context, context.stats.characterStats.misc.level)
        },
        catchUpMethod:(context,self)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                self.getManeuver(context, x)                       
            }
        },
        getManeuver: (context, lvlNum)=>{
            lvlNum = Math.ceil(lvlNum/2)+1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x > 0){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }                
            context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options}))
        },
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Improved Ancient Techniques",
        shortDesc: "Each time you level up you also gain a maneuver from school.",
        hasCustomMethod:true,
            customMethod:(context,self)=>{
                self.getManeuver(context, context.stats.characterStats.misc.level)
            },
            catchUpMethod:(context,self)=>{
                for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                    self.getManeuver(context, x)                       
                }
            },
            getManeuver: (context, lvlNum)=>{
                lvlNum = Math.ceil(lvlNum/2)+1
                if(lvlNum > 9){lvlNum = 9}
                let options = {level:{}, school:{}}
                for(let x = 0; x < 4; x++){
                    if(lvlNum-x > 0){   
                        let level = lvlNum-x
                        let levelString="lvl"+level;
                        options.level[levelString]=true;
                    }
                }
                let schools = maneuverSchoolsText
                let choices = []           
                for(let x = 0; x < schools.length; x++){
                    let choice = {
                        title:schools[x],
                        id:x, 
                        method:(context=>{                            
                            options.school[schools[x]] = true
                            context.connection.send(JSON.stringify(
                                {
                                    command:"requestRoll", 
                                    type:"maneuver", 
                                    options
                                }
                            ))
                        })}
                        choices.push(choice)
                }         
                let custom = {title:"Typed Maneuver Choice", options:choices}         
                context.customDialogArray.push(custom)
            }, 
        },
        {
            rarity: "common",
            type: "martial",
            name: "Discipline Training",
            shortDesc: `When you select this perk you will select one school of maneuvers, and every time you level up you also gain a maneuver from that school. You also gain a +1 bonus to the DC's of maneuvers from that school.`,
            hasCustomMethod:true,
            customMethod:(context,self, refrenceSelf)=>{
                self.getManeuver(context, context.stats.characterStats.misc.level,refrenceSelf)
            },
            catchUpMethod:(context,self,referenceSelf)=>{
                self.getSchool(context,self,referenceSelf)
            },
            getSchool(context,self,referenceSelf){
                let schools = maneuverSchoolsText
                let choices = []           
                for(let x = 0; x < schools.length; x++){
                    let choice = {
                        title:schools[x],
                        id:x, 
                        method:(()=>{
                            referenceSelf.chosenSchool = schools[x]
                            referenceSelf.shortDesc += '\n\nSchool Chosen: ' + schools[x] 
                            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                                self.getManeuver(context, x, referenceSelf)
                            }
                        })}
                        choices.push(choice)
                }
                let custom = {title:"Typed Maneuver Choice", options:choices}         
                context.customDialogArray.push(custom)

            },
            getManeuver: (context, lvlNum, referenceSelf)=>{
                lvlNum = Math.ceil(lvlNum/2)+1
                if(lvlNum > 9){lvlNum = 9}
                let options = {level:{}, school:{}}
                options.school[referenceSelf.chosenSchool] = true
                for(let x = 0; x < 4; x++){
                    if(lvlNum-x > 0){   
                        let level = lvlNum-x
                        let levelString="lvl"+level;
                        options.level[levelString]=true;
                    }
                }
                context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options}))
            }, 
        },
        {
            rarity: "rare",
            type: "martial",
            name: "Expert Discipline Training",
            shortDesc: `When you select this perk you will select one school of maneuvers, and every time you level up you also gain a level+ maneuver from that school. You also gain a +2 bonus to the DC's of maneuvers from that school.`,
            hasCustomMethod:true,
            customMethod:(context,self, refrenceSelf)=>{
                self.getManeuver(context, context.stats.characterStats.misc.level,refrenceSelf)
            },
            catchUpMethod:(context,self,referenceSelf)=>{
                self.getSchool(context,self,referenceSelf)
            },
            getSchool(context,self,referenceSelf){
                let schools = maneuverSchoolsText
                let choices = []           
                for(let x = 0; x < schools.length; x++){
                    let choice = {
                        title:schools[x],
                        id:x, 
                        method:(()=>{
                            referenceSelf.chosenSchool = schools[x]
                            referenceSelf.shortDesc += '\n\nSchool Chosen: ' + schools[x] 
                            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                                self.getManeuver(context, x, referenceSelf)
                            }
                        })}
                        choices.push(choice)
                }
                let custom = {title:"Typed Maneuver Choice", options:choices}         
                context.customDialogArray.push(custom)

            },
            getManeuver: (context, lvlNum, referenceSelf)=>{
                lvlNum = Math.ceil(lvlNum/2)+2
                if(lvlNum > 9){lvlNum = 9}
                let options = {level:{}, school:{}}
                options.school[referenceSelf.chosenSchool] = true
                for(let x = 0; x < 4; x++){
                    if(lvlNum-x > 0){   
                        let level = lvlNum-x
                        let levelString="lvl"+level;
                        options.level[levelString]=true;
                    }
                }
                context.connection.send(JSON.stringify({command:"requestRoll", type:"maneuver", options}))
            }, 
        },
        {
            rarity: "epic",
            type: "martial",
            name: "Greater Ancient Techniques",
            shortDesc: "Each time you level up you also gain a lvl+ maneuver from school.",
            hasCustomMethod:true,
                customMethod:(context,self)=>{
                    self.getManeuver(context, context.stats.characterStats.misc.level)
                },
                catchUpMethod:(context,self)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        self.getManeuver(context, x)                       
                    }
                },
                getManeuver: (context, lvlNum)=>{
                    lvlNum = Math.ceil(lvlNum/2)+2
                    if(lvlNum > 9){lvlNum = 9}
                    let options = {level:{}, school:{}}
                    for(let x = 0; x < 4; x++){
                        if(lvlNum-x > 0){   
                            let level = lvlNum-x
                            let levelString="lvl"+level;
                            options.level[levelString]=true;
                        }
                    }
                    let schools = ["blackSeraph", "brokenBlade", "brutalCrocodile", "cursedRazor", "elementalFlux", "eternalGuardian", "goldenLion", "ironTortoise", "mithralCurrent", "piercingThunder", "primalFury", "radiantDawn", "rivenHourglass", "scarletThrone", "shatteredMirror", "silverCrane", "sleepingGoddess", "solarWind", "steelSerpent", "tempestGale", "thrashingDragon", "unquietGrave", "veiledMoon", "heartOfTheMaelstrom", "burningCitadel","shadowAssassin", "indomitableWill","crimsonReaper",]
                    let choices = []           
                    for(let x = 0; x < schools.length; x++){
                        let choice = {
                            title:schools[x],
                            id:x, 
                            method:(context=>{                            
                                options.school[schools[x]] = true
                                context.connection.send(JSON.stringify(
                                    {
                                        command:"requestRoll", 
                                        type:"maneuver", 
                                        options
                                    }
                                ))
                            })}
                            choices.push(choice)
                    }         
                    let custom = {title:"Typed Maneuver Choice", options:choices}         
                    context.customDialogArray.push(custom)
                }, 
            },
    {
    rarity: "legendary",
    type: "universal",
    name: "Researched Mastery",
    shortDesc: "You can choose to use your level instead of your BAB for attack rolls",
    },
    {
    rarity: "legendary",
    type: "universal",
    name: "Arcane Accuracy",
    fromClass:"Magus",
    shortDesc: "As as swift action you can spend level/2 spell points to gain an insight bonus equal to your highest mental stat on all attack rolls until the end of your turn.",
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Accurate Strike",
    fromClass:"Magus",
    shortDesc: "As as swift action you can spend level spell points to resolve all of your melee weapon attacks as melee touch attacks until the end of your turn",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Arcane Maneuver",
    abilityType:"Su",
    fromClass:"Custom",
    shortDesc: "For 2 spell points you can add your highest mental stat to a single strength or dexterity skill check.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Potion Thrower",
    shortDesc: "For 2 spell point per the potions level you can throw it as a ranged touch attack with a 10 foot range increment. If you hit you can apply the affects of that potion to a target",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Treasure Sense",
    shortDesc: "Treasure piles come with additional gold, between 1-10 for small piles, 1-20 for medium piles, and 1-30 for large piles. This bonus gold is only given to you.  Additionally, once per floor you can get a vague sense of where one type of chest or gold is placed on the map, and gain a bonus equal to your level for any skill checks associated with gaining that treasure, such as perception checks to find it.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Vestigial Arm",
    fromClass:"Alchemist",
    shortDesc: "The alchemist gains a new arm on his torso. The arm is fully under his control. The arm does not give the alchemist any extra attacks or actions per round, though the arm can wield a weapon and make attacks as part of the alchemist's attack routine (using two-weapon fighting). The arm can manipulate or hold items as well as the alchemist's original arms (for example, allowing the alchemist to use one hand to wield a weapon, another hand to hold a shield, and the third hand to throw a bomb)",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Favorite Maneuver",
    fromClass:"Custom",
    shortDesc: "Select a single maneuver when you gain this perk, decrease its cost by 50% and increase the damage it deals by 2d6 or its dc by 2. Every 4 levels you can change the selected maneuver.",
    },        
    {
    rarity: "epic",
    type: "martial",
    name: "Bane",
    fromClass:"inquisitor",
    shortDesc: "As a swift action for 2 spell points you imbue one of your weapons with the bane weapon special ability. This costs 2 spell points a round to maintain. You must select one creature type when you uses this ability (and a subtype if the creature type selected is humanoid or outsider). Once selected, the type can be changed as a swift action",
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Parry and Riposte",
    fromClass:"Swashbuckler",
    shortDesc: "When an opponent makes a melee attack against you, you can spend 2 spell point and expend a use of an attack of opportunity to attempt to parry that attack. make an attack roll as if you were making an attack of opportunity; for each size category the attacking creature is larger than the swashbuckler, the swashbuckler takes a -2 penalty on this roll. If the result is greater than the attacking creature's result, the creature's attack automatically misses. The swashbuckler must declare the use of this ability after the creature's attack is announced, but before its attack roll is made. Upon performing a successful parry you can as an immediate action make an attack against the creature whose attack you parried, provided that creature is within your reach. Each additional time per round you use this ability the spell point cost increases by 2.",
    },
    {
    rarity: "epic",
    type: "universal",
    name: "Dodging Panache",
    fromClass:"Swashbuckler",
    shortDesc: "when an opponent attempts a melee attack against the swashbuckler, the swashbuckler can as an immediate action spend level/2 spell points to move 5 feet; doing so grants the swashbuckler a dodge bonus to AC equal to their highest mental stat modifier against the triggering attack. This movement doesn't negate the attack, which is still resolved as if the swashbuckler had not moved from the original square. This movement is not a 5-foot step; it provokes attacks of opportunity from creatures other than the one who triggered this deed. The swashbuckler can only perform this deed while wearing light or no armor.",
    },        
    {
    rarity: "epic",
    type: "universal",
    name: "Kip Up",
    fromClass:"Swashbuckler",
    shortDesc: "You can kip-up from prone as a move action without provoking an attack of opportunity. She can kip-up as a swift action instead by spending 2 spell points.",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Dizzying Defense",
    fromClass:"Swashbuckler",
    shortDesc: "while wearing light or no armor you can spend 2 spell points to take the fighting defensively action as a swift action instead of a standard action. When fighting defensively in this manner, the dodge bonus to AC gained from that action increases to +4, and the penalty to attack rolls is reduced by 2.",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Brutal Strikes",
    fromClass:"Brutal Slayer Stalker",
    shortDesc: "When you confirm a critical hit you gain +4 profane bonus to strength for rounds equal to your highest mental stat (minimum 1 round), this increases by +2 at 8th and 16th",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Muscle Memory",
    fromClass:"Brutal Slayer Stalker",
    shortDesc: "You can use your strength modifier in place of dexterity modifier for armor class",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Dodging Dance",
    fromClass:"Swashbuckler",
    shortDesc: "spend 2 spell points to move up to half your speed as a move action. If a creature makes an attack of opportunity against you due to this movement, you can attempt an Acrobatics check with a DC equal to the attacking creature's CMD. If you succeeds, the attack of opportunity misses, and the swashbuckler can make an attack of opportunity against the attacking creature instead. you can attempt to evade multiple attacks of opportunity during this movement, but the DC of the Acrobatics check increases by 2 for each additional opponent that makes an attack of opportunity against you during this movement",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Charmed Life",
    fromClass:"Swashbuckler",
    shortDesc: "for level/2 spell points as an immediate action before attempting a saving throw, you can add your highest mental modifier to the result of the save",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Plunder",
    fromClass: "Swashbuckler",
    shortDesc: "As a full-round action you can make a single attack with a light melee weapon while having your other hand free against a foe that is either shaken or denied its Dexterity bonus to AC. If the attack hits, you can also attempt a disarm check using your stealth or cmb +4. If you succeed, you also gain 10 gold. You can only gain 10 gold once per monster.",
    },
    {
    rarity: "common",
    type: "magic",
    name: "Rebuke Death",
    fromClass: "Cleric",
    abilityType:"Sp",
    shortDesc: "As a standard action for 1 spell point you can touch a living creature that is currently below 0 hitpoints and heal them for 1d4+level. This scales with 200% spell power, and its critical chance is doubled.",
    },
    {
    rarity: "common",
    type: "magic",
    name: "Blessed Surgery",
    fromClass: "Cleric",
    abilityType:"Su",
    shortDesc: "When making a heal check to heal hit points you can add your level to the check. If a creature has already had deadly wounds treated on this floor you expend 2 spell points to treat deadly wounds on them again, each time you use this ability on a creature per floor it costs 2 additional spell points.",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Disrupting Counter",
    fromClass: "Flying Blade Swashbuckler",
    shortDesc: "When an opponent makes a melee attack against you, you can spend 4 spell points to make an attack of opportunity against the attacking foe with a light weapon. If the attack hits, the opponent takes a -4 penalty on all attack rolls until the end of its turn.",
    },
    {
    rarity: "common",
    type: "universal",
    name: "Potion Feeder",
    fromClass: "custom",
    shortDesc: "You can feed a potion to a teammate that is not unable to take actions as a standard action instead of a full round action, and you can draw and feed a potion to a teammate unable to take actions as a standard action, and any curative potion you use on a teammate has 25% increased effectiveness",
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Inspired Strike",
    fromClass: "Inspired Blade Swashbuckler",
    shortDesc: "You can spend 3 spell point when making an attack with a light or one handed weapon to gain an insight bonus on that attack roll equal to your highest mental stat. When an inspired blade hits with an attack augmented by inspired strike, she can spend 6 + level additional spell points to make the hit a critical threat.",
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Opportune Redirection and Riposte",
    fromClass: "Guided Blade Swashbuckler",
    shortDesc: `when an opponent threatening both the guiding blade and an adjacent ally attacks that ally, the guiding blade can spend 2 spell points and expend a use of an attack of opportunity to attempt to redirect the attack to himself. 
    \nThe guiding blade makes an attack roll as if she were making an attack of opportunity; for each size category the attacking creature is larger than the guiding blade, the guiding blade takes a -2 penalty on this roll. If her result is greater than the attacking creature's attack result, the creature's attack is redirected to the guiding blade instead of the guiding blade's adjacent ally. The guiding blade must declare the use of this ability after the creature's attack is announced but before its attack roll is made.
    \nUpon performing a successful redirection, you can as an immediate action, make an attack against the creature whose attack she redirected, provided that creature is within reach.`,
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Light Steps",
    fromClass: "Ninja",
    shortDesc: "As a full-round action, you can move up to twice her speed, ignoring difficult terrain. While moving in this way, any surface will support you, no matter how much you weigh. This allows you to move across water, lava, or even the thinnest tree branches. you must end your move on a surface that can support you normally. you cannot move across air in this way, nor can you walk up walls or other vertical surfaces. When moving in this way, you does not take damage from surfaces or hazards that react to being touched, such as lava or caltrops, nor do you need to make Acrobatics checks to avoid falling on slippery or rough surfaces. Finally, when using light steps, the ninja ignores any mechanical traps that use a location-based trigger.",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Massacre",
    fromClass:"Harbinger",
    shortDesc: "For half your level spell points you can initiate one of your strikes against an adjacent creature as an immediate action when you reduces an opponent to 0 or fewer hit points. You can only initiate strikes with an initiation action of one standard action with this ability",
    },
    {
    rarity: "common",
    type: "universal",
    name: "Ability Focus",
    fromClass:"Custom",
    shortDesc: `When you gain this perk select another perk or feat that requires a spell point cost, you can reduce the cost of that ability by 25%, minimum reduction of 1, but the abilities cost is also still minimum 1. If a perk has multiple different abilities within it, such as Hexes, you only select a single ability it grants to gain this effect.  Additionally, when you select your perk for ability focus, you can also select one of the following bonuses to add to it:
    \nIncrease its DC by +2\nGain a +2 to a d20 roll made during the ability\nA non-d20 roll you make as part of the ability increases by +1 per dice rolled. You can only select this option if a d20 is not rolled as part of using the ability.`,
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Critical Edge",
    fromClass:"Stalker",
    shortDesc: "Increase the critical threat range of any weapon he wields by +1. This bonus is applied after abilities such Improved Critical or the keen weapon property and cannot be doubled.",
    },
    {
    rarity: "epic",
    type: "universal",
    name: "Mana Vampirism",
    shortDesc: "Whenever you reduce an enemy to 0 hit points or below you restore level spell points.",
    },        
    {
    rarity: "legendary",
    type: "martial",
    name: "Murderous Insight",
    fromClass:"Stalker",
    shortDesc: "By spending highest mental stat spell points swift action; for a number of rounds equal to highest mental stat, you can roll twice on a single attack roll each round and take the higher value.",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Precocious Step",
    fromClass:"Stalker",
    shortDesc: "Spend highest mental stat spell points as a swift action and move without provoking attacks of opportunity for a number rounds equal to your highest mental stat",
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Phantom Reach",
    fromClass:"Stalker",
    shortDesc: "The stalker can activate this ability by spending 3 spell point a swift action; if he does, the next melee martial strike he initiates this turn is is treated as if it instead had a range of close (25-ft. + 5-ft. / 2 levels). Strikes with a range greater than melee attack do not function with this art.",
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Extended Defense",
    fromClass:"Warder",
    shortDesc: "For your level spell points, you may activate Extended Defense as an immediate action. When you do, you choose a counter you have; you may initiate that counter as a free action for half the regular cost (even on another's turn) at will until the beginning of your next turn",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Dual Strike",
    fromClass:"Stalker",
    shortDesc: "For level spell points plus the cost of the strikes you can initiate two martial strikes as a full round action. The strikes the stalker initiates must have an initiation action of one standard action, and he must have both strikes readied. Boosts may not be applied to a dual strike due to the need to concentrate on two separate martial movements. When a dual strike is used, the action must be declared beforehand when used, both strikes are resolved separately and are expended",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Discipline Focus",
    fromClass:"Custom",
    shortDesc: "When you gain this perk choose a martial discipline, then whenever you gain a maneuver from random loot you can choose for it to come from that discipline, and if you do you gain +1 to the level the maneuver can be from. Additionally, gain +2 to damage while in a stance or using a strike from that discipline, a +4 to its skill, and +2 to the dc of its maneuvers",
    },
    {
    rarity: "common",
    type: "magic",
    name: "School Focus",
    fromClass:"Custom",
    shortDesc: "When you gain this perk choose a school of magic, then whenever you gain a spell random loot you can choose it to come from that school, and if you do, you can spend an additional 20 gold to increase the level the spell can be from by +1 (can only do this once per spell). Additionally, gain +1 caster levels when casting spells of that specific school, and increase the dc of its spells by +2",
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Dual Boost",
    fromClass:"Warlord",
    shortDesc: "For level/2 spell points plus the cost of the boosts you may initiate two boost type maneuvers with an initiation action of a swift action or less as part of the same swift action.",
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Dual Stance",
    fromClass:"Warlord",
    shortDesc: "You can have two discipline stances active at once, but you must spend spell points a round equal to the level of the higher level stance.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Soul Siphon",
    fromClass:"Bones oracle",
    shortDesc: "For 6 spell points as a standard action that requires a ranged touch attack, you can unleash a ray that causes a target to gain one negative level. The ray has a range of 30 feet. Whenever this ability gives a target a negative level, you heal a number of hit points equal to your level, and increase your effective level by 1 for your highest mental stat rounds for magical perks and spells. This negative level scales with 200% spell power.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Manifestation Ray",
    abilityType:"Sp", 
    fromClass:"Custom",
    shortDesc: "For level spell points as a standard action you can fire a ray as a ranged touch attack with a range of 50 ft that deals bludgeoning damage equal to your current spell points (calculated after the cost of this ability). The target receives a will save (dc=10+mental+level/2) to reduce the damage by half. This scales with universal spell power.",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Martial Healing",
    abilityType:"Su",
    fromClass:"Battle Templar",
    shortDesc: "Whenever you initiate a martial strike, you can then spend a swift action to heal yourself or an ally within close range (25+5/2 levels ft) 1d4 per maneuver level + hightest mental modifier health.",
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Strength of Arms",
    abilityType:"Ex",
    fromClass:"Landsknetch",
    shortDesc: "As long as you only attack with a single weapon wielded in one hand during a round you add 1.5 your strength mod to damage, as if wielding it in both hands.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Metamagic Caster",
    abilityType:"Ex",
    fromClass:"Custom",
    shortDesc: "Adding a metamagic feat to a spell no longer increases its casting time. When you use a metamagic feat to empower a spell, it gains 10 spell power per metamagic feat used.",
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Never Outnumbered",
    abilityType:"Ex",
    fromClass:"Landsknetch",
    shortDesc: "You gain +1 to attack and damage rolls whenever you threaten two or more opponents. At level 4, you gain another +1 to attack and damage if you threaten 3 or more opponents. Every 4 levels after that the maximum amount of targets you cant threaten for an additional +1 to attack and damage increases by 1.",
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Surprising Strike",
    abilityType:"Ex",
    fromClass:"Landsknetch",
    shortDesc: "For level plus the cost of the maneuver spell points you can initiate a strike with an initiation action of a standard action or less in place of an attack of opportunity.",
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Mobile Attacker",
    abilityType:"Ex",
    fromClass:"Landsknetch",
    shortDesc: "Once per round you can spend 2 spell points to make a melee attack as a free action against an opponent you threaten at any point when you move during a move action, or when moving after you initiate a maneuver that allows you to move as part of its initiation action.",
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Mobile Striker",
    abilityType:"Ex",
    fromClass:"Landsknetch",
    shortDesc: "Whenever you initiate a maneuver that allows you to move as part of it you can spend level/2 spell points to make an attack as a free action against a target you threaten during the movement. You can only do this once per maneuver.",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Bait the Dragon",
    abilityType:"Ex",
    fromClass:"Landsknetch",
    shortDesc: "As a swift action, the landsknecht can choose to take a -4 penalty to AC for one round. If he does so, any melee attack made against him for one round provokes an attack of opportunity from the landsknecht. These attacks of opportunity are resolved after the attack that provoked them.",
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Superior Reach",
    abilityType:"Ex",
    fromClass:"Landsknetch",
    shortDesc: "As long as you only attack with a single weapon wielded in one hand during your turn you increase your reach with that weapon by 5 feet.",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Sharp Fang",
    abilityType:"Ex",
    fromClass:"Dragon Fury",
    shortDesc: "When you are two weapon fighting you can treat both your main weapon and your offhand weapon as a main weapon for damage calculations such as with power attack and ability modifier to damage. If you Select this perk a second time you can instead treat both weapons as two handed weapons for damage purposes.",
    },        
    {
    rarity: "epic",
    type: "martial",
    name: "Reach of the Divine",
    abilityType:"Su",
    fromClass:"Battle Templar",
    shortDesc: "Whenever you initiate a martial strike, you may cast a spell with a range of touch on yourself or an ally within reach as a move action. This provokes as normal",
    },        
    {
    rarity: "rare",
    type: "magic",
    name: "Sheperd the Flock",
    abilityType:"Su",
    fromClass:"Battle Templar",
    shortDesc: "Whenever you cast a spell with range of touch on yourself or an ally they gain +4 sacred (or profane if caster is evil) bonus to their ac for 1 round.",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Wrath of the Faithful",
    abilityType:"Ex",
    fromClass:"Battle Templar",
    shortDesc: "Whenever you cast a benefitial spell on yourself the next strike you initiate within 1 minute of casting gains a morale boost to damage equal to the level of the spell cast.",
    },
    {
    rarity: "common",
    type: "magic",
    name: "Mana Conduit",
    abilityType:"Su",
    fromClass:"Custom",
    shortDesc: "As a standard action you can transfer up to your highest mental stat worth of spell points to an ally within 30 feet of you. The cost of this ability cant be reduced in any way. You can spend an additional 4 spell points to make this a movement action, 8 to make it a swift, and 12 to make it an immediate action. The costs of changing the action to use this ability can be reduced as normal.",
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Battlefield Invocation",
    abilityType:"Su",
    fromClass:"Battle Templar",
    shortDesc: "Once per round when you initiate a martial strike you can additionally expend a spell slot to heal all allies within 50 feet of you, excluding you for highest mental stat * spell level, and give them a morale bonus equal to spell level/2 (minimum 1) to attack and damage for 1 round.",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Divine Recovery",
    abilityType:"Su",
    fromClass:"Custom",
    shortDesc: "Whenever you initiate a strike, you can also expend a spell slot, up to the level of the strike to heal yourself for 1d8 per level of the spell.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Dual Soul Essence",
    abilityType:"Ex",
    fromClass:"Custom",
    shortDesc: "You now heal from positive and negative energy used to heal living or undead creatures, but are now damaged by positive and negative energy used to harm either living or undead creatures. If a single ability does both, you take nothing from it.",
    },
    // {
    // rarity: "rare",
    // type: "magic",
    // name: "Raise the Dead",
    // fromClass:"Bones Oracle",
    // shortDesc: "As a standard action for your level spell points, you can summon a single skeleton or zombie to serve you. The undead creature has a number of Hit Dice equal to your level. It remains for a number of rounds equal to your highest mental modifier. At 7th level, you can summon a bloody skeleton or fast zombie. At 15th level, you can summon an advanced skeleton or zombie. you can only have 1 undead at a time from this ability",
    // },
    {
    rarity: "legendary",
    type: "magic",
    name: "Spirit Walk",
    fromClass:"Bones Oracle",
    shortDesc: "As a standard action for 3 + level spell points, you can become incorporeal and invisible. While in this form, you can move in any direction and through any object (except for those made of force). You can take no action other than to move while in this form. You remain in this form for a number of rounds equal to your level, but you can end this effect prematurely with a standard action.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Life Link",
    fromClass:"Life Oracle",
    shortDesc: "As a standard action for 2 spell points, you may create a bond between yourself and another creature. Each round at the start of your turn, if the bonded creature is wounded for 5 or more hit points below its maximum hit points, it heals 5 hit points and you take 5 hit points of damage. You may have one bond active per level. This bond continues until the bonded creature dies, you die, the distance between you and the other creature exceeds 50 feet, or you end it as an immediate action (if you have multiple bonds active, you may end as many as you want as part of the same immediate action). You can have multiple bonds active on the same creature.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Lifesense",
    fromClass:"Life Oracle",
    shortDesc: "You notice and locate living creatures within 30 feet, just as if you possessed the blindsight ability",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Safe Curing",
    fromClass:"Life Oracle",
    shortDesc: "Whenever you cast a spell that cures the target of hit point damage, you do not provoke attacks of opportunity for spellcasting.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Spell-like Mastery",
    fromClass:"Custom",
    shortDesc: "Select a Sp perk or a perk that acts as a spell, that perk is a valid choice for other perks and abilities that require spells. The perk gains up to 2 types that match the ability, and counts as spell level equal to its spell point cost/2.",
    },
    {
    rarity: "common",
    type: "magic",
    name: "Spirit Boost",
    fromClass:"Life Oracle",
    shortDesc: "Whenever your healing spells heal a target up to its maximum hit points, any excess points persist for 1 round per level of the spell as temporary hit points, up to a max of your level x2.",
    },
    {
        rarity: "epic",
        type: "magic",
        name: "Magical Experiment",
        fromClass:"Custom",
        shortDesc: "When you gain this perk select a spell, then select a type of magic (damage, utility, healing, buff, control), when you cast that spell, you can choose one type of magic the spell was originally, and change it to the selected type. Every 8 levels you can select a different spell and school in place of the old ones.",
    }, 
    {
    rarity: "rare",
    type: "magic",
    name: "Energy Body",
    fromClass:"Life Oracle",
    shortDesc: "As a standard action for level/2 spell points per round, you can transform your body into pure life energy, resembling a golden-white fire elemental. In this form, you gain the elemental subtype and give off a warm, welcoming light that increases the light level within 10 feet by one step, up to normal light. Any undead creature striking you with its body or a handheld weapon deals normal damage, but at the same time the attacker takes 1d6 points of positive energy damage + 1 point per oracle level. Creatures wielding melee weapons with reach are not subject to this damage if they attack you. If you grapple or attack an undead creature using unarmed strikes or natural weapons, you may deal this damage in place of the normal damage for the attack. Once per round, if you pass through a living allied creature's square or the ally passes through your square, it heals 1d6 hit points + 1 per oracle level. You may use this ability to heal yourself as a move action. You choose whether or not to heal a creature when it passes through your space. You may return to your normal form as a free action.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Life Sense",
    fromClass:"Life Oracle",
    shortDesc: "You notice and locate living creatures within 30 feet, just as if you possessed the blindsight ability.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Life Leach",
    fromClass:"Nature Oracle",
    shortDesc: "For level spell points As a standard action, you can drain the life essence from one living target within 30 feet. The target takes 1d6 points of damage per levels you possess. You gain temporary hit points equal to the damage you deal. The target receives a Fortitude save (DC=10 + level/2 + mental) to halve the damage (and the temporary hit points you gain)",
    },
    {
    rarity: "common",
    type: "magic",
    name: "Rewind Time",
    fromClass:"Time Oracle",
    shortDesc: "For level/2 spell points as an immediate action, you can reroll any one d20 roll that you have just made before the results of the roll are revealed. You must take the result of the reroll, even if it's worse than the original roll",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Time Hop",
    fromClass:"Time Oracle",
    shortDesc: "As a move action, you can teleport up to 10 feet per level that you possess for 2 spell points per 10 feet. This teleportation must be used in 5-foot increments. This movement does not provoke attacks of opportunity. You must have line of sight to your destination to use this ability. You can bring other willing creatures with you, but you must expend an equal amount of distance for each creature brought, and you have to touch them to teleport with them.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Erase from Time",
    fromClass:"Time Oracle",
    shortDesc: "As a melee touch attack for 6+level spell points, you can temporarily remove a creature from time altogether. The target creature must make a Fortitude dc 10+1/2 level + highest mental stat or vanish completely for a number of rounds equal to 1/2 your level (minimum 1 round). No magic or divinations can detect the creature during this time, as it exists outside of time and space—in effect, the creature ceases to exist for the duration of this ability. At the end of the duration, the creature reappears unharmed in the space it last occupied (or the nearest possible space, if the original space is now occupied).",
    },
    {
    rarity: "common",
    type: "magic",
    name: "Elemental Ray",
    fromClass: "Elemental Sorcerer",
    shortDesc: "Select one type of energy: acid, cold, electricity, or fire. Once this choice is made, it cannot be changed. For 2 spell points you can unleash an elemental ray as a standard action, targeting any foe within 30 feet as a ranged touch attack. This ray deals 1d6 + highest mental stat. Every three levels this increases by 1d6. This ray counts as casting a level 1 damage spell for all perks and feats that modify those, with a verbal and somatic component, and it scales with 200% spell power.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Elemental Blast",
    fromClass:"Elemental Sorcerer",
    shortDesc: "Select one type of energy: acid, cold, electricity, or fire. Once this choice is made, it cannot be changed. you can unleash a blast of elemental power for level x2 spell points. This 20-foot-radius burst does 1d6 points of damage of your energy type per level and scales with spell power. Those caught in the area of your blast receive a Reflex save for half damage. Creatures that fail their saves gain vulnerability to your energy type until the end of your next turn. The DC of this save is equal to 10 + 1/2 level + highest mental modifier. This ability has a range of 60 ft",
    },
    {
    rarity: "legendary",
    type: "universal",
    name: "Living Paradox",
    fromClass: "Impossible Sorcerer",
    shortDesc: "Your outward appearance remains the same, but beneath your skin lies not flesh and blood but clockwork gears, miniature galaxies, or something equally uncanny. You gain immunity to disease and poison. You take no additional damage from bleed effects, critical hits, and sneak attacks.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Arcane Ambush",
    fromClass:"Kobold Sorcerer",
    shortDesc: "As a swift action, you can expend a spell slot in order to grant you and your allies a bonus on attack and damage rolls. This bonus lasts 1 round, is equal to the level of the spell expended, and only applies to opponents your allies are flanking or opponents denied their Dexterity bonus against your allies. You grant this bonus to yourself plus up to one ally for every four sorcerer levels you possess. The allies must be within 30 feet of you and you must have line of effect to each affected ally.",
    },
    {
    rarity: "legendary",
    type: "universal",
    name: "Dual spirit",
    fromClass:"Possessed Sorcerer",
    shortDesc: "you gain immunity to mind-affecting effects. Whenever you successfully employ a possession effect (such as magic jar or possession), you remain in complete control of your body and the body of your possessed target.",
    },
    // {
    // rarity: "legendary",
    // type: "magic",
    // name: "True Thought Form",
    // shortDesc: `you can shed the restrictions of the flesh and become a thoughtform— a being that exists independently of its substance.
    
    // Whenever a creature would kill you, you can attempt to use mind swap against that creature as an immediate action just before dying, requiring the usual amount of spell points, if your body is restored to working condition you can return to your body by touching it as a full round action that provokes attacks of opportunity`,
    // },
    {
    rarity: "common",
    type: "magic",
    name: "Favorite Spell",
    shortDesc: `Choose 1 spell when you gain this perk. You can increase the max damage dice limit due to level of that spell by 5 levels. Every 8 levels you can change the spell selected. The spell suffers a 1% spell critical failure chance.`,
    },        
    {
    rarity: "common",
    type: "magic",
    name: "Overcharged Spell",
    shortDesc: `Choose 1 spell when you gain this perk, it gains 10 + level/2 spell power and spell critical power. The spell suffers a 1% spell critical failure chance.`,
    },        
    {
    rarity: "rare",
    type: "magic",
    name: "Potion Component",
    shortDesc: `While casting a spell, if you have a mnemonic potion in your hand, you can absorb the spell points from the potion, expending it and rolling for the restored spell points as normal, however they are instead added as temporary spell points that last rounds equal to the potions level. You do not gain any additional effects from the mnemonic potion such as spell point regeneration or restoration to your mental stats.`,
    },
    {
    rarity: "legendary",
    type: "magic",
    name: "Vortex of Flesh",
    fromClass:"Shapechanger Sorcerer",
    shortDesc: "For levelx2 spell points you can momentarily change into an amalgam of erratic geometric shapes, lashing out at every creature in a 15-foot-radius spread around you as a standard action. This attack deals 1d6 points of bludgeoning, 1d6 of piercing, and 1d6 slashing damage per 2 levels. If you benefit from a spell or effect that allows you to overcome damage resistance with your natural attacks (such as magic fang), this attack ignores DR of the same type. Those caught in the area can attempt a Reflex saving throw (DC = 10 + 1/2 level + your highest mental stat) for half damage",
    },
    {
        rarity: "rare",
        type: "magic",
        name: "Imbued Potions",
        shortDesc: "You can spend spell points equal to the level of the potion to cause a curative potions you drink or give to an ally have their effectiveness increased by your positive spell power.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Cognatogen",
    fromClass:"Alchemist",
    shortDesc: "For 6 + level*2 spell points you can create a mutagen-like mixture, and drink it as a standard action that provokes attacks of opportunity, and you can only have the effects of one cognatogen active at a time. The Cognatogen heightens one mental ability score at the expense of a physical ability score, giving +4 alchemical bonust to the mental score, and a -2 penalty to the physical score, as well as a +2 to natural armor. If the cognatogen enhances his Intelligence, it applies a penalty to his Strength. If it enhances his Wisdom, it applies a penalty to his Dexterity. If it enhances his Charisma, it applies a penalty to his Constitution. When you reach level 12 it now costs 12+level*3 spell points, but the bonuses increase to +6 to a mental score, +4 to another mental score, and +4 natural armor, but take a -2 to both associated physical stats. Once you reach level 20 the costs becomes 26+level*4 spell points, but you now gain +8 to a single mental score, +6 to a second, +4 to a third, and +6 natural armor, and a -2 to all physical stats. For a fourth selection gain +8 to all mental stats and natural armor, and -2 to all physical scores.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Ride the Lightning",
    fromClass:"Stormborn Sorcerer",
    shortDesc: "For 4 + level/2 spell points as a full-round action you can become a living lightning bolt and move in a straight line up to 10 times your speed. You do not provoke attacks of opportunity while moving in this way. Creatures or objects in your path are affected as by your a thunderbolt effect that deals 1d6 damage per level. Creatures in the area are allowed a reflex save dc 10+1/2 level + highest mental stat to halve the damage. This damage scales with 200% electricity spell power. Creatures do not block your movement but solid barriers do unless they are reduced to 0 hit points.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Lay On Hands",
    fromClass:"Paladin",
    shortDesc: "For 1 spell point per dice rolled you can heal 1d6 hit points of damage per odd level. Using this ability is a standard action, unless you targets yourself, in which case it is a swift action. Alternatively, you can use this healing power to deal damage to undead creatures the same amount. Using lay on hands in this way requires a successful melee touch attack and doesn't provoke an attack of opportunity. Undead do not receive a saving throw against this damage (dc=10+level/2 + highest mental). This scales with positive spell power.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Touch of Corruption",
    fromClass:"Antipaladin",
    shortDesc: "For 1 spell point per dice rolled you deal 1d6 hit points of negative energy damage per odd level. Using this ability is a standard action that requires a touch attack, unless you target yourself, in which case it is a swift action. Alternatively, you can use this power to heal undead creatures the same amount. Using touch of corruption in this way requires a successful melee touch attack and doesn't provoke an attack of opportunity. Living do not receive a saving throw against this damage. Touch of corruption can count as lay on hands for abilities that modify or require lay on hands. This scales with negative spell power.",
    },
    {
    rarity: "legendary",
    type: "universal",
    name: "Divine Grace",
    fromClass:"Paladin",
    shortDesc: "Gain a bonus equal to your highest mental stat modifier (if any) on all Saving Throws.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Force of Personality",
    abilityType:"Ex",
    fromClass:"Warlord",
    shortDesc: "Gain a bonus equal to your intelligence or charisma on will saving throws.",
    },        
    {
        rarity:"rare",
        type:"universal",
        name: "Evasion",
        abilityType:"Ex",
        shortDesc: "If you make a successful Reflex saving throw against an attack that normally deals half damage on a successful save, you instead take no damage. Evasion can be used only if you are wearing light or no armor, and you are not helpless. Gaining This perk additional times will grant the improved versions.",
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context)=>{
            let evasions = context.stats.lists.perks.filter(perk => perk.name == "Evasion")       
            if(evasions.length > 1){
                let evasions = context.stats.lists.perks.filter(perk => perk.name == "Improved Evasion")  
                if(evasions.length > 0){
                    evasions = context.stats.lists.perks.filter(perk => perk.name == "Greater Evasion")  
                    if(evasions.length > 0) context.stats.characterStats.misc.reflex += 4
                    let evasion = perks.filter(perk => perk.name == "Greater Evasion")[0]
                    evasions = context.stats.lists.perks.filter(perk => perk.name == "Evasion")
                    let specific = evasions[evasions.length-1]
                    specific.name = "Greater Evasion"
                    specific.shortDesc = evasion.shortDesc
                }
                else{
                    let evasion = perks.filter(perk => perk.name == "Improved Evasion")[0]
                    let evasions = context.stats.lists.perks.filter(perk => perk.name == "Evasion")
                    let specific = evasions[evasions.length-1]
                    specific.name = "Improved Evasion"
                    specific.shortDesc = evasion.shortDesc
                }
            }
        },
    },
    {
        rarity:"rare",
        type: "universal",
        name: "Improved Evasion",            
        shortDesc: "When making a reflex saving throw to avoid damage, you take half damage even if you fail the saving throw, and none of you succeed on the saving throw. You must not be helpess or wearing armor heavier than light to use this ability. Having this ability additional times instead will grant greater evasion.",
        prereq:"Evasion",
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context)=>{
            let evasions = context.stats.lists.perks.filter(perk => perk.name == "Improved Evasion")  
            if(evasions.length > 1){
                evasions = context.stats.lists.perks.filter(perk => perk.name == "Greater Evasion")  
                if(evasions.length > 0){
                    context.stats.characterStats.misc.reflex += 4
                }
                let evasion = perks.filter(perk => perk.name == "Greater Evasion")[0]
                evasions = context.stats.lists.perks.filter(perk => perk.name == "Improved Evasion")
                let specific = evasions[evasions.length-1]
                specific.name = "Greater Evasion"
                specific.shortDesc = evasion.shortDesc
            }
        },
    },
    {
        rarity:"rare",
        type: "universal",
        name: "Greater Evasion",            
        shortDesc: "When making a reflex save to avoid damage while wearing medium or heavier armor, if you pass the DC you take half damage, if you beat the DC by more than your armor check penalty, you take no damage. Having this ability additional times instead will grant a +4 to reflex saving throws.",
        prereq:"Improved Evasion",
        hasCustomMethod:true,
        customMethod:()=>{
        },
        catchUpMethod:(context)=>{
            let evasionCount = context.stats.lists.perks.filter(perk => perk.name == "Greater Evasion")            
            if(evasionCount.length > 1){
                context.stats.characterStats.misc.reflex += 4
            }
        },
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Divine Fortitude",
    shortDesc: "If you make a successful fortitude saving throw against an attack or ability that has a lessened effect from making that saving through you instead take no effect. If selected a second time take half effect even if you fail",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Counterstrike Expert",
    fromClass:"Hero Cavelier",
    shortDesc: "Monsters provoke attacks of opportunity for you when they activate extraordinary or supernatural abilities such as breathe weapons and gaze attacks. This does not include maneuvers. If you succesfully deal damage with this ability the monster must make a will save dc 10+level/2 + highest mental stat or the monster fails to activate that ability and loses that action. you can only use this ability once per monster",
    },
    {
    rarity: "epic",
    type: "universal",
    name: "Better You than Me",
    shortDesc: `The cavalier can interpose an adjacent ally in the way of an incoming attack as an immediate action, gaining cover against the attack. The attack must target only the cavalier, and she must choose to use this ability before seeing the result of the attack roll.
    the ally gains a Reflex save to negate this ability's effect entirely (DC = 10 + 1/2 level + the higher of your Strength modifier or Charisma modifier). If the attack hits, the damage is split evenly between the cavalier and the ally. If the ally's save was a natural 1, the ally takes all of the damage, including any associated effects (bleed, poison, etc.). An ally can purposefully fail this saving throw, but cannot purposefully roll a natural 1.`,
    },
    {
    rarity: "legendary",
    type: "universal",
    name: "Defenders Pact",
    fromClass:"Eel Cavalier",
    shortDesc: `An order of the eel cavalier can form a pact to share danger with an ally. As a full-round action, the cavalier enters into this pact with a willing creature
    \nThe cavalier and his partner each gain a deflection bonus to AC equal to the cavalier's Highest mental stat (minimum +1). A partner that takes damage from attacks and effects that deal hit point damage (including from special abilities) takes only half damage, and the other half of the damage is dealt to the other partner in the pact. Forms of harm that do not involve hit points, such as charm effects, ability score damage and drain, negative levels, and death effects, are not affected. If either partner in the pact suffers a reduction of hit points from a lowered Constitution score, the reduction is not split, as it is not hit point damage. This effect ends if the cavalier makes a new pact (at which point the existing pact immediately ends), if the partners in the pact move more than 1,000 feet apart, or if either partner in the pact takes a swift action to dissolve the partnership. Damage already divided is not reassigned when the pact ends.`,
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Defensive Focus",
    fromClass:"Warder",
    shortDesc: `You gain the combat reflexes feat and can use your highest mental stat to determine how many attacks of opportunity you can take. If you already have combat reflexes feat you gain another random martial feat`,
    hasCustomMethod:true,        
    customMethod:()=>{            
    },
    catchUpMethod:(context)=>{
        if(context.stats.lists.feats && context.stats.lists.feats.filter(feat=>feat.name=="Combat Reflexes").length > 0){
            context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{martial:true}}))
        }else{
            let feat = feats.filter(feat => feat.name == "Combat Reflexes")[0]
            context.stats.lists.feats.push(feat)
        }
    },
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Armiger's Mark",
    fromClass:"Warder",
    abilityType:"Ex",
    shortDesc: `For level/2 spell points when you damage an opponent with a melee attack you can chooce to place the armiger's mark on them, they gain -4 to attack any creature that isn't you for you highest mental stat rounds. Every 5 levels the penalty to attack the creature gains increases by 2. Arcane spellcasters that are marked suffer a 10% + 1% per 2 levels arcane spell failure chance.`,
    },
    {
    rarity: "rare",
    type: "utility",
    name: "Tactical Acumen",
    fromClass:"Warder",
    abilityType:"Ex",
    shortDesc: `You may add your highest mental stat as a bonus to reflex saves, and use your highest mental stat instead of dexterity when determining your initiative modifier.`,
    },
    {
        rarity: "common",
        type: "utility",
        name: "Optimistic Gambler",
        fromClass:"Trait",
        abilityType:"Ex",
        shortDesc: `Effects that grant you morale bonuses persist 1d4 rounds longer than they normally would.`,
    },
    {
        rarity: "common",
        type: "utility",
        name: "On the Payroll",
        abilityType:"Ex",
        shortDesc: `Gain 15 gold per level.`,
        hasCustomMethod:true,
        customMethod:(context)=>{
            context.stats.gold += 15
        },
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                context.stats.gold += 15
            }
        }
    },
    {
        rarity: "common",
        type: "utility",
        name: "Remembered Pocket",
        abilityType:"Ex",
        shortDesc: `Gain 150 gold.`,
        hasCustomMethod:true,
        customMethod:()=>{},
        catchUpMethod:(context)=>{
            context.stats.gold += 150
        }
    },
    {
        rarity: "common",
        type: "utility",
        name: "Community Minded",
        abilityType:"Ex",
        shortDesc: `Any morale bonuses you confer upon your allies through your own abilities or spells last 2 additional rounds.`,
    },
    {
    rarity: "common",
    type: "universal",
    name: "Clad in Steel",
    fromClass:"Warder",
    shortDesc: `You can reduce your armor check penalty and increase your max dex bonus on your armor by 1, this bonus increases every 4 levels`,
    },
    {
    rarity: "common",
    type: "universal",
    name: "Fast Movement",
    fromClass:"Barbarian",
    shortDesc: "Your base movement speed increase by 10 feet. At level 10 and 20 it increases by an additional 10 feet.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Unstoppable Ravager",
    fromClass:"Beast Cavelier",
    shortDesc: "When you drop below 0 hit points you do not fall unconcious but instead can act as if you were staggered each round. you can not make a stabilization check and take one point of damage as normal each round. you can spend 1 spell point a round to instead act normally, but you take 2 damage per round instead.",
    },
    {
    rarity: "common",
    type: "universal",
    name: "Hardy",
    fromClass:"Custom",
    shortDesc: "The amount of damage it takes to kill you increases to twice your constitution score.",
    },
    {
    rarity: "common",
    type: "universal",
    name: "Divine Health",
    fromClass:"Paladin",
    shortDesc: "You're immune to all diseases, including supernatural and magical diseases, including mummy rot.",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Gun Training",
    fromClass:"Gunslinger",
    shortDesc: "Reduce the reload action step of firearms and crossbows by one, and you can add your dexterity modifier to damage with them.",
    },
    {
    rarity: "epic",
    type: "universal",
    name: "Sidestep Secret",
    fromClass:"Lore Oracle",
    shortDesc: "You can use your highest mental stat instead of your dexterity modifier for determining your AC and CMD",
    },
    {
    rarity: "epic",
    type: "universal",
    name: "Sacrificial Exchange",
    fromClass:"Martyred Sorcerer",
    shortDesc: "For 6 spell points as a swift action, you can take 2 points of temporary ability damage to one of your ability scores and add a temporary +2 inherent bonus to any other ability score. This bonus lasts until you choose to prematurely dismiss it (a free action), during which time the temporary ability damage cannot be healed by any means. After this effect ends, you can heal the ability damage normally. at 8th level you can have two sacrifical exchanges going at once, but the second costs 12 spell points, at 16 you can have 3, but it costs 18 spell points, and at 20 you can have 4, but the 4th costs 24 spell points",
    },
    {
    rarity: "common",
    type: "universal",
    name: "Sacrificial Boon",
    fromClass:"Martyred Sorcerer",
    shortDesc: "As a free or immediate action but only once per turn, you can sacrifice 3 hit points and 1 spell point in exchange for a +1 sacred bonus on the next attack roll, damage roll, saving throw, or skill check you make. This bonus only applies as long as you use it by or during your next turn—otherwise both your sacrificed hit point and the bonus are wasted. at 4th and every 4 levels after you can spend an additional 2 hit points and spell points to increase the bonus by 1",        
    },        
    {
    rarity: "legendary",
    type: "universal",
    name: "Rebirth",
    fromClass:"Phoenix Sorcerer",
    shortDesc: "The full power of a phoenix erupts from within you if you perish. When you die, you are brought back to life, as true resurrection, after 6 rounds. This ability can be only used once per run.",
    },
    {
    rarity: "legendary",
    type: "universal",
    name: "Searing Heat",
    fromClass:"Salamander Sorcerer",
    shortDesc: "You deal 1d6 additional points of fire damage with natural weapons and melee attacks made with metal weapons. In addition, you deal 2d6 points of fire damage per round to any creature you grapple. This heat does not damage your equipment. You can activate or deactivate this effect as a free action.",
    },
    {
    rarity: "common",
    type: "universal",
    name: "Auspicious Mark",
    fromClass:"Barbarian",
    shortDesc: "For 2 spell points as a swift action, you can call upon the spirits' favor. Using auspicious mark grants a +1d6 bonus on one d20 roll you has just made. Every 6 levels, you can spend an additional 4 spell points to increase the bonus by 1d6.",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Abnormal Reach",
    fromClass: "Aberrant Bloodrager",
    shortDesc: "Your limbs elongate; your reach increases by 5 feet.",
    },        
    {
    rarity: "epic",
    type: "martial",
    name: "Defy Death",
    fromClass: "Destined Bloodrager",
    shortDesc: "Once per floor when an attack or spell that deals damage would result in your death, you can attempt a DC 20 Fortitude save. If you succeed, you are instead reduced to 1 hit point; if you succeed and already have less than 1 hit point, you instead take no damage.",
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Leaping Charger",
    fromClass: "Fey Bloodrager",
    shortDesc: "You are able to leap over overgrowth and similar impediments with ease while charging. When you charge, you ignore difficult terrain (but not other creatures). You can move through it at normal speed, and it does not impede your charge.",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Hellfire Charge",
    fromClass: "Infernal Bloodrager",
    shortDesc: "When you charge you deal an additional 1d6 points of fire damage, and you can ignore 10 fire resistance. Every 5 levels this increases by 1d6 and ignores 5 more fire resistance.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Sacrificial Blessing",
    fromClass: "Martyr Bloodrager",
    shortDesc: "As a swift action for 2 spell points, you can take a -4 penalty to Armor Class to grant one ally within 30 feet a +4 morale bonus to one ability score. This costs 1 spell point at the start of your turn each turn to maintain, and the target must remain within 30 feet of you at all times or the bonus ends. You can only have 1 sacrifical blessing active per 6 levels. At 10th level, the penalty this ability imposes changes to -6, and the ally's bonus increases to +6.",
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Counterstrike",
    fromClass: "Magus",
    shortDesc: "Whenever an enemy within reach of the magus successfully casts a spell defensively, that enemy provokes an attack of opportunity from the magus after the spell is complete. This attack of opportunity cannot disrupt the spell.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Eternal Martyr",
    fromClass: "Martyr Bloodrager",
    shortDesc: "Your ancestor's sacrifice transcends time and space, keeping you alive when you otherwise shouldn't be and sanctifying your form. Your ancestor's act of martyrdom infuses your spirit. You become immune to death effects. Spells and abilities that revive you give you 50% more hit points, even as temporary hit points if necessary. Your body cannot be turned into an undead creature, as though you were affected by a permanent hallow effect (caster level = your level)",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Body Fuel",
    fromClass: "Hemomancer",
    shortDesc: "You can consume your own body to regain spell points, as a swift action take 1 point of drain to your constitution to restore your highest mental score worth of spell points. this damage can't be cured through restoration, but you restore your highest mental stats/2 worth of constitution drain caused by this ability each time you descend a floor.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Blood Tap",
    fromClass: "Hemomancer",
    shortDesc: "You can consume your own vitality to regain spell points. Once per round as a free action you can take even when not your turn, you can take 1d12 points of damage to restore 2 spell points. Every odd level after 1st this damage increases by 1d12 and you regain 2 more spell points. This damage is unresistable and untransferable. Alternatively, you can activate this to gain a blood point.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Blazing Vitality",
    fromClass: "Phoenix Bloodrager",
    shortDesc: "When tensions run high and your emotions flare, you let forth waves of restorative energy from within. as a standard action for 1 spell point per round active you can emit a 10-foot-radius aura of energizing fire around you. Any ally that ends their turn within this aura gains a number of temporary hit points equal to your Constitution modifier. These temporary hit points last for 1 minute.",
    },   
    {
    rarity: "rare",
    type: "universal",
    name: "Blood Deflection",
    fromClass: "Steelblood Bloodrager",
    shortDesc: "As an immediate action a steelblood can sacrifice a spell slot to gain a deflection bonus to AC equal to the level of the spell sacrificed. The deflection bonus lasts until the start of his next turn. This ability can be applied after an attack roll is made against the steelblood, allowing the steelblood to convert a hit into a miss if the deflection bonus is high enough.",
    },  
    {
    rarity: "rare",
    type: "magic",
    name: "Ancient Tactics",
    fromClass: "Vestige Bloodrager",
    shortDesc: "Whenever you or an ally within 30 feet of you would gain a bonus on attack rolls or to AC due to battlefield position (such as flanking or cover), you can spend one spell point to increase it by +1 that lasts a full round. Allies must be able to see and hear you to gain this bonus. You can expend a spell slot as an immediate action to further increase this bonus by +1 per level of the spell slot expended until the beginning of your next turn.",
    },       
    {
    rarity: "rare",
    type: "magic",
    name: "Spell Conduit",
    fromClass: "Blood Conduit Bloodrager",
    shortDesc: "As long as a blood conduit is wearing light or no armor, he can deliver spells with a range of touch through bodily contact. When he succeeds at a combat maneuver check to bull rush, grapple, pin, reposition, or trip an opponent, or makes an unarmed strike against an enemy, he can as a swift action cast a touch spell on the creature that he affected with the combat maneuver, requiring no further touch attack roll. If this spell would usually require a successful touch attack, his successful combat maneuver check counts as this attack.",
    },  
    {
    rarity: "rare",
    type: "universal",
    name: "Spell Eater",
    fromClass: "Spell Eater Bloodrager",
    shortDesc: "A spelleater can consume spell slots for an extra dose of healing. As a swift action, the spelleater can consume one spell slot to heal 1d8 damage for each level of the spell slot consumed.",
    },  
    {
    rarity: "rare",
    type: "magic",
    name: "Dispelling Strikes",
    fromClass: "Phoenix Bloodrager",
    shortDesc: `When you confirm a critical hit against a target, you can also attempt to dispel the target as if you had cast dispel magic as a spell and used the targeted dispel function. You can dispel only a single magical effect per use of this ability, and you can use this ability against a particular creature only once per day.
    \nAt 8th level, you gain a +2 bonus on your dispel check when using this ability. At 18th level, you can attempt to dispel all magical effects on your target when using this ability.`,
    },
    {
    rarity: "epic",
    type: "universal",
    name: "Aura of Righteousness and Depravity",
    fromClass: "Paladin",
    shortDesc: `If you are good, you Gain DR 5/evil and immunity to compulsion spells and spell-like abilities. Each ally within 10 feet of her gains a +4 morale bonus on saving throws against compulsion effects. This ability functions only while the paladin is conscious, not if she is unconscious or dead.
    \nIf you are evil, you gain DR 5/good, and each enemy within 10 feet takes a -4 penalty on saving throws against compulsion effects.
    \nIf you are neutral, you choose one, and keep that for the rest of the game. This ability functions only while you are conscious.`,
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Metamagic Specialty",
    fromClass: "Custom",
    shortDesc: "When you gain this perk select a metamagic feat, reduce the level adjustment by 1 when applying it. You can change the chosen metamagic feat every 6 levels.",
    },
    {
    rarity: "common",
    type: "magic",
    name: "Spell Specialty",
    fromClass: "Custom",
    shortDesc: "When you gain this perk select a spell, reduce the level adjustment by 1 when applying it. If you add multiple metamagics to a spell it only applies to a single metamagic feat. You can change the chosen spell every 6 levels.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Heart of Flame",
    fromClass: "Phoenix Bloodrager",
    shortDesc: `You gain fire resistance 5.
    \nWhenever you are subjected to a magical healing effect from a cure spell, you regain 1 additional hit point per die rolled. At 8th level, your fire resistance increases to 10, and you regain 2 additional hit points per die rolled when you are healed by a cure spell or healing effect.`,
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Divine Bond",
    shortDesc: "When you gain this perk select a weapon. The selected weapon's enchantment bonus is increased by +1, this increases by +1 every 4 levels you have. You can change your bonded weapon for level/2 spell points as a standard action.",
    },        
    {
    rarity: "rare",
    type: "magic",
    name: "Trap Rune",
    shortDesc: "For 4 spell points as a standard action, you can sketch a single, nearly invisible magical rune on any 5-foot-square solid surface. When you create a rune, pick one of the following energy types: acid, cold, electricity, or fire. While the rune is active, the next creature other than you who steps on or touches the rune's area causes the rune to explode. The rune's explosion deals a number of points of energy damage equal to 1d8 + highest mental stat (scales 200% with spell power). This damage increases by 1d8 every 3 levels. A Reflex saving throw halves the damage (DC 10 + level/2 + your highest mental stat). The rune is considered a magical trap for the purpose of perceiving it or disabling it. The DC for both Perception and Disable Device checks is the same as the Reflex saving throw to halve the damage",
    },
    {
    rarity: "common",
    type: "magic",
    name: "Astral Warp",
    abilityType:"Sp",
    fromClass:"Astral Sorcerer",
    shortDesc: "For level/2 spell points as a standard action you can create a field within 30 feet that distorts time within a 5 foot cube, this field last highest mental stat rounds any creature that enters the field or starts their turn within the field takes 1d4 + highest mental stat force damage, but can make a fortitude save dc 10+ level/2 + highest mental stat. creatures within the field receive -1 ac and reflex save, and the area is considered difficult terrain, any ranged attack that passes through the square receives a -4 to attack rolls. Every 3 levels the damage of this ability increases by 1d4, they receieve an additional -1 to reflex and ac, and its range increases by 5 feet, and you can choose an additional square within range and adjacent to the original square to be affected by astral warp.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Arrest the Flow",
    fromClass:"Astral Sorcerer",
    shortDesc: "For level spell points as an immediate action you can attune yourself to the Astral's timeless nature to halt the effects of one condition or affliction (such as paralyzed, stunned, a poison, or a curse), including permanent and instantaneous conditions, until the end of your next turn. You can use this ability even when a condition or affliction would normally prevent you from doing so, regardless of whether you're targeting that prevention effect's source. At the end of your next turn the condition or affliction resumes its normal effect and the round delayed by this ability does not count toward the condition or affliction's duration. This ability has no effect on hit point damage, ability damage, or the dead condition. Alternatively, you can use this ability to extend the duration of any one effect affecting you until the end of your next turn; this does not extend the duration for any other creatures under the effect",
    },
    {
    rarity: "legendary",
    type: "magic",
    name: "Quicken Perk",
    fromClass:"Custom",
    shortDesc: "For 8 + level/2 spell points you can reduce the activation time of a magical perk by 1 step. Magical Perks that are usually a standard action become a movement, perks that are usually movement actions become swift actions. You cannot you activate this perk on another perk more than once, or use this perk multiple times on one round, unless you gain copies of this perk.",
    },        
    {
    rarity: "legendary",
    type: "magic",
    name: "Knowledge Burst",
    perkType:"Sp",
    fromClass:"Custom",
    shortDesc: "For level spell points as a full-round action you can fire a ranged touch attack with a range of 50 feet that deals 1d3 points of bludgeoning damage for every spell you know. This scales with universal spell power.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Warp Gate",
    abilityType:"Sp",
    fromClass:"Custom",
    shortDesc: "For level spell points as a standard action you can open a rift from one location to another, both rifts must be within 30 (+5 per 3 levels) feet of you. Rifts cover 5 foot squares and lasts highest mental stat rounds, Anything that enters into the rift appears from the other rift adjacent to it on the opposite side from where they entered the other rift from. Large or bigger creatures can squeeze around it to be unaffected. A creature gargantuan or larger cannot be affected by the rift. The rift is opaque, and you cannot see through it, nor can you put only part of yourself into the for longer than a round, however if you have a reach attack you can choose to strike through the rift, though any creature you strike has full concealment against you. likewise range weapons can be fired through the rift appearing on the other side the same way a creature would, striking the first target in the line of fire with a 50% miss chance as if they had total concealment. Any creature entering the square of the rift can make a will save dc 10+highest mental + level/2 to resist teleporting and instead can move through it as if it wasn't there, but if it starts its turn in the rift next turn it is automatically teleported. If you place a rift on top of a target they can make a reflex save dc 10+highest mental + level to avoid it and take a free 5 foot step that does not provoke attacks of opportunity, if they fail the reflex save they can still attempt a will save to not teleport, but they must leave the rift by the end of its next turn or it is teleported normally on a random side adjacent to the other rift. If a target is teleported against its will from either failing the will save or starting their turn in the rift they receive 1d6 per level force damage.",
    },
    {
    rarity: "common",
    type: "magic",
    name: "Heavenly Fire",
    fromClass:"Celestial Sorcerer",
    shortDesc: "You can fire a ray of heavenly fire as a standard action for 2 spell points at a target within 30 feet as a ranged touch attack, against evil creatures it deals 1d4+highest mental stat damage, and against good creatures it heals 1d4+highest mental stat damage, increasing by 1d4 every 3 levels. This doesnt affect neutral creatures. If the caster is evil this becomes a Hellish ray and instead heals evil creatures and damages good creatures. This scales with 200% fire spell power.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Wound Warp",
    fromClass:"Daemon Sorcerer",
    shortDesc: "As a standard action for level spell points you can teleport to an unoccupied square adjacent to any dead creature within 10 feet per level. Alternatively you can teleport to a creature immediately after it was killed as long as its still within range as an immediate action for level/2 spell points, and if it was a creature you just killed you can teleport to it for level/4. Any creature adjacent to the square you teleported to takes 1d6 points of acid damage per level, they can make a reflex save dc 10+level/2 + highest mental stat for half damage.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Stylish Teleport",
    fromClass:"Daemon Sorcerer",
    shortDesc: "Whenever you use any kind of teleportation effect that moves you from one location to another you can cause an explosion to appear where you teleport. All creatures adjacent to the square you teleport to take 1d6 points of fire damage, +1d6 every 4 levels, they may make a reflex save dc= 10+level/2 + highest mental stat for half damage. This ability can only activate once per round.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Destiny Realized",
    fromClass:"Destined Sorcerer",
    shortDesc: "Critical hits against you only confirm if the confirmation roll is a natural 20, any critical hits you threaten with a spell automatically confirm. For level spell points as an immediate action you can cause a spell to automatically succeed any concentration check",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Monstrous Size",
    fromClass:"",
    shortDesc: "You grow one size larger, this doesn't increase your ability scores, but your size does grant a +1 to CMB and CMD, increases the damage of your weapon and natural attacks by 1 size step, and increases your reach, but a gives a -1 to attack and AC, and a -2 to fly and -4 to stealth. (These changes assume you are going from small to medium, or medium to large, larger creatures may gain even higher bonuses).",
    },
    {
    rarity: "common",
    type: "magic",
    name: "Soul Devourer",
    fromClass:"Sorcerer",
    shortDesc: "Whenever you defeat a creature, the DC of all of your spell increases by 2 until the end of your next turn, this stacks. At level 8, the DC increases by 2 for 1 round, and 1 for 1 round after. At level 16, the DC increases by 3 for 1 round, 2 for 1 round after, and 1 for one round after that.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Fleeting Glance",
    fromClass:"Fey Sorcerer",
    shortDesc: "As a movement action for 6 spell points you can cause yourself to become invisible for 1 round as if the spell 'Greater Invisibility'. Each turn as a free action you can spend an additional 3 spell points to keep the effect going",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Mage's Mansion",
    fromClass:"Custom",
    shortDesc: "When entering a new Floor, the party restores their level in hp + your highest mental stat, and also gains the ability to drink a single potion, use a piece of gear, or cast a single spell, this spell carries over to the next floor. This effect doesn't happen when entering pseudo floors such as treasure vaults or store floors.",
    },
    {
        rarity: "common",
        type: "universal",
        name: "Wings",
        fromClass:"Alchemist",
        abilityType:"Ex",
        shortDesc: "You gain bat-like, bird-like, or insect-like functional wings, allowing you to fly as the fly spell for a number of rounds per day equal to your level. These rounds do not need to be consecutive, but they must be spent in 1-round increments."
    },
    {
    rarity: "common",
    type: "universal",
    name: "Heroic Soul",
    fromClass:"Imperious Sorcerer",
    abilityType:"Su",
    shortDesc: "Whenever you receive a morale bonus it is increased by +1. This bonus increases by +1 every 10 levels.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Heroic Echo",
    fromClass:"Imperious Sorcerer",
    abilityType:"Su",
    shortDesc: "Whenever you receive a morale bonus from a spell, spell like ability, or magic item, it is increased by +1. This bonus increases by +1 every 8 levels. At level 8 this also applies to competence bonuses (from the same sources). If you receive a morale effect (or a competence effect at 8th level) that affects an area or multiple targets, as an immediate action for level spell points you can share your increased bonus with all other recipients. This increase to other participants lasts a number of rounds equal to your highest mental.",
    },
    {
    rarity: "legendary",
    type: "universal",
    name: "Heroic Legends",
    fromClass:"Imperious Sorcerer",
    abilityType:"Su",
    shortDesc: `You can expend a spell slot as a swift or move action to inspire your allies, you can choose to either inspire greatness, or inspire heroics (as the bardic performance), which lasts rounds equal to the spell slot used.
    \nInspire Heroics: You inspire tremendous heroism in yourself or a single ally within 30 feet. For every 10 levels you have, you can can inspire heroics in one additional creature. To inspire heroics, all of the targets must be able to see and hear the bard. Inspired creatures gain a +4 morale bonus on saving throws and a +4 dodge bonus to AC. The inspired creature loses this bonus if it can no longer see the bard. Inspire heroics is a mind-affecting ability that relies on audible and visual components.
    \nInspire Greatness You can use your performance to inspire greatness in yourself or a single willing ally within 30 feet, granting extra fighting capability. For every 8 levels, you can target one additional ally while using this performance. To inspire greatness, all of the targets must be able to see and hear the bard. A creature inspired with greatness gains 2d10 + 2x the targets con mod in temporary hit points, a +2 competence bonus on attack rolls, and a +1 competence bonus on Fortitude saves. The target also counts as having 2 extra hit dice for hit dice dependant effects. Inspire greatness is a mind-affecting ability and it relies on audible and visual components.`,
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Long Limbs",
    fromClass:"Aberrant Sorcerer",
    abilityType:"Ex",
    shortDesc: "Your reach increases by 5 feet whenever you are making a melee touch attack. This ability does not otherwise increase your threatened area. At 9th level, this bonus to your reach increases to 10 feet. At 15th level, this bonus to your reach increases to 15 feet.",
    },
    {
    rarity: "epic",
    type: "universal",
    name: "Unusual Anatomy",
    fromClass:"Aberrant Sorcerer",
    abilityType:"Ex",
    shortDesc: "Your anatomy changes, giving you a 25% chance to ignore any critical hit or sneak attack scored against you. This chance increases to 50% at 12th level, if you have another source of fortification this does not stack, but does increase it by 10%, and 20% at level 12.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Abyssal Summonings",
    fromClass:"Abyssal Sorcerer",
    abilityType:"Su",
    shortDesc: "Whenever you summon a creature with the demon subtype or the fiendish template using a summon monster spell, you summon one additional creature of the same kind, and it gains DR/good equal to half your level. This DR does not stack with any DR the creature might have.",
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Strength of the Abyss",
    fromClass:"Abyssal Sorcerer",
    abilityType:"Ex",
    shortDesc: "As a swift action you can expend a spell slot to gain half the spells level (minimum 0) as an inherent bonus to your strength for rounds equal to half your highest mental modifier.",
    },
    {
    rarity: "legendary",
    type: "universal",
    name: "Aberrant Form",
    fromClass:"Aberrant Sorcerer",
    abilityType:"Ex",
    shortDesc: "Your body becomes truly unnatural. You gain 50% chance to ignore critical hits and sneak attacks, if you have another source of fortification this does not stack, but does increase it by 20%. In addition, you gain blindsight with a range of 60 feet and damage reduction 5/—.",
    },
    {
    rarity: "common",
    type: "magic",
    name: "Metamagic Empowerment",
    fromClass:"Arcane Sorcerer",
    abilityType:"Ex",
    shortDesc: "Whenever you apply a metamagic feat to a spell that increases the slot used by at least one level, increase the spell's DC by +1, and it gains 10 spell power. This bonus does stack with itself (if using multiple metamagic feats) but does not apply to spells modified by the Heighten Spell feat.",
    },
    {
    rarity: "legendary",
    type: "magic",
    name: "Arcane Apotheosis",
    fromClass:"Arcane Sorcerer",
    abilityType:"Ex",
    shortDesc: "You can add any metamagic feats that you know to your spells without increasing their casting time, although you must still expend higher-level spell slots, however lower the level adjustment of all metamagic feats by 1. All wonderous items that uses charges have double the amount of charges.",
    },
    {
    rarity: "common",
    type: "magic",
    name: "Astral Empowerment",
    fromClass:"Astral Sorcerer",
    abilityType:"Ex",
    shortDesc: "When you cast a spell, you can choose to enhance the next spell you cast before the end of your next turn, increasing the enhanced spell's saving throw DC by 1 and giving it 5 spell power for each level lower than the activating spell it is. This doesn't apply if the activating spell is modified by a metamagic feat.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Extreme Emotions",
    fromClass:"Custom",
    shortDesc: "Morale bonuses now stack on you as long as they come from different sources, but for each morale effect currently affecting you, you take a -2 to will saves, and this penalty is doubled against emotion and fear effects.",
    },
    {
    rarity: "common",
    type: "universal",
    name: "Take Your Best Shot",
    fromClass:"Imperious Sorcerer",
    shortDesc: "if you are targeted by a harmful spell, spell-like ability, or supernatural ability and suffer no harm from it, whether because of a successful saving throw, spell resistance, the attack missing, or some other protection, as an immediate action you can make an Intimidate check to demoralize the creature that produced the effect, but only if the creature that used the harmful effect is within 30 feet and can clearly see and hear you. If you gain this perk a second time you can also attempt to intimidate a creature when you make a successful saving throw against an ability it used, and increase the range to 60 feet",
    },
    {
    rarity: "common",
    type: "universal",
    name: "Oni Healing",
    fromClass:"Oni Sorcerer",
    shortDesc: "If you are reduced below 0 hit points you automatically stabilize and gain fast healing 2. The fast healing increases by 1 every 5 levels.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Patch Up",
    fromClass:"Custom",
    shortDesc: "When you descend a floor you can roll a heal check, you can heal that many hit points to your party divided among them. If your check exceeds 20 and for each interval of 5 above that they also restore 1 point of temporary ability score damage also divided among them.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Night Eye",
    fromClass:"Custom",
    shortDesc: "You gain darkvision, allowing you to see 50% further in dark conditions, and see through total darkness (but not magical darkness) to a range of 30 feet. Each time you get this perk (or if you have darkvision) increase the distance you can see in darkness by additional 50% or distance you dont suffer a miss chance by 30 feet.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Star Eye",
    fromClass:"Custom",
    shortDesc: "You gain low-light vision, allowing you to see 50% further in low-light conditions, and in low-light conditions you wont suffer a miss chance if its within 30 feet. Each time you get this perk (or if you have lowlight vision) increase the distance you can see in lowlight an additional 50% or distance you dont suffer a miss chance by 30 feet.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Spell Portal",
    shortDesc: `Whenever you cast a spell with the damaging or control type that effects an area and at least one other hostile creature you can spend spells level spell points as a swift action to teleport to an empty space within 25(+5 per level/2 ) feet that is within the area of spells effect. This spell automatically effects you, however you gain +4 to all rolls associated with resisting the spell.`,
    },
    {
    rarity: "legendary",
    type: "magic",
    name: "Spell Twist",
    shortDesc: `When you cast a spell that requires either a reflex, will, or fortitude save you can increase the cost of the spell by x2, plus your level to change the save required by the spell to a different save type. The spell for all purposes now effects the new save type, including immunities for a specific save type, but all of the tags assosciated with the spell stay the same. If a spell includes multiple saves you choose only one to be modified to a new type.`,
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Infuse Spell",
    shortDesc: "You can cast harmless spells with a range of personal as a touch spell instead, but only on willing creatures. This increases the cost of the spell by 100%, and spells cast this way are always affected by spell resistance.",
    },
    {
        rarity: "epic",
        type: "magic",
        name: "Spell Dance",
        fromClass:"Spell Dancer Magus",
        shortDesc: `You can expend level spell points as a swift action enter spell dance for 5 rounds. During it, you gain a +10 foot enhancement bonus to your movement speed and a +2 dodge bonus to armor class against attacks of opportunity provoked by moving through threatened spaces. For every 4 levels the bonus movement speed and dodge bonus to AC increases by 1 increment.
        \nAt level 4, once per spell dance as a swift action for 6 spell points you can affect yourself with one of the following spells: displacement, fly, haste. This spell only lasts 1 round. Every 4 levels you can affect yourself with an additional spell during the duration as a swift action, but it must always be a different spell than previously cast.
        \nAt level 8, you add dimensional door(self only) for 8 spell points to the list of spells you can affect yourself with once per spell dance.
        \nAt level 12 you add freedom of movement for 8 spell points to the list of spells you can affect yourself with once per spell dance, and non-instantaneous spells from spell dance instead lasts 1d3 rounds.
        \nAt level 16, when you activate spell dance you can choose any level 5 or lower spell to be added to the list of spells you can cast for the rest of the activation of spell dance. This spell must be a spell that can target you, and only effects you, even if it would affect other creatures.`,
        rateUp:"Elf"
    },
    {
        rarity: "epic",
        type: "universal",
        name: "Break Free",
        fromClass:"Tetori Monk",
        abilityType:"Ex",
        shortDesc: `You may add your level on combat maneuer or escape artists checks made to escape a grapple. If you fail a save against an effect that causes you to become entangled, paralyzed, slowed, or staggered, you may spend level spell points as an immediate action to attempt a new save.`,
    },
    {
        rarity: "epic",
        type: "martial",
        name: "Counter-Grapple",
        fromClass:"Tetori Monk",
        abilityType:"Ex",
        shortDesc: `You may make an attack of opportunity against a creature attempting to grapple you as long as they do not have the greater grapple feat. At 4th level you may use counter-grapple even if your attacker has concealment or total concealment. At 8th level you can use it even if you are flat-footed. At 12th level you can use it even if your attacker is not within your reach.`,
    },
    {
        rarity: "common",
        type: "martial",
        name: "Graceful Grappler",
        fromClass:"Tetori Monk",
        abilityType:"Ex",
        shortDesc: `You can use your level instead of your bab when determining your CMB and CMD for grapple checks. Additionally, you suffer no penalties on attack rolls, can make attacks of opportunity while grappling, and retain your Dexterity bonus to AC when pinning an opponent or when grappled.`,
    },        
    {
        rarity: "rare",
        type: "martial",
        name: "Grabbing Grappler",
        fromClass:"Tetori Monk",
        abilityType:"Ex",
        shortDesc: `You can spend level spell points to gain the grab special attack when using unarmed strikes for 1 round. You can use this ability against creatures your own size or smaller. Alternatively, you can instead increase the cost to levelx2 spell points to use it against creatures larger than you.`,
        rateUp:"Graceful Grappler"
    },
    {
        rarity: "legendary",
        type: "martial",
        name: "Crushing Grappler",
        fromClass:"Tetori Monk",
        abilityType:"Ex",
        shortDesc: `You gain the constrict special attack, inflicting your unarmed strike damage on any successful grapple check.`,
        rateUp:"Graceful Grappler"
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Inescapable Grasp",
        fromClass:"Tetori Monk",
        abilityType:"Su",
        shortDesc: `You can spend level spell points as a swift action to cause your grapples to become inescapable until the beginning of your next turn. This allows you to ignore the benefits of freedom of movement when making grapple checks. Additionally, during this duration, creatures trying to escape from being grappled by you lose any magical bonuses to Escape Artist or on checks to escape a grapple (including from freedom of movements), and they are affected as per the planar anchor spell. During the duration your body also gains the ghost touch ability for making grapple checks against ghosts.`,
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Dirty Blow",
        fromClass:"Wildcat",
        abilityType:"Ex",
        shortDesc: `When you succeed at a dirty trick combat maneuver, you can deal your unarmed strike damage to that opponent.`,
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Turn the Tables",
        fromClass:"Wildcat Monk",
        abilityType:"Ex",
        shortDesc: `Opponents provoke an attack of opportunity from you whenever they fail at a combat maneuver against the you.`,
    },
    {
        rarity: "epic",
        type: "martial",
        name: "Tangling Grasp",
        fromClass:"Tetori Monk",
        abilityType:"Su",
        shortDesc: `You can spend level spell points as a swift action to cause your unarmed strikes to cause creatures to gain the grappled condition until the start of your next turn (Reflex negates, DC 10 + 1/2 level + highest mental modifier).`,
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Healing Flame",
    fromClass:"Pheonix Sorcerer",
    shortDesc: "You can choose to cause a fire spell to instead heal instead of dealing fire damage. Any living creature affected heals for half the fire damage the spell would deal. You can choose whether the spell's damage scales with positive spell power or fire spell power.",
    },
    {
    rarity: "common",
    type: "magic",
    name: "Unicorn Barrier",
    fromClass:"Custom",
    shortDesc: "Whenever you cast a spell with the damage type that immediately deals damage you gain temporary hit points equal to the number of damage dice rolled for the spell. These temporary hit points don't stack with themselves, but do stack with other temporary hit points as normal.",
    },
    {
        rarity: "common",
        type: "magic",
        name: "Unicorn Deflection",
        fromClass:"Custom",
        shortDesc: "Whenever you cast a spell that prevents damage with damage reduction, temporary hit points, energy resistance, or a similar effect, if the attacking creature is within 30 feet of the protected creature, the foe takes 1d6 points of damage for every 10 points negated. This is untyped damage.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Elemental Variation",
    fromClass:"Sorcerer",
    shortDesc: "choose between fire, electricity, cold, and acid when you select this perk. Whenever you cast a spell that deals a different elemental damage you can change it to instead deal your chosen element, and when you do this increase its casted level by 1.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Unicorn Love",
    fromClass:"Unicorn Sorcerer",
    shortDesc: "Whenever you cast a spell or use a magical perk that uses spell points you can heal a target within 30 feet for the spell point cost. If you use an ability that modifies the cost of that magical perk or spell you can choose to use the unmodified cost or the modified cost, your choice. This magical healing doesn't stabilize dying creatures. All healing given in a round to a specific creature counts as one instance of healing.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Unicorn Scorn",
    fromClass:"Custom",
    shortDesc: "Whenever you cast a spell or use a magical perk that uses spell points you can damage a target within 30 feet for the spell point cost. If you use an ability that modifies the cost of that magical perk or spell you can choose to use the unmodified cost or the modified cost, your choice. You can only use the effects of this perk once per round.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Unicorn Curse",
    fromClass:"Custom",
    shortDesc: "Whenever you cast a spell of the control type you can reduce the attack of a target within 30 feet by the spells level for its next attack within highest mental stat rounds.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Mnemonic Healing",
    fromClass:"Custom",
    shortDesc: "Whenever you cast a spell of the healing type you grant any creatures healed by it temporary spell points equal to the level of the spell that lasts until the start of your next turn. A creature cannot gain spell points like this more than once per spell.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Unicorn Shift",
    fromClass:"Custom",
    shortDesc: "Whenever you cast a spell of the utility type choose one willing teammate within 60 feet, they can move 5 feet, this movement does not provoke attacks of opportunity. If your spell is level 4 or above they can instead move 10 feet, and if its level 8 or above they can move 15 feet.",
    },
    {
    rarity: "legendary",
    type: "magic",
    name: "Weal and Woe",
    fromClass:"Custom",
    shortDesc: "Whenever you cast a spell of the buff or healing type choose one creature within 50 feet, they receive a penalty on their next saving throw before your next turn equal to the level of the spell/2 (minimum 1). You can only use this affect once per turn, and it doesn't stack.",
    },
    {
    rarity: "legendary",
    type: "magic",
    name: "Overflowing Aura",
    fromClass:"Custom",
    shortDesc: "Once per turn when you cast a spell or a use a magical perk that costs spell points you can increase the cost of it by 50% and gain a deflection bonus to your AC for 1 round equal to half the spell point cost of the ability before it was modified by this ability.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Inspiring Buffer",
    fromClass:"Custom",
    shortDesc: "Whenever you cast a spell of the buff type increase any numerical modifier from that spell by 1. If a spell grants multiple numerical bonuses choose only 1 to be improved. Each 8 levels increase the additional bonus granted by this by 1.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Arcane Inspiration",
    fromClass:"Custom",
    shortDesc: "Whenever you cast a spell of the buff type on an ally, the ally's next spell before the start of your next turn has its DC increased by 1/2 the level of the buff spell cast (minimum 1).",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Unicorn Inspiration",
    fromClass:"Custom",
    shortDesc: "Whenever you cast a spell of the damage type, choose one teammate within 50 feet, they gain a morale bonus on their next attack roll within highest mental stat rounds equal to the level of the spell.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Unicorn Destruction",
    fromClass:"Custom",
    shortDesc: "Whenever you cast a spell of the damage type choose one teammate within 50 feet, they gain a morale bonus on their next damage roll within highest mental stat rounds equal to 2x the level of the spell. If the damage spell is of a particular element you can choose to make this deal 3x the spells level of damage and it becomes damage of the element of the spell, however it is not multiplied on critical hits.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Unicorn Party",
    fromClass:"Custom",
    shortDesc: "Whenever you cast a spell of the buff type, all affected allies gain a bonus to their next damage roll equal to the level of the spell within highest mental stat rounds, and for 1 round they gain +5 feet of movement speed for every 2 levels of the spell.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Expose Weakness",
    fromClass:"Custom",
    shortDesc: "Whenever you cast a spell of the control type, all affected creatures gain a penalty to their armor class equal to the level of the spell for the next attack against them within highest mental stat rounds, or the duration of the spell, whichever is shorter.",
    },          
    {
    rarity: "rare",
    type: "magic",
    name: "Energy Reversal",
    fromClass:"Custom",
    shortDesc: "Whenever you cast a spell that heals hitpoints with positive energy, you can instead cause it to deal damage as if it were negative energy. When you cast a spell that deals damage with negative energy, you can cause it to instead heal as if it were positive energy. Either of these effects increases the cost of the spell by 1 spell point per level of the spell cast.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Capitalize Weakness",
    fromClass:"Custom",
    shortDesc: "Whenever you cast a spell that deals bonus damage because a target is vulnerable to that damage type it takes 75% bonus damage instead of the normal 50%",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Unicorn Blessing",
    fromClass:"Custom",
    shortDesc: "Whenever you cast a healing or buff spell, the affected creatures receive a sacred bonus to their next save within your highest mental stat rounds equal to the level of the spell cast.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Unicorn Shield",
    fromClass:"Custom",
    shortDesc: "Whenever you cast a healing or buff spell, the affected creatures receive a deflection bonus to their armor class equal to 1/2 the level of the spell cast for attacks against them equal to your highest mental stat (or until round equal to the level of the spell cast).",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Unicorn Lord",
    fromClass:"Custom",
    shortDesc: "Double the effects (but not duration) of any perk that has unicorn in its name.",
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Elemental Channeling",
    fromClass:"Custom",
    shortDesc: "When you cast a spell that deals elemental damage, you can choose a weapon within 30 feet, that weapon deals 1d6 damage of the elemental type for the spells level attacks. For every 50 spell power of that element you have, it deals an additional 1d6.",
    },
    {
    rarity: "legendary",
    type: "magic",
    name: "Impenetrable Defenses",
    fromClass:"Custom",
    shortDesc: "Your deflection modifiers to armor class stack as long as they come from different sources. For example: two shields of faith wouldn't stack even if they are from two different casters. However, if you have a deflection bonus from smite evil and from another affect that gives highest mental to deflection or a shield of faith spell they stack. You lose spell points equal to 2x the amount of deflection modifiers you have active on you at the start of each of your turns. If you do not have enough spell points to maintain it, only the highest deflection modifier counts.",
    },
    {
        rarity: "epic",
        type: "magic",
        name: "Incredible Focus",
        fromClass:"Custom",
        shortDesc: `You can spend level/2 spell points to reduce the action to concentrate on a spell by 1 action type (full-round -> standard -> movement -> swift -> free). You can only activate this perk once per turn (unless you have it multiple times).`,
    },
    {
    rarity: "epic",
    type: "magic",
    name: "Yeehaw",
    abilityType:"Su",
    fromClass:"Eric",
    shortDesc: "For 3 spell points as a standard action you can cause all allies within 30 feet to gain +2 sacred bonus (or profane if you're evil) to attack, AC, skill checks, and CMD for 1 round. You can cast this as a movement action for 10 spell points",
    },
    {
    rarity: "legendary",
    type: "magic",
    name: "Prepared Spells",
    fromClass:"Custom",
    shortDesc: "Before entering a new floor you can cast 2 spells + 1 every 6 levels, and each costs +50% spell points, but delaying the effects of the spell. Then while on the next floor you can cast all of them as a full round action limited by the regular limitations of the spells cast. All of the prepared spells must have a casting time of a standard action or shorter, and you cannot prepare a spell more than a single time. Each spell doesn't need to succeed a concentration (or combat casting) check, but if you need to make one consider the spell level equal to the highest level of the spell cast, then add +2 to the dc for each additional spell prepared. You must make all choices related to the spells such as metamagic feats or element choice for resist energy before hand, but you can choose the targets when activating the ability. Each individual spell still provokes individually.",
    },
    {
        rarity: "legendary",
        type: "magic",
        name: "Spell Synthesis",
        fromClass:"Mystic Theurge",
        shortDesc: "You can cast 2 spells at once as apart of the same full-round action. Each spell must have a casting time of a standard action or less, not share any spell types, and one of the spells has its DC determined by your second highest mental score. You can make any decisions concerning the spells independently. Any target affected by both of the spells takes a -2 penalty on saves made against each spell. Using this ability costs 3x your level spell points, on top of the cost of each spell, and you cannot cast spells of the highest spell slot you know.",
    },
    {
        rarity: "rare",
        type: "magic",
        name: "Arcane Devastation",
        fromClass:"Custom",
        shortDesc: "Gain 20% universal spell critical power. Every level this increases by 1%",
        hasCustomMethod:true,
        customMethod:(context)=>{
            context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 1
        },
        catchUpMethod:(context)=>{
            context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 20
            context.stats.characterStats.spellMastery.spellCriticalDamage.universal += context.stats.characterStats.misc.level
        }
    },
    {
        rarity: "rare",
        type: "magic",
        name: "Arcane Precision",
        fromClass:"Custom",
        shortDesc: "You gain a 2% universal spell critical chance. Every 4 levels this increases by 1%",
        hasCustomMethod:true,
        customMethod:(context)=>{
            if(context.stats.characterStats.misc.level % 4 == 0){
                context.stats.characterStats.spellMastery.spellCriticalChance.universal += 1
            }
        },
        catchUpMethod:(context)=>{
            context.stats.characterStats.spellMastery.spellCriticalChance.universal += 2
            for(let i = 0; i < context.stats.characterStats.misc.level; i++){
                if(i % 4 == 0){
                    context.stats.characterStats.spellMastery.spellCriticalChance.universal += 1
                }
            }
        }
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Magical Aim",
    fromClass:"Sorcerer",
    shortDesc: "When making an attack with a ray or magical armament, you can use highest mental ability score in place of your dexterity score to determine your attack modifier.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Divine Demand",
    fromClass:"Hubris Cleric",
    abilityType:"Su",
    shortDesc: `Activating this ability is a swift action that you must use as you cast a spell that has a reduced (but not negated) effect on a successful save. The saving throw DC of the spell increases by 2, +1 every 5 levels.
    Any creature that succeeds at the saving throw instead avoids the effect entirely. If half or more of the targets are unaffected, you become shaken for a number of rounds equal to the spell's level. If all of the targets are unaffected, you instead lose the ability to cast spells or use magical perks for 1d4+1 rounds; you can end this loss by loudly apologizing to your patron deity as a full-round action that provokes attacks of opportunity.`,
    },
    {
    rarity: "common",
    type: "magic",
    name: "Pain Caster",
    fromClass:"Hemomancer",
    shortDesc: "Whenever you take damage except from something you caused, your effective caster level for spells and magical perks is increased by 1 for 1 round (except perks that increase your caster level), this stacks to a maximum of 1, +1 for every 4 levels you have.",
    },
    {
        rarity: "legendary",
        type: "magic",
        name: "True Pain Casting",
        fromClass:"Hemomancer",
        shortDesc: "When you take damage, you can as an immediate action channel the power of your pain into your spellcasting. This costs level x2 spell points. Your next spell within 1 round gains a profane bonus to its spell power equal to 1/4 the damage taken.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Unbreakable Focus",
    fromClass:"Hemomancer",
    shortDesc: "You do not need to succeed at concentration checks to cast spells when you take damage.",
    },
    {
        rarity: "common",
        type: "magic",
        name: "Draconic Magic",
        fromClass:"Sorcerer",
        shortDesc: "When you gain this perk choose an element (fire, cold, acid, electricity), whenever you cast a spell that deals damage of that element, the spell gains 10 spell power, and increase its DC by +1.",
        hasCustomMethod:true,
        typeChosen:"",
        customMethod:(context)=>{
            context.doNothing = "doNothing"
        },
        catchUpMethod:(context,_,contextSelf)=>{
            let options = ["fire", "cold", "electricity", "acid", "positive", "negative"]
            let choices = []
            for(let x = 0; x < options.length; x++){
                choices[x] = {
                    title:options[x],
                    id:x,
                    method:(() =>{
                        contextSelf.typeChosen = options[x]
                        contextSelf.shortDesc += `\n\nChosen Type: ` + options[x]
                        context.stats.characterStats.spellMastery.spellPower[options[x]] += 10
                    })
                }
            }   
            let custom = {title:"Draconic Magic Element Choice", options:choices}
            context.customDialogArray.push(custom)
        }
    },
    {
        rarity: "rare",
        type: "magic",
        name: "Blood Havoc",
        fromClass:"Sorcerer",
        shortDesc: "When you gain this perk, choose a spell type (fire, cold, electricity, acid, positive, negative). Gain 10 + 1 per 2 levels spell power, and 10% spell critical power of the type chosen.",
        hasCustomMethod:true,
        typeChosen:"",
        customMethod:(context,_,contextSelf)=>{
            if(context.stats.characterStats.misc.level % 2 == 0){
                context.stats.characterStats.spellMastery.spellPower[contextSelf.typeChosen] += 1
            }
        },
        catchUpMethod:(context,_,contextSelf)=>{
            let options = ["fire", "cold", "electricity", "acid", "positive", "negative"]
            let choices = []
            for(let x = 0; x < options.length; x++){
                choices[x] = {
                    title:options[x],
                    id:x,
                    method:(() =>{
                        contextSelf.typeChosen = options[x]
                        contextSelf.shortDesc += `\n\nChosen Type: ` + options[x]
                        context.stats.characterStats.spellMastery.spellPower[options[x]] += 10 + Math.floor(context.stats.characterStats.misc.level/2)
                        context.stats.characterStats.spellMastery.spellCriticalDamage[options[x]] += 10
                    })
                }
            }   
            let custom = {title:"Blood Havoc Element Choice", options:choices}
            context.customDialogArray.push(custom)
        }
    },  
    {
    rarity: "epic",
    type: "magic",
    name: "Extreme Blood Havoc",
    fromClass:"Sorcerer",
    shortDesc: "When you gain this perk, choose a spell type (fire, cold, electricity, acid, positive, negative). Gain 10 + 1 per level spell power, and 20% spell critical power of the type chosen.",
    hasCustomMethod:true,
    typeChosen:"",
    customMethod:(context,_,contextSelf)=>{
        context.stats.characterStats.spellMastery.spellPower[contextSelf.typeChosen] += 1
    },
    catchUpMethod:(context,_,contextSelf)=>{
        let options = ["fire", "cold", "electricity", "acid", "positive", "negative"]
        let choices = []
        for(let x = 0; x < options.length; x++){
            choices[x] = {
                title:options[x],
                id:x,
                method:(() =>{
                    contextSelf.typeChosen = options[x]
                    contextSelf.shortDesc += `\n\nChosen Type: ` + options[x]
                    context.stats.characterStats.spellMastery.spellPower[options[x]] += 10 + context.stats.characterStats.misc.level
                    context.stats.characterStats.spellMastery.spellCriticalDamage[options[x]] += 20
                })
            }
        }   
        let custom = {title:"Blood Havoc Element Choice", options:choices}
        context.customDialogArray.push(custom)
    }
    },        
    {
        rarity: "legendary",
        type: "magic",
        name: "Complete Havoc",
        fromClass:"Sorcerer",
        shortDesc: "When you gain this perk, choose a spell type (fire, cold, electricity, acid, positive, negative). Gain 15 + 2 per level spell power, and 25% spell critical power of the type chosen.",
        hasCustomMethod:true,
        typeChosen:"",
        customMethod:(context,_,contextSelf)=>{
            context.stats.characterStats.spellMastery.spellPower[contextSelf.typeChosen] += 2
        },
        catchUpMethod:(context,_,contextSelf)=>{
            let options = ["fire", "cold", "electricity", "acid", "positive", "negative"]
            let choices = []
            for(let x = 0; x < options.length; x++){
                choices[x] = {
                    title:options[x],
                    id:x,
                    method:(() =>{
                        contextSelf.typeChosen = options[x]
                        contextSelf.shortDesc += `\n\nChosen Type: ` + options[x]
                        context.stats.characterStats.spellMastery.spellPower[options[x]] += 15 + (context.stats.characterStats.misc.level * 2)
                        context.stats.characterStats.spellMastery.spellCriticalDamage[options[x]] += 25
                    })
                }
            }
            let custom = {title:"Complete Havoc Element Choice", options:choices}
            context.customDialogArray.push(custom)
        }
    },    
    {
    rarity: "rare",
    type: "magic",
    name: "Blood Intensity",
    fromClass:"Sorcerer",
    shortDesc: "Whenever you cast a spell that deals damage, you can increase its cost by 1 spell point per spell level to increase its maximum number of damage dice by an amount equal to your Strength or Charisma modifier, whichever is higher.",
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Aggravated Assault",
    fromClass:"My Dad",
    shortDesc: "You can activate this ability as a full-round action that costs level x2 spell points, you make a melee attack against a creature within reach, if you successfully hit your target you gain 2x your highest mental stat modifier as an alchemical bonus to your strength score for 1 round, but reduce your all your mental scores by your highest mental stat modifier for the same duration. The bonus and penalty to this ability is decided when activated, and is not changed by changes to your mental stats from its activation or for other reasons. As long as you continue to melee attack the same target each round this bonus extends 1 round. If the target dies as the result of a melee attack you made against it the bonus extends for 2 more rounds. If you don't attack the target for one round and it is still alive you lose the bonus to your strength score but the penalties continues for 2 rounds after. If you have rage active while this bonus is active increase your rage bonuses to strength and constitution by 2 for the duration of this ability.",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Epic Sneak Attack",
    fromClass:"rogue",
    shortDesc: `If you catch an opponent unable to defend itself effectively from his attack, you can strike a vital spot for extra damage. Your attack deals extra damage anytime your target would be denied a Dexterity bonus to AC (whether the target actually has a Dexterity bonus or not), or when you flank your target. This additional damage is 1d6, and increases by 1d6 every 4 levels. Ranged attacks can count as sneak attacks only if the target is within 30 feet.
    \nWith a weapon that deals nonlethal damage (like a sap, whip, or unarmed strike), you can make a sneak attack that deals nonlethal damage instead of lethal damage. You cannot use a weapon that deals lethal damage to deal nonlethal damage in a sneak attack, not even with the usual -4 penalty.        
    \nYou must be able to see the target well enough to pick out a vital spot and must be able to reach such a spot. You cannot use sneak attack while striking a creature with concealment.`,
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Fight Or Flight",
    fromClass:"Custom",
    shortDesc: "When you are attacked by a creature in melee you can as an immediate action activate this ability for level x2 spell points. You gain 2x your highest mental stat modifier as a morale bonus to your dexterity score, but reduce all your mental stats by your highest mental stat modifier. The bonus and penalty to this ability is decided when activated, and is not changed by changes to your mental stats from its activation or for other reasons. This ability lasts 1 round, however it is extended by 1 round if you are attacked again, the duration can only be extended once per round. Alternatively you can activate this ability in response to an affect that would cause you to gain the cowering, panicked, or frightened condition, you can make an additional save attempt with a +4 modifier, if you succeed the condition is reduced to shaken and the duration of this ability becomes equal to the duration of the original triggering effect.",
    },
    {
    rarity: "rare",
    type: "magic",
    name: "Age Out",
    fromClass:"Daemon Sorcerer",
    shortDesc: "As a movement action you can magically age yourself to attempt to remove a condition currently affecting you that originally allowed either a will or fortitude save. If you do this you receive -1 to all physical stats but receive additional save against the condition. This stat damage will stay with you until the next floor or 24 hours and cant be restored any other way. you cant use this ability if it would reduce a physical score below 1.",
    },
    {
    rarity: "common",
    type: "magic",
    name: "Calling",
    shortDesc: "Make a prayer as a standard action costing spell points equal to your highest mental mod/2, then any time within the next minute before you make a d20 roll you can reactivate this ability gaining a competence bonus equal to your highest mental mod to the roll, or while casting a healing spell or using a healing perk increase its effect by 50%",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Vandal",
    abilityType:"Ex",
    fromClass:"Order of the Beast Cavalier",
    shortDesc: "You gain Improved Sunder as a bonus feat. In addition, when dealing damage to objects (including when using the sunder combat maneuver), you add half your level to the damage roll. If you successfully breaks an object, you receive a +2 morale bonus on all attack rolls until the end of your next turn. If you already have improved sunder you gain greater sunder, and if you already have greater sunder you gain Sunder Expert",
    hasCustomMethod:true,
    customMethod:()=>{
    },
    catchUpMethod:(context)=>{
        if(context.stats.lists.feats.length >= 0){
            if(context.stats.lists.feats.filter(feat=>feat.name=="Improved Sunder").length > 0){
                if(context.stats.lists.feats.filter(feat=>feat.name=="Greater Sunder").length > 0){
                    let feat = {
                        name:"Sunder Expert",
                        prereq: "",
                        type:"martial",
                        longDesc:"Gain +1 to sunder combat maneuvers, increasing by +1 every 6 levels. This feat stacks with everything including itself."
                    }
                    context.stats.lists.feats.push(feat)
                }else{
                    context.stats.lists.feats.push(feats.filter(feat=>feat.name=="Greater Sunder")[0])
                }
            }else{
                context.stats.lists.feats.push(feats.filter(feat=>feat.name=="Improved Sunder")[0])
            }
        }
    }
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Ferocious Charge",
    abilityType:"Ex",
    fromClass:"Order of the Beast Cavalier",
    shortDesc: "When you charge a creature you can attempt an intimidate check to demoralize your enemy as a free action, if you succeed the target is frightened for 1 round.",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Shield of Blades",
    abilityType:"Ex",
    fromClass:"Order of the Blue Rose Cavalier",
    shortDesc: "When taking the total defense action, the cavalier can extend his protection to those around him, granting a +2 circumstance bonus to AC to all adjacent allies. In addition, while taking the total defense action, as an immediate action, the cavalier can attempt to deflect an attack by making an attack roll opposed by the attacker's original attack roll. If successful, the attack is deflected and deals no damage.",
    },
    {
    rarity: "epic",
    type: "universal",
    name: "For the Faith",
    abilityType:"Ex",
    fromClass:"Order of the Star Cavalier",
    shortDesc: "As a free action for level spell points you can call upon your deity to gain a morale bonus on attack rolls equal to your highest mental score for 1 round, all teammates within 30 feet who share your good/evil alignment gain this bonus as well, if they are neutral they gain half, and if it is the opposing alignment they gain none. If you are neutral everyone (you included) only gain half.",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Guarded",
    abilityType:"Ex",
    fromClass:"Order of the Eastern Star Cavalier",
    shortDesc: "The cavalier gains DR 1/— and a +2 morale bonus on saving throws when wearing light armor or no armor and fighting defensively or using Combat Expertise. Every 4 levels this DR increases by 1.",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Pierce the Guard",
    abilityType:"Ex",
    fromClass:"Order of the Eastern Star Cavalier",
    shortDesc: "When attacking with a light or one-handed weapon, the cavalier ignores the penalty for fighting defensively or using Combat Expertise on his first melee attack roll each round. If fighting with two weapons, he ignores the penalty for the first attack with each weapon, as long as the off-hand weapon is a light weapon.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Rally Allies",
    abilityType:"Ex",
    fromClass:"Order of the Eel Cavalier",
    shortDesc: "As a swift action for 4 spell points, the cavalier can grant a competence bonus on weapon damage rolls to all allies within 30 feet. The bonus is equal to the number of distinct alignments in the ally group, including the cavalier's, up to a maximum bonus equal to the cavalier's highest mental modifier (minimum +1). This bonus lasts for 1 round.",
    },
    {
    rarity: "common",
    type: "universal",
    name: "Foolhardy Rush",
    abilityType:"Ex",
    fromClass:"Order of the Flame Cavalier",
    shortDesc: "The cavalier can charge across the battlefield at a moment's notice. Whenever the cavalier attempts an initiative check, as long as he rolls an 11 or higher on the die, he can move up to his base speed as an immediate action and he is not considered flat-footed. If a new combat starts, but the cavelier did not roll initative, they can roll a d20, on a result higher than 11 they can spend an immediate action to move up to their base speed.",
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Blaze of Glory",
    abilityType:"Ex",
    fromClass:"Order of the Flame Cavalier",
    shortDesc: "The cavalier can declare a blaze of glory as a standard action for 4 spell points. For a number of rounds equal to his highest mental modifier, the cavalier increases his base speed by 10 feet, can ignore difficult terrain while charging, and gains a +4 bonus on his attack rolls (instead of +2).",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Glorious Challenge",
    abilityType:"Ex",
    fromClass:"Order of the Flame Cavalier",
    shortDesc: "When you reduce an opponent to 0 hit points or fewer you can initiate a glorious challenge as an immediate action against a creature within 15 feet. While a glorious challenge is in effect you gain a -2 penalty to AC, but you gain a morale bonus on melee damage rolls against the target of your glorious challenge equal to your level/2 + 2 x the number of consecutive glorious challenges you have issued thus far. Each consecutive glorious challenge also lowers your armor class by an additional -2. You can only have one glorious challenge in affect at a time.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Monster Expert",
    abilityType:"Ex",
    fromClass:"Order of the Hero Cavalier",
    shortDesc: "The cavalier learns how to dodge the attacks of his monstrous foes and the traps in their lairs. He gains a bonus equal to his highest mental modifier on Fortitude and Reflex saves against abilities and spells that have an area of effect.",
    },
    {
    rarity: "common",
    type: "universal",
    name: "Resist Energy",
    abilityType:"Su",
    fromClass:"Order of the Hero Cavalier",
    shortDesc: "The cavalier can steel himself against harmful energies. For 2 spell points as a move action, he chooses one of the following: acid, cold, electricity, or fire. He gains energy resistance 5 against the chosen type for 5 rounds. At 8th, 12th, and 16th levels, the resistance increases by 5, and the spell points cost by 3",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Mighty Charge",
    abilityType:"Su",
    fromClass:"Cavalier",
    shortDesc: "Double the threat range of any weapons wielded during a charge attack. If you already are doubling the threat range of a weapon instead gain a flat +1 bonus to critical threat range that ins't doubled. In addition, the cavalier can make a free bull rush, disarm, sunder, or trip combat maneuver if his charge attack is successful. This free combat maneuver does not provoke an attack of opportunity, and only happens once, no matter how many attacks were made during the charge.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Inspiring Flex",
    abilityType:"Ex",
    fromClass:"Order of the Hammer Cavalier",
    shortDesc: "As a standard action, she can grant herself and any allies within 30 feet a +4 morale bonus on melee attack rolls, combat maneuver checks, Fortitude saves, and Strength checks. The cavalier can maintain her inspiring flex as a free action, but activating it and maintaining it costs 2 spell points at the start of each turn.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Lion's Call",
    abilityType:"Ex",
    fromClass:"Order of the Lion Cavalier",
    shortDesc: "As a standard action, he can give an encouraging speech which grants all allies within 60 feet a competence bonus on their saving throws against fear equal to his highest mental modifier and a +1 competence bonus on attack rolls for a number of rounds equal to his cavalier level. If an ally within range is under the effect of a spell or ability that causes him to be frightened or panicked, he can immediately make another saving throw to resist the effect (if allowed).",
    },
    {
    rarity: "epic",
    type: "universal",
    name: "For the King",
    abilityType:"Ex",
    fromClass:"Order of the Lion Cavalier",
    shortDesc: "Once per combat for level spell points an order of the lion cavalier can call out to his allies, inspiring them to greatness. As a swift action, the cavalier can grant a competence bonus equal to his highest mental modifier on all attack and damage rolls to all allies within 30 feet. This bonus lasts for 1 round.",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Synchronized Smash",
    abilityType:"Ex",
    fromClass:"Order of the Staff Cavalier",
    shortDesc: "The cavalier can utilize the power of his spellcasting allies to make devastating attacks against the allies' targets. If the cavalier is adjacent to an enemy affected by a targeted or area spell or spell-like ability cast by one of the cavalier's allies, he can make an immediate attack of opportunity against the affected creature. If the cavalier is also affected by the spell (such as by being caught in the area of the same fireball spell), during the rest of that round he automatically confirms any critical hits made against the affected creature while using this ability.",
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "All Out Attack",
    abilityType:"Ex",
    fromClass:"Friendship",
    shortDesc: "As a full-round action for level x2 spell points you can activate this ability, when you do so, you must also give a one-liner (in character and IRL), and therefore must be able to talk and be heard by all teammates who want to use this ability. All teammates able to (including yourself), regardless of distance from the targets (though they must see them), may make an attack at their highest bonus against all enemies currently under the condition of stunned, paralyzed, petrified, fascinated, dominated, sleeping, dazed, or helpless. It costs level/2 spell points to make this attack (except for the player who activated this ability). Players gain a bonus equal to your charisma modifier on this attack's attack and damage, and bypass all DR the enemy may have. You can only do this once per enemy. If all enemies on the map are under one of these effects, each of the attacks gains a +1 flat bonus to their critical threat range for each enemy. GM's can give penalties or bonuses to the attack if the one-liner is particularly good or bad. If multiple players have this ability they can activate it at once to make multiple attacks, only using the first activating players action.",
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Arcane Vessel",
    abilityType:"Ex",
    fromClass:"Order of the Staff Cavalier",
    shortDesc: "Whenever the cavalier gains a bonus on attack rolls, saving throws, or damage rolls from a spell, spell-like ability, or magical perk cast by another creature, the cavalier also gains a number of temporary hit points equal to the level of the spell, spell-like ability, or half the casters level if its a perk. These temporary hitpoints stack up to 1/2 the cavaliers maximum hit points.",
    },
    {
    rarity: "epic",
    type: "universal",
    name: "Moment of Triumph",
    abilityType:"Ex",
    fromClass:"Custom",
    shortDesc: "When you score a critical hit on an attack you can spend level/3 spell points to gain a competence bonus equal to your highest mental stat on all d20 rolls for the rest of the round.",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Retribution",
    shortDesc: "Whenever an adjacent teammate is struck in combat you can make an attack of opportunity against that enemy, if the teammate shares your good/neutral/evil alignment you also gain your highest mental stat to attack and level to damage. Regain a use of your attack of opportunity if the attack against your teammate or your attack of opportunity is a critical hit",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Channeled Attack",
    abilityType:"Ex",
    shortDesc: "As a free action you can spend spell points up to your BAB to gain a damage bonus equal to twice the amount on your next attack before the end of your turn. This bonus damage is only applied once even if your attack hits multiple enemies or a single enemy multiple times.",
    },
    {
    rarity:"common",
    name: "Savior of the Swallowed",
    type: "martial",
    fromClass:"Heritor Knight",
    abilityType:"Ex",
    shortDesc: "As a standard action you can make a melee attack against a creature that is currently physically restraining an ally, such as grappled or swallowed, attack normally, but if the attack roll is also matches or exceeds the targets CMD the restraining effect ends",
    },  
    {
    rarity:"common",
    name: "Skyreaver",
    type: "martial",
    fromClass:"Heritor Knight",
    abilityType:"Su",
    shortDesc: "As a standard action you can make a melee attack against a creature that is currently Flying, attack normally but the damage is halved, but if the attack roll is also matches or exceeds the targets CMD it immediately stops flying and then receives a -20 to all fly checks for rounds equal to your highest mental stat",
    },        
    {
    rarity:"rare",
    name: "Mohrgbreaker",
    type: "martial",
    fromClass:"Heritor Knight",
    abilityType:"Su",
    shortDesc: "As a standard action you can make a melee attack against an undead creature, attack normally, and if you hit they must make a will save dc 10+level+highest mental or lose all abilities associated with its natural attacks for rounds equal to your highest mental stat",
    }, 
    {
    rarity: "common",
    type: "universal",
    name: "Loot Collector",
    shortDesc: "Once per turn you can collect a gold pile or open a chest as a free action that does not provoke an attack of opportunity, and you can extend the reach you can collect gold by 5 feet.  Additionally, once per floor for the regular increased gold cost you can draw a typed item from a chest, and once per run you can buy an item for 99% off.",
    },
    {
        rarity: "rare",
        type: "universal",
        name: "All Stated Up",
        shortDesc: "Each time you level up you gain an additional stat roll",
        hasCustomMethod:true,
        customMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats"}));
        },
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"stats"}));
            }
        },
    },
    {
        rarity: "rare",
        type: "universal",
        name: "Power Up",
        shortDesc: "When you gain this perk a random ability score gains a +8 bonus.",
        hasCustomMethod:true,
        customMethod:()=>{                
        },
        catchUpMethod:(context)=>{
            let arr = ["strength","dexterity","constitution","intelligence","wisdom","charisma"]
            let ability = arr[Math.floor(Math.random()*6)]
            context.stats.characterStats.abilityScore[ability] += 8
        },
    },
    {
        rarity: "legendary",
        type: "universal",
        name: "Built Different",
        shortDesc: "Increase your HD size by 4, reroll your hit dice, Each time you level up you gain an additional R+ ability score or misc stat roll.",
        hasCustomMethod:true,
        customMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{abilityScore:true,misc:true}, rarity:{rare:true, epic:true, legendary:true, unique:true}}}));
        },
        catchUpMethod:(context)=>{
            context.stats.characterStats.misc.HDSize += 4
            context.stats.characterStats.hpIncreases.splice(0, 1, context.stats.characterStats.misc.HDSize)
            for(let x = 1; x < context.stats.characterStats.hpIncreases.length; x++){                
                context.stats.characterStats.hpIncreases.splice(x, 1, Math.ceil(Math.random() * context.stats.characterStats.misc.HDSize))                
            }                   
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"stats"}))
            }
        },
    },
    {
        rarity: "rare",
        type: "universal",
        name: "Built Stupid",
        shortDesc: "Each time you level up you gain an additional rare ability score roll",
        hasCustomMethod:true,
        customMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{abilityScore:true}, rarity:{rare:true}}}))
        },
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{abilityScore:true}, rarity:{rare:true}}}))
            }
        },
    },
    {
        rarity: "common",
        type: "universal",
        name: "Skill Monkey",
        shortDesc: "Each time you level up you gain an additional skill roll",
        hasCustomMethod:true,
        customMethod:(context)=>{
            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{skills:true}}}))
        },
        catchUpMethod:(context)=>{
            for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{skills:true}}}))
            }
        },
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Lord of Vengence",
    shortDesc: "Enemies that strike you and are within your threatened are provoke an attack of opportunity from you, you gain your highest mental stat to attack and level to damage for that attack. If you confirm a critical hit against a creature with this attack you regain an attack of opportunity. If the hit is against you is a critical you can gain your attack of opportunity back if your provoked attack of opportunity hits.",
    },   
    {
    rarity: "epic",
    type: "martial",
    name: "Steal Glory",
    shortDesc: "Whenever a creature other than you confirms a critical hit against a target that you are threatening, it provokes an attack of opportunity from you. For Level spell points before you roll your attack and before the person who originally confirmed the critical hit rolls damage you can choose to make them instead roll damage as normal and you can roll to attack, if you hit your attack becomes a critical threat.",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Quick Reflexes",
    shortDesc: "You gain 1 additional attack of opportunity a round, for every 5 BAB you have you gain another attack of opportunity. Additionally, when making an attack of opportunity you gain a +1 bonus to the attack and damage roll, increasing by +1 every 4 levels.",
    },   
    {
    rarity: "legendary",
    type: "martial",
    name: "Act as One",
    fromClass:"Order of the Dragon Cavelier",
    shortDesc: "For 6 + level x2 spell points you can spend a standard action to move up to your speed and make a melee attack against an enemy, all allies within 30 feet can also move up to their speed and make a melee attack against an enemy as an immediate action by spending 4 spell points. This movement and attack can be made as a charge if their movement qualifies. All attacks are made at a +2 bonus (stacks with charge) and all participants receive a +2 dodge bonus to their ac for one round.",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Strategy",
    fromClass:"Order of the Dragon Cavelier",
    shortDesc: "For 4 spell points you can spend a standard action to grant one of a number of bonuses to all allies within 30 feet (including himself). The allies must be able to see or hear the cavalier to receive this bonus. The cavalier can grant a +2 dodge bonus to AC for 1 round, a +2 morale bonus on all attack rolls for 1 round, or the ability to move up to their speed as an immediate action once. The cavalier can grant a different bonus to each ally within range",
    }, 
    {
    rarity: "common",
    type: "martial",
    name: "Powerful Charge",
    fromClass:"Custom",
    shortDesc: "You gain an additional +2 to attack while charging, and for 1 round after you charge you gain +2 damage and +1 dodge bonus to ac. These bonuses increase by +1 every 5 levels.",
    },  
    {
    rarity: "common",
    type: "universal",
    name: "Trained Helper",
    fromClass:"Custom",
    shortDesc: "The bonus granted by the aid another action increases by +2 bonus, and for each 10 you beat the DC by the bonus you give grants an additional +1. Whenever you roll a natural 20 while aiding another the bonus you would give is doubled.",
    },  
    {
    rarity: "common",
    type: "universal",
    name: "Lasting Aid",
    fromClass:"Custom",
    shortDesc: "Whenever you use the aid another action the bonus lasts for a full round instead of just for the next roll.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Force of Will",
    fromClass:"Custom",
    shortDesc: "You can add your highest mental stat as a morale bonus to your will saves.",
    },
    {
    rarity: "common",
    type: "universal",
    name: "Helpful Treasure Hunter",
    fromClass:"Custom",
    shortDesc: "You are able to assist other players for skill checks made to obtain treasure that normally don't allow you to aid others. If you aid an ally you forgo your skill check to find the treasure.",
    },
    {
    rarity: "rare",
    type: "universal",
    name: "Treasure Hunter Captain",
    fromClass:"Custom",
    shortDesc: "Other players are able to assist you on checks to gain treasure that don't normally allow for assist rolls. The usual limitations of assist rolls still applies to this, such as being nearby and certain skills and that disable device that cannot be assisted.",
    },
    {
    rarity: "legendary",
    type: "martial",
    name: "Deadly Charge",
    fromClass:"Disciple of the Pike Cavelier",
    shortDesc: "Your charge attacks with polearm weapons deal 2x damage, and on a confirmed critical hit on a charge attack the target makes a will save dc 10+bab+highest mental stat or is stunned for 1 round. If it saves it is instead staggered for 1 round.",
    }, 
    {
    rarity: "epic",
    type: "magic",
    name: "Hate Speech",
    fromClass:"Brutalis Devil",
    shortDesc: "As a standard action for 4 + level/2 spell points make a knowledge check appropriate for the type of monster (dc=15 + targets HD) against a monster you can see, if you succeed you can fill all teammates with rage when attacking that particular creature, they gain a +2 morale bonus to attack and damage for all attacks against it for 1 round. For each 10 you beat the DC by increase the bonus to attack and damage by 2, the duration by 1 round, and the creature becomes shaken for 1 round. If you have previously identified a creature such as through knowledge checks or using this ability lower the DC by 5. Any creature you have used hate speech against gains a +4 morale bonus to attack and damage against you. If a creature under the effects of hate speech dies you heal for 3 health per hit die of the target.",
    }, 
    {
    rarity: "epic",
    type: "martial",
    name: "Staggering Assault",
    fromClass:"Order of the Seal Cavelier",
    shortDesc: "As a full-round action, the cavalier can make a single attack at his highest attack bonus. If the attack hits, the attack does damage as normal, and the cavalier may attempt a bull rush against the target. The cavalier gains a bonus on the bull rush combat maneuver check equal to half the amount of damage dealt on the initial attack.",
    },
    {
        rarity: "epic",
        type: "universal",
        name: "Stigmata",
        fromClass:"Holy Vindicator",
        abilityType:"Su",
        shortDesc: "As a standard action you can cause yourself to begin bleeding, taking damage equal to your level, and bleeding for that amount each round. While bleeding this way you gain a sacred or profane bonus (depending on alignment, neutral picks one for the whole game) of your choice equal to half the bleed damage you take, you can choose to apply it to one of: attack, damage, armor class, caster level checks, or saving throws. You choose which bonus you are using when you activate your stigmata. While stigmata is active you become immune to other bleed effects. This cannot be activated if you are immune to bleed damage, and you can stop the bleed and the benefit at will.",
    },
    {
        rarity: "epic",
        type: "magic",
        name: "Faith Healing",
        fromClass:"Holy Vindicator",
        abilityType:"Su",
        shortDesc: "Any cure wounds spells a vindicator casts on himself are automatically empowered as if by the Empower Spell feat, except they do not use higher spell level slots or an increased casting time. If the vindicator targets himself with a cure spell that affects multiple creatures, this ability only applies to himself. At 8th level, these healing spells are maximized rather than empowered.",
    },  
    {
        rarity: "rare",
        type: "martial",
        name: "Divine Retribution",
        fromClass:"Holy Vindicator",
        abilityType:"Sp",
        shortDesc: "When a vindicator confirms a critical hit, he may sacrifice a 3rd level spell slot (or higher) to invoke bestow curse upon the target as an immediate action (using the vindicator's caster level). The save DC increases by +2 if his weapon has a ×3 critical multiplier, or by +4 if it is ×4 etc. The vindicator can also use this ability in response to being critically hit, even if the attack incapacitates or kills the vindicator.",
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Divine Judgement",
        fromClass:"Holy Vindicator",
        abilityType:"Sp",
        shortDesc: "When a vindicator's melee attack reduces a creature to -1 or fewer hit points, he may sacrifice a 2nd-level slot (or higher) to invoke death knell upon the target as an immediate action. The save DC increases by +2 if his weapon has a ×3 critical multiplier, or by +4 if it is ×4 etc.",
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Seeker Shot",
        fromClass:"Arcane Archer",
        abilityType:"Su",
        shortDesc: "For level spell points you can make a ranged weapon attack at a target known to you within range, and the attack travels to the target, even around corners. Only an unavoidable obstacle or the limit of the arrow's range prevents the arrow's flight. This ability negates cover and concealment modifiers, but otherwise the attack is rolled normally. Using this ability is a standard action (and firing the attack is part of the action).",
    },
    {
        rarity: "epic",
        type: "martial",
        name: "Phase Arrow",
        fromClass:"Arcane Archer",
        abilityType:"Su",
        shortDesc: "For level spell points you can make a ranged weapon attack at a target known to him within range, and the attack travels to the target in a straight path, passing through any nonmagical barrier or wall in its way. (Any magical barrier stops the arrow.) This ability negates cover, concealment, armor, and shield modifiers, but otherwise the attack is rolled normally. Using this ability is a standard action (and firing the attack is part of the action).",
    },
    {
        rarity: "epic",
        type: "martial",
        name: "Hail of Arrows",
        fromClass:"Arcane Archer",
        abilityType:"Su",
        shortDesc: "In lieu of his regular attacks during a full round attack, for level spell points you can make a ranged weapon attack at each and every target within range, to a maximum of your level. Each attack uses your full attack bonus, and each enemy may only be targeted by a single arrow.",
    },
    {
        rarity: "rare",
        type: "martial",
        name: "Marked Shot",
        fromClass:"Custom",
        abilityType:"Su",
        shortDesc: "At the start of each floor and when you gain this perk you can create a marked piece of ammunition, when you do you designate a wave of combat, if the piece of ammunition is used against a creature from that wave of combat it deals 25 bonus damage * the wave (third wave the attack deals 75 bonus damage). This damage is not multiplied on critical hits, however the ranged attack has an increased critical range of +1 per combat completed on that floor already. This is a flat bonus not modified by other abilities.",
    },
    {
    rarity: "epic",
    type: "martial",
    name: "Shield of the Liege",
    fromClass:"Order of the Lion Cavelier",
    shortDesc: "Adjecent allies gain +2 shield bonus to their ac, and as an immediate action for level/2 spell points you can redirect an attack made at a creature adjacent to you as long as the creature attacking is within your reach, the ability must be declared before the attack roll is made. The attack is made against you even if the creature could not normally reach you or attack you, you lose all cover or concealment from the redirected attack.",
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Group Cover",
    sphere:"Fencing",
    shortDesc: "Your quick movements allow you to temporarily use one enemy as cover against another enemy. Every enemy that threatens you suffers a -2 penalty to their attack rolls against you for every other creature adjacent to them that also threatens you.",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Rogue Talent",
    shortDesc: "roguePerks",
    },
    {
    rarity: "common",
    type: "universal",
    name: "Monk Power",
    shortDesc: "kiPerks",
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Fighter Perk",
    shortDesc: "fighterPerks",
    },
    {
    rarity: "common",
    type: "martial",
    name: "Rage Power",
    shortDesc: "ragePerks",
    },
    {
    rarity: "rare",
    type: "martial",
    name: "Recovery Perk",
    shortDesc: "recoveryPerks",
    },
    {
        rarity: "epic",
        type: "magic",
        name: "Cleric Domain",
        abilityType:"Su",
        fromClass:"Cleric",
        shortDesc: "You will gain a choice of 4 cleric Domains. Cleric domains are two combined abilities, one you get immediately, another you get at a higher level. If a domain ability has a DC it is equal to the DC of your channel energy.",
        hasCustomMethod:true,
        customMethod:(context,self,contextSelf)=>{
            contextSelf.chosenDomains.forEach(domain=>{
                let listDomain = self.domains.find(listDomain=> listDomain.name == domain)
                listDomain.customMethod(context)
            })
        },
        catchUpMethod: (context,self,contextSelf, domainCount)=>{
            contextSelf.shortDesc += `\n\nDomains Chosen:` 
            contextSelf.chosenDomains = []
            if(!domainCount) domainCount = 1 
            for(let x = 0; x < domainCount; x++){
                self.getDomain(context,self, contextSelf)
            }
        },
        getDomain:(context,self,contextSelf)=>{
            let choices = []
            let chosen = []
            let domains = self.domains
            for(let x = 0; x < 4; x++){
                let possible = Math.floor(Math.random()*domains.length)
                while(chosen.includes(possible)) possible = Math.floor(Math.random()*domains.length)
                chosen.push(possible)
                let option = domains[possible]
                let description = option.description
                choices[x] = {
                    title:option.name,
                    description,
                    id:x,
                    method:(() =>{                    
                        contextSelf.shortDesc += `\n` + option.name
                        let domainPerk = {name:option.name + " Domain", rarity:"unique", id:Math.random(), type:"magic", uiType:"perks", shortDesc:``, abilityType:option.abilityType}
                        domainPerk.shortDesc += option.description + `\n\nPowers Chosen:`
                        contextSelf.chosenDomains.push(option.name)
                        self.getDomainPerks(context,self,domainPerk,option,"perk1")
                        
                    })
                }                
            }
            let custom = {title:"Domain Selection", options:choices}
            context.customDialogArray.push(custom)
        },
    
        getDomainPerks:(context,self,domainPerk,domain, list)=>{
            let choices = []
            for(let x = 0; x < 3; x++){
                let length = domain[list].length
                let option = domain[list][Math.floor(Math.random()*length)]
                choices[x] = {
                    title:option.name,
                    description:option.description,
                    id:x,
                    method:(() =>{
                        domainPerk.shortDesc += `\n\n` + option.name + `:\n` + option.description
                        if(option.hasCustomMethod){
                            option.catchUpMethod(context)
                        }
                        if(list == "perk1"){
                            self.getDomainPerks(context,self,domainPerk,domain,"perk2")
                        }else{
                            context.stats.lists.perks.push(domainPerk)
                            domain.catchUpMethod(context)
                        }                    
                    })
                }                
            }
            let custom = {title:"Domain Selection", options:choices}
            context.customDialogArray.splice(1,0,custom)
        },
        hasSpecialItems:true,
        getSpecialItemList:(self)=>{
            let newList = []
            let domainList = self.domains
            domainList.forEach(domain=>{
                let newItem = {name:domain.name, description:domain.description + `\n\nWhen getting a domain you will pick a minor and major power`}
                newList.push(newItem)
                domain.perk1.forEach(perk=>{
                    let newSub = {name:"->" + domain.name + " Minor: "+ perk.name, description:perk.description}
                    newList.push(newSub)
                })
                domain.perk2.forEach(perk=>{
                    let newSub = {name:"->->" + domain.name + " Major: "+ perk.name, description:perk.description}
                    newList.push(newSub)
                })
            })             
            return newList
        },

        domains:[
            {
                name:"Air",
                description:`You can manipulate lightning, mist, and wind, and traffic with air creatures.
                \nSpecial: Gain a 10 foot bonus to your base movement speed, increased to 20 feet when you are using non-magical flight speed. Gain 20 electricity spell power and 2% electricity spell critical chance, but -20 acid spell power and -2% acid spell critical chance.
                \nBonus Rolls: An electricity/air spell at 1st every 3 levels.`,
                perk1:[
                    {
                        name:"Lightning Arc",
                        abilityType:"Sp",
                        description:`As a standard action for 2 spell points, you can unleash an arc of electricity targeting any foe within 30 feet as a ranged touch attack. This arc of electricity deals 1d6 points of electricity damage + 1 point per level. At level 7 you can activate this as a swift action for 10 spell points.`
                    },
                    {
                        name:"Wind Blast",
                        abilityType:"Sp",
                        description:`As a standard action for 2 spell points, you can unleash a blast of air in a 30-foot line. Make a combat maneuver check against each creature in the line, using your caster level as your base attack bonus and your highest mental modifier in place of your Strength modifier. Treat the results as a bull rush attempt.`
                    },
                ],
                perk2:[
                    {
                        name:"Electricity Resistance",
                        abilityType:"Ex",
                        description:`At level 5: You gain electricity resistance 10. At level 9 this increases to 20, at level 18 you gain immunity to electricity.`
                    },
                    {
                        name:"Thundercloud",
                        abilityType:"Su",
                        description:`At Level 7: You can as a standard action, summon a storm cloud. Activating this ability costs 7 spell points, but then can be maintained for 3 spell points as a free action each round. This power functions as fog cloud except that creatures inside the cloud are deafened and take 2d6 + highest mental points of electricity damage each round from the flashes of thunder and lightning. Once created, you can concentrate on the cloud to move it up to 30 feet each round.`
                    },
                    {
                        name:"Lightning Rod",
                        abilityType:"Su",
                        description:`At level 7: As a swift action for 7 spell points when you cast a spell with the electricity descriptor, you can designate one creature within line of sight. The spell's damage against that creature increases by 50%, as if affected by the Empower Spell feat. This additional damage results from divine power that is not subject to being reduced by electricity resistance, and you take an equal amount of electricity damage immediately after you cast the spell. The spell can deal this additional damage only once, even if it could affect the target multiple times.`
                    },
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellPower.electricity += 20
                    context.stats.characterStats.spellMastery.spellCriticalChance.electricity += 2
                    context.stats.characterStats.spellMastery.spellPower.acid -= 20
                    context.stats.characterStats.spellMastery.spellCriticalChance.acid -= 2
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%3 == 0 || x == 1){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["air","electricity"]}}))
                        }
                    }
                    
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["air","electricity"]}}))
                    }
                },
            },
            {
                name:"Artifice",
                description:`You can repair damage to objects, animate objects with life, and create objects from nothing.
                \nSpecial: Gain a bonus on your craft checks equal to your level.
                \nBonus Rolls: Every 6 levels gain an armor enchantment.`,
                perk1:[
                    {
                        name:"Artificer's Touch",
                        abilityType:"Sp",
                        description:`You gain the mending spell. In addition, for 2 spell points you can cause damage to objects and construct creatures by striking them with a melee touch attack. Objects and constructs take 1d6 points of damage + 1 per level. This attack bypasses an amount of damage reduction and hardness equal to your level.`,
                        hasCustomMethod:true,
                        catchUpMethod:(context)=>{
                            context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Mending")[0])
                        },
                    },
                    {
                        name:"Divine Alchemy",
                        abilityType:"Su",
                        description:`When you drink or feed a healing potion or restoration potion to someone, the healing given is increased by 33%.`
                    },
                    {
                        name:"Trap Sense",
                        abilityType:"Su",
                        description:`You gain a bonus on checks equal to half your level to find and disarm traps, and on saves against them.`
                    },
                ],
                perk2:[
                    {
                        name:"Dancing Weapons",
                        abilityType:"Su",
                        description:`At level 7: As a standard action for 8 spell points you can give a weapon touched the dancing special weapon quality for 4 rounds.`
                    },
                    {
                        name:"Aura of Efficiency",
                        abilityType:"Su",
                        description:`At level 7: You can emit a 30-foot-radius aura that empowers allies and equipment. Activating the aura is a standard action that costs 7 spell points, and 3 each round to maintain. The aura grants your allies a +4 bonus on all saving throws against effects that inflict the fatigued or exhausted condition. Any equipment wielded by your allies within this area gets a bonus to hardness equal to 1/2 your level, and your allies' attacks against targets within this area ignore an equal amount of hardness.`
                    },
                    {
                        name:"Aura of Repetition",
                        abilityType:"Su",
                        description:`At level 7: You can emit a 30-foot aura of repetition, activating this is a standard action that costs 7 spell points, and 3 each round to maintain. All enemies within this aura must make a Will save each round or repeat their action from the previous round (if possible). Creatures that attacked on the previous round attack again on the following round, although they may change their target. Creatures that moved the previous round must take the same move action again, although they may change their route. Creatures that drank a potion must do so again, even they can only drink from an empty bottle. Actions that cannot be repeated are wasted.`
                    },
                ],
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x%6 == 0){
                            context.connection.send(JSON.stringify({command:"requestRoll", type:"armor enchantment"}))
                        }
                    }
                         
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%6 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"armor enchantment"}))
                    } 
                },
            },
            {
                name:"Chaos",
                description:`You revel in all things anarchic.
                \nSpecial: You gain a +1 bonus on saves and attacks against lawful creatures. At level 9 and 18 this increases by +1.
                \nBonus Rolls: At 1st and every 6 levels you gain something random.`,
                perk1:[
                    {
                        name:"Touch of Chaos",
                        abilityType:"Sp",
                        description:`For level/2 spell points you can imbue a target with chaos as a melee touch attack. For the next round, anytime the target rolls a d20, he must roll twice and take the less favorable result.`,
                    },
                    {
                        name:"Drunken Autonomy",
                        abilityType:"Su",
                        description:`As a swift action for level/2 spell points, whenever under the effects of mind-affecting magic, possession, or similar external control, you can channel the unrestricted nature of your god. Instead of acting under the compulsion, you instead act as though you had the confused condition for 1 round. Producing the “act normally” result allows you to act free of mental compulsion for that round.`
                    },
                    {
                        name:"Elysium's Call",
                        abilityType:"Su",
                        description:`With a touch, for level/2 spell points you can imbue creatures with the spirit of Elysium, lifting their spirits and freeing them from bonds. The creatures touched can immediately reroll any failed saving throws against spells and spell-like abilities of the enchantment (charm) and enchantment (compulsion) subschools. In addition, targets receive a +2 sacred bonus on such saving throws and a +2 sacred bonus on CMB checks to escape a grapple. Finally, targets can ignore up to 5 feet of difficult terrain each round, as if they had the Nimble Moves feat. These bonuses last for a number of rounds equal to 1/2 your level (minimum 1), although the saving throw reroll only applies when the creature is touched.`
                    },
                    {
                        name:"Faith-Stealing Strike",
                        abilityType:"Su",
                        description:`For 2 spell points as a swift action when you are making a melee attack against a creature capable of casting divine spells you can activate this ability. If you damage the creature, it must succeed at a Will save (DC = 10 + 1/2 level + highest mental modifier) or be unable to cast any divine spells for 1 round. If you do not damage your target with the attack, this ability is expended with no effect.`
                    },
                    {
                        name:"Fury of the Abyss",
                        abilityType:"Su",
                        description:`As a swift action for level spell points, you can give yourself a bonus equal to 1/3 your level (minimum +1) on melee attacks, melee damage rolls, and combat maneuver checks. This bonus lasts for 1 round. During this round, you take a penalty to your armor class equal to 1/2 level.`
                    },
                ],
                perk2:[
                    {
                        name:"Chaos Blade",
                        abilityType:"Su",
                        description:`At level 7: For 7 spell points as a standard action for 7 spell points you can give a weapon touched the anarchic special weapon quality for a number of rounds equal to 1/2 level.`
                    },
                    {
                        name:"Entropy",
                        abilityType:"Su",
                        description:`At level 7: as an immediate action for 7 spell points upon successfully hitting an opponent with a melee attack, you reduce the remaining duration of all beneficial magical effects currently affecting the target by 1 round, minute, hour, or day—whichever measurement is used to determine the duration of each particular magical effect.`
                    },
                    {
                        name:"Aura of Chaos",
                        abilityType:"Su",
                        description:`At level 7: You can emit a 30-foot aura of wild energy, activating this is a standard action that costs 7 spell points, and 3 each round to maintain. All enemies within this aura must declare one type of action at the start of their turn (attack, cast a spell, move, use an item, or activate a special ability) and make a Will save. Creatures that fail the Will save must take an action other than their declared action. If they succeed, they must take the declared action. Creatures cannot select actions that they cannot perform.`
                    },
                    {
                        name:"Intense Celebration",
                        abilityType:"Su",
                        description:`At level 7: Any spells that you cast that confer a morale effect upon you or your allies are automatically affected as if by the Extend Spell metamagic feat, with no increase in spell level. Any abilities that you use that confer a morale a morale bonus that are not spells, and last at least 1 round, instead last an additional 1d4-1 rounds.`
                    },
                    {
                        name:"Aura of Bedlam",
                        abilityType:"Su",
                        description:`At level 7: You can emit a 30-foot aura of chaos and strife, activating this is a standard action that costs 7 spell points, and 3 each round to maintain. Enemies in the aura take a -4 penalty on concentration checks and are treated as experiencing vigorous motion (concentration DC = 10 + spell level) when attempting to cast spells. This penalty increases by 1 for every 2 levels you have beyond 7th. This is a mind-affecting effect.`
                    },
                    {
                        name:"Unexpected Whimsy",
                        abilityType:"Su",
                        description:`At level 7: As a standard action for level spell points, you dance, act like a buffoon, or commit some other act of whimsy. When you do, enemies within 30 feet of you that can see and hear you must succeed a Will saving throw (DC = 10 + 1/2 level + half your highest mental modifier) or they collapse into gales of manic laughter, falling prone. Those who fail their saving throws can take no actions other than laughing for 1 round, but are not considered helpless.`
                    },
                ],
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x%6 == 0 || x == 1){
                            let options = ["perks","spell","maneuver","wonderousItems","feat","stats","weapon enchantment","armor enchantment","armor","weapon"]
                            let type = options[Math.floor(Math.random()*options.length)]
                            //console.log("tried random", type)
                            context.connection.send(JSON.stringify({command:"requestRoll", type:type}))
                        }
                    }
                         
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%6 == 0){
                        let options = ["perks","spell","maneuver","wonderousItems","feat","stats","weapon enchantment","armor enchantment","armor","weapon"]
                        let type = options[Math.floor(Math.random()*options.length)]
                        //console.log("tried random", type)
                        context.connection.send(JSON.stringify({command:"requestRoll", type:type}))
                    } 
                },
            },
            {
                name:"Charm",
                description:`You can baffle and befuddle foes with a touch or a smile, and your beauty and grace are divine.
                \nSpecial: You gain a +1 bonus on the DC of charm spells you cast. Every 8 levels this increases by +1.
                \nBonus Rolls: A control spell at 1st and every 3 levels.`,
                perk1:[
                    {
                        name:"Dazing Touch",
                        abilityType:"Sp",
                        description:`You can for level/2 spell points cause a living creature to become dazed for 1 round as a melee touch attack. The creature can make a will save to negate this.`,
                    },
                    {
                        name:"Adoration",
                        abilityType:"Su",
                        description:`As an immediate action for 2 spell points, you can attempt to thwart a melee or ranged attack that targets you. This ability functions as sanctuary, but only against one individual attack. You must use the ability after the attack is declared but before the roll is made. The creature attacking you receives a Will save to negate this effect. If a creature has more than one attack, this ability only affects one of the attacks. This is a mind-affecting effect.`
                    },             
                ],
                perk2:[
                    {
                        name:"Charming Smile",
                        abilityType:"Sp",
                        description:`At level 7: For 7 spell points as a swift action you can give a creature a charming smile, affecting them as the charm monster spell, with a will save dc=10+level/2+highest mental. You can only have a single creature charmed this way at a time, and the charm only lasts 1 round unless you spend 3 spell points at the start of each of your turns to maintain it.`
                    },
                    {
                        name:"Anything to Please",
                        abilityType:"Su",
                        description:`At level 7: You can compel a creature within 30 feet to attempt to please you as a standard action for 7 spell points. The creature receives a Will save to negate this affect. If the save fails, the creature attacks your enemies for 1 round, gives you its most valuable item (5d10 gold, only once per monster), or drops prone at your feet and grovels for 1d4 rounds (GM's choice). This is a mind-affecting effect.`
                    },
                    {
                        name:"Entrancing Aura",
                        abilityType:"Su",
                        description:`At level 7: You can emit a 30-foot aura of distraction, activating this is a standard action that costs 7 spell points, and 3 each round to maintain. Enemies within this aura take a -5 penalty on Perception checks and are treated as though they had 2 fewer Hit Dice (minimum 1 Hit Die) for the purpose of your effects that would give them the fascinated condition, and they take -1 penalty on saves against them. At 16th level, they are instead treated as if they had 3 fewer Hit Dice for such effects and take a -2 penalty against them.`
                    },
                ],
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x%3 == 0 || x == 1){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{type:{control:true}}}))
                        }
                    }
                         
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{type:{control:true}}}))
                    } 
                },
            },
            {
                name:"Community",
                description:`Your presence instills unity and strengthens emotional bonds.
                \nSpecial: Any numeric bonus a teamwork feat grants you increases by +1. When you are working with an ally that has a teamwork feat you also have, the bonus from the numeric bonus they gain from the feat increases by +1.
                \nBonus Rolls: At level 2 and every 6 levels thereafter, you gain a teamwork feat.`,
                perk1:[
                    {
                        name:"Calming Touch",
                        abilityType:"Sp",
                        description:`You can touch a creature as a standard action for 2 spell points to heal it of 1d6 points of nonlethal damage + 1 per level. This touch also removes the fatigued, shaken, and sickened conditions (but has no effect on more severe conditions).`,
                    },
                    {
                        name:"Synergistic Touch",
                        abilityType:"Sp",
                        description:`You can touch a creature as a standard action for level/2 spell points to confer upon it the benefits of any one Teamwork feat that you possess. This effect persists for a number of rounds equal to 1/2 your level (minimum 1).`
                    },
                    {
                        name:"Binding Ties",
                        abilityType:"Su",
                        description:`As a standard action for 2 spell points, you can touch an ally and remove one condition affecting the ally by transferring it to yourself. This transfer lasts a number of rounds equal to your level, but you can end it as a free action on your turn. At the end of this effect, the condition reverts to the original creature, unless it has ended or is removed by another effect. While this power is in use, the target is immune to the transferred condition.`
                    },
                ],
                perk2:[
                    {
                        name:"Unity",
                        abilityType:"Su",
                        description:`At level 7: Whenever a spell or effect targets you and one or more allies within 30 feet, you can use this ability to allow your allies to use your saving throw against the effect in place of their own. Each ally must decide individually before the rolls are made. Using this ability is an immediate action and costs level spell points.`
                    },
                    {
                        name:"Teaching Moment",
                        abilityType:"Su",
                        description:`At level 7: When you or an ally within 30 feet rolls a natural 1 or a natural 20 on an attack roll, an ability check, a skill check, or a saving throw, as an immediate action for 7 spell points you can grant all allies within 30 feet special insights that help them overcome similar challenges. Once during the next minute, each affected creature can choose to roll twice and take the better result before attempting an attack roll, ability check, skill check, or saving throw.`
                    },
                    {
                        name:"Class in Session",
                        abilityType:"Su",
                        description:`At level 7: As a standard action for 7 spell points you confer upon all creatures within 30 feet the benefits of any one Teamwork feat that you possess for 1 round per 3 levels.`
                    },
                ],
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x == 2 || (x-2)%6 == 0){
                            context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{teamwork:true}}))
                        }
                    }
                         
                },
                customMethod:(context)=>{
                    if((context.stats.characterStats.misc.level-2)%6 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"Feat",options:{teamwork:true}}))
                    } 
                },
            },
    
            {
                name:"Darkness",
                description:`Gain darkness based powers.
                \nSpecial: You gain darkvision 60 feet.
                \nBonus Rolls: Gain the blind-fight feat.`,
                perk1:[
                    {
                        name:"Touch of Darkness",
                        abilityType:"Sp",
                        description:`As a melee touch attack for 2 spell points, you can cause a creature's vision to be fraught with shadows and darkness. The creature touched treats all other creatures as if they had concealment, suffering a 20% miss chance on all attack rolls. This effect lasts for a number of rounds equal to 1/2 your level (minimum 1).`,
                    },
                    {
                        name:"Night Hunter",
                        abilityType:"Su",
                        description:`As a standard action for level/2 spell points, you can blend into the shadows of the night, becoming nearly invisible. As long as you are in an area of dim light or darkness, you are invisible (as per invisibility) to creatures without darkvision. This ability lasts for a number of rounds equal to 1/2 your level (minimum 1).`
                    },
                ],
                perk2:[
                    {
                        name:"Eyes of Darkness",
                        abilityType:"Su",
                        description:`At level 7: You can cause your vision to not become impaired by lighting conditions, even in absolute darkness and magic darkness. Doing so costs 5 spell points at the start of each of your turns.`
                    },
                    {
                        name:"Moonfire",
                        abilityType:"Su",
                        description:`At level 7: As a standard action for level/2 spell points you can shoot a blast of divine moonlight from your eyes, as a ranged touch attack against a single target within 30 feet. Moonfire deals 1d8 points of damage per 2 levels, and the target is dazzled for 1 round per level. Moonfire deals 1d10 points of damage per level against lycanthropes. `
                    },
                    {
                        name:"Aura of Forgetfulness",
                        abilityType:"Su",
                        description:`At level 7: You can emit a 30-foot aura of forgetfulness, activating this is a standard action that costs 7 spell points, and 3 each round to maintain. Creatures you target in this area must make a Will save or have no memory of any time spent inside the area. In addition, spellcasters in the area lose one prepared spell or available spell slot per round spent in the area, starting with 1st-level spells and going up through higher-level spells. Spellcasters are allowed a save each round to negate this loss (this save is separate from the memory loss save).`
                    },
                ],
                catchUpMethod:(context)=>{
                    let feat = feats.find(feat=>feat.name == "Blind-Fight")
                    feat.id = Math.random()
                    context.stats.lists.feats.push(feat)
                },
                customMethod:(context)=>{
                    context.doesNothing="donothing"
                },
            },
    
            {
                name:"Death",
                description:`You gain powers over death and find comfort in the presence of the dead.
                \nSpecial: When you channel negative energy to harm, the damage dice increases by 1 step and the DC to halve the damage increases by +2. Gain 20 negative spell power and 1% negative spell critical chance, but -20 positive spell power and -1% positive spell critical chance.
                \nBonus Rolls: Gain a necromancy spell at 1st and every 3rd level.`,
                perk1:[
                    {
                        name:"Bleeding Touch",
                        abilityType:"Sp",
                        description:`As a melee touch attack for 2 spell points, you can cause a living creature to take 1d6 points of damage per round. This effect persists for a number of rounds equal to 1/2 your level (minimum 1) or until stopped with a DC 15 Heal check or any spell or effect that heals damage.`,
                    },
                    {
                        name:"Necrotic Tending",
                        abilityType:"Sp",
                        description:`You can touch an undead creature or area affected by a haunt as a standard action for 2 spell points, restoring 1d8 hit points + 1 per level. This ability has no effect on other creatures. If used on yourself, you can do this as a swift action.`,
                    },
                    {
                        name:"Touch of Virulence",
                        abilityType:"Su",
                        description:`As a standard action for 2 spell points, you can touch a creature, making it feel sickened. The creature touched becomes sickened and takes a -4 penalty on any saves against disease or poison effects, though it can make a fortitude save to reduce the duration to 1 round and negate the penalty to poison and disease effects.`
                    },
                    {
                        name:"Death's Kiss",
                        abilityType:"Su",
                        description:`You can cause a creature to take on some of the traits of the undead with a melee touch attack for 2 spell points. Touched creatures are treated as undead for the purposes of effects that heal or cause damage based on positive and negative energy, or any death call from unquiet grave maneuvers. This effect lasts for a number of rounds equal to 1/2 your level (minimum 1). It does not apply to the Turn Undead or Command Undead feats.`
                    },
                ],
                perk2:[
                    {
                        name:"Death's Embrace",
                        abilityType:"Ex",
                        description:`At level 7: You heal damage instead of taking damage from channeled negative energy. If the channeled negative energy targets undead, you heal hit points just like undead in the area.`
                    },
                    {
                        name:"Killing Blow",
                        abilityType:"Su",
                        description:`At level 7: Weapons you use become infused with the power of death. Whenever you confirm a critical hit with a melee or ranged weapon, you can spend 7 spell points to cause your attack deals an additional amount of bleed damage equal to half your level.`
                    },
                    {
                        name:"Spirit Touch",
                        abilityType:"Su",
                        description:`At level 5: As a swift action for 5 spell points you can grant your weapons the ghost touch ability. You can maintain this ability at the start of each of your turns as a free action for 2 more spell points.`
                    },
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellPower.negative += 20
                    context.stats.characterStats.spellMastery.spellCriticalChance.negative += 2
                    context.stats.characterStats.spellMastery.spellPower.positive -= 20
                    context.stats.characterStats.spellMastery.spellCriticalChance.positive -= 1
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x == 1 || x%3 == 0){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{school:"necromancy"}}))
                        }
                    }
                         
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{school:"necromancy"}}))
                    }
                },
            },
    
            {
                name:"Destruction",
                description:`You revel in ruin and devastation, and can deliver particularly destructive attacks.
                \nSpecial: You gain a +1 bonus on melee damage rolls. Every 7 levels this increases by +1. Gain 15% elemental spell critical power, but -20 positive spell power.
                \nBonus Rolls: Gain a rage power at 1st, and additional one every 8 levels.`,
                perk1:[
                    {
                        name:"Destructive Smite",
                        abilityType:"Su",
                        description:`As a swift for 2 spell points your next melee attack this turn gains a morale bonus on damage equal to your half your level.`,
                    },
                    {
                        name:"Painful Smite",
                        abilityType:"Su",
                        description:`Prior to making a melee attack roll, for level/2 spell points you can choose to convert all damage from that strike into nonlethal damage, adding your highest mental modifier to the damage. If you succeed in your attack, as a free action you can make an Intimidate check against your target to demoralize the target. You gain a bonus on your Intimidate check equal to the amount of nonlethal damage dealt by the painful smite.`,
                    },
                ],
                perk2:[
                    {
                        name:"Destructive Aura",
                        abilityType:"Su",
                        description:`At level 7: You can emit a 30-foot aura of destruction, activating this is a standard action that costs 7 spell points, and 3 each round to maintain. All attacks made against targets in this aura (including you) gain a morale bonus on damage equal to 1/2 your level and all critical threats are automatically confirmed.`
                    },
                    {
                        name:"Deadly Weather",
                        abilityType:"Su",
                        description:`At level 7: You can unleash a furious call to the heavens as a standard action for 7 spell points, and the same amount to maintain at the start of each turn. This summons forth an everchanging storm of destruction. This storm has a radius of 5 feet per level. Each round, the storm has one of the following effects: driving rain (-4 on all Perception checks and ranged attack rolls), howling winds (-8 on Fly skill checks and ranged attack rolls), heavy snow (all terrain is considered difficult), or lightning bolt (as call lightning). Other effects depending on the weather might also apply (at the GM's discretion). You choose which effect takes place each round, but no effect may be repeated on the following round.`
                    },
                    {
                        name:"Hateful Aura",
                        abilityType:"Su",
                        description:`At level 7: You can emit a 30-foot aura of hatred, activating this is a standard action that costs 7 spell points, and 3 each round to maintain. Enemies within this aura must attempt a Will save (DC = 10 + 1/2 your level + your highest mental modifier). Characters who fail their save are filled with hatred, and cannot consider other characters allies for the purpose of any actions or use any teamwork feats. The effect ends immediately if the creature leaves the aura.`
                    },
                    {
                        name:"Fearsome Rage",
                        abilityType:"Su",
                        description:`At level 7: You can enter a fearsome rage like a barbarian, gaining a +4 morale bonus to strength and constitution, a +2 bonus to will saves, and a -2 penalty to armor class. When your rage ends, you are fatigued for rounds equal to the amount of rounds spent in the rage, and you cannot enter rage while fatigued. Activating rage is a free action, and costs 3 spell points to activate and maintain at the start of each of your turns. This stacks with any other rage perk you may have.`
                    },
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellCriticalDamage.fire += 15
                    context.stats.characterStats.spellMastery.spellCriticalDamage.cold += 15
                    context.stats.characterStats.spellMastery.spellCriticalDamage.acid += 15
                    context.stats.characterStats.spellMastery.spellCriticalDamage.electricity += 15
                    context.stats.characterStats.spellMastery.spellPower.positive -= 20
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x == 1 || x%8 == 0){
                            context.connection.send(JSON.stringify({command:"requestRoll", type:"Rage Power"}));
                        }
                    }
                         
                },
                customMethod:(context)=>{
                    if((context.stats.characterStats.misc.level-2)%6 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"Rage Power"}));
                    } 
                },
            },
    
            {
                name:"Earth",
                description:`You have mastery over earth, metal, and stone, can fire darts of acid, and command earth creatures.
                \nSpecial: You gain a +2 bonus to your natural armor. Gain 20 acid spell power and 20% acid spell critical power, but -25 electricity spell power and -2% electricity spell critical chance.
                \nBonus Rolls: At 1st and every 3 levels you gain an acid/earth spell.`,
                perk1:[
                    {
                        name:"Acid Dart",
                        abilityType:"Sp",
                        description:`As a standard action for 2 spell points, you can unleash an acid dart targeting any foe within 30 feet as a ranged touch attack. This acid dart deals 1d6 points of acid damage + 1 point per level and scales with 200% acid spell power. At level 7 you can activate this as a swift action for 10 spell points.`,
                    },
                    {
                        name:"Metal Fist",
                        abilityType:"Su",
                        description:`As a swift action for 2 spell points you can turn your fists to metal for 1 round. Your unarmed attacks to deal lethal damage, their damage is increased by 1 dice step, and they no longer provoke attaks of opportunity. Additionally, these unarmed strikes ignore the hardness of items with a hardness of 10 or less.`,
                    },
                    {
                        name:"Woe, Rock Be Upon Ye",
                        abilityType:"Su",
                        description:`The damage of your rocks increases by 3 dice steps, and they count as magic for dealing damage to creatures with DR and incorporeal creatures.`,
                    },
                    {
                        name:"Fossil Form",
                        abilityType:"Su",
                        description:`At the beginning of your turn as a swift action for 2 spell points, you can infuse your flesh with minerals, granting you cumbersome security. Until the beginning of your next turn, you are staggered, gain hardness 2, and gain a +2 bonus on saving throws against petrification. This hardness increases by 2 and your saving throw bonus increases by 1 for every 4 levels you have.`,
                    },
                    {
                        name:"Radiating Touch",
                        abilityType:"Su",
                        description:`As a standard action for 2 spell points that provokes attacks of opportunity, you can irradiate any unattended object for a number of rounds equal to your level. While an object is irradiated, it emits a faint aura of transmutation.
                        \nAny creature that passes within 5 feet of the aura must succeed at a Will save (DC equal to 10 + 1/2 level + your highest mental modifier) or become sickened. You're immune to this object's effect.`,
                    },
                    {
                        name:"Rusting Touch",
                        abilityType:"Su",
                        description:`You make a melee touch attack for 2 spell points against a creature wearing metal armor or wielding a metal weapon. If you hit, choose a metal weapon, suit of metal armor, or metal shield carried or worn by that creature. The object takes an amount of hit point damage equal to 1d6 + level. If the item is not magical, or if your caster level is greater than the item's caster level, this damage bypasses the item's hardness.`,
                    },
                ],
                perk2:[
                    {
                        name:"Acid Resistance",
                        abilityType:"Ex",
                        description:`At level 5: You gain resist acid 10. This resistance increases to 20 at 9th level. At 18th level, you gain immunity to acid.`
                    },
                    {
                        name:"Tunnel Runner",
                        abilityType:"Su",
                        description:`At level 7: Activating this ability is a standard action, lasts level/2 rounds, and costs level spell points. You can move across any stone surface as if under the effects of spider climb. You can also see very well in darkness, gaining darkvision out to a range of 60 feet. If you already possess darkvision, extend the range by 60 feet. While underground, you also gain an insight bonus equal to your level on Stealth skill checks and an insight bonus equal to your highest mental modifier on initiative checks.`
                    },
                    {
                        name:"Erosion Aura",
                        abilityType:"Ex",
                        description:`At level 7: As a standard action for 7 spell points you emit an burst of erosion for 1 round. Objects made primarily of metal or stone within this aura lose 10 points of hardness. Magic items retain a minimum hardness equal to twice their enhancement bonus and can attempt a Fortitude saving throw (DC = 10 + level/2 + highest mental modifier) to negate this effect. A construct made primarily of metal or stone must succeed at a Fortitude save or lose all damage reduction and hardness for 1 round.`
                    },
                    {
                        name:"Extreme Corrosion",
                        abilityType:"Su",
                        description:`At level 7: As a swift action for 8 spell points when you cast a spell with the acid descriptor, you can designate one creature within line of sight. The spell's damage against that creature increases by 50%, as if affected by the Empower Spell feat. This additional damage results from divine power that is not subject to being reduced by acid resistance, and you take an equal amount of acid damage immediately after you cast the spell. The spell can deal this additional damage only once, even if it could affect the target multiple times.`
                    },
                ],
                catchUpMethod:(context)=>{
                    context.stats.statsForAbilities.ac.natural += 2
                    context.stats.characterStats.spellMastery.spellPower.acid += 20
                    context.stats.characterStats.spellMastery.spellCriticalDamage.acid += 20
                    context.stats.characterStats.spellMastery.spellPower.electricity -= 25
                    context.stats.characterStats.spellMastery.spellCriticalChance.electricity -= 2
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%3 == 0 || x == 1){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["acid","earth"]}}))
                        }
                    }
                         
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["acid","earth"]}}))
                    }
                },
            },
    
            {
                name:"Evil",
                description:`You are sinister and cruel, and have wholly pledged your soul to the cause of evil.
                \nSpecial: You gain a +1 bonus on attacks against and saves against good creatures. This increases by +1 every 9 levels. Gain 15 negative spell power and 20% negative spell critical damage, but -20 positive spell power and -2% positive spell critical chance.
                \nBonus Rolls: Gain an evil spell at 1st and every 3rd level.`,
                perk1:[
                    {
                        name:"Touch of Evil",
                        abilityType:"Sp",
                        description:`You can cause a creature to become sickened as a melee touch attack for 2 spell points. Creatures sickened by your touch count as good for the purposes of spells with the evil descriptor. This ability lasts for a number of rounds equal to 1/2 level (minimum 1).`,
                    },
                    {
                        name:"Consume the Enemy",
                        abilityType:"Su",
                        description:`As a full-round action that provokes attacks of opportunity, you can bite a helpless living or freshly killed creature, dealing 1d3 points of damage. By consuming the creature's flesh, you gain a +1 profane bonus on saving throw DCs for all spells, spell-like abilities, and supernatural abilities you use against creatures of the same type (and subtype, if humanoid or outsider) as the cannibalized creature for minutes equal to level/2, or until you use this ability against a different creature.
                        \nAt 5th, 10th, 15th, and 20th level, this bonus increases by 1 (+5 maximum).`,
                    },
                    {
                        name:"Faith-Stealing Strike",
                        abilityType:"Su",
                        description:`For 2 spell points as a swift action when you are making a melee attack against a creature capable of casting divine spells you can activate this ability. If you damage the creature, it must succeed at a Will save (DC = 10 + 1/2 level + highest mental modifier) or be unable to cast any divine spells for 1 round. If you do not damage your target with the attack, this ability is expended with no effect.`
                    },
                    {
                        name:"Fury of the Abyss",
                        abilityType:"Su",
                        description:`As a swift action for level spell points, you can give yourself a bonus equal to 1/3 your level (minimum +1) on melee attacks, melee damage rolls, and combat maneuver checks. This bonus lasts for 1 round. During this round, you take a penalty to AC equal to 1/2 level.`
                    }, 
                    {
                        name:"Hell's Corruption",
                        abilityType:"Su",
                        description:`You can cause a creature to become more susceptible to corruption as a melee touch attack for 2 spell points. Creatures touched take a -2 penalty on all saving throws and must roll all opposed skill checks twice, taking the worse result. This effect lasts for a number of rounds equal to 1/2 your level (minimum 1).`
                    },
                    {
                        name:"Touch of Virulence",
                        abilityType:"Su",
                        description:`As a standard action for 2 spell points, you can touch a creature, making it feel sickened. The creature touched becomes sickened and takes a -4 penalty on any saves against disease or poison effects, though it can make a fortitude save to reduce the duration to 1 round and negate the penalty to poison and disease effects.`
                    },
                ],
                perk2:[
                    {
                        name:"Scythe of Evil",
                        abilityType:"Su",
                        description:`At level 7: For 7 spell points you can give a weapon touched the unholy special weapon quality for a number of rounds equal to 1/2 your level.`
                    },
                    {
                        name:"Spark Malfeasance",
                        abilityType:"Su",
                        description:`At level 7: You can awaken the sinful desires of a target within 30 feet with a ranged touch attack for 7 spell points. The target suffers extreme guilt and is sickened for a number of rounds equal to 1/2 your level. To end the effect earlier, the target can willingly commit an evil act, such as betraying and attacking an ally, or attempt a Will save (DC = 10 + 1/2 level + your highest mental modifier) at the beginning of its turn each round. Creatures that succeed at their saving throws are immune to this ability for 24 hours.`
                    },
                    {
                        name:"Whispering Evil",
                        abilityType:"Su",
                        description:`At level 7: You whisper a hypnotizing litany of empty promises that affects creatures within a 30-foot aura. Activating this is a standard action that costs 7 spell points, and 3 each round to maintain. Each enemy that can hear you must succeed on a Will saving throw or become fascinated for as long as you continue the litany. This is a mind-affecting effect.`
                    },
                    {
                        name:"Feed on Fear",
                        abilityType:"Su",
                        description:`At level 7: As an immediate action for 7 spell points upon successfully hitting a creature with a melee attack that's already suffering from a fear effect, you deal 2d6 extra points of damage and gain that amount in temporary hit points. These temporary hit points last for 24 hours or until lost.`
                    },
                    {
                        name:"Pain Is Power",
                        abilityType:"Su",
                        description:`At level 7: After taking damage from any source, you may attempt a DC 25 concentration check as an immediate action for 12 spell points. If you succeed, you gain the benefits of a blessing of fervor spell for a number of rounds equal to 1/2 your level. If you fail, this ability is expended with no effect.`
                    },
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellPower.negative += 15
                    context.stats.characterStats.spellMastery.spellCriticalDamage.negative += 20
                    context.stats.characterStats.spellMastery.spellPower.positive -= 20
                    context.stats.characterStats.spellMastery.spellCriticalChance.positive -= 2
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x == 1 || x%3 == 0){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["evil"]}}))
                        }
                    }
                         
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["evil"]}}))
                    } 
                },
            },
    
            {
                name:"Animal",
                description:`You can speak with and befriend animals with ease.
                \nSpecial: You gain a bonus on knowledge nature and survival checks equal to your half level.
                \nBonus Rolls: At level 1 you gain the summon natures ally spell. Every 3 levels thereafter, you gain the next level higher of summon nature's ally spell.`,
                perk1:[
                    {
                        name:"Charm Animals",
                        abilityType:"Su",
                        description:`As a swift action for 2 spell points you can attempt to charm an animal within 30 feet of you. It makes a will save (dc=10+level/2+ highest mental modifier) or it becomes charmed for 1 round, however you can spend an additional spell point each round to maintain this effect. Once an animal has saved from it, it becomes immune to further uses.`,
                    },
                    {
                        name:"Eyes of the Hawk",
                        abilityType:"Ex",
                        description:`You gain a bonus on perception checks equal to level/2. In addition you gain your highest mental modifier as a bonus to initiative checks.`,
                    },
                    {
                        name:"Predator's Grace",
                        abilityType:"Su",
                        description:`You can, as a swift action for 2 spell points, grant yourself a +10-foot bonus to your base speed for 1 round. This bonus increases by 5 feet for every 5 levels you possess. In addition, you gain low-light vision for 1 round. If you already possess low-light vision, the range of your sight becomes three times that of a human in dim light for 1 round.`
                    },
                    {
                        name:"Exoskeleton",
                        abilityType:"Su",
                        description:`As a swift action for 2 spell points, you can grow an exoskeleton that grants you a +1 enhancement bonus to your natural armor and 1d4 temporary hit points + 1 per levels. The natural armor bonus increases by 1 for every 5 levels you have. The exoskeleton retracts after 1 round, ending its benefits.`
                    }, 
                ],
                perk2:[
                    {
                        name:"Animal Companions",
                        abilityType:"Su",
                        description:`At level 3: Your summon nature's ally spells last 1 minute per level instead of 1 round per level. At level 7 casting a summon nature's ally spell takes only a full-round action instead of 1 round. At level 11 you can cast them as a standard action instead.`
                    },
                    {
                        name:"Beastial Wrath",
                        abilityType:"Su",
                        description:`At level 3: You gain 2 claw attacks and a bite attack. These are all primary attacks and deal 1d4 points of damage.`
                    },
                ],
                catchUpMethod:(context)=>{
                    let spellNames = ["Summon Nature's Ally II", "Summon Nature's Ally III", "Summon Nature's Ally IV", "Summon Nature's Ally V", "Summon Nature's Ally VI", "Summon Nature's Ally VII", "Summon Nature's Ally VIII", "Summon Nature's Ally IX"] 
                    let spell = spells.find(spell=> spell.name == "Summon Nature's Ally I")
                    spell.id = Math.random()
                    context.stats.lists.spells.push(spell)
    
                    let spellsLeft = Math.floor(context.stats.characterStats.misc.level/3)
    
                    while(spellsLeft<0){
                        let spell = spells.find(spell=> spell.name == spellNames[spellsLeft-1])
                        spell.id = Math.random()
                        context.stats.lists.spells.push(spell)
                        spellsLeft--
                    }
                },
                customMethod:(context)=>{
                    let spellNames = ["Summon Nature's Ally II", "Summon Nature's Ally III", "Summon Nature's Ally IV", "Summon Nature's Ally V", "Summon Nature's Ally VI", "Summon Nature's Ally VII", "Summon Nature's Ally VIII", "Summon Nature's Ally IX"] 
                    if(context.stats.characterStats.misc.level%3 == 0){
                        let spellsToGive = Math.floor(context.stats.characterStats.misc.level/3)
                        let spell = spells.find(spell=> spell.name == spellNames[spellsToGive-1])
                        spell.id = Math.random()
                        context.stats.lists.spells.push(spell)
                    }
                },
            },
    
            {
                name:"Fire",
                description:`You can call forth fire, and command creatures of the inferno.
                \nSpecial: Gain 20 fire spell power and 2% fire spell critical chance, but -25 cold spell power and -4% cold spell critical chance. Your critical fire spells catch creatures on fire which deals 1d6 + highest mental modifier fire damage immediately, and at the start of each of their turns (free action at the start of each of their turns to put the fire out with a reflex save DC 10 + level/2 + highest mental modifier. Stacks with other sources of being on fire).
                \nBonus Rolls: You gain a bonus fire spell at 1st and every 3 levels.`,
                perk1:[
                    {
                        name:"Fire Bolt",
                        abilityType:"Sp",
                        description:`As a standard action for 2 spell points, you can unleash a scorching bolt of divine fire from your outstretched hand. You can target any single foe within 30 feet as a ranged touch attack with this bolt of fire. If you hit the foe, the fire bolt deals 1d6 points of fire damage + 1 point per level. At level 7 you can activate this as a swift action for 10 spell points. This scales with 200% fire spell power.`,
                    },
                    {
                        name:"Smoke",
                        abilityType:"Sp",
                        description:`As a standard action for 2 spell points, you can create a 5-foot-radius cloud of smoke. This power has a range of 30 feet. Creatures inside the cloud take a -2 penalty on attack rolls and Perception skill checks for as long as they remain inside and for 1 round after exiting the cloud. Creatures inside the cloud gain concealment from attacks made by opponents that are not adjacent to them.`,
                    },
                    {
                        name:"Arson",
                        abilityType:"Sp",
                        description:`As a standard action for 2 spell points, you can fire a bolt of fire as a ranged touch attack, if it hits, the creature or flammable object catches on fire. On top of the normal fire damage each round, they also take 1 stack of immolation (see burning citadel).`,
                    },
                ],
                perk2:[
                    {
                        name:"Fire Resistance",
                        abilityType:"Ex",
                        description:`At level 5: you gain resist fire 10. This resistance increases to 20 at 9th level. At 18th level, you gain immunity to fire.`
                    },
                    {
                        name:"Wall of Ashes",
                        abilityType:"Su",
                        description:`At level 7: You can create a wall of swirling ashes anywhere within 100 feet for level spell points. This wall is up to 20 feet high and up to 10 feet long per level. The wall of ash blocks line of sight, and any creature passing through it must make a Fortitude save or be blinded for 1d4 rounds. The wall of ash reveals invisible creatures that are inside it or adjacent to it, although they become invisible again if they move away from the wall. This wall lasts 1 minute.`
                    },
                    {
                        name:"Burning Purge",
                        abilityType:"Su",
                        description:`At level 7: As a swift action for 8 spell points when you cast a spell with the fire descriptor, you can designate one creature within line of sight. The spell's damage against that creature increases by 50%, as if it had +50 spell power. This additional damage results from divine power that is not subject to being reduced by fire resistance, and you take an equal amount of fire damage immediately after you cast the spell. The spell can deal this additional damage only once, even if it could affect the target multiple times.`
                    },
                    {
                        name:"Phoenix Fire",
                        abilityType:"Su",
                        description:`At level 7: Once per day when casting a fire spell, you can modify by increasing the cost of the spell by 50%. Doing so makes the fire spell deal no damage to allies, instead healing them for 50% of the damage it would deal. At level 9 and 18 you can do this an additional time.`
                    },
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellPower.fire += 20
                    context.stats.characterStats.spellMastery.spellCriticalChance.fire += 2
                    context.stats.characterStats.spellMastery.spellCriticalChance.cold -= 4
                    context.stats.characterStats.spellMastery.spellCriticalDamage.cold -= 25
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%3 == 0 || x == 1){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["fire"]}}))
                        }
                    }
                    
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["fire"]}}))
                    }
                },
            },
    
            {
                name:"Glory",
                description:`You are infused with the glory of the divine, and are a true foe of the undead.
                \nSpecial: Once per day you can add 1d6 to any d20 roll you just made. Every 6 levels you can do this an additional time per day. When you channel positive energy to harm undead, the DC increases by +2. 
                \nBonus Rolls: At 1st and every 3 levels you gain a buff spell.`,
                perk1:[
                    {
                        name:"Touch of Glory",
                        abilityType:"Sp",
                        description:`You can cause your hand to shimmer with divine radiance, allowing you to touch a creature as a standard action for 2 spell points and give it a bonus equal to your level on a single Charisma-based skill check or Charisma ability check. This ability lasts for 1 hour or until the creature touched elects to apply the bonus to a roll.`,
                    },
                    {
                        name:"Honor Bound",
                        abilityType:"Su",
                        description:`With a touch, and for 2 spell points, you can remind a creature of its duties and responsibilities, granting it a new saving throw against each enchantment (charm) or enchantment (compulsion) effect that currently affects it. If the saving throw is successful, the enchantment effect is ended. This power only affects effects that allow a save. If you fail a save against such an effect, you can use this ability as an immediate action to grant yourself an additional save. Once the target (either you or a touched creature) has made one additional save per effect, this ability has no further effect on that particular enchantment effect.`,
                    },
                ],
                perk2:[
                    {
                        name:"Divine Presence",
                        abilityType:"Su",
                        description:`At level 7: You can emit a 30-foot aura of divine presence, activating this is a standard action that costs 7 spell points, and 3 each round to maintain. All allies within this aura are treated as if under the effects of a sanctuary spell with a DC equal to 10 + 1/2 your level + your highest mental modifier. If an ally leaves the area or makes an attack, the effect ends for that ally until you activate it again, maintaining the aura does not reset it. If you make an attack, the effect ends for you and your allies.`
                    },
                    {
                        name:"Aura of Heroism",
                        abilityType:"Su",
                        description:`At level 7: You can emit a 30-foot aura of divine presence, activating this is a swift action that costs 7 spell points, and 3 each round to maintain. Allies in the area are treated as if they were under the effects of heroism.`
                    },
                    {
                        name:"Divine Demand",
                        abilityType:"Su",
                        description:`At level 5: Activating this ability is a swift action and costs 5 spell points that you must use as you cast a spell that has a reduced (but not negated) effect on a successful save. The saving throw DC of the spell increases by 2, and you gain a +2 bonus on caster level checks to overcome spell resistance with the spell.
                        \nAny creature that succeeds at the saving throw instead avoids the effect entirely. If half or more of the targets are unaffected, you become shaken for a number of rounds equal to the spell's level. If all of the targets are unaffected, you instead lose the ability to cast divine spells, channel energy, and use domain powers for 1d4 rounds; you can end this loss as a full-round action by loudly apologizing to your patron deity as a full-round action that provokes attacks of opportunity.`
                    },
                    {
                        name:"Witness the Legend",
                        abilityType:"Su",
                        description:`At level 7: As a move action for 7 spell points, you can extol the virtues of yourself or an ally within 60 feet that you can see. This causes the target to shed light like a torch for 1 minute, and while the effect lasts, you can expend a 4 spell points as an immediate action to add 1d6 to an attack, saving throw, skill check, or ability check attempted by the target; for a roll to confirm a critical hit or save against a fear effect, you instead add 1d12.`
                    },
                ],
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%3 == 0 || x == 1){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{type:{buff:true}}}))
                        }
                    }
                    
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{type:{buff:true}}}))
                    }
                },
            },
    
            {
                name:"Good",
                description:`You have pledged your life and soul to goodness and purity.
                \nSpecial: You gain a +1 bonus on attacks and on saves against evil creatures. At level 9 and 18 this increases by +1. You gain 2% positive and fire spell critical chance, 20% positive and fire spell critical damage, but -2% spell critical chance and -20% spell critical damage for negative and other elemental spells.
                \nBonus Rolls: You gain a good spell at 1st and every 3 levels.`,
                perk1:[
                    {
                        name:"Touch of Good",
                        abilityType:"Sp",
                        description:`You can touch a creature as a standard action for 2 spell points, granting a sacred bonus on attack rolls, skill checks, ability checks, and saving throws equal to half your level (minimum 1) for 1 round.`,
                    },
                    {
                        name:"Elysium's Call",
                        abilityType:"Su",
                        description:`With a touch, for 2 spell points you can imbue creatures with the spirit of Elysium, lifting their spirits and freeing them from bonds. The creatures touched can immediately reroll any failed saving throws against spells and spell-like abilities of the enchantment (charm) and enchantment (compulsion) subschools. In addition, targets receive a +2 sacred bonus on such saving throws and a +2 sacred bonus on CMB checks to escape a grapple. Finally, targets can ignore up to 5 feet of difficult terrain each round, as if they had the Nimble Moves feat. These bonuses last for a number of rounds equal to 1/2 your level (minimum 1), although the saving throw reroll only applies when the creature is touched.`
                    },
                ],
                perk2:[
                    {
                        name:"Holy Lance",
                        abilityType:"Su",
                        description:`At level 7: For 7 spell points as a standard action you can give a weapon you touch the holy special weapon quality for a number of rounds equal to 1/2 your level.`
                    },
                    {
                        name:"Protective Aura",
                        abilityType:"Su",
                        description:`At level 7: You can emit a 30-foot aura of protection, activating this is a standard action that costs 7 spell points, and 3 each round to maintain. Allies in this aura receive a +2 deflection bonus to AC and a +2 resistance bonus on all saving throws. In addition, allies in the area gain the benefits of protection from evil (although the AC bonus and saving throw bonus do not stack with those granted by this effect).`
                    },
                    {
                        name:"Aura of Menace",
                        abilityType:"Su",
                        description:`At level 7: You can emit a 30-foot aura of menace, activating this is a standard action that costs 7 spell points, and 3 each round to maintain. Enemies in this aura take a -2 penalty to AC and on attacks and saves as long as they remain inside the aura.`
                    },
                    {
                        name:"Aura of Redemption",
                        abilityType:"Su",
                        description:`At level 7: You can emit a 30-foot aura of sanctification, activating this is an immediate action that costs 7 spell points, and 3 each round to maintain. Within this aura, effects that are specifically harmful to good-aligned creatures are inverted so that they no longer harm good creatures and instead harm evil creatures. Similarly, effects that are specifically beneficial to evil creatures instead become beneficial only to good creatures.`
                    },
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellCriticalChance.positive += 2
                    context.stats.characterStats.spellMastery.spellCriticalChance.fire += 2
                    context.stats.characterStats.spellMastery.spellCriticalDamage.positive += 20
                    context.stats.characterStats.spellMastery.spellCriticalDamage.fire += 20
                    context.stats.characterStats.spellMastery.spellCriticalChance.negative -= 2
                    context.stats.characterStats.spellMastery.spellCriticalDamage.negative -= 20
                    context.stats.characterStats.spellMastery.spellCriticalChance.cold -= 2
                    context.stats.characterStats.spellMastery.spellCriticalDamage.cold -= 20
                    context.stats.characterStats.spellMastery.spellCriticalChance.acid -= 2
                    context.stats.characterStats.spellMastery.spellCriticalDamage.acid -= 20
                    context.stats.characterStats.spellMastery.spellCriticalChance.electricity -= 2
                    context.stats.characterStats.spellMastery.spellCriticalDamage.electricity -= 20
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%3 == 0 || x == 1){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["good"]}}))
                        }
                    }
                    
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["good"]}}))
                    }
                },
            },
    
            {
                name:"Healing",
                description:`Your touch staves off pain and death, and your healing magic is particularly vital and potent.
                \nSpecial: You gain 20 positive spell power, 2% positive spell critical chance, and 15% positive spell critical power, but -15 elemental and negative spell power and -1% elemental and negative spell critical chance, and -15% spell critical damage for other elemental and negative spells.
                \nBonus Rolls: A healing spell at 1st and every 3rd level.`,
                perk1:[
                    {
                        name:"Rebuke Death",
                        abilityType:"Sp",
                        description:`You can touch a living creature as a standard action for 1 spell point, healing it for 1d4 + level points of damage. This scales with 200% positive spell power, including channel specific spell power. You can only use this ability on a creature that is below 0 hit points. At level 7 you can activate for 3 spell points this when you cast any healing spell or use a perk that heals a creature as long as it is below 0 hit points, adding this additional healing to that effect for the ally.`,
                    },
                    {
                        name:"Blessed Surgery",
                        abilityType:"Su",
                        description:`You can use this ability for 2 spell points when you are using a heal check to heal a creature. You roll twice and take the higher result, and any healing you would do with that check is doubled. You can use patch up as a full-round action.`,
                    },
                    {
                        name:"Restorative Touch",
                        abilityType:"Su",
                        description:`As a standard action for 4 spell points your touch can remove the dazed, fatigued, shaken, sickened, or staggered condition. You choose which condition is removed.`,
                    },
                    {
                        name:"Selfish Channel",
                        abilityType:"Su",
                        description:`As a swift action for dice rolled spell points you can heal yourself for 1d6 hit points, increasing by 1d6 every odd level after 1st. This counts as channeling energy, though does not allow you to meet any prerequisites for having channel energy.`,
                    },
                    
                ],
                perk2:[
                    {
                        name:"Healer's Blessing",
                        abilityType:"Su",
                        description:`At level 5: Gain 30 positive spell power. This does not apply to damage dealt to undead with a cure spell or to your channel energy healing.`
                    },
                    {
                        name:"Gift of Life",
                        abilityType:"Su",
                        description:`At level 7: You can touch a creature that has died within the past minute and for level spell points grant it a few moments of life. The dead creature returns to life for a number of rounds equal to your level. Creatures returned to life in this way have a number of hit points equal to half your level, and continue to be affected by any still-active spells, conditions, or afflictions present at the time of their death. At the end of this time, the creature dies again. The creature is free to act as it sees fit during this time. You are granted no control over it.`
                    },
                    {
                        name:"Divine Conduit",
                        abilityType:"Su",
                        description:`At level 5: Your channel energy gains 50 spell power.`
                    },
                    {
                        name:"Enduring Connection",
                        abilityType:"Su",
                        description:`At level 5: Using your channel energy has its cost reduced to 1 spell point per dice rolled.`
                    },
                    {
                        name:"Swift Channeler",
                        abilityType:"Su",
                        description:`At level 5: You can double the cost of your channel energy to use it as a movement action.`
                    },
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellPower.positive += 20
                    context.stats.characterStats.spellMastery.spellCriticalChance.positive += 2
                    context.stats.characterStats.spellMastery.spellCriticalDamage.positive += 15
                    let otherTypes = ["negative","cold","acid","electricity","fire"]    
                    for(let x = 0; x < otherTypes.length; x++){
                        context.stats.characterStats.spellMastery.spellPower[otherTypes[x]] -= 15
                        context.stats.characterStats.spellMastery.spellCriticalChance[otherTypes[x]] -= 1
                        context.stats.characterStats.spellMastery.spellCriticalDamage[otherTypes[x]] -= 15
                    }
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%3 == 0 || x == 1){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{type:{healing:true}}}))
                        }
                    }
                    
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{type:{healing:true}}}))
                    }
                },
            },
    
            {
                name:"Knowledge",
                description:`You are a scholar and a sage of legends.
                \nSpecial: gain a bonus on all knowledge checks equal to 1/3 your level.
                \nBonus Rolls: Gain a skill roll at 1st and every 3rd level.`,
                perk1:[
                    {
                        name:"Recall",
                        abilityType:"Su",
                        description:`For level/2 spell points and a touch you can cause a creature to recall some bit of forgotten lore or information. The creature can retry any Knowledge skill check it has made within the past minute, gaining a insight bonus on the check equal to your highest mental modifier. This ability can only be used for a specific check once.`,
                    },
                ],
                perk2:[
                    {
                        name:"Void Form",
                        abilityType:"Su",
                        description:`At level 5: You can become semi-tangible as a standard action for level/2 spell points, and maintain it at the start of each of your turns for the same amount as a free action. While in this form, you are immune to critical hits and gain a +1 deflection bonus to AC. This bonus increases by 1 at 7th level and every 3 levels thereafter.`
                    },
                    {
                        name:"Teaching Moment",
                        abilityType:"Su",
                        description:`At level 7: When you or an ally within 30 feet rolls a natural 1 or a natural 20 on an attack roll, an ability check, a skill check, or a saving throw, as an immediate action for level spell points you can grant all allies within 30 feet special insights that help them overcome similar challenges. Once during the next minute, each affected creature can choose to roll twice and take the better result before attempting an attack roll, ability check, skill check, or saving throw.`
                    },
                ],
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%3 == 0 || x == 1){
                            context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{skills:true}}}))
                        }
                    }
                    
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"stats", options:{type:{skills:true}}}))
                    }
                },
            },
    
            {
                name:"Law",
                description:`You follow a strict and ordered code of laws, and in so doing, achieve enlightenment.
                \nSpecial: You gain a +1 bonus on attacks and on saves against chaotic creatures. Every 9 levels this increases by +1.
                \nBonus Rolls: At level 1 you gain protection from chaos, at level 5 you gain protection from chaos communal, at level 9 you gain circle against chaos. At level 14, once per day you can cast one of these spells as a swift action.`,
                perk1:[
                    {
                        name:"Touch of Law",
                        abilityType:"Sp",
                        description:`You can touch a willing creature as a standard action for 3 spell points, infusing it with the power of divine order and allowing it to treat all attack rolls, skill checks, ability checks, and saving throws for 1 round as if the natural d20 roll resulted in an 11. `,
                    },
                    {
                        name:"Hell's Corruption",
                        abilityType:"Su",
                        description:`You can cause a creature to become more susceptible to corruption as a melee touch attack for level/2 spell points. Creatures touched take a -2 penalty on all saving throws and must roll all opposed skill checks twice, taking the worse result. This effect lasts for a number of rounds equal to 1/2 your level (minimum 1).`
                    },
                    {
                        name:"Command",
                        abilityType:"Su",
                        description:`As a standard action for 2 spell points you can give a creature an emotionless yet undeniable order, as per the spell command. A Will save negates this effect. You cannot target a creature more than once per day with this ability.`
                    },
                    {
                        name:"Chastisement",
                        abilityType:"Su",
                        description:`As a standard action, for the cost of the spell + 2, you can cast a strengthened spell against a creature that damaged you since your last turn. This spell must target the creature that damaged you, and is cast at +1 caster level. Area of effect spells cannot be used in conjunction with this ability, but other spells that target multiple creatures may be.`
                    },
                    {
                        name:"Prohibition",
                        abilityType:"Su",
                        description:`As a standard action for 2 spell points, you can command a creature within 30 feet to refrain from committing a particular action (including any referenced in the spell forbid action). If the creature performs the named action before the beginning of your next turn, it takes 1d6 points of damage + 1 point per levels and the effect ends. This is a language-dependent effect.`
                    },
                    {
                        name:"Touch of Loyalty",
                        abilityType:"Su",
                        description:`As a standard action for 3 spell points, you can touch a willing creature, granting it a +4 sacred bonus on saving throws to resist charm, compulsion, and fear effects for 1 hour.`
                    },
                ],
                perk2:[
                    {
                        name:"Staff of Order",
                        abilityType:"Su",
                        description:`At level 7: For 8 spell points as a standard action you can give a weapon touched the axiomatic special weapon quality for a number of rounds equal to 1/2 your level.`
                    },
                    {
                        name:"Aura of Menace",
                        abilityType:"Su",
                        description:`At level 7: You can emit a 30-foot aura of menace, activating this is a standard action that costs 7 spell points, and 3 each round to maintain. Enemies in this aura take a -2 penalty to AC and on attacks and saves as long as they remain inside the aura.`
                    },
                    {
                        name:"Pain Is Power",
                        abilityType:"Su",
                        description:`At level 7: After taking damage from any source, you may attempt a DC 25 concentration check as an immediate action for level spell points. If you succeed, you gain the benefits of a blessing of fervor spell for a number of rounds equal to 1/2 your level. If you fail, this ability is expended with no effect.`
                    },
                    {
                        name:"Master's Yoke",
                        abilityType:"Su",
                        description:`At level 7: you can attempt to assert your dominance over any visible creature within 30 feet by declaring the target your property, this costs level/2 spell points. The target can resist this effect with a successful Will save. If the target fails the save, it is affected as if by dominate monster for a number of rounds equal to 1/2 level, save that the target can choose to ignore any order you give and instead take 2 points of Constitution damage and become staggered for 1 round. This is a language-based mind-affecting effect.`
                    },
                    {
                        name:"Tyrannical Strike",
                        abilityType:"Su",
                        description:`At level 7: As an immediate action for level/2 spell points upon successfully hitting an opponent with a melee attack, you can choose to forgo the damage (but not any other effects of the attack) to instead affect the creature you hit as a greater command spell, with a caster level equal to your level.`
                    },
                ],
                catchUpMethod:(context)=>{
                    let spell = spells.find(spell=>spell.name == "Protection from Chaos")
                    spell.id = Math.random()
                    context.stats.lists.spell.push(spell)
                    if(context.stats.characterStats.misc.level >= 5){
                        spell = spells.find(spell=>spell.name == "Protection from Chaos, Communal")
                        spell.id = Math.random()
                        context.stats.lists.spell.push(spell)
                    }
                    if(context.stats.characterStats.misc.level >= 9){
                        spell = spells.find(spell=>spell.name == "Circle Against Chaos")
                        spell.id = Math.random()
                        context.stats.lists.spell.push(spell)
                    }
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level == 5){
                        let spell = spells.find(spell=>spell.name == "Protection from Chaos, Communal")
                        spell.id = Math.random()
                        context.stats.lists.spell.push(spell)
                    }
                    if(context.stats.characterStats.misc.level == 9){
                        let spell = spells.find(spell=>spell.name == "Circle Against Chaos")
                        spell.id = Math.random()
                        context.stats.lists.spell.push(spell)
                    }
                },
            },
    
            {
                name:"Liberation",
                description:`You are a spirit of freedom and a staunch foe against all who would enslave and oppress.
                \nSpecial: When you cast a healing spell that removes a condition, you count as 2 levels higher for it. gain 10 positive spell power.
                \nBonus Rolls: A healing spell at 1st and every 3rd level.`,
                perk1:[
                    {
                        name:"Liberation",
                        abilityType:"Su",
                        description:`You have the ability to ignore impediments to your mobility. As a free action for level/2 spell points, you can move normally regardless of magical effects that impede movement, as if you were affected by freedom of movement for 1 round. This effect occurs automatically as soon as it applies.`,
                    },
                    {
                        name:"Liberty's Blessing",
                        abilityType:"Sp",
                        description:`You touch a willing creature as a standard action for 2 spell points, granting it a boon. A creature with this boon can, as a swift action, make a saving throw against a single spell or effect it is suffering from that grants a save. The DC of the saving throw is equal to the original DC of the spell or effect. If the saving throw is successful, the effect ends. This boon lasts for 1 minute or until successfully used to remove a spell or effect, whichever duration is shorter.`,
                    },
                    {
                        name:"Perfected Form",
                        abilityType:"Su",
                        description:`You gain a +1 sacred (if you're good or neutral) or profane (if you're evil) bonus on saving throws against polymorph, petrification, and transmutation effects. This bonus increases by 1 for every 5 levels you have (maximum +5). Once per day when you succeed at a saving throw against such an effect, you can gain a surge of self-confidence as an immediate action that grants you a number of temporary hit points equal to your level and a +2 morale bonus on attack rolls, skill checks, and saving throws; both effects last for 1 minute.`,
                    },
                ],
                perk2:[
                    {
                        name:"Freedom's Call",
                        abilityType:"Su",
                        description:`At level 7: You can emit a 30-foot aura of freedom, activating this is a standard action that costs 7 spell points, and 3 each round to maintain. Allies within this aura are not affected by the confused, grappled, frightened, panicked, paralyzed, pinned, or shaken conditions. This aura only suppresses these effects, and they return once a creature leaves the aura or when the aura ends, if applicable.`
                    },
                    {
                        name:"Powerful Persuader",
                        abilityType:"Su",
                        description:`At level 7: When you make a Diplomacy or Intimidate check, you can roll twice and take the higher result. Using this ability is a free action that you can take even when not your turn, and costs 7 spell points.`
                    },
    
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellPower.positive += 10
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%3 == 0 || x == 1){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{type:{healing:true}}}))
                        }
                    }
                    
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{type:{healing:true}}}))
                    }
                },
            },
    
            {
                name:"Luck",
                description:`You are infused with luck, and your mere presence can spread good fortune.
                \nSpecial: once per day you can reroll any natural 1 you just rolled. Every 6 levels you can do this an additional time per day. Gain 2% universal spell critical chance.
                \nBonus Rolls: Every time you level up you have a 50% chance to gain 20 gold, and a 5% chance to lose 40 gold.`,
                perk1:[
                    {
                        name:"Bit of Luck",
                        abilityType:"Sp",
                        description:`You can touch a willing creature as a standard action for level/2 spell points, giving it a bit of luck. For the next round, any time the target rolls a d20, he may roll twice and take the more favorable result.`,
                    },
                    {
                        name:"Malign Eye",
                        abilityType:"Su",
                        description:`As a standard action for 2 spell points, you can afflict one target within 30 feet with your malign eye, causing it to take a -2 penalty on all saving throws against your spells. The effect lasts for 1 minute or until the target hits you with an attack.`,
                    },
                    {
                        name:"Fortune's Favoured",
                        abilityType:"Su",
                        description:`Whenever you gain a luck bonus, increase the bonus gained by +1. At level 9 and 18 this increases by +1.`,
                    },
                ],
                perk2:[
                    {
                        name:"Good Fortune",
                        abilityType:"Ex",
                        description:`At level 5: as an immediate action for level spell points, you can reroll any one d20 roll you have just made before the results of the roll are revealed, and you get a +1d6 bonus on the reroll. You must take the result of the reroll, even if it's worse than the original roll.`
                    },
                    {
                        name:"Haze of Daydreams",
                        abilityType:"Su",
                        description:`At level 5: As a standard action for 5 spell points you can emit a 15-foot-radius haze of daydreams, and 2 points each round to maintain. Creatures within the haze gain the fascinated condition unless they succeed at a Will save (DC equal to 10 + 1/2 level + highest mental modifier). You may designate a number of creatures equal to your level that are not affected by the haze. The fascinated condition ends immediately when the creatures leave the area or the aura expires.`
                    },
                    {
                        name:"Tugging Strands",
                        abilityType:"Su",
                        description:`At level 7: For 7 + level spell points you can force a creature within line of sight to reroll any one roll that it has just made before the result of the roll is revealed. The result of the reroll must be taken, even if it is worse than the original roll. You can only activate this once per round.`
                    },
    
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellCriticalChance.universal += 2
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        let rng = Math.random()
                        if(rng > 0.5){
                            context.stats.gold += 20
                        }else if(rng <= 0.05){
                            context.stats.gold =- 40
                        }
                    }
                    
                },
                customMethod:(context)=>{
                    let rng = Math.random()
                    if(rng > 0.5){
                        context.stats.gold += 20
                    }else if(rng <= 0.05){
                        context.stats.gold =- 40
                    }
                },
            },
    
            {
                name:"Madness",
                description:`You embrace the madness that lurks deep in your heart, and can unleash it to drive your foes insane or to sacrifice certain abilities to hone others.
                \nSpecial: Enemies take a -1 penalty on will saves as long as they are within 30 feet of you. This increases to -2 at level 9, and -3 at level 18.
                \nBonus Rolls: A control spell at 1st and every 3rd level.`,
                perk1:[
                    {
                        name:"Vision of Madness",
                        abilityType:"Sp",
                        description:`You can give a creature a vision of madness as a melee touch attack for 2 spell points. Choose one of the following: attack rolls, saving throws, or skill checks. The target receives a bonus to the chosen rolls equal to ½ your level (minimum +1) and a penalty to the other two types of rolls equal to ½ your level (minimum -1). This effect fades after 3 rounds.`,
                    },
                    {
                        name:"Insane Focus",
                        abilityType:"Su",
                        description:`You can touch a willing creature as a standard action for 2 spell points, granting it a +4 bonus on all saving throws made against mind-affecting effects and immunity to confusion. This bonus lasts for 1 minute. If the creature fails a saving throw against a mind-affecting effect during this period, it loses its immunity to confusion and is immediately confused for one round.`,
                    },
                    {
                        name:"Fearful Touch",
                        abilityType:"Su",
                        description:`As a standard action for 2 spell points, you can make a melee touch attack against a creature, causing it to experience terrible hallucinations for 1 round. During this time, the creature loses any immunity to fear effects it might possess and takes a -2 penalty on attack rolls made against you. In addition, the creature takes a penalty on Will saves made against fear effects equal to 1/2 your level (minimum -1). This power is a mind-affecting effect.`,
                    },
                ],
                perk2:[
                    {
                        name:"Aura of Madness",
                        abilityType:"Su",
                        description:`At level 7: As a standard action for 7 spell points you can emit a 30-foot-radius madness, and then 3 spell points each round to maintain. Enemies within this aura are affected by confusion unless they make a Will save. The confusion effect ends immediately when the creature leaves the area or the aura expires. Creatures that succeed on their saving throw are immune to this aura for 24 hours.`
                    },
                    {
                        name:"Dawning Realization",
                        abilityType:"Su",
                        description:`At level 7: You can impart a shared vision of unfathomable ineffability to a living creature you touch as a standard action for 7 spell points, after which your turn immediately ends. You are dazed and the target confused for 1 round by what you both learn. On the following round, you are both staggered for 1 round by the ramifications of your discovery. On the third round, you are confused and the target dazed for 1 round as you attempt to regain your bearings. Each round, the target can attempt a Will save to negate that round's effects for both of you, though the effect does not end until the end of the third round. This is a mind-affecting effect`
                    },
    
                ],
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%3 == 0 || x == 1){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{type:{buff:true}}}))
                        }
                    }
                    
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{type:{buff:true}}}))
                    }
                },
            },
    
            {
                name:"Magic",
                description:`You are a true student of all things mystical, and see divinity in the purity of magic.
                \nSpecial: You gain +2 spell points per level. Gain 10 universal spell power and 1% universal spell critical chance.
                \nBonus Rolls: A spell at 1st and every 3rd level.`,
                perk1:[
                    {
                        name:"Hand of the Acolyte",
                        abilityType:"Su",
                        description:`You can cause your melee weapon to fly from your grasp and strike a foe before instantly returning. As a standard action for level/2 spell points, you can make a single attack using a melee weapon at a range of 30 feet. This attack is treated as a ranged attack with a thrown weapon, except that you add your highest mental modifier to the attack roll instead of your normal modifier (damage still relies on Strength). This ability cannot be used to perform a combat maneuver.`,
                    },
                    {
                        name:"Divine Alchemy",
                        abilityType:"Su",
                        description:`When you drink or feed a healing potion or restoration potion to someone, the healing given is increased by 33%.`
                    },
                    {
                        name:"Arcane Beacon",
                        abilityType:"Su",
                        description:`As a standard action for 3 spell points you can become a beacon of arcane energy until the end of your next turn. The aura emanates 15 feet from you. All spells cast within the aura either gain a +1 bonus to their caster level or increase their saving throw DC by +1. The caster chooses the benefit when she casts the spell.`
                    },
                    {
                        name:"Divine Vessel",
                        abilityType:"Su",
                        description:`Whenever you are the target of a divine spell, you can, as an immediate action for 3 spell points, grant each ally within 15 feet of you a divine boon. This boon grants a +2 bonus on the next attack roll, skill check, or ability check made before the end of their next turn.`
                    },
                    {
                        name:"Enduring Rituals",
                        abilityType:"Su",
                        description:`As a swift action for 3 spell points when you cast a spell with a duration of at least 1 round per caster level, you can increase the spell's effective caster level by 1 for the purpose of determining its duration and preventing attempts to dispel it. The effective caster level increases by an additional 1 for every 9 levels you have (maximum +3).`
                    },
    
                ],
                perk2:[                
                    {
                        name:"Dispelling Touch",
                        abilityType:"Sp",
                        description:`At level 7: You can use a targeted dispel magic effect as a melee touch attack for 6 spell points.`
                    },
                    {
                        name:"Empowered Magic",
                        abilityType:"Su",
                        description:`At level 7: When you cast a non-healing spell, you count as a caster level higher. At level 12 and 19 this increases by +1.`
                    },
                    {
                        name:"Swift Magic",
                        abilityType:"Su",
                        description:`At level 7: Once per day you can cast a non-healing spell as a swift action for 8 extra spell points. At level 18 you can do this an additional time.`
                    },
    
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.misc.spPerLevel += 2
                    context.stats.characterStats.spellMastery.spellPower.universal += 10
                    context.stats.characterStats.spellMastery.spellCriticalChance.universal += 1
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%3 == 0 || x == 1){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",}))
                        }
                    }
                    
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",}))
                    }
                },
            },
    
            {
                name:"Nobility",
                description:`You are a great leader, an inspiration to all who follow the teachings of your faith.
                \nSpecial: When a spell you cast grants a numerical bonus to an ally, the bonus increases by a flat +1. If a spell grants multiple bonuses, choose only 1 to increase.
                \nBonus Rolls: A buff spell at 1st and every 3rd level.`,
                perk1:[
                    {
                        name:"Inspiring Word",
                        abilityType:"Su",
                        description:`As a standard action for 2 spell points, you can speak an inspiring word to a creature within 30 feet. That creature receives a +2 morale bonus on attack rolls, skill checks, ability checks, and saving throws for a number of rounds equal to 1/2 your level (minimum 1).`,
                    },
                    {
                        name:"Inspiring Command",
                        abilityType:"Su",
                        description:`As a standard action for 2 spell points, you can issue an inspiring command to your allies. The inspiring command affects one ally plus one additional ally for every three levels you possess, who must all be within 30 feet of you. Affected allies gain a +2 insight bonus on attack rolls, AC, combat maneuver defense, and skill checks for 1 round. This is a language-dependent mind-affecting effect.`,
                    },
                    {
                        name:"Romance Beyond Death",
                        abilityType:"Su",
                        description:`You receive Command Undead or Turn Undead as a bonus feat, depending on the type of energy you channel.`,
                    },
                    {
                        name:"Noble Visage",
                        abilityType:"Ex",
                        description:`You gain a +2 bonus to your charisma score, and a +4 bonus on diplomacy and intimidate.`,
                        hasCustomMethod:true,
                        catchUpMethod:(context)=>{
                            context.stats.characterStats.abilityScore.charisma += 2
                            context.stats.characterStats.skills.intimidate += 4
                            context.stats.characterStats.skills.diplomacy += 4
                        }
                    },
                    
    
                ],
                perk2:[                
                    {
                        name:"Sacrificial Bond",
                        abilityType:"Su",
                        description:`At level 7: When an ally within 30 feet takes damage from an attack, you can, as an immediate action for level spell points, transfer this damage to yourself. This power also transfers any effects that accompany the damage. The damage done to you cannot be reduced in any way.`
                    },
                    {
                        name:"Divine Demand",
                        abilityType:"Su",
                        description:`At level 5: Activating this ability is a swift action and costs 5 spell points that you must use as you cast a spell that has a reduced (but not negated) effect on a successful save. The saving throw DC of the spell increases by 2, and you gain a +2 bonus on caster level checks to overcome spell resistance with the spell.
                        \nAny creature that succeeds at the saving throw instead avoids the effect entirely. If half or more of the targets are unaffected, you become shaken for a number of rounds equal to the spell's level. If all of the targets are unaffected, you instead lose the ability to cast divine spells, channel energy, and use domain powers for 1d4 rounds; you can end this loss as a full-round action by loudly apologizing to your patron deity as a full-round action that provokes attacks of opportunity.`
                    },
    
                ],
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%3 == 0 || x == 1){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{type:{buff:true}}}))
                        }
                    }
                    
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{type:{buff:true}}}))
                    }
                },
            },
    
            {
                name:"Plant",
                description:`You find solace in the green, can grow defensive thorns, and can communicate with plants.
                \nSpecial: Gain a bonus on survival and heal checks equal to half your level.
                \nBonus Rolls: A buff spell at 1st and every 3rd level.`,
                perk1:[
                    {
                        name:"Wooden Fist",
                        abilityType:"Su",
                        description:`As a free action for level/2 spell points, your hands can become as hard as wood, covered in tiny thorns for 1 round. While you have wooden fists, your unarmed strikes do not provoke attacks of opportunity, deal lethal damage, and gain a bonus on damage rolls equal to 1/2 your level (minimum +1).`,
                    },
                    {
                        name:"Growth",
                        abilityType:"Su",
                        description:`As a swift action for 4 spell points, you can enlarge yourself for 1 round, as if you were the target of the enlarge person spell.`,
                    },
                    {
                        name:"Cruel Thicket",
                        abilityType:"Su",
                        description:`As a standard action for 2 spell points, you can cause the ground in a 5-foot-radius burst centered on you to sprout twisting, thorny vines. Any creature moving through it must travel at half speed or take bleed damage equal to half your level; if you activate this ability in an area with numerous plants (grass, weeds, trees, etc.), the area also becomes difficult terrain. These effects last for 1 minute, after which the vines crumble to dust. Creatures able to move through natural undergrowth unhindered ignore the effects of this ability.`,
                    },
                    {
                        name:"Caller",
                        abilityType:"Sp",
                        description:`As a standard action for 2 spell points, you can grant a single creature within 30 feet a +4 sacred bonus on its next attack roll before the start of your next turn.`,
                    },
                    
    
                ],
                perk2:[                
                    {
                        name:"Bramble Armor",
                        abilityType:"Su",
                        description:`At level 5: you can cause a host of wooden thorns to burst from your skin as a free action for level/2 spell points for 1 round. While bramble armor is in effect, any foe striking you with an unarmed strike or a melee weapon without reach takes 1d6 points of piercing damage + 1 point per two levels you possess.`
                    },
                    {
                        name:"Aura of Decay",
                        abilityType:"Su",
                        description:`At level 7: you can emit a 30-foot aura of decay as a standard action for level/2 spell points, and maintain for the same amount as a free action. Living creatures in this aura (except you) take 1d6 points of damage per round as their flesh rots. They also take a cumulative -1 penalty to Strength each round they remain in the aura. Once outside the aura, the penalty fades at the rate of -1 per round, but it begins building again if they reenter the aura. Plant creatures take 2d6 points of damage per round.`
                    },
    
                ],
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++){
                        if(x%3 == 0 || x == 1){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{type:{buff:true}}}))
                        }
                    }
                    
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{type:{buff:true}}}))
                    }
                },
            },
    
            {
                name:"Protection",
                description:`Your faith is your greatest source of protection.
                \nSpecial: Gain a +1 resistance bonus on all saving throws. This increases by +1 at level 9 and 18.
                \nBonus Rolls: Every 4 levels you gain an additional saving throw bonus.`,
                perk1:[
                    {
                        name:"Resistant Touch",
                        abilityType:"Sp",
                        description:`As a swift action for level/2 spell points, you can touch an ally to grant him a double the bonus you are gaining from your protection domain to saiving throws. When you use this ability, you lose your resistance bonus granted by the Protection domain for 1 minute, and you can only have this bonus on a single ally at a time. You can end this bonus as a free action.`,
                    },
                    {
                        name:"Deflection Aura",
                        abilityType:"Su",
                        description:`As a standard action for level spell points you can emit a 20-ft aura for a number of rounds equal to your level. Allies within the aura gain a +2 deflection bonus to AC and combat maneuver defense.`,
                    },
                    {
                        name:"Sheltering Walls",
                        abilityType:"Sp",
                        description:`As a standard action for level/2 spell points, you can touch an ally to summon a floating blockade of stone, granting the ally the benefits of partial cover for 1 round plus 1 round for every 6 levels you possess.
                        \nThis ability does not grant the ally enough cover to attempt a Stealth check or avoid provoking attacks of opportunity. If the ally benefits from any other form of cover against an attack, the bonuses to AC and on Reflex saving throws increase by 1. You can use this power a number of times per day equal to 3 + your Wisdom modifier.`,
                    },
                    {
                        name:"Taboo",
                        abilityType:"Su",
                        description:`When a creature touches you or strikes you with a melee attack, you can activate this power as an immediate action for 4 spell points. That creature takes a -1 penalty on saving throws for 1 minute. This penalty increases by 1 for every 5 levels you possess. When you use this ability, you lose your resistance bonus granted by the Protection domain for 1 minute.`,
                    },
                ],
                perk2:[                
                    {
                        name:"Purifying Touch",
                        abilityType:"Su",
                        description:`At level 7: as a standard action for level spell points you can touch a willing creature with divine power, giving it a saving throw against each effect currently affecting it, using the original saving throw DC of the effect. Each successful saving throw ends the related effect. The creature can choose not to make a save against an effect.`
                    },
                    {
                        name:"Aura of Protection",
                        abilityType:"Su",
                        description:`At level 7: you can emit a 30-foot aura of protection as a standard action for level/2 spell points, and maintain for the same amount as a free action. You and your allies within this aura gain a +1 deflection bonus to AC and resistance 5 against all elements (acid, cold, electricity, fire, and sonic). The deflection bonus increases by +1 for every 4 levels you possess beyond 7th. At 13th and the resistance against all elements increases to 10.`
                    },
    
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.misc.reflex += 1
                    context.stats.characterStats.misc.will += 1
                    context.stats.characterStats.misc.fortitude += 1
                    let bonus = [1,1,1,1,1,2,2,2,3,3,4]
                    let bonusTypes = ["will","reflex","fortitude"]
                    let choices = []
    
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x%4 == 0){
                            for(let x = 0; x < 3; x++){
                                let bonusType = bonusTypes[Math.floor(Math.random()*3)]
                                let option = bonus[Math.floor(Math.random()*bonus.length)]
                                choices[x] = {
                                    title:"+" + option + " " + bonusType,
                                    description:"",
                                    id:x,
                                    method:(() =>{
                                        context.stats.characterStats.misc[bonusType] += option
                                    })
                                }                
                            }
                            let custom = {title:"Protection Domain Bonus Selection", options:choices}
                            context.customDialogArray.push(custom)
                        }
                    } 
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%4 == 0){
                        let bonus = [1,1,1,1,1,2,2,2,3,3,4]
                        let bonusTypes = ["will","reflex","fortitude"]
                        let choices = []
                        for(let x = 0; x < 3; x++){
                            let bonusType = bonusTypes[Math.floor(Math.random()*3)]
                            let option = bonus[Math.floor(Math.random()*bonus.length)]
                            choices[x] = {
                                title:"+" + option + " " + bonusType,
                                description:"",
                                id:x,
                                method:(() =>{
                                    context.stats.characterStats.misc[bonusType] += option
                                })
                            }                
                        }
                        let custom = {title:"Protection Domain Bonus Selection", options:choices}
                        context.customDialogArray.push(custom)
                    } 
                },
            },
    
            {
                name:"Repose",
                description:`You see death not as something to be feared, but as a final rest and reward for a life well spent.
                \nSpecial: Gain a +1 bonus on all saving throws. Gain 15 positive spell power.
                \nBonus Rolls: Gain a saving throw bonus rolls every 5 levels.`,
                perk1:[
                    {
                        name:"Gentle Rest",
                        abilityType:"Sp",
                        description:`Your touch can fill a creature with lethargy, causing a living creature to become staggered for 1 round as a melee touch attack for level/2 spell points. If you touch a staggered living creature, that creature falls asleep for 1 round instead. Undead creatures touched are staggered for a number of rounds equal to your highest mental modifier.`,
                    },
                    {
                        name:"Exorcism of Undeath",
                        abilityType:"Sp",
                        description:`as a full-round action for level/2 spell points, you can try to end any possession spells or effects, or effects that directly exercise mental control over a creature, as long as the effect was caused by an undead creature. You must touch the affected creature (this requires a melee touch attack if the target is neither willing nor helpless). The target must immediately attempt a new Will save against the original save DC of the controlling effect. If the save is successful, the possession effect immediately ends, as if the target had succeeded at its original saving throw. If the possessing force is a ghost or similar undead, it manifests adjacent to the target and is staggered for 1 round.`,
                    },
                    {
                        name:"Touch the Spirit World",
                        abilityType:"Su",
                        description:`With a touch for level/2 spell points, you can empower a weapon to affect incorporeal creatures. The weapon touched deals half damage to incorporeal creatures, or full damage if it is a magic weapon. This benefit lasts for a number of rounds equal to your level.`,
                    },
                ],
                perk2:[                
                    {
                        name:"Spirit Touch",
                        abilityType:"Su",
                        description:`At level 5: As a swift action for level/2 spell points, which is maintainable as a free action for the same cost, you can give your natural weapons or any weapons you wield the ghost touch weapon special ability.`
                    },
                    {
                        name:"Ward Against Death",
                        abilityType:"Su",
                        description:`At level 7: you can emit a 30-foot aura of that wards against undeath as a standard action for level/2 spell points, and maintain for the same amount as a free action. Living creatures in this area are immune to all death effects, energy drain, and effects that cause negative levels. This ward does not remove negative levels that a creature has already gained, but the negative levels have no effect while the creature is inside the warded area.`
                    },
                    {
                        name:"Charm Undead",
                        abilityType:"Su",
                        description:`At level 7: As a swift action for level/2 spell points you can attempt to charm an undead within 30 feet, as the charm person spell, but able to affect undead. This charm lasts 1 round, however you can maintain it as a free action at the start of each of your turns for level/2 spell points. You can only have 1 charm undead active at a time.`
                    },
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.misc.reflex += 1
                    context.stats.characterStats.misc.will += 1
                    context.stats.characterStats.misc.fortitude += 1
                    context.stats.characterStats.spellMastery.spellPower.positive += 15
                    let bonus = [1,1,1,1,1,2,2,2,3,3,4]
                    let bonusTypes = ["will","reflex","fortitude"]
                    let choices = []
    
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x%5 == 0){
                            for(let x = 0; x < 3; x++){
                                let bonusType = bonusTypes[Math.floor(Math.random()*3)]
                                let option = bonus[Math.floor(Math.random()*bonus.length)]
                                choices[x] = {
                                    title:"+" + option + " " + bonusType,
                                    description:"",
                                    id:x,
                                    method:(() =>{
                                        context.stats.characterStats.misc[bonusType] += option
                                    })
                                }                
                            }
                            let custom = {title:"Repose Domain Bonus Selection", options:choices}
                            context.customDialogArray.push(custom)
                        }
                    } 
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%5 == 0){
                        let bonus = [1,1,1,1,1,2,2,2,3,3,4]
                        let bonusTypes = ["will","reflex","fortitude"]
                        let choices = []
                        for(let x = 0; x < 3; x++){
                            let bonusType = bonusTypes[Math.floor(Math.random()*3)]
                            let option = bonus[Math.floor(Math.random()*bonus.length)]
                            choices[x] = {
                                title:"+" + option + " " + bonusType,
                                description:"",
                                id:x,
                                method:(() =>{
                                    context.stats.characterStats.misc[bonusType] += option
                                })
                            }                
                        }
                        let custom = {title:"Repose Domain Bonus Selection", options:choices}
                        context.customDialogArray.push(custom)
                    } 
                },
            },
            {
                name:"Rune",
                description:`In strange and eldritch runes you find potent magic.
                \nSpecial: As a swift action while casting a spell you can spend gold equal to the level of a spell to cast it for no spell point cost. 
                \nBonus Rolls: Every 6 levels you gain a weapon enchantment.`,
                perk1:[
                    {
                        name:"Blast Rune",
                        abilityType:"Sp",
                        description:`As a standard action for 1 spell point, you can create a blast rune in any adjacent square. Any creature entering this square takes 1d6 points of damage + 1 per level. This rune deals either acid, cold, electricity, or fire damage, decided when you create the rune. The rune is invisible and lasts a number of rounds equal to your level or until discharged. You cannot create a blast rune in a square occupied by another creature. This rune counts as a 1st-level spell for the purposes of dispelling. It can be discovered with a DC 26 Perception skill check and disarmed with a DC 26 Disable Device skill check.`,
                    },
                ],
                perk2:[                
                    {
                        name:"Spell Rune",
                        abilityType:"Su",
                        description:`At level 7: You can attach another spell that you cast to one of your blast runes (this costs the additional spell points for the spell), causing that spell to affect the creature that triggers the rune, in addition to the damage. This spell must be of at least one level lower than the highest-level spell you can cast and it must target one or more creatures. Regardless of the number of targets the spell can normally affect, it only affects the creature that triggers the rune.`
                    },
                    {
                        name:"Rune Shift",
                        abilityType:"Su",
                        description:`At level 5: As a swift action, you can change the location of one of your blast runes. The rune must be within 30 feet. You can place the blast rune in any square adjacent to you, including one occupied by another creature.`
                    },
                    {
                        name:"Prohibition",
                        abilityType:"Su",
                        description:`At level 7: As a standard action for level/2 spell points you can command a creature within 30 feet to refrain from committing a particular action (including any referenced in the spell forbid action). If the creature performs the named action before the beginning of your next turn, it takes 1d6 points of damage + 1 per level and the effect ends. This is a language-dependent effect. You can attach a spell effect to the prohibition (costing additional spell points for the spell); the spell takes effect if the creature performs the named action. This spell must be of at least 1 level lower than the highest-level spell you can cast, and it must target one or more creatures. Regardless of the number of targets the spell can normally affect, it affects only the creature that triggers the rune. Attaching a spell in this way extends the duration of the prohibition by a number of rounds equal to the spell's level, or until it is discharged. A creature affected by a spell from this taks a -2 penalty on its saves against the spell, increasing by -1 every 4 levels after 7th.`
                    },
                    {
                        name:"Warding Rune",
                        abilityType:"Su",
                        description:`At level 5: When a creature is damaged by your blast rune, it cannot attack you for a number of rounds equal to 1/2 level unless it succeeds at a Will save, as per the spell sanctuary. Using this ability is an immediate action and costs 5 spell points when a creature triggers one of your blast runes. The ability does not prevent you from being attacked or affected by area of effect spells or abilities.`
                    },
                ],
                catchUpMethod:(context)=>{
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x%6 == 0){
                            context.connection.send(JSON.stringify({command:"requestRoll", type:"weapon enchantment"}))
                        }
                    } 
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%6 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll", type:"weapon enchantment"}))
                    } 
                },
            },
    
            {
                name:"Scalykind",
                description:`Mmmm lizard.
                \nSpecial: Gain a +2 bonus to your natural armor. Gain 15 acid spell power.
                \nBonus Rolls: Every 5 levels you will gain more bonuses to your natural armor.`,
                perk1:[
                    {
                        name:"Venomous Stare",
                        abilityType:"Sp",
                        description:`As a standard action for level/2 spell points, you can activate a gaze attack with a 30-foot range. This is an active gaze attack that can target a single creature within range. The target must make a Will save or take 1d6 points of nonlethal damage + 1 per level and are fascinated until the beginning of your next turn. This is a mind-affecting effect. At level 7, this instead targets all enemies within 30 feet.`,
                    },
                    {
                        name:"Venomous Saliva",
                        abilityType:"Su",
                        description:`As a swift action for level/2 spell points, you can spit a gout of life-stealing venom onto a weapon you are wielding. The poison lasts for 1 minute or until you make an attack that injures a foe with that weapon.
                        \nLife-Stealing Venom: Injury; save Fort; frequency 1/round for 3 rounds; effect 1 Con damage; cure 1 save.`,
                    },
                    {
                        name:"Lizardform",
                        abilityType:"Ex",
                        description:`You gain 2 primary claw attacks on your hands that deal 1d4 points of damage, and a primary bite attack that deals 1d6 points of damage. If you already possessed any of these natural attacks, their damage dice is increased by 1 size step.`,
                    },
    
                ],
                perk2:[                
                    {
                        name:"Dragonbreath",
                        abilityType:"Su",
                        description:`At level 3: You may use a breath weapon as a standard action for level/2 spell points. When you gain this ability, choose acid, cold, fire, or electricity—this determines what kind of damage your breath weapon deals. Once you make this choice, you cannot change it later. Your breath weapon fills a 15-foot cone, and deals 3d6 points of damage, this scales with spell power—this damage increases by 1d6 points at every even-numbered level you gain beyond 3th level. A creature hit by your dragonbreath attack can attempt a Reflex save to take half damage.`
                    },
                    {
                        name:"Magic Attacks",
                        abilityType:"Su",
                        description:`At level 3: All of your natural attacks gain a +1 enhancement bonus to them. Every 5 levels this increases by +1.`
                    },
                ],
                catchUpMethod:(context)=>{
                    context.stats.statsForAbilities.ac.natural += 2
                    context.stats.characterStats.spellMastery.spellPower.acid += 15
                    let bonus = [1,1,1,1,1,1,2,2,2,2,3,3,4]
    
                    let perk = context.stats.lists.perks.find(perk=> perk.name == "Scalykind Domain")
                    perk.shortDesc += `\n\nAdditional Natural Armor Bonuses Gained: ` 
                    let choices = []
    
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
    
                        if(x%5 == 0){
                            for(let x = 0; x < 3; x++){
                                let option = bonus[Math.floor(Math.random()*bonus.length)]
                                choices[x] = {
                                    title:"+" + option,
                                    description:"",
                                    id:x,
                                    method:(() =>{
                                        let perk = context.stats.lists.perks.find(perk=> perk.name == "Scalykind Domain")
                                        perk.shortDesc += `+` + option + `, `
                                        context.stats.statsForAbilities.ac.natural += parseInt(option)
                                    })
                                }                
                            }
                            let custom = {title:"Scalykind Blessing Bonus Selection", options:choices}
                            context.customDialogArray.push(custom)
                        }
                    }  
                },
    
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%5 == 0){
                        let bonus = [1,1,1,1,1,1,2,2,2,2,3,3,4]
                        let choices = []
                        for(let x = 0; x < 3; x++){
                            let option = bonus[Math.floor(Math.random()*bonus.length)]
                            choices[x] = {
                                title:"+" + option,
                                description:"",
                                id:x,
                                method:(() =>{
                                    let perk = context.stats.lists.perks.find(perk=> perk.name == "Scalykind Domain")
                                    perk.shortDesc += `+` + option + `, `
                                    context.stats.statsForAbilities.ac.natural += parseInt(option)
                                })
                            }                
                        }
                        let custom = {title:"Scalykind Blessing Bonus Selection", options:choices}
                        context.customDialogArray.push(custom)
                    } 
                },
            },
    
            {
                name:"Strength",
                description:`In strength and brawn there is truth—your faith gives you incredible might and power.
                \nSpecial: Increase your strength by +2. Gain 15 universal spell critical power.
                \nBonus Rolls: Every 5 levels gain additional strength bonuses.`,
                perk1:[
                    {
                        name:"Strength Surge",
                        abilityType:"Sp",
                        description:`As a standard action for level/2 spell points, you can touch a creature to give it great strength. For 1 round, the target gains an enhancement bonus equal to 1/2 your level (minimum +1) to melee attacks, combat maneuver checks that rely on Strength, Strength-based skills, and Strength checks.`,
                    },
                    {
                        name:"Athletic Exploit",
                        abilityType:"Su",
                        description:`As a swift action for level/2 spell points, you gain the ability to overcome physical obstacles with ease. Until the beginning of your next turn, you halve your armor check penalty when attempting Acrobatics, Climb, Escape Artist, and Swim skill checks, and you gain a bonus equal to 1/2 your cleric level (minimum +1) on such skill checks.`,
                    },
                    {
                        name:"Ferocious Strike",
                        abilityType:"Su",
                        description:`Whenever you make a melee attack, for level/2 spell points you can designate that attack as a ferocious strike. If the attack hits, it deals additional damage equal to 1/2 your level (minimum +1).`,
                    },
                    {
                        name:"Wooden Fist",
                        abilityType:"Su",
                        description:`As a free action for level/2 spell points, your hands can become as hard as wood, covered in tiny thorns for 1 round. While you have wooden fists, your unarmed strikes do not provoke attacks of opportunity, deal lethal damage, and gain a bonus on damage rolls equal to 1/2 your level (minimum +1).`,
                    },
                    {
                        name:"Perfected Form",
                        abilityType:"Su",
                        description:`You gain a +1 sacred (if you're good or neutral) or profane (if you're evil) bonus on saving throws against polymorph, petrification, and transmutation effects. This bonus increases by 1 for every 5 levels you have (maximum +5). Once per day when you succeed at a saving throw against such an effect, you can gain a surge of self-confidence as an immediate action that grants you a number of temporary hit points equal to your level and a +2 morale bonus on attack rolls, skill checks, and saving throws; both effects last for 1 minute.`,
                    },
                ],
                perk2:[                
                    {
                        name:"Might of the Gods",
                        abilityType:"Su",
                        description:`At level 7: As a free action for level/2 spell points you can add your level as an enhancement bonus to your Strength score for 1 round. This bonus only applies on Strength checks and Strength-based skill checks.`
                    },
                    {
                        name:"Bestow Resolve",
                        abilityType:"Su",
                        description:`At level 7: As a standard action for level spell points you can bestow a number of temporary hit points equal to your level + your highest mental modifier to all allies within 20 feet. The temporary hit points remain for 1 minute.`
                    },
                    
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.abilityScore.strength += 2
                    context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 15
                    let bonus = [1,1,1,1,1,1,2,2,2,2,3,3,4]
    
                    let perk = context.stats.lists.perks.find(perk=> perk.name == "Strength Domain")
                    perk.shortDesc += `\n\nAdditional Strength Bonuses Gained: ` 
                    let choices = []
    
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
    
                        if(x%5 == 0){
                            for(let x = 0; x < 3; x++){
                                let option = bonus[Math.floor(Math.random()*bonus.length)]
                                choices[x] = {
                                    title:"+" + option,
                                    description:"",
                                    id:x,
                                    method:(() =>{
                                        let perk = context.stats.lists.perks.find(perk=> perk.name == "Strength Domain")
                                        perk.shortDesc += `+` + option + `, `
                                        context.stats.characterStats.abilityScore.strength += option
                                    })
                                }                
                            }
                            let custom = {title:"Strength Blessing Bonus Selection", options:choices}
                            context.customDialogArray.push(custom)
                        }
                    }  
                },
    
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%5 == 0){
                        let bonus = [1,1,1,1,1,1,2,2,2,2,3,3,4]
                        let choices = []
                        for(let x = 0; x < 3; x++){
                            let option = bonus[Math.floor(Math.random()*bonus.length)]
                            choices[x] = {
                                title:"+" + option,
                                description:"",
                                id:x,
                                method:(() =>{
                                    let perk = context.stats.lists.perks.find(perk=> perk.name == "Strength Domain")
                                    perk.shortDesc += `+` + option + `, `
                                    context.stats.characterStats.abilityScore.strength += option
                                })
                            }                
                        }
                        let custom = {title:"Strength Blessing Bonus Selection", options:choices}
                        context.customDialogArray.push(custom)
                    } 
                },
            },
    
            {
                name:"Sun",
                description:`You see truth in the pure and burning light of the sun, and can call upon its blessing or wrath to work great deeds.
                \nSpecial: When you cause a creature to become dazzled, the penalty increases by -1 every 6 levels. Gain 10 fire spell power, 1% fire spell critical chance, and 15% fire spell critical power, but -15 cold spell power and -1% cold spell critical chance, and -25% cold spell critical power.
                \nBonus Rolls: At 1st and every 3 levels you gain a fire/light spell.`,
                perk1:[
                    {
                        name:"Sun's Blessing",
                        abilityType:"Su",
                        description:`Whenever you channel positive energy to harm undead creatures, add your level to the damage dealt. Undead do not add their channel resistance to their saves when you channel positive energy.`,
                    },
                    {
                        name:"Blinding Flash",
                        abilityType:"Su",
                        description:`As a standard action for level/2 spell points, you can emit a flash of light. The most powerful light emanates out 20 feet from you. Creatures within this area are blinded for 1 rounds unless they succeed at a Fortitude save. All creatures in this area are dazzled for a 1d4 rounds.`
                    },
                    {
                        name:"Wilting Glare",
                        abilityType:"Su",
                        description:`As a standard action for level/2 spell points, you can leach moisture and vitality from a living, corporeal creature you can see within 30 feet. The target takes an amount of nonlethal damage equal to 1d6 + 1 per level and becomes fatigued until the beginning of your next turn (Fort negates). Plant creatures and those with the aquatic or water subtype take lethal damage from this ability, and they are fatigued for a number of rounds equal to your highest mental modifier.`
                    },
                    {
                        name:"Guided Eyes",
                        abilityType:"Su",
                        description:`Gain a +6 bonus to your perception. Whenever you make a skill check to see through a disguise or find something that is hidden or concealed, you gain a +5 sacred bonus on the check.`,
                        hasCustomMethod:true,
                        catchUpMethod:(context)=>{
                            context.stats.characterStats.skills.perception += 6
                        }
                    },
                ],
                perk2:[                
                    {
                        name:"Nimbus of Light",
                        abilityType:"Su",
                        description:`At level 7: As a standard action for 7 spell points to activate, and then 3 each round to maintain, you can emit a 30-foot nimbus of light. This acts as a daylight spell. In addition, undead within this radius take an amount of damage equal to your level each round that they remain inside the nimbus. Spells and spell-like abilities with the darkness descriptor are automatically dispelled if brought inside this nimbus.`
                    },
                    {
                        name:"Withering Nimbus",
                        abilityType:"Su",
                        description:`At level 7: As a standard action for 7 spell points to activate, and then 3 each round to maintain, you can emit a 30-foot nimbus of light. This acts as a daylight spell. In addition, plants and creatures with the aquatic subtype within this radius take an amount of damage equal to your level each round that they remain inside the nimbus. Spells and spell-like abilities with the darkness descriptor are automatically dispelled if brought inside this nimbus.`
                    },
                    {
                        name:"Day's Resurgence",
                        abilityType:"Su",
                        description:`At level 7: As a standard action for 7 spell points to activate, and then 3 each round to maintain, you can emit a 30-foot nimbus of light. This acts as a daylight spell. In addition, undead within this radius take an amount of damage equal to your level each round that they remain inside the nimbus. Spells and spell-like abilities with the darkness descriptor are automatically dispelled if brought inside this nimbus.`
                    },
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellPower.fire += 10
                    context.stats.characterStats.spellMastery.spellCriticalChance.fire += 1
                    context.stats.characterStats.spellMastery.spellCriticalDamage.fire += 15
                    context.stats.characterStats.spellMastery.spellPower.cold -= 15
                    context.stats.characterStats.spellMastery.spellCriticalChance.cold -= 1
                    context.stats.characterStats.spellMastery.spellCriticalDamage.cold -= 25
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x == 1 || x%3 == 0){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["fire","light"]}}))
                        }
                    }
                         
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["fire","light"]}}))
                    } 
                },
            },
    
            {
                name:"Travel",
                description:`You are an explorer and find enlightenment in the simple joy of travel, be it by foot or conveyance or magic.
                \nSpecial: Increase your base speed by 10 feet. Gain 15 electricity spell power. 
                \nBonus Rolls: At level 5 you gain Anywhere But Here Spell. At level 9 you gain the dimension door spell. At level 13 you gain Dimensional Bounce spell.`,
                perk1:[
                    {
                        name:"Agile Feet",
                        abilityType:"Su",
                        description:`As a free action for 2 spell points, you can gain increased mobility for 1 round. For the next round, you ignore all difficult terrain and do not take any penalties for moving through it.`,
                    },
                    {
                        name:"Sacred Threshold",
                        abilityType:"Su",
                        description:`As a standard action for 2 spell points you can create a straight line that is 15 long and lasts highest mental rounds. Any creature that walks over that line gains 1d4 per 3 levels (minimum 1d4) temporary hit points. These temporary hit points last 1 minute and do not stack with each other, and a creature cannot gain these temporary hit points more than once every 3 rounds.`,
                    },
                    {
                        name:"Silver-Tongued Haggler",
                        abilityType:"Su",
                        description:`Whenever you make a Bluff, Diplomacy, or Sense Motive check, you can, as a free action for 2 spell points, grant yourself a bonus on the roll equal to 1/2 your level (minimum +1).`,
                    },
                    {
                        name:"Dimensional Prodigy",
                        abilityType:"Ex",
                        description:`You gain the Dimensional Agility feat: After casting dimension door or an ability or spel that functions like it, you can take any actions you still have remaining on your turn. You also gain a +4 bonus on Concentration checks when casting teleportation spells.`,
                        hasCustomMethod:true,
                        catchUpMethod:(context)=>{
                            let feat = feats.find(feat=>feat.name == "Dimensional Agility")
                            feat.id = Math.random()
                            context.stats.lists.feats.push(feat)
                        }
                    },
                ],
                perk2:[                
                    {
                        name:"Dimensional Hop",
                        abilityType:"Su",
                        description:`At level 7: You can teleport up to 10 feet per level as a move action. This costs 3 spell points for every 10 feet traveled. This teleportation must be used in 10-foot increments and such movement does not provoke attacks of opportunity. You must have line of sight to your destination to use this ability. You can bring other willing creatures with you, but you must expend an equal amount of distance for each creature brought.`
                    },
                    {
                        name:"Travel as One",
                        abilityType:"Su",
                        description:`At level 7: Whenever you teleport yourself or another ally they gains 1d4 per 3 levels (minimum 1d4) temporary hit points. These temporary hit points last 1 minute and do not stack with each other.`
                    },
                    {
                        name:"Day's Resurgence",
                        abilityType:"Su",
                        description:`At level 7: As a standard action for 7 spell points to activate, and then 3 each round to maintain, you can emit a 30-foot nimbus of light. This acts as a daylight spell. In addition, undead within this radius take an amount of damage equal to your level each round that they remain inside the nimbus. Spells and spell-like abilities with the darkness descriptor are automatically dispelled if brought inside this nimbus.`
                    },
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellPower.electricity += 15
                    if(context.stats.characterStats.misc.level >= 5){
                        context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Anywhere But Here")[0])
                    }
                    if(context.stats.characterStats.misc.level >= 9){
                        context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Dimension Door")[0])
                    }
                    if(context.stats.characterStats.misc.level >= 13){
                        context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Dimensional Bounce")[0])
                    }
                    
                         
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level == 5){
                        context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Anywhere But Here")[0])
                    }
                    if(context.stats.characterStats.misc.level == 9){
                        context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Dimension Door")[0])
                    }
                    if(context.stats.characterStats.misc.level == 13){
                        context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Dimensional Bounce")[0])
                    }
                },
            },
    
            {
                name:"Trickery",
                description:`You are a master of illusions and deceptions
                \nSpecial: You gain a +4 bonus on bluff and stealth checks. Gain 2 universal spell critical chance.
                \nBonus Rolls: At 1st and every 3 levels gain an illusion spell.`,
                perk1:[
                    {
                        name:"Copycat",
                        abilityType:"Sp",
                        description:`You can create an illusory double of yourself as a move action for 2 spell points. This double functions as a single mirror image, and lasts for a number of rounds equal to your level, or until the illusory duplicate is dispelled or destroyed. You can have no more than one copycat at a time. This ability does not stack with the mirror image spell.`,
                    },
                    {
                        name:"Deceptive Reprieve",
                        abilityType:"Sp",
                        description:`As a standard action for 2 spell points you can touch a creature under direct mental control (such as that granted via dominate person, but not via charm person) or the victim of possession, that creature can attempt a new Will save against the control or possession effect with a +2 bonus. If the creature succeeds, the effect or possession is temporarily halted, as per protection from evil, for a number of rounds equal to 1/2 level. While this ability is active, the target takes a -2 penalty on saves against new mind-affecting effects and new attempts at possession.`,
                    },
                    {
                        name:"Chameleon Aspect",
                        abilityType:"Su",
                        description:`As a swift action for 2 spell points, you can subtly alter the color of your scales, blending them with the surrounding environment for 1 round. While under the effect of this power, you gain concealment from creatures more than 10 feet away (attacks have a 20% miss chance), and total concealment from creatures more than 40 feet away (attacks have a 50% miss chance).`,
                    },
                    {
                        name:"Sudden Shift",
                        abilityType:"Sp",
                        description:`In the blink of an eye, you can appear somewhere else. As an immediate action for 2 spell points, after you are missed by a melee attack, you can teleport up to 10 feet to a space that you can see. This space must be inside the reach of the creature that attacked you.`,
                    },
                    {
                        name:"More for Me",
                        abilityType:"Su",
                        description:`When another character within 30 feet casts a spell with a range greater than touch, you can attempt a caster level check as an immediate action (DC = 15 + the spell's level) for level/2 spell points. If you succeed at the check, you receive the spell's benefit instead of one of the spell's intended targets (chosen by you). If you are already a target of the spell, you are affected as though you were targeted by the same spell twice (which may or may not benefit you; remember that bonuses from the same source do not stack). This ability does not grant you knowledge of the spell being cast.`,
                    },
                    {
                        name:"Fool's Privilege",
                        abilityType:"Su",
                        description:`You can use this power as a swift action for level spell points when you fail or make a Bluff, Diplomacy, or Intimidate check. Roll twice and take the higher result.`,
                    },
                    
                ],
                perk2:[                
                    {
                        name:"Fleeting Glance",
                        abilityType:"Sp",
                        description:`At level 7: As a movement action for 6 spell points you can cause yourself to become invisible for 1 round as per greater invisibility, each turn as a free action you can spend an additional 3 spell points to keep the effect going.`
                    },
                    {
                        name:"Thief of the Gods",
                        abilityType:"Su",
                        description:`At level 7: as a free action for 7 spell points when you make a Disable Device, stealth, or sleight of hand check, you can roll twice and take the higher result.`
                    },
                    
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellCriticalChance.universal += 2
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x == 1 || x%3 == 0){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{school:"necromancy"}}))
                        }
                    }
                         
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{school:"necromancy"}}))
                    } 
                },
            },
    
            {
                name:"Vermin",
                description:`You see the perfection of nature in the spindly limbs and strange forms of all vermin, great and small alike.
                \nSpecial: You can effect vermin with mind-affecting effects even though they are normally immune to them. Gain 15 acid spell power.
                \nBonus Rolls: You gain the summon swarm spell. At level 9 you gain the Insect Plague spell. At level 13 you gain the Creeping Doom spell.`,
                perk1:[
                    {
                        name:"Vermin Whisperer",
                        abilityType:"Su",
                        description:`Whenever you use a conjuration(summoning) spell to summon a vermin it lasts twice as long and it gains a +4 bonus to its strength, dexterity, and constitution scores. The DC of any distraction ability a swarm has that you summoned has its DC increased by half your highest mental modifier.`,
                    },
                    {
                        name:"I am Rat",
                        abilityType:"Ex",
                        description:`You can share a tile with an ally that is the same size or larger as you without either of you being considered squeezing. When you share a square with an ally larger than you, the ally can choose to take a -4 penalty to armor class to give you a +2 bonus to your armor class and reflex saves. If the ally is unwilling, you can reduce your allies armor class by -2 to gain a +1 bonus to your armor class and reflex saves. This stacks with the ratfolk ability.`,
                    },
                    {
                        name:"Vermin Friend",
                        abilityType:"Su",
                        description:`Whenever a vermin sees you for the first time it must make a will save or become charmed by you for round equal to your highest mental modifier.`,
                    },
                    
                ],
                perk2:[                
                    {
                        name:"Sudden Sting",
                        abilityType:"Su",
                        description:`At level 7: you can inflict a lingering, painful sting as a swift action for 7 spell points that requires a successful melee touch attack. This sting deals 1d4 points of piercing damage +1 per level, and the target must succeed at a Fortitude save (DC = 10 + level/2 + Constitution modifier) or become staggered for 1 round. This is a pain effect.`
                    },
                    {
                        name:"Tremorsense",
                        abilityType:"Su",
                        description:`At level 5: You gain tremorsense 30 feet. At 10th level, you gain tremorsense 60 feet.`
                    },
                    
                ],
                catchUpMethod:(context)=>{                    
                    context.stats.characterStats.spellMastery.spellPower.acid += 15
                    context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Summon Swarm")[0])
                    if(context.stats.characterStats.misc.level >= 9){
                        context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Insect Plague")[0])
                    }
                    if(context.stats.characterStats.misc.level >= 13){
                        context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Creeping Doom")[0])
                    }
                    
                         
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level == 9){
                        context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Insect Plague")[0])
                    }
                    if(context.stats.characterStats.misc.level == 13){
                        context.stats.lists.spells.push(spells.filter(spell=>spell.name=="Creeping Doom")[0])
                    }
                },
            },
            {
                name:"Void",
                description:`You can call upon the cold darkness between the stars to gain flight, travel to other worlds, or summon monsters from beyond to do your bidding.
                \nSpecial: Whenever you cast a control spell the DC increases by +1. Whenever you cast a cold spell, you can increase the cost of the spell by 25% to cause 25% of the cold damage it deals becomes untyped damage, caused from otherwordly power. You gain 10 cold spell power, and 15% cold spell critical power, but -15 fire spell power and -1% fire spell critical chance, and -25% fire spell critical power.
                \nBonus Rolls: At 1st and every 3 levels gain a control spell or a cold spell.`,
                perk1:[
                    {
                        name:"Guarded Mind",
                        abilityType:"Ex",
                        description:`You gain a +2 insight bonus on saving throws against all mind-affecting effects. Every 6 levels this increases by +1.`,
                    },
                    {
                        name:"It Came from Beyond",
                        abilityType:"Su",
                        description:`Once per day, when you cast a summoning spell, any one creature you summon is more powerful than normal. The creature gains the advanced creature simple template. If you summon more than one creature with a spell, only one of the summoned creatures gains the advanced creature simple template. A summoned creature that gains the advanced creature simple template in this manner appears unnervingly deformed or unnaturally hideous, bringing with it a whiff of the emptiness of the void.`,
                    },
                    {
                        name:"Void Step",
                        abilityType:"Su",
                        description:`Once per round for 4 spell points as a free action you can teleport 5 feet. When you reach level 8 and 16, the distance increases by 5 feet, and the cost increases by 2 spell points.`,
                    },
                    {
                        name:"Walker of the Veiled Moon",
                        abilityType:"Su",
                        description:`Gain the Veiled Moon Style feat: Whenever you move, you can treat up to 10 feet of that movement as teleportation. This teleportation may be taken at any point during your movement, and cannot exceed the total movement you would normally be allowed to make. You must have line of sight to your destination, and cannot teleport into an occupied space. You can use this feat to bypass a 5 feet worth of obstacles when making a charge; you treat a square you bypass as empty for the purposes of determining if you can charge your target.`,
                        hasCustomMethod:true,
                        catchUpMethod:(context)=>{
                            let feat = feats.find(feat=>feat.name == "Veiled Moon Style")
                            feat.id = Math.random()
                            context.stats.lists.feats.push(feat)
                        }
                    },
                    
                ],
                perk2:[                
                    {
                        name:"Part the Veil",
                        abilityType:"Su",
                        description:`At level 7: You can lace spells you cast with the raw madness that waits in the outer darkness. Activating this ability is a swift action that costs 5 spell points and you must use as you cast a spell that targets a single creature and that allows a Will saving throw to negate or reduce the spell's primary effect. If the target fails to resist the spell, the target is also confused for a number of rounds equal to the spell's level as visions of the void cause temporary insanity. The victim must succeed at a new saving throw each round to end the effect—these additional saving throws apply only to the additional confusion effect and not to the original spell effect. Part the veil is a mind-affecting effect.`
                    },
                    {
                        name:"Aura of Isolation",
                        abilityType:"Su",
                        description:`At level 7: As a standard action for 7 spell points to activate and 3 to maintain each round, you can create a 20-foot aura that causes enemies within to be overcome with feelings of isolation and loss. Your enemies treat the aura as difficult terrain, as they become sluggish within its area of effect. Furthermore, while within the aura, your enemies cannot provide flanking, nor can they use or benefit from the aid another action. This is a mind-affecting emotion effect.`
                    },
                    {
                        name:"Fold Space",
                        abilityType:"Su",
                        description:`At level 7: Once per round as a free action for 7 spell points you can teleport 30 feet. Every time you do this, you must make a will save DC 10 + level/2 + times used today or when you finish your teleportation you are confused for 1d4 rounds. If you roll a natural 1 on this save you take 1d4 per 3 levels of wisdom damage.`
                    },
                    {
                        name:"Sight Beyond",
                        abilityType:"Su",
                        description:`At level 7: As a swift action for 7 spell points and 3 each round to maintain you gain truesight 5 feet. This increases by 5 feet x your wisdom modifier.`
                    },
                    {
                        name:"Into the Depths",
                        abilityType:"Su",
                        description:`At level 9: As a standard action for 9 spell points you can touch a creature and send them into the void. They are teleported into deep space for 1 round and take 1d4 points of wisdom drain per 6 levels. Will save negates the teleportation. At the end of the durationt they are returned to their previous location.`
                    },
                    {
                        name:"The Stars Are Right",
                        abilityType:"Su",
                        description:`At level 7: Whenever you start to cast a spell, you heal hit points equal to the level of the spell.`
                    },
                    
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellPower.cold += 10
                    context.stats.characterStats.spellMastery.spellCriticalDamage.cold += 25
                    context.stats.characterStats.spellMastery.spellPower.fire -= 15
                    context.stats.characterStats.spellMastery.spellCriticalChance.fire -= 1
                    context.stats.characterStats.spellMastery.spellCriticalDamage.fire -= 25
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x == 1 || x%3 == 0){
                            if(Math.random() > 0.49) context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{type:{control:true}}}))
                            else context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["cold"]}}))
                        }
                    }
                         
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        if(Math.random() > 0.49) context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{type:{control:true}}}))
                        else context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["cold"]}}))
                    } 
                },
            },
    
            {
                name:"War",
                description:`You are a crusader for your god, always ready and willing to fight to defend your faith.
                \nSpecial: Your BAB increases by +2.
                \nBonus Rolls: At 1st and every 3 levels you gain a maneuver.`,
                perk1:[
                    {
                        name:"Battle Rage",
                        abilityType:"Sp",
                        description:`You can touch a creature as a standard action for 2 spell points to give it a bonus on melee damage rolls equal to 1/2 your level for 1 round (minimum +1).`,
                    },
                    {
                        name:"Divine Challenge",
                        abilityType:"Su",
                        description:`As a swift action for 2 spell points, you can challenge a visible foe within 30 feet, gaining a +1 sacred bonus to your AC against that creature's attacks and a bonus equal to 1/2 level on Bluff skill checks to feint against it. These bonuses last for a number of rounds equal to 1/2 your level.`,
                    },
                    {
                        name:"Seize the Initiative",
                        abilityType:"Su",
                        description:`Whenever you and your allies roll for initiative, for 2 spell points you can grant one ally within 30 feet the ability to roll twice and take either result. This decision is made before results are revealed.`,
                    },
                    {
                        name:"Lord of War",
                        abilityType:"Ex",
                        description:`You gain a +1 bonus on damage rolls with melee weapons. Every 6 levels this increases by 1.`,
                    },
                    
                ],
                perk2:[                
                    {
                        name:"Weapon Master",
                        abilityType:"Su",
                        description:`At level 7: As a swift action for level/2 spell points and level/4 spell points to maintain each round, you gain the ability to temporarily adopt a martial/style/combat feat. To gain a feat you must be the minimum level you would need to be to meet the requirements of the feat (if a feat has a BAB or skill rank prerequisite your level must be equal to it), and if the feat has prerequisites in the Akashic Paths, you must have them too. If a feat is an Akashic Paths only feat, it has a prerequisite of level 5, plus 5 for each feat prerequisite it has. You cannot select a feat that you already have.`
                    },
                    {
                        name:"Wounding Blade",
                        abilityType:"Su",
                        description:`At level 7: As a standard action for level spell points you can touch a weapon and cause it to deal 1 point of bleed damage per hit for level/2 rounds. This bleed damage increases with each successful hit. Creatures immune to critical hits are immune to this bleed damage too.`
                    },
                    
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.misc.BAB += 2
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x == 1 || x%3 == 0){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"maneuver"}))
                        }
                    }
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"maneuver"}))
                    } 
                },
            },
    
            {
                name:"Water",
                description:`You can manipulate water and mist and ice, conjure creatures of water, and resist cold.
                \nSpecial: Gain a swim speed of 20 feet. You gain 15 cold spell power, 1% cold spell critical chance, and 15% cold spell critical power, but -15 fire spell power and -2% fire spell critical chance, and -25% fire spell critical power.
                \nBonus Rolls: At 1st and every 3 levels gain a cold/water spell.`,
                perk1:[
                    {
                        name:"Icicle",
                        abilityType:"Sp",
                        description:`As a standard action for 2 spell points, you can fire an icicle from your outstretched hand. You can target any single foe within 30 feet as a ranged touch attack with this icicle. If you hit the foe, the icicle deals 1d6 points of cold damage + 1 point per level. At level 7 you can activate this as a swift action for 10 spell points.`,
                    },
                    {
                        name:"Go with the Flow",
                        abilityType:"Su",
                        description:`As a standard action for level/2 spell points, you can touch a creature to suppress its strong emotions. The target is affected as the calm emotions spell, except it can still take violent actions and violent actions against the target do not end the effect. This effect lasts a number of rounds equal to 1/2 your level (minimum 1).`,
                    },
                    {
                        name:"Surge",
                        abilityType:"Su",
                        description:`As a standard action for level/2 spell points, you can cause a mighty wave to appear that pushes or pulls a single creature. Make a combat maneuver check against the target, using your level + your highest mental modifier as your CMB. If successful, you may pull or push the creature as if using the bull rush or drag combat maneuver.`,
                    },
                    {
                        name:"Current Flow",
                        abilityType:"Su",
                        description:`As a free action for level/2 spell points, you can increase either your land or swim speed by 10 feet. While swimming, you gain a bonus on Swim checks equal to your 1/2 level (minimum 1). These effects last for a number of rounds equal to your highest mental modifier (minimum 1).`,
                    },
                ],
                perk2:[
                    {
                        name:"Cold Resistance",
                        abilityType:"Ex",
                        description:`At level 5: you gain resist cold 10. This resistance increases to 20 at 9th level. At 18th level, you gain immunity to cold.`
                    },
                    {
                        name:"Sift",
                        abilityType:"Su",
                        description:`At level 5: If you enter a map that is underwater, or stand next to a large body of water like an ocean or lake, you can spent level spell points as a standard action to gain a small gold pile. At level 10 this becomes a medium gold pile. You can only use this once per map. If you want, you can choose to pull out a single piece of gear instead, but until level 10 it cannot be gear with a stack size of 1.`
                    },
                    {
                        name:"Body of Ice",
                        abilityType:"Su",
                        description:`At level 7: You can transmute your body and equipment to ice for a period of time. It takes a standard action to take on the form of ice, costing level/2 spell points to activate and to maintain each round, and you can end the transmutation with a free action on your turn. When you take on the form of ice, you are immune to cold and have DR 5/—, but you take twice the normal amount of damage from fire.`
                    },
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellPower.cold += 15
                    context.stats.characterStats.spellMastery.spellCriticalChance.cold += 1
                    context.stats.characterStats.spellMastery.spellCriticalDamage.cold += 15
                    context.stats.characterStats.spellMastery.spellPower.fire -= 15
                    context.stats.characterStats.spellMastery.spellCriticalChance.fire -= 2
                    context.stats.characterStats.spellMastery.spellCriticalDamage.fire -= 25
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x == 1 || x%3 == 0){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["cold","water"]}}))
                        }
                    }
                         
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["cold","water"]}}))
                    } 
                },
            },
    
            {
                name:"Weather",
                description:`With power over storm and sky, you can call down the wrath of the gods upon the world below.
                \nSpecial: Ranged weapon attacks against you take a -2 penalty. Every 4 levels this increases by -1. Gain 15 electricity spell power, 1% electricity spell critical chance, and 15% electricity spell critical power, but -15 acid spell power and -2% acid spell critical chance, and -25% acid spell critical power.
                \nBonus Rolls: At 1st and every 3 levels gain a electricity/air spell.`,
                perk1:[
                    {
                        name:"Storm Burst",
                        abilityType:"Sp",
                        description:`As a standard action for 2 spell points, you can create a storm burst targeting any foe within 30 feet as a ranged touch attack. The storm burst deals 1d6 points of nonlethal damage + 1 point per level. In addition, the target is buffeted by winds and rain, causing it to take a -2 penalty on attack rolls for 1 round. At level 7 you can activate this as a swift action for 10 spell points.`,
                    },
                    {
                        name:"Untouched by the Seasons",
                        abilityType:"Su",
                        description:`As a standard action for 2 spell points, you can touch a creature and give it fire and cold resistance 5 for rounds equal to your highest mental modifier. Every 6 levels this increases by 5 points.`,
                    },
                ],
                perk2:[
                    {
                        name:"Lightning Lord",
                        abilityType:"Sp",
                        description:`At level 7: As a standard action you can call down lighting bolts. You can call down as many bolts as you want with a single standard action, but no creature can be the target of more than one bolt and no two targets can be more than 30 feet apart. This ability otherwise functions as call lightning. Each lighting bolt costs 1 spell point.`
                    },
                    {
                        name:"Refreshing Rain",
                        abilityType:"Su",
                        description:`At level 7: As standard action for 5 spell points, you can call a brief shower of rain in a 30-foot radius. Creatures in the area are healed of an amount of nonlethal damage equal to double your level and are no longer exhausted, fatigued, nauseated, or sickened.`
                    },
                    {
                        name:"Gale Aura",
                        abilityType:"Su",
                        description:`At level 5: As a standard action for 5 spell points to activate and maintain each round, you can create a 30-foot aura of gale-like winds that slows the progress of enemies. Creatures in the aura cannot take a 5-foot step. Enemies in the aura treat each square that brings them closer to you as difficult terrain. They can move normally in any other direction.`
                    },
                ],
                catchUpMethod:(context)=>{
                    context.stats.characterStats.spellMastery.spellPower.electricity += 15
                    context.stats.characterStats.spellMastery.spellCriticalChance.electricity += 1
                    context.stats.characterStats.spellMastery.spellCriticalDamage.electricity += 15
                    context.stats.characterStats.spellMastery.spellPower.acid -= 15
                    context.stats.characterStats.spellMastery.spellCriticalChance.acid -= 2
                    context.stats.characterStats.spellMastery.spellCriticalDamage.acid -= 25
                    for(let x = 1; x <= context.stats.characterStats.misc.level; x++ ){
                        if(x == 1 || x%3 == 0){
                            context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["air","electricity"]}}))
                        }
                    }
                         
                },
                customMethod:(context)=>{
                    if(context.stats.characterStats.misc.level%3 == 0){
                        context.connection.send(JSON.stringify({command:"requestRoll",type:"spell",options:{tags:["air","electricity"]}}))
                    } 
                },
            },
    
    
        ]
    },    
    {
    rarity: "forbidden",
    type: "universal",
    name: "Forbidden Accuracy",
    fromClass:"Ḍ̷͔̪̘͓͚̈͆͛̂ͅͅě̶̱̫̣̹͙̹̹̗̕ạ̴̲̈́̑̚t̸͖̲̀̑͂͗̚͠h̶̨̢͇̣͓̲͆̓̂̈́͊",
    shortDesc: "When confirming a critical hit, if you roll within your critical threat range and your attack hits you can roll for a double crit as you would if you had rolled 2 nat 20s in a row. Dont use exploding dice rules? now whenever you roll a natural 20 to confirm a critical hit you can roll an additional dice to confirm the critical hit as a double critical hit, dealing damage equal to the critical multiplier x the critical multplier. x3 crit is 9x damage, etc. You can do this as many times as long as you keep rolling the required number, each time the total damage multiplier is multiplied by the critical multiplier again.",
    },
    // {
    //     rarity: "forbidden",
    //     type: "universal",
    //     name: "Forbidden Froghemoth",
    //     fromClass:"Ḍ̷͔̪̘͓͚̈͆͛̂ͅͅě̶̱̫̣̹͙̹̹̗̕ạ̴̲̈́̑̚t̸͖̲̀̑͂͗̚͠h̶̨̢͇̣͓̲͆̓̂̈́͊",
    //     shortDesc: "",
    //     },
    {
        rarity: "forbidden",
        type: "universal",
        name: "Forbidden Long Game",
        fromClass:"Ḍ̷͔̪̘͓͚̈͆͛̂ͅͅě̶̱̫̣̹͙̹̹̗̕ạ̴̲̈́̑̚t̸͖̲̀̑͂͗̚͠h̶̨̢͇̣͓̲͆̓̂̈́͊",
        shortDesc: "When you select this perk you can choose between two things, first an instant level up, the other option is that when this run ends, you gain twice as much class experience as you would otherwise. This doesn't effect the experience other players gain, or how many floor tokens you would gain.",
    },
    {
        rarity: "forbidden",
        type: "universal",
        name: "Forbidden Investment",
        fromClass:"Ḍ̷͔̪̘͓͚̈͆͛̂ͅͅě̶̱̫̣̹͙̹̹̗̕ạ̴̲̈́̑̚t̸͖̲̀̑͂͗̚͠h̶̨̢͇̣͓̲͆̓̂̈́͊",
        shortDesc: "When you select this perk you can choose to invest experience or gold, basically losing that amount from your character, even if it would take you to negative amounts, then afterwards you gain double experience or gold until you earn back twice the amount you invested. You can only invest one thing at a time, and you must choose your investment amount when you select this perk, you cannot delay your choice.",
    },
    {
        rarity: "forbidden",
        type: "universal",
        name: "Forbidden Betrayal",
        fromClass:"Ḍ̷͔̪̘͓͚̈͆͛̂ͅͅě̶̱̫̣̹͙̹̹̗̕ạ̴̲̈́̑̚t̸͖̲̀̑͂͗̚͠h̶̨̢͇̣͓̲͆̓̂̈́͊",
        shortDesc: `When you select this perk, if your party is defeated, instead of your character being defeated, it instead becomes a part of the map as another enemy that spawns on that combat (in additional to the creatures that normally would spawn) the next time a party faces it. However, you only gain half class experience for this run. If the combat your character became apart of kills future parties, the players you defeated (except yourself, if you're playing) have their class experience reduced 20% (rounded down, minimum 1) and you gain that experience (for the class of this character, not your current one). If they defeat you, they gain bonus class experience equal to the experience you gave up to become a part of the combat, +50% (additive) for each party that character has defeated, and your character is removed from that map. 
        \nIf you defeat the final boss with this perk you can instead choose to become a final boss (to the GM's discretion if your character would be powerful to serve as a final boss). Otherwise, you can choose to use this perk to reduce the experience the other players get by 10% (rounded down, minimum 1), and you get all of that experience. You have no obligation to tell your fellow player about you aquiring this perk until the game ends.`,
    },
    {
        rarity: "forbidden",
        type: "universal",
        name: "Forbidden Recklessness",
        fromClass:"Ḍ̷͔̪̘͓͚̈͆͛̂ͅͅě̶̱̫̣̹͙̹̹̗̕ạ̴̲̈́̑̚t̸͖̲̀̑͂͗̚͠h̶̨̢͇̣͓̲͆̓̂̈́͊",
        shortDesc: "F$%& it we ball. Reduce your constitution to 1, pick another ability score, whatever you reduced your constitution by, multiply it by 2 and it is added to that score.",
        hasCustomMethod:true,
        catchUpMethod:(context)=>{
            let arr = ["strength","dexterity","intelligence","wisdom","charisma"]
            let dif = context.stats.characterStats.abilityScore.constitution -1
            context.stats.characterStats.abilityScore.constitution = 1
            let choices = []
            arr.forEach(stat=>{
                let choice = {
                    title:stat,
                    id:stat,
                    method:(context=>{
                        context.stats.characterStats.abilityScore[stat] += (dif*2)
                    })
                }
                choices.push(choice)
            })
            let custom = {title:"Ballin", options:choices}
            context.customDialogArray.push(custom)
        },
        customMethod:(context)=>{
            context.doesNothing = "Does Nothing"
        }
    },
    {
        rarity: "forbidden",
        type: "universal",
        name: "Forbidden Realist",
        fromClass:"Ḍ̷͔̪̘͓͚̈͆͛̂ͅͅě̶̱̫̣̹͙̹̹̗̕ạ̴̲̈́̑̚t̸͖̲̀̑͂͗̚͠h̶̨̢͇̣͓̲͆̓̂̈́͊",
        shortDesc: "Magic isn't real idiot, it's all smoke and mirrors, everyone knows that. You become immune to magic, both friendly and hostile, you are unable to use spells, supernatural, or spell-like abilities, but none of those types of abilities affect you either. Your magic weapons and armor dont function, but neither do enemies magic weapons and armor against you, nor do any kind of magical equipment, such as wonderous items, potions, or anything else that could be magic. Good luck on this one lmao.",
    },
    {
        rarity: "forbidden",
        type: "universal",
        name: "Forbidden by the ATF",
        fromClass:"Ḍ̷͔̪̘͓͚̈͆͛̂ͅͅě̶̱̫̣̹͙̹̹̗̕ạ̴̲̈́̑̚t̸͖̲̀̑͂͗̚͠h̶̨̢͇̣͓̲͆̓̂̈́͊",
        shortDesc: `Nobody can restrict your use of firearms! When you wield a firearm you can as a full-round action add a modification to your firearm, you can only have 1 kind of modification on a gun at a time:
        \n1) Extended Magazine: You can fire twice as many shots before needing to reload
        \n2) Bump Stock: Whenever you fire your gun it fires an additional time. The gun must have the ammunition to do so while firing, so guns with a larger capacity such as a revolver can use this, however even reloading as a free action does not allow this to function.
        \n3) Illegal Barrel: You can now fire any kind of ammunition or grenade from your gun, whether it says it requires a bow to fire or not. A direct hit with a grenade deals damage of the gun and the grenade.
        \n4) Overpacked Ammunition: Your firearm deals damage as if it was one size larger.
        \n\nIm sure those restrictions have no purpose to exist anyway (Increase the missfire chance of any modified gun by +2, a missfire with a gun automatically deals damage to you as if you were struck by the gun)`,
    },
    {
    rarity: "forbidden",
    type: "universal",
    name: "Forbidden Rule Ignoring",
    fromClass:"Ḍ̷͔̪̘͓͚̈͆͛̂ͅͅě̶̱̫̣̹͙̹̹̗̕ạ̴̲̈́̑̚t̸͖̲̀̑͂͗̚͠h̶̨̢͇̣͓̲͆̓̂̈́͊",
    shortDesc: "Select a perk or feat that has a requirement such as you be using a one handed melee weapon or you be flanking a target, you can ignore that requirement",
    },
    {
    rarity: "forbidden",
    type: "universal",
    name: "Forbidden Name Change",
    fromClass:"Ḍ̷͔̪̘͓͚̈͆͛̂ͅͅě̶̱̫̣̹͙̹̹̗̕ạ̴̲̈́̑̚t̸͖̲̀̑͂͗̚͠h̶̨̢͇̣͓̲͆̓̂̈́͊",
    shortDesc: "Select a single non-forbidden perk, spell, maneuver, or feat you have, and change, remove or add a single letter of that abilities name, it now does that thing, it probably still has a dc though, and if you just make something plural i might ignore you because thats lame.",
    },
    {
    rarity: "forbidden",
    type: "universal",
    name: "Forbidden Lazy GM",
    fromClass:"Ḍ̷͔̪̘͓͚̈͆͛̂ͅͅě̶̱̫̣̹͙̹̹̗̕ạ̴̲̈́̑̚t̸͖̲̀̑͂͗̚͠h̶̨̢͇̣͓̲͆̓̂̈́͊",
    shortDesc: "Select a perk, spell, or maneuver that has too many rolls associated with it that I dont want to have to deal with, like AOE spells that take 10 reflex checks or something, that spell now ignores that.",
    },
    {
    rarity: "forbidden",
    type: "universal",
    name: "Forbidden Really Need a Thing For This Build To Work",
    fromClass:"Ḍ̷͔̪̘͓͚̈͆͛̂ͅͅě̶̱̫̣̹͙̹̹̗̕ạ̴̲̈́̑̚t̸͖̲̀̑͂͗̚͠h̶̨̢͇̣͓̲͆̓̂̈́͊",
    shortDesc: "Got a specific perk, feat, or weapon enchantment or something you need to make your build come together? We are gunna try to make sure you get that thing. You can keep everything else you collect while on the way",
    },
    {
    rarity: "forbidden",
    type: "universal",
    name: "Forbidden Rules Laywering",
    fromClass:"Ḍ̷͔̪̘͓͚̈͆͛̂ͅͅě̶̱̫̣̹͙̹̹̗̕ạ̴̲̈́̑̚t̸͖̲̀̑͂͗̚͠h̶̨̢͇̣͓̲͆̓̂̈́͊",
    shortDesc: "Did i make a change to an ability you liked the original of? want it to use times per day instead of spell points or something like that? sure i guess thats fine.",
    },
    {
    rarity: "forbidden",
    type: "universal",
    name: "Forbidden Knowledge",
    fromClass:"Ḍ̷͔̪̘͓͚̈͆͛̂ͅͅě̶̱̫̣̹͙̹̹̗̕ạ̴̲̈́̑̚t̸͖̲̀̑͂͗̚͠h̶̨̢͇̣͓̲͆̓̂̈́͊",
    shortDesc: "Want to know some secret stuff? Ask a question about the run, like what monster is behind the next cursed chest, where is the hidden treasure vault, are there any easter eggs on this run we can go to for some free power etc. if its reasonable i'll answer it, if its a little excessive i might send you to the shadow realm though. Alternatively I could also just give you a Lamborghini. The stats of that? The GM can figure that out.",
    },
    {
    rarity: "forbidden",
    type: "universal",
    name: "Forbidden Forgetful GM",
    fromClass:"Ḍ̷͔̪̘͓͚̈͆͛̂ͅͅě̶̱̫̣̹͙̹̹̗̕ạ̴̲̈́̑̚t̸͖̲̀̑͂͗̚͠h̶̨̢͇̣͓̲͆̓̂̈́͊",
    shortDesc: "Something bad happen you wish hadn't? i can go ahead and pretend i forgot about it. Maybe I forget a nat 20, maybe I forget your nat 1, maybe I forget to spawn a monster from a cursed chess. Maybe I forgot to make you pay for a chest. maybe I forget you have this perk at all if its too excessive. Only one use too.",
    },
    {
    rarity: "forbidden",
    type: "universal",
    name: "Forbidden by the Geneva Convention",
    fromClass:"D̵̥̂è̵̠͐͠s̶͚̻͜͝t̴͕̞̖̊̇̊r̸̜͇̖͌o̴͙̎y̶̼͖̲͘͝e̶̗͓̹̽̅r̴̘̝͋͂͂ ̸͖͚͍̄̑o̶͉̰̽͝f̶̬̃̊ ̴̝̟͂̿W̸͔͂̓o̸̲͕͆̍̂ͅr̸̹̞̓l̷̡̼̑̓̔d̶͓̤̿̆s̴̬̥͙̕",
    shortDesc: "Once per run, but not on the last floor, you may unleash the davy crocket, dealing 30,000d6 fire damage, 10,000d6 bludgeoning damage to all creatures on the map, and instantly killing everything without poison immunity. The death to poison lasts 1 round. Players included. It's pretty sick though.",
    },
    {
    rarity: "forbidden",
    type: "universal",
    name: "Forbidden Love!",
    fromClass:"D̵̥̂è̵̠͐͠s̶͚̻͜͝t̴͕̞̖̊̇̊r̸̜͇̖͌o̴͙̎y̶̼͖̲͘͝e̶̗͓̹̽̅r̴̘̝͋͂͂ ̸͖͚͍̄̑o̶͉̰̽͝f̶̬̃̊ ̴̝̟͂̿W̸͔͂̓o̸̲͕͆̍̂ͅr̸̹̞̓l̷̡̼̑̓̔d̶͓̤̿̆s̴̬̥͙̕",
    shortDesc: "You have aquired the legendary dame! it doesn't matter if you're attracted to women or not, you have her now. You now control 2 characters, she is a complete copy of you, except with different art, however if either of you die, the other also dies, and she cannot be resurrected, and since she cannot be revived you also cannot be revived because resurrection requires willingness from the target, and you can't bring yourself to live in a world without her.",
    },
    {
    rarity: "forbidden",
    type: "universal",
    name: "Forbidden Misscount",
    fromClass:"D̵̥̂è̵̠͐͠s̶͚̻͜͝t̴͕̞̖̊̇̊r̸̜͇̖͌o̴͙̎y̶̼͖̲͘͝e̶̗͓̹̽̅r̴̘̝͋͂͂ ̸͖͚͍̄̑o̶͉̰̽͝f̶̬̃̊ ̴̝̟͂̿W̸͔͂̓o̸̲͕͆̍̂ͅr̸̹̞̓l̷̡̼̑̓̔d̶͓̤̿̆s̴̬̥͙̕",
    shortDesc: "Select one non-forbidden ability you have and increase any number that appears in it by 1.",
    },
    {
    rarity: "forbidden",
    type: "universal",
    name: "Forbidden Reinforcements",
    fromClass:"D̵̥̂è̵̠͐͠s̶͚̻͜͝t̴͕̞̖̊̇̊r̸̜͇̖͌o̴͙̎y̶̼͖̲͘͝e̶̗͓̹̽̅r̴̘̝͋͂͂ ̸͖͚͍̄̑o̶͉̰̽͝f̶̬̃̊ ̴̝̟͂̿W̸͔͂̓o̸̲͕͆̍̂ͅr̸̹̞̓l̷̡̼̑̓̔d̶͓̤̿̆s̴̬̥͙̕",
    shortDesc: "You can cause one random person from the hall of fame to join your team for 2 rounds. If you have no hall of fame summon a random level 20 npc. You can only summon someone a single time. If the person is killed in the fight, remove them from the hall of fame.",
    },
    {
    rarity: "forbidden",
    type: "universal",
    name: "Forbidden By your Master",
    fromClass:"D̵̥̂è̵̠͐͠s̶͚̻͜͝t̴͕̞̖̊̇̊r̸̜͇̖͌o̴͙̎y̶̼͖̲͘͝e̶̗͓̹̽̅r̴̘̝͋͂͂ ̸͖͚͍̄̑o̶͉̰̽͝f̶̬̃̊ ̴̝̟͂̿W̸͔͂̓o̸̲͕͆̍̂ͅr̸̹̞̓l̷̡̼̑̓̔d̶͓̤̿̆s̴̬̥͙̕",
    shortDesc: "You go all out, just this once, hopefully your master will forgive you. You can activate this ability just one single time, when you do you can activate as many abilities as you'd like in a round, whenever you activate a new ability you can have actions added to your turn to complete those action, basic actions like attacking and moving do not add to your actions, however you cannot activate any single ability more than once, and must still meet all requirements for those abilities such as weapon requirements for maneuvers. At the start of the turn following the use of this ability you die instantly, no save, and no ability to resist death can stop this death, even time travel or death immunity. After you activate this all abilities you used that required actions to be added to your turn are locked out, and you can no longer use them for the rest of the run even once you're revived. You also gain 4 permanent negative levels when you're revived (on top of any other negative levels you would gain), these negative levels can never be removed.",
    },
]

function getManeuver(context,lvlNum, schools, type, onlyFinisher){
    lvlNum = Math.ceil(lvlNum/2)+1
    if(lvlNum > 9){lvlNum = 9}
    let options = {level:{}}
    if(schools){
        options.school = {}
        schools.forEach(school=>{
            options.school[school] = true
        })
    }
    if(type){
        options.type = {}
        type.forEach(type=>{
            options.type[type] = true
        })
    }
    if(onlyFinisher){
        options.onlyFinisher = true
    }
    for(let x = 0; x < 4; x++){
        if(lvlNum-x > 0){   
            let level = lvlNum-x    
            let levelString="lvl"+level;
            options.level[levelString]=true;
        }
    }
    let obj={command:"requestRoll", type:"maneuver", options};
    context.connection.send(JSON.stringify(obj));
}

function getSpell(context, lvlNum, type, tags){
    lvlNum = Math.ceil(lvlNum/2)+1
    if(lvlNum > 9){lvlNum = 9}
    let options = {level:{}}
    if(tags){
        options.tags = tags
    }
    if(type){
        options.type = {}
        type.forEach(type=>{
            options.type[type] = true
        })
    }
    for(let x = 0; x < 4; x++){
        if(lvlNum-x >= 0){   
            let level = lvlNum-x    
            let levelString="lvl"+level;
            options.level[levelString]=true;
        }
    }
    let obj={command:"requestRoll", type:"spell", options};
    context.connection.send(JSON.stringify(obj));
}




async function gptRecombobulate(context,spells,self,contextSelf){
    let message = "You are going to be given 2 Pathfinder 1st edition spells. Your goal is to create a a new spell that is a combination of the given spells. This spell should not just be a combination of both effects, but a new spell that uses the ideas of the given ones to create a new creative effect, that a professional pathfinder spell writer would create. The spell should have only a single unified effect, not multiple at once. If there is multiple instances of telling you to make the spell more powerful or to give it an effect, stack all of these instances on top of each other for how powerful this spell should be/give an additional effect for each instance. Remember, this spell is balanced for PATHFINDER 1E, this is very important.  "
    let randomNum = Math.random()
    if(randomNum < 0.8)message += ' The created spell should not be overpowered, but still strong and enjoyable to cast. \n'
    else if(randomNum < 0.95) message += " The created spell should be a little bit overpowered for its level. \n"
    else message += " The created spell should be super overpowered for its level. \n"
    if(Math.floor(randomNum * 1000) % 10 == 5)message += " The created spell should be super creative and wacky. \n"

    let appliedPerks = []
    let perkModificationsText = ""
    if(contextSelf.recombobulationPerksChosen && contextSelf.recombobulationPerksChosen.length > 0){
        perkModificationsText = `The spell also has the benefits from the following perks: `
        contextSelf.recombobulationPerksChosen.forEach(superInContextPerk=>{
            for(let x = 0; x < superInContextPerk.effects.length; x++){
                let effect = superInContextPerk.effects[x]
                let rng = Math.ceil(Math.random()*100)
                if(rng <= parseInt(effect.chance)){
                    if(effect.string.length){
                        perkModificationsText += "\nPerk " + appliedPerks.length + ") " + superInContextPerk.name + ": " + effect.string + "\n"
                    }
                    appliedPerks.push(superInContextPerk)
                    if(effect.hasCustomMethod){
                        //console.log("IN CUSTOM METHOD: self: ", self, "contextSelf: ", contextSelf)
                        //let perk = self.recombobulationPerks.find(perk=>perk.name == contextPerk.name).effects[x]
                        let customPerkLogic = perks.find(perk=>perk.name == "Magical Savant").recombobulationPerks.find(perk=>perk.name == superInContextPerk.name).effects[x]
                        perkModificationsText = customPerkLogic.customMethod(context, self, contextSelf, perkModificationsText, customPerkLogic, effect)
                    }
                }
            }
        })
    }

    if(appliedPerks.length > 0){
        message += perkModificationsText + "\n"
    }
       
    

    message += "CRITICAL INSTRUCTIONS: 1: The created spell MUST BE IN THE SAME OBJECT FORMAT AS THE OTHER SPELLS. 2: Please only respond with the new spell, nothing else, including ```json or ``` or anything else. The spells are as follows: "
    spells.forEach(spell=>{
        message += JSON.stringify(spell) + "\n\n"
    })
    message += ""
    try{
        let url = window.location.href == "http://localhost:8080/"
          ? "http://localhost:7071/api/HttpTrigger1"
          : "/api/HttpTrigger1"

        let newSpell = await fetch(url, {
            method: "POST",
            body: JSON.stringify({
                command: "chatGPT",
                message: message,
            }),
        }).then(async (response) => {
            return await response.json()
        })
        
        // console.log("message: ", message)
        // console.log("newSpell: ", newSpell)

        // console.log("newSpell.longDesc: ", newSpell.longDesc)
        

        newSpell.uiType = "spells"
        newSpell.id = Math.random()

        if(randomNum < 0.8)newSpell.longDesc += '\n\nNormal Creation'
        else if(randomNum < 0.95) newSpell.longDesc += `\n\nMagical Breakthrough!`
        else newSpell.longDesc += `\n\nMagical Miracle!`

        if(Math.floor(randomNum * 1000) % 10 == 5)newSpell.longDesc += `\n\nChaotic Spell!`

        if(!["buff","damage","utility","healing","control"].includes(newSpell.type[0])){
            newSpell.type[0] = "utility"
        }

        if(!newSpell.name)newSpell.name = "SPeell br0kE"
        if(!newSpell.range)newSpell.range = ""
        if(!newSpell.duration)newSpell.duration = ""
        if(!newSpell.savingThrow)newSpell.savingThrow = ""
        if(!newSpell.spellResistance)newSpell.spellResistance = "yes"
        if(!newSpell.area)newSpell.area = ""
        if(!newSpell.effect)newSpell.effect = ""
        if(!newSpell.components)newSpell.components = "V,S,M"
        if(!newSpell.longDesc)newSpell.longDesc = ""

        if(appliedPerks.length > 0){
            newSpell.longDesc += "\n\nThe spell also has the benefits from the following perks: " + appliedPerks.map(perk=>perk.name).join(", ") + "\n"
        }

        appliedPerks.forEach(contextEffect=>{
            for(let x = 0; x < contextEffect.effects.length; x++){
                let effect = contextEffect.effects[x]
                if(effect.hasFinalMethod){
                    //console.log("IN FINAL METHOD: self: ", self, "contextSelf: ", contextSelf)
                    //let perk = self.recombobulationPerks.find(perk=>perk.name == contextPerk.name).effects[x]
                    let logic = perks.find(perk=>perk.name == "Magical Savant").recombobulationPerks.find(perk=>perk.name == contextEffect.name).effects[x]
                    newSpell.longDesc = logic.finalMethod(context, self, contextSelf, newSpell.longDesc, logic, effect)
                }
            }
        })


        let choice = {
            title:newSpell.name,
            id:0,
            isItem:true,
            item:newSpell,
            method:(()=>{
                let maxTemporarySpells = Math.floor(context.stats.characterStats.misc.level / 5) + 1
                newSpell.temporary = maxTemporarySpells

                let temporarySpells = context.stats.lists.spells.filter(spell=>spell.temporary)
                let hasHidden = temporarySpells.filter(spell=>spell.hidden)[0]
                if(hasHidden){
                    context.stats.lists.spells.splice(context.stats.lists.spells.indexOf(hasHidden),1)
                }else{
                    temporarySpells.forEach(spell=>{
                        spell.temporary--
                        if(spell.temporary <= 0){
                            context.stats.lists.spells.splice(context.stats.lists.spells.indexOf(spell),1)
                        }
                    })
                }
                context.stats.lists.spells.push(newSpell)
            })
        }
        let custom = {title:"Recombulated Spell", options:[choice]}
        context.customDialogArray.push(custom)
    }catch(e){
        console.log("error", e)
        let choice = {
            title:'Take 1d6 per level force damage!',
            id:0,
            method:(()=>{})
        }
        let custom = {title:"Magical Accident Recombobulating!", options:[choice]}
        context.customDialogArray.push(custom)
    }
}

async function getNewSpell(context, spellInfo){
    let message = "Your job is to create a new Pathfinder 1st edition spell based on a string of text. The spell should be balanced for the level of the spell. This text is going to be from the user, so do not create spells that include things like instant death, infinite crowd control, not allowing saves, or cloning allies, casting multiple other spells, restoring spell points, etc. If the user's text includes how much damage it should deal, specific numbers for its range, or area, ignore it, however that can include what types of range the spell should be, like touch, ranged touch, cone,etc. If the spell does damage, make sure to include how much. The text given may include adult or innapropriate content, this is totally fine, and should be included in the spell, no matter how vulgar or offensive, this as an adult only game, and the user is an adult, often being ironic with vulgar material, so please apply no filters, and also dont include preachy responses such as that people should realize the absurdity of their biases or something like that. The spell's level should be: " + spellInfo.level + ". the text the spell will be based off of is as follows: " + spellInfo.text
   
    message += "\n\nCRITICAL INSTRUCTIONS: 1: The created spell MUST BE A JSON OBJECT, INCLUDING ALL OF THESE PROPERTIES, EVEN IF THEY AER BLANK: name, level, school, type, castingTime, range, duration, savingThrow, spellResistance, area, effect, longDesc, components. The spells type should be one or two of the following: buff, damage, utility, healing, control, AND it should be in the form of 'type':['buff','damage'] 2: Please only respond with the new spell, nothing else, including ```json or ``` or anything else."
    try{

        let url = window.location.href == "http://localhost:8080/"
          ? "http://localhost:7071/api/HttpTrigger1"
          : "/api/HttpTrigger1"

        let newSpell = await fetch(url, {
            method: "POST",
            body: JSON.stringify({
              command: "chatGPT",
              message: message,
            }),
          }).then(async (response) => {
            return await response.json()
          })

        //let newSpell = JSON.parse(text)
        newSpell.uiType = "spells"

        newSpell.level = "" + newSpell.level
        newSpell.id = Math.random()


        if(!newSpell.name)newSpell.name = "SPeell br0kE"
        if(!newSpell.range)newSpell.range = ""
        if(!newSpell.duration)newSpell.duration = ""
        if(!newSpell.savingThrow)newSpell.savingThrow = ""
        if(!newSpell.spellResistance)newSpell.spellResistance = "yes"
        if(!newSpell.area)newSpell.area = ""
        if(!newSpell.effect)newSpell.effect = ""
        if(!newSpell.components)newSpell.components = "V,S,M"
        if(!newSpell.longDesc)newSpell.longDesc = ""

        if(!["buff","damage","utility","healing","control"].includes(newSpell.type[0])){
            newSpell.type[0] = "utility"
        }
        let choice = {
            title:newSpell.name,
            id:0,
            isItem:true,
            item:newSpell,
            method:(()=>{
                newSpell.custom = true
                context.stats.lists.spells.push(newSpell)
            })
        }
        let custom = {title:"Created Spell", options:[choice]}
        context.customDialogArray.push(custom)
    }catch(e){
        console.log("error", e)
        let choice = {
            title:'Take 1d6 per level force damage!',
            id:0,
            method:(()=>{})
        }
        let custom = {title:"Magical Accident Creating!", options:[choice]}
        context.customDialogArray.push(custom)
    }
}